(function () {
    'use strict';
    angular.module('app', [
            'ngResource',
            'ecTranslate',
            'ngMap',
            'gridster',
            'ngSanitize',
            'ngclipboard',
            'ngCookies',
            'ecComponents'
        ])
        .config(Config)
        .run(Run);

    Run.$inject = ['$state', 'urlService', 'apiAirBoss', 'runtimeService', '$window', 'amChartHelper'];

    function Run($state, urlService, apiAirBoss, runtimeService, $window, amChartHelper) {
        runtimeService.getConfigData();

        // Set the default AmCharts theme to our EcTheme
        AmCharts.theme = amChartHelper.getEcTheme();

        // The default parseFormat will need to be updated to reflect the user's
        // preferred majority format once settings are solidified. (Should days or months be first)   
        kendo.ui.DatePicker.fn.options.format = "MM/dd/yyyy"; //This would be set to the user's preferred date format
        kendo.ui.DatePicker.fn.options.parseFormats = [
            "yyyy/MM/dd",
            "MM/dd/yyyy",
            "MMddyyyy",
            "MM/dd/yy",
            "MMddyy",
            "MM/dd",
            "yyyy.MM.dd",
            "MM.dd.yyyy",
            "MM.dd.yy",
            "MM.dd",
            "yyyy-MM-dd",
            "MM-dd-yyyy",
            "MM-dd-yy",
            "MM-dd",
            "yyyyMMdd"
        ];

        kendo.ui.DatePicker.fn.options.minDate = "01/01/1900"; // minimum date possible
        kendo.ui.DatePicker.fn.options.maxDate = "01/01/3000"; // maximum date possible

        // Used to store the previous route, helps us deal with locating in the trees
        var oldRouteValue = {};

        // subscribeToEvent only works in the full app with ng5 also loaded
        // on the login screen the $state is the ng1 state provider which doesn't offer these, and doesn't need them
        if($state.subscribeToEvent){
            $state.subscribeToEvent('$stateChangeSuccess', function () {
                $window.ECP = $window.ECP || {};
                $window.ECP.ghostHelpers = $window.ECP.ghostHelpers || {};
                $window.ECP.ghostHelpers.ng1StateParams = $state.params;
    
                // Grab the urlService values of the new route and we will call
                // any watcher functions that exist
                var newRouteValue = {
                    id: urlService.id(),
                    type: urlService.type(),
                    path: urlService.path(),
                    search: urlService.search()
                };
    
                urlService.runWatcherFuncs(newRouteValue, oldRouteValue);
    
                // Assign the old route the current
                oldRouteValue = newRouteValue;
            });
    
            // Before every state change cancel all pending API requests and clear the ng1 user cache so any ng5 user updates will be visible to ng1 pages
            $state.subscribeToEvent('$stateChangeStart', function () {
                apiAirBoss.cancelAll();
                runtimeService.getConfigData();
            });
        }
        
    }
    Config.$inject = ['$httpProvider', '$logProvider', '$locationProvider', '$qProvider', '$compileProvider'];

    function Config($httpProvider, $logProvider, $locationProvider, $qProvider, $compileProvider) {
        $locationProvider.html5Mode(false);
        $locationProvider.hashPrefix('');
        $logProvider.debugEnabled(false);
        $qProvider.errorOnUnhandledRejections(true);

        $compileProvider.debugInfoEnabled(true); // TODO: set back to false

        $httpProvider.interceptors.push('waitForMe');
        $httpProvider.interceptors.push('flightDirector');
    }
})();
﻿// This is only around because some controllers are registered to it.  It will go away when angularJs goes away.
(function() {
  'use strict';
  angular.module('accountsModule', []);
})();
﻿(function() {
  'use strict';
  angular.module('administrationModule', []);
})();
﻿(function () {
    'use strict';
    angular.module('billsModule', [])
 })();
﻿//This file needs to remain while we still have ng1 resources registered with it, even though all of the routes have been moved into NG5
(function () {
    'use strict';
    angular.module('buildingsModule', []);
})();
(function () {
  'use strict';
  angular.module('ecTranslate', [
    'pascalprecht.translate'
  ]).config(Config);

  Config.$inject = ['$translateProvider'];

  function Config($translateProvider) {
    // @see http://angular-translate.github.io/docs/#/guide/19_security
    // Disable sanitization of localized values to allow localized values 
    // to include HTML
    $translateProvider.useSanitizeValueStrategy(null);

    // Lets Angular-Translate know about this form of interpolation to be used for plural keys
    $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

    // Tell Angular-Translate to use our custom loader
    $translateProvider.useLoader('translationLoader');

    //NOTE: this logic is a copy of the logic in translation-helper.service.ts and should be kept in sync. We can't share them between NG4 and NG1
    //wire up the default language if available, using a variable that the language pack itself attaches to the window under the "ECP" namespace
    //the name and structure of these language packs is controlled by the translate-build-cache job in the gulpfile
    //if unavailable something is wrong and no language file was loaded for some reason. It will fall back to loading en_US from server later        

    var firstLang = null;
    if (window.ECP && window.ECP.languagePacks) {
        for (var langKey in window.ECP.languagePacks) {
            $translateProvider.translations(langKey, window.ECP.languagePacks[langKey]);
            firstLang = firstLang || langKey;
        };
    }

    // Tell the translate code and moment to use the new locale
    // NOTE: This should be the LAST time we touch moment during configuration; otherwise we might inadvertently reset the moment locale; see above comment.
    // NOTE: The hash below is SHARED between NG1 and NG4 via window.ECP.langToMomentMap. app.js loads first, so we don't need to re-declare window.ECP.langToMomentMap
    // in NG4.
    window.ECP.langToMomentMap = {
        "fr_CA": "fr-ca",
        "en_US": "en",
        "pt": "pt",
        "es": "es"
    };
    $translateProvider.use(firstLang || 'en_US');
    var momentLang = window.ECP.langToMomentMap[firstLang];
    moment.locale(momentLang);
  }
})();
﻿//This file needs to remain while we still have ng1 resources registered with it, even though all of the routes have been moved into NG5
(function () {
    'use strict';
    angular.module('dashboardModule', []);
})();
﻿(function () {
    'use strict';
    angular.module('groupsModule', []);
})();
﻿(function () {
    'use strict';
    angular.module('loginModule', [
        'ecTranslate', 
        'kendo.directives',
        'ngCookies'
    ]);
})();
﻿(function () {
    'use strict';
    angular.module('vendorsModule', []);
})();
﻿(function () {
    'use strict';

    angular
        .module('administrationModule')
        .controller('administrationController', AdministrationController);

    AdministrationController.$inject = ['apiResource', '$compile', '$scope'];

    function AdministrationController(apiResource, $compile, $scope) {
        
    }

})();

﻿(function () {
    'use strict';

    angular
        .module('administrationModule')
        .controller('costAvoidanceOverviewController', CostAvoidanceOverviewController);

    CostAvoidanceOverviewController.$inject = ['apiResource', 'glazeService', '$translate', 'translationHelper', 'runtimeService', 'userService'];

    function CostAvoidanceOverviewController(apiResource, glazeService, $translate, translationHelper, runtimeService, userService) {
        var vm = this;
        var propertiesList = [
            'CAPBaseStartDefault',
            'CAPSavingStartDefault',
            'CAPBaseMonthsDefault',
            'CAPSummerBPTDefault',
            'CAPWinterBPTDefault',
            'CAPMinDDday',
            'CAHighPercent',
            'WeatherDegreeUnit'
        ];

        vm.costAvoidanceData = [];

        (function () {

            vm.grid = gridDefinition();
            vm.editCostAvoidance = function editCostAvoidance() {
                glazeService.openGlaze(0, 'edit-cost-avoidance');
            };

            apiResource.administration().systemSettings().query({}).$promise.then(function (result) {
                vm.costAvoidanceData = _.pick(result, propertiesList);

                // grid data source expects an array
                vm.grid.defaultSettings.dataSource = [vm.costAvoidanceData];
                vm.grid.defaultSettings.dataSource = _.map(vm.grid.defaultSettings.dataSource, function (setting) {
                    setting.baselineLengthDisplay = setting.CAPBaseMonthsDefault.value + ' ' + $translate.instant('months');

                    var degreeUnitOutside = (setting.WeatherDegreeUnit.value == 0 ? '°F' : '°C') + ' ' + $translate.instant('outside');
                    setting.heatingNeededDisplay = setting.CAPWinterBPTDefault.value + degreeUnitOutside;
                    setting.coolingNeededDisplay = setting.CAPSummerBPTDefault.value + degreeUnitOutside;

                    setting.minDegreesDaysDisplay = translationHelper.translateAndInterpolate('MinDegreeDaysBeforeWeatherAdjustment', {
                        'minDegreeDays': setting.CAPMinDDday.value,
                        'minDegreeDaysMonth': calculateDegreesDaysPerMonth(setting.CAPMinDDday.value)
                    });
                   
                    setting.reasonablenessDisplay = translationHelper.translateAndInterpolate('CostAvoidanceReasonableness', {
                        'percentValue': setting.CAHighPercent.value
                    });

                    return setting;
                });
            });
           
        })();

        // Calculate degree days per month based on degree days per day
        function calculateDegreesDaysPerMonth(minDegreesDaysPerDay) {
            return Math.round((minDegreesDaysPerDay * 365 / 12) * 100) / 100;
        }

       
        function gridDefinition() {
            var grid = {};

            grid.defaultSettings = {
                header: $translate.instant('Default Settings for New Meters'),
                dataSource: {},
                scrollable: false,
                columns: [
                    {
                        field: "CAPBaseStartDefault.value",
                        title: "Baseline start",
                        attributes: {
                            id: 'baselineStart_value'
                        }
                    },
					{
					    field: "baselineLengthDisplay",
                        title: "Baseline length",
                        attributes: {
                            id: 'baselineLength_value'
                        }
					},
                    {
                        field: "CAPSavingStartDefault.value",
                        title: "Savings start",
                        attributes: {
                            id: 'savingsStart_value'
                        }
                    },
                    {
                        field: "heatingNeededDisplay",
                        title: "Heating needed below",
                        attributes: {
                            id: 'heatingNeeded_value'
                        }
                    },
                    {
                        field: "coolingNeededDisplay",
                        title: "Cooling needed above",
                        attributes: {
                            id: 'coolingNeeded_value'
                        }
                    },
					{
					    field: "minDegreesDaysDisplay",
                        title: "Minimum degree days before weather adjustment",
                        attributes: {
                            id: 'minDegreeDays_value'
                        }
					},
                    {
                        field: "reasonablenessDisplay",
                        title: "Cost avoidance reasonableness",
                        attributes: {
                            id: 'reasonableness_value'
                        }
                    }
                ]
            };

            runtimeService.getConfigData().then(function () {
                if (userService.userHasPermission("GlobalCostAvoidanceSettingsManage")) {
                    grid.defaultSettings.columns.push(
                        {
                            headerAttributes: {
                                "class": "ec-grid-actions"
                            },
                            headerTemplate: "<button id='editCostAvoidanceSettings' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Edit cost avoidance settings\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='grid.controller.editCostAvoidance()'><i class='ec-icon icon-edit'></i></button>"
                        }
                    );
                }
            });

            return grid;
        }
    }
})();

﻿(function () {
    'use strict';

    angular
       .module('app')
       .controller('editCostAvoidanceController', EditCostAvoidanceController);

    EditCostAvoidanceController.$inject = ['apiResource', 'urlService', 'glazeService', '$state', 'regexService', 'customValidator', '$window', '$translate'];

    function EditCostAvoidanceController(apiResource, urlService, glazeService, $state, regexService, customValidator, $window, $translate) {
        var vm = this;
        var propertiesList = [
            'CAPBaseStartDefault',
            'CAPSavingStartDefault',
            'CAPBaseMonthsDefault',
            'CAPSummerBPTDefault',
            'CAPWinterBPTDefault',
            'CAPMinDDday',
            'CAHighPercent',
            'WeatherDegreeUnit'
        ];

        vm.costAvoidanceData = [];
        vm.gotoProperties = gotoProperties;
        vm.updateDegreeDaysPerMonth = updateDegreeDaysPerMonth;
        vm.ddPerMonth = 0;
        vm.showDDCalculation = false;

        vm.validate = validate;
        vm.validationMessages = {
            savingsStartCompareMessage: $translate.instant("must be after baseline start + length"),
            baselineStartRequiredMessage: $translate.instant("must be 01/01/1900–01/01/2099")
        };

        vm.validationOptions = {
            validateOnBlur: false,
            messages: {
                required: function (input) {
                    var optionalParam = {};

                    // if input has a specific message for required validation, return that
                    if (input.attr('required-message')) {
                        return input.attr('required-message');
                    }

                    return customValidator.validationMessages.requiredMessage(input, optionalParam);
                },
                customValidation: function (input) {
                    var optionalParam = {};
                    return customValidator.validationMessages.customValidationMessage(input, optionalParam);
                }
            },
            rules: {
                customValidation: function (input) {
                    var optionalParam = {};
                    if (input.is("[compare-date-validation=true]") && input.is("[name=savingsStart]")) {
                        optionalParam.operator = "gte";
                        optionalParam.targetDate = moment(vm.costAvoidanceData.CAPBaseStartDefault.value).add(vm.costAvoidanceData.CAPBaseMonthsDefault.value, 'months').format('MM/DD/YYYY');
                    }

                    return customValidator.validations.customValidation(input, optionalParam);
                }
            }
        };

        vm.regexService = {
            restrictDouble: regexService.restrictDouble(),
            restrictPositiveInteger: regexService.restrictPositiveInteger()
        };

        (function constructor() {
            glazeService.primaryAction = validate;
            glazeService.secondaryAction = function() { 
                glazeService.hideGlaze();

                // Share the isConfirm variable to control whether Save or Save And Continue buttons display
                // in the form title.
                glazeService.isConfirm = false; 
            }            

            // hardcode the baseline lengths
            // created as objects so a value and text field can be specified
            // there is no value template available for comboboxes
            vm.baselineLengthData = [];
            for (var i = 12; i < 37; i++) {
                vm.baselineLengthData.push({ value: i, text: i.toString() + " " + $translate.instant("months") });
            }

            glazeService.setLoadingVisibility(true);
            apiResource.administration().systemSettings().query({}, function (result) {
                vm.costAvoidanceData = _.pick(result, propertiesList);

                updateDegreeDaysPerMonth();

                if (vm.costAvoidanceData.WeatherDegreeUnit.value === "0") {
                    vm.temperatureOptions = {
                        format: "°F"
                    };
                }
                else {
                    vm.temperatureOptions = {
                        format: "°C"
                    };
                }
                vm.temperatureOptions.min = 0;
                vm.temperatureOptions.max = 100;

                vm.sliderTooltip = {
                  template: "#=value#" + vm.temperatureOptions.format
              };

                glazeService.setLoadingVisibility(false);
            }, function (error) {
                glazeService.showErrorMessage(error.data.status.message);
                glazeService.setLoadingVisibility(false);
            });

        })();


        function validate(event) {
            if (vm.validator.validate()) {
                glazeService.isConfirm = true;
                confirmSave(event);
            }
            else {
                glazeService.showErrorMessage();
            }
        }

        function confirmSave(event) {
            if (event.action === "confirmed") {
                save();
                glazeService.isConfirm = false;
            }
            else {
                var messageList = [
                    "ChangesWillNotAffectExistingMeters",
                    "Changes to balance point temperatures will also affect normalization settings."
                ];
                glazeService.showPrimaryActionConfirmationMessage(messageList);
            }
        }

        function gotoProperties() {
            glazeService.hideGlaze();
            $state.reload();
        }

        function save() {
            glazeService.setSavingVisibility(true);
            apiResource.administration().systemSettings().update(vm.costAvoidanceData, function (result) {
                gotoProperties();
            }, function (error) {
                glazeService.setSavingVisibility(false);
                glazeService.showErrorMessage(error.data.status.message);
            });
        }

        function updateDegreeDaysPerMonth() {
            var value = parseFloat(vm.costAvoidanceData.CAPMinDDday.value);
            if (!isNaN(value)) {
                value = value > 1 ? 1 : value;
                value = value < 0 ? 0 : value;
                vm.ddPerMonth = Math.round(value * 365 / 12 * 100) / 100;
                vm.showDDCalculation = true;
            } else {
                vm.showDDCalculation = false;
                vm.costAvoidanceData.CAPMinDDday.value = null;
            }
        }
    }
})();

﻿(function () {
    'use strict';

    angular
       .module('app')
       .controller('editNormalizationController', EditNormalizationController);

    EditNormalizationController.$inject = ['apiResource', 'glazeService', '$state', 'regexService', 'customValidator', 'temperatureService', '$filter'];

    function EditNormalizationController(apiResource, glazeService, $state, regexService, customValidator, temperatureService, $filter) {
        var vm = this;
        var propertiesList = [
            'WeatherNormalizedYear',
            'CAPSummerBPTDefault',
            'CAPWinterBPTDefault',
            'WeatherDegreeUnit'
        ];

        vm.settingsList = [];

        vm.validate = validate;
        vm.gotoProperties = gotoProperties;

        vm.validationOptions = {
            validateOnBlur: false,
            messages: {
                required: function (input) {
                    var optionalParam = {};
                    return customValidator.validationMessages.requiredMessage(input, optionalParam);
                },
                customValidation: function (input) {
                    var optionalParam = {};
                    return customValidator.validationMessages.customValidationMessage(input, optionalParam);
                }
            },
            rules: {
                customValidation: function (input) {
                    var optionalParam = {};
                    return customValidator.validations.customValidation(input, optionalParam);
                }
            }
        };

        vm.regexService = {
            restrictPositiveInteger: regexService.restrictPositiveInteger()
        };

        (function constructor() {
            glazeService.primaryAction = validate;
            glazeService.secondaryAction = function() { 
                glazeService.hideGlaze();

                // Share the isConfirm variable to control whether Save or Save And Continue buttons display
                // in the form title.
                glazeService.isConfirm = false; 
            }      
            
            glazeService.setLoadingVisibility(true);
            apiResource.administration().systemSettings().query({}, function (result) {
                vm.settingsList = _.pick(result, propertiesList);
                if (vm.settingsList.WeatherDegreeUnit.value === "0") {
                    vm.temperatureOptions = temperatureService.balancePointOptions('degf');
                }
                else {
                    vm.temperatureOptions = temperatureService.balancePointOptions('degc');
                }

                // if values fall outside acceptable ranges, try to convert them (the units most likely changed)
                vm.settingsList.CAPWinterBPTDefault.value = $filter('temperature')(vm.settingsList.CAPWinterBPTDefault.value, vm.temperatureOptions);
                vm.settingsList.CAPSummerBPTDefault.value = $filter('temperature')(vm.settingsList.CAPSummerBPTDefault.value, vm.temperatureOptions);

                var years = [];
                for (var year = 1990; year < moment().year(); year++) {
                    years.push(year.toString());
                }
                vm.normalizationComparisonYearList = years;

                glazeService.setLoadingVisibility(false);
            }, function (error) {
                glazeService.showErrorMessage(error.data.status.message);
                glazeService.setLoadingVisibility(false);
            });

        })();


        function validate(event) {
            if (vm.validator.validate()) {
                glazeService.isConfirm = true;
                confirmSave(event);
            }
            else {
                glazeService.showErrorMessage();
            }
        }

        function gotoProperties() {
            glazeService.hideGlaze();
            $state.reload();
        }

        function confirmSave(event) {
            if (event.action === "confirmed") {
                save();
                glazeService.isConfirm = false;
            }
            else {                
                glazeService.showPrimaryActionConfirmationMessage("Changes to balance point temperatures will also affect cost avoidance settings.");                                
            }
        }

        function save() {
            glazeService.setSavingVisibility(true);
            apiResource.administration().systemSettings().update(vm.settingsList, function (result) {
                gotoProperties(true);
            }, function (error) {
                glazeService.setSavingVisibility(false);
                glazeService.showErrorMessage(error.data.status.message);
            });
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('administrationModule')
        .controller('normalizationController', NormalizationController);

    NormalizationController.$inject = ['apiResource', 'glazeService', '$translate', 'temperatureService', '$filter', 'runtimeService', 'userService'];

    function NormalizationController(apiResource, glazeService, $translate, temperatureService, $filter, runtimeService, userService) {
        var vm = this;
        var propertiesList = [
            'WeatherNormalizedYear',
            'CAPSummerBPTDefault',
            'CAPWinterBPTDefault',
            'WeatherDegreeUnit'
        ];

        vm.settingsList = [];

        vm.openGlaze = function (glazeId, glazeType) {
            glazeService.openGlaze(glazeId, glazeType);
        };

        (function () {

            // All grid definitions & datasources are
            // contains within vm.grids
            vm.grids = gridDefinitions();

            apiResource.administration().systemSettings().query({}).$promise.then(function (result) {

                vm.settingsList = _.pick(result, propertiesList);
                if (vm.settingsList.WeatherDegreeUnit.value === "0") {
                    vm.temperatureOptions = temperatureService.balancePointOptions('degf');
                }
                else {
                    vm.temperatureOptions = temperatureService.balancePointOptions('degc');
                }

                // if values fall outside acceptable ranges, try to convert them (the units most likely changed)
                vm.settingsList.CAPWinterBPTDefault.value = $filter('temperature')(vm.settingsList.CAPWinterBPTDefault.value, vm.temperatureOptions);
                vm.settingsList.CAPSummerBPTDefault.value = $filter('temperature')(vm.settingsList.CAPSummerBPTDefault.value, vm.temperatureOptions);

                // grid data source expects an array
                vm.grids.settings.dataSource = [vm.settingsList];
            });

        })();

        function gridDefinitions() {
            var grids = {};

            grids.settings = {
                dataSource: {},
                scrollable: false,
                columns: [
                    {
                        field: "WeatherNormalizedYear.value",
                        title: "Normalization comparison year"
                    },
                    {
                        field: "WeatherDegreeUnit.value",
                        title: "Heating needed below",
                        template: "#=CAPWinterBPTDefault.value + (WeatherDegreeUnit.value == 0 ? '°F' : '°C') + ' " + $translate.instant('outside') + "'#"
                    },
                    {
                        field: "WeatherDegreeUnit.value",
                        title: "Cooling needed above",
                        template: "#=CAPSummerBPTDefault.value + (WeatherDegreeUnit.value == 0 ? '°F' : '°C') + ' " + $translate.instant('outside') + "'#"
                    }
                ]
            };

            runtimeService.getConfigData().then(function () {
                if (userService.userHasPermission("NormalizationSettingsManage")) {
                    grids.settings.columns.push(
                        {
                            headerAttributes: {
                                "class": "ec-grid-actions"
                            },
                            headerTemplate: "<button ng-click='grid.controller.openGlaze(0, \"edit-normalization\")' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Edit normalization settings\" | translate}}' class='ec-btn-icon btn btn-secondary'><i class='ec-icon icon-edit'></i></button>"
                        }
                    );
                }
            });

            return grids;
        }


    }

})();

﻿(function () {
    'use strict';

    angular
        .module('administrationModule')
        .controller('editReportGroupController', EditReportGroupController);

    EditReportGroupController.$inject = ['$q', 'urlService', 'apiResource', 'glazeService', 'customValidator', '$state'];

    function EditReportGroupController($q, urlService, apiResource, glazeService, customValidator, $state) {
        var vm = this;
        vm.reportGroupId = glazeService.getCurrentId();
        vm.addGroupToMembership = addGroupToMembership;
        vm.removeGroupFromMembership = removeGroupFromMembership;
        vm.isLoading = true;

        var glazeOptions = glazeService.getGlazeOptions();
        vm.action = glazeOptions.action;        

        vm.currentReportGroup = {
            reportGroupInfo: '',
            reportGroupCode: '',
            reports: []
        };
        /*
        assigned grid settings
        */
        vm.assignedGridSettings = {
            header: "Assigned Reports",
            selectable: false,
            navigatable: false,
            dataSource: {
                group: {
                    field: "reportType.reportTypeCode"
                },
                sort: [
                    { field: "reportCode", dir: "asc" }
                ],                
                pageable: false
            },
            pageable: false,
            groupable: false,
            scrollable: false,
            resizable: false,
            functions: {
                removeGroupFromMembership: removeGroupFromMembership
            },
            columns: [
                {
                    field: "reportCode",
                    title: "Report code"
                },
                {
                    field: "reportInfo",
                    title: "Report name"
                },
                {
                    attributes: {
                        "class": "ec-grid-actions"
                    },
                    template: "<button type='button' ng-click='grid.controller.removeGroupFromMembership(#=reportId#)' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Remove report from group\" | translate}}' class='ec-btn-icon btn btn-secondary'><i class='ec-icon icon-cancel'></i></button>"
                },
                {
                    field: "reportType.reportTypeCode",
                    hidden: true,
                    groupHeaderTemplate: function (item) {
                        var typeGroup = _.find(vm.assignedGridSettings.dataSource.data, function (itr) {
                            return itr.reportType.reportTypeCode == item.value;
                        });
                        return kendo.htmlEncode(typeGroup.reportType.reportTypeInfo + " [" + typeGroup.reportType.reportTypeCode + "]");
                    }
                }
                
            ]
        };
        /*
        available grid settings
        */
        vm.availableGridSettings = {
            header: "Available Reports",
            selectable: false,
            navigatable: false,
            dataSource: {
                group: {
                    field: "reportType.reportTypeCode"
                },
                sort: [
                    { field: "reportCode", dir: "asc" }
                ],                
                pageable: false
            },
            pageable: false,
            groupable: false,
            scrollable: false,
            resizable: false,
            functions: {
                addGroupToMembership: addGroupToMembership
            },
            columns: [
                {
                    field: "reportCode",
                    title: "Report code",
                    dir: "asc"
                },
                {
                    field: "reportInfo",
                    title: "Report name"
                },
                {
                    attributes: {
                        "class": "ec-grid-actions"
                    },
                    template: "<button type='button' ng-click='grid.controller.addGroupToMembership(#=reportId#)' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Add report to group\" | translate}}' class='ec-btn-icon btn btn-secondary'><i class='ec-icon icon-add'></i></button>"
                },
                {
                    field: "reportType.reportTypeCode",
                    hidden: true,
                    groupHeaderTemplate: function (item) {
                        var typeGroup = _.find(vm.availableGridSettings.dataSource.data, function (itr) {
                            return itr.reportType.reportTypeCode == item.value;
                        });
                        return kendo.htmlEncode(typeGroup.reportType.reportTypeInfo + " [" + typeGroup.reportType.reportTypeCode + "]");
                    }
                }

            ]
        };


        /*
         * Validation
         */
        vm.validate = validate;
        vm.validationOptions = {
            validateOnBlur: false,
            messages: {
                required: function (input) {
                    return customValidator.validationMessages.requiredMessage(input);
                },
                customValidation: function (input) {
                    var optionalParam = {};
                    return customValidator.validationMessages.customValidationMessage(input, optionalParam);
                }
            },
            rules: {
                customValidation: function (input) {
                    var optionalParam = {};
                    return customValidator.validations.customValidation(input, optionalParam);
                }
            }
        };


        /*
         * Constructor
         */
        (function constructor() {
            initialFormLoad();
            glazeService.primaryAction = validate;
            glazeService.secondaryAction = glazeService.hideGlaze;            
        })();

        function initialFormLoad() {

            glazeService.setLoadingVisibility(true);
            // Call all needed APIs and push promises so we can act
            // when they all return
            var loadingPromises = [];
            
            loadingPromises.push(apiResource.report().report().query({}).$promise);
            if (vm.action !== 'add') {
                loadingPromises.push(apiResource.report().reportGroup().get({ reportGroupId: vm.reportGroupId }).$promise);
            }

            $q.all(loadingPromises).then(function (res) {

                var allReports = _(res[0]).map('baseReport').flatten().uniqBy('reportId').value();

                if (vm.action !== 'add') {
                    vm.currentReportGroup = res[1];
                }

                // User must provide name and code if adding or copying
                // This matches what we do in ECO
                if (vm.action === 'add' || vm.action === 'copy') {
                    vm.currentReportGroup.reportGroupInfo = '';
                    vm.currentReportGroup.reportGroupCode = '';
                }

                vm.assignedGridSettings.dataSource.data = vm.currentReportGroup.reports;
                vm.availableGridSettings.dataSource.data = removeReportsAlreadyInGroup(allReports);

                updateTitleCounts();

                // Expose function to set the organization code
                // when the organization info is blurred. Don't 
                // worry about "codifying" the info -- the input
                // for code should handle char restrictions
                vm.updateCode = function (e) {
                    vm.currentReportGroup.reportGroupCode = vm.currentReportGroup.reportGroupInfo ? vm.currentReportGroup.reportGroupInfo.toUpperCase() : '';
                };
                
                glazeService.setLoadingVisibility(false);
                vm.isLoading = false;
            }, function (error) {
                glazeService.showErrorMessage(error.data.status.message);                
                glazeService.setLoadingVisibility(false);
                vm.isLoading = false;
            });
        }


        /*
         * Remove assigned reports from the available reports
         */
        function removeReportsAlreadyInGroup(availableReports) {
            // use temp variable so binding only occurs once
            var tempAvailableReports = availableReports;
            _.remove(tempAvailableReports, function (item) {
                var shouldRemove = false;
                _.each(vm.assignedGridSettings.dataSource.data, function (toRemove) {
                    if (toRemove.reportId == item.reportId
                        && toRemove.reportType.reportTypeId == item.reportType.reportTypeId) {
                        shouldRemove = true;
                    }
                });
                return shouldRemove;
            });

            return tempAvailableReports;
        }


        /*
         * Add selected members of the available grid
         * to the assigned grid
         */
        function addGroupToMembership(reportId) {
            var selectedDataItems = [];
            _.remove(vm.availableGridSettings.dataSource.data, function (item) {
                if (item.reportId == reportId) {
                    selectedDataItems.push(item);
                    return true;
                }
                return false;
            });

            vm.assignedGridSettings.dataSource.data = _.union(vm.assignedGridSettings.dataSource.data, selectedDataItems);
            updateTitleCounts();            
        }


        /*
         * Remove selected members of the assgined grid
         * and assign them to the available grid
         */
        function removeGroupFromMembership(reportId) {
            var selectedDataItems = [];
            _.remove(vm.assignedGridSettings.dataSource.data, function (item) {
                if (item.reportId == reportId) {
                    selectedDataItems.push(item);
                    return true;
                }
                return false;
            });

            vm.availableGridSettings.dataSource.data = _.union(vm.availableGridSettings.dataSource.data, selectedDataItems);
            updateTitleCounts();            
        }


        /*
         * Update the given titles of each of the grids based
         * on the length of their datasources
         */
        function updateTitleCounts() {
            vm.assignedGridSettings.headerCount = vm.assignedGridSettings.dataSource.data.length;
            vm.availableGridSettings.headerCount = vm.availableGridSettings.dataSource.data.length;
        }       


        /*
         * Validate any validators
         */
        function validate(event) {

            if (vm.validator.validate()) {
                save();
            }
            else {
                glazeService.showErrorMessage(customValidator.validationMessages.genericHeaderMessage());
            }
        }


        /*
         * Persist the changes and call the API
         */
        function save() {

            // we just pass in the report ids
            glazeService.setSavingVisibility(true);
            vm.currentReportGroup.reportIds = _.map(vm.assignedGridSettings.dataSource.data, 'reportId');

            // remove property 'reportGroupId' if it exists (it will if we are copying or editing)
            vm.currentReportGroup = _.omit(vm.currentReportGroup, 'reportGroupId');
            // remove property 'reports'
            vm.currentReportGroup = _.omit(vm.currentReportGroup, 'reports');

            // adding and copying are essentially the same
            
            if (vm.action === 'add' || vm.action === 'copy') {
                apiResource.report().reportGroup().save(vm.currentReportGroup, function (result) {
                    gotoProperties(true);
                }, function (error) {
                    glazeService.setSavingVisibility(false);
                    glazeService.showErrorMessage(error.data.status.message);
                });
            }
            else {
                apiResource.report().reportGroup().update({ reportGroupId: vm.reportGroupId }, vm.currentReportGroup, function (result) {
                    gotoProperties(true);
                }, function (error) {
                    glazeService.setSavingVisibility(false);
                    glazeService.showErrorMessage(error.data.status.message);
                });
            }
        }


        /*
         * After a successful save, go back to the overview page
         */
        function gotoProperties(refresh) {
            glazeService.hideGlaze();
            if (refresh && urlService.module() === "manage") {
                $state.reload();
            }
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('administrationModule')
        .controller('reportGroupOverviewController', ReportGroupOverviewController);

    ReportGroupOverviewController.$inject = ['apiResource', '$state', 'glazeService', '$translate', 'confirmationService'];

    function ReportGroupOverviewController(apiResource, $state, glazeService, $translate, confirmationService) {
        var vm = this;
        vm.reportGroups = [];
        

        vm.openGlaze = function (glazeId, glazeType) {
            glazeService.openGlaze(glazeId, glazeType);
        };

        (function () {

            vm.grid = gridDefinition();

            vm.deleteReportGroup = function deleteReportGroup(reportGroupId) {

                confirmationService.confirmation($translate.instant("Delete report group"), $translate.instant("Are you sure?")).then(function (result) {

                    if (!result) {
                        return;
                    }

                    apiResource.report().reportGroup().remove({ reportGroupId: reportGroupId }, function (result) {
                        $state.reload();
                    });
                });
            };

            vm.addReportGroup = function addReportGroup() {
                glazeService.openGlaze(0, 'add-report-group', "Add Report Group", { action: "add" });
            };

            vm.editReportGroup = function editReportGroup(reportGroupId) {
                glazeService.openGlaze(reportGroupId, 'edit-report-group', "Edit Report Group", { action: "edit" });
            };

            vm.copyReportGroup = function copyReportGroup(reportGroupId) {
                glazeService.openGlaze(reportGroupId, 'copy-report-group', "Copy Report Group", { action: "copy" });
            };


            apiResource.report().reportGroup().query({}, function (result) {
                // need to know number of reports in each group
                angular.forEach(result, function (reportGroup) {
                    reportGroup.recommendedReports = reportGroup.reports.length;
                });

                vm.reportGroups = result;
                vm.grid.dataSource = vm.reportGroups;

            }, function (error) {
                vm.grid.dataSource = [];
            });

        })();

        function gridDefinition() {
            var grid = {};

            var actionTemplate =
                //"<button tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Copy report group\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='grid.controller.copyReportGroup(#=reportGroupId#)'><i class='ec-icon icon-copy'></i></button>" +
                "<button tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Edit report group\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='grid.controller.editReportGroup(#=reportGroupId#)' ng-if='#=reportGroupId# !== 1'><i class='ec-icon icon-edit'></i></button>" +
                "<button tooltip data-toggle='tooltip' title='{{ \"Delete report group\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='grid.controller.deleteReportGroup(#=reportGroupId#)' ng-if='#=reportGroupId# !== 1'><i class='ec-icon icon-delete'></i></button>";

            grid = {
                dataSource: {
                    sort: { field: "reportGroupInfo" }
                },
                scrollable: false,
                columns: [
                    {
                        field: "reportGroupInfo",
                        title: "Report group name"
                    },
                    {
                        field: "reportGroupCode",
                        title: "Report group code"
                    },
					{
					    field: "recommendedReports",
					    title: "Recommended reports"
					},
					{
					    headerAttributes: { "class": "ec-grid-actions" },
					    attributes: { "class": "ec-grid-actions" },
					    template: actionTemplate,
					    headerTemplate: "<button ng-click='grid.controller.addReportGroup()' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Add report group\" | translate}}' class='ec-btn-icon btn btn-secondary'><i class='ec-icon icon-add'></i></button>"
					}
                ]
            };

            return grid;
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('administrationModule')
        .controller('editTargetComparisonController', EditTargetComparisonController);

    EditTargetComparisonController.$inject = ['urlService', 'apiResource', 'glazeService', 'customValidator', '$state', 'regexService', '$translate', 'userService'];

    function EditTargetComparisonController(urlService, apiResource, glazeService, customValidator, $state, regexService, $translate, userService) {
        var vm = this;
        var propertiesList = [
            'PowerviewTargetLabel',
            'PowerviewTargetFiscalYear',
            'PowerviewTargetMultiplierCost',
            'PowerviewTargetMultiplierGHG',
            'PowerviewTargetMultiplierUse',
            'PowerviewTargetShowCost',
            'PowerviewTargetShowGHG',
            'PowerviewTargetShowUse'
        ];

        vm.targetComparisonData = [];
        vm.targetBaseFiscalYears = [];
        vm.validate = validate;
        vm.validationMessages = {
            editTargetComparisonRequiredMessage: $translate.instant("must be 1990–current year")
        };

        vm.validationOptions = {
            validateOnBlur: false,
            messages: {
                required: function (input) {
                    // if input has a specific message for required validation, return that
                    if (input.attr('required-message') && !input.is("select")) {
                        return input.attr('required-message');
                    }

                    return customValidator.validationMessages.requiredMessage(input);
                }
            }
        };

        vm.regexService = {
            restrictDouble: regexService.restrictDouble()
        };

        vm.toggle = toggle;

        // Constructor
        (function constructor() {
            glazeService.primaryAction = validate;
            glazeService.secondaryAction = glazeService.hideGlaze;

            processTargetBaseFiscalYears();

            apiResource.administration().systemSettings().query({}, function (result) {
                vm.targetComparisonData = _.pick(result, propertiesList);
            }, function (error) {

            });

        })();


        // target base fiscal years contains years in the range 1990 - current year
        function processTargetBaseFiscalYears() {

          var fiscalStartMonth = userService.getUser().fiscalYearStartMonth;
          var today = moment();
          if (fiscalStartMonth != 1) {  // don't adjust the year if the fiscal cycle follows the calendar cycle
              if (userService.getUser().fiscalYearMethod === "beginning") {  // "beginning" option shifts year back by 1
                  today = moment(today).add(-1, 'years');
              }
              if (moment(today).month() + 1 >= fiscalStartMonth) {  // shift year forward by 1 if current period >= beginning period
                  today = moment(today).add(1, 'years');
              }
          }

          for (var i = 1990; i < today.year(); i++) {
              vm.targetBaseFiscalYears.push(i.toString());
          }
        }
        
        // Validate any validators
        function validate(event) {
            if (vm.validator.validate()) {
                save();
            }
            else {
                glazeService.showErrorMessage(customValidator.validationMessages.genericHeaderMessage());
            }
        }

        function toggle(showProp, multiplierProp) {
            // when the target for certain chart is disabled
            // default its multiplier to 1
            if (vm.targetComparisonData[showProp].value === "0") {
                vm.targetComparisonData[multiplierProp].value = "1";
            }
        }

        // Persist the changes and call the API
        function save() {
            glazeService.setSavingVisibility(true);

            apiResource.administration().systemSettings().update(vm.targetComparisonData, function (result) {
                gotoProperties(true);
            }, function (error) {
                glazeService.setSavingVisibility(false);
                glazeService.showErrorMessage(error.data.status.message);
            });
        }


        // After a successful save, go back to the overview page
        function gotoProperties(refresh) {
            glazeService.hideGlaze();
            if (refresh && urlService.module() === "manage") {
                $state.reload();
            }
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('administrationModule')
        .controller('targetComparisonOverviewController', TargetComparisonOverviewController);

    TargetComparisonOverviewController.$inject = ['apiResource', 'glazeService', '$filter', '$translate', 'translationHelper', 'runtimeService', 'userService'];

    function TargetComparisonOverviewController(apiResource, glazeService, $filter, $translate, translationHelper, runtimeService, userService) {
        var vm = this;
        var propertiesList = [
            'PowerviewTargetLabel',
            'PowerviewTargetFiscalYear',
            'PowerviewTargetMultiplierCost',
            'PowerviewTargetMultiplierGHG',
            'PowerviewTargetMultiplierUse',
            'PowerviewTargetShowCost',
            'PowerviewTargetShowGHG',
            'PowerviewTargetShowUse'
        ];

        vm.targetComparisonData = [];

        (function () {

            vm.grid = gridDefinition();
            vm.editTargetComparison = function editReportGroup() {
                glazeService.openGlaze(0, 'edit-target-comparison');
            };

            apiResource.administration().systemSettings().query({}).$promise.then(function (result) {
                vm.targetComparisonData = _.pick(result, propertiesList);

                processTargetCharts();

                // grid data source expects an array
                vm.grid.dataSource = [vm.targetComparisonData];
            });
           
        })();

        function processTargetCharts() {
            var costChartsString = '', useChartsString = '', ghgChartsString = '';
            var multiplier = {};

            if (+vm.targetComparisonData.PowerviewTargetShowCost.value) {
                costChartsString = translationHelper.translateAndInterpolate('AdminTargetsCostCharts', {
                    'powerviewTargetMultiplierCost': vm.targetComparisonData.PowerviewTargetMultiplierCost.value
                });
            }

            if (+vm.targetComparisonData.PowerviewTargetShowUse.value) {
                useChartsString = translationHelper.translateAndInterpolate('AdminTargetsUseCharts', {
                    'powerviewTargetMultiplierUse': vm.targetComparisonData.PowerviewTargetMultiplierUse.value
                });
            }

            if (+vm.targetComparisonData.PowerviewTargetShowGHG.value) {
                ghgChartsString = translationHelper.translateAndInterpolate('AdminTargetsGhgCharts', {
                    'powerviewTargetMultiplierGHG': vm.targetComparisonData.PowerviewTargetMultiplierGHG.value
                });
            }

            vm.targetComparisonData.enabledCharts = costChartsString + useChartsString + ghgChartsString;

            vm.targetComparisonData.labelDisplay = $translate.instant(vm.targetComparisonData.PowerviewTargetLabel.value);
        }

        function gridDefinition() {
            var grid = {};

            grid = {
                dataSource: {},
                scrollable: false,
                columns: [
                    {
                        field: "labelDisplay",
                        title: "Target line label"
                    },
                    {
                        field: "PowerviewTargetFiscalYear.value",
                        title: "Target base fiscal year"
                    },
					{
					    field: "enabledCharts",
					    title: "Charts with target enabled",
					    template: "<ul>#= enabledCharts.replace(/\\n/g, '<br/>') #</ul>"
					}
                ]
            };

            runtimeService.getConfigData().then(function () {
                if (userService.userHasPermission("ApplicationSettingsManage")) {
                    grid.columns.push(
                        {
                            headerAttributes: {
                                "class": "ec-grid-actions"
                            },
                            headerTemplate: "<button tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Edit target comparison\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='grid.controller.editTargetComparison()'><i class='ec-icon icon-edit'></i></button>"
                        }
                    );
                }
            });

            return grid;
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('importIntervalDataController', ImportIntervalDataController);

    ImportIntervalDataController.$inject = ['apiResource', 'glazeService', '$translate', 'customValidator', '$state', 'translationHelper', '$http', '$window'];

    function ImportIntervalDataController(apiResource, glazeService, $translate, customValidator, $state, translationHelper, $http, $window) {
        var vm = this;

        vm.fileResults = "";
        vm.fileName = "";
        vm.tasksLog = new Object();
        vm.isImportComplete = false;
        vm.validate = validate;
        vm.importFormatsLinkClick = importFormatsLinkClick;

        vm.validationOptions = {
            validateOnBlur: false,
            messages: {
                required: function (input) {
                    return customValidator.validationMessages.requiredMessage(input);
                }
            }
        };

        vm.comment = null;

        (function constructor() {
            initialFormLoad();

            glazeService.primaryAction = validate;
            glazeService.secondaryAction = close;

        })();

        function initialFormLoad() {
            var awaiter = new PromiseAwaiter();

            awaiter.add(apiResource.importer().readingProfile().query({}, function (result) {
                vm.profiles = _.orderBy(result, 'profileCode');
            }));

            glazeService.showLoading(awaiter);
        }

        function close() {
            glazeService.hideGlaze();
        }

        // function which will upload the loaded file
        function importFile(event) {
            if (!vm.isImportComplete && vm.fileResults) {
                glazeService.setIsImporting(true, true);
                glazeService.setWaitingOverlayVisibility(true, $translate.instant("Please wait while records are imported"));

                // Inlining HTTP request due to tight-loop.
                // It seems that ng-resource is mangling the response, resulting
                // in a tight-loop and ultimately locking up the browser for many
                // seconds
                $http({
                    method: 'POST',
                    url: 'api/v3/import/reading',
                    headers: {
                        "Content-Type": "application/json"
                    },
                    data: { profileCode: vm.selectedProfile, data: vm.fileResults, importNote: vm.comment }
                }).then(function (result) {
                    glazeService.setIsImporting(false, true);
                    vm.isImportComplete = true;

                    glazeService.setWaitingOverlayVisibility(false);

                    /**
                     * Scenarios for the following block:
                     * 
                     * 1. If the glaze is opened from the button on the import list, the glaze should do
                     *    nothing and close since the import list will handle the refresh
                     * 
                     * 2. If the glaze is opened from the create menu while on the import list, the import
                     *    list wont have the onGlazeClosed handler set up so it cannot handle the refresh
                     *    on its own
                     *    
                     * 3. if the glaze is opened from the create menu while elsewhere in the app, the glaze
                     *    will redirect to the fullscreen version of the import list
                     */
                    if ($state.name === "intervaldata.imports" && window.ECP.onGlazeClose) {
                        // do nothing, import list will refresh its grid
                    } else if ($state.name === "intervaldata.imports" && !window.ECP.onGlazeClose) {
                        $state.reload();
                    } else {
                        $state.navigateByUrl("manage/intervaldata/import/list");
                    }

                    close();
                }).catch(function(result){
                    // error could be because of:
                    //  - invalid file format (note that there is no task returned)

                    glazeService.setIsImporting(false, false);
                    vm.isImportComplete = false;

                    glazeService.setWaitingOverlayVisibility(false);
                    if (result.data.status && result.data.status.message) {
                        glazeService.showErrorMessage(result.data.status.message);
                    } else {
                        glazeService.showErrorMessage(result.statusText);
                    }
                });
            }
            else {
                glazeService.hideGlaze();
            }
        }

        function validate(event) {
            if (vm.validator.validate()) {
                glazeService.hideErrorMessage();
                importFile(event);
            }
            else {
                glazeService.showErrorMessage();
            }
        }

        function importFormatsLinkClick(event) {
            $window.ECP.onGlazeClose = null;
            glazeService.hideGlazeForStateChange(event);
            // If we are in the interval data module, go to the module version
            if ($state.url.startsWith('/intervaldata')) {
                $state.navigateByUrl('intervaldata/import/formats');
            // Otherwise go to the manage version
            } else {
                $state.navigateByUrl('manage/intervaldata/import/format/list');
            }
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('editBuildingGroupsController', EditBuildingGroupsController);

    EditBuildingGroupsController.$inject = ['$q', 'urlService', 'apiResource', 'glazeService', 'customValidator', '$state'];

    function EditBuildingGroupsController($q, urlService, apiResource, glazeService, customValidator, $state) {
        var vm = this;
        vm.placeId = glazeService.getCurrentId();
        vm.addGroupToMembership = addGroupToMembership;
        vm.removeGroupFromMembership = removeGroupFromMembership;

        // Kendo grid settings for the assigned grid
        vm.assignedGridSettings = {
            header: "Associated Building Groups",
            selectable: false,
            navigatable: false,
            dataSource: {
                group: {
                    field: "placeGroupCategory.placeGroupCategoryCode"
                },
                data: []
            },
            pageable: false,
            groupable: false,
            scrollable: false,
            resizable: false,
            functions: {
                removeGroupFromMembership: removeGroupFromMembership
            },
            columns: [
                {
                    field: "placeGroupCode",
                    title: "Group code",
                },
                {
                    field: "placeGroupInfo",
                    title: "Group name"
                },
                {
                    attributes: {
                        "class": "ec-grid-actions"
                    },
                    template: "<button type='button' ng-click='grid.controller.removeGroupFromMembership(#=placeGroupId#)' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Remove group association\" | translate}}' class='ec-btn-icon btn btn-secondary'><i class='ec-icon icon-cancel'></i></button>"
                },
                {
                    field: "placeGroupCategory.placeGroupCategoryCode",
                    hidden: true,
                    groupHeaderTemplate: function (item) {
                        var placeGroup = _.find(vm.assignedGridSettings.dataSource.data, function (itr) {
                            return itr.placeGroupCategory.placeGroupCategoryCode == item.value;
                        });
                        return kendo.htmlEncode(placeGroup.placeGroupCategory.placeGroupCategoryInfo + " [" + placeGroup.placeGroupCategory.placeGroupCategoryCode + "]");
                    }
                }
            ]
        };

        // Kendo grid settings for the available groups grid
        vm.availableGridSettings = {
            header: "Available Building Groups",
            selectable: "multiple",
            navigatable: false,
            dataSource: {
                group: {
                    field: "placeGroupCategory.placeGroupCategoryCode"
                },
                data: []
            },
            pageable: false,
            groupable: false,
            scrollable: false,
            resizable: false,
            functions: {
                addGroupToMembership: addGroupToMembership
            },
            columns: [
                {
                    field: "placeGroupCode",
                    title: "Group code",
                    attributes: {
                        "class": "text-break-all"
                    }
                },
                {
                    field: "placeGroupInfo",
                    title: "Group name"
                },
                {
                    attributes: {
                        "class": "ec-grid-actions"
                    },
                    template: "<button type='button' ng-click='grid.controller.addGroupToMembership(#=placeGroupId#)' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Add group association\" | translate}}' class='ec-btn-icon btn btn-secondary'><i class='ec-icon icon-add'></i></button>"
                },
                {
                    field: "placeGroupCategory.placeGroupCategoryCode",
                    hidden: true,
                    groupHeaderTemplate: function (item) {
                        var placeGroup = _.find(vm.availableGridSettings.dataSource.data, function (itr) {
                            return itr.placeGroupCategory.placeGroupCategoryCode == item.value;
                        });
                        return kendo.htmlEncode(placeGroup.placeGroupCategory.placeGroupCategoryInfo + " [" + placeGroup.placeGroupCategory.placeGroupCategoryCode + "]");
                    }
                }
            ]
        };

        vm.validate = validate;
        // Setup validation options for form controls
        vm.validationOptions = {
            validateOnBlur: false,
            messages: {
                required: function (input) {
                    return customValidator.validationMessages.requiredMessage(input);
                },
                customValidation: function (input) {
                    var optionalParam = {};
                    return customValidator.validationMessages.customValidationMessage(input, optionalParam);
                }
            },
            rules: {
                customValidation: function (input) {
                    var optionalParam = {};
                    return customValidator.validations.customValidation(input, optionalParam);
                }
            }
        };

        (function constructor() {
            initialFormLoad();

            glazeService.primaryAction = validate;
            glazeService.secondaryAction = glazeService.hideGlaze;
        })();

        function initialFormLoad() {
            glazeService.setLoadingVisibility(true);

            // Add all of the api requests promises to this array and wait for them to return, once done
            // broadcast an event for our glaze service to know to stop showing the waiting indicator
            var loadingPromises = [];

            // Call all needed APIs and push promises so we can act
            // when they all return
            loadingPromises.push(apiResource.place().groups().query({ placeId: vm.placeId }).$promise);
            loadingPromises.push(apiResource.group().placeGroup().query({}).$promise);

            $q.all(loadingPromises).then(function (res) {
                // Remove autogroups and UDAGs from the array of groups for
                // both assigned and available
                vm.assignedGridSettings.dataSource.data = _.filter(res[0], { "autoGroup": false, "userDefinedAutoGroup": false });

                // Remove assigned groups from the available groups.
                // Use a temp var so that the binding is only kicked off
                // once.
                var tempAvailableGroups = _.filter(res[1], { "autoGroup": false, "userDefinedAutoGroup": false });
                _.remove(tempAvailableGroups, function (item) {
                    var shouldRemove = false;
                    _.each(vm.assignedGridSettings.dataSource.data, function (toRemove) {
                        if (toRemove.placeGroupCode == item.placeGroupCode
                            && toRemove.placeGroupCategory.placeGroupCategoryId == item.placeGroupCategory.placeGroupCategoryId) {
                            shouldRemove = true;
                        }
                    });
                    return shouldRemove;
                });
                vm.availableGridSettings.dataSource.data = tempAvailableGroups;
                updateTitleCounts();
                glazeService.setLoadingVisibility(false);
            }, function (error) {
                glazeService.showErrorMessage(error.data.status.message);
                glazeService.setLoadingVisibility(false);
            });
        }

        // Returns an array of the selected items in a grid
        function selectedItems(grid) {
            var selectedRows = grid.select();
            var selectedDataItems = [];
            for (var i = 0; i < selectedRows.length; i++) {
                var dataItem = grid.dataItem(selectedRows[i]);
                selectedDataItems.push(dataItem);
            }

            return selectedDataItems;
        }

        // Update the given titles of each of the grids based
        // on the length of their datasources
        function updateTitleCounts() {
            vm.assignedGridSettings.headerCount = vm.assignedGridSettings.dataSource.data.length;
            vm.availableGridSettings.headerCount = vm.availableGridSettings.dataSource.data.length;
        }

        // Add selected members of the available grid
        // to the assigned grid
        function addGroupToMembership(placeGroupId) {
            var selectedDataItems = [];
            _.remove(vm.availableGridSettings.dataSource.data, function (item) {
                if (item.placeGroupId == placeGroupId) {
                    selectedDataItems.push(item);
                    return true;
                }
                return false;
            });

            vm.assignedGridSettings.dataSource.data = _.union(vm.assignedGridSettings.dataSource.data, selectedDataItems);
            updateTitleCounts();
        }

        
        // Remove selected members of the assgined grid
        // and assign them to the available grid
        function removeGroupFromMembership(placeGroupId) {
            var selectedDataItems = [];
            _.remove(vm.assignedGridSettings.dataSource.data, function (item) {
                if (item.placeGroupId == placeGroupId) {
                    selectedDataItems.push(item);
                    return true;
                }
                return false;
            });

            vm.availableGridSettings.dataSource.data = _.union(vm.availableGridSettings.dataSource.data, selectedDataItems);
            updateTitleCounts();
        }

        // Validate any validators
        function validate(event) {

            if (vm.validator.validate()) {
                save();
            }
            else {
                glazeService.showErrorMessage();
            }
        }

        // Persist the changes and call the API
        function save() {
            glazeService.setSavingVisibility(true);

            var members = _.map(vm.assignedGridSettings.dataSource.data, function (item) {
                return {
                    'placeGroupId': item.placeGroupId,
                    'includeInCharts': item.hasOwnProperty('includeInCharts') ? item.includeInCharts : true
                };
            });

            apiResource.place().groups().update({ placeId: vm.placeId }, members, function (result) {
                gotoProperties(true);
            }, function (error) {
                glazeService.setSavingVisibility(false);
                glazeService.showErrorMessage(error.data.status.message);
            });
        }

        // After a successful save, go back to the properties page
        function gotoProperties(refresh) {
            glazeService.hideGlaze();
            if (refresh && urlService.module() === "buildings") {
                $state.reload();
            }
        }


    }

})();

﻿(function () {
    'use strict';

    angular
        .module('app') 
        .controller('createOtherSavingsController', CreateOtherSavingsController);

    CreateOtherSavingsController.$inject = ['urlService', 'glazeService', 'apiResource', 'customValidator', '$state', '$q', '$templateCache', 'regexService', '$translate', 'translationHelper', 'runtimeService'];

    function CreateOtherSavingsController(urlService, glazeService, apiResource, customValidator, $state, $q, $templateCache, regexService, $translate, translationHelper, runtimeService) {
        var vm = this;
        var meterId = urlService.id();

        vm.otherSavings = { frequencyTypeId: '0' };

        // add new category template- variables and functions
        vm.newCategory = {};
        vm.addCategoryShown = false;
        vm.validateCategory = validateCategory;

        vm.currencySymbol = '';

        vm.toggles = {
            frequencyType: [
                { id: "once", label: "once", value: "0" },
                { id: "continuous", label: "continuous", value: "1" },
                { id: "recurring", label: "recurring", value: "2" }
            ]
        };

        vm.placeholder = translationHelper.placeholder();

        vm.regexService = {
            restrictDouble: regexService.restrictDouble()
        };

        vm.validationOptions = {
            validateOnBlur: false,
            messages: {
                required: function (input) {
                    return customValidator.validationMessages.requiredMessage(input);
                },
                customValidation: function (input) {
                    var optionalParam = {};

                    if (input.is("[ec-combo-box-ng-required-validation=true]")) {
                        optionalParam.ngRequired = vm.otherSavings.frequencyTypeId === '2';
                    }

                    return customValidator.validationMessages.customValidationMessage(input, optionalParam);
                }
            },
            rules: {
                customValidation: function (input) {
                    var optionalParam = {};

                    if (input.is("[ec-combo-box-ng-required-validation=true]")) {
                        optionalParam.ngRequired = vm.otherSavings.frequencyTypeId === '2';
                    }

                    return customValidator.validations.customValidation(input, optionalParam);
                }
            }
        };

        // kendo combox header template
        vm.addNewCategoryTemplate = $templateCache.get('addNewCategoryTemplate.html');

        (function constructor() {

            initialFormLoad();

            // Remember Months are 0 based
            // Need to add 1 before saving
            var months = [];
            for (var i = 0; i < 12; i++) {
                months.push({ monthNumber: i, monthName: moment().month(i).format("MMM") });
            }

            vm.toMonths = new kendo.data.DataSource({
                data: months
            });

            vm.fromMonths = new kendo.data.DataSource({
                data: months
            });

            glazeService.primaryAction = validate;
            glazeService.secondaryAction = glazeService.hideGlaze;
        })();

        function initialFormLoad() {
            var awaiter = new PromiseAwaiter();

            glazeService.setLoadingVisibility(true);

            awaiter.add(apiResource.savings().otherSavingsCategory().query({}, function (result) {
                vm.otherSavingsCategoryList = new kendo.data.DataSource({
                    data: result
                });

                glazeService.setLoadingVisibility(false);
            }));

            // Get our configuration data so we know the tree display settings
            awaiter.add(runtimeService.getConfigData().then(function (config) {
                vm.currencySymbol = config.currencyUnit ? config.currencyUnit.unitInfo : "$";
            }));

            glazeService.showLoading(awaiter);
        }

        // validates the controls for required fields
        function validate() {
            if (vm.validator.validate()) {
                save();
            }
            else {
                glazeService.showErrorMessage();
            }
        }

        function save() {

            // sanitize hte data (the date stuff) before calling the POST API
            sanitizeData();

            glazeService.setSavingVisibility(true);

            apiResource.savings().otherSavings().save({ meterId: meterId }, vm.otherSavings, function (result) {
                glazeService.hideGlaze();
                gotoProperties(true);
            }, function (error) {
                glazeService.setSavingVisibility(false);
                glazeService.showErrorMessage(error.data.status.message);
            });
        }

        // sanitize data before it is sent to the API for saving
        function sanitizeData() {

            //Clear out from and to data when frequency is-  once (frequencyTypeId 0)
            if (vm.otherSavings.frequencyTypeId === '0') {
                vm.otherSavings.endDate = null;
            }

            //Clear out from and to data when frequency is-  once (frequencyTypeId 0) or continuous (frequencyTypeId 1)
            if (vm.otherSavings.frequencyTypeId === '0' || vm.otherSavings.frequencyTypeId === '1') {
                vm.otherSavings.fromMonth = null;
                vm.otherSavings.toMonth = null;
            }
        }

        function gotoProperties(refresh) {
            glazeService.hideGlaze();
            if (refresh && urlService.module() === "buildings") {
                $state.reload();
            }
        }


        // #region add new category functions

        // validates the new category form for the required fields
        function validateCategory(event) {
            event.preventDefault();

            vm.categoryErrorMessage = "";
            if (vm.categoryValidator.validate()) {
                saveCategory();
            }
            else {
                vm.categoryErrorMessage = customValidator.validationMessages.genericHeaderMessage();
            }
        }

        // saves the new new category
        // and selects it in the combox
        function saveCategory() {

            vm.newCategorySaving = true;

            apiResource.savings().otherSavingsCategory().save(vm.newCategory, function (result) {
                vm.newCategorySaving = false;

                var newCategory = {
                    otherSavingsCategoryId: result.otherSavingsCategoryId,
                    otherSavingsCategoryInfo: result.otherSavingsCategoryInfo
                };

                vm.otherSavings.otherSavingsCategoryId = newCategory.otherSavingsCategoryId;

                vm.otherSavingsCategoryList.add(newCategory);

                vm.addCategoryShown = false;

            },
            function (error) {
                vm.newCategorySaving = false;
                vm.categoryErrorMessage = error.data.status.message;
            });

        }

        //#endregion

    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app') 
        .controller('createSpecialAdjustmentController', CreateSpecialAdjustmentController);

    CreateSpecialAdjustmentController.$inject = ['urlService', 'glazeService', 'apiResource', 'customValidator', 'regexService', '$window', '$q', '$state', '$translate'];

    function CreateSpecialAdjustmentController(urlService, glazeService, apiResource, customValidator, regexService, $window, $q, $state, $translate) {
        var vm = this;

        vm.kendoOptions = {
            datePickerOption: {
                parseFormats: ["yyyy-MM-ddTHH:mm:ss"],
                minDate: moment("01/01/1900").format('MM/DD/YYYY'), // minimum date possible
                maxDate: moment("01/01/2999").format('MM/DD/YYYY') // maximum date possible
            }
        };

        vm.toggles = {
            frequencyType: [
                { id: "continuous", label: "continuous", value: "continuous" },
                { id: "recurring", label: "recurring", value: "recurring" }
            ]
        };

        vm.choosePlaceholder = $translate.instant("Choose");
        vm.monthPlaceholder = $translate.instant("Month");
        vm.dayPlaceholder = $translate.instant("Day");

        vm.regexService = {
            restrictDouble: regexService.restrictDouble()
        };

        vm.meterId = urlService.id();
        vm.specialAdjustment = { frequency: "continuous" };

        vm.onFromMonthChange = onFromMonthChange;
        vm.onToMonthChange = onToMonthChange;

        vm.validationOptions = {
            validateOnBlur: false,
            messages: {
                required: function (input) {
                    return customValidator.validationMessages.requiredMessage(input);
                },
                customValidation: function (input) {
                    var optionalParam = {};

                    if (input.is("[ec-combo-box-ng-required-validation=true]")) {
                        optionalParam.ngRequired = vm.specialAdjustment.frequency === 'recurring';
                    }

                    return customValidator.validationMessages.customValidationMessage(input, optionalParam);
                }
            },
            rules: {
                customValidation: function (input) {
                    var optionalParam = {};

                    if (input.is("[ec-combo-box-ng-required-validation=true]")) {
                        optionalParam.ngRequired = vm.specialAdjustment.frequency === 'recurring';
                    }

                    return customValidator.validations.customValidation(input, optionalParam);
                }
            }
        };

        (function constructor() {
            initialFormLoad();

            //Remember Months are 0 based
            //Need to add 1 before saving
            var months = [];
            for (var i = 0; i < 12; i++) {
                months.push({ monthNumber: i, monthName: $translate.instant(moment().month(i).format("MMM")), numberOfDays: daysInMonth(i) });
            }

            vm.months = months;
            
            vm.onFromMonthChange();
            vm.onToMonthChange();

            glazeService.primaryAction = validate;
            glazeService.secondaryAction = glazeService.hideGlaze;
        })();

        function initialFormLoad() {
            var awaiter = new PromiseAwaiter();

            awaiter.add(apiResource.savings().specialAdjustmentMethods().query({}, function (result) {
                vm.availableSpecialAdjustmentMethods = result;
                _.forEach(vm.availableSpecialAdjustmentMethods, function (item) {
                    item.label = $translate.instant(item.label);
                });
            }));

            awaiter.add(apiResource.savings().specialAdjustmentTypes().query({}, function (result) {
                vm.availableSpecialAdjustmentTypes = result;
            }));

            glazeService.showLoading(awaiter);
        }

        // validates the controls for required fields
        function validate() {
            if (vm.validator.validate()) {
                save();
            }
            else {
                glazeService.showErrorMessage();
            }
        }

        function save() {
            glazeService.setSavingVisibility(true);

            //Clear out the value when it isn't used
            vm.specialAdjustment.specialAdjustmentMethodId = vm.specialAdjustmentMethod.specialAdjustmentMethodId;
            if (vm.specialAdjustmentMethod.precision === -1) {
                vm.specialAdjustment.value = 0;
            }

            vm.specialAdjustment.specialAdjustmentTypeId = vm.specialAdjustmentTypeId;
            //Clear out from and to data when frequency is continuous
            if (vm.specialAdjustment.frequency === 'continuous') {
                vm.specialAdjustment.fromMonth = 0;
                vm.specialAdjustment.fromDay = null;
                vm.specialAdjustment.toMonth = 0;
                vm.specialAdjustment.toDay = null;
            }

            apiResource.savings().specialAdjustment().save({ meterId: vm.meterId }, vm.specialAdjustment, function (result) {
                glazeService.hideGlaze();
                gotoProperties(true);
            }, function (error) {
                glazeService.setSavingVisibility(false);
                glazeService.showErrorMessage(error.data.status.message);
            });
        }

        //Setup the number of days dropdown when the month changes
        function onFromMonthChange() {            
            vm.fromDays = getDaysDataSource(vm.specialAdjustment.fromMonth);
            //If you have a day selected that will no longer exist in the list clear the value
            if (parseInt(vm.specialAdjustment.fromDay) > vm.fromDays.length) {
                vm.specialAdjustment.fromDay = "1";
            }
        }

        function onToMonthChange() {
            vm.toDays = getDaysDataSource(vm.specialAdjustment.toMonth);
            //If you have a day selected that will no longer exist in the list clear the value
            if (parseInt(vm.specialAdjustment.toDay) > vm.toDays.length) {
                vm.specialAdjustment.toDay = "1";
            }
        }

        //Get the number of days in the month selected to populate the combo box dropdown
        //Need a string value for the combobox search or else kendo with throw a javascript error when typing in the combo box dropdown
        function getDaysDataSource(monthNumber) {
            var days = [];
            if (monthNumber == undefined) {
                return days;
            }
            var dayCount = vm.months[parseInt(monthNumber)].numberOfDays;
            for (var i = 1; i <= dayCount; i++) {
                days.push({ dayNumberAsString: i.toString(), dayNumber: i });
            }

            return days;
        }

        function daysInMonth(month) {
            //Use non leap year because we always only want to get 28 days in February
            //Using 0 for the day gets the last day of the previous month so also need to add 1 to the month
            return new Date(2015, month+1, 0).getDate();
        }

        function gotoProperties(refresh) {
            glazeService.hideGlaze();
            if (refresh && urlService.module() === "buildings") {
                $state.reload();
            }
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('buildingsModule')
        .controller('editMeterExplanationOfSavingsController', EditMeterExplanationOfSavingsController);

    EditMeterExplanationOfSavingsController.$inject = ['urlService', 'apiResource', 'glazeService', '$window', '$q'];

    function EditMeterExplanationOfSavingsController(urlService, apiResource, glazeService, $window, $q) {
        var vm = this;
        vm.meterId = urlService.id();

        (function constructor() {
            initialFormLoad();

            // All actions our glaze can perform
            glazeService.actions = {
                cancel: cancel
            };

            vm.savingsDetailSource = 'energycap://chart/meter/savingsDetails/' + vm.meterId + '?billId=' + glazeService.getCurrentId();
        })();

        function initialFormLoad() {
            glazeService.setLoadingVisibility(true);

            getMeterSavingsDetails(glazeService.getCurrentId()).then(function (result) {
                glazeService.setLoadingVisibility(false);
            }, function (error) {
                glazeService.setLoadingVisibility(false);
            });
        }

        function getMeterSavingsDetails(billId) {
            return apiResource.savings().meterBills().query({ meterId: vm.meterId }, function (result) {
                if (result.length > 0) {

                    var billIndex = _.findIndex(result, function (bill) {
                        return bill.billId == billId;
                    });

                    vm.billingPeriod = result[billIndex].periodName + " " + result[billIndex].calendarYear;
                }
            }).$promise;
        }

        function cancel() {
           glazeService.hideGlaze();
        }
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('editMeterGroupsController', EditMeterGroupsController);

    EditMeterGroupsController.$inject = ['$q', 'urlService', 'apiResource', 'glazeService', 'customValidator', '$state'];

    function EditMeterGroupsController($q, urlService, apiResource, glazeService, customValidator, $state) {
        var vm = this;
        vm.meterId = glazeService.getCurrentId();
        vm.addGroupToMembership = addGroupToMembership;
        vm.removeGroupFromMembership = removeGroupFromMembership;

        // Kendo grid settings for the assigned grid
        vm.assignedGridSettings = {
            header: "Associated Meter Groups",
            selectable: false,
            navigatable: false,
            dataSource: {
                group: {
                    field: "meterGroupCategory.meterGroupCategoryCode"
                },
                data: []
            },
            pageable: false,
            groupable: false,
            scrollable: false,
            resizable: false,
            functions: {
                removeGroupFromMembership: removeGroupFromMembership
            },
            columns: [
                {
                    field: "meterGroupCode",
                    title: "Group code"
                },
                {
                    field: "meterGroupInfo",
                    title: "Group name"
                },
                {
                    attributes: {
                        "class": "ec-grid-actions"
                    },
                    template: "<button type='button' ng-click='grid.controller.removeGroupFromMembership(#=meterGroupId#)' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Remove group association\" | translate}}' class='ec-btn-icon btn btn-secondary'><i class='ec-icon icon-cancel'></i></button>"
                },
                {
                    field: "meterGroupCategory.meterGroupCategoryCode",
                    hidden: true,
                    groupHeaderTemplate: function (item) {
                        var meterGroup = _.find(vm.assignedGridSettings.dataSource.data, function (itr) {
                            return itr.meterGroupCategory.meterGroupCategoryCode == item.value;
                        });
                        return kendo.htmlEncode(meterGroup.meterGroupCategory.meterGroupCategoryInfo + " [" + meterGroup.meterGroupCategory.meterGroupCategoryCode + "]");
                    }
                }
            ]
        };

        // Kendo grid settings for the available groups grid
        vm.availableGridSettings = {
            header: "Available Meter Groups",
            selectable: "multiple",
            navigatable: false,
            dataSource: {
                group: {
                    field: "meterGroupCategory.meterGroupCategoryCode"
                },
                data: []
            },
            pageable: false,
            groupable: false,
            scrollable: false,
            resizable: false,
            functions: {
                addGroupToMembership: addGroupToMembership
            },
            columns: [
                {
                    field: "meterGroupCode",
                    title: "Group code",
                    attributes: {
                        "class": "text-break-all"
                    },
                },
                {
                    field: "meterGroupInfo",
                    title: "Group name"
                },
                {
                    attributes: {
                        "class": "ec-grid-actions"
                    },
                    template: "<button type='button' ng-click='grid.controller.addGroupToMembership(#=meterGroupId#)' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Add group association\" | translate}}' class='ec-btn-icon btn btn-secondary'><i class='ec-icon icon-add'></i></button>"
                },
                {
                    field: "meterGroupCategory.meterGroupCategoryCode",
                    hidden: true,
                    groupHeaderTemplate: function (item) {
                        var meterGroup = _.find(vm.availableGridSettings.dataSource.data, function (itr) {
                            return itr.meterGroupCategory.meterGroupCategoryCode == item.value;
                        });
                        return kendo.htmlEncode(meterGroup.meterGroupCategory.meterGroupCategoryInfo + " [" + meterGroup.meterGroupCategory.meterGroupCategoryCode + "]");
                    }
                }
            ]
        };

        vm.validate = validate;
        // Setup validation options for form controls
        vm.validationOptions = {
            validateOnBlur: false,
            messages: {
                required: function (input) {
                    return customValidator.validationMessages.requiredMessage(input);
                },
                customValidation: function (input) {
                    var optionalParam = {};
                    return customValidator.validationMessages.customValidationMessage(input, optionalParam);
                }
            },
            rules: {
                customValidation: function (input) {
                    var optionalParam = {};
                    return customValidator.validations.customValidation(input, optionalParam);
                }
            }
        };

        (function constructor() {
            initialFormLoad();

            glazeService.primaryAction = validate;
            glazeService.secondaryAction = glazeService.hideGlaze;
        })();

        function initialFormLoad() {
            glazeService.setLoadingVisibility(true);

            // Add all of the api requests promises to this array and wait for them to return, once done
            // broadcast an event for our glaze service to know to stop showing the waiting indicator
            var loadingPromises = [];

            // Call all needed APIs and push promises so we can act
            // when they all return
            loadingPromises.push(apiResource.meter().groups().query({ meterId: vm.meterId }).$promise);
            loadingPromises.push(apiResource.group().meterGroup().query({}).$promise);

            $q.all(loadingPromises).then(function (res) {
                // Remove autogroups and UDAGs from the array of groups for
                // both assigned and available
                vm.assignedGridSettings.dataSource.data = _.filter(res[0], { "autoGroup": false, "userDefinedAutoGroup": false });

                // Remove assigned groups from the available groups.
                // Use a temp var so that the binding is only kicked off
                // once.
                var tempAvailableGroups = _.filter(res[1], { "autoGroup": false, "userDefinedAutoGroup": false });
                _.remove(tempAvailableGroups, function (item) {
                    var shouldRemove = false;
                    _.each(vm.assignedGridSettings.dataSource.data, function (toRemove) {
                        if (toRemove.meterGroupCode == item.meterGroupCode
                            && toRemove.meterGroupCategory.meterGroupCategoryId == item.meterGroupCategory.meterGroupCategoryId) {
                            shouldRemove = true;
                        }
                    });
                    return shouldRemove;
                });
                vm.availableGridSettings.dataSource.data = tempAvailableGroups;

                updateTitleCounts();
                glazeService.setLoadingVisibility(false);
            }, function (error) {
                glazeService.showErrorMessage(error.data.status.message);
                glazeService.setLoadingVisibility(false);
            });
        }

        // Returns an array of the selected items in a grid
        function selectedItems(grid) {
            var selectedRows = grid.select();
            var selectedDataItems = [];
            for (var i = 0; i < selectedRows.length; i++) {
                var dataItem = grid.dataItem(selectedRows[i]);
                selectedDataItems.push(dataItem);
            }

            return selectedDataItems;
        }

        // Update the given titles of each of the grids based
        // on the length of their datasources
        function updateTitleCounts() {
            vm.assignedGridSettings.headerCount = vm.assignedGridSettings.dataSource.data.length;
            vm.availableGridSettings.headerCount = vm.availableGridSettings.dataSource.data.length;
        }

        // Add selected members of the available grid
        // to the assigned grid
        function addGroupToMembership(meterGroupId) {
            var selectedDataItems = [];
            _.remove(vm.availableGridSettings.dataSource.data, function (item) {
                if (item.meterGroupId == meterGroupId) {
                    selectedDataItems.push(item);
                    return true;
                }
                return false;
            });

            vm.assignedGridSettings.dataSource.data = _.union(vm.assignedGridSettings.dataSource.data, selectedDataItems);
            updateTitleCounts();
        }


        // Remove selected members of the assgined grid
        // and assign them to the available grid
        function removeGroupFromMembership(meterGroupId) {
            var selectedDataItems = [];
            _.remove(vm.assignedGridSettings.dataSource.data, function (item) {
                if (item.meterGroupId == meterGroupId) {
                    selectedDataItems.push(item);
                    return true;
                }
                return false;
            });

            vm.availableGridSettings.dataSource.data = _.union(vm.availableGridSettings.dataSource.data, selectedDataItems);
            updateTitleCounts();
        }

        // Validate any validators
        function validate(event) {

            if (vm.validator.validate()) {
                save();
            }
            else {
                glazeService.showErrorMessage();
            }
        }

        // Persist the changes and call the API
        function save() {
            glazeService.setSavingVisibility(true);

            var members = _.map(vm.assignedGridSettings.dataSource.data, function (item) {
                return {
                    'meterGroupId': item.meterGroupId,
                    'includeInCharts': item.hasOwnProperty('includeInCharts') ? item.includeInCharts : true
                };
            });

            apiResource.meter().groups().update({ meterId: vm.meterId }, members, function (result) {
                gotoProperties(true);
            }, function (error) {
                glazeService.setSavingVisibility(false);
                glazeService.showErrorMessage(error.data.status.message);
            });
        }

        // After a successful save, go back to the properties page
        function gotoProperties(refresh) {
            glazeService.hideGlaze();
            if (refresh && urlService.module() === "buildings") {
                $state.reload();
            }
        }


    }

})();

﻿(function () {
    'use strict';

    angular
        .module('app') 
        .controller('editOtherSavingsController', EditOtherSavingsController);

    EditOtherSavingsController.$inject = ['urlService', 'glazeService', 'apiResource', 'customValidator', '$state', '$q', '$templateCache', 'regexService', '$translate', 'translationHelper', 'runtimeService'];

    function EditOtherSavingsController(urlService, glazeService, apiResource, customValidator, $state, $q, $templateCache, regexService, $translate, translationHelper, runtimeService) {
        var vm = this;
        var meterId = urlService.id();
        var otherSavingsId = glazeService.getCurrentId();

        vm.otherSavings = { };

        // add new category template- variables and functions
        vm.newCategory = {};
        vm.addCategoryShown = false;
        
        vm.validateCategory = validateCategory;

        vm.placeholder = translationHelper.placeholder();

        vm.regexService = {
            restrictDouble: regexService.restrictDouble()
        };

        vm.validationOptions = {
            validateOnBlur: false,
            messages: {
                required: function (input) {
                    return customValidator.validationMessages.requiredMessage(input);
                },
                customValidation: function (input) {
                    var optionalParam = {};

                    if (input.is("[ec-combo-box-ng-required-validation=true]")) {
                        optionalParam.ngRequired = vm.otherSavings.frequencyTypeId === '2';
                    }

                    return customValidator.validationMessages.customValidationMessage(input, optionalParam);
                }
            },
            rules: {
                customValidation: function (input) {
                    var optionalParam = {};

                    if (input.is("[ec-combo-box-ng-required-validation=true]")) {
                        optionalParam.ngRequired = vm.otherSavings.frequencyTypeId === '2';
                    }

                    return customValidator.validations.customValidation(input, optionalParam);
                }
            }
        };

        (function constructor() {
            initialFormLoad();

            // kendo combox header template
            vm.addNewCategoryTemplate = $templateCache.get('addNewCategoryTemplate.html');

            // Remember Months are 0 based
            // Need to add 1 before saving
            var months = [];
            for (var i = 0; i < 12; i++) {
                months.push({ monthNumber: i, monthName: moment().month(i).format("MMM") });
            }

            vm.toMonths = new kendo.data.DataSource({
                data: months
            });

            vm.fromMonths = new kendo.data.DataSource({
                data: months
            });

            glazeService.primaryAction = validate;
            glazeService.secondaryAction = glazeService.hideGlaze;
        })();

        function initialFormLoad() {
            var awaiter = new PromiseAwaiter();
 
            awaiter.add(apiResource.savings().otherSavings().get({ meterId: meterId, otherSavingsId: otherSavingsId }, function (result) {
                vm.otherSavings = result;

                if (vm.otherSavings.frequencyTypeId === '0') {
                    vm.otherSavings.frequencyLabel = $translate.instant('once');
                } else if (vm.otherSavings.frequencyTypeId === '1') {
                    vm.otherSavings.frequencyLabel = $translate.instant('continuous');
                } else if (vm.otherSavings.frequencyTypeId === '2') {
                    vm.otherSavings.frequencyLabel = $translate.instant('recurring');
                }
                
            }));

            awaiter.add(apiResource.savings().otherSavingsCategory().query({}, function (result) {
                vm.otherSavingsCategoryList = new kendo.data.DataSource({
                    data: result
                });
            }));

            glazeService.showLoading(awaiter);
        }

        // validates the controls for required fields
        function validate() {
            if (vm.validator.validate()) {
                save();
            }
            else {
                glazeService.showErrorMessage();
            }
        }

        function save() {

            // sanitize hte data (the date stuff) before calling the POST API
            sanitizeData();

            glazeService.setSavingVisibility(true);

            apiResource.savings().otherSavings().update({ meterId: meterId, otherSavingsId: otherSavingsId }, vm.otherSavings, function (result) {
                gotoProperties(true);
            }, function (error) {
                glazeService.setSavingVisibility(false);
                glazeService.showErrorMessage(error.data.status.message);
            });
        }

        // sanitize data before it is sent to the API for saving
        function sanitizeData() {

            //Clear out from and to data when frequency is-  once (frequencyTypeId 0)
            if (vm.otherSavings.frequencyTypeId === '0') {
                vm.otherSavings.endDate = null;
            }

            //Clear out from and to data when frequency is-  once (frequencyTypeId 0) or continuous (frequencyTypeId 1)
            if (vm.otherSavings.frequencyTypeId === '0' || vm.otherSavings.frequencyTypeId === '1') {
                vm.otherSavings.fromMonth = null;
                vm.otherSavings.toMonth = null;
            }
        }

        function gotoProperties(refresh) {
            glazeService.hideGlaze();
            if (refresh && urlService.module() === "buildings") {
                $state.reload();
            }
        }


        // #region add new category functions


        // validates the new category form for the required fields
        function validateCategory(event) {
            event.preventDefault();

            vm.categoryErrorMessage = "";
            if (vm.categoryValidator.validate()) {
                saveCategory();
            }
            else {
                vm.categoryErrorMessage = customValidator.validationMessages.genericHeaderMessage();
            }
        }

        // saves the new new category
        // and selects it in the combox
        function saveCategory() {

            vm.newCategorySaving = true;

            apiResource.savings().otherSavingsCategory().save(vm.newCategory, function (result) {
                vm.newCategorySaving = false;

                var newCategory = {
                    otherSavingsCategoryId: result.otherSavingsCategoryId,
                    otherSavingsCategoryInfo: result.otherSavingsCategoryInfo
                };

                vm.otherSavings.otherSavingsCategoryId = newCategory.otherSavingsCategoryId;

                vm.otherSavingsCategoryList.add(newCategory);

                vm.addCategoryShown = false;

            },
            function (error) {
                vm.newCategorySaving = false;
                vm.categoryErrorMessage = error.data.status.message;
            });

        }

        //#endregion

    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('editSpecialAdjustmentController', EditSpecialAdjustmentController);

    EditSpecialAdjustmentController.$inject = ['urlService', 'glazeService', 'apiResource', 'customValidator', '$state', 'regexService', '$q', '$translate'];

    function EditSpecialAdjustmentController(urlService, glazeService, apiResource, customValidator, $state, regexService, $q, $translate) {
        var vm = this;

        vm.kendoOptions = {
            datePickerOption: {
                parseFormats: ["YYYY-MM-DDTHH:mm:ss"],
                min: moment("01/01/1900").format('MM/DD/YYYY'), // minimum date possible
                max: moment("01/01/2999").format('MM/DD/YYYY') // maximum date possible
            }
        };

        vm.choosePlaceholder = $translate.instant("Choose");
        vm.monthPlaceholder = $translate.instant("Month");
        vm.dayPlaceholder = $translate.instant("Day");
        
        vm.regexService = {
            restrictDouble: regexService.restrictDouble()
        };

        vm.meterId = urlService.id();
        vm.specialAdjustmentId = glazeService.getCurrentId();

        vm.onFromMonthChange = onFromMonthChange;
        vm.onToMonthChange = onToMonthChange;

        vm.validationOptions = {
            validateOnBlur: false,
            messages: {
                required: function (input) {
                    return customValidator.validationMessages.requiredMessage(input);
                },
                customValidation: function (input) {
                    var optionalParam = {};

                    if (input.is("[ec-combo-box-ng-required-validation=true]")) {
                        optionalParam.ngRequired = vm.specialAdjustment.frequency.frequency === "recurring";
                    }

                    return customValidator.validationMessages.customValidationMessage(input, optionalParam);
                }
            },
            rules: {
                customValidation: function (input) {
                    var optionalParam = {};

                    if (input.is("[ec-combo-box-ng-required-validation=true]")) {
                        optionalParam.ngRequired = vm.specialAdjustment.frequency.frequency === "recurring";
                    }

                    return customValidator.validations.customValidation(input, optionalParam);
                }
            }
        };

        (function constructor() {   

            //Remember Months are 0 based
            //Need to add 1 before saving
            var months = [];
            for (var i = 0; i < 12; i++) {
                months.push({ monthNumber: i, monthName: $translate.instant(moment().month(i).format("MMM")), numberOfDays: daysInMonth(i) });
            }

            vm.months = months;            
            initialFormLoad();
            glazeService.primaryAction = validate;
            glazeService.secondaryAction = glazeService.hideGlaze; 
        })();

        function initialFormLoad() {
            var awaiter = new PromiseAwaiter();
            awaiter.add(apiResource.savings().specialAdjustmentMethods().query({}, function (result) {
                vm.availableSpecialAdjustmentMethods = result;              
                _.forEach(vm.availableSpecialAdjustmentMethods, function (item) {
                    item.label = $translate.instant(item.label);
                });
            }));
            

            awaiter.add(apiResource.savings().specialAdjustmentTypes().query({}, function (result) {
                vm.availableSpecialAdjustmentTypes = result;                
            }));

            awaiter.add(apiResource.savings().specialAdjustment().get({ meterId: vm.meterId, specialAdjustmentId: vm.specialAdjustmentId }, function (result) {
                vm.specialAdjustment = result;

                vm.specialAdjustment.frequency.frequency = vm.specialAdjustment.frequency.frequency.toLowerCase();

                // Format our dates
                vm.specialAdjustment.frequency.startDate = vm.specialAdjustment.frequency.startDate ? moment(vm.specialAdjustment.frequency.startDate).format('MM/DD/YYYY') : '';
                vm.specialAdjustment.frequency.endDate = vm.specialAdjustment.frequency.endDate ? moment(vm.specialAdjustment.frequency.endDate).format('MM/DD/YYYY') : '';    
    
                if (vm.specialAdjustment.frequency.frequency === "recurring") {
                    vm.specialAdjustment.frequencyLabel = $translate.instant('recurring');

                    // Setup our from and to month combo box fields
                    vm.specialAdjustment.fromMonth = (parseInt(vm.specialAdjustment.frequency.annualCycleStartMMDD / 100) - 1).toString();

                    // Call on change to get the data provider for the control
                    onFromMonthChange();

                    vm.specialAdjustment.fromDay = vm.fromDays[(vm.specialAdjustment.frequency.annualCycleStartMMDD % 100) - 1].dayNumber.toString();

                    vm.specialAdjustment.toMonth = (parseInt(vm.specialAdjustment.frequency.annualCycleEndMMDD / 100) - 1).toString();

                    // Call on change to get the data provider for the control
                    onToMonthChange();

                    vm.specialAdjustment.toDay = vm.toDays[(vm.specialAdjustment.frequency.annualCycleEndMMDD % 100) - 1].dayNumber.toString();
                } else if (vm.specialAdjustment.frequency.frequency === "continuous") {
                    vm.specialAdjustment.frequencyLabel = $translate.instant('continuous');
                }
            }));

            awaiter.notifyWhenDone().then(function (data) {
                var specAdj = _.find(vm.availableSpecialAdjustmentTypes, function (item) {
                    return item.specialAdjustmentTypeId == vm.specialAdjustment.specialAdjustmentType.specialAdjustmentTypeId;
                });
                vm.specialAdjustmentTypeId = specAdj.specialAdjustmentTypeId;
                _.forEach(vm.availableSpecialAdjustmentMethods, function (item) {
                    item.label = $translate.instant(item.label);
                })
                vm.specialAdjustmentMethod = _.find(vm.availableSpecialAdjustmentMethods, function (item) {
                    return item.specialAdjustmentMethodId == vm.specialAdjustment.specialAdjustmentMethod.specialAdjustmentMethodId;
                });
            });
                
            

            glazeService.showLoading(awaiter);
        }

        // validates the controls for required fields
        function validate() {
            if (vm.validator.validate()) {
                save();
            }
            else {
                glazeService.showErrorMessage();
            }
        }

        function save() {
            glazeService.setSavingVisibility(true);

            //Clear out the value when it isn't used
            //Clear out the value when it isn't used
            vm.specialAdjustment.specialAdjustmentMethod.specialAdjustmentMethodId = vm.specialAdjustmentMethod.specialAdjustmentMethodId;
            if (vm.specialAdjustmentMethod.precision === -1) {
                vm.specialAdjustment.value = 0;
            }

            vm.specialAdjustment.specialAdjustmentType.specialAdjustmentTypeId = vm.specialAdjustmentTypeId;

            //Clear out from and to data when frequency is continuous
            if (vm.specialAdjustment.frequency.frequency === "continuous") {
                vm.specialAdjustment.fromMonth = 0;
                vm.specialAdjustment.fromDay = null;
                vm.specialAdjustment.toMonth = 0;
                vm.specialAdjustment.toDay = null;
            }

            apiResource.savings().specialAdjustment().update({ meterId: vm.meterId, specialAdjustmentId: vm.specialAdjustmentId }, vm.specialAdjustment, function (result) {
                glazeService.hideGlaze();
                gotoProperties(true);
            }, function (error) {
                glazeService.setSavingVisibility(false);
                glazeService.showErrorMessage(error.data.status.message);
            });
        }

        function onFromMonthChange() {
            vm.fromDays = getDaysDataSource(vm.specialAdjustment.fromMonth);
            //If you have a day selected that will no longer exist in the list clear the value
            if (parseInt(vm.specialAdjustment.fromDay) > vm.fromDays.length) {
                vm.specialAdjustment.fromDay = "1";
            }
        }

        function onToMonthChange() {
            vm.toDays = getDaysDataSource(vm.specialAdjustment.toMonth);
            //If you have a day selected that will no longer exist in the list clear the value
            if (parseInt(vm.specialAdjustment.toDay) > vm.toDays.length) {
                vm.specialAdjustment.toDay = "1";
            }
        }

        //Get the number of days in the month selected to populate the combo box dropdown
        //Need a string value for the combobox search or else kendo with throw a javascript error when typing in the combo box dropdown
        function getDaysDataSource(monthNumber) {
            var days = [];
            if (monthNumber == undefined) {
                return days;
            }
            var dayCount = vm.months[parseInt(monthNumber)].numberOfDays;
            for (var i = 1; i <= dayCount; i++) {
                days.push({ dayNumberAsString: i.toString(), dayNumber: i });
            }

            return days;
        }

        function daysInMonth(month) {
            //Use non leap year because we always only want to get 28 days in February
            //Using 0 for the day gets the last day of the previous month so also need to add 1 to the month
            return new Date(2015, month + 1, 0).getDate();
        }

        function gotoProperties(refresh) {
            glazeService.hideGlaze();
            if (refresh && urlService.module() === "buildings") {
                $state.reload();
            }
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('buildingsModule')
        .controller('meterCalendarizedUseVsWeatherController', MeterCalendarizedUseVsWeatherController);

    MeterCalendarizedUseVsWeatherController.$inject = ['apiResource', '$state', '$translate', 'translationHelper', 'powerviewHelper'];

    /**
    * Controller for the Meter Calendarized Use vs Weather Powerview
    */
    function MeterCalendarizedUseVsWeatherController(apiResource, $state, $translate, translationHelper, powerviewHelper) {
        var vm = this;

        ////////////////////////////////////////////////////////////////////////
        // TODO: remove after ECAP-3957 is done
        vm.converted = true;
        ////////////////////////////////////////////////////////////////////////

        vm.DETAIL_TEMPLATE_HTML =
            "<table class='mb-2'>" +
                "<thead class='k-grid-header'>" +
                    "<tr>" +
                        "<th class='k-header border-left-0' translate>Cooling</th>" +
                        "<th class='k-header' translate>Heating</th>" +
                    "</tr>" +
                "</thead>" +
                "<tbody>" +
                    "<tr>" +
                        "<td>#:coolingMessage#</td>" +
                        "<td>#:heatingMessage#</td>" +
                    "</tr>" +
                "</tbody>" +
            "</table>";

        vm.id = $state.params.meterId;

        init();

        /**
        * Constructor function to be called when the controller is ready to load
        */
        function init() {
            vm.status = 'pending';
            vm.message = 'Loading';

            apiResource.meter().calendarizedUseVsWeather().query({ meterId: vm.id }, function (result) {

                var translatedResults = _.map(result, function (current) {
                    if (current.isCoolingWeatherSensitive) {
                        current.coolingMessage = translationHelper.translateAndInterpolate('Calendarized Use vs Weather - Weather sensitive message', {
                            aboveOrBelow: "above",
                            balancePoint: current.summerBalancePoint,
                            weatherFactor: current.coolingWeatherFactor,
                            useUnit: current.useUnit.unitInfo,
                            baseUsePerDay: current.coolingBaseUsePerDay
                        });
                    }
                    else {
                        current.coolingMessage = $translate.instant('Calendarized Use vs Weather - Not weather sensitive message');
                    }

                    if (current.isHeatingWeatherSensitive) {
                        current.heatingMessage = translationHelper.translateAndInterpolate('Calendarized Use vs Weather - Weather sensitive message', {
                            aboveOrBelow: "below",
                            balancePoint: current.winterBalancePoint,
                            weatherFactor: current.heatingWeatherFactor,
                            useUnit: current.useUnit.unitInfo,
                            baseUsePerDay: current.heatingBaseUsePerDay
                        });
                    }
                    else {
                        current.heatingMessage = $translate.instant('Calendarized Use vs Weather - Not weather sensitive message');
                    }
                    return current;
                });

                setPowerviewProperties(powerviewHelper.getPowerviewProperties({ results: result }));
                createWidgets();
            }, function (error) {
                setPowerviewProperties(powerviewHelper.getPowerviewProperties());
            });
        }

        /**
         * Sets view properties for the powerview
         * @param {Object} properties - The powerview properties
         */
        function setPowerviewProperties(properties) {
            vm.data = properties.data;
            vm.message = properties.message;
            vm.status = properties.status;
        }

        function createWidgets() {
            vm.widgets = [];

            vm.widgets.push(powerviewHelper.getWidgetDefinition({
                id: "useVsWeather",
                type: 'dataGrid',
                class: 'col-12',
                autoHeight: true,
                content: useVsWeatherDetailsGrid()
            }));
        }

        function useVsWeatherDetailsGrid() {
            return {
                dataGrid: {
                    dataSource: {
                        sort: { field: "year", dir: "desc" },
                        data: vm.data.results
                    },
                    detailTemplate: kendo.template(vm.DETAIL_TEMPLATE_HTML),
                    columns: [
                        {
                            field: "year",
                            title: "Year"
                        },
                        {
                            title: "Cooling",
                            headerAttributes: {
                                class: 'ec-grid-merged-cell-top ec-util-border-bottom'
                            },
                            columns: [
                                {
                                    field: "isCoolingWeatherSensitive",
                                    title: "Weather-sensitive",
                                    template: "<i class='ec-icon #=isCoolingWeatherSensitive ? 'icon-check' : ''#'></i>"
                                },
                                {
                                    field: "coolingBaseUsePerDay",
                                    title: "Base load",
                                    template: "#=isCoolingWeatherSensitive ? coolingBaseUsePerDay  + ' ' + useUnit.unitInfo + '/" + $translate.instant("day") + "' : ''#"
                                },
                                {
                                    field: "coolingWeatherFactor",
                                    title: "Weather factor",
                                    template: "#=isCoolingWeatherSensitive ? coolingWeatherFactor + ' ' + useUnit.unitInfo + '/" + $translate.instant("CDD") + "' : ''#",
                                    headerAttributes: {
                                        class: 'ec-grid-merged-cell-bottom'
                                    },
                                }
                            ]
                        },
                        {
                            title: "Heating",
                            headerAttributes: {
                                class: 'ec-util-border-bottom'
                            },
                            columns: [
                                {
                                    field: "isHeatingWeatherSensitive",
                                    title: "Weather-sensitive",
                                    template: "<i class='ec-icon #=isHeatingWeatherSensitive ? 'icon-check' : ''#'></i>"
                                },
                                {
                                    field: "heatingBaseUsePerDay",
                                    title: "Base load",
                                    template: "#=isHeatingWeatherSensitive ? heatingBaseUsePerDay + ' ' + useUnit.unitInfo + '/" + $translate.instant("day") + "' : ''#"
                                },
                                {
                                    field: "heatingWeatherFactor",
                                    title: "Weather factor",
                                    template: "#=isHeatingWeatherSensitive ? heatingWeatherFactor + ' ' + useUnit.unitInfo + '/" + $translate.instant("HDD") + "' : ''#"

                                }
                            ]
                        }
                    ]
                }
            };           
        }
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('buildingsModule')
        .controller('meterExplanationOfSavingsController', MeterExplanationOfSavingsController);

    MeterExplanationOfSavingsController.$inject = ['$state', 'apiResource', 'glazeService', '$templateCache', '$q', '$translate', 'gridHelper', 'chartHelper', 'userService'];

    /**
    * Controller for the Meter Explanation of Savings Powerview
    */
    function MeterExplanationOfSavingsController($state, apiResource, glazeService, $templateCache, $q, $translate, gridHelper, chartHelper, userService) {
        var vm = this;
        vm.meterId = $state.params.meterId;
        vm.details = savingsDailyGrid();

        vm.previousBillId = 0;
        vm.nextBillId = 0;

        vm.manualAdjustment = manualAdjustment;

        vm.locked = false;

        vm.currencyUnit = '';

        vm.canAdjustSavings = userService.userHasPermission('ManuallyAdjustSavingsManage');

        (function constructor() {
            // All actions our glaze can perform
            glazeService.actions = {
                secondaryAction: glazeService.hideGlaze,
                previous: previous,
                next: next,
                navigationDisplay: navigationDisplay,
                hasPrevious: hasPrevious,
                hasNext: hasNext
            };

            vm.savingsDetailSource = 'energycap://chart/meter/savingsDetails/' + vm.meterId + '?billId=' + glazeService.getCurrentId();

            initialFormLoad();
        })();

        function initialFormLoad() {
            glazeService.setLoadingVisibility(true);

            // Add all of the api requests promises to this array and wait for them to return, once done
            // broadcast an event for our glaze service to know to stop showing the waiting indicator
            var loadingPromises = [];

            // Get the daily grid details
            loadingPromises.push(getMeterDailyDetails(glazeService.getCurrentId()));

            // Get the bill being viewed info and the next and previous bill id
            loadingPromises.push(getMeterSavingsDetails(glazeService.getCurrentId()));

            $q.all(loadingPromises).then(function (data) {
                // Resolved
                glazeService.setLoadingVisibility(false);
            },
            function (data) {
                // Rejected
                glazeService.setLoadingVisibility(false);
            });
        }

        function manualAdjustment() {
            glazeService.openGlaze(glazeService.getCurrentId(), 'edit-meter-explanation-of-savings');
        }
        
        function getMeterDailyDetails(billId) {

            return apiResource.savings().meterDaily().get({ meterId: vm.meterId, billId: billId }, function (result) {

                vm.daily = result.daily;

                angular.forEach(vm.daily, function (day) {

                    // Give every daily record the native use unit info to display in the table
                    day.unitInfo = result.nativeUseUnit.unitInfo;

                    // Assign the billing period to each record using the first day records date
                    day.billingPeriod = result.periodName + " " + result.calendarYear;
                });
                vm.details.dataSource.data = vm.daily;

            }, function (error) {
                vm.daily = [];
            }).$promise;
        }

        function getMeterSavingsDetails(billId) {
            vm.previousBillId = 0;
            vm.nextBillId = 0;

            return apiResource.savings().meterBills().query({ meterId: vm.meterId }, function (result) {
                if (result.length > 0) {

                    var billIndex = _.findIndex(result, function (bill) {
                        return bill.billId == billId;
                    });

                    // Check that we actually found the bill we wanted
                    if (billIndex > -1) {
                        vm.billingPeriod = result[billIndex].periodName + " " + result[billIndex].calendarYear;
                        vm.locked = result[billIndex].locked;
                        if (result[billIndex].billMtrNotes !== null) {
                            vm.billMtrNotes = result[billIndex].billMtrNotes.reverse();
                        }

                        // If our bill's index in the array is greater than zero then there is a bill id before it
                        if (billIndex > 0) {
                            vm.previousBillId = result[billIndex - 1].billId;
                        }
   
                        // If our bill's index in the array is not at the end then there is one after it
                        if (billIndex <= result.length - 1) {
                            vm.nextBillId = result[billIndex + 1].billId;
                        }
                    }
                    
                }

            }).$promise;
        }

        function navigationDisplay() {
            return vm.billingPeriod;
        }

        function hasPrevious() {
            return vm.previousBillId > 0;
        }

        function previous() {
            if (vm.previousBillId > 0) {
                glazeService.openGlaze(vm.previousBillId, 'meter-explanation-of-savings');
            }
        }

        function hasNext() {
            return vm.nextBillId > 0;
        }

        function next() {
            if (vm.nextBillId > 0) {
                glazeService.openGlaze(vm.nextBillId, 'meter-explanation-of-savings');
            }
        }

        function detailInit(e) {
            e.detailRow.find("#savingsDetails").kendoGrid({
                dataSource: {
                    transport: {
                        read: function (options) {
                            options.success(e.data.messages);
                        }
                    }
                },
                scrollable: false,
                pageable: false,
                columns: [
                    {
                        field: "messageType", 
                        width: "25%", 
                        headerAttributes: { style: "display: none" },
                        attributes: { style: 'font-weight: bold' }
                    },
                    {
                        field: "message", headerAttributes: { style: "display: none" }
                    }
                ]
            });
        }

        function savingsDailyGrid() {
            var translatedBatccTitle = $translate.instant("Baseline Adjusted to Current Conditions");
            var translatedBatccAcronym = $translate.instant("BATCC");
            var batccHeader = "<abbr tooltip data-toggle='tooltip' title='" + translatedBatccTitle + "'>" + translatedBatccAcronym + "</abbr>";

            return {
                dataSource: {
                    aggregate: [
                        {
                            field: "billingPeriod",
                            aggregate: "min"
                        },
                        {
                            field: "baselineNonWeatherNativeUse",
                            aggregate: "sum"
                        },
                        {
                            field: "baselineWeatherNativeUse",
                            aggregate: "sum"
                        },
                        {
                            field: "batccNonWeatherNativeUse",
                            aggregate: "sum"
                        },
                        {
                            field: "batccWeatherNativeUse",
                            aggregate: "sum"
                        },
                        {
                            field: "batccCost",
                            aggregate: "sum"
                        },
                        {
                            field: "unitInfo",
                            aggregate: "min"
                        },
                        {
                            field: "baselineCoolingDegreeDays",
                            aggregate: "sum"
                        },
                        {
                            field: "currentCoolingDegreeDays",
                            aggregate: "sum"
                        },
                        {
                            field: "baselineHeatingDegreeDays",
                            aggregate: "sum"
                        },
                        {
                            field: "currentHeatingDegreeDays",
                            aggregate: "sum"
                        }
                    ]
                },
                height: '100%',
                pageable: false,
                scrollable: true,
                resizable: false,
                detailTemplate: $templateCache.get('savingsDetailsGrid.html'),
                detailInit: detailInit,
                columns: [
                    {
                        title: "Date",
                        field: "date",
                        template: "#=moment(date).format('MM/DD/YYYY')#",
                        footerTemplate: "#=data.billingPeriod.min#",
                        width: "4.5rem"
                    },
                    {
                        title: "Non-weather use",
                        headerAttributes: {
                            class: 'text-center border-left'
                        },
                        columns: [
                            {
                                title: "Baseline",
                                field: "baselineNonWeatherNativeUse",
                                template: "#=baselineNonWeatherNativeUse != null ? kendo.format('{0:n1}', baselineNonWeatherNativeUse) : 0 # #:unitInfo#",
                                footerTemplate: "#=kendo.format('{0:n0}', sum)# #:data.unitInfo.min#",
                                headerAttributes: {
                                    class: 'text-right border-left'
                                },
                                attributes: {
                                    class: 'text-right text-nowrap text-clip',
                                },
                                footerAttributes: {
                                    class: 'text-nowrap text-clip'
                                }
                            },
                            {
                                title: batccHeader,
                                skipTranslate: true,
                                field: "batccNonWeatherNativeUse",
                                template: "#=batccNonWeatherNativeUse != null ? kendo.format('{0:n1}', batccNonWeatherNativeUse) : 0 # #:unitInfo#",
                                footerTemplate: "#=kendo.format('{0:n0}', sum)# #:data.unitInfo.min#",
                                headerAttributes: {
                                    class: 'text-right'
                                },
                                attributes: {
                                    class: 'text-right text-nowrap text-clip'
                                },
                                footerAttributes: {
                                    class: 'text-nowrap text-clip'
                                }
                            }]
                    },
                    {
                        title: "Weather use",
                        headerAttributes: {
                            class: 'text-center border-left'
                        },
                        columns: [
                            {
                                title: "Baseline",
                                field: "baselineWeatherNativeUse",
                                template: "#=baselineWeatherNativeUse != null ? kendo.format('{0:n1}', baselineWeatherNativeUse) : 0# #:unitInfo#",
                                footerTemplate: "#=kendo.format('{0:n0}', sum)# #:data.unitInfo.min#",
                                headerAttributes: {
                                    class: 'text-right border-left'
                                },
                                attributes: {
                                    class: 'text-right text-nowrap text-clip'
                                },
                                footerAttributes: {
                                    class: 'text-nowrap text-clip'
                                }
                            },
                            {
                                title: batccHeader,
                                skipTranslate: true,
                                field: "batccWeatherNativeUse",
                                template: "#=batccWeatherNativeUse != null ? kendo.format('{0:n1}', batccWeatherNativeUse) : 0# #:unitInfo#",
                                footerTemplate: "#=kendo.format('{0:n0}', sum)# #:data.unitInfo.min#",
                                headerAttributes: {
                                    class: 'text-right'
                                },
                                attributes: {
                                    class: 'text-right text-nowrap text-clip'
                                },
                                footerAttributes: {
                                    class: 'text-nowrap text-clip'
                                }
                            }]
                    },
                    {
                        title: "Cost",
                        headerAttributes: {
                            class: 'text-center border-left'
                        },
                        columns: [
                            {
                                title: batccHeader,
                                skipTranslate: true,
                                field: "batccCost",
                                template: function (item) {
                                    //For now assume all costs are the same unit
                                    vm.currencyUnit = vm.currencyUnit === '' ? item.costUnit.unitInfo : vm.currencyUnit;
                                    return chartHelper.currencyFormat(item.batccCost, kendo.htmlEncode(item.costUnit.unitInfo), 2);
                                },
                                footerTemplate: function (item) { return chartHelper.currencyFormat(item.batccCost.sum, kendo.htmlEncode(vm.currencyUnit), 0); },
                                headerAttributes: {
                                    class: 'text-right border-left'
                                },
                                attributes: {
                                    class: 'text-right text-nowrap'
                                },
                                footerAttributes: {
                                    class: 'text-nowrap'
                                }
                            },
                            {
                                title: "AUC",
                                field: "averageUnitCost",
                                template: function (item) { return chartHelper.currencyFormat(item.averageUnitCost, kendo.htmlEncode(item.costUnit.unitInfo), 3); },
                                headerAttributes: {
                                    class: 'text-right'
                                },
                                attributes: {
                                    class: 'text-right text-nowrap'
                                }
                            }
                        ]
                    },
                    {
                        title: "Adjustments",
                        headerAttributes: {
                            class: 'text-center border-left'
                        },
                        columns: [
                            {
                                title: "Floor area",
                                field: "areaAdjustment",
                                template: "<i class='ec-icon ec-icon-xs #=areaAdjustment == true ? 'icon-check' : ''#'></i>",
                                attributes: {
                                    class: 'text-center'
                                },
                                headerAttributes: {
                                    class: 'border-left text-center text-clip'
                                }
                            },
                            {
                                title: "Special",
                                field: "specialAdjustment",
                                template: "<i class='ec-icon ec-icon-xs #=specialAdjustment == true ? 'icon-check' : ''#'></i>",
                                attributes: {
                                    class: 'text-center'
                                },
                                headerAttributes: {
                                    class: 'text-center'
                                }
                            },
                            {
                                title: "Other",
                                field: "otherAdjustment",
                                attributes: {
                                    class: 'text-center'
                                },
                                template: "<i class='ec-icon ec-icon-xs #=otherAdjustment == true ? 'icon-check' : ''#'></i>",
                                headerAttributes: {
                                    class: 'text-center'
                                }
                            },
                            {
                                title: "Weather",
                                field: "weatherAdjustment",
                                attributes: {
                                    class: 'text-center'
                                },
                                template: "<i class='ec-icon ec-icon-xs #=weatherAdjustment == true ? 'icon-check' : ''#'></i>",
                                headerAttributes: {
                                    class: 'text-center'
                                }
                            }
                        ]
                    },
                    {
                        title: "Cooling degree days",
                        headerAttributes: {
                            class: 'text-center border-left'
                        },
                        columns: [
                            {
                                field: "baselineCoolingDegreeDays",
                                title: "Baseline",
                                template: "#=baselineCoolingDegreeDays != null ? baselineCoolingDegreeDays : 0#",
                                footerTemplate: "#=kendo.format('{0:n0}', sum)#",
                                headerAttributes: {
                                    class: 'text-right border-left'
                                },
                                attributes: {
                                    class: 'text-right'
                                },
                                width: "4rem"
                            },
                            {
                                field: "currentCoolingDegreeDays",
                                title: "Current",
                                template: "#=currentCoolingDegreeDays != null ? currentCoolingDegreeDays : 0#",
                                footerTemplate: "#=kendo.format('{0:n0}', sum)#",
                                headerAttributes: {
                                    class: 'text-right'
                                },
                                attributes: {
                                    class: 'text-right'
                                },
                                width: "4rem"
                            }
                        ]
                    },
                    {
                        title: "Heating degree days",
                        headerAttributes: {
                            class: 'text-center border-left'
                        },
                        columns: [
                            {
                                field: "baselineHeatingDegreeDays",
                                title: "Baseline",
                                template: "#=baselineHeatingDegreeDays != null ? baselineHeatingDegreeDays : 0#",
                                footerTemplate: "#=kendo.format('{0:n0}', sum)#",
                                headerAttributes: {
                                    class: 'text-right border-left'
                                },
                                attributes: {
                                    class: 'text-right'
                                },
                                width: "4rem"
                            },
                            {
                                field: "currentHeatingDegreeDays",
                                title: "Current",
                                template: "#=currentHeatingDegreeDays != null ? currentHeatingDegreeDays : 0#",
                                footerTemplate: "#=kendo.format('{0:n0}', sum)#",
                                headerAttributes: {
                                    class: 'text-right'
                                },
                                attributes: {
                                    class: 'text-right'
                                },
                                width: "4rem"
                            }
                        ]
                    }
                ]
            };
        }
    }


})();
﻿(function () {
    'use strict';

    angular
        .module('buildingsModule')
        .controller('meterIntervalDataController', MeterIntervalDataController);

    MeterIntervalDataController.$inject = ['$state', 'apiResource', '$translate', '$timeout', 'colorHelper', 'userService', 'confirmationService', '$dialog', 'setupSheetService', 'amChartsService', 'telemetryService', 'channelWrapperService', 'errorService', '$scope'];

    /**
    * Controller for the Meter Actual Channels Powerview
    */
    function MeterIntervalDataController($state, apiResource, $translate, $timeout, colorHelper, userService, confirmationService, $dialog, setupSheetService, amChartsService, telemetryService, channelWrapperService, errorService, $scope) {
        var vm = this;
        vm.meter = {};
        vm.model = {};
        vm.chart = {};
        vm.channelData1 = [];
        vm.channelDataForTable = [];
        vm.channelData2 = [];
        vm.cardTitleBase = $translate.instant("IntervalDataChart_TC");

        vm.editTitle = $translate.instant("EditReadingTitle_SC");
        vm.deleteTitle = $translate.instant("DeleteReadingTitle_SC");

        vm.cardTitle = vm.cardTitleBase;
        vm.status = { status: 'hasData', message: '', displayAsMask: true };
        vm.pageStatus = { status: 'hasData', message: '', displayAsMask: true };
        vm.canManageReadings = userService.userHasPermission("IntervalDataManage");
        vm.canAddChannels = userService.userHasPermission("MetersEdit");
        /**
         * Properties related to the channel's interval; Used to make decisions about whether to show/hide certain settings that don't make sense
         */
        vm.comparePeriodType = "week";
        vm.enableDayBtn = false;
        vm.enableWeekBtn = false;
        vm.enableMonthBtn = false;

        vm.raw = false;

        vm.changeChannel = changeChannel;
        vm.getChannelData = getChannelData;
        vm.addChannelOrReading = addChannelOrReading;

        vm.shadeWeekends = false;
        vm.shadeNights = false;

        vm.title = "Channel Readings";

        /**
         * When true, show controls, chart, and table.  When false, show overlay.
         */
        vm.showChart = true;

        /**
         * Does the current meter have channels?
         */
        vm.hasChannels = true;

        /**
         * Does the current channel have readings (regardless if they are currently shown)?
         * This is different than "are there readings to show for the selected timeframe".
         */
        vm.hasReadings = true;

        /**
         * Text to show in the overlay when meter has no channels or channel has no readings
         */
        vm.noChannelsOrReadingsText = '';

        /**
         * Image to show in the empty state when meter has no channels or channel has no readings
         */
        vm.noChannelsOrReadingsImgSrc = '';

        /**
         * Text to show on the button in the overlay when meter has no channels or channel has no readings
         */
        vm.addButtonText = '';

        /**
         * Does the user have permission to do the action currently associated with the 'Add" button?
         * AddChannel requires MetersCreate, AddReading requires IntervalDataManage
         */
        vm.addButtonVisible = true;

        vm.unit = "";

        vm.zoomChart = zoomChart;

        /**
         * needed to show/hide weekend/night shading
         */
        vm.readingDays = [];
        vm.weekendGuides = [];
        vm.nightGuides = [];
        vm.maxMeasuredValue = 0;

        vm.dateFormats = [
            { period: 'fff', format: 'LL:NN:SS A' },
            { period: 'ss', format: 'LL:NN:SS A' },
            { period: 'mm', format: 'LL:NN A' },
            { period: 'hh', format: 'LL:NN A' },
            { period: 'DD', format: 'EEE MMM DD' },
            { period: 'WW', format: 'EEE MMM DD' },
            { period: 'MM', format: 'EEE MMM DD, YYYY' },
            { period: 'YYYY', format: 'EEE MMM DD' }];

            // Definition to pass to ec-grid, which wraps a kendo grid
            vm.grid = {
                scrollable: true,
                resizable: false,
                pageable: {
                    pageSize: 50
                },
                dataSource: {
                },
                page: function (e) {
                    // Scroll the grid back to the top on page change
                    var container = e.sender.wrapper.children(".k-grid-content");
                    container.scrollTop(0);

                    telemetryService.trackEvent("interval-data-reading-table-page-changed", {
                        "pageNumber": e.page
                    });
                },
                columns: [
                    {
                        width: "9.5rem",
                        title: "ChannelReading_TC",
                        attributes: { "class": "text-nowrap" },
                        template: "#=dateLabel# #=timeLabel#"
                    },
                    {
                        width: "8rem",
                        title: "ReadingValue_SC",
                        headerAttributes: { "class": "text-right" },
                        attributes: { "id": "readingValue_#=rowIndex#", "class": "text-right" },
                        template: "#=rawValue#"
                    },
                    {
                        width: "12rem",
                        title: "CalculatedValue_SC",
                        headerAttributes: { "class": "text-right" },
                        attributes: { "id": "calculatedValue_#=rowIndex#",  "class": "text-right" },
                        template: "#=gridDisplayValue# #:unitLabel#"
                    },
                    {
                        width: "7rem",
                        attributes: { "class": "text-center" },
                        template: "<ec-tags ng-if='#=estimated#' [tags]='[{ label: \"Estimated\" }]' class='mb-n2 mt-n2'></ec-tags>"
                    },
                    {
                        title: "Note",
                        field: "note",
                        attributes: { "title": "# if (note !== null) { # #:note# # } #"},
                        template: "# if (note !== null) { # <div class='text-truncate'>#:note#</div> # } #"
                    },
                    {
                        width: "4.0625rem",
                        headerAttributes: {
                            "class": "ec-grid-actions d-flex flex-row-reverse"
                        },
                        attributes: {
                            "class": "ec-grid-actions d-flex flex-row-reverse"
                        },
                        headerTemplate: "<ec-button id='addReadingButton'" +
                            "    type='icon'" +
                            "    icon='icon-add'" +
                            "    (clicked)='grid.controller.addReading()'" +
                            "    title='{{ \"AddReadingTitle_SC\" | translate}}'" +
                            "    ng-if='grid.controller.canManageReadings'" +
                            "    [disabled]='!grid.controller.selectedChannel'>" +
                            "</ec-button>" +
                            "<ec-dropdown id='setupSheet_menu'" +
                            "             icon='icon-file-excel'" +
                            "             menu-template-type='label'" +
                            "             [menu-min-width]='240'" +
                            "             [popup-fixed]='true'" +
                            "             menuTitle='{{ \"Setup Spreadsheets\" | translate }}'" +
                            "             title='{{ \"Setup Spreadsheets\" | translate }}'" +
                            "             [items]='grid.controller.setupSheetMenuItems'" +
                            "             [show-arrow]='false'" +
                            "             ng-if='grid.controller.setupSheetMenuItems.length > 0'>" +
                            "</ec-dropdown>",
                            template: "<div class='ec-icon-button'" +
                            "   id='editReadingButton_{{#=rowIndex#}}_button'" +
                            "   title='{{grid.controller.editTitle}}'" +
                            "   tabindex='0'" +
                            "   ng-if='grid.controller.canManageReadings'" +
                            "   ng-click='grid.controller.editReading(dataItem)'>" +
                            "       <i class='ec-icon icon-edit'></i>" +
                            "</div>" +
                            "<div class='ec-icon-button'" +
                            "   id='deleteReadingButton_{{#=rowIndex#}}_button'" +
                            "   title='{{grid.controller.deleteTitle}}'" +
                            "   tabindex='0'" +
                            "   ng-if='grid.controller.canManageReadings'" +
                            "   ng-click='grid.controller.deleteReading(dataItem)'>" +
                            "       <i class='ec-icon icon-delete'></i>" +
                            "</div>"
                    }
                ]
            };

        /**
         * @constructor
         * Get channel list and populate/show initial chart view
         */
        (function constructor() {
            setStatusPending();

            //need to bind and unbind these events evenly to avoid leaking them when switching dashboards
            $state.subscribeToEvent('channelAdded', onChannelAddedExternally);
            $scope.$on('$destroy', function(){
                $state.unsubscribeFromEvent('channelAdded', onChannelAddedExternally);
            });

            vm.meter.meterId = $state.params.meterId;

            vm.datePickerOptions = {
                parseFormats: ["yyyy-MM-ddTHH:mm:ss"],
                minDate: moment("12/30/1899", "MM/DD/YYYY").format('MM/DD/YYYY'), // minimum date possible
                maxDate: moment("01/01/3000", "MM/DD/YYYY").format('MM/DD/YYYY') // maximum date possible
            };

            vm.addReading = addReading;
            vm.editReading = editReading;
            vm.deleteReading = deleteReading;

            //because the channel data might or might not be on the meter object at this point we need to assign the values instead of
            //overwriting the meter object itself
            //we won't try to trap errors here and overlay the page because this is only used as readonly info (meter name and timezone)
            //when they add a reading, which most users won't do. We don't want an error here to prevent them from seeing the table/chart/channels
            //and if that call fails too then it has its own error handler.
            apiResource.meter().meter().get({ meterId: vm.meter.meterId }, function(meter) {
                vm.meter = Object.assign(meter, vm.meter);
            });

            var channelsPromise = channelWrapperService.getMeterChannels(vm.meter.meterId, null);
            channelsPromise.then(function(channels){
                vm.meter.channels = channels;

                if (!vm.meter.channels || vm.meter.channels.length == 0) {
                    // no channels, show the Add Channel overlay and exit the callback function
                    setStatusNoChannels();
                    return;
                }

                if (vm.meter.channels && vm.meter.channels.length > 0) {

                    // Select the first channel by default
                    vm.selectedChannel = vm.meter.channels[0];

                    changeChannel();
                }
            }).catch(function (response) {
                vm.meter.channels = [];
                vm.channelDataForTable = [];
                setStatusError(response);
            });

        })();


        /**
         * Get channel data for new user-selected channel
         */
        function changeChannel() {
            // Need to repopulate the menu to make sure the filter is set correctly
            loadSetupSheetMenu();

            if (!vm.selectedChannel) {
                setStatusNoData();
                vm.channelDataForTable = [];
                return;
            }

            setStatusPending();

            vm.enableDayBtn = (vm.selectedChannel.intervalMinutes < 1440); // only show "day" button if channel interval less than 1 day
            vm.enableWeekBtn = (vm.selectedChannel.intervalMinutes < 10080);  // only show "week" button if channel interval less than 1 week
            vm.enableMonthBtn = (vm.selectedChannel.intervalMinutes < 43200);  // only show "month" button if channel interval less than 1 month

            // TODO: look at comments on lines below - may need to adjust shading accordingly now that it's no longer an input
            //vm.enableShadeNightsBtn = vm.enableDayBtn; // only show "shade nights" checkbox if channel interval less than 1 day
            //vm.enableShadeWeekendsBtn = vm.enableWeekBtn; // only show "shade weekends" checkbox if channel interval less than 1 week

            if(vm.selectedChannel.intervalMinutes >= 43200){
                vm.comparePeriodType = 'year';
                // turn off the shading options if looking at a year of data
                vm.shadeWeekends = false;
                vm.shadeNights = false;
            }
            else {
                vm.comparePeriodType = 'week';
                // turn on the shading options by default
                vm.shadeWeekends = true;
                vm.shadeNights = true;
            }

            setEndDate( vm.selectedChannel.lastReadingDate ? moment(vm.selectedChannel.lastReadingDate) : moment());

            // Load the chart
            vm.model = getModel();

            if (!vm.selectedChannel.hasReadings) {
                setStatusNoReadings(false);
                vm.channelDataForTable = [];
                return;
            } else {
                getChannelData();
            }
        }

        /** Set the end date textbox on the screen to the provided value and shift the datepicker max date to match. The date can be Date(), moment(), or ISO string format */
        function setEndDate(endDate){
            // Set the readings end date to last reading date
            vm.endDate = moment(endDate).format('YYYY-MM-DD');

            // set max date for date picker
            vm.datePickerOptions.maxDate = moment(vm.endDate).format('MM/DD/YYYY');
        }

        /**
         * Get amStockChart base model for this chart
         * @returns {Object}
         */
        function getModel() {

            return {
                "type": "stock",
                "theme": "light",
                "dataDateFormat": "YYYY-MM-DDTJJ:NN:SS",
                "pathToImages": "/assets/images/amcharts/images/",
                "legend": null,
                "dataSets": [{
                    "title": "Channel Data",
                    "fieldMappings": [{
                        "fromField": "value",
                        "toField": "value"
                    }],
                    "color": colorHelper.getCurrentVsPriorYearColor("current"),
                    "dataProvider": vm.channelData1,
                    "categoryField": "time",
                    "stockEvents": []
                },{
                    "title": "Previous Period",
                    "compared": true,
                    "fieldMappings": [{
                        "fromField": "value",
                        "toField": "value"
                    }],
                    "color": colorHelper.getCurrentVsPriorYearColor("prior"),
                    "dataProvider": vm.channelData2,
                    "categoryField": "categoryTime"
                }],
                "categoryAxesSettings": {
                    "parseDates": true,
                    "minPeriod": (vm.comparePeriodType == 'week') ? "mm" : "MM",
                    "gridThickness": 1,
                    "gridAlpha": 1,
                    "gridColor": "#CCCCCC",
                    "fillAlpha": .1,
                    "boldPeriodBeginning": false,
                    "equalSpacing": false,
                    "autoGridCount": false,
                    "groupToPeriods": ['mm'],
                    "dateFormats": vm.dateFormats
                },
                "panelsSettings": {
                    marginLeft: 72
                },
                "panels": [{
                    "title": "Value",
                    "percentHeight": 70,
                    "recalculateToPercents": "never", // important to not show values as percentages
                    "stockGraphs": [{
                        "id": "g1",
                        "valueField": "value",
                        "lineColor": colorHelper.getCurrentVsPriorYearColor("current"),
                        "lineThickness": 2,
                        "fillAlphas": 0,
                        "comparable": true,
                        "compareField": "value",
                        "compareGraphLineColor": colorHelper.getCurrentVsPriorYearColor("prior"),
                        "compareGraphLineThickness": 2,
                        "balloonText": "[[dateLabel]] \n [[timeLabel]] \n [[value]] [[unitLabel]] \n [[readingType]]",
                        "compareGraphBalloonText": "[[dateLabel]] \n [[timeLabel]] \n [[value]] [[unitLabel]] \n [[readingType]]",
                        "compareGraph": {
                            "fillAlphas": 0,
                        }
                    }],
                    "stockLegend": null,
                    "valueAxes": [{
                        "title": "",
                        "gridThickness": 0,
                        "guides": [{
                            'lineAlpha': 1,
                            'lineThickness': 2,
                            'lineColor':  colorHelper.getGuideLineColor("target")
                        }]
                    }],
                }],
                "stockEventsSettings": {
                    "rollOverColor": "#f5d400",
                    "balloonColor": "#f5d400",
                    "borderAlpha": 0
                },
                "valueAxesSettings": {
                    "inside": false
                },
                "chartScrollbarSettings": {
                    "dragIcon": "dragIconRoundSmall",
                    "dragIconWidth": 24,
                    "autoGridCount": false,
                    "ignoreCustomColors": true,
                    "graph": "g1",
                    "graphType": "line",
                    "backgroundAlpha": 0,
                    "selectedBackgroundAlpha": 0.3,
                    "selectedBackgroundColor": "#e1e9f9",
                    "selectedGraphFillAlpha": 1,
                    "selectedGraphLineAlpha": 0,
                    "selectedGraphFillColor": "rgb(45, 92, 184)",
                    "color": "#1a1a23",
                    "height": 24,
                    "fillAlphas": 0,
                    "hideResizeGrips": true
                },
                "periodSelector": {
                    "position": "top",
                    "inputFieldsEnabled": false,
                    "hideOutOfScopePeriods": false,
                    "periodsText": "",
                    "periods": [{
                        "period": "DD",
                        "count": 1,
                        "label": "1 " + $translate.instant('day'),
                        "selected": false
                    }, {
                        "period": "DD",
                        "count": 7,
                        "label": "1 " + $translate.instant('week'),
                        "selected": vm.comparePeriodType != 'year'
                    }, {
                        "period": "MM",
                        "count": 1,
                        "label": "1 " + $translate.instant('month'),
                        "selected": false
                    }, {
                        "period": "YYYY",
                        "count": 1,
                        "label": "1 " + $translate.instant('year'),
                        "selected": vm.comparePeriodType == 'year'
                    }]
                },
                "chartCursorSettings": {
                    "valueBalloonsEnabled": true,
                    "graphBulletSize": 1,
                    "cursorAlpha": 0.1,
                    "categoryBalloonDateFormats": vm.dateFormats
                }
            };
        }

        /**
         * Get channel data from API (and comparison data if requested).
         * Create night/weekend shading guides and determine max reading value.
         * Replaces old data.
         */
        function getChannelData() {
            // if end date is empty, or for some reason user cleared out the current channel control value, don't attempt to get data
            if(vm.endDate == "" || vm.endDate == null || !vm.selectedChannel || !moment(vm.endDate).isValid()){
                setStatusNoData();
                return;
            }

            setStatusPending();

            // if we are getting new "base" data, we want to clear out any "comparison" data
            // we might have
            vm.channelData2 = [];
            vm.model.dataSets[1].dataProvider = vm.channelData2;

            // Need to ask for 20 years of data back if we're plotting monthly channels; otherwise get 1 month
            if(vm.comparePeriodType == 'week') {
                vm.startDate = moment(vm.endDate).subtract(1, 'months').format('YYYY-MM-DD');
            }
            else {
                vm.startDate = moment(vm.endDate).subtract(20, 'years').format('YYYY-MM-DD');
            }

            // Set card title with date range of "base" data
            vm.cardTitle = vm.cardTitleBase + ' ' + moment(vm.startDate).format('MM/DD/YYYY') + '–' +  moment(vm.endDate).format('MM/DD/YYYY');

            apiResource.reading().reading().get({
                channelId: vm.selectedChannel.channelId,
                beginDate: moment(vm.startDate).format('YYYY-MM-DD'),
                endDate: moment(vm.endDate).format('YYYY-MM-DD') + 'T23:59:59',
                originalValue: false
            }, function (data) {

                vm.unit = data.unit.unitInfo;
                vm.model.panels[0].title = data.unit.unitInfo;
                // Set our value axis title to be the first items unit code, they'll all be the same
                if (vm.model.panels[0].valueAxes[0].title === "") {
                    vm.model.panels[0].valueAxes[0].title = data.unit.unitInfo;
                }

                vm.model.dataSets[0].stockEvents = [];
                vm.channelData1 = processBaseReadingData(data.readings);
                if (vm.channelData1.length === 0) {
                    vm.channelDataForTable = [];
                    setStatusNoReadings(true);
                    return;
                }
                // need to do this assignment again so chart will update properly
                vm.model.dataSets[0].dataProvider = vm.channelData1;

                getComparisonChannelData();
            });
        }

        /**
         * For each reading, set labels for balloon and create guides
         * for night/weekend shading.  Also track max measured value
         */
        function processBaseReadingData(readingData) {
            // reset
            vm.readingDays = [];
            vm.weekendGuides = [];
            vm.nightGuides = [];
            vm.maxMeasuredValue = 0;
            var baseData = [];

            angular.forEach(readingData, function(reading) {
                if (reading.value > vm.maxMeasuredValue) {
                    vm.maxMeasuredValue = reading.value;
                }
                if (reading.value === null) {
                    reading.gridDisplayValue = '';
                } else {
                    reading.gridDisplayValue = reading.value;
                }

                setLabelsForBalloon(reading);

                createNightAndWeekendGuides(reading);

                if (reading.note !== null && reading.note !== "") {
                    vm.model.dataSets[0].stockEvents.push({
                        "date": reading.time,
                        "type": "sign",
                        "backgroundColor": colorHelper.getPrimaryChartColors(0),
                        "graph": "g1",
                        "description": reading.note
                    });
                }

                baseData.push(reading);
            });

            return baseData;
        }

        /**
         * For each reading, set labels for balloon and update max measured value
         * Also, update reading's "categoryTime" so the readings will overlay properly
         */
        function processComparisonReadingData(readingData) {
            var comparisonData = [];

            angular.forEach(readingData, function(reading) {
                if (reading.value > vm.maxMeasuredValue) {
                    vm.maxMeasuredValue = reading.value;
                }
                if (reading.value === null) {
                    reading.gridDisplayValue = '';
                } else {
                    reading.gridDisplayValue = reading.value;
                }

                // To make the overlay work properly, need to normalize the dates of last period's reading to make it SEEM like they're for the same time period
                if (vm.comparePeriodType == 'week') {
                    reading.categoryTime = moment(reading.time).add(7, 'days').format('YYYY-MM-DD[T]HH:mm:ss');
                }
                else {
                    reading.categoryTime = moment(reading.time).add(1, 'years').format('YYYY-MM-DD[T]HH:mm:ss');
                }

                setLabelsForBalloon(reading);
                comparisonData.push(reading);
            });

            return comparisonData;
        }


        /**
         * Get comparison channel data from API.
         * Replaces old comparison data.
         */
        function getComparisonChannelData() {

            var comparisonStartDate;
            var comparisonEndDate;

            if(vm.comparePeriodType == 'week') {
                // If we're dealing with an interval less than 1 month, get 7 days back before the first series' start date
                comparisonStartDate = moment(vm.startDate).subtract(7, 'days').format('YYYY-MM-DD');
                comparisonEndDate = moment(vm.endDate).subtract(7, 'days').format('YYYY-MM-DD');
            }
            else {
                // If we're dealing with an interval of 1 month or more, get 1 year back before the first series' start date (shifts 3-year window back by 1 year)
                comparisonStartDate = moment(vm.startDate).subtract(1, 'years').format('YYYY-MM-DD');
                comparisonEndDate = moment(vm.endDate).subtract(1, 'years').format('YYYY-MM-DD');
            }

            apiResource.reading().reading().get({
                channelId: vm.selectedChannel.channelId,
                beginDate: comparisonStartDate,
                endDate: comparisonEndDate + 'T23:59:59',
                originalValue: false
            }, function (data2) {
                vm.channelData2 = processComparisonReadingData(data2.readings);

                if (vm.channelData1.length === 0 && vm.channelData2.length === 0) {
                    setStatusNoData();
                    return;
                }

                // update dataProvider reference so chart will draw properly
                vm.model.dataSets[1].dataProvider = vm.channelData2;

                populateTable();

                vm.model.panels[0].valueAxes[0].guides[0].value = vm.maxMeasuredValue;
                vm.model.panels[0].valueAxes[0].guides[0].balloonText = vm.maxMeasuredValue + ' ' + vm.unit;

                //switch to hasData so the chart div is there before we populate it
                setStatusHasData();

                vm.chart = amChartsService.makeChart("chartdiv", vm.model);

                toggleShading();

                vm.chart.validateNow(true);
                vm.chart.setDefaultPeriod();
            });
        }


        /**
         * Populate table with data from the chart.  Remove duplicate readings
         */
        function populateTable() {
            // copy and reverse data so most recent reading is on top of table
            var reversedBase = vm.channelData1.slice().reverse();
            var reversedCompare = vm.channelData2.slice().reverse();

            // combine the two arrays, returning unique readings (based on date/time)
            var uniqueReadings = _.unionBy(reversedBase, reversedCompare, function(x) {
                return x.dateLabel + x.timeLabel;
            });

            // Append the row index for our ids to be consistent with how we
            // had it implemented before. Kendo does not give us this in the js version
            angular.forEach(uniqueReadings, function (reading, index) {
                reading.rowIndex = index;
            });

            vm.grid.dataSource = uniqueReadings;
        }

        /**
         * Assign values to reading's time, date, unit and type labels
         */
        function setLabelsForBalloon(reading) {
            // Formatted items for our bubble display
            reading.timeLabel = moment(reading.time).format("h:mm:ss A");
            reading.dateLabel = moment(reading.time).format("MM/DD/YYYY");
            reading.unitLabel = vm.unit;

            if (reading.estimated) {
                reading.readingType = $translate.instant('Estimated');
            }
            else {
                reading.readingType = $translate.instant('Actual Data');
            }
        }

        /**
         * Given a reading, create shade guides for nights and weekends
         * if we have not already done so for the day of the reading.
         * We only want to do this for the "base" readings, not comparison readings.
         * @param {Object} reading The reading from the API.
         */
        function createNightAndWeekendGuides(reading) {
            var dayFormat = "MM/DD/YYYY";

            // if we haven't already processed the current reading's day
            var day = moment(reading.time).format(dayFormat);
            if (vm.readingDays.indexOf(day) === -1) {

                // Check to see if the time fell on a weekend and we haven't already found that date.
                if ((moment(reading.time).day() === 0 || moment(reading.time).day() === 6)) {

                    // Push the guide for each of our weekend days found
                    vm.weekendGuides.push({
                        "date": moment(day, dayFormat).format('YYYY-MM-DDTHH:mm:ss'),
                        "toDate": moment(day, dayFormat).add(1, 'days').format('YYYY-MM-DDTHH:mm:ss'),
                        "fillAlpha": .7,
                        "fillColor": "#E4E4E4",
                        "tickLength": 0,
                        "lineThickness": 0
                    });
                }

                // Guides from midnight to 6AM
                vm.nightGuides.push({
                    "date": moment(day, dayFormat).format('YYYY-MM-DDTHH:mm:ss'),
                    "toDate": moment(day, dayFormat).add(6, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
                    "fillAlpha": .7,
                    "fillColor": "#E0E0F3",
                    "tickLength": 0,
                    "lineThickness": 0
                });
                // Guides for 6PM to midnight
                vm.nightGuides.push({
                    "date": moment(day, dayFormat).add(18, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
                    "toDate": moment(day, dayFormat).add(1, 'days').format('YYYY-MM-DDTHH:mm:ss'),
                    "fillAlpha": .7,
                    "fillColor": "#E0E0F3",
                    "tickLength": 0,
                    "lineThickness": 0
                });

                // add day to array so we don't add guides again
                vm.readingDays.push(moment(reading.time).format("MM/DD/YYYY"));
            }
        }


        /**
         * Add or remove nights and weekends shading from chart
         */
        function toggleShading() {
            var activeGuides = [];

            if (vm.shadeWeekends == true) {
                activeGuides = vm.weekendGuides;
            }

            if (vm.shadeNights == true) {
                activeGuides = _.concat(activeGuides, vm.nightGuides);
            }

            vm.model.panels[0].categoryAxis.guides = activeGuides;
        }


        function zoomChart(input) {
            //Need $timeout or else you get $rootScope:inprog jquery click error
            $timeout(function () {
                angular.element(".amcharts-period-selector-div input")[input].click();
            });
        }

        /** Set display status when data is loading */
        function setStatusPending() {
            vm.showChart = true;
            vm.hasChannels = true;
            vm.hasReadings = true;
            vm.pageStatus.status = 'pending';
            vm.pageStatus.message = 'Loading';
        }

        /** Set display status to show chart and table */
        function setStatusHasData() {
            vm.showChart = true;
            vm.hasChannels = true;
            vm.hasReadings = true;
            vm.noChannelsOrReadingsText = '';
            vm.noChannelsOrReadingsImgSrc = '';
            vm.addButtonText = '';
            vm.pageStatus.status = 'hasData';
            vm.pageStatus.message = '';
            vm.status.status = 'hasData';
            vm.status.message = '';
        }

        /** Set display status when there is no data for the given Channel/date */
        function setStatusNoData() {
            vm.showChart = true;
            vm.pageStatus.status = 'hasData';
            vm.pageStatus.message = '';
            vm.status.status = 'noData';
            vm.status.message = 'No data is available';
        }

        /** Set display status when something goes wrong loading the channel list or meter */
        function setStatusError(response) {
            vm.showChart = false;
            vm.pageStatus.status = 'error';
            vm.pageStatus.message = $translate.instant(errorService.parseApiError(response));
            vm.status.status = 'hasData';
            vm.status.message = '';
        }

        /** Hide chart and table, and display overlay with appropriate messaging */
        function setStatusNoChannels() {
            vm.showChart = false;
            vm.hasChannels = false;

            if(vm.canAddChannels) {
                vm.noChannelsOrReadingsText = 'MeterIntervalData_NoChannelsMessageWithPermission_SC';
            } else {
                vm.noChannelsOrReadingsText = 'MeterIntervalData_NoChannelsMessageWithoutPermission_SC';
            }

            vm.noChannelsOrReadingsImgSrc = '/assets/images/no-channels.svg';
            vm.addButtonText = 'AddNewChannel_TC';
            vm.addButtonVisible = vm.canAddChannels;

            vm.pageStatus.status = 'hasData';
            vm.pageStatus.message = '';
            vm.status.status = 'hasData';
            vm.status.message = '';
        }

        /** Hide chart and table, and display overlay with appropriate messaging
         * @param currentPeriodOnly - set to true if there are no readings for the current period but there may be some of other time periods
         *                            defaults to false, meaning the channel has no readings at all
         *
         * If we're only identifying "no readings" for the current period we leave the date box enabled and give them a different message
        */
        function setStatusNoReadings(currentPeriodOnly) {
            vm.showChart = false;
            vm.hasReadings = currentPeriodOnly;
            vm.noChannelsOrReadingsText = 'MeterIntervalData_NoReadingsMessage_SC';
            vm.noChannelsOrReadingsImgSrc = '';
            vm.addButtonText = 'AddReadingTitle_TC';
            vm.addButtonVisible = vm.canManageReadings;

            vm.pageStatus.status = 'hasData';
            vm.pageStatus.message = '';
            vm.status.status = 'hasData';
            vm.status.message = '';
        }

        /** If meter has no channels, open the manage channel dialog.  Otherwise open 'add reading' dialog */
        function addChannelOrReading() {
            if (!vm.hasChannels) {
                $dialog.openDialog('manage-channel', 'medium', { isCreate: true, meter: vm.meter }).then(onManageChannelDialogClose);
            } else {
                addReading();
            }
        }


        /**Add a new reading for the selected channel */
        function addReading(){
            $dialog.openDialog('manage-reading', 'small', getReadingDialogContext()).then(onManageReadingDialogClose);
        }

        /**Edit a specific reading from the table */
        function editReading(reading){
            $dialog.openDialog('manage-reading', 'small', getReadingDialogContext(reading)).then(onManageReadingDialogClose);
        }

        /**Delete a reading after confirming that the user wants to continue */
        function deleteReading(reading){
            confirmationService.confirmation($translate.instant('DeleteReadingTitle_SC'), $translate.instant('DeleteReadingConfirmation_SC')).then(function(result){
                if(!result) {
                    return;
                }
                apiResource.reading().readingDelete().remove({
                    observationId: reading.observationId
                }, function() {
                    //refresh the readings we're showing now that we deleted that one
                    getChannelData();
                });
            });
        }

        /** Return the context the dialog uses with an optional reading.
         * @param reading Optional reading to edit, if null or undefined the dialog will add a new reading
         */
        function getReadingDialogContext(reading) {
            return {
                channelId: vm.selectedChannel.channelId,
                reading: reading,
                meter: vm.meter,
                channelDisplay: vm.selectedChannel.label
            }
        }

        //when they save their changes in the dialog, we want to update the screen
        //If it is the first reading we always want to show it. Otherwise we only change the selected date if the new reading is
        //after the most recent reading for the channel. This way if they moved the date we don't switch it on them
        function onManageReadingDialogClose(result){
            if(result.save && result.context){
                var readingDate = moment(result.context.reading.time);
                var graphEndDate = moment(vm.endDate);

                if(!vm.hasReadings || !vm.endDate || readingDate > graphEndDate) {
                    setEndDate(readingDate);
                    updateSelectedChannelForNewReading(readingDate);
                }

                getChannelData();
            }
        }

        //update the channel we pulled down to know about the reading so that if they switch channels and
        //switch back it will still have the "hasReadings" state even if we never re-make the API call
        //we also have to update the meter channels array reference so the combobox actually picks the change up
        function updateSelectedChannelForNewReading(readingDate){
            if(vm.selectedChannel){
                var meterChannel = vm.meter.channels.find(function(channel){
                    return channel.channelId == vm.selectedChannel.channelId;
                });

                if(meterChannel){
                    meterChannel.lastReadingDate = readingDate;
                    meterChannel.hasReadings = readingDate != null;
                    vm.meter.channels = vm.meter.channels.slice();
                }
            }
        }

        /**Load the items that should appear on the setup sheet menu */
        function loadSetupSheetMenu(){
          setupSheetService.dialog = $dialog.rootDialog;

          return setupSheetService.getIntervalDataMenuItems(vm.selectedChannel.channelId).then(function(items){
              vm.setupSheetMenuItems = items;
          });
        }

        function onManageChannelDialogClose(result) {
            if(result.save){
                $state.reload();
            }
        }

        /*Fires as a callback from ng1StateService when somebody uses the Add Channel menu item in the meter breadcrumb bar*/
        function onChannelAddedExternally(){
            $state.reload();
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('buildingsModule')
        .controller('meterSavingsOtherSavingsController', MeterSavingsOtherSavingsController);

    MeterSavingsOtherSavingsController.$inject = ['apiResource', '$state', 'glazeService', '$translate',
        'confirmationService', 'chartHelper', 'powerviewHelper', 'gridHelper', 'runtimeService', 'userService'];

    /**
    * Controller for the Meter Savings Other Savings Powerview
    */
    function MeterSavingsOtherSavingsController(apiResource, $state, glazeService, $translate,
        confirmationService, chartHelper, powerviewHelper, gridHelper, runtimeService, userService) {
        var vm = this;

        ////////////////////////////////////////////////////////////////////////
        // TODO: remove after ECAP-3957 is done
        vm.converted = true;
        ////////////////////////////////////////////////////////////////////////

        vm.id = $state.params.meterId;
        vm.fullScreen = true;

        vm.addOtherAdjustment = addOtherAdjustment;
        vm.editOtherAdjustment = editOtherAdjustment;
        vm.deleteOtherSavings = deleteOtherSavings;

        vm.savingsAdjustmentsManage = false;

        init();

        /**
        * Constructor function to be called when the controller is ready to load
        */
        function init() {
            vm.status = 'pending';
            vm.message = 'Loading';

            // Set Permissions to hide/show buttons
            // Everything on this screen as some dependency on permissions so calling once
            // and not doing anything until these values are set
            runtimeService.getConfigData().then(function () {

                vm.savingsAdjustmentsManage = userService.userHasPermission("SavingsAdjustmentsManage");

                if (vm.savingsAdjustmentsManage) {
                    vm.addNew = {
                        label: $translate.instant('Add Other Savings'),
                        callback: vm.addOtherAdjustment
                    }
                }

                apiResource.savings().otherSavings().query({ meterId: vm.id }, function (result) {
                    var otherSavings = [];

                    angular.forEach(result, function (otherSaving) {

                        var saving = {
                            otherSavingsId: otherSaving.otherSavingsId,
                            startDate: otherSaving.startPeriod,
                            endDate: otherSaving.endPeriod,
                            frequency: $translate.instant(otherSaving.frequency),
                            value: otherSaving.value,
                            category: otherSaving.otherSavingsCategory.otherSavingsCategoryInfo,
                            description: otherSaving.description,
                            costUnit: otherSaving.costUnit,
                            frequencyStartEnd: ''
                        };

                        if (otherSaving.frequency === "Recurring") {
                            var startMonth = moment(otherSaving.annnualCycleStartMonth, "MM").format('MMMM');
                            var endMonth = moment(otherSaving.annualCycleEndMonth, "MM").format('MMMM');
                            saving.frequencyStartEnd = "(" + startMonth + " &#8211; " + endMonth + ")";
                        }

                        otherSavings.push(saving);
                    });

                    setPowerviewProperties(powerviewHelper.getPowerviewProperties({ results: otherSavings }));
                    createWidgets();
                }, function (error) {
                    setPowerviewProperties(powerviewHelper.getPowerviewProperties());
                });
            });
        }

        /**
         * Sets view properties for the powerview
         * @param {Object} properties - The powerview properties
         */
        function setPowerviewProperties(properties) {
            vm.data = properties.data;
            vm.message = properties.message;

            // Show the widget even if there is no data
            if (properties.status === 'noData') {
                vm.status = 'hasData';
            } else {
                vm.status = properties.status;
            }
        }

        function createWidgets() {
            vm.widgets = [];

            vm.widgets.push(powerviewHelper.getWidgetDefinition({
                id: "otherSavings",
                type: 'dataGrid',
                class: 'col-12',
                autoHeight: true,
                content: getOtherSavingsGrid()
            }));
        }

        /**
        * Generates the defintion for the other savings grid
        * @returns {object} - Object that will define the other savings grid
        */
        function getOtherSavingsGrid() {
            var content = {
                dataGrid: {
                    noDataMessage: $translate.instant("NoOtherSavings_SC"),
                    sortable: {
                        allowUnsort: false
                    },
                    detailTemplate: "#:description#",
                    columns: [
                        {
                            width: 80,
                            field: "startDate",
                            title: "Start",
                            template: "#=moment(startDate, 'YYYYMM').format('MMM/YYYY')#",
                            headerAttributes: {
                                class: 'border-left-0'
                            },
                            attributes: {
                                class: 'text-nowrap text-right'
                            }
                        },
                        {
                            width: 80,
                            field: "endDate",
                            title: "End",
                            template: "#=endDate != null ? moment(endDate, 'YYYYMM').format('MMM/YYYY') : ''#",
                            attributes: {
                                class: 'text-nowrap text-right'
                            }
                        },
                        {
                            width: 210,
                            field: "frequency",
                            title: "Frequency",
                            template: "#=frequency# <span class='text-nowrap'>#=frequencyStartEnd#</span>"
                        },
                        {
                            width: 128,
                            field: "value",
                            title: "Amount_TC",
                            template: function (item) { return chartHelper.currencyFormat(item.value, item.costUnit.unitInfo, 2); },
                            attributes: {
                                class: 'text-right text-nowrap'
                            }
                        },
                        {
                            field: "category",
                            title: "Category"
                        }
                    ]
                }
            };

            if (vm.savingsAdjustmentsManage) {
                content.dataGrid.columns.push({
                    headerAttributes: { "class": "ec-grid-actions" },
                    attributes: { "class": "ec-grid-actions" },
                    template: "<button id='deleteOtherSaving_#=otherSavingsId#' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Delete other savings\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='vm.controller.deleteOtherSavings(#=otherSavingsId#)'><i class='ec-icon icon-delete'></i></button><button id='editOtherSaving_#=otherSavingsId#' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Edit other savings\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='vm.controller.editOtherAdjustment(#=otherSavingsId#)'><i class='ec-icon icon-edit'></i></button>",
                    headerTemplate: "<button id='addOtherSavings' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Add other savings\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='vm.controller.addOtherAdjustment()'><i class='ec-icon icon-add'></i></button>",
                    width: (gridHelper.ACTION_ICON_WIDTH * 2)  + 5, // the + 5 is for the padding (Firefox truncates and hides the edit pencil)
                });
            }

            if (vm.data) {
                content.dataGrid.dataSource = {
                    sort: { field: "startDate", dir: "desc" },
                    data: vm.data.results
                };
            }

            return content;
        }

        /**
        * Click handler for the other savings grid to add a new other savings
        */
        function addOtherAdjustment() {
            glazeService.openGlaze(0, 'create-other-adjustment');
        }

        /**
        * Click handler for the other savings grid to edit an other savings item
        * @param {integer} otherSavingsId - Other Savings identifier
        */
        function editOtherAdjustment(otherSavingsId) {
            glazeService.openGlaze(otherSavingsId, 'edit-other-adjustment');
        }

        /**
        * Click handler for the other savings grid to delete an other savings item
        * @param {integer} otherSavingsId - Other Savings identifier
        */
        function deleteOtherSavings(otherSavingsId) {
            confirmationService.confirmation($translate.instant("Delete other savings"), $translate.instant("Are you sure?")).then(function (result) {
                if (!result) {
                    return;
                }

                apiResource.savings().otherSavings().remove({ meterId: vm.id, otherSavingsId: otherSavingsId }, function (result) {
                    $state.reload();
                });
            });
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('buildingsModule')
        .controller('meterSavingsSpecialAdjustmentsController', MeterSavingsSpecialAdjustmentsController);

    MeterSavingsSpecialAdjustmentsController.$inject = ['apiResource', '$filter', '$state', 'glazeService', '$translate',
        'confirmationService', 'powerviewHelper', 'gridHelper', 'runtimeService', 'userService'];

    /**
    * Controller for the Meter Savings Special Adjustments Powerview
    */
    function MeterSavingsSpecialAdjustmentsController(apiResource, $filter, $state, glazeService, $translate,
        confirmationService, powerviewHelper, gridHelper, runtimeService, userService) {
        var vm = this;

        ////////////////////////////////////////////////////////////////////////
        // TODO: remove after ECAP-3957 is done
        vm.converted = true;
        ////////////////////////////////////////////////////////////////////////

        vm.id = $state.params.meterId;
        vm.fullScreen = true;

        vm.addSpecialAdjustment = addSpecialAdjustment;
        vm.editSpecialAdjustment = editSpecialAdjustment;
        vm.deleteSpecialAdjustment = deleteSpecialAdjustment;

        vm.savingsAdjustmentsManage = false;

        init();

        /**
        * Constructor function to be called when the controller is ready to load
        */
        function init() {
            vm.status = 'pending';
            vm.message = 'Loading';

            // Set Permissions to hide/show buttons
            // Everything on this screen as some dependency on permissions so calling once
            // and not doing anything until these values are set
            runtimeService.getConfigData().then(function () {

                vm.savingsAdjustmentsManage = userService.userHasPermission("SavingsAdjustmentsManage");

                if (vm.savingsAdjustmentsManage) {
                    vm.addNew = {
                        label: $translate.instant('AddSpecialAdjustments_TC'),
                        callback: vm.addSpecialAdjustment
                    }
                }

                apiResource.savings().specialAdjustment().query({ meterId: vm.id }, function (result) {
                    var specialAdjustments = [];

                    angular.forEach(sortData(result, "indexNumber", false), function (adjustment) {
                        var adj = {
                            specialAdjustmentId: adjustment.specialAdjustmentId,
                            sequence: adjustment.indexNumber,
                            startDate: adjustment.frequency.startDate,
                            endDate: adjustment.frequency.endDate,
                            frequency: adjustment.frequency.frequency,
                            value: adjustment.value,
                            category: adjustment.specialAdjustmentType.specialAdjustmentTypeInfo,
                            method: adjustment.specialAdjustmentMethod.label,
                            comments: adjustment.comments,
                            frequencyStartEnd: ''
                        };
                        if (adjustment.frequency.frequency.toLowerCase() === "recurring") {
                            adj.frequencyStartEnd = "(" + adjustment.frequency.annualCycleStartInfo + " &#8211; " + adjustment.frequency.annualCycleEndInfo + ")";
                        }
                        specialAdjustments.push(adj);
                    });

                    setPowerviewProperties(powerviewHelper.getPowerviewProperties({ results: specialAdjustments }));
                    createWidgets();
                }, function (error) {
                    setPowerviewProperties(powerviewHelper.getPowerviewProperties());
                });
            });
        }

        /**
         * Sets view properties for the powerview
         * @param {Object} properties - The powerview properties
         */
        function setPowerviewProperties(properties) {
            vm.data = properties.data;
            vm.message = properties.message;

            // Show the widget even if there is no data
            if (properties.status === 'noData') {
                vm.status = 'hasData';
            } else {
                vm.status = properties.status;
            }
        }

        function createWidgets() {
            vm.widgets = [];

            vm.widgets.push(powerviewHelper.getWidgetDefinition({
                id: "specialAdjustments",
                type: 'dataGrid',
                class: 'col-12',
                autoHeight: true,
                content: getSpecialAdjustmentsGrid()
            }));
        }

        /**
        * Generates the defintion for the special adjustments grid
        * @returns {object} - Object that will define the special adjustments grid
        */
        function getSpecialAdjustmentsGrid() {
            var content = {
                dataGrid: {
                    noDataMessage: $translate.instant("NoSpecialAdjustments_SC"),
                    sortable: {
                        allowUnsort: false
                    },
                    detailTemplate: "#:comments#",
                    columns: [
                        {
                            width: 28,
                            field: "sequence",
                            title: '',
                            headerAttributes: {
                                class: 'ec-grid-not-resizable border-left-0'
                            },
                            attributes: {
                                class: 'text-right pl-0'
                            }
                        },
                        {
                            width: 80,
                            field: "startDate",
                            title: "Start",
                            template: "#=moment(startDate).format('MM/DD/YYYY')#",
                            headerAttributes: {
                                class: 'border-left-0'
                            }
                        },
                        {
                            width: 80,
                            field: "endDate",
                            title: "End",
                            template: "#=moment(endDate).format('MM/DD/YYYY')#"
                        },
                        {
                            width: 108,
                            field: "frequency",
                            title: "Frequency",
                            template: "#=frequency# <span class='text-nowrap'>#=frequencyStartEnd#</span>"
                        },
                        {
                            width: 80,
                            field: "value",
                            title: "Value",
                            template: "<span>#=value != null ? kendo.format('{0:n4}', value) : ''#</span>",
                            attributes: {
                                class: 'text-right'
                            },
                            headerAttributes: {
                                class: 'text-right'
                            }
                        },
                        {
                            width: 88,
                            field: "category",
                            title: "Category"
                        },
                        {
                            field: "method",
                            title: "Method"
                        }
                    ]
                }
            };

            if (vm.savingsAdjustmentsManage) {
                content.dataGrid.columns.push({
                    headerAttributes: { "class": "ec-grid-actions" },
                    attributes: { "class": "ec-grid-actions" },
                    template: "<button id='deleteSpecialAdjustment_#=specialAdjustmentId#' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Delete special adjustment\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='vm.controller.deleteSpecialAdjustment(#=specialAdjustmentId#)'><i class='ec-icon icon-delete'></i></button><button id='editSpecialAdjustment_#=specialAdjustmentId#' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Edit special adjustment\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='vm.controller.editSpecialAdjustment(#=specialAdjustmentId#)'><i class='ec-icon icon-edit'></i></button>",
                    headerTemplate: "<button id='addSpecialAdjustment' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Add special adjustment\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='vm.controller.addSpecialAdjustment()'><i class='ec-icon icon-add'></i></button>",
                    width: (gridHelper.ACTION_ICON_WIDTH * 2)  + 5, // the + 5 is for the padding (Firefox truncates and hides the edit pencil)
                });
            }

            if (vm.data) {
                content.dataGrid.dataSource = {
                    data: vm.data.results
                };
            }

            return content;
        }

        /**
        * Click handler for the special adjustments grid to add a new special adjustments
        */
        function addSpecialAdjustment() {
            glazeService.openGlaze(0, 'create-special-adjustment');
        }

        /**
        * Click handler for the special adjustments grid to edit a special adjustment item
        * @param {integer} specialAdjustmentId - Special Adjustment identifier
        */
        function editSpecialAdjustment(specialAdjustmentId) {
            glazeService.openGlaze(specialAdjustmentId, 'edit-special-adjustment');
        }

        /**
        * Click handler for the special adjustments grid to edit a special adjustment item
        * @param {integer} specialAdjustmentId - Special Adjustment identifier
        */
        function deleteSpecialAdjustment(specialAdjustmentId) {
            confirmationService.confirmation($translate.instant("Delete special adjustment"), $translate.instant("Are you sure?")).then(function (result) {
                if (!result) {
                    return;
                }

                apiResource.savings().specialAdjustment().remove({ meterId: vm.id, specialAdjustmentId: specialAdjustmentId }, function (result) {
                    $state.reload();
                });
            });
        }

        /**
        * Function that wraps the angular orderBy filter
        * @param {array} data - Data array to sort
        * @param {string} dataField - Field to sort by in the data array
        * @param {bool} reverse - Flag to tell the order by to sort in reverse (desc)
        * @returns {array} - Data array passed in sorted by the dataField and direction
        */
        function sortData(data, dataField, reverse) {
            return $filter('orderBy')(data, dataField, reverse);
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('buildingsModule')
        .controller('meterSavingsTrendsController', MeterSavingsTrendsController);

    MeterSavingsTrendsController.$inject = ['$state', 'apiResource', 'glazeService', '$translate', 'powerviewHelper', 'chartHelper', 'userService'];

    /**
    * Controller for the Meter Savings Trends Powerview
    */
    function MeterSavingsTrendsController($state, apiResource, glazeService, $translate, powerviewHelper, chartHelper, userService) {
        var vm = this;
        vm.id = $state.params.meterId;
        vm.widgets = [];
        vm.status = 'pending';
        vm.message = 'Loading';

        vm.viewExplanationOfSavings = viewExplanationOfSavings;

        init();

        /**
        * Constructor function to be called when the controller is ready to load
        */
        function init() {
            vm.widgets.push(powerviewHelper.getWidgetDefinition({
                type: "chart",
                baseUrl: 'energycap://chart/meter/savingsTrends/',
                id: vm.id,
                class: "col-12 ec-powerview-trends-chart",
                showActions: false
            }));

            vm.savingsDetailsWidget = {
                type: "grid",
                source: getSavingsDetailsGrid(),
                class: "col-12 ec-grid-no-header ec-powerview-trends-grid"
            };

            vm.widgets.push(vm.savingsDetailsWidget);

	        apiResource.savings().meterBills().query({ meterId: vm.id, numberOfYears: userService.getUser().preference.trendChartNumberOfYears }, function (result) {
                vm.bills = result;

                angular.forEach(vm.bills, function (bill) {
                    bill.billingPeriod = parseInt(bill.calendarYear) * 100 + parseInt(bill.calendarPeriod);
                });

                vm.bills.sort(function (a, b) {
                    return a.billingPeriod === b.billingPeriod ? 0 : (a.billingPeriod > b.billingPeriod) ? -1 : 1;
                });

                vm.savingsDetailsWidget.source.dataSource = vm.bills;
                vm.status = 'hasData';
            }, function (error) {
                vm.status = 'error';
                vm.message = powerviewHelper.API_ERROR_MESSAGE
                vm.bills = [];
                vm.savingsDetailsWidget.source.dataSource = vm.bills;
            });
            
        }

        /**
        * Click handler for the details grid to view the Explanation of Savings for a bill
        * @param {integer} billId - Bill identifier
        */
        function viewExplanationOfSavings(billId) {
            glazeService.openGlaze(billId, 'meter-explanation-of-savings');
        }

        /**
        * Generates the defintion for the details grid
        * @returns {object} - Object that will define the details grid
        */
        function getSavingsDetailsGrid() {
            var translatedBatccTitle = $translate.instant("Baseline Adjusted to Current Conditions");
            var batccAcronym = $translate.instant("BATCC");
            var batccHeader = "<abbr tooltip data-toggle='tooltip' title='" + translatedBatccTitle + "'>" + batccAcronym + "</abbr>";

            var ddTitle = $translate.instant('DegreeDays_TC');
            var ddAcronym = $translate.instant('DD');
            var ddHeader = "<abbr tooltip data-toggle='tooltip' title='" + ddTitle + "'>" + ddAcronym + '</abbr>';

            var adjTitle = $translate.instant('Adjusted');
            var adjAbbreviated = $translate.instant('Adj_TC');
            var adjHeader = "<abbr tooltip data-toggle='tooltip' title='" + adjTitle + "'>" + adjAbbreviated + '</abbr>';

            return {                
                dataSource: {
                    sort: {
                        field: "periodName",
                        dir: "desc"
                    }
                },
                pageable: false,
                sortable: true,
                scrollable: true,
                resizable: false,
                columns: [
                    {
                        headerAttributes: { "class": "ec-grid-actions p-0" },
                        attributes: { "class": "ec-grid-actions" },
                        template: "<button id='viewEosButton_#=billId#' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"View savings details\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='grid.controller.viewExplanationOfSavings(#=billId#)'><i class='ec-icon icon-view'></i></button>"
                    },
                    {
                        field: "periodName",
                        title: "Billing Period",
                        headerAttributes: { class: 'text-wrap' },
                        attributes: { class: 'text-nowrap'},
                        template: function (item) { return $translate.instant(item.periodName) + ' ' + item.calendarYear;  },
                        sortable: {
                            compare: function (a, b) {                                
                                return a.billingPeriod === b.billingPeriod ? 0 : (a.billingPeriod > b.billingPeriod) ? 1 : -1;
                            }
                        }
                        
                    },
                    {
                        title: "Cost",
                        headerAttributes: {
                            class: 'text-center border-left'
                        },
                        columns: [
                            {
                                field: "baselineCost",
                                title: "Baseline",
                                template: function (item) { return chartHelper.currencyFormat(item.baselineCost, item.costUnit.unitInfo, 0); },
                                attributes: {
                                    "class": "text-right text-nowrap"
                                },
                                headerAttributes: {
                                    "class": "text-right border-left"
                                },
                            },
                            {
                                title: batccHeader,
                                skipTranslate: true,
                                field: "batccCost",
                                template: function (item) { return chartHelper.currencyFormat(item.batccCost, item.costUnit.unitInfo, 0); },
                                attributes: {
                                    "class": "text-right text-nowrap"
                                },
                                headerAttributes: {
                                    "class": "text-right"
                                },
                            },
                            {
                                field: "actualCost",
                                title: "Actual",
                                template: function (item) { return chartHelper.currencyFormat(item.actualCost, item.costUnit.unitInfo, 0); },
                                attributes: {
                                    "class": "text-right text-nowrap"
                                },
                                headerAttributes: {
                                    "class": "text-right"
                                },
                            }]
                    },
                    {
                        title: "Cost Avoidance",
                        headerAttributes: {
                            class: 'text-center border-left'
                        },
                        columns: [
                            {
                                field: "savingsCost",
                                title: "Amount",
                                template: function (item) { return chartHelper.currencyFormat(item.savingsCost, item.costUnit.unitInfo, 0); },
                                attributes: {
                                    "class": "text-right text-nowrap"
                                },
                                headerAttributes: {
                                    "class": "text-right border-left"
                                },
                            },
                            {
                                field: "savingsCostPercent",
                                title: "%",
                                template: "<span class='ec-data-indicator #=capStatus#'></span> #=savingsCostPercent != null ? kendo.format('{0:n1}', savingsCostPercent) + '%' : 0#",
                                attributes: {
                                    "class": "text-right position-relative"
                                },
                                headerAttributes: {
                                    "class": "text-right"
                                },
                                width: 64
                            }
                        ]
                    },
                    {
                        title: "Cooling",
                        headerAttributes: {
                            class: 'text-center border-left'
                        },
                        columns: [
                            {
                                field: "cdd",
                                title: ddHeader,
                                template: "#=cdd != null ? cdd : 0#",
                                attributes: {
                                    "class": "text-right"
                                },
                                headerAttributes: {
                                    "class": "text-right border-left"
                                },
                                width: 48
                            },
                            {
                                width: 36,
                                field: "cddAdjusted",
                                title: adjHeader,
                                template: "<i class='ec-icon ec-icon-xs #=cddAdjusted == true ? 'icon-check' : ''#'></i>",
                                attributes: {
                                    "class": "text-center"
                                },
                                headerAttributes: {
                                    "class": "text-center"
                                },
                            }
                        ]
                    },
                    {
                        title: "Heating",
                        headerAttributes: {
                            class: 'text-center border-left'
                        },
                        columns: [
                            {
                                field: "hdd",
                                title: ddHeader,
                                template: "#=hdd != null ? hdd : 0#",
                                attributes: {
                                    "class": "text-right"
                                },
                                headerAttributes: {
                                    "class": "text-right border-left"
                                },
                                width: 48
                            },
                            {
                                width: 36,
                                field: "hddAdjusted",
                                title: adjHeader,
                                template: "<i class='ec-icon ec-icon-xs #=hddAdjusted == true ? 'icon-check' : ''#'></i>",
                                attributes: {
                                    "class": "text-center"
                                },
                                headerAttributes: {
                                    "class": "text-center"
                                },
                            }
                        ]
                    },
                    {
                        title: "Use",
                        headerAttributes: {
                            class: 'text-center border-left'
                        },
                        columns: [
                            {
                                field: "baselineNativeUse",
                                title: "Baseline",
                                template: "#=baselineNativeUse != null ? kendo.format('{0:n0}', baselineNativeUse) : 0#",
                                attributes: {
                                    "class": "text-right"
                                },
                                headerAttributes: {
                                    "class": "text-right border-left"
                                },
                            },
                            {
                                title: batccHeader,
                                skipTranslate: true,
                                field: "batccNativeUse",
                                template: "#=batccNativeUse != null ? kendo.format('{0:n0}', batccNativeUse) : 0#",
                                attributes: {
                                    "class": "text-right"
                                },
                                headerAttributes: {
                                    "class": "text-right"
                                },
                            },
                            {
                                field: "actualNativeUse",
                                title: "Actual",
                                template: "#=actualNativeUse != null ? kendo.format('{0:n0}', actualNativeUse) : 0#",
                                attributes: {
                                    "class": "text-right"
                                },
                                headerAttributes: {
                                    "class": "text-right"
                                },
                            }                            
                        ]
                    },
                    {
                        title: "Use Avoidance",
                        headerAttributes: {
                            class: 'text-center border-left'
                        },
                        columns: [
                            {
                                field: "savingsNativeUse",
                                title: "Amount",
                                template: "#=savingsNativeUse != null ? kendo.format('{0:n0}', savingsNativeUse) : 0#",
                                attributes: {
                                    "class": "text-right"
                                },
                                headerAttributes: {
                                    "class": "text-right border-left"
                                },
                            },
                            {
                                field: "savingsNativeUsePercent",
                                title: "%",
                                template: "#=savingsNativeUsePercent != null ? kendo.format('{0:n1}', savingsNativeUsePercent) + '%' : 0#",
                                attributes: {
                                    "class": "text-right"
                                },
                                headerAttributes: {
                                    "class": "text-right"
                                },
                                width: 56
                            }
                        ]
                    }
                ]
            };           
        }

        
    }


})();
﻿(function () {
    'use strict';

    angular
        .module('buildingsModule')
        .controller('savingsMonthlyOrganizationController', SavingsMonthlyOrganizationController);

    SavingsMonthlyOrganizationController.$inject = ['$state', 'apiResource'];

    function SavingsMonthlyOrganizationController($state, apiResource) {
    	var vm = this;
    	vm.commodities = [];
    	vm.organizationId = $state.params.placeId;
    	vm.selectedCommodity = {};

        (function constructor() {
            apiResource.place().digestSavingsYearly().get(
                {
                    placeId: vm.organizationId
                }, function (result) {
                    vm.commodities = result.commodities;
                    vm.lastUpdated = moment(result.updated).format("MM/DD/YYYY h:mm:ss a");
        	});
        })();
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('accountMeterResource', AccountMeterResource);

    AccountMeterResource.$inject = ['$resource'];

    function AccountMeterResource($resource) {

        var resource = {
            accountMeter: accountMeter,
            rate: rate,
	        templates: templates
        };

        function accountMeter() {
            return $resource("api/v3/accountmeter", {},
            {
                save: {
                    method: 'POST',
                    transformRequest: mapSave,
                    isArray: true
                }
            });
        }

        function templates() {
            return $resource("api/v3/accountmeter/:accountMeterId/template/:formTemplateId", { accountMeterId: '@accountMeterId', formTemplateId: '@formTemplateId'},
            {
               
                save: {
                    method: 'POST',
                    transformRequest: mapSaveTemplates
                },
                update: {
                    method: 'PUT',
                    transformRequest: mapUpdateTemplates
                },
                remove: {
                    method: 'DELETE'
                }
            });
        }
	
	function rate() {
            return $resource("api/v3/accountmeter/:accountMeterId/rate", { accountMeterId: '@accountMeterId' },
            {
                save: {
                    method: 'POST',
                    transformRequest: mapSaveRate
                }
            });
        }


        function mapSave(data, headersGetter) {

            var accountMeterList = [];

            angular.forEach(data, function (item) {
                accountMeterList.push({
                    accountId: item.account.accountId,
                    meterId: item.meterId,
                    beginDate: item.beginDate ? item.beginDate : moment("01/01/2000"),
                    endDate: moment("01/01/3000"),
                    deregulated: item.deregulated.value,
                    templateId: item.template.templateId,
                    rateId: item.rate.rateId,
                    vendorTypeId: (item.vendorType ? item.vendorType.vendorTypeId : null),
                    generalLedgerId: (item.generalLedger ? item.generalLedger.generalLedgerId : null)
                });
            });

            return angular.toJson(accountMeterList);
        }

        function mapSaveTemplates(data, headersGetter) {
            var template = {
                templateId: data.templateId,
                beginDate: data.beginDate ? data.beginDate : moment("01/01/2000").format('MM/DD/YYYY'),
                endDate: data.endDate ? data.endDate : moment("01/01/3000").format('MM/DD/YYYY')
            };

            return angular.toJson(template);
        }

        function mapUpdateTemplates(data, headersGetter) {
            var template = {
                templateId: data.templateId,
                beginDate: data.beginDate ? data.beginDate : moment("01/01/2000").format('MM/DD/YYYY'),
                endDate: data.endDate ? data.endDate : moment("01/01/3000").format('MM/DD/YYYY')
            };

            return angular.toJson(template);
        }

	function mapSaveRate(data, headersGetter) {
            var accountRate = {
                rateId: data.rateId,  // tariffId
                templateId: data.template.templateId,
                startDate: data.startDate ? data.startDate : moment("01/01/2000")
            };

            return angular.toJson(accountRate);
        }
        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('accountResource', AccountResource);

    AccountResource.$inject = ['$resource', '$paginationResource', 'mapResponseContentHelper', 'dateHelper'];

    function AccountResource($resource, $paginationResource, mapResponseContentHelper, dateHelper) {

        var resource = {
            account: account,
            allAccounts: allAccounts,
            digestActualMonthly: digestActualMonthly,
            digestActualYearly: digestActualYearly,
            rates: rates,
            templates: templates,
            list: list,
            udfs: udfs,
            listApprove: listApprove,
            listDeleteBills: listDeleteBills,
            listExportHold: listExportHold,
            listVoid: listVoid,
            listPossibleDestinationAccounts: listPossibleDestinationAccounts,
            listMoveBills: listMoveBills,
            listUnexport: listUnexport
        };

        function account(options) {
            if (angular.isUndefined(options)) {
                options = {};
            }

            if (!options.hasOwnProperty('cancelable')) {
                options.cancelable = true;
            }

        	return $resource("api/v3/account/:accountId", { accountId: '@accountId' },
            {
                query: { method: "GET", isArray: true, cache: false },
                get: {
                    method: 'GET',
                    cancelable: options.cancelable
                },
                save: {
        	        method: 'POST',
        	        transformRequest: mapSave
                },
                update: {
                    method: 'PUT',
                    transformRequest: mapUpdate
                }
            });
        }

        function allAccounts(options) {

            if (angular.isUndefined(options)) {
                options = {};
            }

            if (!options.hasOwnProperty('cancelable')) {
                options.cancelable = true;
            }

            return $paginationResource('api/v3/account/:accountId', { accountId: '@accountId' }, {
                query: { method: 'GET', isArray: true, cache: false, cancelable: false },
                get: { method: 'GET', cancelable: options.cancelable }
            });
        }

        function digestActualMonthly() {
            return $resource('api/v3/account/:accountId/digest/actual/monthly', { accountId: '@accountId' });
        }

        function digestActualYearly() {
            return $resource('api/v3/account/:accountId/digest/actual/yearly', { accountId: '@accountId' });
        }

        function rates() {
            return $resource("api/v3/account/:accountId/rate", { accountId: '@accountId' });
        }

        function templates() {
            return $resource("api/v3/account/:accountId/template", { accountId: '@accountId' });
        }

        function list() {
            return $resource('api/v3/account/:accountId/list/bill', { accountId: '@accountId' },
            {
                get: {
                    method: 'GET', cache: false, transformResponse: function (data, headers) {
                        var response = {};
                        response.result = angular.fromJson(data);
                        response.headers = headers();
                        return response;
                    }
                }
            });
        }

        function udfs() {
            return $resource("api/v3/account/:accountId/udf", { accountId: '@accountId' },
				{
				    query: {
				        method: 'GET', isArray: true, cache: false,
				        transformResponse: mapUdfsResponse
				    },
				    update: {
				        method: 'PUT',
				        transformRequest: mapUpdateUdfs,
				        isArray: true
				    }
				});
        }

        function listApprove() {
            return $resource("api/v3/account/:accountId/list/bill/approve", { accountId: '@accountId' }, {
                update: {
                    method: 'PUT'
                }
            });
        }

        function listDeleteBills() {
            return $resource("api/v3/account/:accountId/list/bill/data", { accountId: '@accountId' }, {
                remove: {
                    method: 'DELETE'
                }
            });
        }

        function listExportHold() {
            return $resource("api/v3/account/:accountId/list/bill/exporthold", { accountId: '@accountId' }, {
                update: {
                    method: 'PUT'
                }
            });
        }

        function listVoid() {
            return $resource("api/v3/account/:accountId/list/bill/void", { accountId: '@accountId' }, {
                update: {
                    method: 'PUT'
                }
            });
        }

        function listPossibleDestinationAccounts() {
            return $resource("api/v3/account/:accountId/list/bill/possibleDestinationAccounts", { accountId: '@accountId' }, {
                update: {
                    method: 'PUT'
                }
            });
        }

        function listMoveBills() {
            return $resource("api/v3/account/:accountId/list/bill/moveBills", { accountId: '@accountId' }, {
                update: {
                    method: 'PUT'
                }
            });
        }

        function listUnexport() {
            return $resource("api/v3/account/:accountId/list/bill/unexport", { accountId: '@accountId' }, {
                update: {
                    method: 'PUT',
                    cancelable: false,
                    transformRequest: mapUnexport
                }
            });
        }

        function mapUdfsResponse(data) {
            var jsonData = angular.fromJson(data);

            jsonData.forEach(function (json) {
                if (json.dataType.dataTypeId === 6 && json.value) {
                    json.value = moment(json.value).format('MM/DD/YYYY');
                }
            });

            return jsonData;
        }

        function mapUpdateUdfs(data, headersGetter) {

            var accountUdfs = [];
            angular.forEach(data, function (udf) {

                if (udf.dataType.dataTypeId === 6 && udf.value) {
                    udf.value = dateHelper.pretendUTC(moment(udf.value, "MM/DD/YYYY").toDate());
                }

                accountUdfs.push({
                    udfId: udf.udfId,
                    value: udf.value === '' ? null : udf.value
                });
            });

            return angular.toJson(accountUdfs);
        }

        function mapSave(data, headersGetter) {
            var account = {
                accountCode: data.accountNumber,
                country: data.address ? data.address.country : null,
                postalCode: data.address ? data.address.postalCode : null,
                line1: data.address ? data.address.line1 : null,
                line2: data.address ? data.address.line2 : null,
                city: data.address ? data.address.city : null,
                state: data.address ? data.address.state : null,
                accountTypeId: 1,
                costCenterId: data.parent.costCenterId,
                vendorId: data.vendor.vendorId,
                accrualEnabled: data.accrualEnabled ? true : false
            };

            if (data.accountName === "number") {
                account.accountInfo = data.accountNumber;
            } else if (data.accountName === "address") {
                account.accountInfo = data.address.line1;
            } else if (data.accountName === "user-defined") {
                account.accountInfo = data.accountNameUserDefined;
            }

            return angular.toJson(account);
        }

        function mapUpdate(data, headersGetter) {
            var account = {
                accountCode: data.accountCode,
                accountInfo: data.accountInfo,
                country: data.address ? data.address.country : null,
                postalCode: data.address ? data.address.postalCode : null,
                line1: data.address ? data.address.line1 : null,
                line2: data.address ? data.address.line2 : null,
                city: data.address ? data.address.city : null,
                state: data.address ? data.address.state : null,
                accountTypeId: 1,
                costCenterId: data.parent.costCenterId,                
                accrualEnabled: data.accrualEnabled ? true : false,
                serviceStart: data.serviceStart,
                serviceEnd: data.serviceEnd,
                memo: data.memo,
                depositAmount: data.depositAmount,
                depositNote: data.depositNote,
                depositReturn: data.depositReturn,
                depositPaid: data.depositPaid,
                customerId: data.customer ? data.customer.customerId : null,
                contactId: data.contact ? data.contact.contactId : null,
                active: data.active

            };

            return angular.toJson(account);
        }

        function mapUnexport(data, headersGetter) {
            var request = {
                exportMode: data.exportMode
            };
            return angular.toJson(request);
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('administrationResource', AdministrationResource);

    AdministrationResource.$inject = ['$resource'];

    function AdministrationResource($resource) {

        var resource = {
            systemSettings: systemSettings,
            accountingGl: accountingGl,
            glSubCodeValues: glSubCodeValues,
            accountPeriods: accountPeriods
        };

        function systemSettings() {
            return $resource("api/v3/admin/systemsetting", { },
            {
                query: {
                    method: "GET", isArray: false, cache: false, transformResponse: mapSystemSettingsResponse
                },
                get: {
                    method: 'GET', cache: false
                },
                update: {
                    method: 'PUT', isArray: true, transformRequest: mapSystemSettingsRequest
                }
            });
        }


        function mapSystemSettingsResponse(data) {
            var jsonData = angular.fromJson(data);
            var mappedProps = {};

            jsonData.forEach(function (jsonDataItem) {
                mappedProps[jsonDataItem.fieldName] = jsonDataItem;
            });

            return mappedProps;
        }

        function mapSystemSettingsRequest(data, headersGetter) {
            var requestList = [];
            for (var property in data) {
                requestList.push({
                    fieldName: data[property].fieldName,
                    value: data[property].value,
                    dataTypeId: data[property].dataType.dataTypeId
                });
            }

            return angular.toJson(requestList);
        }

        function accountingGl() {
            return $resource("api/v3/glsubcode", {},
            {
                query: {
                    method: "GET", isArray: true, cache: false
                },
                get: {
                    method: 'GET', cache: false
                },
                update: {
                    method: 'POST', isArray: true
                }
            });
        }

        function glSubCodeValues() {
            return $resource('api/v3/glsubcode/:subCodeIndex/savedValues', { subCodeIndex: '@subCodeIndex' }, {
                query: { method: 'GET', isArray: true, cache: false }
            });
        }

        function accountPeriods() {
            return $resource("api/v3/admin/accountperiod", {},
            {
                query: {
                    method: "GET", isArray: true, cache: false
                }
            });
        }
        

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('apiAirBoss', ApiAirBoss);

    ApiAirBoss.$inject = [];

    /*
        ApiAirBoss service controls inflight API (HTTP) requests.
        If directed, ApiAirBoss can cancel all inflight API requests
        except those that have a configuration with a property of 
        'cancelable' being false. Unless specified in a request
        config, all API requests are cancelable. 
    */
    function ApiAirBoss() {
        var context = this;

        (function constructor() {
            context.pendingRequests = [];
            context.addRequest = addRequest;
            context.removeRequest = removeRequest;
            context.cancelAll = cancelAll;
            context.cancelIf = cancelIf;
        })();

        function addRequest(request) {
            context.pendingRequests.push(request);
        }

        function removeRequest(request) {
            context.pendingRequests = _.filter(context.pendingRequests, function (p) {
                return p !== request;
            });
        }

        function cancelAll() {
            cancelIf(function (request) {
                // Check to see if the HTTP config has a property of cancelable.
                // If it is set to 'FALSE' then that mean the requests is NOT cancelable
                // and won't be 'resolved' to a canceled state.
                var lowerUrl = (request.url || '').toLowerCase();
                var isStaticFile = _.endsWith(lowerUrl, '.html') || _.endsWith(lowerUrl, '.htm');
                var isCancelable = !request.hasOwnProperty('cancelable') || request.cancelable == true;

                return isCancelable && !isStaticFile;
            });
        }

        /**Cancels all requests that match the provided filter function
        *@param {function} filter - a function that accepts the http request and returns true if it should be canceled
        */
        function cancelIf(filter) {
            angular.forEach(context.pendingRequests, function (value, key) {
                if (filter && filter(value)) {
                    value.rejection.resolve('canceled');
                    context.removeRequest(value);
                }
            });
        }

        return context;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('apiResource', ApiFactory);

    ApiFactory.$inject = [
            '$resource',
            'administrationResource',
            'accountResource',
            'accountMeterResource',
            'billResource',
            'commodityResource',
            'costCenterResource',
            'customerResource',
            'dashboardResource',
            'energyProjectResource',
            'groupResource',
            'meResource',
            'meterResource',
            'observationTypeResource',
            'placeResource',
            'placeTypeResource',
            'postalCodeResource',
		        'primaryUseResource',
            'rateResource',
            'readingResource',
            'reportResource',
            'savingsResource',
            'searchResource',
            'setupSheetResource',
            'taskResource',
            'templateResource',
            'timezoneResource',
            'udfResource',
            'unitResource',
            'vendorResource',
            'filterDataResource',
            'importerResource',
            'workflowResource',
            'batchResource',
            'chargebackWorkflowResource'
    ];

    function ApiFactory(
                    $resource,
                    administrationResource,
                    accountResource,
                    accountMeterResource,
		                billResource,
                    commodityResource,
                    costCenterResource,
                    customerResource,
                    dashboardResource,
                    energyProjectResource,
                    groupResource,
                    meResource,
                    meterResource,
                    observationTypeResource,
                    placeResource,
                    placeTypeResource,
                    postalCodeResource,
		                primaryUseResource,
                    rateResource,
                    readingResource,
                    reportResource,
                    savingsResource,
                    searchResource,
                    setupSheetResource,
                    taskResource,
                    templateResource,
                    timezoneResource,
                    udfResource,
                    unitResource,
                    vendorResource,
                    filterDataResource,
                    importerReource,
                    workflowResource,
                    batchResource,
                    chargebackWorkflowResource
                    ) {

        var service = {
            administration: administration,
            me: me,
            meter: meter,
            place: place,
            placeType: placeType,
            primaryUse: primaryUse,
            search: search,
            commodity: commodity,
            vendor: vendor,
            account: account,
            rate: rate,
            accountMeter: accountMeter,
            bill: bill,
            dashboard: dashboard,
            reading: reading,
	          report: report,
	          costCenter: costCenter,
	          customer: customer,
            observationType: observationType,
            task: task,
            template: template,
            timezone: timezone,
            group: group,
            energyProject: energyProject,
            savings: savings,
            setupSheet: setupSheet,
            udf: udf,
            unit: unit,
            postalCode: postalCode,
            filterData: filterData,
            importer: importer,
            workflow: workflow,
            batch: batch,
            chargebackWorkflow: chargebackWorkflow
        };

        function administration() {
            return administrationResource;
        }

        function me() {
            return meResource;
        }

        function group() {
            return groupResource;
        }

        function dashboard() {
            return dashboardResource;
        }

        function place() {
            return placeResource;
        }

        function meter() {
            return meterResource;
        }


        function placeType() {
            return placeTypeResource;
        }

        function primaryUse() {
            return primaryUseResource;
        }

        function search() {
            return searchResource;
        }

        function commodity() {
            return commodityResource;
        }

        function vendor() {
            return vendorResource;
        }

        function account() {
            return accountResource;
        }

        function rate() {
            return rateResource;
        }

        function accountMeter() {
            return accountMeterResource;
        }

        function bill() {
            return billResource;
        }

        function reading() {
            return readingResource;
        }

        function report() {
            return reportResource;
        }

        function costCenter() {
            return costCenterResource;
        }

        function observationType() {
            return observationTypeResource;
        }

        function template() {
            return templateResource;
        }

        function timezone() {
            return timezoneResource;
        }

        function energyProject() {
            return energyProjectResource;
        }

        function savings() {
            return savingsResource;
        }

        function udf() {
            return udfResource;
        }

        function unit() {
            return unitResource;
        }

        function postalCode() {
            return postalCodeResource;
        }

        function task() {
            return taskResource;
        }

        function setupSheet() {
            return setupSheetResource;
        }

        function customer() {
            return customerResource;
        }

        function filterData() {
            return filterDataResource;
        }

        function importer() {
            return importerReource;
        }

        function workflow() {
            return workflowResource;
        }

        function batch() {
            return batchResource;
        }

        function chargebackWorkflow() {
          return chargebackWorkflowResource;
      }

        return service;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('batchResource', BatchResource);

    BatchResource.$inject = ['$resource'];

    function BatchResource($resource) {

        var resource = {
            batch: batch
        };

        function batch() {
            return $resource("api/v3/batch?filter=:filter", { filter: '@filter' }, {
                query: {
                    method: "GET", isArray: true, cache: false
                }
            });
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('billResource', BillResource);

    BillResource.$inject = ['$resource', 'mapResponseContentHelper'];

    function BillResource($resource, mapResponseContentHelper) {

        var resource = {
            bill: bill,
            billApprove: billApprove,
            billVoid: billVoid,
            billExportHold: billExportHold,
            billDelete: billDelete,
            possibleDestinationAccounts: possibleDestinationAccounts,
            moveBills: moveBills,
            billUnexport: billUnexport,
            billSplit: billSplit
        };

        function bill() {
        	return $resource("api/v3/bill?filter=:filter", { filter: '@filter' },
            {
                query: {
                    method: "GET", isArray: true, cache: false
                },
                get: {
                    method: 'GET', cache: false, transformResponse: function (data, headers) {
                        var response = {};
                        response.data = data;
                        response.headers = headers();
                        return response;
                    }
                }
            });
        }

        function billApprove() {
            return $resource("api/v3/bill/approve", {}, {
                update: {
                    method: 'PUT',
                    transformRequest: mapBills
                }
            });
        }

        function billVoid() {
            return $resource("api/v3/bill/void", {}, {
                update: {
                    method: 'PUT',
                    transformRequest: mapBills
                }
            });
        }

        function billExportHold() {
            return $resource("api/v3/bill/exporthold", {}, {
                update: {
                    method: 'PUT',
                    transformRequest: mapBills
                }
            });
        }

        function billDelete() {
            return $resource("api/v3/bill/delete", {}, {
                remove: {
                    method: 'POST',
                    transformRequest: mapBills
                }
            });
        }

        function possibleDestinationAccounts() {
            return $resource("api/v3/bill/possibleDestinationAccounts/", {}, {
                update: {
                    method: 'PUT',
                    transformRequest: mapBills
                }
            });
        }

        function moveBills() {
            return $resource("api/v3/bill/moveBills/", {}, {
                update: {
                    method: 'PUT'
                }
            });
        }

        function billUnexport() {
            return $resource("api/v3/bill/unexport", {}, {
                update: {
                    method: 'PUT',
                    cancelable: false,
                    transformRequest: mapBillsUnexport
                }
            });
        }

        function billSplit() {
            return $resource("api/v3/bill/split/", {}, {
                run: {
                    method: 'POST',
                    transformRequest: mapSplitSettings
                }
            });
        }

        function mapSplitSettings(data, headersGetter) {
            //fieldId of id-1000 is the billId
            var requestObj = { 
                ids: _.map(data.bills, 'id-1000'),
                note: data.note,
                batchSettings: data.batchSettings
            };

            if (data.action) {
                requestObj[data.action] = data.actionBool;
            }

            return angular.toJson(requestObj);
        }

        function mapBills(data, headersGetter) {
            //fieldId of id-1000 is the billId
            var requestObj = { ids: _.map(data.bills, 'id-1000') };

            if (data.action) {
                requestObj[data.action] = data.actionBool;
            }

            return angular.toJson(requestObj);
        }

        function mapBillsUnexport(data, headersGetter) {
            //fieldId of id-1000 is the billId
            var requestObj = { billIds: _.map(data.bills, 'id-1000') };

            if (data.exportMode) {
                requestObj["exportMode"] = data.exportMode;
            }

            return angular.toJson(requestObj);
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('chargebackWorkflowResource', ChargebackWorkflowResource);

    ChargebackWorkflowResource.$inject = ['$resource'];

    function ChargebackWorkflowResource($resource) {

        var resource = {
            chargebackWorkflow: chargebackWorkflow
        };

        function chargebackWorkflow() {
            return $resource("api/v3/chargebackWorkflow", {
                query: {
                    method: "GET", isArray: true, cache: false, cancelable: false
                }
            });
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('commodityResource', CommodityResource);

    CommodityResource.$inject = ['$resource'];

    function CommodityResource($resource) {

        var resource = {
            commodity: commodity,
            commodityUnit: commodityUnit,
            digestActualYearly: digestActualYearly,
            commodityWithCategoryInfo: commodityWithCategoryInfo
        };

        function commodity() {
            return $resource("api/v3/commodity/:commodityId", {commodityId: '@commodityId'}, {
                query: { method: "GET", isArray: true, cache: false }
            });
        }

        function commodityWithCategoryInfo() {
            return $resource("api/v202304/commodity/:commodityId", {commodityId: '@commodityId'}, {
                query: { method: "GET", isArray: true, cache: false }
            });
        }

    	function commodityUnit() {
    	    return $resource("api/v3/commodity/:commodityId/unit?nounCode=:nounCode", { commodityId: '@commodityId', nounCode: '@nounCode' }, {
    	        query: { method: "GET", isArray: true, cache: false }
    	    });
    	}

    	function digestActualYearly() {
    	    return $resource('api/v3/commodity/:commodityId/digest/actual/yearly', { commodityId: '@commodityId' });
    	}

    	return resource;
    }

})();
﻿(function () {
	'use strict';

	angular
        .module('app')
        .factory('costCenterResource', CostCenterResource);

	CostCenterResource.$inject = ['$resource', '$paginationResource'];

	function CostCenterResource($resource, $paginationResource) {

		var resource = {
		    costCenter: costCenter,
            allCostCenters: allCostCenters,
		    digestActualMonthly: digestActualMonthly,
		    digestActualYearly: digestActualYearly
		};

		function costCenter() {
		    return $resource('api/v3/costCenter/:costCenterId', { costCenterId: '@costCenterId' },
            {
                query: { method: 'GET', isArray: true, cache: false, cancelable: false },
                save: {
                    method: 'POST',
                    transformRequest: mapSave
                },
                update: {
                    method: 'PUT',
                    transformRequest: mapUpdate
                },
                remove: { // Using remove here vs delete since some warn that delete being a reserved word may conflict in IE unless using bracket notation
                    method: 'DELETE'
                }
			});
		}

		function allCostCenters(options) {

		    if (angular.isUndefined(options)) {
		        options = {};
		    }

		    if (!options.hasOwnProperty('cancelable')) {
		        options.cancelable = true;
		    }

		    return $paginationResource('api/v3/costCenter/:costCenterId', { costCenterId: '@costCenterId', field: '@field' }, {
		        query: { method: 'GET', isArray: true, cache: false, cancelable: false },
		        get: { method: 'GET', cancelable: options.cancelable }
		    });
		}

		function digestActualMonthly() {
		    return $resource('api/v3/costCenter/:costCenterId/digest/actual/monthly', { costCenterId: '@costCenterId' });
		}

		function digestActualYearly() {
		    return $resource('api/v3/costCenter/:costCenterId/digest/actual/yearly', { costCenterId: '@costCenterId' });
		}

		function mapSave(data, headersGetter) {
		    var costcenter = {
		        costCenterCode: data.costCenterCode,
		        costCenterInfo: data.costCenterInfo,
		        parentCostCenterId: data.parent ? data.parent.costCenterId : null
		    };	    

		    return angular.toJson(costcenter);
		}

		function mapUpdate(data, headersGetter) {
		    var costcenter = {
		        costCenterCode: data.costCenterCode,
		        costCenterInfo: data.costCenterInfo,
		        parentCostCenterId: data.parent ? data.parent.costCenterId : null
		    };

		    return angular.toJson(costcenter);
		}

		return resource;
	}
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('customerResource', customerResource);

    customerResource.$inject = ['$resource', '$paginationResource'];

    function customerResource($resource, $paginationResource) {

        var resource = {
            customer: customer
        };
         
        function customer() {
            return $resource("api/v3/customer", {}, {
                query: { method: "GET", isArray: true, cache: false }
            });
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('dashboardResource', DashboardResource);

    DashboardResource.$inject = ['$resource'];

    function DashboardResource($resource) {

        var resource = {
            dashboard: dashboard,
            copy: copy,
            createMap: createMap,
            widget: widget,
            dashboardWidget: dashboardWidget,
            euiWidget: euiWidget,
            billsOverdueFromVendorWidget: billsOverdueFromVendorWidget,
            missingBills: missingBills,
            mapWidget: mapWidget,
            intervalDataWidget: intervalDataWidget,
            mostExpensiveBuildingsWidget: mostExpensiveBuildingsWidget,
            monthlyUseTrend: monthlyUseTrend,
            monthlyCostTrend: monthlyCostTrend,
            programSavingsAndCostAvoidanceByYearWidget: programSavingsAndCostAvoidanceByYearWidget,
            monthlyCostAvoidanceTrend: monthlyCostAvoidanceTrend,
	        carbonFootprintWidget: carbonFootprintWidget,
	        mostExpensiveMetersWidget: mostExpensiveMetersWidget,
            costAvoidanceByCommodityWidget: costAvoidanceByCommodityWidget,
            billCountWidget: billCountWidget,
            executeWidget:executeWidget
        };

        function dashboard(options) {

            if (angular.isUndefined(options)) {
                options = {};
            }

            if (!options.hasOwnProperty('cancelable')) {
                options.cancelable = true;
            }

            return $resource("api/v3/dashboard/:dashboardId?filter=:filter", { filter: '@filter', dashboardId: '@dashboardId' },
            {
                query: { method: "GET", isArray: true, cache: false, cancelable: options.cancelable },
                save: { method: 'POST' },
                update: { method: 'PUT' },
                remove: { method: 'DELETE' }
            });
        }

        function copy(options) {
            return $resource("api/v3/dashboard/:dashboardId/copy", { dashboardId: '@dashboardId' },
            {
                save: { method: 'POST' }
            });
        }

        function createMap() {
            return $resource("/api/v3/dashboard",
            {
                save: { method: 'POST' }
            });
        }

        function widget() {
            return $resource("api/v3/widget", { },
            {
                query: { method: "GET", isArray: true, cache: false }
            });
        }

        function dashboardWidget() {
            return $resource("api/v3/dashboard/:dashboardId/widget", { dashboardId: '@dashboardId' },
            {
                get: { method: 'GET', isArray: true },
                save: { method: 'POST' },
                update: { method: 'PUT', isArray: true }
            });
        }

        function euiWidget() {
            return $resource("api/v3/widget/eui/:specificWidgetId?filter=:filter", { specificWidgetId: '@specificWidgetId', filter: '@filter' },
            {
                get: { method: 'GET', isArray: true }
            });
        }

        function billsOverdueFromVendorWidget() {
            return $resource("api/v3/widget/billsoverduefromvendor/:specificWidgetId?filter=:filter", { specificWidgetId: '@specificWidgetId', filter: '@filter' },
            {
                get: { method: 'GET', isArray: true }
            });
        }

        function missingBills() {
            return $resource("api/v3/widget/missingbills/:specificWidgetId?filter=:filter", { specificWidgetId: '@specificWidgetId', filter: '@filter' },
            {
                get: { method: 'GET', isArray: true }
            });
        }

        function mapWidget() {
            return $resource("api/v3/widget/map/:specificWidgetId?filter=:filter", { specificWidgetId: '@specificWidgetId', filter: '@filter' },
            {
                get: { method: 'GET', isArray: true }
            });
        }

    	function intervalDataWidget() {
            return $resource("api/v3/widget/intervaldata/:specificWidgetId?filter=:filter", { specificWidgetId: '@specificWidgetId', filter: '@filter' },
            {
                get: { method: 'GET', isArray: true }
            });
    	}

    	function mostExpensiveBuildingsWidget() {
    	    return $resource("api/v3/widget/mostexpensivebuildings/:specificWidgetId?filter=:filter", { specificWidgetId: '@specificWidgetId', filter: '@filter' },
            {
                get: { method: 'GET', isArray: true }
            });
        }

        function executeWidget() {
    	    return $resource("api/v3/widget/exec/:specificWidgetId?filter=:filter", { specificWidgetId: '@specificWidgetId', filter: '@filter' },
            {
                // query - intended for use when the response from this stored procedure widget endpoint is an array of results.
                query: { method: 'GET', isArray: true },
                // get - intended for use when the response form this stored procedure widget endpoint is an object of some kind (perhaps containing multiple arrays).
                get: { method: 'GET', isArray: false }
            });
    	}

    	function monthlyUseTrend() {
    	    return $resource("api/v3/widget/monthlyusetrend/:specificWidgetId?filter=:filter", { specificWidgetId: '@specificWidgetId', filter: '@filter' });
    	}

    	function monthlyCostTrend() {
    	    return $resource("api/v3/widget/monthlycosttrend/:specificWidgetId?filter=:filter", { specificWidgetId: '@specificWidgetId', filter: '@filter' });
    	}

	    function programSavingsAndCostAvoidanceByYearWidget() {
    	    return $resource("api/v3/widget/programsavings/:specificWidgetId?filter=:filter", { specificWidgetId: '@specificWidgetId', filter: '@filter' },
            {
                get: { method: 'GET', isArray: false }
            });
    	}

	    function monthlyCostAvoidanceTrend() {
    	    return $resource("api/v3/widget/monthlysavingstrend/:specificWidgetId?filter=:filter", { specificWidgetId: '@specificWidgetId', filter: '@filter' },
            {
                get: { method: 'GET', isArray: true }
            });
    	}

	    function carbonFootprintWidget() {
    	        return $resource("api/v3/widget/carbonfootprint/:specificWidgetId?filter=:filter", { specificWidgetId: '@specificWidgetId', filter: '@filter' });
    	    }

	    function mostExpensiveMetersWidget() {
    	        return $resource("api/v3/widget/mostexpensivemeters/:specificWidgetId?filter=:filter", { specificWidgetId: '@specificWidgetId', filter: '@filter' },
                {
                    get: { method: 'GET', isArray: true }
                });
	    }

	    function costAvoidanceByCommodityWidget() {
	        return $resource("api/v3/widget/costavoidancebycommodity/:specificWidgetId?filter=:filter", { specificWidgetId: '@specificWidgetId', filter: '@filter' });
        }

        function billCountWidget() {
            return $resource("api/v3/widget/billcount/:specificWidgetId?filter=:filter", { specificWidgetId: '@specificWidgetId', filter: '@filter' });
        }

        return resource;
    }
})();
﻿(function () {
	'use strict';

	angular
        .module('app')
        .factory('energyProjectResource', EnergyProjectResource);

	EnergyProjectResource.$inject = ['$resource', 'dateHelper'];

	function EnergyProjectResource($resource, dateHelper) {

		var resource = {
		    energyProject: energyProject,
		    energyProjectType: energyProjectType,
		    projectManager: projectManager
		};

		function energyProject() {
		    return $resource('api/v3/energyproject/:projectId', { projectId: '@projectId' }, {
		        query: { method: 'GET', cache: false, transformResponse: mapEnergyProjectResponse },
		        save: { method: 'POST', transformRequest: mapEnergyProjectSaveData },
		        update: {
		            method: 'PUT',
		            transformRequest: mapEnergyProjectSaveData
		        },
		        remove: { // Using remove here vs delete since some warn that delete being a reserved word may conflict in IE unless using bracket notation
                    method: 'DELETE'
                }
			});
		}

		function energyProjectType() {
		    return $resource('api/v3/energyproject/energyprojecttype', {}, {
		        query: { method: 'GET', isArray: true, cache: false },
		        save: { method: 'POST' }
		    });
		}

		function projectManager() {
		    return $resource('api/v3/energyproject/projectmanager?query=:query', { query: '@query' }, {
		        query: { method: 'GET', isArray: true, cache: false }
		    });
		}

		function mapEnergyProjectResponse(data) {

		    var jsonData = angular.fromJson(data);

		    var energySavingsUnit = null;

		    // We get back a energySavingsUnit even when there is not one with a unitId of 0 which gets then displayed
            // in the combobox.  We should just leave the unit object null
		    if (jsonData.energySavings.energySavingsUnit && jsonData.energySavings.energySavingsUnit.energySavingsUnitId > 0) {
		        energySavingsUnit = {
		            unitId: jsonData.energySavings.energySavingsUnit.energySavingsUnitId,
		            unitCode: jsonData.energySavings.energySavingsUnit.energySavingsUnitCode,
		            unitInfo: jsonData.energySavings.energySavingsUnit.energySavingsUnitInfo
		        };
		    }

		    var project = {
		        placeId: jsonData.place.placeId,
		        name: jsonData.energyProjectCode,
		        shortName: jsonData.energyProjectInfo,
		        startDate: jsonData.installationBeginDate ? moment(jsonData.installationBeginDate).format('MM/DD/YYYY') : '',
		        endDate: jsonData.installationEndDate ? moment(jsonData.installationEndDate).format('MM/DD/YYYY') : '',
		        cost: jsonData.installationCost,
		        projectType: jsonData.energyProjectType,
		        rebate: jsonData.utilityRebate,
		        fundingScource: jsonData.fundingSource,
		        memo: jsonData.note,
		        energySavings: jsonData.energySavings.energySavings,
		        energySavingsUnit: energySavingsUnit,
                costSavings: jsonData.costSavings.costSavings,
                costSavingsUnit: jsonData.costSavings.costSavingsUnit,
                projectManager: jsonData.projectManager
		    };

		    return project;
		}

		function mapEnergyProjectSaveData(data, headersGetter) {
		    var project = {
		        placeId: data.placeId,
		        energyProjectCode: data.name,
		        energyProjectInfo: data.shortName,
                installationBeginDate: dateHelper.pretendUTC(moment(data.startDate, "MM/DD/YYYY").toDate()),
                installationEndDate: dateHelper.pretendUTC(moment(data.endDate, "MM/DD/YYYY").toDate()),
		        installationCost: data.cost,
		        energyProjectTypeCode: data.projectType ? data.projectType.energyProjectTypeCode : "",
		        utilityRebate: data.rebate,
		        fundingSource: data.fundingScource,
		        note: data.memo,
		        energySavings: data.energySavings,
		        energySavingsUnitCode: data.energySavingsUnit ? data.energySavingsUnit.unitCode : "",
                costSavings: data.costSavings,
                costSavingsUnitCode: data.costSavingsUnit.costSavingsUnitCode,
		        projectManager: data.projectManager
		    };

		    return angular.toJson(project);
		}

		return resource;
	}
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('filterDataResource', FilterDataResource);

    FilterDataResource.$inject = ['$resource'];

    function FilterDataResource($resource) {

        var resource = {
            filterdata: filterdata
        };

        function filterdata() {
            return $resource("api/v3/filterData/:datafieldId?search=:search", { datafieldId: '@datafieldId', search: '@search' },
            {
                query: { method: "GET", isArray: true, cache: false }
            });
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('groupResource', GroupResource);

    GroupResource.$inject = ['$resource'];

    function GroupResource($resource) {

        var resource = {
            meterGroup: meterGroup,
            meterGroupCategory: meterGroupCategory,
            placeGroup: placeGroup,
            placeGroupDigest: placeGroupDigest,
            meterGroupDigest: meterGroupDigest,
            placeGroupCategory: placeGroupCategory,
            meterGroupMembers: meterGroupMembers,
            placeGroupMembers: placeGroupMembers,
            meterGroupIncludeAllMembersInCharts: meterGroupIncludeAllMembersInCharts,
            placeGroupIncludeAllMembersInCharts: placeGroupIncludeAllMembersInCharts,
            meterGroupUpdateUserAutoGroup: meterGroupUpdateUserAutoGroup,
            meterGroupUpdateAllUserAutoGroups: meterGroupUpdateAllUserAutoGroups,
            placeGroupUpdateUserAutoGroup: placeGroupUpdateUserAutoGroup,
            placeGroupUpdateAllUserAutoGroups: placeGroupUpdateAllUserAutoGroups
        };

        function meterGroup(options) {
            if (angular.isUndefined(options)) {
                options = {};
            }
            
            if (!options.hasOwnProperty('cancelable')) {
                options.cancelable = true;
            }

            return $resource("api/v3/meterGroup/:meterGroupId", { meterGroupId: '@meterGroupId' },
            {
                query: { method: "GET", isArray: true, cache: false, cancelable: options.cancelable },
                get: { method: 'GET' },
                delete: { method: 'DELETE' }
            });
        }

        function meterGroupCategory(options) {
            if (angular.isUndefined(options)) {
                options = {};
            }
            
            if (!options.hasOwnProperty('cancelable')) {
                options.cancelable = true;
            }

            return $resource("api/v3/meterGroup/category/:meterGroupCategoryId", { meterGroupCategoryId: '@meterGroupCategoryId' },
            {
                query: { method: "GET", isArray: true, cache: false, cancelable: options.cancelable },
                get: { method: 'GET' },
                save: { method: 'POST' }
            });
        }

        function meterGroupMembers() {
            return $resource("api/v3/meterGroup/:meterGroupId/member/:memberId", { meterGroupId: '@meterGroupId', memberId: '@memberId' },
            {
                query: { method: "GET", isArray: true, cache: false },
                update: { method: "PUT", transformRequest: mapMemberUpdateRequest }
            });
        }

        function placeGroup() {
            return $resource("api/v3/placeGroup/:placeGroupId", { placeGroupId: '@placeGroupId' },
            {
                query: { method: "GET", isArray: true, cache: false },
                get: { method: 'GET' },
                delete: { method: 'DELETE' }
            });
        }

        function placeGroupDigest() {
            return $resource("api/v3/placeGroup/:placeGroupId/digest/:view/:type/?commodityId=:commodityId&commodityCategoryId=:commodityCategoryId&billingPeriodOption=:periodType&showExcludedMembers=:showExcluded&showZeroAverages=:showZeroAverages&highToLowRanking=true",
                { placeGroupId: '@placeGroupId', view: '@view', type: '@type', periodType: '@periodType', commodityId: '@commodityId', commodityCategoryId: '@commodityCategoryId', showExcluded: '@showExcluded', showZeroAverages: '@showZeroAverages' },
            {
                get: { method: 'GET' }
            });
        }

        function meterGroupDigest() {
            return $resource("api/v3/meterGroup/:meterGroupId/digest/:view/:type/?commodityId=:commodityId&commodityCategoryId=:commodityCategoryId&billingPeriodOption=:periodType&showExcludedMembers=:showExcluded&showZeroAverages=:showZeroAverages&highToLowRanking=true",
                { meterGroupId: '@meterGroupId', view: '@view', type: '@type', periodType: '@periodType', commodityId: '@commodityId', commodityCategoryId: '@commodityCategoryId', showExcluded: '@showExcluded', showZeroAverages: '@showZeroAverages' },
            {
                get: { method: 'GET' }
            });
        }

        function placeGroupCategory() {
            return $resource("api/v3/placeGroup/category/:placeGroupCategoryId", { placeGroupCategoryId: '@placeGroupCategoryId' },
            {
                query: { method: "GET", isArray: true, cache: false },
                get: { method: 'GET' },
                save: { method: 'POST' }
            });
        }

        function placeGroupMembers() {
            return $resource("api/v3/placeGroup/:placeGroupId/member/:memberId", { placeGroupId: '@placeGroupId', memberId: '@memberId' },
            {
                query: { method: "GET", isArray: true, cache: false },
                update: { method: "PUT", transformRequest: mapMemberUpdateRequest }
            });
        }

        function mapMemberUpdateRequest(data) {
            var member = {
                includeInCharts: data.includeInCharts
            };

            return angular.toJson(member);
        }

        function placeGroupIncludeAllMembersInCharts() {
            return $resource("api/v3/placeGroup/:placeGroupId/member/includeInCharts", { placeGroupId: '@placeGroupId' },
            {
                save: { method: 'POST' }
            });
        }

        function meterGroupIncludeAllMembersInCharts() {
            return $resource("api/v3/meterGroup/:meterGroupId/member/includeInCharts", { meterGroupId: '@meterGroupId' },
            {
                save: { method: 'POST' }
            });
        }

        function meterGroupUpdateUserAutoGroup() {
            return $resource("api/v3/meterGroup/:meterGroupId/updateUserAutoGroup", { meterGroupId: '@meterGroupId' },
            {
                save: { method: 'POST' }
            });
        }

        function meterGroupUpdateAllUserAutoGroups() {
            return $resource("api/v3/meterGroup/updateUserAutoGroups", {},
            {
                save: { method: 'POST' }
            });
        }

        function placeGroupUpdateUserAutoGroup() {
            return $resource("api/v3/placeGroup/:placeGroupId/updateUserAutoGroup", { placeGroupId: '@placeGroupId' },
            {
                save: { method: 'POST' }
            });
        }

        function placeGroupUpdateAllUserAutoGroups() {
            return $resource("api/v3/placeGroup/updateUserAutoGroups", {},
            {
                save: { method: 'POST' }
            });
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('importerResource', ImporterResource);

    ImporterResource.$inject = ['$resource'];

    function ImporterResource($resource) {

        var resource = {
            readingProfile: readingProfile,
            billProfile: billProfile
        };

        function readingProfile() {
            return $resource('api/v3/import/reading/profile', { }, {
                query: { method: 'GET', isArray: true, cache: false, cancelable: false }
            });
        }

        function billProfile() {
            return $resource('api/v3/import/bill/profile', { }, {
                query: { method: 'GET', isArray: true, cache: false, cancelable: false }
            });
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('flightDirector', FlightDirector);

    FlightDirector.$inject = ['$q', '$injector', 'apiAirBoss', '$window', '$translate', 'userService2'];

    /*
        FlightDirectorInterceptor will notify the APIAirBoss service
        that a API (HTTP) request is pending flight. It will also
        notify the APIAirBoss that a pending API request has received
        a response and is 'landing'. 
    */
    function FlightDirector($q, $injector, apiAirBoss, $window, $translate, userService) {

        var requestInterceptor = {
            request: function (config) {
                var rejectionPromise = $q.defer();
                var timeout = $q.defer();
                config.timeout = timeout.promise;
                config.rejection = rejectionPromise;
                apiAirBoss.addRequest(config);
                return config;
            },
            response: function (response) {
                apiAirBoss.removeRequest(response.config);
                return response;
            },
            responseError: function (response) {
                // If the status code of the API is a 401, 
                // redirect to login.   
                if (response.status === 401 && response.config.url !== "/api/v3/me") {
                    userService.logout();
                } else {                    
                    return $q.reject(response);
                }
            }
        };

        return requestInterceptor;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('waitForMe', WaitForMe);

    WaitForMe.$inject = ['$q', '$injector'];

    function WaitForMe($q, $injector) {
        var requestInterceptor = {
            // If a given HTTP request if not "api/v3/me", 
            // then we want to wait until we have a token
            // via "api/v3/me"
            request: function (config) { 
                // If a request url starts with assets or api, we need to prefix
                // with '/' so the C# AppController does not pick up the 
                // request and return the entire app html. This happens with
                // relative paths because our base href is now '/app/'
                // TODO: move to separate interceptor
                if (config.url.toString().startsWith('assets/') || config.url.toString().startsWith('api/')) {
                    config.url = '/' + config.url;
                }

                if ((config.url === "/api/v3/me" || config.url.indexOf("/assets/locales/") > -1) && config.method === "GET") {
                    return config;
                }

                var d = $q.defer();
                var runtimeService = $injector.get('runtimeService');
                runtimeService.getConfigData().then(function (data) {
                    config.headers.Authorization = "Bearer " + data.token;

                    // If the HTTP request URL ends with '.html', we are going to assume
                    // that it is a static file and has no existing query parameters. We'll 
                    // add a single query parameter with the version to act as a cache-busting mechanism. 
                    if(config.url.toString().endsWith('.html') && window.ECP.hasOwnProperty('version'))
                    {
                        config.url = config.url + '?v=' + window.ECP.version;
                    }

                    d.resolve(config);
                });
                return d.promise;
            }
        };

        return requestInterceptor;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('meResource', MeResource);

    MeResource.$inject = ['$resource', '$window'];

    function MeResource($resource, $window) {
        return $resource("api/v3/me", {}, {
            update: { method: 'PUT' },
            get: { method: 'GET', cache: false, cancelable: false },
            withJwtAuthentication: { method: 'GET', cache: false, cancelable: false, headers: { 'Authorization': 'Bearer ' + $window.jwt } },
            withPublicDashboardAuthentication: { method: 'GET', cache: false, cancelable: false, headers: { 'ECI-PUBLIC-DASHBOARD-KEY': $window.ECP.publicDashboardKey } }
        });
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('meterResource', MeterResource);

    MeterResource.$inject = ['$resource', '$paginationResource', 'dateHelper'];

    function MeterResource($resource, $paginationResource, dateHelper) {

        var resource = {
            meter: meter,
            allMeters: allMeters,
            groups: groups,
            udfs: udfs,
            templates: templates,
            rates: rates,
            digestActualMonthly: digestActualMonthly,
            digestActualYearly: digestActualYearly,
            digestCalendarizedMonthly: digestCalendarizedMonthly,
            digestCalendarizedYearly: digestCalendarizedYearly,
            digestNormalizedMonthly: digestNormalizedMonthly,
            digestNormalizedYearly: digestNormalizedYearly,
            digestSavingsMonthly: digestSavingsMonthly,
            digestSavingsYearly: digestSavingsYearly,
            bills: bills,
            ghgFactor: ghgFactor,
            digestGhgYearly: digestGhgYearly,
            list: list,
            calendarizedUseVsWeather: calendarizedUseVsWeather,
            listApprove: listApprove,
            listDeleteBills: listDeleteBills,
            listExportHold: listExportHold,
            listVoid: listVoid,
            listUnexport: listUnexport
        };

        function meter(options) {

            if (angular.isUndefined(options)) {
                options = {};
            }

            if (!options.hasOwnProperty('cancelable')) {
                options.cancelable = true;
            }

            return $resource("api/v3/meter/:meterId?filter=:filter&field=:field", { filter: '@filter', meterId: '@meterId', field:'@field' },
            {
                query: {
                    method: "GET",
                    isArray: true,
                    cache: false,
                    transformResponse: mapMeterResponse
                },
                get: {
                    method: 'GET',
                    cancelable: options.cancelable,
                    transformResponse: mapMeterResponse
                },
                update: {
                    method: 'PUT',
                    transformRequest: mapUpdate
                },
                save: {
                    method: 'POST',
                    transformRequest: mapSave
                }
            });
        }

        function allMeters(options) {

            if (angular.isUndefined(options)) {
                options = {};
            }

            if (!options.hasOwnProperty('cancelable')) {
                options.cancelable = true;
            }

            return $paginationResource('api/v3/meter/:meterId', { meterId: '@meterId' }, {
                query: {
                    method: 'GET',
                    isArray: true,
                    cache: false,
                    cancelable: false,
                    transformResponse: mapAllMetersResponse
                },
                get: {
                    method: 'GET',
                    cancelable: options.cancelable,
                    transformResponse: mapAllMetersResponse
                }
            });
        }

        function digestActualYearly() {
            return $resource('api/v3/meter/:meterId/digest/actual/yearly', { meterId: '@meterId' });
        }

        function digestActualMonthly() {
            return $resource('api/v3/meter/:meterId/digest/actual/monthly', { meterId: '@meterId' });
        }

        function digestCalendarizedYearly() {
            return $resource('api/v3/meter/:meterId/digest/calendarized/yearly', { meterId: '@meterId' });
        }

        function digestCalendarizedMonthly() {
            return $resource('api/v3/meter/:meterId/digest/calendarized/monthly', { meterId: '@meterId' });
        }

        function digestNormalizedYearly() {
            return $resource('api/v3/meter/:meterId/digest/normalized/yearly', { meterId: '@meterId' });
        }

        function digestNormalizedMonthly() {
            return $resource('api/v3/meter/:meterId/digest/normalized/monthly', { meterId: '@meterId' });
        }

        function digestSavingsYearly() {
            return $resource('api/v3/meter/:meterId/digest/savings/yearly', { meterId: '@meterId' });
        }

        function digestSavingsMonthly() {
            return $resource('api/v3/meter/:meterId/digest/savings/monthly', { meterId: '@meterId' });
        }

        function groups() {
            return $resource("api/v3/meter/:meterId/group", { meterId: '@meterId' }, {
                update: {
                    method: 'PUT',
                    isArray: true
                }
            });
        }

        function udfs() {
            return $resource("api/v3/meter/:meterId/udf", { meterId: '@meterId' },
				{
				    query: {
				        method: 'GET', isArray: true, cache: false,
				        transformResponse: mapUdfsResponse
				    },
				    update: {
				        method: 'PUT',
				        transformRequest: mapUpdateUdfs,
				        isArray: true
				    }
				});
        }

        function templates() {
            return $resource("api/v3/meter/:meterId/template", { meterId: '@meterId' });
        }

        function rates() {
            return $resource("api/v3/meter/:meterId/rate", { meterId: '@meterId' });
        }

        function bills() {
            return $resource("api/v3/meter/:meterId/bill", { meterId: '@meterId' });
        }

        function ghgFactor() {
            return $resource("api/v3/meter/:meterId/ghg/factor", { meterId: '@meterId' });
        }

        function digestGhgYearly() {
            return $resource('api/v3/meter/:meterId/digest/ghg/yearly', { meterId: '@meterId' });
        }

        function list() {
            return $resource('api/v3/meter/:meterId/list/bill', { meterId: '@meterId' },
            {
                get: {
                    method: 'GET', cache: false, transformResponse: function (data, headers) {
                        var response = {};
                        response.result = angular.fromJson(data);
                        response.headers = headers();
                        return response;
                    }
                }
            });
        }

        function calendarizedUseVsWeather() {
            return $resource("api/v3/meter/:meterId/usevsweather/calendarized", { meterId: '@meterId' },
                {
                    query: {
                        method: 'GET', isArray: true
                    }
                });
        }

        function listApprove() {
            return $resource("api/v3/meter/:meterId/list/bill/approve", { meterId: '@meterId' }, {
                update: {
                    method: 'PUT'
                }
            });
        }

        function listDeleteBills() {
            return $resource("api/v3/meter/:meterId/list/bill/data", { meterId: '@meterId' }, {
                remove: {
                    method: 'DELETE'
                }
            });
        }

        function listExportHold() {
            return $resource("api/v3/meter/:meterId/list/bill/exporthold", { meterId: '@meterId' }, {
                update: {
                    method: 'PUT'
                }
            });
        }

        function listVoid() {
            return $resource("api/v3/meter/:meterId/list/bill/void", { meterId: '@meterId' }, {
                update: {
                    method: 'PUT'
                }
            });
        }

        function listUnexport() {
            return $resource("api/v3/meter/:meterId/list/bill/unexport", { meterId: '@meterId' }, {
                update: {
                    method: 'PUT',
                    cancelable: false,
                    transformRequest: mapUnexport
                }
            });
        }

        function mapUdfsResponse(data) {
            var jsonData = angular.fromJson(data);

            jsonData.forEach(function (json) {
                if (json.dataType.dataTypeId === 6 && json.value) {
                    json.value = moment(json.value).format('MM/DD/YYYY');
                }
            });

            return jsonData;
        }

        function mapUpdateUdfs(data, headersGetter) {

            var meterUdfs = [];
            angular.forEach(data, function (udf) {
                if (udf.dataType.dataTypeId === 6 && udf.value) {
                    udf.value = dateHelper.pretendUTC(moment(udf.value, "MM/DD/YYYY").toDate());
                }

                meterUdfs.push({
                    udfId: udf.udfId,
                    value: udf.value === '' ? null : udf.value
                });
            });

            return angular.toJson(meterUdfs);
        }

        function mapUpdate(data, headersGetter) {
            return angular.toJson({
                meterCode: data.meterCode,
                meterInfo: data.meterInfo,
                placeId: data.parent ? data.parent.placeId : null,
                address: data.address ? data.address : null,
                billEntryNote: data.billEntryNote,
                includeInEnergyStar: data.includeInEnergyStar,
                includeInCostAvoidance: data.includeInCostAvoidance,
                primaryUseId: data.primaryUse && data.primaryUse.primaryUseId ? data.primaryUse.primaryUseId : null,
                meterTypeId: data.meterType ? data.meterType.meterTypeId : null,
                properties: {
                    serialNumber: data.properties.serialNumber ? data.properties.serialNumber : null,
                    importId: data.properties.importId ? data.properties.importId : null
                }
            });
        }

        function mapSave(data, headersGetter) {
            var meter = {
                meterCode: data.meterCode,
                meterInfo: data.meterInfo,
                commodityId: data.commodityId,
                placeId: data.parent ? parseInt(data.parent.placeId) : null,
                address: data.address ? data.address : null,
                billEntryNote: data.billEntryNote ? data.billEntryNote : null,
                properties: {},
                primaryUseId: data.primaryUse && data.primaryUse.primaryUseId ? data.primaryUse.primaryUseId : null,
                meterTypeId: data.meterTypeId
            };

            if (data.serialNumber) {
                meter.properties["Serial Number"] = data.serialNumber;
            }

            if (data.importId) {
                meter.properties["Import ID"] = data.importId;
            }

            return angular.toJson(meter);
        }

        function mapMeterResponse(data) {
            var meter = angular.fromJson(data);
            return meter;
        }

        function mapAllMetersResponse(data) {
            var meters = angular.fromJson(data);
            return meters;
        }

        function mapUnexport(data, headersGetter) {
            var request = {
                exportMode: data.exportMode
            };
            return angular.toJson(request);
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('observationTypeResource', ObservationTypeResource);

    ObservationTypeResource.$inject = ['$resource'];

    function ObservationTypeResource($resource) {

        var resource = {
            observationType: observationType
        };

        function observationType() {
            return $resource("api/v3/observationType?filter=:filter", { filter: '@filter' },
            {
                query: { method: "GET", isArray: true, cache: false }
            });
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('$paginationResource', PaginationResource);

    PaginationResource.$inject = ['$resource', '$q'];

    function PaginationResource($resource, $q) {

        function paginationResourceFactory(url, paramDefaults, actions, options) {

            var combinedData = [];
            var successCallBack;
            var internalePromise = $q.defer();
            var internalResource = $resource(url, paramDefaults, actions);
            var pagingResource = {};

            // Helper to wrap $resource functions
            function internalizeFunction (propertyName) {
                pagingResource[propertyName] = function (params, success, error) {
                    return internalResource[propertyName](params, success, error);
                };
            }

            // function which checks if there are any more pages (data) that needs to be retrieved
            // when data is completely retrieved- it resolves the promise and sends back the data to controller through a call back function
            var successFunction = function (data, headers) {

                // combine the data from multiple calls to the API
                combinedData = combinedData.concat(data);

                if (parseInt(headers().pagenumber) < parseInt(headers().totalpages)) {
                    paramDefaults.pageNumber = parseInt(headers().pagenumber) + 1;

                    /*eslint-disable */
                    internalResource.query(paramDefaults, successFunction);
                    /*eslint-enable */
                }
                else {
                    // there is no more data to be retrieved
                    // resolve the promise and send back the combined data to controller
                    internalePromise.resolve();
                    successCallBack(combinedData);
                }
            };

            // Setup "stock" $resource functions
            internalizeFunction("get");
            internalizeFunction("query");
            internalizeFunction("save");
            internalizeFunction("remove");
            internalizeFunction("delete");

            // Internalize any "custom" actions provided
            // via the definition
            for (var prop in actions) {
                if (actions.hasOwnProperty(prop)) {
                    internalizeFunction(prop);
                }
            }

            // Redef query to support pagination
            pagingResource.query = function (params, callback) {
                paramDefaults = params;
                successCallBack = callback;
                internalResource.query(params, successFunction);
                return internalePromise;
            };

            return pagingResource;
        }


        return paginationResourceFactory;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('placeResource', PlaceResource);

    PlaceResource.$inject = ['$paginationResource', '$resource', 'dateHelper'];

    function PlaceResource($paginationResource, $resource, dateHelper) {

        var resource = {
            place: place,
            allPlaces: allPlaces,
            digestActualMonthly: digestActualMonthly,
            digestActualYearly: digestActualYearly,
            digestCalendarizedMonthly: digestCalendarizedMonthly,
            digestCalendarizedYearly: digestCalendarizedYearly,
            digestNormalizedMonthly: digestNormalizedMonthly,
            digestNormalizedYearly: digestNormalizedYearly,
            digestSavingsMonthly: digestSavingsMonthly,
            digestSavingsYearly: digestSavingsYearly,
            digestGhgYearly: digestGhgYearly,
            digestGhgMonthly: digestGhgMonthly,
            digestEnergyUseIntensity: digestEnergyUseIntensity,
            udfs: udfs,
            groups: groups,
            projects: projects,
            placeSize: placeSize
        };

        function place(options) {

            if (angular.isUndefined(options)) {
                options = {};
            }

            if (!options.hasOwnProperty('cancelable')) {
                options.cancelable = true;
            }

            return $resource('api/v3/place/:placeId', { placeId: '@placeId' }, {
                query: { method: 'GET', isArray: true, cache: false, cancelable: false },
                get: { method: 'GET', cancelable: options.cancelable },
                update: {
                    method: 'PUT',
                    transformRequest: mapUpdate
                },
                save: {
                    method: 'POST',
                    transformRequest: mapSave
                }
            });

        }

        function allPlaces(options) {

            if (angular.isUndefined(options)) {
                options = {};
            }

            if (!options.hasOwnProperty('cancelable')) {
                options.cancelable = true;
            }

            return $paginationResource('api/v3/place/:placeId', { placeId: '@placeId' }, {
                query: { method: 'GET', isArray: true, cache: false, cancelable: false },
                get: { method: 'GET', cancelable: options.cancelable }
            });
        }

        function digestActualYearly() {
            return $resource('api/v3/place/:placeId/digest/actual/yearly', { placeId: '@placeId' });
        }

        function digestActualMonthly() {
            return $resource('api/v3/place/:placeId/digest/actual/monthly', { placeId: '@placeId' });
        }

        function digestCalendarizedYearly() {
            return $resource('api/v3/place/:placeId/digest/calendarized/yearly', { placeId: '@placeId' });
        }

        function digestCalendarizedMonthly() {
            return $resource('api/v3/place/:placeId/digest/calendarized/monthly', { placeId: '@placeId' });
        }

        function digestNormalizedYearly() {
            return $resource('api/v3/place/:placeId/digest/normalized/yearly', { placeId: '@placeId' });
        }

        function digestNormalizedMonthly() {
            return $resource('api/v3/place/:placeId/digest/normalized/monthly', { placeId: '@placeId' });
        }

        function digestSavingsYearly() {
            return $resource('api/v3/place/:placeId/digest/savings/yearly', { placeId: '@placeId' });
        }

        function digestSavingsMonthly() {
            return $resource('api/v3/place/:placeId/digest/savings/monthly', { placeId: '@placeId' });
        }

        function digestGhgYearly() {
            return $resource('api/v3/place/:placeId/digest/ghg/yearly', { placeId: '@placeId' });
        }

        function digestGhgMonthly() {
            return $resource('api/v3/place/:placeId/digest/ghg/monthly', { placeId: '@placeId' });
        }

        function digestEnergyUseIntensity() {
            return $resource("api/v3/place/:placeId/digest/energyUseIntensity", { placeId: '@placeId' },
                {
                    query: {
                        method: 'GET', isArray: true, cache: false
                    }
                });
        }

        function udfs() {
            return $resource("api/v3/place/:placeId/udf", { placeId: '@placeId' },
                {
                    query: {
                        method: 'GET', isArray: true, cache: false,
                        transformResponse: mapUdfsResponse
                    },
                    update: {
                        method: 'PUT',
                        transformRequest: mapUpdateUdfs,
                        isArray: true
                    }
                });
        }

        function groups() {
            return $resource("api/v3/place/:placeId/group", { placeId: '@placeId' }, {
                update: {
                    method: 'PUT',
                    isArray: true
                }
            });
        }

        function projects() {
            return $resource("api/v3/place/:placeId/project", { placeId: '@placeId' },
                {
                    query: {
                        method: 'GET', isArray: true, cache: false,
                        transformResponse: mapProjectsResponse
                    }
                });
        }

        function placeSize() {
            return $resource('api/v3/place/:placeId/size/:placeSizeId', { placeId: '@placeId', placeSizeId: '@placeSizeId' }, {
                get: {
                    method: 'GET', isArray: true, cache: false,
                    transformResponse: mapPlaceSizeResponse
                },
                save: {
                    method: 'POST',
                    transformRequest: mapSavePlaceSize
                },
                update: {
                    method: 'PUT',
                    transformRequest: mapSavePlaceSize
                },
                updateList: {
                    method: 'PUT',
                    isArray: true,
                    transformRequest: mapUpdatePlaceSizeList
                },
                remove: { // Using remove here vs delete since some warn that delete being a reserved word may conflict in IE unless using bracket notation
                    method: 'DELETE'
                }
            });
        }

        function mapPlaceSizeResponse(data) {
            var jsonData = angular.fromJson(data);

            jsonData.forEach(function (item) {
                item.value = item.value.toString();
                item.beginDate = item.beginDate ? moment(item.beginDate).format('MM/DD/YYYY') : '';
                item.endDate = item.endDate ? moment(item.endDate).format('MM/DD/YYYY') : '';
            });

            return jsonData;
        }

        function mapUdfsResponse(data) {
            var jsonData = angular.fromJson(data);

            jsonData.forEach(function (json) {
                if (json.dataType.dataTypeId === 6 && json.value) {
                    json.value = moment(json.value).format('MM/DD/YYYY');
                }
            });

            return jsonData;
        }

        function mapProjectsResponse(data) {
            var jsonData = angular.fromJson(data);

            jsonData.forEach(function (jsonDataItem) {

                // when the energysavings unit is null
                if (!jsonDataItem.energySavings.energySavingsUnit.energySavingsUnitCode) {
                    var energySavingsUnitItem = {
                        energySavingsUnitCode: '',
                        energySavingsUnitIf: 0,
                        energySavingsUnitInfo: ''
                    };
                }

                jsonDataItem.fundingSource = jsonDataItem.fundingSource ? jsonDataItem.fundingSource : '';
                jsonDataItem.utilityRebate = jsonDataItem.utilityRebate ? jsonDataItem.utilityRebate : '';
                jsonDataItem.installationBeginDate = jsonDataItem.installationBeginDate ? jsonDataItem.installationBeginDate : '';
                jsonDataItem.installationEndDate = jsonDataItem.installationEndDate ? jsonDataItem.installationEndDate : '';
                jsonDataItem.installationCost = jsonDataItem.installationCost ? jsonDataItem.installationCost : '';
                jsonDataItem.note = jsonDataItem.note ? jsonDataItem.note : '';
                jsonDataItem.costSavings.costSavings = jsonDataItem.costSavings.costSavings ? jsonDataItem.costSavings.costSavings : '';
                jsonDataItem.energySavings.energySavings = jsonDataItem.energySavings.energySavings ? jsonDataItem.energySavings.energySavings : '';
                jsonDataItem.projectManager = jsonDataItem.projectManager ? jsonDataItem.projectManager : '';
                jsonDataItem.energySavings.energySavingsUnit = jsonDataItem.energySavings.energySavingsUnit.energySavingsUnitCode ? jsonDataItem.energySavings.energySavingsUnit : energySavingsUnitItem;
            });

            return jsonData;
        }

        function mapUpdateUdfs(data, headersGetter) {

            var placeUdfs = [];
            angular.forEach(data, function (udf) {

                if (udf.dataType.dataTypeId === 6 && udf.value) {
                    udf.value = dateHelper.pretendUTC(moment(udf.value, "MM/DD/YYYY").toDate());
                }

                placeUdfs.push({
                    udfId: udf.udfId,
                    value: udf.value === '' ? null : udf.value
                });
            });

            return angular.toJson(placeUdfs);
        }

        function mapUpdate(data, headersGetter) {
            var place = {
                placeCode: data.placeCode,
                placeInfo: data.placeInfo,
                parentPlaceId: data.parent ? data.parent.placeId : null,
                placeTypeId: data.placeType ? data.placeType.placeTypeId : null,
                primaryUseId: data.primaryUse && data.primaryUse.primaryUseId ? data.primaryUse.primaryUseId : null,
                buildDate: dateHelper.pretendUTC(moment(data.buildDate, "MM/DD/YYYY").toDate()),
                address: data.address,
                weatherStationCode: data.weatherStation ? data.weatherStation.stationCode : null
            };

            return angular.toJson(place);
        }


        function mapSave(data, headersGetter) {
            var place = {
                placeCode: data.placeCode,
                placeInfo: data.placeInfo,
                parentPlaceId: data.parent ? data.parent.placeId : null,
                placeTypeId: data.placeType ? data.placeType.placeTypeId : null,
                buildDate: dateHelper.pretendUTC(moment(data.buildDate, "MM/DD/YYYY").toDate()),
                primaryUseId: data.primaryUse && data.primaryUse.primaryUseId ? data.primaryUse.primaryUseId : null,
                address: data.address ? data.address : null
            };

            return angular.toJson(place);
        }

        function mapSavePlaceSize(data, headersGetter) {

            // Place some defaults if the user does not enter any as this will be written regardless and nothing is required
            var placeSize = {
                beginDate: data.beginDate ? dateHelper.pretendUTC(moment(data.beginDate, "MM/DD/YYYY").toDate()) : dateHelper.pretendUTC(moment("01/01/2000", "MM/DD/YYYY").toDate()),
                endDate: data.endDate ? dateHelper.pretendUTC(moment(data.endDate, "MM/DD/YYYY").toDate()) : '',
                value: data.value ? data.value : 0,
                unitCode: data.unitCode
            };

            return angular.toJson(placeSize);
        }

        function mapUpdatePlaceSizeList(data, headersGetter) {
            var placeSizeList = [];

            // Place some defaults if the user does not enter any as this will be written regardless and nothing is required
            angular.forEach(data, function (dataItem) {
                var placeSize = {
                    beginDate: dataItem.beginDate ? dateHelper.pretendUTC(moment(dataItem.beginDate, "MM/DD/YYYY").toDate()) : dateHelper.pretendUTC(moment("01/01/2000", "MM/DD/YYYY").toDate()),
                    endDate: dataItem.endDate ? dateHelper.pretendUTC(moment(dataItem.endDate, "MM/DD/YYYY").toDate()) : '',
                    value: dataItem.value ? dataItem.value : 0,
                    unitCode: dataItem.unitCode
                };

                placeSizeList.push(placeSize);
            });

            return angular.toJson(placeSizeList);
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('placeTypeResource', PlaceTypeResource);

    PlaceTypeResource.$inject = ['$resource'];

    function PlaceTypeResource($resource) {
        return $resource("api/v3/place/placeType");
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('postalCodeResource', PostalCodeResource);

    PostalCodeResource.$inject = ['$resource'];

    function PostalCodeResource($resource) {

        var resource = {
            postalCode: postalCode
        };

        function postalCode() {
            return $resource("api/v3/postalCode/:postalCode", { postalCode: '@postalCode' }, {
                get: { method: 'GET' }
            });
        }

    	return resource;
    }

})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('primaryUseResource', PrimaryUseResource);

    PrimaryUseResource.$inject = ['$resource'];

    function PrimaryUseResource($resource) {
    	return $resource("api/v3/primaryUse", {}, {
    	    query: { method: "GET", isArray: true, cache: false },
    	    save: {
    			method: 'POST'
    		}
    	});
    
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('rateResource', RateResource);

    RateResource.$inject = ['$resource'];

    function RateResource($resource) {

        var resource = {
            rate: rate,
            rateUnit: rateUnit,
            digestActualYearly: digestActualYearly
        };

        function rate() {
        	return $resource("api/v3/rate/:rateId?filter=:filter", { rateId: '@rateId', filter: '@filter' },
            {
                query: { method: "GET", isArray: true, cache: false },
                save: { method: 'POST', transformRequest: mapRateRequest },
                update: { method: 'PUT', transformRequest: mapRateUpdateRequest },
                remove: { method: 'DELETE' }
            });
        }

        function rateUnit() {
            return $resource("api/v3/rate/:rateId/unit", { rateId: '@rateId' },
            {
                query: { method: "GET", isArray: false, cache: false }
            });
        }

        function digestActualYearly() {
            return $resource('api/v3/rate/:rateId/digest/actual/yearly', { rateId: '@rateId' });
        }

        function mapRateRequest(data) {
            var rate = {
                name: data.name,
                commodityId: data.commodityId,
                vendorId: data.vendorId,
                note: data.note
            };

            return angular.toJson(rate);
        }

        function mapRateUpdateRequest(data) {
            var rate = {
                name: data.name,
                note: data.note
            };

            return angular.toJson(rate);
        }

        return resource;
    }
})();
﻿(function () {
	'use strict';

	angular
        .module('app')
        .factory('readingResource', ReadingResource);

	ReadingResource.$inject = ['$resource'];

	function ReadingResource($resource) {

		var resource = {
			reading: reading,
			readingDelete: readingDelete
		};

		function reading() {
			return $resource("api/v3/channel/:channelId/reading?beginDate=:beginDate&endDate=:endDate&originalValue=:originalValue", { channelId: '@channelId', beginDate: '@beginDate', endDate: '@endDate', originalValue: '@originalValue' },
            {
            	get: { method: "GET", cache: false }
            });
		}

		function readingDelete() {
			return $resource("api/v3/reading/:observationId", { observationId: 'observationId' },
            {
            	remove: { method: "DELETE", cache: false }
            });
		}

		return resource;
	}
})();
﻿(function () {
    'use strict';


    angular
        .module('app')
        .factory('reportResource', ReportResource);

    ReportResource.$inject = ['$resource', '$paginationResource'];

    function ReportResource($resource, $paginationResource) {

        var resource = {
            report: report,
            reportGroup: reportGroup,
            quickReport: quickReport, 
            installLatest: installLatest
        };

        function report() {
            return $resource("api/v3/report", {},
            {
                query: { method: "GET", isArray: true, cache: false }
            });
        }

        function reportGroup() {
            return $resource("api/v3/report/reportgroup/:reportGroupId", { reportGroupId: '@reportGroupId'},
            {
                query: { method: "GET", isArray: true, cache: false },
                get: { method: 'GET' },
                update: { method: 'PUT' },
                save: { method: 'POST' },
                remove: { method: 'DELETE' }
            });
        }

        function quickReport() {
            return $resource("api/v3/report/quick", {}, 
            {
                post: { 
                    method: "POST",           
                    responseType: "arraybuffer",
                    transformResponse: function(data, headersGetter) { return { data : data, headers: headersGetter() } }                    
                }
            });
        }

        function installLatest() {
            return $resource("api/v3/report/install/latest", {}, 
            {
                post: { 
                    method: "POST",    
                    cancelable: false,       
                    transformResponse: function(data, headersGetter) { return { data : data, headers: headersGetter() } }                    
                }
            });
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('savingsResource', SavingsResource);

    SavingsResource.$inject = ['$resource', '$translate', 'dateHelper'];

    function SavingsResource($resource, $translate, dateHelper) {

        var resource = {
            meterBills: meterBills,
            meterDaily: meterDaily,
            adjustedCostType: adjustedCostType,
            baseLine: baseLine,
            manualAdjustment: manualAdjustment,
            specialAdjustment: specialAdjustment,
            specialAdjustmentMethods: specialAdjustmentMethods,
            specialAdjustmentTypes: specialAdjustmentTypes,
            otherSavings: otherSavings,
            otherSavingsCategory: otherSavingsCategory
        };

        function meterBills() {
            return $resource('api/v3/savings/meter/:meterId/bill', { meterId: '@meterId' }, {
                query: { method: 'GET', isArray: true, cache: false, cancelable: false }
            });
        }

        function meterDaily() {
            return $resource('api/v3/savings/meter/:meterId/bill/:billId/daily', { meterId: '@meterId', billId: '@billId' }, {
                get: { method: 'GET', cancelable: false, transformResponse: mapDailyResponse }
            });
        }

        function adjustedCostType() {
            return $resource('api/v3/savings/adjustedCostType', {}, {
                query: { method: 'GET', isArray: true, cache: false, cancelable: false }
            });
        }

        function baseLine() {
            return $resource('api/v3/savings/meter/:meterId/baseline?save=:save', { meterId: '@meterId', save: '@save' }, {
                query: { method: 'GET', cache: false, cancelable: false, transformResponse: mapBaseLineSaveResponse },
                save: {
                    method: 'POST',
                    transformRequest: mapBaseLineSaveRequest
                }
            });
        }

        function manualAdjustment() {
            return $resource('api/v3/savings/meter/:meterId/bill/:billId/manualadjustment', { meterId: '@meterId', billId: '@billId' }, {
                save: {
                    method: 'POST'
                }
            });
        }

        function specialAdjustment() {
            return $resource('api/v3/savings/meter/:meterId/adjustment/special/:specialAdjustmentId', { meterId: '@meterId', specialAdjustmentId: '@specialAdjustmentId' }, {
                query: { method: 'GET', isArray: true, cache: false, cancelable: false, transformResponse: mapSpecialAdjustmentResponse },
                save: {
                    method: 'POST',
                    transformRequest: mapSpecialAdjustmentSaveRequest
                },
                update: {
                    method: 'PUT',
                    transformRequest: mapSpecialAdjustmentUpdateRequest
                },
                remove: { method: 'DELETE' }
            });
        }

        function specialAdjustmentMethods() {
            return $resource('api/v3/savings/adjustment/special/method', { }, {
                query: { method: 'GET', isArray: true, cache: false, cancelable: false, transformResponse: mapSpecialAdjustmentMethodResponse }
            });
        }

        function specialAdjustmentTypes() {
            return $resource('api/v3/savings/adjustment/special/type', {}, {
                query: { method: 'GET', isArray: true, cache: false, cancelable: false, transformResponse: mapSpecialAdjustmentTypeResponse }
            });
        }

        function otherSavings() {
            return $resource('api/v3/savings/meter/:meterId/adjustment/otherSavings/:otherSavingsId', { meterId: '@meterId', otherSavingsId: '@otherSavingsId' }, {
                query: { method: 'GET', isArray: true, cache: false, cancelable: false },
                get: { method: 'GET', transformResponse: mapOtherSavingsGetResponse },
                save: {
                    method: 'POST',
                    transformRequest: mapOtherSavingsSaveRequest
                },
                update: {
                    method: 'PUT',
                    transformRequest: mapOtherSavingsUpdateRequest
                },
                remove: { method: 'DELETE' }
            });
        }

        function otherSavingsCategory() {
            return $resource('api/v3/savings/adjustment/othersavings/category', {}, {
                query: { method: 'GET', isArray: true, cache: false, cancelable: false, transformResponse: mapOtherSavingsCategoryResponse },
                save: { method: 'POST' }
            });
        }

        function mapBaseLineSaveResponse(data) {
            var jsonData = angular.fromJson(data);

            var baseLineProcessor = jsonData;
            baseLineProcessor.baselineStartDate = jsonData.baselineStartDate ? moment(jsonData.baselineStartDate).format('MM/DD/YYYY') : '';
            baseLineProcessor.savingsStartDate = jsonData.savingsStartDate ? moment(jsonData.savingsStartDate).format('MM/DD/YYYY') : '';

            return baseLineProcessor;
        }

        function mapBaseLineSaveRequest(data, headersGetter) {
            var baseline = {
                includeInCAP: data.includeInCAP,
                adjustArea: data.adjustArea,
                adjustedCostTypeId: data.adjustedCostType ? data.adjustedCostType.adjustedCostTypeId : null,
                adjustSummer: data.adjustSummer,
                adjustWinter: data.adjustWinter,
                baselineMonths: data.baselineMonths,
                baselineStartDate: dateHelper.pretendUTC(moment(data.baselineStartDate, "MM/DD/YYYY").toDate()),
                savingsStartDate: dateHelper.pretendUTC(moment(data.savingsStartDate, "MM/DD/YYYY").toDate()),
                coolingTemp: data.coolingTemp,
                heatingTemp: data.heatingTemp,
                extendedWeatherStartDate: dateHelper.pretendUTC(moment(data.baselineStartDate, "MM/DD/YYYY").subtract(data.yearsOfData, 'years').toDate()),
                useExtendedWeather: data.yearsOfData == 0 ? false : true,
                baselineBills: []
            };

            angular.forEach(data.baselineBills, function(bill) {
                baseline.baselineBills.push({
                    billId: bill.billId,
                    isExcluded: bill.isExcluded
                });
            });

            return angular.toJson(baseline);
        }

        function mapOtherSavingsUpdateRequest(data) {
            // pre-defined array of all the possible frequency types for other savings
            var otherSavingsTypeArray = ["one-time", "continuous", "recurring"];

            var otherSavings = {
                description: data.description,
                otherSavingsCategoryId: data.otherSavingsCategoryId,
                frequency: otherSavingsTypeArray[data.frequencyTypeId],
                // Forcing english as the date locale since our control doesn't support other languages
                startPeriod: moment(data.startDate, "MMM YYYY", "en").format('YYYYMM'),
                endPeriod: data.endDate === null ? '' : moment(data.endDate, "MMM YYYY", "en").format('YYYYMM'),
                annualCycleStartMonth: data.fromMonth + 1,
                annualCycleEndMonth: data.toMonth + 1,
                value: data.amount
            };

            return angular.toJson(otherSavings);
        }

        function mapOtherSavingsCategoryResponse(data) {
            var jsonData = angular.fromJson(data);
            angular.forEach(jsonData, function (category) {
                category.otherSavingsCategoryInfo = $translate.instant(category.otherSavingsCategoryInfo);
            });            

            return jsonData;
        }

        // map the response data of GET Other response by Id to map the controller properties
        function mapOtherSavingsGetResponse(data) {
            var jsonData = angular.fromJson(data);

            // pre-defined array of all the possible frequency types for other savings
            var otherSavingsTypeArray = ["one-time", "continuous", "recurring"];

            var otherSavings = {
                description: jsonData.description,
                otherSavingsCategoryId: jsonData.otherSavingsCategory.otherSavingsCategoryId,
                frequencyTypeId: otherSavingsTypeArray.indexOf(jsonData.frequency.toLowerCase()).toString(),
                // Forcing english as the date locale since our control doesn't support other languages
                startDate: moment(jsonData.startPeriod, "YYYYMM").lang("en").format('MMM YYYY'),
                endDate: moment(jsonData.endPeriod, "YYYYMM").lang("en").format('MMM YYYY'),
                fromMonth: jsonData.annnualCycleStartMonth - 1,
                toMonth: jsonData.annualCycleEndMonth - 1,
                amount: jsonData.value,
                costUnit: jsonData.costUnit
            };

            return otherSavings;
        }


        function mapOtherSavingsSaveRequest(data, headersGetter) {
            // pre-defined array of all the possible frequency types for other savings
            var otherSavingsTypeArray = ["one-time", "continuous", "recurring"];

            var otherSavings = {
                description: data.description,
                otherSavingsCategoryId: data.otherSavingsCategoryId,
                frequency: otherSavingsTypeArray[data.frequencyTypeId],
                // Forcing english as the date locale since our control doesn't support other languages
                startPeriod: moment(data.startDate, "MMM YYYY", "en").format('YYYYMM'),
                endPeriod: data.endDate === null ? '' : moment(data.endDate, "MMM YYYY", "en").format('YYYYMM'),
                annualCycleStartMonth: data.fromMonth + 1,
                annualCycleEndMonth: data.toMonth + 1,
                value: data.amount
            };

            return angular.toJson(otherSavings);
        }

        function mapSpecialAdjustmentSaveRequest(data, headersGetter) {
            var frequencyTypeId = data.frequency.toLowerCase() == "continuous" ? 0 : 1;

            var specialAdjustment = {
                specialAdjustmentMethodId: data.specialAdjustmentMethodId,
                comments: data.comments,
                value: data.value ? parseFloat(data.value) : 0,
                specialAdjustmentTypeId: data.specialAdjustmentTypeId,
                frequency: data.frequency,
                startDate: dateHelper.pretendUTC(moment(data.startDate, "MM/DD/YYYY").toDate()),
                endDate: dateHelper.pretendUTC(moment(data.endDate, "MM/DD/YYYY").toDate()),
                annualCycleStartMMDD: frequencyTypeId === 1 ? ((parseInt(data.fromMonth) + 1) * 100) + parseInt(data.fromDay) : 0, //Need to add 1 to the months because js months are 0 based
                annualCycleEndMMDD: frequencyTypeId === 1 ? ((parseInt(data.toMonth) + 1) * 100) + parseInt(data.toDay) : 0
            };

            return angular.toJson(specialAdjustment);
        }

        function mapSpecialAdjustmentUpdateRequest(data, headersGetter) {
            var frequencyTypeId = data.frequency.frequency.toLowerCase() == "continuous" ? 0 : 1;

            var specialAdjustment = {
                specialAdjustmentMethodId: data.specialAdjustmentMethod.specialAdjustmentMethodId,
                comments: data.comments,
                value: data.value ? parseFloat(data.value) : 0,
                specialAdjustmentTypeId: data.specialAdjustmentType.specialAdjustmentTypeId,
                startDate: dateHelper.pretendUTC(moment(data.frequency.startDate, "MM/DD/YYYY").toDate()),
                endDate: dateHelper.pretendUTC(moment(data.frequency.endDate, "MM/DD/YYYY").toDate()),
                annualCycleStartMMDD: frequencyTypeId === 1 ? ((parseInt(data.fromMonth) + 1) * 100) + parseInt(data.fromDay) : 0, //Need to add 1 to the months because js months are 0 based
                annualCycleEndMMDD: frequencyTypeId === 1 ? ((parseInt(data.toMonth) + 1) * 100) + parseInt(data.toDay) : 0
            };

            return angular.toJson(specialAdjustment);
        }

        function mapSpecialAdjustmentResponse(data) {
            var jsonData = angular.fromJson(data);

            angular.forEach(jsonData, function (adj) {
                adj.specialAdjustmentMethod.label = $translate.instant(adj.specialAdjustmentMethod.label);
                adj.specialAdjustmentType.specialAdjustmentTypeInfo = $translate.instant(adj.specialAdjustmentType.specialAdjustmentTypeInfo);
                adj.frequency.frequency = $translate.instant(adj.frequency.frequency);
            });

            return jsonData;
        }
     
        function mapSpecialAdjustmentTypeResponse(data) {
            var jsonData = angular.fromJson(data);

            angular.forEach(jsonData, function (type) {
                type.specialAdjustmentTypeInfo = $translate.instant(type.specialAdjustmentTypeInfo);
            });

            return jsonData;
        }
                 
        function mapSpecialAdjustmentMethodResponse(data) {
            var jsonData = angular.fromJson(data);

            angular.forEach(jsonData, function (method) {
                method.label = $translate.instant(method.label);
            });

            return jsonData;
        }

        function mapDailyResponse(data) {
            var jsonData = angular.fromJson(data);

            angular.forEach(jsonData.daily, function (daily) {
                angular.forEach(daily.messages, function (message) {
                    message.message = $translate.instant(message.message);
                    message.messageType = $translate.instant(message.messageType);
                });                
            });

            return jsonData;
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('searchResource', SearchResource);

    SearchResource.$inject = ['$resource', '$q'];

    function SearchResource($resource, $q) {

        var resource = {
            search: search
        };

        function search(options) {

            if (angular.isUndefined(options)) {
                options = {};
            }

            if (!options.hasOwnProperty('cancelable')) {
                options.cancelable = true;
            }

            return $resource("api/v3/search?query=:query&limit=:limit", { query: '@query', limit: '@limit' },
                {
                    query: { method: "GET", isArray: true, cache: false },
                    get: { method: "GET", cancelable: options.cancelable }
                });
        }


        return resource;
    }

})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('setupSheetResource', SetupSheetResource);

    SetupSheetResource.$inject = ['$resource', 'mapResponseContentHelper'];

    function SetupSheetResource($resource, mapResponseContentHelper) {

        var resource = {
            setupSheet: setupSheet,
            filter: filter,
            url: 'api/v3/setup'
        };


        function setupSheet() {
            return $resource(resource.url, {},
            {
                query: {
                    method: "GET",
                    headers: { accept: 'application/json' },
                    cache: false,
                    responseType: 'arraybuffer',
                    transformResponse: mapResponseContentHelper.mapExcelResponse
                    
                },
                save: {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/vnd.ms-excel' }
                }
            });
        }

        function filter() {
            return $resource('api/v3/setup/filter', {}, {
                query: { method: 'GET', isArray: true }
            });
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('taskResource', TaskResource);

    TaskResource.$inject = ['$resource'];

    function TaskResource($resource) {

        var resource = {
            tasks: tasks
        };


        function tasks() {
            return $resource("api/v3/task", {},
            {
                get: {
                    method: 'GET', isArray: true, cache: false
                }
            });
        }

        return resource;
    }
})();
﻿(function () {
	'use strict';

	angular
        .module('app')
        .factory('templateResource', TemplateResource);

	TemplateResource.$inject = ['$paginationResource', '$resource'];

	function TemplateResource($paginationResource, $resource) {

		var resource = {
		    template: template,
		    templateLines: templateLines
		};

		function templateLines() {
		        return $resource('api/v3/template/:templateId/version/:versionId', { templateId: '@templateId', versionId: '@versionId' }, {
		            query: { method: 'GET', isArray: true, cache: false, cancelable: false }
		        });
		}

		// uses the new pagination resource which takes care of retrieving multiple pages if available
		function template() {

		    return $paginationResource("api/v3/template/:templateId?filter=:filter&pageNumber=:pageNumber", 
                { 
                    templateId: '@templateId',
                    filter: '@filter'
                },
                {
                    query: { method: "GET", isArray: true, cache: false },
                    save: { method: 'POST' }
                });

		}

		return resource;
	}
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('timezoneResource', TimezoneResource);

    TimezoneResource.$inject = ['$resource', '$translate'];

    function TimezoneResource($resource, $translate) {

        var resource = {
            timezone: timezone
        };

        function timezone() {
            return $resource("api/v3/timezone", {},
            {
                query: {
                    method: "GET",
                    isArray: true,
                    cache: false,
                    transformResponse: function (data) {
                        var response = angular.fromJson(data);

                        angular.forEach(response, function (time) {
                            time.timeZoneDisplay = $translate.instant(time.timeZoneInfo);
                        });

                        return _.orderBy(response, ['gmtOffset', 'timeZoneDisplay']);
                    }
                }
            });
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('udfResource', UdfResource);

    UdfResource.$inject = ['$resource'];

    function UdfResource($resource) {

        var resource = {
            udf: udf,
            udflist: udflist
        };

        function udf() {
        	return $resource("api/v3/udf?filter=:filter", { filter: '@filter' },
            {
                query: {
                    method: "GET", isArray: true, cache: false
                }
            });
        }

        function udflist() {
            return $resource("api/v3/udf/list/:udftype", { udftype: '@udftype' },
            {
                save: {
                    method: "PUT",
                    isArray: true,
                    transformRequest: mapUpdateUdfs
                }
            });
        }

        function mapUpdateUdfs(data) {

            var udflist = [];
            
            angular.forEach(data, function (udf) {
                var udfselects = [];
                angular.forEach(udf.valuesList, function (selectVal) {
                    udfselects.push({ udfSelectValueId: selectVal.udfSelectValueId, value: selectVal.listvalue });
                });
                udflist.push({
                    udfId: udf.udfId,
                    name: udf.name,
                    dataTypeId: udf.dataType.dataTypeId,
                    udfSelectValues: udfselects
                });
            });

            return angular.toJson(udflist);
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('unitResource', UnitResource);

    UnitResource.$inject = ['$resource'];

    function UnitResource($resource) {

        var resource = {
            unit: unit
        };

        function unit() {
            return $resource("api/v3/unit?filter=:filter", { filter: '@filter' },
            {
                query: { method: "GET", isArray: true, cache: false }
            });
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('vendorResource', VendorResource);

    VendorResource.$inject = ['$resource', '$paginationResource', 'dateHelper'];

    function VendorResource($resource, $paginationResource, dateHelper) {

        var resource = {
            vendor: vendor,
            allVendors: allVendors,
            digestActualYearly: digestActualYearly,
            udfs: udfs,
            contracts: contracts,
            assignAccounts : assignAccounts
        };
         
        function vendor() {
            return $resource('api/v3/vendor/:vendorId', { vendorId: '@vendorId' },
            {
                query: { method: 'GET', isArray: true, cache: false },
                get: { method: 'GET' },
                save: { method: 'POST' },
                update: {
                    method: 'PUT'
                },
                remove: { // Using remove here vs delete since some warn that delete being a reserved word may conflict in IE unless using bracket notation
                    method: 'DELETE'
                }
            });
        }

        function allVendors(options) {

            if (angular.isUndefined(options)) {
                options = {};
            }

            if (!options.hasOwnProperty('cancelable')) {
                options.cancelable = true;
            }

            return $paginationResource('api/v3/vendor/:vendorId', { vendorId: '@vendorId' }, {
                query: { method: 'GET', isArray: true, cache: false, cancelable: false },
                get: { method: 'GET', cancelable: options.cancelable }
            });
        }

        function digestActualYearly() {
            return $resource('api/v3/vendor/:vendorId/digest/actual/yearly', { vendorId: '@vendorId' });
        }

        function udfs() {
            return $resource("api/v3/vendor/:vendorId/udf", { vendorId: '@vendorId' },
				{
				    query: {
				        method: 'GET', isArray: true, cache: false,
				        transformResponse: mapUdfsResponse
				    },
				    update: {
				        method: 'PUT',
				        transformRequest: mapUpdateUdfs,
				        isArray: true
				    }
				});
        }

        function contracts() {
            return $resource("api/v3/vendor/:vendorId/contract", { vendorId: '@vendorId' },
				{
				    query: { method: 'GET', isArray: true, cache: false }
				});
        }

        function assignAccounts() {
            return $resource("api/v3/vendor/:vendorId/account", { vendorId: '@vendorId' },
                {
                    update: {
                        method: 'PUT',                        
                        isArray: true
                    }
                });
        }

        function mapUdfsResponse(data) {
            var jsonData = angular.fromJson(data);

            jsonData.forEach(function (json) {
                if (json.dataType.dataTypeId === 6 && json.value) {
                    json.value = moment(json.value).format('MM/DD/YYYY');
                }
            });

            return jsonData;
        }

        function mapUpdateUdfs(data, headersGetter) {

            var vendorUdfs = [];
            angular.forEach(data, function (udf) {

                if (udf.dataType.dataTypeId === 6 && udf.value) {
                    udf.value = dateHelper.pretendUTC(moment(udf.value, "MM/DD/YYYY").toDate());
                }

                vendorUdfs.push({
                    udfId: udf.udfId,
                    value: udf.value === '' ? null : udf.value
                });
            });

            return angular.toJson(vendorUdfs);
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('workflowResource', workflowResource);

    workflowResource.$inject = ['$resource'];

    function workflowResource($resource) {

        var resource = {
            workflowBatch: workflowBatch,
            workflowExport: workflowExport,
            workflowApproval: workflowApproval,
            workflowChargeback: workflowChargeback
        };

        function workflowBatch(options) {
            if (angular.isUndefined(options)) {
                options = {};
            }

            if (!options.hasOwnProperty('cancelable')) {
                options.cancelable = true;
            }

            return $resource("api/v3/workflow/batch", {}, {
                get: { method: 'GET', cancelable: options.cancelable }
            });
        }

        function workflowExport(options) {
            if (angular.isUndefined(options)) {
                options = {};
            }

            if (!options.hasOwnProperty('cancelable')) {
                options.cancelable = true;
            }

            return $resource("api/v3/workflow/export?exportMode=:exportMode", { exportMode: '@exportMode' }, {
                get: { method: 'GET', cancelable: options.cancelable }
            });
        }

        function workflowApproval(options) {
            if (angular.isUndefined(options)) {
                options = {};
            }

            if (!options.hasOwnProperty('cancelable')) {
                options.cancelable = true;
            }

            return $resource("api/v3/workflow/approval", {}, {
                get: { method: 'GET', cancelable: options.cancelable }
            });
        }

        function workflowChargeback(options) {
            if (angular.isUndefined(options)) {
                options = {};
            }

            if (!options.hasOwnProperty('cancelable')) {
                options.cancelable = true;
            }

            return $resource('api/v3/workflow/chargeback', {}, {
                get: { method: 'GET', cancelable: options.cancelable}
            })
        }

        return resource;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('amChartHelper', AmChartHelper);

   AmChartHelper.$inject = ['colorHelper'];

    /**
     * Returns the EcTheme used for AmChart defaults
     * @constructor
     */
   function AmChartHelper(colorHelper) {

        var service = {
            getEcTheme: getEcTheme
        };

        return service;
        
        /**
        * Gets the EnergyCAP theme for AmCharts
        * @returns {object}
        */
        function getEcTheme() {
            return {
                // settings.scss for borders, colors, etc
                themeName: "ecTheme",

                AmChart: {
                    color: colorHelper.GENERAL_COLORS.BLACK,
                    backgroundColor: colorHelper.GENERAL_COLORS.WHITE,
                    fontFamily: "Roboto",
                    autoMarginOffset: 0,
                    sequencedAnimation: false
                },

                AmBalloon: {
                    color: colorHelper.AMCHART_ELEMENTS.BALLOON_TEXT_COLOR,
                    fontSize: 13,
                    fillAlpha: 1,
                    animationDuration: 0,
                    fadeOutDuration: .15
                },

                AmCoordinateChart: {

                },

                AmStockChart: {

                },

                AmSlicedChart: {

                },

                AmPieChart: {
                    colors: colorHelper.getPrimaryChartColors(),
                    outlineAlpha: 1,
                    outlineThickness: 0,
                    labelTickColor: colorHelper.GENERAL_COLORS.BLACK,
                    labelTickAlpha: 0.3,
                    pullOutDuration: 0,
                    startDuration: 0,
                    labelText: "",
                    labelRadius: 0,
                    labelsEnabled: false,
                    pullOutRadius: 10,
                    autoMargins: true,
                    marginBottom: 0,
                    marginLeft: 0,
                    marginTop: 0,
                    marginRight: 0,
                    percentPrecision: 1,
                    groupPercent: 1
                },

                AmSerialChart: {
                    colors: colorHelper.getPrimaryChartColors(),
                    columnWidth: 0.5
                },

                AmRectangularChart: {
                    zoomOutButtonColor: colorHelper.GENERAL_COLORS.BLACK,
                    zoomOutButtonRollOverAlpha: 0.15,
                    zoomOutButtonImage: "lens"
                },

                AxisBase: {
                    axisColor: colorHelper.AMCHART_ELEMENTS.AXIS_COLOR,
                    axisAlpha: 1,
                    gridAlpha: 0.1,
                    gridColor: colorHelper.GENERAL_COLORS.BLACK,
                    axisThickness: 1
                },

                // Scroll bar for Eui, Interval chart, etc
                ChartScrollbar: {
                    backgroundColor: colorHelper.GENERAL_COLORS.BLACK,
                    backgroundAlpha: 0.12,
                    graphFillAlpha: 0.5,
                    graphLineAlpha: 0,
                    selectedBackgroundColor: colorHelper.GENERAL_COLORS.WHITE,
                    selectedBackgroundAlpha: 0.4,
                    gridAlpha: 0.15
                },

                ChartCursor: {
                    cursorColor: colorHelper.GENERAL_COLORS.BLACK,
                    color: colorHelper.GENERAL_COLORS.WHITE,
                    cursorAlpha: 0.5
                },

                AmLegend: {
                    color: colorHelper.GENERAL_COLORS.BLACK,
                    markerType: "square",
                    markerSize: 12
                },

                AmGraph: {
                    bulletSize: 4,
                    fillAlphas: 1,
                    lineAlpha: 1
                },

                CategoryAxis: {
                    autoWrap: true,
                    autoRotateCount: 13,
                    autoRotateAngle: 25,
                    gridPosition: "start",
                    gridAlpha: 0
                },

                GaugeAxis: {
                    tickColor: colorHelper.GENERAL_COLORS.BLACK,
                    tickAlpha: 1,
                    tickLength: 15,
                    minorTickLength: 8,
                    axisThickness: 3,
                    axisColor: colorHelper.GENERAL_COLORS.BLACK,
                    axisAlpha: 1,
                    bandAlpha: 0.8
                },

                TrendLine: {
                    lineAlpha: 0.8
                },

                ValueAxis: {
                    gridAlpha: 0,
                    title: ""
                },

                Guide: {
                    lineAlpha: 1,
                    lineThickness: 2
                }

            };
        }
    }
})();
﻿(function () {
    'use strict';

    angular
		.module('app')
		.directive('amchartTwoWaySource', AmChart);

    AmChart.$inject = ['chartContext', 'apiResource', '$timeout', 'urlService', 'glazeService', '$translate', 'amChartsService'];

    function AmChart(chartContext, apiResource, $timeout, urlService, glazeService, $translate, amChartsService) {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                source: '=',
                legendid: '@'
            },
            templateUrl: "assets/templates/chart/amChart.html",
            link: function (scope, element, attrs) {
                // The element is not replaced, therefore we need to add 
                // some classes for styling
                element.addClass('d-block ec-chart-split');

                var reloadChart = true;
                //hold the chartObj, so we can clear it when we switch monthly to cumulative
                var chartObj = null;
                scope.isLoading = true;               

                scope.addWidget = function () {
                    var widget = {
                        'chartType': 'amchart',
                        'url': scope.source
                    };
                    apiResource.dashboard().dashboard().addWidget(widget);
                };

                function load() {
                    //clear the old chart object
                    if (chartObj !== null)
                    {
                        chartObj.clear();
                    }

                    // Show the spinner, it'll be shown if this chart is being loaded for the first time,
                    // but it may have been hidden if we're just refreshing the charts url
                    scope.isLoading = true;

                    var catalog = chartContext.catalog(scope.source);
                    var amchartElement = angular.element(element).find(".ec-chart")[0];

                    scope.viewDetails = function () {
                        glazeService.openGlaze(0, 'magnify-chart', scope.title, scope.source);
                    };                                     

                    if (catalog) {
                        scope.title = catalog.title;
                        chartContext.provider(catalog, scope.source).then(function (resolvedArgs) {
                            var eventHandlers = resolvedArgs.eventHandlers;
                            var result = {};

                            if (resolvedArgs.result) {
                                result = resolvedArgs.result;
                            } else {
                                result = resolvedArgs;
                            }

                            if (result.titles && result.titles.length) {
                                scope.title = result.titles[0].text;
                                result.titles = [];
                            }                           

                            if (result.dataProvider.length === 0) {
                                //scope.hasData = false;
                                // Show an overlay message if there is no data.
                                scope.message = 'No data is available';
                            }
                            else {                         
                                var chart = amChartsService.makeChart(amchartElement, result);
                                var eventParams = {};

                                if (eventHandlers && eventHandlers.clickGraphItem) {
                                    chart.addListener("clickGraphItem", eventHandlers.clickGraphItem);
                                }
                                

                                if (chart.legend) {
                                    chart.legend.addListener('hideItem', function (e) {
                                        reloadChart = false;

                                        if (eventHandlers && eventHandlers.hideLegend) {
                                            eventParams.source = scope.source;                                            
                                            eventHandlers.hideLegend(e, eventParams);
                                            scope.source = eventParams.source;
                                        }
                                    });

                                    chart.legend.addListener('showItem', function (e) {
                                        reloadChart = false;

                                        // if provider has custom event handler- call it!
                                        if (eventHandlers && eventHandlers.showLegend) {
                                            eventParams.source = scope.source;
                                            eventHandlers.showLegend(e, eventParams);
                                            scope.source = eventParams.source;
                                        }
                                    });
                                }
                                chartObj = chart;
                            }
                            scope.isLoading = false;
                        });
                    }
                }

                var sourceWatcher = scope.$watch('source', function (newValue, oldValue) {

                    if (newValue && reloadChart) {
                        load();
                    }
                    reloadChart = true; // reset

                }, true);

                scope.$on('$destroy', function () {
                    sourceWatcher();
                });

            }
        };
    }

})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('chartHelper', ChartHelper);

    ChartHelper.$inject = ['$filter', '$translate', 'translationHelper', 'colorHelper'];

    /**
     * Provides utility functions related to charting
     * @constructor
     */
    function ChartHelper($filter, $translate, translationHelper, colorHelper) {

        var chartPieces = {
            DEFAULT_BULLET_SIZE: 5,
            DEFAULT_BULLET_TYPE: "round",
            CURRENT_VALUE_BULLET_SIZE: 7,
            PER_UNIT_DECIMAL_PLACES: 3,
            USE_DECIMAL_PLACES: 2,
            COST_DECIMAL_PLACES: 2,
            API_PROPERTIES: {
                // Constant chart display types with their digest value to pull data from
                USE: "commonUse",
                SAVINGS_USE: "savingsCommonUse",
                NATIVE_USE: "nativeUse",
                SAVINGS_NATIVE_USE: "savingsNativeUse",
                ALL_TIME_USE: "allTimeCommonUse",
                ALL_TIME_BATCC_USE: "allTimeBATCCCommonUse",
                ALL_TIME_SAVINGS_USE: "allTimeSavingsCommonUse",

                COST: "totalCost",
                SAVINGS_COST: "savingsTotalCost",
                ALL_TIME_COST: "allTimeTotalCost",
                ALL_TIME_BATCC_COST: "allTimeBATCCTotalCost",
                ALL_TIME_SAVINGS_COST: "allTimeSavingsTotalCost",

                UNIT_COST: "commonUseUnitCost",
                NATIVE_UNIT_COST: "nativeUseUnitCost",

                DEMAND: "commonDemand",

                TARGET_COMPARISON_COST: "totalCost",
                TARGET_COMPARISON_COST_YTD: "totalCostYtd",

                TARGET_COMPARISON_USE: "globalUse",
                TARGET_COMPARISON_USE_YTD: "globalUseYtd"
            },
            numberFormat: numberFormat,
            currencyFormat: currencyFormat,
            dateFormat: dateFormat,
            valueAxisTitleFormat: valueAxisTitleFormat,
            isMillion: isMillion,
            isMillionDivision: isMillionDivision,
            millionFormat: millionFormat,
            map: map,
            sumOfDecimals: sumOfDecimals,
            sortData: sortData,
            rollifyData: rollifyData,
            rollifyAccountingData: rollifyAccountingData,
            rollifyData2MonthsBack: rollifyData2MonthsBack,
            translateCategoryNames: translateCategoryNames,
            getAxisBaseValue: getAxisBaseValue,
            getCalendarMonth: getCalendarMonth,
            tokenizeUrl: tokenizeUrl,
            sumGrandchildren: sumGrandchildren,
            getArrowChartData: getArrowChartData,
            getSavingsArrowChartData: getSavingsArrowChartData,
            formatUseHeader: formatUseHeader,
            formatUnitCostHeader: formatUnitCostHeader,
            formatUnitCostAxis: formatUnitCostAxis,
            savingsStatus: savingsStatus,
            getAmChartDefaults: getAmChartDefaults,
            getCurrentYearVsPriorYearSerialChartDefaults: getCurrentYearVsPriorYearSerialChartDefaults,
            getSummarySerialChartDefaults: getSummarySerialChartDefaults,
            hasRequiredUnits: hasRequiredUnits,
            getDisplayItems: getDisplayItems,
            getCostAndUseSummarySerialChartDefaults: getCostAndUseSummarySerialChartDefaults,
            getTwelveMonthCommodityPieChartDefaults: getTwelveMonthCommodityPieChartDefaults,
            getCostAvoidanceByCommoditySerialChartDefaults: getCostAvoidanceByCommoditySerialChartDefaults,
            getArrowChartDefaults: getArrowChartDefaults,
            getStockChartDefaults: getStockChartDefaults,
            getSparklineChartDefaults: getSparklineChartDefaults,
            getThermometerChartDefaults: getThermometerChartDefaults,
            translateMonthYear: translateMonthYear,
            getCurrentYearVsPriorYearSerialLineChartDefaults: getCurrentYearVsPriorYearSerialLineChartDefaults,
            getPercentDifference: getPercentDifference
        };

        /* is over 1,000,000 or under 1,000,000
        * @returns {bool}
        */
        function isMillion(data, property) {
            return _.some(data, function (value) {
                return value[property] >= 1000000 || value[property] <= -1000000;
            });
        }

        /**
         * Returns truthy if {numeratorProperty}/{denominatorProperty} in {data}
         * is over 1,000,000 or under 1,000,000
         * @returns {bool}
         */
        function isMillionDivision(data, numeratorProperty, denominatorProperty) {
            return _.some(data, function (value) {
                var divisionResult = value[numeratorProperty] / value[denominatorProperty];
                return divisionResult >= 1000000 || divisionResult <= -1000000;
            });
        }

        /**
         * Returns the sum of the total cost properties for an array
         * @returns {number}
         */
        function sumOfDecimals(data, property, startPeriod, endPeriod) {
            startPeriod = typeof startPeriod !== 'undefined' ? parseInt(startPeriod) : Number.MIN_VALUE;
            endPeriod = typeof endPeriod !== 'undefined' ? parseInt(endPeriod) : Number.MAX_VALUE;

            var sum = 0;
            angular.forEach(data, function (result) {

                if (result.calendarPeriod && result.calendarYear) {
                    var period = result.calendarYear * 100 + result.calendarPeriod;
                    if (period >= startPeriod && period <= endPeriod) {
                        sum += parseFloat(result[property]);
                    }
                }
                else {
                    sum += parseFloat(result[property]);
                }
            });
            return sum;
        }

        /**
         * Projects {data} onto {func} setting
         * the color property
         */
        function map(data, func) {
            var cnt = 0;

            angular.forEach(data, function (item) {
                item.color = colorHelper.getPrimaryChartColors(cnt);

                // Current year we want to say YTD
                if (item.year === (new Date().getFullYear())) {
                    item.year = yearFormat(item.year);
                }

                func(item);
                cnt++;
            });
        }

        function tokenizeUrl(source) {
            var splitSource = source.split("/");
            var endOfUrl = splitSource[splitSource.length - 1].split('?');

            var options = {
                id: endOfUrl[0],
                baseUrl: source.split('?')[0]
            };

            //Add query parameters to options
            if (endOfUrl.length > 1) {
                endOfUrl[1].split("&").forEach(function (part) {
                    var item = part.split("=");
                    options[item[0]] = decodeURIComponent(item[1]);
                });
            }

            return options;
        }

        function yearFormat(value) {
            return value + "YTD";
        }

        function numberFormat(value, precision) {
            return $filter('number')(value, precision);
        }

        function currencyFormat(value, currencySymbol, precision) {
            if (typeof (value) !== "undefined" && value !== null && value !== "") {
                return $filter('currency')(value, currencySymbol + ' ', precision)
            } else {
                return '';
            }
        }

        function dateFormat(value) {
            return value.format('M/D/YYYY');
        }

        function millionFormat(value, isMillion) {
            return isMillion ? value / 1000000 : value;
        }

        function valueAxisTitleFormat(unit, isMillion) {
            return isMillion ? unit + " x 1,000,000" : unit;
        }

        function getAxisBaseValue(value, currentAxisBaseValue, isMillion) {
            value = millionFormat(value, isMillion);
            return value < currentAxisBaseValue ? value : currentAxisBaseValue;
        }

        function getCalendarMonth(period) {
            return moment(period, "MM").format('MMM');
        }

        /// Given a string such as "December 2017", translate it. Note that it is English going into this function but may be converted to another language coming out.
        function translateMonthYear(monthYearString) {                               
            var localLocale = moment(monthYearString, "MMMM YYYY", "en");
            localLocale.locale(moment.locale());
            var monthYearTranslated = localLocale.format("MMMM YYYY");  
            return monthYearTranslated;
        }

        function sortData(data, dataField, reverse) {
            if (typeof reverse === 'undefined') {
                reverse = false;
            }
            return $filter('orderBy')(data, dataField, reverse);
        }

        function getPercentDifference(value1, value2) {            
            if(isNaN(value1) || isNaN(value2)) {
                // throw "value1 and value2 must be numbers";
                return null;
            }
            if(!value2 || !value1){
                // throw "value1 and value2 cannot be null"
                return null;
            }
            if(value1 == 0){
                // avoid divide by zero
                return null;
            }            

            return (value2 - value1)/value1*100;
        }

        // re-arrange data in a rolling 12 months chart
        function rollifyData(monthlyDataHash, today) {

            var chartData = [];
            for (var i = 0; i < 12; i++) {
                var month = moment(today).subtract(11 - i, 'months').format("MMM");

                // show empty column when there is no data for that month
                if (typeof monthlyDataHash[month] === 'undefined') {
                    monthlyDataHash[month] = {};
                    monthlyDataHash[month].year = month;
                }

                chartData.push(monthlyDataHash[month]);
            }

            return chartData;
        }

        /**
        * Re-arrange {monthlyDataHash} in a new array and return it. The rules for the new array are - number of elements will be  {numberOfPeriods}.
        * Data for {currentAccPeriod} should be the last element in the array.
        * Instead of using month names from regular calendar, use the name of period from {accountPeriods}
        * @param {array} monthlyDataHash source array that needs to be rearranged
        * @param  {number} numberOfPeriods how many accounting periods - should be one of 12 or 13
        * @param {array} accountPeriods user-defined accounting periods
        * @param {number} currentAccPeriod current accounting period - should be >=1 and <= {numberOfPeriods}
        * @returns {array}
        **/
        function rollifyAccountingData(monthlyDataHash, numberOfPeriods, accountPeriods, currentAccPeriod) {
            var chartData = [];

            for (var i = 0; i < numberOfPeriods; i++) {
                var monDataIndex = i + currentAccPeriod;
                if (monDataIndex >= numberOfPeriods) {
                    monDataIndex = monDataIndex - numberOfPeriods;
                }

                var month = accountPeriods[monDataIndex].name;


                // show empty column when there is no data for that month
                if (typeof monthlyDataHash[month] === 'undefined') {
                    monthlyDataHash[month] = {};
                    monthlyDataHash[month].year = month;
                }

                chartData.push(monthlyDataHash[month]);
            }
            return chartData;

        }  



        // re-arrange data in a rolling 12 months chart where 2 months prior is the last month
        function rollifyData2MonthsBack(monthlyDataHash, today) {

            var chartData = [];
            for (var i = 0; i < 12; i++) {
                var month = moment(today).subtract(13 - i, 'months').format("MMM");

                // show empty column when there is no data for that month
                if (typeof monthlyDataHash[month] === 'undefined') {
                    monthlyDataHash[month] = {};
                    monthlyDataHash[month].year = month;
                }

                chartData.push(monthlyDataHash[month]);
            }

            return chartData;
        }
        // translate the category field names in a chart      
        function translateCategoryNames(chartData, fieldName) {
            angular.forEach(chartData, function (data) {
                data[fieldName] = $translate.instant(data[fieldName]);
            });
        }

        /**
        * Sums grandchild properties
        * var data = [ { child: { grandchild: 1 } }, { child: { grandchild: 1} } ];
        * var result = sumGranchildren(data, 'child', 'grandchild');
        * // result = 2
        */
        function sumGrandchildren(data, childName, grandchildName) {
            return _.reduce(_.map(data, childName), function (memo, num) {
                return memo + (num && num[grandchildName] ? num[grandchildName] : 0);
            }, 0);
        }

        function savingsStatus(capStatus) {
            switch (capStatus) {
                case "savings":
                    return "Savings";
                case "loss":
                    return "Loss";
                case "savingsLocked":
                    return "Savings - Locked";
                case "lossLocked":
                    return "Loss - Locked";
                case "highPercent":
                    return "High CA % of BATCC Cost";
                case "aucToBaseline":
                    return "Unit Cost Defaulted to Baseline";
                default:
                    return capStatus;
            }
        }





        function getArrowChartData(apiData, propertyToTotal, unit, precision, today) {
            if (apiData && apiData.results) {
                var dateDisplayFormat = "MMM YYYY";
                var thisYearEnd = moment(today).subtract(2, 'months');
                var thisYearStart = moment(today).subtract(13, 'months');

                var thisYearEndPeriod = thisYearEnd.format("YYYYMM");
                var thisYearStartPeriod = thisYearStart.format("YYYYMM");

                var lastYearEnd = moment(today).subtract(2, 'months').subtract('1', 'year');
                var lastYearStart = moment(today).subtract(13, 'months').subtract('1', 'year');
                var thisYearSpan = $translate.instant(thisYearStart.format('MMM')) + thisYearStart.format(' YYYY') + "\u2013" + $translate.instant(thisYearEnd.format('MMM')) + thisYearEnd.format(' YYYY');

                var lastYearEndPeriod = lastYearEnd.format("YYYYMM");
                var lastYearStartPeriod = lastYearStart.format("YYYYMM");
                var lastYearSpan = $translate.instant(lastYearStart.format('MMM')) + lastYearStart.format(' YYYY') + "\u2013" + $translate.instant(lastYearEnd.format('MMM')) + lastYearEnd.format(' YYYY');

                var thisYearTotal = null;
                var lastYearTotal = null;
                var changeValue = null;
                var currency = apiData && apiData.costUnit ? apiData.costUnit.unitInfo : null;

                precision = precision || 0;

                map(apiData.results, function (item) {
                    var itemPeriod = item.calendarYear * 100 + item.calendarPeriod;
                    if (itemPeriod >= thisYearStartPeriod && itemPeriod <= thisYearEndPeriod) {
                        thisYearTotal += item[propertyToTotal];
                    }
                    else if (itemPeriod >= lastYearStartPeriod && itemPeriod <= lastYearEndPeriod) {
                        lastYearTotal += item[propertyToTotal];
                    }
                });

                if (lastYearTotal) {
                    lastYearTotal = lastYearTotal / 365;
                }

                if (thisYearTotal) {
                    thisYearTotal = thisYearTotal / 365;
                }

                //The grid puts the units in the header but the sidebar on the graph puts them inline, so we need two separately formatted values
                //we don't just do it inline when defining the result because we need to factor in missing values without getting "null KWH"
                var thisYearTotalGridDisplay = null;
                var thisYearTotalGraphDisplay = null;
                var lastYearTotalGridDisplay = null;
                var lastYearTotalGraphDisplay = null;

                if (thisYearTotal !== null) {
                    thisYearTotalGridDisplay = unit ? numberFormat(thisYearTotal, precision) : currencyFormat(thisYearTotal, currency, precision);
                    thisYearTotalGraphDisplay = unit ? numberFormat(thisYearTotal, precision) + ' ' + unit : currencyFormat(thisYearTotal, currency, precision);
                }
                if (lastYearTotal !== null) {
                    lastYearTotalGridDisplay = unit ? numberFormat(lastYearTotal, precision) : currencyFormat(lastYearTotal, currency, precision);
                    lastYearTotalGraphDisplay = unit ? numberFormat(lastYearTotal, precision) + ' ' + unit : currencyFormat(lastYearTotal, currency, precision);
                }

                return {
                    currentYearSpan: thisYearSpan,
                    currentYearValue: thisYearTotal,
                    currentYearValueDisplay: thisYearTotalGraphDisplay,

                    previousYearValue: lastYearTotal,
                    previousYearSpan: lastYearSpan,
                    previousYearValueDisplay: lastYearTotalGraphDisplay,

                    currencyToDisplay: currency,
                    gridRows: [
                        { timePeriod: lastYearSpan, totalValue: lastYearTotalGridDisplay },
                        { timePeriod: thisYearSpan, totalValue: thisYearTotalGridDisplay }
                    ]
                };
            } else {
                //indicate no data
                return {
                    currentYearValue: null,
                    previousYearValue: null
                };
            }
        }

        function getSavingsArrowChartData(apiData, actualValue, batccValue, avoidanceValue, unit, precision, today) {
            if (apiData) {
                var currency = apiData.costUnit.unitInfo;
                var savingsStartDate = apiData.savingsStartDate ? $translate.instant(moment(apiData.savingsStartDate).format('MMM')) + moment(apiData.savingsStartDate).format(' YYYY') : $translate.instant('Inception');
                var savingsEndDate = $translate.instant(moment(today).format('MMM')) + moment(today).format(' YYYY');

                var result = {
                    savingsStartDate: savingsStartDate,
                    savingsEndDate: savingsEndDate,
                    timePeriod: savingsStartDate + " \u2013 " + savingsEndDate,
                    actualValue: actualValue,
                    batccValue: batccValue,
                    avoidanceValue: avoidanceValue
                };

                precision = precision || 0;

                result.actualValueGridDisplay = unit ? numberFormat(result.actualValue, 0) : currencyFormat(result.actualValue, currency, precision);
                result.actualValueDisplay = unit ? result.actualValueGridDisplay + ' ' + unit : result.actualValueGridDisplay;

                result.avoidanceValueGridDisplay = unit ? numberFormat(result.avoidanceValue, 0) : currencyFormat(result.avoidanceValue, currency, precision);
                result.avoidanceValueDisplay = unit ? result.avoidanceValueGridDisplay + ' ' + unit : result.avoidanceValueGridDisplay;

                result.batccValueGridDisplay = unit ? numberFormat(result.batccValue, 0) : currencyFormat(result.batccValue, currency, precision);
                result.batccValueDisplay = unit ? result.batccValueGridDisplay + ' ' + unit : result.batccValueGridDisplay;

                return result;
            }

        }

        function formatUseHeader(title, unit) {
            var formatString = '{title} ({unit})';
            var translatedTitle = $translate.instant(title);
            return translationHelper.translateAndInterpolate(formatString, { title: translatedTitle, unit: unit });
        }

        function formatUnitCostHeader(title, unit, currency) {
            var formatString = '{title} ({currency}/{unit})';
            var translatedTitle = $translate.instant(title);
            return translationHelper.translateAndInterpolate(formatString, { title: translatedTitle, unit: unit, currency: currency });
        }

        function formatUnitCostAxis(unit, currency, isMillion) {
            var formatString = '{currency}/{unit}';
            var combinedUnit = translationHelper.translateAndInterpolate(formatString, { unit: unit, currency: currency });
            return valueAxisTitleFormat(combinedUnit, isMillion);
        }

        /**
         * Gets the default AmChart default properties
         * @param {boolean} legend Return an AmLegend
         * @returns {object}
         */
        function getAmChartDefaults(legend) {
            var defaults = {
                autoMarginOffset: 0,
                color: '#1a1a23',
                fontFamily: "Roboto",
                marginRight: 8,
                marginTop: 8,
                categoryAxis: {
                    gridPosition: 'start',
                    gridAlpha: 0,
                    labelOffset: -6,
                    minHorizontalGap: 40,
                    axisThickness: 1
                },
                valueAxes: [
                    {
                        gridAlpha: 0,
                        labelOffset: -4,
                        axisThickness: 1,
                        offset: 0
                    }
                ],
                balloon: {
                    animationDuration: 0,
                    fadeOutDuration: .15,
                    setBounds: function(){} //no-op prevents errors when rendering on deleted div
                },
            };

            if (legend) {
                defaults.legend = {
                    markerType: 'square',
                    markerSize: 12,
                    position: 'right',
                    verticalGap: 4,
                    valueWidth: 0,
                    autoMargins: false,
                    marginLeft: 4,
                    marginRight: 8
                }
            }

            return defaults;
        }

        function getDisplayItems(data, type, options) {
            var apiProperties = chartPieces.API_PROPERTIES;

            // Setting up the cost unit and default precision for our charts, certain ones will require more precise values and we'll
            // expect that option to be set at the controller
            var displayItems = {
                costUnit: data.costUnit,
                costPrecision: 0,
                usePrecision: 0
            };

            // Meter level data uses native use so we must check the type to get the correct use unit to display
            switch (type) {
                case apiProperties.NATIVE_USE:
                case apiProperties.NATIVE_UNIT_COST:
                case apiProperties.SAVINGS_NATIVE_USE:
                    displayItems.useUnit = data.nativeUseUnit
                    break;
                case apiProperties.DEMAND:
                    displayItems.demandUnit = data.commonDemandUnit;
                default:
                    displayItems.useUnit = data.commonUseUnit
                    break;
            }

            // If we have options for the chart defined and a cost/use precision setup, override the defaults
            if (options) {
                if (options.costPrecision) {
                    displayItems.costPrecision = options.costPrecision;
                }

                if (options.usePrecision) {
                    displayItems.usePrecision = options.usePrecision;
                }
            }

            return displayItems;
        }

        /**
        * Each type requires that certain units be available for parsing, this function tells us that based on type
        * @param {string} type - Type of data being returned, should be one of the constants
        * @param {Object} unitDisplays - Object containing the Use/Cost unit objects
        * @returns {boolean} - Do the units exist for the type of chart being drawn
        */
        function hasRequiredUnits(type, displayItems) {
            var apiProperties = chartPieces.API_PROPERTIES;

            switch (type) {
                case apiProperties.COST:
                case apiProperties.SAVINGS_COST:
                case apiProperties.ALL_TIME_COST:
                    return angular.isDefined(displayItems.costUnit) && displayItems.costUnit !== null;
                case apiProperties.USE:
                case apiProperties.SAVINGS_USE:
                case apiProperties.NATIVE_USE:
                case apiProperties.SAVINGS_NATIVE_USE:
                case apiProperties.ALL_TIME_USE:
                    return angular.isDefined(displayItems.useUnit) && displayItems.useUnit !== null;
                case apiProperties.UNIT_COST:
                case apiProperties.NATIVE_UNIT_COST:
                    return (angular.isDefined(displayItems.costUnit) && displayItems.costUnit !== null) &&
                        (angular.isDefined(displayItems.useUnit) && displayItems.useUnit !== null);
                case apiProperties.DEMAND:
                    return angular.isDefined(displayItems.demandUnit) && displayItems.demandUnit !== null;
            }
        }

        /**
        * Gets the default properties for a Arrow chart
        * @returns {object}
        */
        function getArrowChartDefaults() {
            return {
                "chart": {
                },
                "dataGrid": {
                    "columns": [{
                        "field": "timePeriod",
                        "title": "Time Period"
                    }]
                }
            };
        }

        /**
        * Gets the default proprties for a Stock Chart
        * @returns {object}
        */
        function getStockChartDefaults(){
            return {
                    "type": "stock",
                    "theme": "light",
                    "startDuration": 0,
                    "pathToImages": "/assets/images/amcharts/images/",
                    "sequenceAnimation": false,
                    "addClassNames": true,                    
                    "panelsSettings": {                        
                        "marginTop": 5,
                        "marginBottom": 5
                    },
                    "panels": [{
                        "startDuration": 0,
                        "recalculateToPercents": "never",
                        "stockLegend": {                            
                        },
                        "stockGraphs": [{                                  
                        }]
                    }],
                    "dataSets": [],
                    "categoryAxesSettings": {
                        "parseDates": true,
                        "equalSpacing": false,                        
                        "gridThickness": 0,
                        "gridAlpha": 1,
                        "gridColor": "#CCCCCC",
                        "fillAlpha": .1,
                        "boldPeriodBeginning": false,
                        "axisThickness": 1,
                        "axisColor": "#1a1a23",
                        "axisAlpha": 1,                        
                        "axisHeight": 24
                    },
                    "valueAxesSettings": {                        
                        "axisThickness": 1,
                        "axisAlpha": 1,
                        "axisColor": "#1a1a23",
                        "inside": false,
                        "showLastLabel": true,
                        "tickLength": 8
                    },
                    "chartCursorSettings": {
                        "valueBalloonsEnabled": true,
                        "pan": true
                    },
                    "chartScrollbarSettings": {
                        "dragIcon": "dragIconRoundSmall",
                        "dragIconWidth": 32,
                        "autoGridCount": false,
                        "ignoreCustomColors": true,                                                        
                        "backgroundAlpha": 0,
                        "selectedBackgroundAlpha": 0.3,
                        "selectedBackgroundColor": "#e1e9f9",
                        "selectedGraphFillAlpha": 1,
                        "selectedGraphLineAlpha": 0,
                        "selectedGraphFillColor": "rgb(45, 92, 184)",
                        "color": "#1a1a23",
                        "scrollbarHeight": 20,
                        "fillAlphas": 0
                    }
                };
        }

        /**
        * Gets the default AmChart default properties for summary serial charts
        * @returns {object}
        */
        function getSummarySerialChartDefaults() {
            return {
                "chart": {
                    "type": "serial",
                    "categoryField": "year",
                    "graphs": [{
                        "type": "column",
                        "valueField": "value",
                        "balloonText": "[[balloonText]]"
                    }],
                    "guides": getZeroGridLineGuide(),
                },
                "dataGrid": {
                    "columns": [{
                        "title": "Year",
                        "field": "year"
                    }]
                }
            };
        }

        /**
       * Gets the default AmChart default properties for a Twelve month commodity pie chart
       * @returns {object}
       */
        function getTwelveMonthCommodityPieChartDefaults() {
            return {
                "chart": {
                    "type": "pie",
                    "valueField": "value",
                    "percentField": "percent",
                    "titleField": "commodityInfo",
                    "balloonText": "[[title]]<br/ >[[valueDisplay]]<br/>[[percents]]%",
                    "legend": {
                        "position": "right",
                        "valueText": "[[percents]]%"
                    }
                },
                "dataGrid": {
                    "columns": [{
                        "field": "commodityInfo",
                        "title": "Commodity"
                    }]
                }
            };
        }

        /**
       * Gets the default AmChart default properties for a Cost Avoidance by Commodity serial chart
       * @returns {object}
       */
        function getCostAvoidanceByCommoditySerialChartDefaults() {
            return {
                "chart": {
                    "type": "serial",
                    "categoryField": "commodityInfo",
                    "categoryAxis": {
                        "autoRotateCount": 5
                    },
                    "graphs": [{
                        "type": "column",
                        "colorField": "color",
                        "lineColorField": "color",
                        "valueField": "value",
                        "balloonText": "[[valueDisplay]]"
                    }],
                    "guides": getZeroGridLineGuide()
                },
                "dataGrid": {
                    "columns": [{
                        "field": "commodityInfo",
                        "title": "Commodity"
                    },
                    {
                        "field": "valueDisplay",
                        "title": "Avoided Cost"
                    }]

                }
            };
        }

        /**
        * Gets the default AmChart default properties for a Cost and Use side by side summary serial chart
        * @returns {object}
        */
        function getCostAndUseSummarySerialChartDefaults() {
            return {
                "chart": {
                    "type": "serial",
                    "colors": [colorHelper.getMultiAxisColor("left"),
                    colorHelper.getMultiAxisColor("right")],
                    "categoryField": "year",
                    "columnSpacing": 0,
                    "graphs": [{
                        "valueAxis": "v1",
                        "type": "column",
                        "valueField": "costValue",
                        "balloonText": "[[costBalloonText]]"
                    },
                    {
                        "valueAxis": "v2",
                        "type": "column",
                        "valueField": "useValue",
                        "balloonText": "[[useBalloonText]]"
                    }],
                    "valueAxes": [{
                        "id": "v1",
                        "titleColor": colorHelper.getMultiAxisColor("left")
                    },
                    {
                        "id": "v2",
                        "titleColor": colorHelper.getMultiAxisColor("right"),
                        "position": "right"
                    }
                    ],
                    "guides": getZeroGridLineGuide()
                },
                "dataGrid": {
                    "columns": [{
                        "field": "year",
                        "title": "Year"
                    },
                    {
                        "field": "costValueDisplay",
                        "title": "Cost"
                    }]
                }
            };
        }

        function getCurrentYearVsPriorYearSerialLineChartDefaults(dataProvider, valueAxisTitle, valueAxisMin, valueAxisUnit, valueAxisUnitPosition, isMillion) {
            return {
                "type": "serial",
                "sequencedAnimation": false,
                "categoryField": "periodName",
                "colors": [colorHelper.getCurrentVsPriorYearColor("prior"),
                    colorHelper.getCurrentVsPriorYearColor("current")],
                "categoryAxis": {
                    "gridPosition": "start",
                    "gridAlpha": 0,
                    "gridCount": 1,
                    "gridThickness": 1,
                    "minorGridAlpha": 1,
                    "tickLength": 0
                },
                "graphs": [
                    {
                        "connect": false,
                        "balloonText": "[[previousBalloonText]]",
                        "bullet": "round",
                        "valueField": "previousValue",
                        "bulletSize": 5,
                        "lineThickness": 3,
                        "fillAlphas": 0
                    },
                    {
                        "connect": false,
                        "balloonText": "[[currentBalloonText]]",
                        "bullet": "round",
                        "valueField": "currentValue",
                        "bulletSizeField": "bulletSize",
                        "bulletSize": 5,
                        "lineThickness": 3,
                        "fillAlphas": 0
                    }
                ],
                "valueAxes": [
                    {
                        "gridAlpha": 0,
                        "position": "left",
                        "unit": isMillion ? "" : valueAxisUnit,
                        "unitPosition": isMillion ? "" : valueAxisUnitPosition,
                        "title": isMillion ? valueAxisTitle : "",
                        "minimum": valueAxisMin
                    }
                ],
                "dataProvider": dataProvider
            };
        }

        /**
        * Gets the default AmChart default properties for the current year vs prior year serial chart
        * @returns {object}
        */
        function getCurrentYearVsPriorYearSerialChartDefaults(previousTitle, mostRecentTitle) {
            return {
                "chart": {
                    "type": "serial",
                    "colors": [colorHelper.getCurrentVsPriorYearColor("prior"),
                    colorHelper.getCurrentVsPriorYearColor("current")],
                    "categoryField": "year",
                    "columnSpacing": 0,
                    "graphs": [
                        {
                            "title": previousTitle ? previousTitle : $translate.instant('Previous 12 Months'),
                            "type": "column",
                            "valueField": "previousYearTotal",
                            "balloonText": "[[previousYearBalloonText]]"
                        },
                        {
                            "title": mostRecentTitle ? mostRecentTitle : $translate.instant('Most Recent 12 Months'),
                            "type": "column",
                            "valueField": "currentYearTotal",
                            "balloonText": "[[currentYearBalloonText]]"
                        }
                    ],
                    "guides": getZeroGridLineGuide(),

                    legend: {
                        position: 'bottom',
                        autoMargins: true,
                        "equalWidths": false,
                        "spacing": 12,
                        "verticalGap": 0,
                        "valueWidth": 0,
                        "switchable": false
                    }
                },
                "dataGrid": {
                    "columns": [{
                        "field": "year",
                        "title": "Month"
                    }]
                },
            };
        }

        /**
        * Gets the default AmChart default properties for a sparkline chart
        * @param {Array} dataProvider - The array containing the data to be charged. Each element must have the properties defined in categoryField, lineField1, lineField2.
        * @param {string} categoryField - Name of the property to be used for chart category
        * @param {string} priorYearLine - Name of the property to be used for the prior year in the sparkline
        * @param {string} currentYearLine - Name of the proprety to be used for the current year in the sparkline        
        * @returns {object}
        */
        function getSparklineChartDefaults(dataProvider, categoryField, priorYearLine, currentYearLine) {
            return {
                "theme": "light",
                "type": "serial",
                "dataProvider": dataProvider,
                "colors": [colorHelper.getCurrentVsPriorYearColor("prior"),
                colorHelper.getCurrentVsPriorYearColor("current")],
                "categoryField": categoryField,
                "autoMargins": false,
                "marginLeft": 0,
                "marginRight": 4,
                "marginTop": 0,
                "marginBottom": 5,
                "graphs": [
                    {        
                        "connect": false,                    
                        "type": "line",
                        "valueField": priorYearLine,
                        "showBalloon": false,
                        "bulletField": "bullet",
                        "bulletSize": 7,
                        "fillAlphas": 0,
                        "lineThickness": 2
                    },
                    {         
                        "connect": false,                   
                        "type": "line",
                        "valueField": currentYearLine,
                        "showBalloon": false,
                        "bulletField": "bullet",
                        "bulletSize": 7,
                        "fillAlphas": 0,
                        "lineThickness": 2
                    }
                ],
                "categoryAxis": {
                    "gridAlpha": 0,
                    "axisAlpha": 0
                },
                "valueAxes": [{
                    "gridAlpha": 0,
                    "axisAlpha": 0
                }]                
            };
        }

        /**
        * Gets the default AmChart default properties for a "thermometer" chart        
        * @param {string} categoryFieldValue - Value to be used for chart category
        * @param {string} priorYearBar - Value to be used for the prior year in the thermometer
        * @param {string} currentYearBar - Value to be used for the current year in the thermometer        
        * @returns {object}
        */
        function getThermometerChartDefaults(categoryFieldValue, priorYearBar, currentYearBar) {
            return { 
                "type": "serial",
                "dataProvider": [{
                    "categoryFieldValue": categoryFieldValue,
                    "priorYearBar": priorYearBar,
                    "currentYearBar": currentYearBar
                }], 
                "colors": [colorHelper.getCurrentVsPriorYearColor("prior"),
                colorHelper.getCurrentVsPriorYearColor("current")],
                "categoryField": "categoryFieldValue",
                "rotate": true,
                "autoMargins": false,
                "marginLeft": 0,
                "marginRight": 0,
                "marginTop": 0,
                "marginBottom": 0,
                "graphs": [{
                    "valueField": "priorYearBar",
                    "type": "column",
                    "showBalloon": false,     
                    "columnWidth":1                                           
                    }, {
                    "valueField": "currentYearBar",
                    "type": "column",
                    "showBalloon": false,
                    "clustered": false,
                    "columnWidth":0.4
                }],
                "categoryAxis": {
                    "gridAlpha": 0,
                    "axisAlpha": 0
                },
                "valueAxes": [
                    {                        
                        "axisAlpha": 0,
                        "gridAlpha": 0,
                        "autoGridCount": false,
                        "gridCount": 50,
                        "labelFrequency": 50
                    }
                ]
            };
        }

        /**
        * Returns the guide that is acting as a '0' grid line since some values can be in the negative and we can't hide all grid lines but that 0th
        * @returns {object}
        * @private
        */
        function getZeroGridLineGuide() {
            return [{
                "lineThickness": 1,
                "lineColor": colorHelper.AMCHART_ELEMENTS.AXIS_COLOR,
                "value": 0
            }];
        }

        return chartPieces;
    }
})();
﻿(function () {
    'use strict';
    angular
        .module('app')
        .factory('colorHelper', ColorHelper);

    ColorHelper.$inject = [];

    /**
     * Factory for Colors
     */
    function ColorHelper() {

        // These are the variable settings for the EnergyCAP color pallette
        // Colors go from lighter (1) to darker (8).

        // Greens
        var green1 = "rgb(227, 251, 214)";
        var green2 = "rgb(194, 236, 172)";
        var green3 = "rgb(153, 216, 120)";
        var green4 = "rgb(99, 184, 54)";
        var green5 = "rgb(43, 154, 3)";
        var green6 = "rgb(39, 134, 4)";
        var green7 = "rgb(40, 111, 15)";
        var green8 = "rgb(24, 86, 2)";

        // Blues
        var blue1 = "rgb(185, 237, 252)";
        var blue2 = "rgb(172, 228, 243)";
        var blue3 = "rgb(118, 206, 230)";
        var blue4 = "rgb(64, 183, 216)";
        var blue5 = "rgb(42, 163, 196)";
        var blue6 = "rgb(36, 143, 172)";
        var blue7 = "rgb(26, 111, 135)";
        var blue8 = "rgb(10, 74, 92)";

        // Grays
        var gray1 = "rgb(218, 228, 233)";
        var gray2 = "rgb(172, 188, 195)";
        var gray3 = "rgb(140, 156, 165)";
        var gray4 = "rgb(117, 132, 143)";
        var gray5 = "rgb(94, 109, 121)";
        var gray6 = "rgb(73, 89, 99)";
        var gray7 = "rgb(53, 71, 81)";
        var gray8 = "rgb(22, 47, 59)";

        // Oranges
        var orange1 = "rgb(253, 195, 161)";
        var orange2 = "rgb(255, 181, 137)";
        var orange3 = "rgb(255, 147, 83)";
        var orange4 = "rgb(255, 131, 57)";
        var orange5 = "rgb(249, 106, 21)";
        var orange6 = "rgb(235, 91, 6)";
        var orange7 = "rgb(214, 80, 2)";
        var orange8 = "rgb(194, 72, 0)";

        // Yellows
        var yellow1 = "rgb(255, 249, 195)";
        var yellow2 = "rgb(255, 239, 155)";
        var yellow3 = "rgb(255, 230, 100)";
        var yellow4 = "rgb(255, 222, 50)";
        var yellow5 = "rgb(245, 207, 8)";
        var yellow6 = "rgb(232, 182, 4)";
        var yellow7 = "rgb(214, 150, 4)";
        var yellow8 = "rgb(178, 124, 0)";

        // Reds
        var red1 = "rgb(255, 225, 231)";
        var red2 = "rgb(255, 178, 192)";
        var red3 = "rgb(255, 138, 159)";
        var red4 = "rgb(254, 88, 117)";
        var red5 = "rgb(237, 56, 88)";
        var red6 = "rgb(219, 11, 48)";
        var red7 = "rgb(197, 1, 36)";
        var red8 = "rgb(150, 0, 27)";

        // Purples
        var purple1 = "rgb(237, 220, 255)";
        var purple2 = "rgb(215, 180, 253)";
        var purple3 = "rgb(188, 140, 239)";
        var purple4 = "rgb(165, 114, 220)";
        var purple5 = "rgb(147, 85, 214)";
        var purple6 = "rgb(118, 48, 193)";
        var purple7 = "rgb(95, 20, 175)";
        var purple8 = "rgb(75, 7, 147)";

        // Browns
        var brown1 = "#e4d3c2";
        var brown2 = "#d4bca2";
        var brown3 = "#c6a686";
        var brown4 = "#ba946f"
        var brown5 = "#af8258";
        var brown6 = "#a57343";
        var brown7 = "#9b6531";
        var brown8 = "#8e5622";

        var aqua1 = "rgb(219, 255, 246)";
        var aqua2 = "rgb(196, 250, 237)";
        var aqua3 = "rgb(121, 232, 205)";
        var aqua4 = "rgb(55, 213, 175)";
        var aqua5 = "rgb(45, 184, 151)";
        var aqua6 = "rgb(34, 153, 125)";
        var aqua7 = "rgb(30, 116, 96)";
        var aqua8 = "rgb(28, 89, 75)";

        var cobalt1 = "rgb(218, 229, 251)";
        var cobalt2 = "rgb(153, 185, 251)";
        var cobalt3 = "rgb(109, 164, 254)";
        var cobalt4 = "rgb(70, 132, 232)";
        var cobalt5 = "rgb(66, 117, 216)";
        var cobalt6 = "rgb(45, 92, 184)";
        var cobalt7 = "rgb(22, 63, 140)";
        var cobalt8 = "rgb(6, 47, 125)";

        var pink1 = "rgb(255, 223, 244)";
        var pink2 = "rgb(255, 194, 235)";
        var pink3 = "rgb(232, 127, 197)";
        var pink4 = "rgb(228, 85, 180)";
        var pink5 = "rgb(207, 61, 158)";
        var pink6 = "rgb(185, 13, 127)";
        var pink7 = "rgb(182, 10, 124)";
        var pink8 = "rgb(151, 3, 101)";

        var good = green6;

        // General Colors
        var GENERAL_COLORS = {
            BLACK: "rgb(26, 26, 35)",
            WHITE: "#ffffff"
        };

        var AMCHART_ELEMENTS = {
            AXIS_COLOR: "#666666",
            BALLOON_TEXT_COLOR: "#333333"
        };

        // List of chart colors in preference from most commonly used to least commonly used
        var primaryChartColors = [
            blue5,
            purple5,
            orange5,
            aqua4,
            cobalt4,
            gray4,
            blue3,
            purple7,
            red5,
            aqua6,
            cobalt3,
            gray6,
            yellow4,
            blue7,
            purple3,
            orange7,
            cobalt8,
            yellow7,
            pink4,
            green6
        ];

        var service = {
            GENERAL_COLORS: GENERAL_COLORS,
            AMCHART_ELEMENTS: AMCHART_ELEMENTS,
            getBenchmarkColors: getBenchmarkColors,
            getCommodityColorClass: getCommodityColorClass,
            getCurrentVsPriorYearColor: getCurrentVsPriorYearColor,
            getExplanationOfSavingsColor: getExplanationOfSavingsColor,
            getGreenhouseGasColor: getGreenhouseGasColor,
            getGuideLineColor: getGuideLineColor,
            getMultiAxisColor: getMultiAxisColor,
            getPrimaryChartColors: getPrimaryChartColors,
            getSavingsColor: getSavingsColor
        };

        return service;

        /**
         * Function that returns an object with the colors needed for the requested benchmark view
         * @param {string} name - Benchmark type to get colors for
         * @returns {Object} - Object that contains colors needed for the benchmark view
         */
        function getBenchmarkColors(name) {
            return {
                foreground1: blue4,
                foreground2: blue4,
                background: GENERAL_COLORS.WHITE
            };
        }

        /**
         * Function that returns the css class needed for a commodity
         * @param {integer} commodityId - Commodity Identifier
         * @param {string} commodityCode - Commodity code
         * @returns {string} - Css class to apply for the commodity color
         */
        function getCommodityColorClass(commodityId, commodityCode) {
            var knownCommodities = ["electric", "irrigation", "naturalgas", "refuse", "sewer", "steam", "stormdrain", "trash", "water",
                "watercold", "waterhot", "watersewer"
            ];

            var cssClass = "";

            if (_.includes(knownCommodities, commodityCode.toLowerCase())) {
                return "ec-commodity-" + commodityCode.toLowerCase();
            }

            // custom commodities
            // also add this extra class just in case we need to change properties for any specific custom commodity
            return "ec-commodity-unknown" + commodityId % knownCommodities.length + " ec-commodity-" + commodityCode.toLowerCase();
        }

        /**
         * Function that returns the Current vs Prior year color requested
         * @param {string} name - Name of the color requested
         * @returns {string} - Hex color code requested
         */
        function getCurrentVsPriorYearColor(name) {
            var colors = {
                prior: blue3,
                current: blue7
            };

            return colors[name];
        }

        /**
         * Function that returns the Explanation of savings color requested
         * @param {string} name - Name of the color requested
         * @returns {string} - Hex color code requested
         */
        function getExplanationOfSavingsColor(name) {
            var colors = {
                nonWeatherUse: gray3,
                weatherUse: gray1,
                actualCurrentUse: blue4,
                useCostAvoidanceSavings: good,
                useCostAvoidanceLoss: orange4,
                lockedAdjustment: gray7
            };

            return colors[name];
        }

        /**
         * Function that returns the green house gas color requested
         * @param {string} name - Name of the color requested
         * @returns {string} - Hex color code requested
         */
        function getGreenhouseGasColor(name) {
            var colors = {
                nitrousOxide: purple5,
                N20: purple5,
                methane: yellow6,
                CH4: yellow6,
                carbonDioxide: blue2,
                CO2: blue2
            };

            return colors[name];
        }

        /**
         * Function that returns the grid line color requested
         * @param {string} name - Name of the color requested
         * @returns {string} - Hex color code requested
         */
        function getGuideLineColor(name) {
            var colors = {
                target: blue8,
                ytd: gray5
            };

            return colors[name];
        }

        /**
         * Function that returns the multi axis color requested
         * @param {string} name - Name of the color requested
         * @returns {string} - Hex color code requested
         */
        function getMultiAxisColor(name) {
            var colors = {
                left: blue5,
                right: orange4
            };

            return colors[name];
        }

        /**
         * Function that returns the primary chart color for the index requested, if no index is supplied it will
         * return the entire array
         * @param {integer} index - Index of the color requested
         * @returns {string|array} - Primary chart hex color code requested or full array of hex colors
         */
        function getPrimaryChartColors(index) {
            if (angular.isDefined(index)) {
                return primaryChartColors[index % 18];
            } else {
                return primaryChartColors;
            }

        }

        /**
         * Function that returns the Savings color requested
         * @param {string} name - Name of the color requested
         * @returns {string} - Hex color code requested
         */
        function getSavingsColor(name) {
            var colors = {
                savings: green5,
                loss: orange4,
                aucToBaseline: purple6,
                highPercent: blue4,
                savingsLocked: green8,
                lossLocked: aqua6
            };

            return colors[name];
        }

    }
})();
﻿(function () {
    'use strict';

    angular
		.module('app')
		.directive('editexplanationofsavingschart', EditExplanationOfSavingsChart);

    EditExplanationOfSavingsChart.$inject = ['chartContext', 'apiResource', '$timeout', 'customValidator', 'glazeService', 'urlService', '$state', 'regexService', 'amChartsService'];

    function EditExplanationOfSavingsChart(chartContext, apiResource, $timeout, customValidator, glazeService, urlService, $state, regexService, amChartsService) {
        return {
            restrict: 'AE',
            replace: true,
            scope: {
                source: '@'
            },
            templateUrl: "assets/templates/chart/editExplanationOfSavingsChart.html",
            controller: function ($scope) {

                $scope.batccUseOptions = {
                    decimals: 0,
                    spinners: false
                };

                $scope.validationOptions = {
                    validateOnBlur: false,
                    messages: {
                        required: function (input) {
                            return customValidator.validationMessages.requiredMessage(input);
                        },
                        customValidation: function (input) {

                            var optionalParam = {};

                            return customValidator.validationMessages.customValidationMessage(input, optionalParam);
                        }
                    },

                    rules: {
                        customValidation: function (input) {

                            var optionalParam = {};

                            return customValidator.validations.customValidation(input, optionalParam);
                        }
                    }
                };

                $scope.regexService = {
                    restrictPositiveInteger: regexService.restrictPositiveInteger()
                };

            },
            link: function (scope, element, attrs) {

                var reloadChart = true;

                glazeService.actions.save = save;

                glazeService.actions.reprocess = reprocess;

                glazeService.actions.isLocked = function () {
                    return scope.locked;
                };

                function load() {

                    scope.batccUseChange = function () {
                        scope.batcc.batccUse = (!scope.batcc.batccUse) ? 0 : scope.batcc.batccUse;
                        scope.avoidance.useAvoidance = scope.batcc.batccUse - scope.actualCurrent.actualCurrentUse;
                    };

                    scope.batccCostChange = function () {
                        scope.batcc.batccCost = (!scope.batcc.batccCost) ? 0 : scope.batcc.batccCost;
                        scope.avoidance.costAvoidance = scope.batcc.batccCost - scope.actualCurrent.actualCurrentCost;
                    };

                    scope.zeroSavings = function () {
                        scope.batcc.batccUse = scope.actualCurrent.actualCurrentUse;
                        scope.batcc.batccCost = scope.actualCurrent.actualCurrentCost;

                        scope.batccUseChange();
                        scope.batccCostChange();
                    };

                    var catalog = chartContext.catalog(scope.source);
                    var amchartElement = angular.element(element).find(".amchart")[0];

                    // Hide our calculations until we have data
                    scope.status = 'pending';

                    if (catalog) {

                        scope.title = catalog.title;

                        $timeout(function () {
                            chartContext.provider(catalog, scope.source).then(function (resolvedArgs) {

                                var eventHandlers = resolvedArgs.eventHandlers;

                                var result = {};
                                if (resolvedArgs.result) {
                                    result = resolvedArgs.result;
                                } else {
                                    result = resolvedArgs;
                                }
                                
                                if (result.titles && result.titles.length) {
                                    scope.title = result.titles[0].text;
                                    result.titles = [];
                                }

                                if (result.dataProvider.length === 0) {
                                    scope.status = 'noData'
                                }
                                else {
                                    var chart = amChartsService.makeChart(amchartElement, result);

                                    // Grab all of our display values from our dataProvider
                                    scope.actualBaseline = _.find(result.dataProvider, function (item) {
                                        return item.category === "Baseline";
                                    });
                                    scope.batcc = _.find(result.dataProvider, function (item) {
                                        return item.category === "BATCC";
                                    });
                                    scope.actualCurrent = _.find(result.dataProvider, function (item) {
                                        return item.category === "Current";
                                    });
                                    scope.avoidance = _.find(result.dataProvider, function (item) {
                                        return item.category === "Avoidance";
                                    });

                                    // Grab the unit for the display values
                                    scope.unit = result.unit;

                                    scope.batccUseFormat = "###,### " + scope.unit.unitInfo;

                                    scope.summerUsePerDD = result.summerUsePerDD;
                                    scope.summerR2 = result.summerR2;

                                    scope.winterUsePerDD = result.winterUsePerDD;
                                    scope.winterR2 = result.winterR2;

                                    scope.billingPeriod = result.billingPeriod;

                                    scope.title = catalog.title.replace('YYYY', scope.billingPeriod.year).replace('MM', scope.billingPeriod.month);

                                    scope.locked = result.locked;

                                    if (result.billMtrNotes !== null) {
                                        scope.billMtrNotes = result.billMtrNotes.reverse();
                                    }

                                    scope.status = 'hasData';
                                }
                            });
                        }, 100);
                    }
                }

                var sourceWatcher = scope.$watch('source', function (newValue, oldValue) {

                    if (newValue && reloadChart) {
                        load();
                    }
                    reloadChart = true; // reset

                }, true);

                scope.$on('$destroy', function () {
                    sourceWatcher();
                });

                // validates the controls for required fields and save
                function save(event) {
                    if (scope.validator.validate()) {
                        var manualAdjustment = {
                            batccNativeUse: scope.batcc.batccUse,
                            batccCost: scope.batcc.batccCost,
                            billMtrNote: scope.changeLog,
                            locked: true
                        };

                        apiResource.savings().manualAdjustment().save({ meterId: urlService.id(), billId: glazeService.getCurrentId() }, manualAdjustment, function (result) {
                            glazeService.hideGlaze();
                            $state.reload();
                        },
                        function (error) {

                        });
                    }
                    else {
                        glazeService.showErrorMessage();
                    }
                }

                // validates the controls for required fields and reprocess
                function reprocess(event) {
                    if (scope.validator.validate()) {
                        var manualAdjustment = {
                            batccNativeUse: 0,
                            batccCost: 0,
                            billMtrNote: scope.changeLog,
                            locked: false
                        };

                        apiResource.savings().manualAdjustment().save({ meterId: urlService.id(), billId: glazeService.getCurrentId() }, manualAdjustment, function (result) {
                            glazeService.hideGlaze();
                            $state.reload();
                        },
                        function (error) {

                        });
                    }
                    else {
                        glazeService.showErrorMessage();
                    }
                }
            }
        };
    }

})();
﻿(function () {
    'use strict';

    angular
		.module('app')
		.directive('explanationofsavingschart', ExplanationOfSavingsChart);

    ExplanationOfSavingsChart.$inject = ['chartContext', 'apiResource', '$timeout', 'glazeService', 'amChartsService'];

    function ExplanationOfSavingsChart(chartContext, apiResource, $timeout, glazeService, amChartsService) {
        return {
            restrict: 'AE',
            replace: true,
            transclude: true,
            scope: {
                source: '@'
            },
            templateUrl: "assets/templates/chart/explanationOfSavingsChart.html",
            link: function (scope, element, attrs) {

                var reloadChart = true;

                function load() {
                    var catalog = chartContext.catalog(scope.source);
                    var amchartElement = angular.element(element).find(".amchart")[0];

                    // Hide our calculations until we have data
                    scope.status = 'pending';

                    if (catalog) {

                        scope.title = catalog.title;

                        $timeout(function () {
                            chartContext.provider(catalog, scope.source).then(function (resolvedArgs) {

                                var eventHandlers = resolvedArgs.eventHandlers;

                                var result = {};
                                if (resolvedArgs.result) {
                                    result = resolvedArgs.result;
                                } else {
                                    result = resolvedArgs;
                                }

                                if (result.titles && result.titles.length) {
                                    scope.title = result.titles[0].text;
                                    result.titles = [];
                                }

                                if (result.dataProvider.length === 0) {
                                    scope.status = 'noData';
                                }
                                else {
                                    var chart = amChartsService.makeChart(amchartElement, result);

                                    scope.manualAdjustment = function () {
                                        glazeService.openGlaze(glazeService.getCurrentId(), 'edit-meter-explanation-of-savings');
                                    };

                                    // Grab all of our display values from our dataProvider
                                    scope.actualBaseline = _.find(result.dataProvider, function (item) {
                                        return item.category === "Baseline";
                                    });
                                    scope.batcc = _.find(result.dataProvider, function (item) {
                                        return item.category === "BATCC";
                                    });
                                    scope.actualCurrent = _.find(result.dataProvider, function (item) {
                                        return item.category === "Current";
                                    });
                                    scope.avoidance = _.find(result.dataProvider, function (item) {
                                        return item.category === "Avoidance";
                                    });

                                    // Grab the unit for the display values
                                    scope.unit = result.unit;

                                    scope.summerUsePerDD = result.summerUsePerDD;
                                    scope.summerR2 = result.summerR2;

                                    scope.winterUsePerDD = result.winterUsePerDD;
                                    scope.winterR2 = result.winterR2;

                                    scope.billingPeriod = result.billingPeriod;

                                    scope.title = catalog.title.replace('YYYY', scope.billingPeriod.year).replace('MM', scope.billingPeriod.month);

                                    scope.locked = result.locked;

                                    scope.billMtrNotes = result.billMtrNotes;

                                    scope.status = 'hasData';
                                }
                            });
                        }, 100);
                    }
                }

                var sourceWatcher = scope.$watch('source', function (newValue, oldValue) {

                    if (newValue && reloadChart) {
                        load();
                    }
                    reloadChart = true; // reset

                }, true);

                scope.$on('$destroy', function () {
                    sourceWatcher();
                });

            }
        };
    }

})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('chartMeterSavingsDetails', ChartMeterSavingsDetails);

    ChartMeterSavingsDetails.$inject = ['$q', 'apiResource', 'colorHelper', 'chartHelper', '$translate'];

    function ChartMeterSavingsDetails($q, apiResource, colorHelper, chartHelper, $translate) {

        function execute(options) {

            // Dark blue
            var nonWeatherUseColor = colorHelper.getExplanationOfSavingsColor("nonWeatherUse");

            // Light blue
            var weatherUseColor = colorHelper.getExplanationOfSavingsColor("weatherUse");

            // Orange
            var actualCurrentUseColor = colorHelper.getExplanationOfSavingsColor("actualCurrentUse");

            // Green. If Use Avoidance is zero or negative the color will change to Red
            var useAvoidanceColor = colorHelper.getExplanationOfSavingsColor("useCostAvoidanceSavings");

            // Some color
            var lockedAdjustmentColor = colorHelper.getExplanationOfSavingsColor("lockedAdjustment");

            var chartData = [];
            var trendLines = [];
            var graphs = [];

            // Horizontal stacked bar chart with value and category axis hidden.
            // First two cateogories in the chart have the possibility of being stacked in appearance.
            // For all chart bars we will define the open/close points for them to float the bars
            var model = {
                "type": "serial",
                "categoryField": "category",
                "rotate": true, // Makes chart horizontal
                "startDuration": 0,
                "sequencedAnimation": false,
                "autoMargins": false,
                "marginBottom": 16,
                "marginLeft": 0,
                "marginRight": 0,
                "marginTop": 0,
                "mouseWheelZoomEnabled": false,
                "categoryAxis": {
                    "gridPosition": "start",
                    "position": "left",
                    "axisAlpha": 0,
                    "gridAlpha": 0,
                    "labelsEnabled": false
                },
                "graphs": [],
                "valueAxes": [
                    {
                        "stackType": "regular",
                        "axisAlpha": 0,
                        "gridAlpha": 0,
                        "labelsEnabled": false
                    }
                ],
                "legend": {
                    "switchable": false,
                    "spacing": 16,
                    "equalWidths": false,
                    "valueWidth": 0,
                    "verticalGap": 0,
                    "markerSize": 8,
                    "fontSize": 12
                },
                "trendLines": [],
                "dataProvider": [],
                "balloon": {
                    "fixedPosition": false,
                    "offsetY": 5
                }
            };

            var deferred = $q.defer();

            // Call the Savings api to get the daters
            apiResource.savings().meterBills().query({ meterId: options.id }, function (result) {
                if (result.length > 0 && options.billId) {
                   
                    var billIndex = _.findIndex(result, function (bill) {
                        return bill.billId == options.billId;
                    });

                    // Check that we actually found the bill we wanted
                    if (billIndex > -1) {

                        var bill = result[billIndex];

                        if (bill.actualNativeUse >= bill.batccNativeUse) {
                            // If our value is 0 or negative the bar will be red
                            useAvoidanceColor = colorHelper.getExplanationOfSavingsColor("useCostAvoidanceLoss");
                        }

                        // Each category in the charts data to show the bars
                        chartData = [
                                {
                                    "category": "Baseline",
                                    "nonWeatherUseOpen": "0",
                                    "nonWeatherUseClose": bill.baselineNonweatherNativeUse,
                                    "weatherUseOpen": bill.baselineNonweatherNativeUse,
                                    "weatherUseClose": bill.baselineWeatherNativeUse + bill.baselineNonweatherNativeUse,
                                    "actualBaselineUse": bill.baselineNativeUse,
                                    "baselineNonWeatherUseDisplay": chartHelper.numberFormat(bill.baselineNonweatherNativeUse, 0) + ' ' + bill.nativeUseUnit.unitInfo,
                                    "baselineWeatherUseDisplay": chartHelper.numberFormat(bill.baselineWeatherNativeUse, 0) + ' ' + bill.nativeUseUnit.unitInfo
                                },
                                {
                                    "category": "BATCC",
                                    "nonWeatherUseOpen": "0",
                                    "nonWeatherUseClose": bill.batccNonweatherNativeUse,
                                    "weatherUseOpen": bill.batccNonweatherNativeUse,
                                    "weatherUseClose": bill.batccWeatherNativeUse + bill.batccNonweatherNativeUse,
                                    "batccUse": bill.batccNativeUse,
                                    "batccCost": bill.batccCost,
                                    "batccCostDisplay": chartHelper.currencyFormat(bill.batccCost, bill.costUnit.unitInfo, 0),
                                    "costUnit": bill.costUnit,
                                    "batccNonWeatherUseDisplay": chartHelper.numberFormat(bill.batccNonweatherNativeUse, 0) + ' ' + bill.nativeUseUnit.unitInfo,
                                    "batccWeatherUseDisplay": chartHelper.numberFormat(bill.batccWeatherNativeUse, 0) + ' ' + bill.nativeUseUnit.unitInfo
                                },
                                {
                                    "category": "Current",
                                    "currentUseOpen": "0",
                                    "currentUseClose": bill.actualNativeUse,
                                    "actualCurrentUse": bill.actualNativeUse,
                                    "actualCurrentCost": bill.actualCost,
                                    "actualCurrentCostDisplay": chartHelper.currencyFormat(bill.actualCost, bill.costUnit.unitInfo, 0),
                                    "costUnit": bill.costUnit,
                                    "actualCurrentUseDisplay": chartHelper.numberFormat(bill.actualNativeUse, 0) + ' ' + bill.nativeUseUnit.unitInfo
                                },
                                {
                                    "category": "Avoidance",
                                    "useAvoidanceOpen": bill.actualNativeUse > bill.batccNativeUse ? bill.batccNativeUse : bill.actualNativeUse,
                                    "useAvoidanceClose": bill.actualNativeUse > bill.batccNativeUse ? Math.abs(bill.savingsNativeUse) + bill.batccNativeUse : bill.savingsNativeUse + bill.actualNativeUse,
                                    "useAvoidance": bill.savingsNativeUse,
                                    "costAvoidance": bill.savingsCost,
                                    "costAvoidanceDisplay": chartHelper.currencyFormat(bill.savingsCost, bill.costUnit.unitInfo, 0),
                                    "costUnit": bill.costUnit,
                                    "useAvoidanceDisplay": chartHelper.numberFormat(bill.savingsNativeUse, 0) + ' ' + bill.nativeUseUnit.unitInfo
                                }
                        ];

                        if (bill.locked) {
                            chartData.splice(1, 1, {
                                "category": "BATCC",
                                "lockedAdjustmentOpen": "0",
                                "lockedAdjustmentClose": bill.batccWeatherNativeUse + bill.batccNonweatherNativeUse,
                                "batccUse": bill.batccNativeUse,
                                "batccCost": bill.batccCost,
                                "batccCostDisplay": chartHelper.currencyFormat(bill.batccCost, bill.costUnit.unitInfo, 0),
                                "costUnit": bill.costUnit,
                                "lockedAdjustmentDisplay": chartHelper.numberFormat(bill.batccWeatherNativeUse + bill.batccNonweatherNativeUse, 0) + ' ' + bill.nativeUseUnit.unitInfo
                            })
                        }

                        // Lines that show the difference between BATCC and Actual Current
                        trendLines = [
                                {
                                    "initialCategory": "Current",
                                    "initialValue": bill.actualNativeUse,
                                    "finalCategory": "Avoidance",
                                    "finalValue": bill.actualNativeUse,
                                    "lineColor": "#1a1a23",
                                    "lineThickness": 1
                                },
                                {
                                    "initialCategory": "BATCC",
                                    "initialValue": bill.batccNativeUse,
                                    "finalCategory": "Avoidance",
                                    "finalValue": bill.batccNativeUse,
                                    "lineColor": "#1a1a23",
                                    "lineThickness": 1
                                }
                        ];

                        graphs = [
                            {
                                "title": $translate.instant("Non-weather use"),
                                "openField": "nonWeatherUseOpen",
                                "closeField": "nonWeatherUseClose",
                                "type": "column",
                                "columnWidth": 0.8,
                                "lineAlpha": 1,
                                "lineColor": nonWeatherUseColor,
                                "fillColors": nonWeatherUseColor,
                                "legendColor": nonWeatherUseColor,
                                "fillAlphas": 1,
                                "legendAlpha": 1,
                                "showBalloon": true,
                                "balloonFunction": function(model) {
                                    return (model.dataContext.category === 'BATCC') ? model.dataContext.batccNonWeatherUseDisplay : model.dataContext.baselineNonWeatherUseDisplay;
                                }
                            },
                            {
                                "title": $translate.instant("Weather use"),
                                "openField": "weatherUseOpen",
                                "closeField": "weatherUseClose",
                                "type": "column",
                                "columnWidth": 0.8,
                                "lineAlpha": 1,
                                "lineColor": weatherUseColor,
                                "fillColors": weatherUseColor,
                                "legendColor": weatherUseColor,
                                "fillAlphas": 1,
                                "legendAlpha": 1,
                                "showBalloon": true,
                                "balloonFunction": function(model) {
                                    return (model.dataContext.category === 'BATCC') ? model.dataContext.batccWeatherUseDisplay : model.dataContext.baselineWeatherUseDisplay;
                                }
                            },
                            {
                                "title": $translate.instant("LockedAdjustment_SC"),
                                "openField": "lockedAdjustmentOpen",
                                "closeField": "lockedAdjustmentClose",
                                "type": "column",
                                "columnWidth": 0.8,
                                "lineAlpha": 1,
                                "lineColor": lockedAdjustmentColor,
                                "fillColors": lockedAdjustmentColor,
                                "legendColor": lockedAdjustmentColor,
                                "fillAlphas": 1,
                                "legendAlpha": 1,
                                "showBalloon": true,
                                "balloonFunction": function(model) {
                                    return model.dataContext.lockedAdjustmentDisplay;
                                }
                            },
                            {
                                "title": $translate.instant('Actual current use'),
                                "openField": "currentUseOpen",
                                "closeField": "currentUseClose",
                                "type": "column",
                                "columnWidth": 0.8,
                                "lineAlpha": 1,
                                "lineColor": actualCurrentUseColor,
                                "fillColors": actualCurrentUseColor,
                                "legendColor": actualCurrentUseColor,
                                "fillAlphas": 1,
                                "legendAlpha": 1,
                                "showBalloon": true,
                                "balloonFunction": function(model) {
                                    return model.dataContext.actualCurrentUseDisplay;
                                }
                            },
                            {
                                "title": $translate.instant('Use avoidance'),
                                "openField": "useAvoidanceOpen",
                                "closeField": "useAvoidanceClose",
                                "type": "column",
                                "columnWidth": 0.8,
                                "lineAlpha": 1,
                                "lineColor": useAvoidanceColor,
                                "fillColors": useAvoidanceColor,
                                "legendColor": useAvoidanceColor,
                                "fillAlphas": 1,
                                "legendAlpha": 1,
                                "showBalloon": true,
                                "balloonFunction": function(model) {
                                    return model.dataContext.useAvoidanceDisplay;
                                }
                            }
                        ];

                        // Pass the native use unit to the controlling chart for it's display
                        // AmCharts will ignore it
                        model.unit = bill.nativeUseUnit;

                        model.summerUsePerDD = bill.coolingUsePerDegreeDay;
                        model.summerR2 = bill.coolR2;
                        
                        model.winterUsePerDD = bill.heatingUsePerDegreeDay;
                        model.winterR2 = bill.heatR2;

                        model.locked = bill.locked;

                        model.billMtrNotes = bill.billMtrNotes;

                        model.billingPeriod = {
                            month: bill.periodName,
                            year: bill.calendarYear
                        };

                        model.trendLines = trendLines;

                        model.graphs = graphs;
                    }
                    
                }

                model.dataProvider = chartData;
                deferred.resolve(model);

            }, function (error) {
                deferred.resolve(model);
            });

            return deferred.promise;
        }

        return {
            execute: execute
        };
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('chartMeterSavingsTrends', ChartMeterSavingsTrends);

    ChartMeterSavingsTrends.$inject = ['$q', 'apiResource', 'chartHelper', '$sce', 'glazeService', 'userService', '$translate', 'colorHelper'];

    function ChartMeterSavingsTrends($q, apiResource, chartHelper, $sce, glazeService, userService, $translate, colorHelper) {

        function execute(options) {
            var model = {
                "type": "serial",                
                "dataDateFormat": "YYYY-MM-DD",
                "categoryField": "savingsDate",
                "startDuration": 0,
                "pathToImages": "/assets/images/amcharts/images/",
                "categoryAxis": {
                    "gridPosition": "middle",
                    "minPeriod": "MM",
                    "equalSpacing": false,
                    "gridAlpha": 0
                },
                "marginTop": 8,
                "marginRight": 16,
                "legend": {
                    "position": "bottom",
                    "autoMargins": true,
                    "spacing": 16,
                    "equalWidths": false,
                    "data": [],
                    "valueWidth": 0,
                    "verticalGap": 0,
                    "markerSize": 8,
                    "fontSize": 12
                },
                "chartScrollbar": {
                    "dragIcon": "dragIconRoundSmall",
                    "dragIconWidth": 24,
                    "autoGridCount": false,
                    "ignoreCustomColors": true,
                    "graph": "AmGraph-1",
                    "backgroundAlpha": 0,
                    "selectedBackgroundAlpha": 0.1,
                    "selectedBackgroundColor": "#e1e9f9",
                    "selectedGraphFillAlpha": 0,
                    "selectedGraphLineAlpha": 1,
                    "selectedGraphFillColor": "rgb(45, 92, 184)",
                    "color": "#7c7c7c",
                    "oppositeAxis": false,
                    "height": 24,
                    "hideResizeGrips": true,
                    "offset": 48
                },
                "trendLines": [],
                "graphs": [
                    {
                        "balloonFunction": function (e) {                            
                            return e.dataContext.savingsCostDisplay + " (" + e.dataContext.savingsDate + ")";
                        },
                        "stackable": false,
                        "fillAlphas": 1,
                        "colorField": "color",
                        "lineColorField": "color",
                        "id": "AmGraph-1",
                        "title": "graph 1",
                        "type": "column",
                        "valueField": "savingsCostValue" 
                    }
                ],
                "guides": [],
                "valueAxes": [
                    {
                        "stackType": "none",
                        "synchronizeWith": "ValueAxis-1",
                        "id": "ValueAxis-1",
                        "title": "", // title set below from API
                        "gridAlpha": 0.2
                    }
                ],
                "zoomOutText": $translate.instant("Show all"),
                "chartGrid": {
                    "columns": [{
                        "field": "savingsDate",
                        "title": "Month"
                    },
                    {
                        "field": "savingsCostDisplay",
                        "title": "Savings Cost"
                    },
                    {
                        "field": "capStatus",
                        "title": "Status"
                    }]
                }
            };

            var deferred = $q.defer();
            apiResource.savings().meterBills().query({ meterId: options.id, numberOfYears: userService.getUser().preference.trendChartNumberOfYears }, function (result) {
                var chart = {};
                var eventHandlers = {};

                eventHandlers.clickGraphItem = function (e) {
                    glazeService.openGlaze(result[e.index].billId, 'meter-explanation-of-savings');
                };

                // handle millions                
                var isMillion = chartHelper.isMillion(result, 'savingsCost');
                
                var currency = "";

                var chartData = result;
                _.forEach(result, function (element) {

                    var calendarPeriod = chartHelper.getCalendarMonth(element.calendarPeriod);

                    element.savingsDate = $translate.instant(calendarPeriod) + " " + element.calendarYear;

                    if (element.capStatus === 'skip') {
                        element.capStatus = (element.savingsCost > 0) ? 'savings' : 'loss';
                        element.capStatus += (element.locked) ? 'Locked' : '';
                    }

                    element.color = colorHelper.getSavingsColor(element.capStatus);
                    element.capStatus = $translate.instant(chartHelper.savingsStatus(element.capStatus));                    

                    element.savingsCostValue = chartHelper.millionFormat(element.savingsCost, isMillion);
                    element.savingsCostDisplay = chartHelper.currencyFormat(element.savingsCost, element.costUnit.unitInfo, 0);

                    if (currency === "") {
                        element.costUnit.unitInfo;
                    }
                });

                // build legend and set colors
                var capStatuses = [
                    "savings",
                    "loss",                    
                    "savingsLocked",                    
                    "lossLocked",                    
                    "highPercent",                    
                    "aucToBaseline"
                ];

                _.forEach(capStatuses, function (capStatus) {
                    model.legend.data.push({
                        "title": $translate.instant(chartHelper.savingsStatus(capStatus)),
                        "color": colorHelper.getSavingsColor(capStatus)
                    });
                });                

                model.valueAxes[0].title = chartHelper.valueAxisTitleFormat(currency, isMillion);

                model.dataProvider = chartData;
                chart.result = model;
                chart.eventHandlers = eventHandlers;
                deferred.resolve(chart);
            });

            return deferred.promise;
        }

        return {
            execute: execute
        };
    }
})();
﻿(function () {
    'use strict';

    angular
        .module("app")
        .directive('normalizedMonthlyAmchartOptions', NormalizedMonthlyAmchartOptions);

    NormalizedMonthlyAmchartOptions.$inject = ['chartHelper', 'runtimeService', '$translate'];

    function NormalizedMonthlyAmchartOptions(chartHelper, runtimeService, $translate) {

        return {
            restrict: "E",
            transclude: true,
            scope: {
                source: "="
            },
            link: function (scope, element, attrs, ctrl, transclude) {
                
                scope.method = runtimeService[attrs.optionkey];

                scope.toggle = [
                    { label: $translate.instant("monthly"), value: "monthly" },
                    { label: $translate.instant("cumulative"), value: "cumulative" }
                ];

                scope.toggleMethod = function () {
                    var options = chartHelper.tokenizeUrl(scope.source);

                    scope.source = options.baseUrl + '?years=' + options.years + '&method=' + scope.method + '&commodityId=' + options.commodityId;
                    scope.$parent.toggled = true;

                    runtimeService[attrs.optionkey] = scope.method;
                };

                transclude(scope, function (clone, scope) {
                    element.append(clone);
                });
            }
        };
    }
})();
﻿(function () {
    'use strict';

    angular
		.module('app')
		.directive('amchart', AmChart);

    AmChart.$inject = ['chartContext', 'apiResource', '$timeout', 'urlService', 'glazeService', '$translate', 'amChartsService'];
    //AS OF 8/6/2020 this file is still being used for unconverted powerview widgets, including Place GHG:
    //http://localhost:5000/app/buildings/organization/1050/actual/ghg
    function AmChart(chartContext, apiResource, $timeout, urlService, glazeService, $translate, amChartsService) {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                source: '@',
                legendid: '@',
                showActions: '='
            },
            templateUrl: "assets/templates/chart/amChart.html",

            // TODO: use a controller. Any logic that is not DOM related should move
            // into a controller to avoid data-binding issues in the template due to 
            // isolate scopes created by ng-ifs, etc.
            link: function (scope, element, attrs) {
                // The element is not replaced, therefore we need to add 
                // some classes for styling
                element.addClass('d-block');
                
                var reloadChart = true;

                // Display loading animation
                scope.isLoading = true;
                scope.message = '';

                function load() {
                    // Show the spinner, it'll be shown if this chart is being loaded for the first time,
                    // but it may have been hidden if we're just refreshing the charts url
                    scope.isLoading = true; 

                    var catalog = chartContext.catalog(scope.source);
                    var amchartElement = angular.element(element).find(".ec-chart")[0];

                    if (scope.showActions) {
                        scope.viewDetails = function () {
                            glazeService.openGlaze(0, 'magnify-chart', scope.title, scope.source);
                        };  
                    }             

                    if (catalog) {
                        // Set the chart header and translate
                        scope.title = catalog.title;

                        chartContext.provider(catalog, scope.source).then(function (resolvedArgs) {
                            var eventHandlers = resolvedArgs.eventHandlers;
                            var result = {};

                            if (resolvedArgs.result) {
                                result = resolvedArgs.result;
                            } else {
                                result = resolvedArgs;
                            }

                            if (result.titles && result.titles.length) {
                                scope.title = result.titles[0].text;
                                result.titles = [];
                            }

                            if (result.dataProvider == null || result.dataProvider.length === 0) {
                                // Show an overlay message if there is no data.
                                scope.message = 'No data is available';
                            } else {
                                // Hide no data message
                                scope.message = '';

                                var chart = amChartsService.makeChart(amchartElement, result);
                                var eventParams = {};

                                if (eventHandlers && eventHandlers.clickGraphItem) {
                                    chart.addListener("clickGraphItem", eventHandlers.clickGraphItem);
                                }

                                if (result.footer) {
                                    scope.hasFooter = true;
                                    scope.footer = result.footer;
                                }

                                if (chart.legend && chart.legend.addListener) {
                                    chart.legend.addListener('hideItem', function (e) {
                                        reloadChart = false;

                                        if (eventHandlers && eventHandlers.hideLegend) {
                                            eventParams.source = scope.source;
                                            eventHandlers.hideLegend(e, eventParams);
                                            scope.source = eventParams.source;
                                        }
                                    });

                                    chart.legend.addListener('showItem', function (e) {
                                        reloadChart = false;

                                        // if provider has custom event handler- call it!
                                        if (eventHandlers && eventHandlers.showLegend) {
                                            eventParams.source = scope.source;
                                            eventHandlers.showLegend(e, eventParams);
                                            scope.source = eventParams.source;
                                        }
                                    });
                                }                                
                                //// save the previous state when radio buttons are toggled
                                //// i.e. hide graphs which were hidden before toggle
                                //if (scope.toggled) {
                                //    eventHandlers.initChart(chart);
                                //    scope.toggled = false;
                                //}
                            }

                            // Hide the loading animation now that the chart is ready 
                            scope.isLoading = false;
                        });
                    }
                }

                var sourceWatcher = scope.$watch('source', function (newValue, oldValue) {

                    if (newValue && reloadChart) {
                        load();
                    }
                    reloadChart = true; // reset

                }, true);

                scope.$on('$destroy', function () {
                    sourceWatcher();
                });

            }
        };
    }

})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('chartCatalog', ChartCatalog);

    ChartCatalog.$inject = ['$translate'];

    /**
     * Catalog provider of all charts.
     * Maps a given URL to the chart provider.
     * @constructor
     */
    function ChartCatalog($translate) {

        var chartCatalog = {
            catalog: [
            // meter savings explanation of savings charts
            {
                // referenced by editMeterExplanationOfSavingsController.js
                // referenced by meterExplanationOfSavingsController.js
                'url': 'energycap://chart/meter/savingsDetails',
                'provider': 'chartMeterSavingsDetails',
                'title': 'Savings for MM YYYY',
                'type': 'explanationofsavingschart'
            },
            {
                // referenced by meterSavingsTrendsController.js
                'url': 'energycap://chart/meter/savingsTrends',
                'provider': 'chartMeterSavingsTrends',
                'title': 'Savings Trends',
                'type': 'amchart'
            }
            ],
            find: function (source) {
                var found = _.find(this.catalog, function (i) {
                    return source.indexOf(i.url) == 0;
                });

                found.title = $translate.instant(found.title);

                return found;
            }
        };

        return chartCatalog;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('chartContext', ChartContext);

    ChartContext.$inject = ['chartCatalog', '$q', '$injector'];

    function ChartContext(chartCatalog, $q, $injector) {

        var context = {
            catalog: catalog,
            provider: provider
        };

        function catalog(source) {
            return chartCatalog.find(source);
        }

        function provider(catalog, source) {
            var deferred = $q.defer();

            var splitSource = source.split("/");
            var provider = $injector.get(catalog.provider);

            var endOfUrl = splitSource[splitSource.length - 1].split('?');

            var options = { 
            	id: endOfUrl[0],
            	baseUrl: source.split('?')[0]
            };

			//Add query parameters to options
            if (endOfUrl.length > 1)
            {
            	endOfUrl[1].split("&").forEach(function(part) {
            		var item = part.split("=");
            		options[item[0]] = decodeURIComponent(item[1]);
            	});
            }

            provider.execute(options).then(function (result) {
            	deferred.resolve(result);
            }, function(error) { 
              deferred.reject(error);
            });

            return deferred.promise;
        }

        return context;

    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('detailsController', DetailsController);

    DetailsController.$inject = ['urlService', 'glazeService', 'chartCatalog', 'chartContext', '$timeout', '$translate', '$window', 'userService'];

    function DetailsController(urlService, glazeService, chartCatalog, chartContext, $timeout, $translate, $window, userService) {
        var vm = this;
        vm.copySuccess = copySuccess;
        vm.print = print;
        glazeService.primaryAction = glazeService.hideGlaze;

        (function constructor() {

            vm.source = glazeService.getGlazeOptions();
            var dateFormat = userService.getUser().preference.dateFormat;
            var catalogEntry = chartCatalog.find(vm.source);

            // To get around a bug that is similar in observation to
            // http://www.telerik.com/forums/grid-angular-k-rebind-issue-since-q3-update
            // Defer the execution with NO SCOPE APPLY
            $timeout(function () {
                // Generate the chartModel using the source and catalog
                chartContext.provider(catalogEntry, vm.source).then(function (chartModel) {
                    vm.updateDate = moment().format(dateFormat); //someday we'd like to get this from the API call that we're showing, but to avoid updating every provider we're just showing "now"

                    // Check to see the chart type, for this go around we'll look at AmChart and ArrowChart types
                    if (catalogEntry.type === "amchart" || catalogEntry.type === "eui-chart") {
                        reformatAmChart(chartModel);
                    } else if (catalogEntry.type.indexOf("arrowchart") > -1) {
                        reformatArrowChart(chartModel);
                    }

                });

                var title = glazeService.getGlazeTitle() || catalogEntry.title;
                glazeService.getGlazeElement().title(title);
            }, 0, false);
        })();

        function copySuccess(e) {
            e.clearSelection();
        }

        function print() {
            // Create a DOM element to shove "chart-details"
            // specific print css into it. We don't want the
            // the charts underneath to show, we set everything
            // we don't want to "display: none"

            var css = $window.document.createElement("style");
            css.type = "text/css";
            css.innerHTML = "@media print { #glazeWindow, body {overflow:hidden; height: " + (angular.element("#glazeWindow")[0].scrollHeight) + "px; } .split-layout { display: none; } body { width: 1500px; } .k-window { display: block !important  } .modules { display: none; } }";
            $window.document.body.appendChild(css);
            $window.print();
            css.remove();
        }

        function reformatAmChart(chartModel) {
            var gridDefinitionOverrides = null;

            // Some charts nest a result object that stores the chart info
            if (chartModel.hasOwnProperty('result')) {
                chartModel = chartModel.result;
            }

            // If the controller specified column data explicitly, use that and let the ecGrid do the translation
            // otherwise check the chart type, we'll grab the column headers a little different for each type
            if (chartModel.chartGrid && chartModel.chartGrid.columns) {
                gridDefinitionOverrides = chartModel.chartGrid;
            } else if(chartModel.type === "pie") {
                gridDefinitionOverrides = { columns: pieChartColumns(chartModel) };
            } else if (chartModel.type === "serial") {
                gridDefinitionOverrides = { columns: serialChartColumns(chartModel) };
            }

            //add on any rows that should be only in the grid, like the target data points when targets are on
            var gridRows = (chartModel.dataProvider || []).concat(gridDefinitionOverrides.additionalRows||[]);

            vm.chartGrid = angular.extend(
                getDefaultGridDefinition(),
                gridDefinitionOverrides,
                { dataSource: gridRows }
            );
        }

        function reformatArrowChart(chartModel) {
            // Arrow type charts dataProvider is an object so we'll push that to our array, thus giving us one record with columns for every
            // property
            vm.chartGrid = angular.extend(
                getDefaultGridDefinition(),
                { columns: getDataProviderColumns(chartModel) },
                chartModel.chartGrid,
                { dataSource: chartModel.dataProvider.gridRows || [chartModel.dataProvider] } //TODO: remove the fallback for the generated row data once all arrow charts are converted
            ); 
        }

        function getDataProviderColumns(chartModel) {
            var columns = [];
            Object.keys(chartModel.dataProvider).forEach(function (key, index) {
                columns.push({
                    field: key,
                    title: key 
                });
            });            

            return columns;
        }

        function serialChartColumns(chartModel) {

            // Start out with the category field for the chart
            var chartColumns = [
                {
                    field: chartModel.categoryField,
                    title: chartModel.categoryField
                }
            ];

            // Loop through all of the graphs pulling their value fields
            angular.forEach(chartModel.graphs, function (graph) {
                var column = {
                    field: graph.valueField,
                    title: graph.valueField
                };

                chartColumns.push(column);
            });

            return chartColumns;
        }

        function pieChartColumns(chartModel) {
            // Grab the title and value field for the display
            var display = [
                {
                    field: chartModel.titleField,
                    title: chartModel.titleField
                },
                {
                    field: chartModel.valueField,
                    title: chartModel.valueField
                }
            ];

            if (chartModel.percentField) {
                display.push({
                    field: chartModel.percentField,
                    title: chartModel.percentField,
                    template: '#=' + chartModel.percentField + '.toFixed(1) + "%"#'
                });
            }

            return display;
        }

        function getDefaultGridDefinition() {
            // Basic definition of our grid for the chart data, the rest will be
            // filled in based on the chart type
            return {
                fontFamily: 'Roboto-Regular', 
                scrollable: false,
                pageable: false,
                columns: []
            };
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app')
        .directive('widget', Widget);

    Widget.$inject = ['chartContext', '$compile'];

    function Widget(chartContext, $compile) {
        return {
            restrict: 'AE',
            priority: 10,
            terminal: true,
            link: {
                pre: function (scope, element, attrs, transclude) {

                    // Retrieve chart type from catalog
                    // Add attribute for the chart directive
                    // Compile the element (to resolve the chart directive)
                    // Stop watching
                    function load(source) {
                        var catalog = chartContext.catalog(source);
                        if (catalog) {
                            element.attr(catalog.type, '');
                            $compile(element, null, 10)(scope);
                            widgetWatcher();
                        }
                    }

                    // Wait for the string interpolation of the "source" attribute to resolve
                    // then call load()
                    var widgetWatcher = scope.$watch(function () {
                        return angular.element(element).attr('source');
                    }, function (newValue) {
                        if (newValue) {
                            load(newValue);
                        }                
                    });
                }
            }
        };
    }

})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('confirmationService', ConfirmationService);

    ConfirmationService.$inject = ['$q'];

    function ConfirmationService($q) {

        var service = {
            confirmation: confirmation
        };

        return service;

        function confirmation(title, message) {

            var deferred = $q.defer();

            deferred.resolve(confirm(message));

            return deferred.promise;
        }
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('customValidator', CustomValidator);

    CustomValidator.$inject = ['$translate', 'translationHelper', 'dateTimeHelper'];

    function CustomValidator($translate, translationHelper, dateTimeHelper) {

        var validationMessages;
        var validations;

        // all the private functions
        var IsRegexMatch;
        var ValidateDate;
        var ValidateZipCode;
        var ValidateInteger;
        var ValidateEcComboBoxNgRequired;
        var CompareDates;

        // all the validation messages (generic)
        var correctionMessage = $translate.instant("IncorrectFormat_LC");
        var requiredMessage = $translate.instant("is required");
        var invalidMessage = $translate.instant("is invalid");
        var genericHeaderMessage = $translate.instant("PleaseCorrectForm_SC");
        var defaultMessage = $translate.instant("please try again later");
        var dateBeforeMinimum = $translate.instant("is before the minimum date allowed");
        var dateAfterMaximum = $translate.instant("is after the maximum date allowed");
        var hyperlinkMessage = $translate.instant("must begin with http:// or https://");

        var dateParseFormats = dateTimeHelper.getParseFormats();

        validationMessages = {

            // depending on the type of validation performed
            // send back the appropriate message
            customValidationMessage: function (input, optionalParam) {

                // do not return any message if the input has the flag- 'show-error-message=false'
                // in that case just highlight the control
                if (input.is("[show-error-message=false]")) {
                   
                    return '';
                }

                if (input.is("[zip-postal-validation=true]")) { // validation message for zipcode

                    return ValidateZipCode(input, optionalParam).message;

                } else if (input.is("[parent-tree-validation=true]")) { // validation message for parent tree

                    if (typeof optionalParam.parent.placeId === 'undefined') {
                        return requiredMessage;
                    }

                } else if (input.is("[date-validation=true]")) { // validation message for date types

                    // if generic date validation is passed
                    // validate for specific cases
                    if (ValidateDate(input, optionalParam).isValid) {
                        if (input.is("[compare-date-validation=true]")) { 
                            if (input.attr("compare-date-validation-message")) {
                                return input.attr("compare-date-validation-message");
                            }

                            return invalidMessage;
                        }
                    }

                    return ValidateDate(input, optionalParam).message;

                } else if (input.is("[hyperlink-validation=true]") && input[0].value !== '') { // validation message for hyper link types

                    return hyperlinkMessage;

                } else if (input.is("[integer-validation=true]")) { // validation message for integer types

                    return ValidateInteger(input).message;

                } else if (input.is("[double-validation=true]") && input[0].value !== '') { // validation message for double types

                    return invalidMessage;

                } else if (input.is("[ec-combo-box-ng-required-validation=true]")) {  // validation message for ec-combo-box types that rely on optional required

                    return ValidateEcComboBoxNgRequired(input, optionalParam).message;

                }


                return defaultMessage; // default message
            },

            genericHeaderMessage: function () {
                return genericHeaderMessage;
            },

            requiredMessage: function (input, optionalParam) {
                // do not return any message if the input has the flag- 'show-error-message=false'
                // in that case just highlight the control
                if (input.is("[show-error-message=false]")) {
                    return '';
                }

                // in case of ec-combo-box don't show any message for the "select" tag
                // the "input" tag inside it will take care of the message
                if (input.is("[ec-combo-box]")) {
                    return '';
                }

                if (input.is("[zip-postal-validation=true]")) {
                    return ValidateZipCode(input, optionalParam).message;
                }

                if (input.attr('maxlength')) {
                    var message = translationHelper.translateAndInterpolate('MaxLengthValidationMessage', { maxLength: input.attr('maxLength') });
                    var unique = !_.isUndefined(input.attr('code-input')) ? ' ' + $translate.instant('and unique') : '';

                    message = message + unique;
                    return message;
                }

                return requiredMessage;
            }

        };

        validations = {

            // depending on the type of control and it's use-case
            // perform the appropriate validation
            customValidation: function (input, optionalParam) {

                if (input.is("[zip-postal-validation=true]")) { // all the validations for zipcode

                    return ValidateZipCode(input, optionalParam).isValid;

                } else if (input.is("[parent-tree-validation=true]")) { // all the validations for parent tree

                    if (typeof optionalParam.parent.placeId === 'undefined') {
                        return false;
                    }

                } else if (input.is("[date-validation=true]") && input[0].value !== '') { // all the validations for date types

                    // if generic date validation is passed
                    // validate for specific cases
                    if (ValidateDate(input, optionalParam).isValid) {
                        if (input.is("[compare-date-validation=true]")) {  // validation for comparing dates


                            return CompareDates(input, optionalParam).isValid;
                        }
                    }

                    return ValidateDate(input, optionalParam).isValid;

                } else if (input.is("[hyperlink-validation=true]") && input[0].value !== '') { // all the validations for hyper link types

                    return IsRegexMatch(optionalParam.regex, input[0].value.toString());

                } else if (input.is("[integer-validation=true]") && input[0].value !== '') { // all the validations for integer types

                    return ValidateInteger(input).isValid;

                } else if (input.is("[double-validation=true]") && input[0].value !== '') { // all the validations for double types

                    return IsRegexMatch(optionalParam.regex, input[0].value.toString());

                } else if (input.is("[ec-combo-box-ng-required-validation=true]")) {  // validation message for ec-combo-box types that rely on conditionally required

                    return ValidateEcComboBoxNgRequired(input, optionalParam).isValid;

                }

                return true;
            }

        };

        // validation logic for ec combo boxes that need to be conditionally required
        ValidateEcComboBoxNgRequired = function (input, optionalParam) {
            var validationResult = { isValid: true, message: '' };

            // ngRequired is the model value that determines if the ec combo box should be validated or not
            if (optionalParam.ngRequired) {

                // Make sure our input has a value, and if not, throw the required error
                if (input[0].value === '') {
                    validationResult.isValid = false;
                    validationResult.message = requiredMessage;
                }
            }

            return validationResult;
        };

        // validation logic for zip/postal codes
        ValidateZipCode = function (input, optionalParam) {

            var validationResult = { isValid: true, message: '' };

            // do not validate OTHER countries
            if (optionalParam.country === 'OTHER') {
                return validationResult;
            }

            if (optionalParam.country === 'CA') {
                if (input[0].value === '' || !IsRegexMatch(optionalParam.regex, input[0].value.toString())) {
                    validationResult.isValid = false;
                    validationResult.message = $translate.instant('must be 6 characters, alternating letters and numbers');
                }
            }
            else { // takes care of US and OTHER
                if (input[0].value === '' || !IsRegexMatch(optionalParam.regex, input[0].value.toString())) {
                    validationResult.isValid = false;
                    validationResult.message = $translate.instant('must be 5–9 numbers');
                }
            }

            return validationResult;
        };


        // validation logic for dates
        ValidateDate = function (input, optionalParam) {
            var validationResult = { isValid: true, message: '' };

            if (input.is("[kendo-date-picker]")) {
                var kendoDate = kendo.parseDate(input[0].value, dateParseFormats);

                if (kendoDate) {
                    return validationResult;
                }
                validationResult.isValid = false;
                validationResult.message = invalidMessage;
                return validationResult;
            }

            // if the given input is not able to create a valid date object- it is invalid
            var inputDate = new Date(input[0].value);
            if (!inputDate.getDate()) {

                validationResult.isValid = false;
                validationResult.message = invalidMessage;
                return validationResult;
            }

            return validationResult;
        };


        // validation logic for integers
        ValidateInteger = function (input) {

            var validationResult = { isValid: true, message: '' };

            if (input[0].value % 1 !== 0 || input[0].value % 1 !== -0) {
                validationResult.isValid = false;
                validationResult.message = invalidMessage;
                return validationResult;
            }

            return validationResult;

        };


        CompareDates = function (input, optionalParam) {
            var validationResult = { isValid: true, message: '' };

            if (optionalParam.operator === "lt") {
                if (!(moment(input[0].value) < moment(optionalParam.targetDate))) {
                    validationResult.isValid = false;
                    validationResult.message = invalidMessage;
                }
            } else if (optionalParam.operator === "gt") {
                if (!(moment(input[0].value) > moment(optionalParam.targetDate))) {
                    validationResult.isValid = false;
                    validationResult.message = invalidMessage;
                }
            } else if (optionalParam.operator === "lte") {
                if (!(moment(input[0].value) <= moment(optionalParam.targetDate))) {
                    validationResult.isValid = false;
                    validationResult.message = invalidMessage;
                }
            } else if (optionalParam.operator === "gte") {
                if (!(moment(input[0].value) >= moment(optionalParam.targetDate))) {
                    validationResult.isValid = false;
                    validationResult.message = invalidMessage;
                }
            }

            else if (optionalParam.operator === "eq") {
                if (!(moment(input[0].value) == moment(optionalParam.targetDate))) {
                    validationResult.isValid = false;
                    validationResult.message = invalidMessage;
                }
            }


            return validationResult;
        };

        // if the given input does not fit the given regex- it is invalid. 
        IsRegexMatch = function (regex, originalStr) {
            var matchResult = (originalStr).match(regex);

            if (!matchResult || (matchResult && matchResult[0] !== originalStr)) {
                return false;
            }

            return true;
        };

        var service = {
            validationMessages: validationMessages,
            validations: validations
        };

        return service;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('dateHelper', DateHelper);

    function DateHelper() {
        var service = {
            pretendUTC: pretendUTC
        };

        function pretendUTC(date) {
            return date ? moment.utc([date.getFullYear(), date.getMonth(), date.getDate()]).toDate() : null;
        }

        return service;
    }
})();
﻿(function () {
    'use strict';

    angular.module('app')
        .directive('card', Card)
        .directive('cardHeader', CardHeader)
        .directive('cardTitle', CardTitle)
        .directive('cardBody', CardBody)
        .directive('cardBodyOverlay', CardBodyOverlay)
        .directive('cardBodyMessage', CardBodyMessage)
        .directive('cardFooter', CardFooter)
        .directive('cardActions', CardActions)
        .directive('cardActionDetails', CardActionDetails)
        .directive('cardActionConfigure', CardActionConfigure)
        .directive('cardActionCancel', CardActionCancel);

    Card.$inject = [];
    CardHeader.$inject = [];
    CardBody.$inject = [];
    CardFooter.$inject = [];
    CardActions.$inject = [];
    CardActionDetails.$inject = ['$translate'];
    CardBodyOverlay.$inject = [];
    CardBodyMessage.$inject = [];
    CardActionConfigure.$inject = ['$translate'];
    CardActionCancel.$inject = ['$translate'];

    function Card() {
        return {
            restrict: 'E',
            template: '<div class="card" ng-transclude></div>',
            transclude: true,
            replace: true
        };
    }

    function CardHeader() {
        return {
            restrict: 'E',
            require: '^^card',
            template: '<header class="card-header" ng-transclude></header>',
            transclude: true,
            replace: true
        };
    }

    function CardTitle() {
        return {
            restrict: 'E',
            require: '^^card-header',
            template: '<h2 class="card-title" ng-transclude></h2>',
            transclude: true,
            replace: true
        };
    }

    function CardActions() {
        return {
            restrict: 'E',
            require: '^^card-header',
            template: '<div class="card-actions" ng-transclude></div>',
            transclude: true,
            replace: true
        };
    }
    
    function CardActionDetails($translate) {
        return {
            restrict: 'E',
            replace: true,
            require: '^^card-actions',
            template: '<button tooltip data-toggle="tooltip" title="' + $translate.instant('View details') + '" data-placement="top" class="ec-btn-icon btn"><i class="ec-icon icon-expand"></i></button>'        
        };
    }

    function CardActionConfigure($translate) {
        return {
            restrict: 'E',
            replace: true,
            require: '^^card-actions',
            template: '<button tooltip data-toggle="tooltip" title="' + $translate.instant('Edit') + '" data-placement="left" class="ec-btn-icon btn"><i class="ec-icon icon-edit"></i></button>'
        };
    }

    function CardActionCancel($translate) {
        return {
            restrict: 'E',
            replace: true,
            require: '^^card-actions',
            template: '<button tooltip data-toggle="tooltip" title="' + $translate.instant('Remove') + '" data-placement="top" class="ec-btn-icon btn"><i class="ec-icon icon-delete"></i></button>'
        };
    }

    function CardBody() {
        return {
            restrict: 'E',
            replace: true,
            require: '^^card',
            template: '<div class="card-block" ng-transclude></div>',
            transclude: true
        };
    }

    function CardBodyOverlay() {
        return {
            restrict: 'E',
            replace: true,
            template: '<div class="ec-overlay p-3" ng-show="loading || message">' + 
                        '<div class="ec-spinner" ng-if="loading">' +
                            '<span class="ec-spinner-1"></span>' + 
                            '<span class="ec-spinner-2"></span>' +
                            '<span class="ec-spinner-3"></span>' +
                            '<span class="ec-spinner-4"></span>' +
                        '</div>' + 
                        '<div ng-if="message" translate class="ec-overlay-message" ng-class="{\'mt-1\': loading}">{{message}}</div>' +
                     '</div>',
            scope: {
                loading: '=?',
                message: '=?overlayMessage'
            }
        };
    }

    function CardBodyMessage() {
        return {
            restrict: 'E',
            replace: true,
            template: '<div class="p-2 text-center ec-overlay-message" ng-transclude></div>',
            transclude: true
        };
    }

    function CardFooter() {
        return {
            restrict: 'E',
            require: '^^card',
            template: '<footer class="ec-util-flex-shrink card-footer py-1 px-2 align-items-center d-flex flex-wrap" ng-transclude></footer>',
            transclude: true,
            replace: true
        };
    }
})();



﻿(function () {
    'use strict';

    angular
                .module('app')
                .directive('clickableComboBox', ClickableComboBox);

    ClickableComboBox.$inject = ['$timeout'];

    /*
        ClickableCombobox disables and replaces certain events
        for a KendoComboBox so that the combobox template will
        honor click events.
    */
    function ClickableComboBox($timeout) {
        return {
            restrict: 'A',
            require: '^ecComboBox',
            compile: function (element, attrs) {
                return {
                    post: function (scope, element, attrs, controller) {
                        // inputWatcher makes sure that the input element is actually rendered
                        var inputWatcher = scope.$watch(function (scope) {
                            if (element.data("kendoComboBox")) {
                                return element;
                            }

                        }, function (value) {
                            if (value != undefined) {

                                var combobox = element.data("kendoComboBox");

                                // Disable the MouseDown event on 
                                // the 'animation container' so that
                                // it doesn't close
                                combobox.list.off('mousedown');

                                var shouldClose = false;

                                // Wrap the default combobox close event
                                // so that we can call it unmodifed when
                                // we want.
                                var wrappedClose = combobox.close;

                                combobox.close = function () {
                                    if (!shouldClose) {
                                        return;
                                    }
                                    wrappedClose.call(combobox);
                                };

                                combobox.input.focusout(function () {
                                    shouldClose = false;
                                    $timeout(function () {
                                        shouldClose = true;
                                    });
                                });

                                // Reorder the focus out event handlers on 
                                // the input control so that our event gets
                                // triggered first

                                /*eslint-disable */
                                var focusOutEvents = $._data(combobox.input[0]).events.focusout;
                                focusOutEvents.splice(focusOutEvents.delegateCount, 0, focusOutEvents.pop());
                                /*eslint-enable */

                                // kill the watcher
                                inputWatcher();
                            }

                        });
                    }
                };
            }

        };
    }

})();
﻿(function () {
    'use strict';

    angular
		.module('app')
		.directive('codeInput', CodeInput);

    CodeInput.$inject = [];

    /*
        Attribute directive to limit an input to only
        characters allowed for code. Requires ngModel
        since we piggy back off of $parsers
    */
    function CodeInput() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {

            	var maxLength = 0;

            	if (attrs.maxlength) {
            		maxLength = parseInt(attrs.maxlength);
            	}

                var formatter = function (input) {
                    if (!input) {
                        return '';
                    }
                    var codedInput = input.replace(/[^a-zA-Z0-9&_/\-]/g, '');

                    if (maxLength > 0) {
                    	codedInput = codedInput.substring(0, maxLength);
                    }

                    if (codedInput != input) {
                        ctrl.$setViewValue(codedInput);
                        ctrl.$render();
                    }

                    return codedInput;
                };

                // Set the parser since that is invoked when the 
                // input is modified from the DOM
                ctrl.$parsers.push(formatter);

                // Set the formatter since that is invoked when
                // the model is modified
                ctrl.$formatters.push(formatter);

            }

        };
    }

})();
﻿(function () {
    'use strict';

    angular.module('app').directive('compile', ['$compile', function ($compile) {
        return function (scope, element, attrs) {
            scope.$watch(
                function (scope) {
                    return scope.$eval(attrs.compile);
                },
                function (value) {
                    element.html(value);
                    $compile(element.contents())(scope);
                }
            );
        };
    }]);

})();
(function() {
  'use strict';

  angular
    .module('app')
    .directive('ecDataDisplay', ecDataDisplay);

  ecDataDisplay.inject = ['$compile'];
  
  /**
   * @name ecDataDisplay
   * @description Small directive for displaying sets of data as 
   * items, counters, and calculations
   * 
   * @param {string} type The type of data-display (item|counter|calculation|address|inline)
   * @param {string} value The value of the data-display 
   * @param {string} label The label for the value of the data-display 
   * @param {string} street1 The value for address line 1
   * @param {string} street2 The value for the address line 2 
   * @param {string} city The value of the address city 
   * @param {string} state The value of the address state 
   * @param {string} country The value of the address country 
   * @param {string} postalcode The value of the address postal code 
   * @param {string} othercode The value of another code such as station code that will be wrapped in square brackets
   * @param {bool} reverse Reverse the order of the label and value 
   * @param {bool} condensed Remove top and bottom margin
   * @param {string} operator Type of calculation operator (minus|plus)
   * @param {bool} bottomline Is the bottom line of a calculation 
   */
  function ecDataDisplay($compile) {
    return function(scope, element, attrs) {
      init();

      /**
       * Intialize the directive 
       */
      function init() {
        addClasses();

        var template = getTemplate();

        appendTemplate(template);
      }

      /**
       * @description Add any necessary classes to the directive element
       */
      function addClasses(){
        if (attrs.type == 'counter') {
          element.addClass('d-flex');
        } else {
          element.addClass('d-block');
        }
      }

      /**
       * @description Get the directive's template
       * @return {object} The jquery object returned by angular.element 
       */
      function getTemplate(){
        var template = angular.element('<div class="ec-data-item"></div>');

        if (!attrs.condensed) {
          template.addClass('my-1');
        }

        if (attrs.reverse) {
          template.addClass('ec-data-reverse');
        }

        var linkTemplate = getLinkTemplate();

        switch (attrs.type) {
          case 'item':
            template = getItemTemplate(template, linkTemplate);
            break;
          case 'inline':
            template = getInlineTemplate(template, linkTemplate);
            break;
          case 'address':
            template = getAddressTemplate(template, linkTemplate);
            break;
          case 'counter':
            template = getCounterTemplate(template, linkTemplate);
            break;
          case 'calculation':
            template = getCalculationTemplate(template, linkTemplate);
            break;
        }

        return template;
      }

      /**
       * @description Compile and append the template to the directive element
       * @param {object} template The final template object
       */
      function appendTemplate(template) {
        element.append($compile(template)(scope));
      }

      /**
       * @description If the directive contains an attribute for a link, generate a link with an 
       * <a> tag and add the attributes to the tag. Also remove those attributes from the directive element.
       * @returns {object|null} The jquery object returned by angular.element if directive is a link.
       */
      function getLinkTemplate(){
        
        var linkTemplate = null;

        // These are the attributes we want to copy if they exist
        var linkAttrs = ['href', 'target', 'ng-href', 'ui-sref', 'ui-sref-active', 'ui-sref-active-eq', 'ng-click'];
        angular.forEach(linkAttrs, function (linkAttr) {
            var attr = _.find(element[0].attributes, ['name', linkAttr]);

            if (!angular.isUndefined(attr)) {
                // Start the template if it hasn't been already
                if (linkTemplate === null) {
                    linkTemplate = angular.element('<a class="d-block"></a>');
                }

                linkTemplate.attr(attr.name, attr.value);

                // Now that we have copied the attribute, we don't want it on the directive element so we will remove it.
                element.removeAttr(attr.name);
            }
        });

        return linkTemplate;
      }

      /**
       * @description Get the template for item type. Wrap template in link if exists 
       * @param {object} template The directive's template object
       * @param {object} linkTemplate The link template object 
       * @returns {object} The item template object 
       */
      function getItemTemplate(template, linkTemplate) {
        var valueTemplate = getValueTemplate(attrs);
        var labelTemplate = getLabelTemplate(attrs);

        if (linkTemplate) {
          linkTemplate.append(valueTemplate);
          return template.append(linkTemplate).append(labelTemplate);
        } else {
          return template.append(valueTemplate + labelTemplate);
        }
      }

      /**
       * @description Get the template for inline type. Wrap template in link if exists 
       * @param {object} template The directive's template object
       * @param {object} linkTemplate The link template object 
       * @returns {object} The inline template object
       */
      function getInlineTemplate(template, linkTemplate) {

        var valueTemplate = getValueTemplate(attrs);
        var labelTemplate = getLabelTemplate(attrs);

        template.addClass('d-inline-flex ec-data-inline');

        if (linkTemplate) {
          linkTemplate.append(valueTemplate);
          return template.append(linkTemplate).append(labelTemplate);
        } else {
          return template.append(valueTemplate + labelTemplate);
        }
      }

      /**
       * @description Get the template for address type. Wrap template in link if exists 
       * @param {object} template The directive's template object
       * @param {object} linkTemplate The link template object 
       * @returns {object} The address template object
       */
      function getAddressTemplate(template, linkTemplate) {

        var addressLines = [];
        var labelTemplate = getLabelTemplate(attrs);

        //intentionally skipping the '---' no data display here because address lines are often empty
        if (attrs.street1) {
          addressLines.push(getValueTemplateRaw("{{" + attrs.street1 + "}}"));
        }
        if (attrs.street2) {
          addressLines.push(getValueTemplateRaw("{{" + attrs.street2 + "}}")); 
        }

        var line = '<span ng-if="' + attrs.city + ' || ' + attrs.state + ' || ' + attrs.postalcode + ' || ' + attrs.country + ' || ' + attrs.othercode + '">' +
          (attrs.city ? "{{" + attrs.city + "}}" : "") + getTemplateWithIf(attrs.city + ' && ' + attrs.state, ", ") + 
          (attrs.state ? "{{" + attrs.state + "}}" : "") + getTemplateWithIf('(' + attrs.city + ' || ' + attrs.state + ') && ' + attrs.country, ", ") + 
          (attrs.country ? "{{" + attrs.country + "}} " : " ") + 
          (attrs.postalcode ? "{{" + attrs.postalcode + "}} " : " ") + 
          (attrs.othercode ? "[{{" + attrs.othercode + "}}]" : "") + 
          '</span>';

        addressLines.push(getValueTemplateRaw(line));

        if (linkTemplate) {
          angular.forEach(addressLines, function(line) {
            linkTemplate.append(line);
          });
          return template.append(linkTemplate).append(labelTemplate);
        } else {
          angular.forEach(addressLines, function(line) {
            template.append(line);
          });
          return template.append(labelTemplate);
        }
      }
      /**
       * @description return a comma wrapped in an ng-if so we don't add commas between missing data
       * @param {string} propToCheck a data value to evaluate in the ng-if
       * @param {string} textToShow data to include in the ng-if that will only appear if it evaulates to a truthy value
       * @returns {string} a template string that will show a comma if the data field has data in it
       */
      function getTemplateWithIf(propToCheck, textToShow) {
          return '<span ng-if="' + propToCheck + '">' + textToShow + '</span>';
      }
      /**
       * @description Get the template for counter type. Wrap template in a link if it exists 
       * @param {object} template The directive's template object
       * @param {object} linkTemplate The link template object 
       * @returns {object} The counter template object
       */
      function getCounterTemplate(template, linkTemplate) {

        var valueTemplate = getValueTemplate(attrs);
        var labelTemplate = getLabelTemplate(attrs);

        // Add bootstrap class(es) for styling counter 
        template.addClass('ec-data-counter');

        if (linkTemplate) {
          linkTemplate.append(valueTemplate);
          return template.append(linkTemplate).append(labelTemplate);
        } else {
          return template.append(valueTemplate).append(labelTemplate);
        }
      }

      /**
       * @description Get the template for calculation type. Wrap template in link if exists 
       * @param {object} template The directive's template object
       * @param {object} linkTemplate The link template object 
       * @returns {object} The calculation template object
       */
      function getCalculationTemplate(template, linkTemplate) {

        template.addClass('ec-data-calculation');
        
        var valueTemplate = angular.element(getValueTemplate(attrs));

        if (attrs.bottomline) {
          valueTemplate.addClass('ec-data-calculation-bottom');
        } else if (attrs.operator == 'minus') {
          valueTemplate.addClass('ec-data-calculation-minus');
        } else if (attrs.operator == 'plus') {
          valueTemplate.addClass('ec-data-calculation-plus');
        } else {
          valueTemplate.addClass('ec-data-calculation-item');
        }

        var labelTemplate = getLabelTemplate(attrs);

        if (linkTemplate) {
          linkTemplate.append(valueTemplate);
          return template.append(linkTemplate).append(labelTemplate);
        } else {
          return template.append(valueTemplate).append(labelTemplate);
        }
      }

      /**
       * @description Get the template for a regular value without wrapping it in double curly braces. 
       * This is used when more complex formatting of the line is already provided
       * @param {object} expression an expression representing the line that will be combined into the template
       * @returns {object} The template object
       */
      function getValueTemplateRaw(expression) {
          return '<div class="ec-data-value">' + expression + '</div>';
      }

      /**
       * @description Get the template for a regular value and add in the double curly braces and filter for replacing the value with --- if it is empty.
       * This function also supports a single value (through attrs.value) or multiple values (through attrs.values)
       * This is used when simply rendering a value out and no complex formatting of the expression is required
       * @param {object} expression an expression representing the line that will be combined into the template
       * @returns {object} The template object
       */
      function getValueTemplate(attrs) {
          if (attrs.values) {
            return '<div class="ec-data-value" ng-repeat="specificValue in ' + attrs.values + '">{{specificValue | fillEmptyPlaceholder}}</div>';
          } else {
            return getValueTemplateRaw("{{ " + attrs.value + " | fillEmptyPlaceholder }}");
          }
      }

      /**
       * @description Get the template for the label(s) of a value, one per line, styled appropriately 
       * @param {object} attrs the attributes passed to this directive, which will be analyzed for properties 
       *                 named labels or label to determine how many rows to produce. If labels is present it is assumed to be
                         an array and one label per entry will be produced, otherwise only a single label is produced with the value of attrs.label
       * @returns {object} The template object
       */
      function getLabelTemplate(attrs) {
          if (attrs.labels) {
              return '<div class="ec-data-label" ng-repeat="specificLabel in ' + attrs.labels + '">{{specificLabel}}</div>';
          } else {
              return '<div class="ec-data-label">{{ ' + attrs.label + ' }}</div>';
          }
       }
    }
  }
})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('ecGlazeNavigator', ecGlazeNavigator);

    ecGlazeNavigator.inject = ['glazeService'];

    /**
     * @name ecIcon
     * @description creates the forward-and-back navigation control that interacts with glaze service to change the item in the glaze 
     */
    function ecGlazeNavigator(glazeService) {
        var directive = {
            restrict: 'E',
            replace: true,
            controllerAs: 'navigator',
            //scope: {
            //  name: '@name'
            //},
            templateUrl: 'assets/templates/directives/ecGlazeNavigator.html',
            controller: function ($scope, $element, $attrs, $timeout, $document) {
                this.$onInit = function () {
                    var vm = this;
                    vm.glazeService = glazeService;

                    // Setup our actions for the form title, these will call the glaze services
                    // primary and secondary actions which will be dictated by the forms controller
                    vm.previous = previous;
                    vm.next = next;
                    vm.navigationDisplay = navigationDisplay;
                    vm.hasNext = hasNext;
                    vm.hasPrevious = hasPrevious;

                    function hasNext() {
                        if (glazeService.actions != null && glazeService.actions.hasNext) {
                            return glazeService.actions.hasNext();
                        }
                    }

                    function hasPrevious() {
                        if (glazeService.actions != null && glazeService.actions.hasPrevious) {
                            return glazeService.actions.hasPrevious();
                        }
                    }

                    function navigationDisplay() {
                        if (glazeService.actions != null && glazeService.actions.navigationDisplay) {
                            return glazeService.actions.navigationDisplay();
                        }
                    }

                    function previous() {
                        if (glazeService.actions != null) {
                            glazeService.actions.previous();
                        }
                    }

                    function next() {
                        if (glazeService.actions != null) {
                            glazeService.actions.next();
                        }
                    }
                }
            }
        };

        return directive;
    }
})();
﻿(function () {
    'use strict';

    angular.module('app').directive('ecGrid', EcGrid);

    EcGrid.$inject = ['$translate'];

    function EcGrid($translate) {
        return {
            restrict: 'E',
            templateUrl: 'assets/templates/directives/ecGrid.html',
            controllerAs: "grid",
            bindToController: true,
            scope: {
                definition: '=',
                controller: '=',
                sortrows: '=?',
                hidenodata: '=?',

                // This was added as a means to put the grid back into a loading state from outside.  
                // This is used in the groups pages when we want to refresh the grid without refreshing the whole page
                isOutsideLoading: '=?'
            },
            link: function (scope, element, attrs) {
                // Add css classes to element since it is not being replaced
                element.addClass('d-block');
            },
            controller: function ($scope, $element, $attrs, $timeout, $document) {
                this.$onInit = function(){
                    var vm = this;
                    vm.sortOrder = [];
                    vm.lockedColumns = false;
                    vm.message = '';

                    // Add classes here that you do not want resizing enabled
                    vm.resizeDisableClassList = ['ec-grid-actions'];

                    (function constructor() {
                        // Show the loading animation 
                        vm.isLoading = true;

                        if (vm.definition && vm.definition.dataSource && (vm.definition.dataSource.length > 0 || vm.definition.dataSource.data)) {
                            vm.definition.dataBound = dataBound;
                        }

                        // All grids will be resizable by default if the controller didn't specify the property
                        if (!vm.definition.hasOwnProperty("resizable")) {
                            vm.definition.resizable = true;
                        }

                        // Look for locked columns 
                        angular.forEach(vm.definition.columns, function (column) {
                            if (column.locked) {
                                vm.lockedColumns = true;

                                if (vm.definition.lockedColumnsRight) {
                                    $element.addClass('ec-grid-lockedcolumns-right');
                                }
                            }
                        });

                        vm.definition.columnResize = function (e) {
                            e.preventDefault();

                            // Add the new width to the current and original column
                            var columnIndex = _.findIndex(vm.definition.columns, function (column) { return column.title === e.column.title; });
                            vm.definition.columns[columnIndex].width = e.newWidth;
                            vm.originalColumns[columnIndex].width = e.newWidth;
                        };

                        // Logic pulled from Kendo documentation to disable resizing on selected columns ( http://docs.telerik.com/kendo-ui/controls/data-management/grid/how-to/Layout/disable-column-resize-for-specific-columns)
                        // We will do it based on item classes, currently there is just one we are going to prevent resizing on
                        // kendoWidgetCreated is so we know the directive has been rendered and we have access to our kendoGrid object
                        $scope.$on("kendoWidgetCreated", function (event, grid) {
                            // Make sure the broadcasted event is for our grid
                            if (grid === vm.kendoGrid) {

                                if (vm.definition.resizable) {
                                    // Bind to the start resizable event so we can see if the column is allowed to be resized
                                    vm.kendoGrid.resizable.bind("start", function (e) {

                                        var disableResize = false;

                                        // Loop through all our excluded classes and see if they exist in the column attempting to be resized
                                        angular.forEach(vm.resizeDisableClassList, function (className) {
                                            if (_.findIndex(angular.element(e.currentTarget).data("th")[0].classList, function (headerClass) {
                                                return headerClass === className;
                                            }) > -1) {
                                                disableResize = true;
                                            }
                                        });

                                        if (disableResize) {
                                            // Column shouldn't resize so prevent default
                                            e.preventDefault();

                                            // Update the cursor
                                            $timeout(function () {
                                                grid.wrapper.removeClass("k-grid-column-resizing");
                                                angular.element($document[0].body).add(".k-grid th").css("cursor", "");
                                            });
                                        }
                                    });
                                }
                            }
                        });

                        $scope.$watch(vm.definition, function () {
                            if (vm.definition) {
                                // loop through columns and translate the titles
                                for (var i = 0; i < vm.definition.columns.length; i++) {
                                    var column = vm.definition.columns[i];
                                    column.title = $translate.instant(column.title);
                                    //Check if this is another level of columns to translate
                                    if (column.columns) {
                                        for (var j = 0; j < column.columns.length; j++) {
                                            var innerColumn = column.columns[j];
                                            innerColumn.title = $translate.instant(innerColumn.title);
                                        }
                                    }
                                }

                                // Make a copy of our columns, we want the original text mostly for when appending sort order numbers
                                vm.originalColumns = angular.copy(vm.definition.columns);

                                // Databound will be called whenever a column is clicked so we can react
                                vm.definition.dataBound = dataBound;
                                vm.kendoGrid.setOptions({ columns: vm.definition.columns });
                                if (vm.sortrows) {
                                    vm.sortableOptions = sortFunc();
                                }
                            }
                        });
                    })();

                    // Kendo's dataBound event that fires when data is bound and the grid is ready to show.
                    function dataBound(e) {
                        if (vm.lockedColumns) {
                            var gridWrapper = e.sender.wrapper;
                            var gridDataTable = e.sender.table;
                            var gridDataArea = gridDataTable.closest(".k-grid-content");

                            gridWrapper.toggleClass("ec-grid-no-scrollbar", gridDataTable[0].offsetHeight < gridDataArea[0].offsetHeight);
                        }
                        vm.message = "";
                        // Show message if no data and translate it
                        if (!vm.hidenodata && ((vm.definition.dataSource.hasOwnProperty("data") && vm.definition.dataSource.data.length === 0) || (!vm.definition.dataSource.hasOwnProperty("data") && vm.definition.dataSource.length === 0))) {
                            vm.message = vm.definition.noDataMessage || 'No data is available';
                        }

                        // Hide the loading animation 
                        vm.isLoading = false;
                    }

                    function sortFunc() {

                        if (!vm.sortrows) {
                            return {};
                        }
                        var sortopt = {
                            filter: ".k-grid tr[data-uid]:not(.editing)",
                            ignore: "input",
                            cursor: "move",
                            placeholder: function (element) {
                                return element
                                    .clone()
                                    .addClass("k-state-hover")
                                    .css("opacity", 0.65);
                            },
                            container: $element.find('tbody')[0],
                            change: function (e) {
                                var data = vm.definition.dataSource.data[e.oldIndex];

                                _.remove(vm.definition.dataSource.data, function (item) {
                                    return item == data;
                                });

                                vm.definition.dataSource.data.splice(e.newIndex, 0, data);
                            }
                        };
                        return sortopt;
                    }
                }
            }
        };
    }

})();
﻿(function () {
    'use strict';

    angular
		.module('app')
		.directive('kendoValidator', KendoValidator);

    KendoValidator.$inject = [];

    function KendoValidator() {
        return {
            link: function () {
            	$.fn.kendoValidator.widget.fn.clearInvalid = function () {

            		// Clear the errors object
            		/*eslint-disable */
            		this._errors = {};
            		/*eslint-enable */

					// Hide all invalid messages
                	this.hideMessages();

					// Toggle the k-invalid class off for all input fields
                	var inputs, idx, length;

            		/*eslint-disable */
                	if (!this.element.is(this._inputSelector)) {
                		inputs = this.element.find(this._inputSelector);
                	/*eslint-enable */
                		for (idx = 0, length = inputs.length; idx < length; idx++) {
                			inputs.eq(idx).toggleClass("k-invalid", false);
                		}
                	} else {
                		this.element.toggleClass("k-invalid", false);
                	}
                };
            }
        };
    }

})();
(function() {
  'use strict';
  
  angular.module('app').directive('href', ngHref);

  ngHref.$inject = ['$state'];

  /**
   * Raw a href links will change the url but do not trigger the router to navigate. 
   * We have Angular's routerLink directive on the ng5+ side to handle this, so this 
   * directive is essentially the same functionality for the ng1 side. When clicked, 
   * if the target attribute is not defined or is '_self', we pass the url to the 
   * router via the Ng1StateService to navigate, otherwise it should be an external 
   * link and we let the browser handle it.
   */
  function ngHref($state) {
    var directive = {
      restrict: 'A',
      link: linkFn
    };

    return directive;

    function linkFn(scope, element, attrs) {
      var isEmbedded = false;
      // Using global location because $location.path() is relative to the /app/ base href
      // and returns an empty string
      if (location.pathname === '/app/embedded') {
        isEmbedded = true;
      }

      if (attrs.href) {
        // Log a message to the console so we can identify links that might need to be updated
        if (attrs.href.startsWith('/app/') || attrs.href.includes('#')) {
          console.log("Found bad href: '" + attrs.href + "'");
        }

        element.on('click', function(event) {
          // If we are in an embedded page, let the browser handle navigation
          // We are checking for the # href to stop Kendo detailTemplates from navigating away when expanding a row
          // We are checking for the control key to allow "open in new window" behavior
          if (attrs.href !== "#" && (!attrs.target || (attrs.target && attrs.target === '_self')) && !event.ctrlKey) {
            if(isEmbedded){
              window.location.href = attrs.href;
            } else {
              $state.navigateByUrl(attrs.href);
            }
            return false;
          }
          return true;
        });
      }
    }
  }
})();

﻿(function () {
	'use strict';

	angular
		.module('app')
		.directive('closePopups', closePopups);

	closePopups.$inject = [];

	function closePopups() {
		return {
			controller: function ($window, $rootScope) {
				// logic to close the pop-up grids
				$window.addEventListener("click", function (event) {

					$rootScope.$broadcast('closePopup');

				}, false);
			}
		};
	}

})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .directive('focusMe', focusMe);

    focusMe.$inject = ['$timeout', '$parse', 'focusMe'];

    function focusMe($timeout, $parse, focusMe) {

        return {
            restrict: 'A',
            link: function (scope, element, attrs) {

                // inputWatcher makes sure that the input element is actually rendered after glaze loads- which is important for the focus to work.
                var inputWatcher = scope.$watch(function (scope) {
                    if (element[0].tagName === "DIV") {
                        if (element.find('input[type="text"]').length > 0) {
                            return element;
                        }
                    }
                    else {
                        return element;
                    }

                }, function (value) {
                    if (value != undefined) {

                        var internalInput = value;

                        if (internalInput[0].tagName === "DIV") {

                            // timeout here is necessary to account for ng-ifs
                            // example: create channel screen
                            $timeout(function () {

                                var bestInternalInput = internalInput.find('input[type="text"]')[0];
                                if (bestInternalInput.name.indexOf("parent") > -1) {
                                    bestInternalInput = internalInput.find('input[type="text"]')[1];
                                }
                            
                                focusMe.focus(bestInternalInput);
                            });
                        }

                        if (internalInput[0].type === "select-one") {

                            internalInput.data('kendoComboBox').bind("open", function () {
                                var bestInternalInput = internalInput.data('kendoComboBox').list.find("input")[0];

                                if (bestInternalInput) {
                                    focusMe.focus(bestInternalInput);
                                }
                            });


                            // event listener for "add new" button click
                            internalInput.data('kendoComboBox').list.bind("click", function (e) {

                                // focus only when the baby-form is loaded first time
                                if(e.target.className.indexOf("add-new-item") > -1){
                                    var bestInternalInput = internalInput.data('kendoComboBox').list.find("input")[0];

                                    if (bestInternalInput) {
                                        focusMe.focus(bestInternalInput);
                                    }
                                }
                            });

                        }

                        // kill the watcher
                        inputWatcher();
                    }

                });
                
            }
        };
    }

})();

    

﻿(function () {
    'use strict';

    angular
		.module('app')
		.directive('regexValidator', RegexValidator);

    RegexValidator.$inject = [];

   
    function RegexValidator() {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
            	regex: '@'
            },
            link: function (scope, element, attrs, modelCtrl) {

            	var getRegexedValue = function (inputValue) {
            		if (!inputValue) {
            			return '';
            		}

            		if (!scope.regex) {
            		    return inputValue;
            		}

            		var regex = new RegExp(scope.regex, "g");
            		var transformedInput = inputValue.toString().match(regex) ? inputValue.toString().match(regex)[0] : '';

            		if (transformedInput !== inputValue) {
            			modelCtrl.$setViewValue(transformedInput);
            			modelCtrl.$render();
            		}

            		return transformedInput;
            	};

            	modelCtrl.$parsers.push(function (modelValue) {
            		var value = getRegexedValue(modelValue);
            		return value;
            	});

            	modelCtrl.$formatters.push(function (modelValue) {
            		var value = getRegexedValue(modelValue);
            		return value;
            	});
            }
        };
    }

})();
﻿(function () {
    'use strict';

    angular
		.module('app')
		.directive('ecCheckBox', EcCheckBox);

    EcCheckBox.$inject = [];

    function EcCheckBox() {
        return {
            restrict: 'E',
            replace: true,
            template: templateFn,
            link: linkFn
        };
        function templateFn(tElement, tAttrs) {
            return "<label class='custom-control custom-checkbox m-0'>" +
                        "<input " + (!_.isUndefined(tAttrs.autofocus) ? "autofocus " : "") +
                        "class='custom-control-input' type='checkbox' ng-model='" + tAttrs.ngModel + "'" +
                        (tAttrs.tabindex ? ' tabindex="' + tAttrs.tabindex + '"' : '') +
                        (tAttrs.ngTrueValue ? ' ng-true-value="' + tAttrs.ngTrueValue + '"' : '') +
                        (tAttrs.ngFalseValue ? ' ng-false-value="' + tAttrs.ngFalseValue + '"' : '') +
                        (tAttrs.ngDisabled ? ' ng-disabled="' + tAttrs.ngDisabled + '"' : '') + 
                        (tAttrs.ngChecked ? ' ng-checked="' + tAttrs.ngChecked + '"' : '') +
                        (tAttrs.ngChange ? ' ng-change="' + tAttrs.ngChange + '"' : '') + ">" +
                        "<i class='ec-icon icon-check'></i>" +
                        (tAttrs.label ? "<span class='custom-control-description'>" + tAttrs.label + "</span>" : '') +
                    "</label>";
        }

        function linkFn(scope, element, attrs) {
            if (attrs.ngDisabled) {
                element.removeAttr('ng-disabled');
            }

            if (attrs.ngModel) {
                element.removeAttr('ng-model');
            }

            if (attrs.tabindex) {
                element.removeAttr('tabindex');
            }

            if (attrs.ngChange) {
                element.removeAttr('ng-change');
            }
        }
    }

})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .directive('ecComboBox', EcComboBox);

    EcComboBox.$inject = ['$timeout']
    function EcComboBox($timeout) {
        return {
            restrict: 'A',
            scope: {
                showForm: '=ecShowForm',
                footers: '=ecFooters',
                required: '=?ngRequired'
            },
            controller: function ($scope, $element, $attrs) {
                this.$onInit = function () {
                    var elementId = $element.attr('id');

                    $scope.$parent.$on('kendoWidgetCreated', function (event, combobox) {
                        if (combobox.element.attr('id') === elementId) {
                            // Initialize event handlers
                            initEventListeners(combobox);
                            // Initialize watchers
                            initWatchers(combobox);

                            // Copy some input attributes to the combobox input that 
                            // Kendo does not do automatically.
                            if ($element.prop('required') || $scope.required) {
                                combobox.input.prop('required', true);
                            }

                            if (!_.isUndefined($attrs.autofocus)) {
                                combobox.input.focus();
                            }

                            if (!_.isUndefined($attrs.name)) {
                                combobox.input.attr('name', $attrs.name + '_input');
                                combobox.input.attr('id', $attrs.name + '_input');
                            }
                        }

                        $scope.$on('$destroy', function () {
                            if (combobox && combobox.popup && combobox.popup.element) {
                                kendo.destroy(combobox.popup.element);
                            }
                        });
                    });

                    /**
                     * Set up event listeners
                     * @param {object} combobox Kendo ComboBox object 
                     */
                    function initEventListeners(combobox) {
                        /**
                         * On FocusOut, if there is a value in the input but no value 
                         * is selected in the dropdown, we'll handle this as a 
                         * "no-selection" case and clear out anything that is in the 
                         * input and then close the popout 
                         */
                        combobox.input.on('blur', function () {
                            if (combobox.selectedIndex == -1) {
                                combobox.text('');
                            }

                            combobox.close();
                        });

                        /**
                         * When the combobox is closed, hide if the form if it is 
                         * still showing. If the form is not showing we need to remove 
                         * our custom positioning because Kendo will get it right when
                         * it reopens
                         */
                        combobox.bind('close', function () {
                            if ($scope.showForm) {
                                $scope.showForm = false;
                            }
                        });
                    }

                    /**
                     * Set up watchers
                     * @param {object} combobox Kendo Combobox object 
                     */
                    function initWatchers(combobox) {
                        // $scope.$watch('footers', function(value) {
                        //     setFooters(value, combobox);
                        // })

                        /**
                         * We will watch the showForm boolean to toggle the form and 
                         * list as well as reposition the popout if needed.
                         */
                        $scope.$watch('showForm', function (value) {
                            onShowForm(value, combobox);
                        });
                    }

                    /**
                     * Set up the footers       
                     * @param {object} headers Headers object passed in from parent 
                     * @param {object} combobox Kendo Combobox object
                     * @todo handle footers (headers)
                     */
                    // function setFooters(headers, combobox) {
                    //     if (headers) {
                    //         if (parseInt(headers.totalpages) <= 1) {
                    //             headers.pagesize = headers.totalnumberofrecords;
                    //         }
                    //     }
                    // }

                    /**
                     * Show and hide the list when showing or hiding the form. Also 
                     * Reposition the popup if needed.
                     * @param {boolean} value Show/Hide the form 
                     * @param {object} combobox The Kendo Combobox object
                     */
                    function onShowForm(value, combobox) {

                        if (value === true) {
                            // Hide the list 
                            combobox.ul.parent().hide();

                            var inputs = combobox.popup.element.find('input');
                            inputs[0].focus();
                        } else if (value === false) {
                            // Show the list 
                            combobox.ul.parent().show();

                            combobox.focus();
                            combobox.refresh();
                        }

                        repositionPopup(combobox);
                    }

                    /**
                     * Reposition the popup to handle a wider popup because of showing the form
                     * if it is aligned to the right.
                     * @param {boolean} value Show/Hide form 
                     * @param {object} combobox Kendo Combobox object 
                     */
                    function repositionPopup(combobox) {
                        if (combobox.options.popup && combobox.options.popup.position && combobox.options.popup.position.indexOf('right') > -1) {

                            var popupContainer = combobox.popup.element.parent('.k-animation-container');

                            if (popupContainer.length > 0) {
                                var element = combobox.input.parent().parent('.k-combobox');
                                var elementLeft = element.offset().left;
                                var elementWidth = element.outerWidth();
                                var popupLeft = combobox.popup.element.offset().left;
                                var popupWidth = combobox.popup.element.outerWidth();

                                var left = popupLeft + (elementLeft + elementWidth) - (popupLeft + popupWidth);
                                popupContainer.css('left', left + 'px');
                            }
                        }
                    }
                }
            }
        };
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .directive('ecDatePicker', EcDatePicker);

    EcDatePicker.$inject = ['$timeout', '$translate', 'userService'];

    function EcDatePicker($timeout, $translate, userService) {
        return {
            restrict: 'E',
            require: 'ngModel',
            compile: function compile(templateElement, templateAttrs) {
                var elementAttrs = "";

                for (var prop in templateAttrs) {
                    if (!_.startsWith(prop, '$')) {
                        var dashProp = prop.replace(/([A-Z])/g, '-$1');
                        elementAttrs += dashProp + "='" + templateAttrs[prop] + "' ";
                    }
                }

                //Replace single quote with escaped single quote to allow it to be passed to kendo as a single-quoted string. The french translation has a single quote in it
                var translatedToday = $translate.instant('Today').replace(/'/g, "\\'"); 
                var dateFormat = userService.getUser().preference.dateFormat;
                var template = '<kendo-date-picker k-footer="\'' + translatedToday + '\'" ' +
                                ' placeholder="MM/DD/YYYY" k-format="MM/dd/yyyy" ' +
                                ' k-suggest="true" k-filter="\'startsWith\'" ' + elementAttrs +
                                ' date-validation="true" regex-validator regex="[0-9-/.]+"></kendo-date-picker>';

                templateElement.html(template).show();

                return {
                    post: function postLink(scope, element, attrs, ngModelCtrl) {

                        var inputElement = element.find("input");
                        var kendoDatePicker = inputElement.data('kendoDatePicker');

                        var datePickerOptions = {
                            minDate: "01/01/1900", // minimum date possible
                            maxDate: "01/01/2099" // maximum date possible
                        };

                        // remove the template element
                        element.children().unwrap();

                        inputElement.bind('blur', function () {
                            sanitizeDate();
                        });

                        function sanitizeDate() {

                            $timeout(function () {

                                // check for min date validation
                                if (ngModelCtrl.$modelValue && moment(ngModelCtrl.$modelValue) < moment(datePickerOptions.minDate)) {
                                    _.set(scope, attrs.ngModel, datePickerOptions.minDate);
                                }

                                // check for max date validation
                                if (ngModelCtrl.$modelValue && moment(ngModelCtrl.$modelValue) > moment(datePickerOptions.maxDate)) {
                                    _.set(scope, attrs.ngModel, datePickerOptions.maxDate);
                                }
                            });
                        }

                        scope.$on('$destroy', function() {
                            if (kendoDatePicker && kendoDatePicker.dateView && kendoDatePicker.dateView.popup && kendoDatePicker.dateView.popup.element) {
                                kendo.destroy(kendoDatePicker.dateView.popup.element);
                            }
                        });
                    }
                };
            }
        };
    }

})();
(function () {
    'use strict';

    angular
      .module('app')
      .directive('ecDropdown1', ecDropdown)
      .directive('ecDropdownItem', ecDropdownItem)
      .directive('ecDropdownHeader', ecDropdownHeader)
      .directive('ecDropdownDivider', ecDropdownDivider);

    function ecDropdown() {
        var directive = {
            link: link,
            restrict: 'E',
            transclude: true,
            scope: {
                iconClass: '<',
                label: '=',
                ngDisabled: '='
            },
            template: function (tElement, tAttrs) {
                // We need to use a span instead of a button because some browsers
                // do not allow buttons to be flex containers
                // see https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers
                if (tAttrs.icon) {
                    return '<span class="btn btn-secondary dropdown-toggle"' +
                                   'ng-click="toggle($event)" ng-disabled="ngDisabled"' +
                                   ((tAttrs.toggle) ? 'data-toggle="tooltip"' : '') + " " +
                                   ((tAttrs.title) ? 'tooltip title="' + tAttrs.title : "") + '"' +
                                   ((tAttrs.placement) ? 'data-placement="' + tAttrs.placement : "") + '">' +
                              '<i class="ec-icon ' + tAttrs.icon + '"></i><span ng-class="{\'ml-2\': label}">{{label || ""}}</span></span>' +
                            '<ec-dropdown-menu class="dropdown-menu" ng-transclude></ec-dropdown-menu>'
                } else if (tAttrs.hasOwnProperty('iconClass')) {
                    return '<span class="btn btn-secondary dropdown-toggle d-flex align-items-center"' +
                                   'ng-click="toggle($event)" ng-disabled="ngDisabled">' +
                              '<i class="ec-icon {{iconClass}}"></i><span class="ml-2 mr-auto ec-util-truncate">{{label || ""}}</span></span>' +
                            '<ec-dropdown-menu class="dropdown-menu" ng-transclude></ec-dropdown-menu>'
                } else {
                    return '<span class="btn btn-secondary dropdown-toggle"' +
                                   'ng-click="toggle($event)" ng-disabled="ngDisabled">{{label || ""}}</span>' +
                            '<ec-dropdown-menu class="dropdown-menu" ng-transclude></ec-dropdown-menu>'
                }
            }
        };

        return directive;

        function link(scope, element, attrs) {
            var menuElement = angular.element(element.children()[1]);
            var menu = null;

            scope.toggle = toggle;

            activate();

            /**
             * Instantiate the dropdown
             */
            function activate(){
                element.addClass('d-block dropdown');

                // tooltip handling - attrs were pushed down to child elements of <ec-dropdown />
                if (attrs.toggle) {
                    element.removeAttr('data-toggle');
                }

                if (attrs.title) {
                    element.removeAttr('title');
                    element.removeAttr('tooltip');
                }
                if (attrs.placement) {
                    element.removeAttr('data-placement');
                }

                scope.$on('$destroy', destroyMenu);
            }


            /**
             * Toggle the dropdown's menu on a click event based on the following
             * conditions:
             *      1. If the body tag was the event target, hide all dropdown menus
             *         and remove the body click event listener.
             *      2. If the event target was a dropdown-toggle and the dropdown menu is
             *         not visible, hide other possible visible menus and then show the
             *         current menu and add a body click event listener.
             *      3. If the event target was a dropdown-toggle and the dropdown menu
             *         has not been appended to the body, append the menu and add
             *         the body click event listener.
             *      4. If the event target was a dropdown-toggle and the dropdown menu is
             *         visible, remove the body click event listener and then hide the menu.
             * @param {Object} event mouseclick event
             */
            function toggle(event) {
                var target = angular.element(event.currentTarget);
                event.stopPropagation();

                if (target[0].tagName == 'BODY') {
                    removeBodyListener();
                    angular.element('ec-dropdown-menu').addClass('ng-hide');
                } else if (target.hasClass('dropdown-toggle')) {
                    if (menu && menuElement.hasClass('ng-hide')) {
                        angular.element('ec-dropdown-menu').addClass('ng-hide')
                        menuElement.removeClass('ng-hide');
                        addBodyListener();
                    } else if (!menu) {
                        angular.element('ec-dropdown-menu').addClass('ng-hide')
                        appendMenu();

                        // Position the menu again because tether doesn't always get it right the first time.
                        menu.position();
                        addBodyListener();
                    } else {
                        removeBodyListener();
                        menuElement.addClass('ng-hide');
                    }
                }
            }

            /**
             * Add a clieck event listener so that we can hide the menu when
             * clicking outside of the menu.
             */
            function addBodyListener() {
                scope.bodyListener = angular.element('body').on('click', toggle);
            }

            /**
             * Remove the body click event listener
             */
            function removeBodyListener() {
                scope.bodyListener.off('click');
            }

            /**
             * Destroy the dropdown menu when the directive scope is destroyed
             */
            function destroyMenu() {
                if (menu) {
                    menuElement.remove();
                    menu.destroy();
                }

                if (scope.bodyListener) {
                    removeBodyListener();
                }
            }

            /**
             * Attach the dropdown menu element to the body with tether.js
             */
            function appendMenu() {
                // Display the menu but make it invisible so that tether can calculate the position it before we display it.
                menuElement.css({ "display": "block", "visibility": "hidden" });
                // Make sure we don't have a class overriding our inline styles
                menuElement.removeClass('ng-hide');

                if (attrs.menuMatchWidth) {
                    menuElement.css({"width": element[0].offsetWidth});
                    menuElement.addClass('dropdown-menu-match-width');
                }

                var x = (attrs.position && attrs.position == 'right' || attrs.position == 'left') ? attrs.position : 'right';

                menu = new Tether({
                    element: menuElement,
                    target: element,
                    attachment: 'top ' + x,
                    targetAttachment: 'bottom ' + x,
                    offset: '-2px 0'
                });

                // Now that the menu is ready, make it visible
                menuElement.css({"visibility": "visible"});
            }
        }
    }

    function ecDropdownItem() {
        var directive = {
            replace: true,
            restrict: 'E',
            transclude: true,
            link: link,
            template: '<a href="" class="dropdown-item" ng-transclude></a>'
        };

        return directive;

        function link(scope, element, attrs) {
            if (attrs.ngDisabled) {
                element.addClass('disabled');
            }
        }
    }

    function ecDropdownHeader() {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<h6 class="dropdown-header" ng-transclude></h6>',
            transclude: true
        }

        return directive;
    }

    function ecDropdownDivider() {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div class="dropdown-divider"></div>'
        };

        return directive;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .directive('ecFileReader', EcFileReader);

    EcFileReader.$inject = ['$q', 'apiResource'];

    function EcFileReader($q, apiResource) {

        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'assets/templates/ec_controls/ecFileReader.html',
            scope: { 
                fileResults: '=',
                fileName: '=?',
                accept: '@',
                labelText: '@',
                placeholderText: '@?'
            },
            link: function (scope, element, attrs) {

                // push the required attribute down to internal input element
                var internalInput = element.find("input");
                if (element.attr("required")) {
                    internalInput.attr("required", element.attr("required"));
                }

                if (element.attr("disabled")) {
                    internalInput.attr("disabled", element.attr("disabled"));
                }

                // use optional input 'placeholderText' if defined, default otherwise
                scope.placeholderText = scope.placeholderText || 'Choose file...';

                element.bind('change', function (e) {
                    var element = e.target;
                    if (!element.value) {
                        return;
                    }

                    // display the file name
                    scope.fileName = element.value.split('\\').pop();

                    readFile(element.files[0]).then(function (result) {
                        scope.fileResults = result;
                    });

                    /*eslint-disable */
                    function readFile(file) {
                        var deferred = $q.defer();
                        var reader = new FileReader();

                        reader.onload = function (e) {
                            var base64String = e.target.result.split(",")[1];
                            deferred.resolve(base64String);
                        }
                        reader.onerror = function (e) {
                            deferred.reject(e);
                        }
                        
                        reader.readAsDataURL(file);

                        return deferred.promise;

                    }
                    /*eslint-enable */
                });

            }

        };

    }

})();

    

﻿(function () {
    'use strict';

    angular
		.module('app')
		.directive('ecNumericBox', EcNumericBox);

    EcNumericBox.$inject = ['$timeout', '$filter'];
   
    function EcNumericBox($timeout, $filter) {
        return {
            restrict: 'E',
            replace: true,
            require: 'ngModel',
            scope: {
                ecNgModel: '=',
                // Exposes a way to call a function on the parent controller after the control has blured and any sanitizing has happened
                // Watching ng-blur from the parent controller does not know if the value has changed based on sanitizing since we do work during blur here
                ecNgBlur: '=' 
            },
            template: '<input class="form-control" ng-model="ecNgModel">',
            link: function ($scope, $element, $attrs, $ngModelCtrl) {
                var vm = this;
                var filter = null;
                var displayFilter = $attrs.displayFilter;
                var restrict = $attrs.restrict;
                
                (function constructor() {

                    filter = parseFilter();

                    // keydown listeners takes care of resticting inputs to provided regexes
                    $element.bind('keydown', onkeydown);
                    $element.bind('blur', onblur);
                    $element.bind('focus', onfocus);

                    // need to set symbols on value when value comes from model
                    // example: first time loading on edit screens where model is already set
                    $ngModelCtrl.$formatters.push(function () {
                        $timeout(onblur);
                    });

                    $attrs.$observe('displayFilter', function (value) {
                        if (value) {
                            displayFilter = value;
                            filter = parseFilter();
                        }
                    });

                })();


                function onkeydown(event) {

                    var key = event.keyCode;

                    // don't run regex match function if key pressed is "tab" key
                    if (key == 9) {
                        return;
                    }

                    // retain characters which matches the provided regex
                    $timeout(function () {
                        //If the ecNgModel is empty no reason to continue
                        if (modelIsEmpty()) {
                            return;
                        }

                        var originalValue = $scope.ecNgModel;
                        var regex = new RegExp(restrict, "g");
                        var cleanedValue = originalValue.toString().match(regex) ? originalValue.toString().match(regex).join('') : '';

                        //only overwrite the value in the model if we had to strip invalid characters to avoid shifting the cursor on them
                        if (cleanedValue !== originalValue) {
                            $ngModelCtrl.$setViewValue(cleanedValue);
                            $element.val(cleanedValue);
                        }
                    });
                }

                function onblur() {
                    //If the ecNgModel is empty no reason to continue
                    if (modelIsEmpty()) {
                        return;
                    }

                    sanitize();

                    // if we don't have a display-filter defined, just show the value
                    $timeout(function () {
                        var displayValue = displayFilter ? $filter(filter.name)($scope.ecNgModel.toString(), filter.operation, filter.text) : $scope.ecNgModel;

                        // affix the sign to the value
                        // example: 234234 to $234,234
                        $element.val(displayValue);

                        // Call the ec-ng-blur function if specified
                        if ($scope.ecNgBlur) {
                            $scope.ecNgBlur();
                        }
                        
                    });
                    
                }

                function onfocus() {
                    //If the ecNgModel is empty no reason to continue
                    if (modelIsEmpty()) {
                        return;
                    }

                    // when input is focussed show only the value
                    // get rid of the sign
                    // example: $234,234 to 234234
                    $element.val($scope.ecNgModel);

                    // on focus we have to explicitly select the text inside the control
                    // for other controls it is doing it for default
                    $element[0].setSelectionRange(0, $scope.ecNgModel.length);
                }


                function sanitize() {
                    var min = $element.attr('min');
                    var max = $element.attr('max');
                    var decimals = $element.attr('decimals');
                    var originalValue = $scope.ecNgModel;
                    var cleanedValue = $scope.ecNgModel;

                    // restrict to min/max
                    cleanedValue = min && +cleanedValue < min ? min : cleanedValue;
                    cleanedValue = max && +cleanedValue > max ? max : cleanedValue;

                    // restrict to number of decimals
                    // run .toFixed logic ONLY for double values.. skip it for integers
                    cleanedValue = decimals && (+cleanedValue % 1) !== 0 ? (+cleanedValue).toFixed(decimals) : cleanedValue;
                    
                    if (cleanedValue !== originalValue) {
                        $ngModelCtrl.$setViewValue(cleanedValue);
                    }
                }

                function parseFilter() {
                    if (!displayFilter) {
                        return null;
                    }
                        
                    var displayFilterArray = displayFilter.split(":");
                    var index = 0;
                    var displayFilterObject = [];

                    // should match the affix filter param sequence
                    // input will always be $scope.ecNgModel
                    var props = ["name", "operation", "text"];

                    displayFilterObject = displayFilterArray.reduce(function (object, item) {
                        object[props[index++]] = item;
                        return object;
                    }, {});

                    return displayFilterObject;
                }

                //returns true if the model is null, undefined, or empty **BUT NOT ZERO**. This avoids treating zero as invalid which was causing it to fail to fill the box when loading the first time.
                function modelIsEmpty() {
                    var model = $scope.ecNgModel;
                    return model === null || angular.isUndefined(model) || model === '';
                }

            }
            
        };
    }

})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .directive('ecPeriodPicker', EcPeriodPicker);

    EcPeriodPicker.$inject = ['$timeout', '$translate', 'translationHelper', 'userService'];

    function EcPeriodPicker($timeout, $translate, translationHelper, userService) {
        return {
            restrict: 'E',
            require: 'ngModel',
            compile: function compile(templateElement, templateAttrs) {
                var elementAttrs = "";

                for (var prop in templateAttrs) {
                    if (!_.startsWith(prop, '$')) {
                        var dashProp = prop.replace(/([A-Z])/g, '-$1');
                        elementAttrs += dashProp + "='" + templateAttrs[prop] + "' ";
                    }
                }

                var placeHolder = translationHelper.placeholder().MonthYYYY;


                //Need to put date format in correct casing for kendo
                var dateFormat = userService.getUser().preference.dateFormat.replace(/m/g, "M").replace(/D/g, "d").replace(/Y/g, "y");

                var translatedToday = $translate.instant('Today').replace(/'/g, "\\'");

                var template = '<kendo-date-picker k-footer="\'' + translatedToday + '\'" ' +
                                ' placeholder="' + placeHolder + '"' +
                                ' k-format="\'MMM yyyy\'" ' +
                                ' k-parse-formats="[\'MMM yyyy\', \'' + dateFormat + '\']"' +
                                ' k-suggest="true" ' +
                                ' k-options="monthPickerOption" ' +
                                ' ' + elementAttrs +
                                ' ></kendo-date-picker>';

                templateElement.html(template).show();

                return {
                    pre: function preLink(scope) {
                        scope.monthPickerOption = {
                            // shows the months of the year
                            start: "year", // kicks in when calender is rendered
                            depth: "year" // kicks in when date is selected
                        }
                    },
                    post: function postLink(scope, element, attrs, ngModelCtrl) {

                        var inputElement = element.find("input");

                        var minDate = moment('1900-01-01');
                        var maxDate = moment('2099-01-01')

                        // remove the template element
                        element.children().unwrap();

                        inputElement.bind('blur', function () {
                            sanitizeDate();
                        });

                        function sanitizeDate() {

                            $timeout(function () {

                                //Check if kendo parsed a valid month year
                                // Forcing english as the date locale since our control doesn't support other languages
                                var testDate = moment(ngModelCtrl.$modelValue, 'MMM YYYY', "en", true);
                                if (testDate.isValid() && testDate.year() > 1899 && testDate.year() < 2099) {
                                    return;
                                }

                                //Kendo could not parse the value into MMM YYYY
                                //If the value is completely invalid blank out the value
                                //If we can make a date and it was less than the min or greater than the max set it accordingly

                                //Convert the date format to allow 1 digit month or day values
                                var dateFormat = userService.getUser().preference.dateFormat.replace(/MM/ig, "M").replace(/DD/ig, "D");
                                testDate = moment(ngModelCtrl.$modelValue, dateFormat, true);

                                if (!testDate.isValid()) {
                                    //If the model is not a valid date clear it out
                                    _.set(scope, attrs.ngModel, '');
                                }
                                else if (testDate < minDate) {
                                    // check for min date validation
                                    _.set(scope, attrs.ngModel, minDate.format('MMM YYYY'));
                                }
                                else if (testDate > maxDate) {
                                    // check for max date validation
                                    _.set(scope, attrs.ngModel, maxDate.format('MMM YYYY'));
                                }

                            });
                        }

                    }
                };
            }
        };
    }

})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .directive('ecSlider', EcSlider);

    EcSlider.$inject = ['$translate'];

    function EcSlider($translate) {
        return {
            restrict: 'E',
            replace: true,
            template: '<input kendo-slider k-drag-handle-title="\'' + $translate.instant('drag') + '\'" />',
            link: function (scope, element, attr) {

                var inputWatcher = scope.$watch(function (scope) {
                    if (element.data('kendoSlider')) {
                        return element;
                    }
                }, function (value) {

                    if (value != undefined) {

                        // add the tick symbol to each tick label
                        if (attr.ecTickSymbol) {
                            var allTicks = element.siblings(".k-slider-items").find("span");
                            _.forEach(allTicks, function (tick) {
                                tick.innerHTML = tick.innerHTML + attr.ecTickSymbol;
                            });
                        }

                        // push down the tabindex to the anchor tag of slider
                        element.siblings().find("a").attr("tabindex", attr.ecTabindex);
                    }

                });

                window.addEventListener('resize', resize);

                scope.$on('$destroy', function() {
                    window.removeEventListener('resize', resize);
                });

                function resize() {
                    var slider = element.getKendoSlider();
                    slider.resize();
                }
            }
        };
    }

})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .directive('ecTextBox', EcTextBox);

    EcTextBox.$inject = ['$timeout'];

    function EcTextBox($timeout) {
        return {
            restrict: 'E',
            replace: true,
            require: 'ngModel',
            template: "<input class='form-control' type='text'>",
            link: function ($scope, $element, $attrs, $ngModelCtrl) {

                var restrict = $attrs.restrict;
                var restrict = $attrs.restrict;

                (function constructor() {

                    if (!_.isUndefined(restrict)) {
                        // keydown listeners takes care of resticting inputs to provided regexes
                        $element.bind('keydown', onkeydown);
                    }

                    if ($attrs.uppercase) {
                        $element.bind('blur', onblur);
                        $element.addClass('text-uppercase');
                    }

                })();


                function onkeydown(event) {
                    // don't run regex match function if key pressed is "tab" key
                    if (event.keyCode == 9) {
                        return;
                    }

                    // retain characters which matches the provided regex
                    $timeout(function () {
                        var regex = new RegExp(restrict, "g");
                        var allowedCharacters = $element.val().match(regex);
                        $element.val(allowedCharacters ? allowedCharacters.join('') : '');

                        $ngModelCtrl.$setViewValue($element.val());
                    });
                }

                function onblur() {
                    $ngModelCtrl.$setViewValue($element.val().toUpperCase().trim());
                }
            }
        };
    }

})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .directive('ecToggle', EcToggle);

    EcToggle.$inject = [];

    function EcToggle() {
        return {
            restrict: 'E',
            replace: true,
            require: 'ngModel',
            scope: {
                items: '=',
                tabindex: '@'
            },
            templateUrl: 'assets/templates/ec_controls/ecToggle.html',
            link: link
        };

        function link($scope, $element, $attrs, $ngModelCtrl) {
 
            $scope.$watch($attrs.ngDisabled, function (value) {
                $scope.disabled = value;
            });

            $scope.groupName = _.uniqueId('group_');

            $scope.setViewValue = function (event) {
                if (!$scope.disabled) {
                    $scope.selectedItem = event.currentTarget.attributes.for.value;
                    $ngModelCtrl.$setViewValue($scope.selectedItem);
                }
            };

            $ngModelCtrl.$render = function () {
                $scope.selectedItem = $ngModelCtrl.$viewValue;
            };

            if ($attrs.tabindex) {
                $element.removeAttr('tabindex');
            }
        }
    }
})();
﻿(function () {
    'use strict';

    angular.module('app').factory('filterContext', FilterContext);
    FilterContext.$inject = ['$translate'];

    function FilterContext($translate) {
        var filterDelimeter = "¦";

        var filterContext = {
        };

        // All value type directives that require a special directive.  We look these up based on caption
        filterContext.valueDirectivesByCaption = function (caption) {
            var operators = {
                            "like": "filter-string",
                            "not like": "filter-string"
            } ;

            switch(caption){
                case 'Data Displayed': {
                    operators.default = "filter-data-displayed";
                    break;
                };
                case 'Meter and Channel (by Code)': {
                    operators.default = "filter-channel-by-meter value-property='\"meterCode\"'";
                    break;
                };
                case 'Meter and Channel (by Name)': {
                    operators.default = "filter-channel-by-meter value-property='\"meterInfo\"'";
                    break;
                };
                case 'Channel Interval': {
                  operators.default = "filter-channel-interval is-esa='false'";
                  break;
                };
                case 'ESA Channel Interval': {
                    operators.default = "filter-channel-interval is-esa='true'";
                    break;
                  };
                case 'Chargeback Workflow Step': {
                  operators.default = "filter-chargeback-workflow-step";
                  break;
                };
                case 'Text': {
                    operators.default = "filter-text";
                    break;
                };
                case 'Fiscal Year': {
                    operators.between = "filter-between-year",
                    operators.default = "filter-year";
                    break;
                };
                // [ECAP-6614] Case added for "Report Title" filter in report "HC01 - Monthly Energy Consumption", which needs to display as a textbox.
                // HC01 is a custom report for Hennepin County. This filter caption is shared by identical use cases in the following reports:
                // PE02 - PLACE ENERGY PROFILE.RPT (PWI Engineering; pwi)
                // PE25 - EXECUTIVE COST PROFILE.RPT (PWI Engineering; pwi)
                // SF02A - ANNUAL ENERGY SUMMARY BY BUILDING.RPT (San Francisco Public Utilities Commission; sfpuc)
                // SF02 - ANNUAL ENERGY SUMMARY BY DEPARTMENT.RPT (San Francisco Public Utilities Commission; sfpuc)
                // SF01 - MONTHLY ENERGY SUMMARY.RPT (San Francisco Public Utilities Commission; sfpuc)
                // TODO: The items above pertain to known hosted clients; it is unknown how many self-hosted clients have similar scenarios.
                case 'Report Title': {
                    operators.default = "filter-string";
                    break;
                };
                case 'Flag Status':
                case 'Flag Issue Status': {
                    operators.default = "filter-boolean yes-caption='\"Resolved_TC\"' no-caption='\"Unresolved_TC\"'";
                    break;
                };

                default: {
                    return undefined;
                };
            }
            return { operators: operators };
        };

        // All data type directives that we fall back to if we don't have a custom caption directive
        filterContext.valueDirectivesByDataType = {
            'select': {
                operators: {
                    "one of": "filter-one-of-string",
                    "not one of": "filter-one-of-string",
                    "between": "filter-between-string",
                    "not between": "filter-between-string",
                    "like": "filter-string",
                    "not like": "filter-string",
                    "default": "filter-dropdown"
                }
            },
            'hyperlink': {
                operators: {
                    "one of": "filter-one-of-string",
                    "not one of": "filter-one-of-string",
                    "between": "filter-between-string",
                    "not between": "filter-between-string",
                    "like": "filter-string",
                    "not like": "filter-string",
                    "default": "filter-dropdown"
                }
            },
            'string': {
                operators: {
                    "one of": "filter-one-of-string",
                    "not one of": "filter-one-of-string",
                    "between": "filter-between-string",
                    "not between": "filter-between-string",
                    "like": "filter-string",
                    "not like": "filter-string",
                    "default": "filter-dropdown"
                }
            },
            'boolean': {
                operators: {
                    "default": "filter-boolean yes-caption='\"yes\"' no-caption='\"no\"'"
                }
            },
            'integer': {
                operators: {
                    "between": "filter-between-integer",
                    "not between": "filter-between-integer",
                    "default": "filter-integer"
                }
            },
            'double': {
                operators: {
                    "between": "filter-between-double",
                    "not between": "filter-between-double",
                    "default": "filter-double"
                }
            },
            'date': {
                operators: {
                    "between": "filter-between-date",
                    "not between": "filter-between-date",
                    "today": "filter-no-value",
                    "yesterday": "filter-no-value",
                    "last 7 days": "filter-no-value",
                    "last 14 days": "filter-no-value",
                    "last 30 days": "filter-no-value",
                    "last 60 days": "filter-no-value",
                    "last 90 days": "filter-no-value",
                    "default": "filter-date"
                }
            },
            'datetime': {
                operators: {
                    "between": "filter-between-date",
                    "not between": "filter-between-date",
                    "today": "filter-no-value",
                    "yesterday": "filter-no-value",
                    "last 7 days": "filter-no-value",
                    "last 14 days": "filter-no-value",
                    "last 30 days": "filter-no-value",
                    "last 60 days": "filter-no-value",
                    "last 90 days": "filter-no-value",
                    "default": "filter-date"
                }
            },
            'datetimeoffset': {
                operators: {
                    "between": "filter-between-date",
                    "not between": "filter-between-date",
                    "today": "filter-no-value",
                    "yesterday": "filter-no-value",
                    "last 7 days": "filter-no-value",
                    "last 14 days": "filter-no-value",
                    "last 30 days": "filter-no-value",
                    "last 60 days": "filter-no-value",
                    "last 90 days": "filter-no-value",
                    "default": "filter-date"
                }
            },
            'dateperiod': {
                operators: {
                    "between": "filter-between-date-period",
                    "not between": "filter-between-date-period",
                    "current month": "filter-no-value",
                    "prior month": "filter-no-value",
                    "prior year": "filter-no-value",
                    "prior fiscal year": "filter-no-value",
                    "prior 12 months*": "filter-no-value",
                    "prior 12 months**": "filter-no-value",
                    "prior 12 months(offset by x)": "filter-no-value",
                    "year-to-date*": "filter-no-value",
                    "year-to-date**": "filter-no-value",
                    "fiscal year-to-date*": "filter-no-value",
                    "fiscal year-to-date**": "filter-no-value",
                    "default": "filter-date-period"
                }
            },
            'accountperiod': {
                operators: {
                    "between": "filter-between-account-period",
                    "not between": "filter-between-account-period",
                    "default": "filter-account-period"
                }
            },
            'percent': {
                operators: {
                    "between": "filter-between-double",
                    "not between": "filter-between-double",
                    "default": "filter-double"
                }
            }
        };

        filterContext.valueDirectivesForBoolean = function(dataFieldId){
            var directive = "filter-boolean yes-caption='\"yes\"' no-caption='\"no\"'";
            switch (dataFieldId) {
                case 12: {
                    //Account is Active
                    directive = "filter-boolean yes-caption='\"filteractive\"' no-caption='\"filterinactive\"'";
                    break;
                };
                case 102:{
                    //Bill is Void
                    directive = "filter-boolean yes-caption='\"filtervoid\"' no-caption='\"filternotvoid\"'";
                    break;
                };
                case 113: {
                    //Bill is estimated
                    directive = "filter-boolean yes-caption='\"filterestimated\"' no-caption='\"filternotestimated\"'";
                    break;
                };
                case 125:{
                    //Bill is approved
                    directive = "filter-boolean yes-caption='\"filterapproved\"' no-caption='\"filternotapproved\"'";
                    break;
                };
                case 883: {
                    //Bill is from vendor
                    directive = "filter-boolean yes-caption='\"filterfromvendor\"' no-caption='\"filternotfromvendor\"'";
                    break;
                };
                case 897: {
                    //Bill has been split
                    directive = "filter-boolean yes-caption='\"filtersplit\"' no-caption='\"filternotsplit\"'";
                    break;
                };
                case 898: {
                    //Bill Import Verified
                    directive = "filter-boolean yes-caption='\"filterverified\"' no-caption='\"filterunverified\"'";
                    break;
                };
                case 900: {
                    //Batch is Open
                    directive = "filter-boolean yes-caption='\"filterbatchopen\"' no-caption='\"filterbatchclosed\"'";
                    break;
                };

                default:{
                    break;
                };
            }
            return directive;
        };

        filterContext.getValueDirective = function (caption, dataTypeCode, operator, dataFieldId) {

            var directive = "";
            var normalizedDataTypeCode = dataTypeCode ? dataTypeCode.toLowerCase() : "";

            // First check to see if our caption is a special case
            var options = filterContext.valueDirectivesByCaption(caption);
            if (options !== undefined) {
                // We have a special caption, now let's see if the operator is special so we know which directive to return
                if (options.operators[operator]) {
                    directive = options.operators[operator];
                } else {
                    directive = options.operators.default;
                }
            } else {
                // We have a common filter, let's see if the operator is special so we know which directive to return
                if (dataTypeCode == 'boolean') {
                    //lets give it some good toggles instead of yes/no
                    directive = filterContext.valueDirectivesForBoolean(dataFieldId);
                }
                else {
                    var directiveOptions = filterContext.valueDirectivesByDataType[normalizedDataTypeCode];

                    if (!directiveOptions && normalizedDataTypeCode === 'datetimeoffset') {
                        directiveOptions = filterContext.valueDirectivesByDataType.datetime;
                    }

                    if (!directiveOptions) {
                        directiveOptions = filterContext.valueDirectivesByDataType.string;
                    }

                    if (directiveOptions.operators[operator]) {
                        directive = directiveOptions.operators[operator];
                    } else {
                        directive = directiveOptions.operators.default;
                    }
                }
            }

            // return the html directive to be rendered on the screen
            return "<" + directive + " ></" + directive + ">";
        };

        filterContext.getSingleFilterValue = function (value) {
            // Check if the value coming in has our split pipe character which would indicate this was once
            // a between or one of type filter.  We can't just throw that value in the input so we will take the
            // "from" value in a between, or the first in a one of
            if (value !== null) {
                if (value.indexOf(filterDelimeter) > -1) {
                    return value.split(filterDelimeter)[0];
                }
            }
            return value;
        };

        filterContext.getSinglePeriodFilterValue = function (value) {
            var valueObject = {};

            // Check to see if we have this filter set and if so, find the period saved to select in the dropdown
            if (value !== null) {
                // Check if the value coming in has our split pipe character which would indicate this was once
                // a between type filter.  Take the To side of the between for our equals value if the length is valid
                if (value.indexOf(filterDelimeter) > -1 && value.split(filterDelimeter)[0].length === 6) {
                    valueObject.year = value.split(filterDelimeter)[0].substring(0, 4);
                    valueObject.period = value.split(filterDelimeter)[0].substring(4);
                    // No split pipe found, checking that it's the appropriate length saved in case of invalid values
                } else if (value.length === 6) {
                    valueObject.year = value.substring(0, 4);
                    valueObject.period = value.substring(4);
                }
            }

            return valueObject;
        };

        filterContext.getOneOfValues = function (value) {
            if (value !== null) {
                if (value.indexOf(filterDelimeter) > -1) {
                    return value.split(filterDelimeter);
                } else {
                    return [value];
                }
            }
            return value;
        };

        filterContext.getBetweenFilterValues = function (value) {
            // Check if the value coming in does not have our split pipe character which would indicate this was once
            // a single control type filter.  Default the from control to this value
            var betweenValues = {};

            if (value !== null) {
                if (value.indexOf(filterDelimeter) === -1) {
                    betweenValues.from = value;
                } else {
                    betweenValues.from = value.split(filterDelimeter)[0];
                    betweenValues.to = value.split(filterDelimeter)[1];
                }
            }
            return betweenValues;
        };

        filterContext.getBetweenPeriodFilterValues = function (value) {
            var betweenValues = {};

            // Check to see if we have this filter set and if so, find the period saved to select in the dropdown
            if (value !== null) {
                // Check if the value coming in has our split pipe character which would indicate this was once
                // a between type filter.  Take the To side of the between for our equals value if the length is valid
                if (value.indexOf(filterDelimeter) > -1) {
                    var filterValues = value.split(filterDelimeter);

                    // Check to make sure the value is a valid length to split up
                    if (filterValues[0].length === 6) {
                        betweenValues.fromValues = {
                            year: filterValues[0].substring(0, 4),
                            period: filterValues[0].substring(4)
                        };
                    }

                    // Check to make sure the value is a valid length to split up.
                    if (filterValues[1].length === 6) {
                        betweenValues.toValues = {
                            year: filterValues[1].substring(0, 4),
                            period: filterValues[1].substring(4)
                        };
                    }
                    // No split pipe found, checking that it's the appropriate length saved in case of invalid values
                } else if (value.length === 6) {
                    betweenValues.fromValues = {
                        year: value.substring(0, 4),
                        period: value.substring(4)
                    };
                }
            }

            return betweenValues;
        };

        filterContext.makeBetweenValue = function (from, to) {
            // If we have nothing do not save a delimeter only
            if (!from && !to) {
                return null;
            }

            var value = "";

            if (from) {
                value = from;
            }

            value += filterDelimeter;

            if (to) {
                value += to;
            }

            return value;
        };

        filterContext.makeOneOfValue = function (values) {
            if (values !== null) {

                return values.join(filterDelimeter);
            }
            else {
                return null;
            }
        };

        return filterContext;
    }
})();
﻿(function () {
    'use strict';

    angular.module('app').component('ng1Filters', {
        template:'<filters filter-set="$ctrl.filterSet" no-filter-selected-message="{{$ctrl.noFilterSelectedMessage}}" translate-context="$ctrl.translateContext" set-auto-focus="$ctrl.setAutoFocus" validate="$ctrl.validate"></filters>',
        controller: function() {},
        controllerAs: '$ctrl',
        bindings: {
            filterSet: '=',
            noFilterSelectedMessage: '@',
            validate: '=',
            setAutoFocus : '=',
            translateContext: '<'
        },
    });

    angular.module('app').directive('filters', Filters);
    angular.module('app').directive('availableFilters', AvailableFilters);
    angular.module('app').directive('setFilters', SetFilters);
    angular.module('app').directive('filterOperator', Operator);
    angular.module('app').directive('removeFilter', RemoveFilter);
    angular.module('app').directive('readOnlyFilter', ReadOnlyFilter);

    Filters.$inject = [];
    AvailableFilters.$inject = [];
    SetFilters.$inject = [];
    Operator.$inject = [];
    RemoveFilter.$inject = [];
    ReadOnlyFilter.$inject = [];

    function Filters() {
        return {
            restrict: 'E',
            templateUrl: 'assets/templates/ec_filters/filters.html',
            transclude: false,
            scope: {
                filterSet: '=',
                noFilterSelectedMessage: '@',
                validate: '=',
                setAutoFocus : '=',
                translateContext: '<'
            },
            controllerAs: 'ctrl',
            bindToController: true,
            controller: function ($element, $translate, translateCorepopPipe) {
                this.$onInit = function() {
                    var vm = this;
                    vm.validate = validate;
                    vm.hideAvailableFilters = false;

                    (function constructor() {
                        $element.addClass('d-flex');

                        // remove anything that is missing a caption
                        vm.filterSet = _.filter(vm.filterSet, function (filter) {
                          if(filter.caption) {
                            filter.translatedCaption = translateCorepopPipe.transform(filter.caption, filter.caption, 'filter', vm.translateContext, 'label');
                            getHelpText(filter);

                            // Used to make it easier to harvest the loco format that will match, this is used by DUX/Devs 
                            // when adding new keys to Loco
                            filter.translateContextHelpKey = translateCorepopPipe.getTranslationKey(filter.caption, 'filter', vm.translateContext.toString(), 'help');
                            filter.translateContextLabelKey = translateCorepopPipe.getTranslationKey(filter.caption, 'filter', vm.translateContext.toString(), 'label');
                            
                            return true;
                          }
                          return false;
                        });

                    })();

                    /**
                     * Set the filter's help property.  If help is defined for filter, an ec-help-popover
                     * will appear next to it (see setFilters.html). 
                     */
                    function getHelpText(filter) {
                        filter.helpText = translateCorepopPipe.transform(filter.caption, undefined, 'filter', vm.translateContext, 'help');
                    }

                    function validate() {
                        // We'll start out optimistic thinking all are great, and if not,
                        // the first filter to return false will overwrite this and we'll flag the filterSet
                        // as invalid
                        var allFiltersValid = true;
                        angular.forEach(vm.filterSet, function (filter) {
                            if (filter.selected && filter.validator) {
                                if (!filter.validator.validate()) {
                                    allFiltersValid = false;
                                }
                            }
                        });

                        return allFiltersValid;
                    }
                }
            }
        };
    }

    function AvailableFilters() {
        return {
            restrict: 'E',
            require: '^^filters',
            templateUrl: 'assets/templates/ec_filters/availableFilters.html',
            transclude: false,
            replace: true,
            scope: {
                filterSet: '=',
                setAutoFocus : '='
            },
            controllerAs: 'ctrl',
            bindToController: true,
            controller: function () {
                this.$onInit = function() {
                    var vm = this;

                    vm.filterCheckboxChange = filterCheckboxChange;

                    vm.recommendedFilters = [];
                    vm.optionalFilters = [];
                    vm.autoFocus = vm.setAutoFocus;

                    (function constructor() {
                        // Remove all filters that are marked as hidden
                        // Filters with a value but hidden will still be sent along when saved
                        vm.filterSet = _.filter(vm.filterSet, function (filter) {
                            return filter.hidden == false;
                        });


                        // Loop through all filters and add the selected property if it has a value
                        // This will be used for our checkbox
                        // If unchecking the box clears the value then we may not need this anymore
                        angular.forEach(vm.filterSet, function (filter) {

                            // pre-select filters that have a value set (saved in db) or are required
                            if (filter.value != null || filter.required == true) {
                                filter.selected = true;
                            }

                            // Set the filter's id to use in the template, using regex to get rid of spaces
                            filter.id = filter.caption.replace(/\s/g, '');
                        });

                        vm.recommendedFilters = _.filter(vm.filterSet, function (filter) {
                            return filter.required == false && filter.recommended == true;
                        });

                        vm.optionalFilters = _.filter(vm.filterSet, function (filter) {
                            return filter.required == false && filter.recommended == false;
                        });
                    })();


                    function filterCheckboxChange(item) {
                        // If we are deselecting a filter item then we want to clear the value so when saved
                        // it clears the value from the filter
                        if (!item.selected) {
                            item.value = null;
                            item.operator = null;
                        }
                    }
                }
            },
            link: function(scope, elem, attrs, FiltersCtrl) {
                if (scope.ctrl && scope.ctrl.recommendedFilters.length === 0 && scope.ctrl.optionalFilters.length === 0) {
                    FiltersCtrl.hideAvailableFilters = true;
                }
            }
        };
    }

    // List of filters that have been selected from the available filter list, sorted by caption
    function SetFilters() {
        return {
            restrict: 'E',
            require: '^^filters',
            templateUrl: 'assets/templates/ec_filters/setFilters.html',
            transclude: false,
            replace: true,
            scope: {
                filterSet: '=',
                noFilterSelectedMessage: '@'
            },
            controllerAs: 'ctrl',
            bindToController: true,
            controller: function (customValidator) {
                this.$onInit = function() {
                    var vm = this;

                    vm.isRequired = isRequired;
                    vm.isSelected = isSelected;

                    (function constructor() {
                    })();

                    function isRequired(item) {
                        return item.required == true;
                    }

                    function isSelected(item) {
                        return item.required == false && item.selected == true;
                    }
                }
            }
        };
    }

    // Filter operator, drives the value directive needed for the filter
    function Operator() {
        return {
            restrict: 'E',
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/operator.html',
            transclude: true,
            replace: true,
            scope: {
                filterItem: '='
            },
            controllerAs: 'ctrl',
            bindToController: true,
            controller: function (filterContext, $scope, $translate) {
                this.$onInit = function() {
                    var vm = this;

                    vm.availableOperators = [];
                    vm.operatorChanged = operatorChanged;

                    (function constructor() {
                        vm.validOperator = false;

                        // Loop through to create our operator object array that will have value/translated display
                        angular.forEach(vm.filterItem.availableOperator, function (operator) {

                            // if the filter data type is integer (2)
                            // and the available operator is 'one of' or 'not one of'
                            // skip it unless the currently set operator matches the available operator
                            if (vm.filterItem.dataType.dataTypeId === 2 &&
                                (
                                    (operator === 'one of' && vm.filterItem.operator !== 'one of') ||
                                    (operator === 'not one of' && vm.filterItem.operator !== 'not one of')
                                )
                            ) {
                                return;
                            }

                            // Look to see if our stored operator exists in the available list and if so flag it found
                            if (vm.filterItem.operator && vm.filterItem.operator === operator) {
                                vm.validOperator = true;
                            }


                            // Like/Not like are being translated to say "Starts with/Not starts with" in Localization for now
                            // to be more explicit of what the operator is actually doing.  If we change that operators behavior
                            // to be "anywhere in string" then the translated value will need to be changed to reflect
                            vm.availableOperators.push({
                                value: operator,
                                display: $translate.instant(operator)
                            });
                        });

                        sortPrior12OffsetOperator(vm.filterItem.availableOperator, vm.availableOperators);

                        // If the operator came in set but it's not valid, clear it out and we'll try to default it
                        if (vm.filterItem.operator && !vm.validOperator) {
                            vm.filterItem.operator = null;
                        }

                        // If no operator is set and we have at least one operator in the list, grab the first for default
                        if (!vm.filterItem.operator && vm.filterItem.availableOperator.length > 0) {
                            vm.filterItem.operator = vm.filterItem.availableOperator[0];
                        }

                        // If there is a operator let's set the value directive on load
                        if (vm.filterItem.operator) {
                            vm.filterItem.valueHtml = filterContext.getValueDirective(vm.filterItem.caption, vm.filterItem.dataType.dataTypeCode, vm.filterItem.operator, vm.filterItem.dataFieldId);
                        }
                    })();

                    /**
                     * Used to shuffle the Date Range operator of "prior 12(offset by x)" to be right behind
                     * the others (the API is returning it as the last operator in the array).
                     * @param {string[]} operatorNames List of operators from the API
                     * @param {object[]} availableOperators Operators with their translated display values
                     */
                    function sortPrior12OffsetOperator(operatorNames, availableOperators) {
                        /** Index of the offset operator */
                        var offsetOperatorIndex = operatorNames.indexOf('prior 12 months(offset by x)');

                        // No sorting necessary if operator in question is not present
                        if (offsetOperatorIndex === -1) { return; }

                        /** Operators that should come immediately before the offset operator (in reverse order) */
                        const prior12Operators = ['prior 12 months**','prior 12 months*','prior fiscal year','prior year'];
                        /** Index of the operator that should come immediately before the offset operator */
                        var prior12OperatorIndex = -1;

                        // Look for operator that should come before prior 12 offset operator
                        prior12Operators.forEach(function (priorOperator) {
                            if (prior12OperatorIndex === -1) {
                                prior12OperatorIndex = operatorNames.indexOf(priorOperator);
                            }
                        });

                        // No operators found that should com immediately before the operator in question.
                        // This shouldn't happen, but at least we know after this check that sorting is possible.
                        if (prior12OperatorIndex === -1) { return; }

                        // No sorting necessary if already in order
                        if (offsetOperatorIndex === prior12OperatorIndex + 1) { return; }

                        // Remove the offset operator (splice returns an array)
                        var offsetOperator = availableOperators.splice(offsetOperatorIndex,1)[0];

                        // Insert the offset operator in its proper sorted place
                        availableOperators.splice(prior12OperatorIndex+1,0,offsetOperator);
                    }

                    // If the operator has changed let's refresh our value directive
                    function operatorChanged() {
                        vm.filterItem.valueHtml = filterContext.getValueDirective(vm.filterItem.caption, vm.filterItem.dataType.dataTypeCode, vm.filterItem.operator, vm.filterItem.dataFieldId);
                    }
                }
            }
        };
    }

    function RemoveFilter() {
        return {
            restrict: 'E',
            require: '^^filters',
            templateUrl: 'assets/templates/ec_filters/removeFilter.html',
            transclude: false,
            replace: true,
            scope: {
                filterItem: '='
            },
            controllerAs: 'ctrl',
            bindToController: true,
            controller: function (filterContext) {
                this.$onInit = function() {
                    var vm = this;

                    vm.removeFilter = removeFilter;

                    (function constructor() {

                    })();

                    // Clear the filters value, operator and set it to not selected
                    function removeFilter() {
                        vm.filterItem.value = null;
                        vm.filterItem.operator = null;
                        vm.filterItem.selected = false;
                    }
                }
            }
        };
    }

    /** Potentially unused directive */
    function ReadOnlyFilter() {
        return {
            restrict: 'E',
            templateUrl: 'assets/templates/ec_filters/readOnlyFilter.html',
            transclude: false,
            replace: true,
            scope: {
                caption: '=',
                operator: '=',
                value: '='
            },
            controllerAs: 'ctrl',
            bindToController: true,
            controller: function () {
                this.$onInit = function() {
                    var vm = this;

                    (function constructor() {
                        vm.filterValues = vm.value.split('¦');
                    })();
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterChannelByMeter', ChannelByMeter);

    ChannelByMeter.$inject = [];

    // Filter to find channels by meter.  We pass in the term saved as the filter text, text or code
    function ChannelByMeter() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/channelByMeter.html',
            transclude: false,
            replace: true,
            scope: {
                valueProperty: '='
            },
            controllerAs: 'ctrl',
            bindToController: true,
            controller: function (apiResource, $scope, $translate, channelWrapperService) {            
                this.$onInit = function() {
                    var vm = this;
    
                    vm.meterPlaceHolder = $translate.instant("Meter");
                    vm.channelPlaceHolder = $translate.instant("Channel_TC");
                    vm.filterItem = $scope.$parent.item;
                    vm.tabStart = "5";
    
                    vm.meterComboChanged = meterComboChanged;
                    vm.channelComboChanged = channelComboChanged;
    
                    vm.meterComboTemplate = '<div class="list-template">' +                                            
                                                '   <div class="label">#: data.value #</div>' +
                                                '</div>';
    
                    // Meter combobox datasource, server filtered and using our filterdata api to
                    // bring back the items that match the combobox text, unless there is no items searched for in the combo,
                    // in which case it returns all meters
                    vm.meterData = new kendo.data.DataSource({
                        serverFiltering: true,
                        transport: {
                            read: function (options) {
                                if ( vm.meterCombo.text() !== "") {
                                    apiResource.filterData().filterdata().query({ datafieldId: vm.filterItem.dataFieldId, search: vm.meterCombo.text() }, function (result) {
                                        options.success(result);
                                     });
                                } else {
                                    apiResource.filterData().filterdata().query({ datafieldId: vm.filterItem.dataFieldId }, function (result, headers) {
                                        options.success(result);                                
                                    });
                                }
                            }
                        }
                    });
    
                    (function constructor() {
                        if (vm.filterItem.value !== null) {                       
                           
                                apiResource.meter().meter().query({ filter: "channelId equals '"+ vm.filterItem.value+"'", field:"meterId,meterCode,meterInfo,channels,channelId,channelCode,interval"}, function (result) {                                
                                    var meter = result[0];
    
                                    //if our channel was deleted, we won't have any data
                                    if (meter !== undefined) {
                                        
                                        // Set the meter combo "text" to the property searched on for this filter, 
                                        //we're not going to set a "selected value" for the meter combo at this time
                                        vm.meterCombo.text(meter[vm.valueProperty]);
    
                                        vm.channels = new kendo.data.DataSource({
                                            data: meter.channels.map(function (channel) {
                                                return Object.assign({}, channel, { channelDisplay: channelWrapperService.getChannelCodeDisplay(channel.channelCode) });
                                            })
                                        });
    
                                        // See if our channelId saved for this widget is still a channel for the meter and if so, pick it
                                        vm.selectedChannel = _.find(meter.channels, function (channel) {
                                            return channel.channelId == vm.filterItem.value;
                                        });
                                    }
                                });                                                 
                        }
                    })();                
    
                    function meterComboChanged() {
                        vm.channelCombo.text("");
                        vm.selectedChannel = null;
                        vm.channels = null;
                        if (!angular.isUndefined(vm.selectedMeter) && vm.selectedMeter !== null) {
                            apiResource.meter().meter().query({ filter: vm.valueProperty + " equals '" + vm.selectedMeter.replace(/'/g, "\\'") + "'", field: "meterId,meterCode,meterInfo,channels,channelId,channelCode,interval" }, function (result) {
                                var meter = result[0];                                                                                           
    
                                // See if there is only one channel - if so select it
                                if(meter.channels){
                                    // Set the channels datasource
                                    vm.channels = new kendo.data.DataSource({
                                        data: meter.channels.map(function (channel) {
                                            return Object.assign({}, channel, { channelDisplay: channelWrapperService.getChannelCodeDisplay(channel.channelCode) });
                                        })
                                    });
                                    if( meter.channels.length == 1){
                                        vm.selectedChannel = meter.channels[0];
                                        vm.filterItem.value = vm.selectedChannel.channelId;
                                    }
                                }
                            });
                        }
                    }
    
                    function channelComboChanged() {
                        if (vm.selectedChannel != "") {
                            vm.filterItem.value = vm.selectedChannel.channelId;
                        }
                    }
                }
            }
        };
    }
})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterAccountPeriod', AccountPeriod);

    AccountPeriod.$inject = [];

    function AccountPeriod() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/datatypes/accountPeriod.html',
            transclude: false,
            controllerAs: 'ctrl',
            bindToController: true,
            scope: {
            },
            controller: function ($scope, regexService, apiResource, filterContext, customValidator, $translate) {            
                this.$onInit = function() {
                    var vm = this;
    
                    vm.regexService = {
                        restrictPositiveInteger: regexService.restrictPositiveInteger()
                    };
    
                    vm.filterItem = $scope.$parent.item;
                    vm.updateFilterValue = updateFilterValue;
                    vm.filterItem.inputName = vm.filterItem.dataFieldId;
    
                    if (!vm.filterItem.validator) {
                        $scope.$on("kendoWidgetCreated", function (event, widget) {
                            widget.options.rules.customValidation = customValidationFunction();
                            widget.options.messages.customValidation = customValidationMessagesFunction();
                            widget.options.messages.required = requiredMessagesFunction();
                        });
                    } else {
                        vm.filterItem.validator.options.rules.customValidation = customValidationFunction();
                        vm.filterItem.validator.options.messages.customValidation = customValidationMessagesFunction();
                        vm.filterItem.validator.options.messages.required = requiredMessagesFunction();
                    }
    
                    vm.filterItem.validationOptions = {
                        validateOnBlur: false,
                    };
    
                    (function constructor() {
                        var value = filterContext.getSinglePeriodFilterValue(vm.filterItem.value);
                        if (value.year) {
                            vm.year = value.year;
                        }
                        apiResource.administration().accountPeriods().query(function (result) {
                            vm.accountPeriods = result;
                            angular.forEach(vm.accountPeriods, function (period) {
                                // Append a zero for items less than 10 to the periodNumber, this is how it's expected to be saved to the database
                                period.periodNumber = _.padStart(period.periodNumber.toString(), 2, '0');
    
                                if (value.period && value.period === period.periodNumber) {
                                    vm.period = period.periodNumber;
                                }
                            });
    
                            updateFilterValue();
                        });
                    })();
    
                    // When either value changes, update the value
                    function updateFilterValue() {
                        if (vm.period && vm.year) {
                            vm.filterItem.value = vm.year + vm.period;
                        }
                    }
    
                    function customValidationFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.period) {
                                    return false;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        };
                    }
    
                    function customValidationMessagesFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.period) {
                                    return $translate.instant("is required");
                                } else {
                                    return "";
                                }
                            } else {
                                return "";
                            }
                        };
                    }
    
                    function requiredMessagesFunction() {
                        return function (input) {
                            return customValidator.validationMessages.requiredMessage(input);
                        };
                    }
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterBetweenAccountPeriod', BetweenAccountPeriod);

    BetweenAccountPeriod.$inject = [];

    function BetweenAccountPeriod() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/datatypes/betweenAccountPeriod.html',
            transclude: false,
            controllerAs: 'ctrl',
            bindToController: true,
            scope: {
            },
            controller: function ($scope, regexService, apiResource, filterContext, $translate, customValidator) {            
                this.$onInit = function() {
                    var vm = this;
    
                    vm.regexService = {
                        restrictPositiveInteger: regexService.restrictPositiveInteger()
                    };
    
                    vm.filterItem = $scope.$parent.item;
                    vm.updateFilterValue = updateFilterValue;
    
                    if (!vm.filterItem.validator) {
                        $scope.$on("kendoWidgetCreated", function (event, widget) {
                            widget.options.rules.customValidation = customValidationFunction();
                            widget.options.messages.customValidation = customValidationMessagesFunction();
                            widget.options.messages.required = requiredMessagesFunction();
                        });
                    } else {
                        vm.filterItem.validator.options.rules.customValidation = customValidationFunction();
                        vm.filterItem.validator.options.messages.customValidation = customValidationMessagesFunction();
                        vm.filterItem.validator.options.messages.required = requiredMessagesFunction();
                    }
    
                    // Range validation can happen here at a later date
                    vm.filterItem.validationOptions = {
                        validateOnBlur: false,
                    };
    
                    (function constructor() {
                        var values = filterContext.getBetweenPeriodFilterValues(vm.filterItem.value);
                        apiResource.administration().accountPeriods().query(function (result) {
                            vm.accountPeriods = result;
                            angular.forEach(vm.accountPeriods, function (period) {
                                // Append a zero for items less than 10 to the periodNumber, this is how it's expected to be saved to the database
                                period.periodNumber = _.padStart(period.periodNumber.toString(), 2, '0');
                                if (values.fromValues && values.fromValues.period === period.periodNumber) {
                                    vm.fromPeriod = period.periodNumber;
                                    vm.fromYear = values.fromValues.year;
                                }
    
                                if (values.toValues && values.toValues.period === period.periodNumber) {
                                    vm.toPeriod = period.periodNumber;
                                    vm.toYear = values.toValues.year;
                                }
                            });
    
                            updateFilterValue();
                        });
                    })();
    
                    // When either value changes, update the value
                    function updateFilterValue() {
                        vm.filterItem.value = filterContext.makeBetweenValue(vm.fromPeriod && vm.fromYear ? vm.fromYear + vm.fromPeriod : null,
                            vm.toPeriod && vm.toYear ? vm.toYear + vm.toPeriod : null);
                    }
    
                    function customValidationFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.fromPeriod || !vm.fromYear || !vm.toPeriod) {
                                    return false;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        };
                    }
    
                    function customValidationMessagesFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.fromPeriod || !vm.fromYear || !vm.toPeriod) {
                                    return $translate.instant("is required");
                                } else {
                                    return "";
                                }
                            } else {
                                return "";
                            }
                        };
                    }
    
                    function requiredMessagesFunction() {
                        return function (input) {
                            return customValidator.validationMessages.requiredMessage(input);
                        };
                    }
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterBetweenDate', BetweenDate);

    BetweenDate.$inject = [];

    function BetweenDate() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/datatypes/betweenDate.html',
            transclude: false,
            controllerAs: 'ctrl',
            bindToController: true,
            scope: {
            },
            controller: function ($scope, filterContext, customValidator, $translate, userService) {            
                this.$onInit = function() {
                    var vm = this;
                    vm.filterItem = $scope.$parent.item;
                    vm.updateFilterValue = updateFilterValue;
    
                    vm.filterItem.inputName = vm.filterItem.dataFieldId;
    
                    if (!vm.filterItem.validator) {
                        $scope.$on("kendoWidgetCreated", function (event, widget) {
                            widget.options.rules.customValidation = customValidationFunction();
                            widget.options.messages.customValidation = customValidationMessagesFunction();
                            widget.options.messages.required = requiredMessagesFunction();
                        });
                    } else {
                        vm.filterItem.validator.options.rules.customValidation = customValidationFunction();
                        vm.filterItem.validator.options.messages.customValidation = customValidationMessagesFunction();
                        vm.filterItem.validator.options.messages.required = requiredMessagesFunction();
                    }
    
                    vm.filterItem.validationOptions = {
                        validateOnBlur: false
                    };
    
                    (function constructor() {
                        vm.datePickerOptions = {
                            parseFormats: ["yyyy-MM-dd"],
                            min: moment("1900-01-01").format('MM/DD/YYYY'), // minimum date possible
                            max: moment("3000-01-01").format('MM/DD/YYYY') // maximum date possible
                        };
    
                        var values = filterContext.getBetweenFilterValues(vm.filterItem.value);
                        if (values.from) {
                            vm.from = values.from;
                        }
                        if (values.to) {
                            vm.to = values.to;
                        }
                        updateFilterValue();
                    })();
    
                    // When either value changes, update the value
                    function updateFilterValue() {
                        vm.filterItem.value = filterContext.makeBetweenValue(vm.from, vm.to);
                    }
    
                    function customValidationFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.from) {
                                    return false;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        };
                    }
    
                    function customValidationMessagesFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.from) {
                                    return $translate.instant("is required");
                                } else {
                                    return "";
                                }
                            } else {
                                return "";
                            }
                        };
                    }
    
                    function requiredMessagesFunction() {
                        return function (input) {
                            return customValidator.validationMessages.requiredMessage(input);
                        };
                    }
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterBetweenDatePeriod', BetweenDatePeriod);

    BetweenDatePeriod.$inject = [];

    function BetweenDatePeriod() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/datatypes/betweenDatePeriod.html',
            transclude: false,
            controllerAs: 'ctrl',
            bindToController: true,
            scope: {
            },
            controller: function ($scope, regexService, filterContext, $translate, customValidator) {
                this.$onInit = function () {
                    var vm = this;

                    vm.regexService = {
                        restrictPositiveInteger: regexService.restrictPositiveInteger()
                    };

                    vm.filterItem = $scope.$parent.item;

                    if (!vm.filterItem.validator) {
                        $scope.$on("kendoWidgetCreated", function (event, widget) {
                            widget.options.rules.customValidation = customValidationFunction();
                            widget.options.messages.customValidation = customValidationMessagesFunction();
                            widget.options.messages.required = requiredMessagesFunction();
                        });
                    } else {
                        vm.filterItem.validator.options.rules.customValidation = customValidationFunction();
                        vm.filterItem.validator.options.messages.customValidation = customValidationMessagesFunction();
                        vm.filterItem.validator.options.messages.required = requiredMessagesFunction();
                    }

                    vm.updateFilterValue = updateFilterValue;
                    vm.filterItem.inputName = vm.filterItem.dataFieldId;

                    // Range validation can happen here at a later date
                    vm.filterItem.validationOptions = {
                        validateOnBlur: false,
                    };

                    vm.months = [];

                    // Get months from Moment and make our dataSource
                    angular.forEach(moment.months(), function (month, index) {
                        var monthIndex = index + 1;
                        vm.months.push({
                            // Month text will be localized via moments locale settings, we will need to switch it when the language changes
                            text: month,
                            // Append a zero for items less than 10 to the month number, this is how it's expected to be saved to the database
                            value: _.padStart(monthIndex.toString(), 2, '0')
                        });
                    });

                    (function constructor() {
                        var values = filterContext.getBetweenPeriodFilterValues(vm.filterItem.value);
                        if (values.fromValues) {
                            vm.fromMonth = _.find(vm.months, function (month) {
                                return month.value === values.fromValues.period;
                            }).value;
                            vm.fromYear = values.fromValues.year;
                        }

                        if (values.toValues) {
                            vm.toMonth = _.find(vm.months, function (month) {
                                return month.value === values.toValues.period;
                            }).value;
                            vm.toYear = values.toValues.year;
                        }

                        updateFilterValue();
                    })();

                    // When either value changes, update the value
                    function updateFilterValue() {
                        // When switching from a between operator to an operator that does not have value controls,
                        // like the "prior year" operator, this updateFilterValue function gets triggered as the 
                        // control is being removed from the filter panel and the other control is being brought to life. This can
                        // cause this function to fire late and clobber the value that the special operator control sets and thus
                        // breaking the way it saves. When this triggers late the operator is set to the special operator already, so we will
                        // do some special checks to only run this if the filter item operator is a between operator.
                        if (vm.filterItem.operator === 'between' || vm.filterItem.operator === 'not between') {
                            vm.filterItem.value = filterContext.makeBetweenValue(vm.fromMonth && vm.fromYear ? vm.fromYear + vm.fromMonth : null,
                                vm.toMonth && vm.toYear ? vm.toYear + vm.toMonth : null);
                        }
                    }

                    function customValidationFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.fromMonth || !vm.fromYear || !vm.toMonth) {
                                    return false;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        };
                    }

                    function customValidationMessagesFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.fromMonth || !vm.fromYear || !vm.toMonth) {
                                    return $translate.instant("is required");
                                } else {
                                    return "";
                                }
                            } else {
                                return "";
                            }
                        };
                    }

                    function requiredMessagesFunction() {
                        return function (input) {
                            return customValidator.validationMessages.requiredMessage(input);
                        };
                    }
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterBetweenDouble', BetweenDouble);

    BetweenDouble.$inject = [];

    function BetweenDouble() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/datatypes/betweenDouble.html',
            transclude: false,
            controllerAs: 'ctrl',
            bindToController: true,
            scope: {
            },
            controller: function ($scope, regexService, filterContext, customValidator, $translate) {            
                this.$onInit = function() {
                    var vm = this;
    
                    vm.regexService = {
                        restrictDouble: regexService.restrictDouble()
                    };
    
                    vm.filterItem = $scope.$parent.item;
                    vm.updateFilterValue = updateFilterValue;
                    vm.filterItem.inputName = vm.filterItem.dataFieldId;
    
                    if (!vm.filterItem.validator) {
                        $scope.$on("kendoWidgetCreated", function (event, widget) {
                            widget.options.rules.customValidation = customValidationFunction();
                            widget.options.messages.customValidation = customValidationMessagesFunction();
                            widget.options.messages.required = requiredMessagesFunction();
                        });
                    } else {
                        vm.filterItem.validator.options.rules.customValidation = customValidationFunction();
                        vm.filterItem.validator.options.messages.customValidation = customValidationMessagesFunction();
                        vm.filterItem.validator.options.messages.required = requiredMessagesFunction();
                    }
    
                    // Range validation can happen here at a later date
                    vm.filterItem.validationOptions = {
                        validateOnBlur: false
                    };
    
                    (function constructor() {
                        var values = filterContext.getBetweenFilterValues(vm.filterItem.value);
                        if (values.from) {
                            vm.from = values.from;
                        }
                        if (values.to) {
                            vm.to = values.to;
                        }
                        updateFilterValue();
                    })();
    
                    // When either value changes, update the value
                    function updateFilterValue() {
                        vm.filterItem.value = filterContext.makeBetweenValue(vm.from, vm.to);
                    }
    
                    function customValidationFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.from) {
                                    return false;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        };
                    }
    
                    function customValidationMessagesFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.from) {
                                    return $translate.instant("is required");
                                } else {
                                    return "";
                                }
                            } else {
                                return "";
                            }
                        };
                    }
    
                    function requiredMessagesFunction() {
                        return function (input) {
                            return customValidator.validationMessages.requiredMessage(input);
                        };
                    }
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterBetweenInteger', BetweenInteger);

    BetweenInteger.$inject = ['regexService'];

    function BetweenInteger(regexService) {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/datatypes/betweenInteger.html',
            transclude: false,
            replace: true,
            controllerAs: 'ctrl',
            bindToController: true,
            scope: {
            },
            controller: function ($scope, filterContext, customValidator, $translate) {            
                this.$onInit = function() {
                    var vm = this;
    
                    vm.regexService = {
                        restrictInteger: regexService.restrictInteger()
                    };
    
                    vm.filterItem = $scope.$parent.item;
                    vm.updateFilterValue = updateFilterValue;
                    vm.filterItem.inputName = vm.filterItem.dataFieldId;
    
                    if (!vm.filterItem.validator) {
                        $scope.$on("kendoWidgetCreated", function (event, widget) {
                            widget.options.rules.customValidation = customValidationFunction();
                            widget.options.messages.customValidation = customValidationMessagesFunction();
                            widget.options.messages.required = requiredMessagesFunction();
                        });
                    } else {
                        vm.filterItem.validator.options.rules.customValidation = customValidationFunction();
                        vm.filterItem.validator.options.messages.customValidation = customValidationMessagesFunction();
                        vm.filterItem.validator.options.messages.required = requiredMessagesFunction();
                    }
    
                    vm.filterItem.validationOptions = {
                        validateOnBlur: false
                    };
    
                    (function constructor() {
                        var values = filterContext.getBetweenFilterValues(vm.filterItem.value);
                        if (values.from) {
                            vm.from = values.from;
                        }
                        if (values.to) {
                            vm.to = values.to;
                        }
                        updateFilterValue();
                    })();
    
                    // When either value changes, update the value
                    function updateFilterValue() {
                        vm.filterItem.value = filterContext.makeBetweenValue(vm.from, vm.to);
                    }
    
                    function customValidationFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.from) {
                                    return false;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        };
                    }
    
                    function customValidationMessagesFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.from) {
                                    return $translate.instant("is required");
                                } else {
                                    return "";
                                }
                            } else {
                                return "";
                            }
                        };
                    }
    
                    function requiredMessagesFunction() {
                        return function (input) {
                            return customValidator.validationMessages.requiredMessage(input);
                        };
                    }
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterBetweenString', BetweenString);

    BetweenString.$inject = [];

    function BetweenString() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/datatypes/betweenString.html',
            transclude: false,
            replace: true,
            controllerAs: 'ctrl',
            bindToController: true,
            scope: {
            },
            controller: function ($scope, filterContext, customValidator, $translate) {            
                this.$onInit = function() {
                    var vm = this;
    
                    vm.filterItem = $scope.$parent.item;
                    vm.updateFilterValue = updateFilterValue;
    
                    vm.filterItem.inputName = vm.filterItem.dataFieldId;
    
                    if (!vm.filterItem.validator) {
                        $scope.$on("kendoWidgetCreated", function (event, widget) {
                            widget.options.rules.customValidation = customValidationFunction();
                            widget.options.messages.customValidation = customValidationMessagesFunction();
                            widget.options.messages.required = requiredMessagesFunction();
                        });
                    } else {
                        vm.filterItem.validator.options.rules.customValidation = customValidationFunction();
                        vm.filterItem.validator.options.messages.customValidation = customValidationMessagesFunction();
                        vm.filterItem.validator.options.messages.required = requiredMessagesFunction();
                    }
    
                    vm.filterItem.validationOptions = {
                        validateOnBlur: false
                    };
    
                    (function constructor() {
                        var values = filterContext.getBetweenFilterValues(vm.filterItem.value);
                        if (values.from) {
                            vm.from = values.from;
                        }
                        if (values.to) {
                            vm.to = values.to;
                        }
                        updateFilterValue();
                    })();
    
                    // When either value changes, update the value
                    function updateFilterValue() {
                        vm.filterItem.value = filterContext.makeBetweenValue(vm.from, vm.to);
                    }
    
                    function customValidationFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.from) {
                                    return false;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        };
                    }
    
                    function customValidationMessagesFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.from) {
                                    return $translate.instant("is required");
                                } else {
                                    return "";
                                }
                            } else {
                                return "";
                            }
                        };
                    }
    
                    function requiredMessagesFunction() {
                        return function (input) {
                            return customValidator.validationMessages.requiredMessage(input);
                        };
                    }
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterBoolean', BooleanValue);

    BooleanValue.$inject = [];

    // Boolean type control, can take in a custom yes/no caption from the catalog if found
    // Each id/name for these input toggles needs to have a unique name for the UI to work properly
    function BooleanValue() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/datatypes/boolean.html',
            transclude: false,
            replace: true,
            scope: {
                yesCaption: '=',
                noCaption: '='
            },
            controllerAs: 'ctrl',
            bindToController: true,
            controller: function ($scope) {            
                this.$onInit = function() {
                    var vm = this;
    
                    vm.filterItem = $scope.$parent.item;
    
                    (function constructor() {
    
                        vm.toggles = {
                            booleanItems: [
                                { label: vm.yesCaption, value: "1" },
                                { label: vm.noCaption, value: "0" }
                            ]
                        };
    
                        // Defaulting boolean values to true if they have no value
                        if (vm.filterItem.value === null) {
                            vm.filterItem.value = 1;
                        }
                    })();
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterDate', Date);

    Date.$inject = [];

    function Date() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/datatypes/date.html',
            transclude: false,
            replace: true,
            controllerAs: 'ctrl',
            bindToController: true,
            scope: {
            },
            controller: function ($scope, filterContext, customValidator) {            
                this.$onInit = function() {
                    var vm = this;
    
                    vm.filterItem = $scope.$parent.item;
                    vm.updateFilterValue = updateFilterValue;
                    vm.filterItem.inputName = vm.filterItem.dataFieldId;
    
                    vm.filterItem.validationOptions = {
                        validateOnBlur: false,
                        messages: {
                            required: function (input) {
                                return customValidator.validationMessages.requiredMessage(input);
                            },
                            customValidation: function (input) {
                                var optionalParam = {};
                                return customValidator.validationMessages.customValidationMessage(input, optionalParam);
                            }
                        },
                        rules: {
                            customValidation: function (input) {
                                var optionalParam = {};
                                return customValidator.validations.customValidation(input, optionalParam);
                            }
                        }
                    };
    
                    (function constructor() {
                        vm.datePickerOptions = {
                            parseFormats: ["yyyy-MM-dd"],
                            min: moment("1900-01-01").format('MM/DD/YYYY'), // minimum date possible
                            max: moment("3000-01-01").format('MM/DD/YYYY') // maximum date possible
                        };
    
                        vm.value = filterContext.getSingleFilterValue(vm.filterItem.value);
                        updateFilterValue();
                    })();
    
                    // When the input changes, update the filter item value
                    function updateFilterValue() {
                        vm.filterItem.value = vm.value;
                    }
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterDatePeriod', DatePeriod);

    DatePeriod.$inject = [];

    function DatePeriod() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/datatypes/datePeriod.html',
            transclude: false,
            controllerAs: 'ctrl',
            bindToController: true,
            scope: {
            },
            controller: function ($scope, regexService, filterContext, customValidator, $translate) {            
                this.$onInit = function() {
                    var vm = this;
    
                    vm.regexService = {
                        restrictPositiveInteger: regexService.restrictPositiveInteger()
                    };
    
                    vm.filterItem = $scope.$parent.item;
    
                    vm.updateFilterValue = updateFilterValue;
                    vm.filterItem.inputName = vm.filterItem.dataFieldId;
    
                    if (!vm.filterItem.validator) {
                        $scope.$on("kendoWidgetCreated", function (event, widget) {
                            widget.options.rules.customValidation = customValidationFunction();
                            widget.options.messages.customValidation = customValidationMessagesFunction();
                            widget.options.messages.required = requiredMessagesFunction();
                        });
                    } else {
                        vm.filterItem.validator.options.rules.customValidation = customValidationFunction();
                        vm.filterItem.validator.options.messages.customValidation = customValidationMessagesFunction();
                        vm.filterItem.validator.options.messages.required = requiredMessagesFunction();
                    }
    
                    vm.filterItem.validationOptions = {
                        validateOnBlur: false
                    };
    
                    vm.months = [];
    
                    // Get months from Moment and make our dataSource
                    angular.forEach(moment.months(), function (month, index) {
                        var monthIndex = index + 1;
                        vm.months.push({
                            // Month text will be localized via moments locale settings, we will need to switch it when the language changes
                            text: month,
                            // Append a zero for items less than 10 to the month number, this is how it's expected to be saved to the database
                            value: _.padStart(monthIndex.toString(), 2, '0')
                        });
                    });
    
                    (function constructor() {
                        var value = filterContext.getSinglePeriodFilterValue(vm.filterItem.value);
                        if (value.period) {
                            vm.month = _.find(vm.months, function (month) {
                                return month.value === value.period;
                            }).value;
                        }
                        if (value.year) {
                            vm.year = value.year;
                        }
                        updateFilterValue();
                    })();
    
                    // When either value changes, update the value
                    function updateFilterValue() {
                        if (vm.month && vm.year) {
                            vm.filterItem.value = vm.year + vm.month;
                        }
                    }
    
                    function customValidationFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.month) {
                                    return false;
                                } else {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                        };
                    }
    
                    function customValidationMessagesFunction() {
                        return function (input) {
                            if (input.is("[name=" + vm.filterItem.dataFieldId + "]")) {
                                if (!vm.month) {
                                    return $translate.instant("is required");
                                } else {
                                    return "";
                                }
                            } else {
                                return "";
                            }
                        };
                    }
    
                    function requiredMessagesFunction() {
                        return function (input) {
                            return customValidator.validationMessages.requiredMessage(input);
                        };
                    }
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterDouble', Double);

    Double.$inject = ['regexService'];

    function Double(regexService) {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/datatypes/double.html',
            transclude: false,
            controllerAs: 'ctrl',
            bindToController: true,
            scope: {
            },
            controller: function ($scope, filterContext, customValidator) {            
                this.$onInit = function() {
                    var vm = this;
    
                    vm.regexService = {
                        restrictDouble: regexService.restrictDouble()
                    };
    
                    vm.filterItem = $scope.$parent.item;
                    vm.updateFilterValue = updateFilterValue;
                    vm.filterItem.inputName = vm.filterItem.dataFieldId;
    
                    vm.filterItem.validationOptions = {
                        validateOnBlur: false,
                        messages: {
                            required: function (input) {
                                return customValidator.validationMessages.requiredMessage(input);
                            }
                        }
    
                    };
                    (function constructor() {
                        vm.value = filterContext.getSingleFilterValue(vm.filterItem.value);
                        updateFilterValue();
                    })();
    
                    // When the input changes, update the filter item value
                    function updateFilterValue() {
                        vm.filterItem.value = vm.value;
                    }
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterDropdown', Dropdown);

    Dropdown.$inject = [];

    function Dropdown() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/datatypes/dropdown.html',
            transclude: false,            
            controllerAs: 'ctrl',
            bindToController: true,
            scope: {
            },
            controller: function (apiResource, $timeout, $scope, filterContext, customValidator, $templateCache) {            
                this.$onInit = function() {
                    var vm = this;
                    vm.comboFooterTemplate = $templateCache.get('comboFooterTemplate.html');
                    
                    vm.filterItem = $scope.$parent.item;
                    vm.filterItem.inputName = vm.filterItem.dataFieldId + "_input";
    
                    vm.filterItem.validationOptions = {
                        validateOnBlur: false,
                        messages: {
                            required: function (input) {
                                return customValidator.validationMessages.requiredMessage(input);
                            },
                            customValidation: function (input) {
    
                                var optionalParam = {};
    
                                return customValidator.validationMessages.customValidationMessage(input, optionalParam);
                            }
                        },
                        rules: {
                            customValidation: function (input) {
    
                                var optionalParam = {};
    
                                return customValidator.validations.customValidation(input, optionalParam);
                            }
                        }
                    };
    
                    vm.dropdownComboChanged = dropdownComboChanged;
    
                    vm.dropdownComboTemplate = '<div class="list-template">' +                                           
                                                '   <div class="label">#: data.value #</div>' +
                                                '</div>';
                    // combobox datasource, server filtered and using our filterData api to
                    // bring back the items that match the combobox text, unless there is no items searched for in the combo,
                    // in which case it returns all values
                    vm.dropdownData = new kendo.data.DataSource({
                        serverFiltering: true,
                        transport: {
                            read: function (options) {
                                if ((options.data.filter && options.data.filter.filters.length > 0 && options.data.filter.filters[0].value !== "") || vm.dropdownCombo.text() !== "") {
                                    apiResource.filterData().filterdata().query({ datafieldId: vm.filterItem.dataFieldId, search: vm.dropdownCombo.text() }, function (result, headers) {
                                        vm.apiHeaders = headers();
                                        if (parseInt(vm.apiHeaders.totalpages) <= 1) {
                                            vm.apiHeaders.pagesize = vm.apiHeaders.totalnumberofrecords;
                                            vm.showFooter = false;
                                        } else {
                                            vm.showFooter = true;
                                        }
    
                                        options.success(result);
                                    });
                                } else {
    
                                    // We will call the filterData api and get back values that match the combo text
                                    apiResource.filterData().filterdata().query({ datafieldId: vm.filterItem.dataFieldId }, function (result, headers) {
                                        vm.apiHeaders = headers();
                                        if (parseInt(vm.apiHeaders.totalpages) <= 1) {
                                            vm.apiHeaders.pagesize = vm.apiHeaders.totalnumberofrecords;
                                            vm.showFooter = false;
                                        } else {
                                            vm.showFooter = true;
                                        }
                                        options.success(result);
                                    });
                                }
                            }
                        }
                    });
    
                    (function constructor() {
                        if (vm.filterItem.value !== null) {
                            vm.selectedDropdown = vm.filterItem.value;
                        }
                    })();                
    
                    function dropdownComboChanged() {
                        if (!angular.isUndefined(vm.selectedDropdown) && vm.selectedDropdown != null) {
                            vm.filterItem.value = vm.selectedDropdown;
                        }
                    }
                }
            }
        };
    }
})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterInteger', Integer);

    Integer.$inject = ['regexService'];

    function Integer(regexService) {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/datatypes/integer.html',
            transclude: false,
            controllerAs: 'ctrl',
            bindToController: true,
            scope: {
            },
            controller: function ($scope, filterContext, customValidator) {            
                this.$onInit = function() {
                    var vm = this;
    
                    vm.regexService = {
                        restrictInteger: regexService.restrictInteger()
                    };
    
                    vm.filterItem = $scope.$parent.item;
                    vm.updateFilterValue = updateFilterValue;
                    vm.filterItem.inputName = vm.filterItem.dataFieldId;
    
                    vm.filterItem.validationOptions = {
                        validateOnBlur: false,
                        messages: {
                            required: function (input) {
                                return customValidator.validationMessages.requiredMessage(input);
                            }
                        }
                    };
    
                    (function constructor() {
                        vm.value = filterContext.getSingleFilterValue(vm.filterItem.value);
                        updateFilterValue();
                    })();
    
                    // When the input changes, update the filter item value
                    function updateFilterValue() {
                        vm.filterItem.value = vm.value;
                    }
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterNoValue', NoValue);

    NoValue.$inject = [];

    function NoValue() {
        return {
            require: '^^filter',
            transclude: false,
            replace: true,
            scope: {
            },
            controllerAs: 'ctrl',
            bindToController: true,
            controller: function ($scope, filterContext) {            
                this.$onInit = function() {
                    var vm = this;
    
                    vm.filterItem = $scope.$parent.item;
                    vm.updateFilterValue = updateFilterValue;
    
                    (function constructor() {
                        vm.value = '';  // null isn't a valid value, have to set it to an empty string
                        updateFilterValue();
                    })();
    
                    // When the input changes, update the filter item value
                    function updateFilterValue() {
                        vm.filterItem.value = vm.value;
                    }
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterOneOfString', OneOfString);

    OneOfString.$inject = [];

    function OneOfString() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/datatypes/oneOfstring.html',
            transclude: false,
            controllerAs: 'ctrl',
            bindToController: true,
            scope: {
            },
            controller: function ($scope, filterContext, apiResource, customValidator) {            
                this.$onInit = function() {
                    var vm = this;
    
                    vm.filterItem = $scope.$parent.item;
                    vm.updateFilterValue = updateFilterValue;
    
                    $scope.$parent.item.inputName = vm.filterItem.dataFieldId;
    
                    vm.filterItem.validationOptions = {
                        validateOnBlur: false,
                        messages: {
                            required: function (input) {
                                return customValidator.validationMessages.requiredMessage(input);
                            }
                        }
                    };
    
                    vm.dropdownData = new kendo.data.DataSource({
                        serverFiltering: true,
                        transport: {
                            read: function (options) {
                                if ((options.data.filter && options.data.filter.filters.length > 0 && options.data.filter.filters[0].value !== "") ) {
                                    apiResource.filterData().filterdata().query({ datafieldId: vm.filterItem.dataFieldId, search: options.data.filter.filters[0].value }, function (result) {
                                        options.success(formatdropdownList(result));
                                    });
                                } 
                                else {
    
                                    // We will call the search api and get back values that match the combo text
                                    apiResource.filterData().filterdata().query({ datafieldId: vm.filterItem.dataFieldId }, function (result, headers) {
                                        options.success(formatdropdownList(result));
                                    });
                                }
                            }
                        }
                    });
    
                    (function constructor() {
                        vm.selectedValues = filterContext.getOneOfValues(vm.filterItem.value);
    
                        vm.selectOptions = {
                            dataSource: vm.dropdownData
                        };
    
                        updateFilterValue();
                    })();
    
                    function formatdropdownList(dropdownValues) {
                        return _.map(dropdownValues, 'value');                   
                    }
    
                    // When the input changes, update the filter item value
                    function updateFilterValue() {
                        vm.filterItem.value = filterContext.makeOneOfValue(vm.selectedValues);
                    }
    
                    $scope.$on('$destroy', function() {
                        if (vm.oneOfCtrl && vm.oneOfCtrl.popup && vm.oneOfCtrl.popup.element) {
                            kendo.destroy(vm.oneOfCtrl.popup.element);
                        }
                    });
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterString', String);

    String.$inject = [];

    function String() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/datatypes/string.html',
            transclude: false,
            controllerAs: 'ctrl',
            bindToController: true,
            scope: {
            },
            controller: function ($scope, filterContext, customValidator) {            
                this.$onInit = function() {
                    var vm = this;
    
                    vm.filterItem = $scope.$parent.item;
                    vm.updateFilterValue = updateFilterValue;
                    vm.filterItem.inputName = vm.filterItem.dataFieldId;
    
                    vm.filterItem.validationOptions = {
                        validateOnBlur: false,
                        messages: {
                            required: function (input) {
                                return customValidator.validationMessages.requiredMessage(input);
                            }
                        }
                    };
    
                    (function constructor() {
                        vm.value = filterContext.getSingleFilterValue(vm.filterItem.value);
                        updateFilterValue();
                    })();
    
                    // When the input changes, update the filter item value
                    function updateFilterValue() {
                        vm.filterItem.value = vm.value;
                    }
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterBetweenYear', FilterBetweenYear);

    FilterBetweenYear.$inject = [];

    function FilterBetweenYear() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/filterBetweenYear.html',
            transclude: false,
            replace: true,
            scope: {
            },
            controllerAs: 'ctrl',
            bindToController: true,
            controller: function ($scope) {            
                this.$onInit = function() {
                    var vm = this;
                    vm.filterItem = $scope.$parent.item;
                    vm.updateFilterValue = updateFilterValue;
    
                    (function constructor() {
                        var validYears = [];
    
                        for (var i = 1980; i <= new Date().getFullYear() + 1; i++) {
                            validYears.push({ value: i });
                        }
    
                        vm.options = {
                            dataTextField: "value",
                            dataValueField: "value",
                            dataSource: validYears
                        };
    
                        if (vm.filterItem.value !== null) {
                            vm.from = vm.filterItem.value.split('¦')[0];
                            vm.to = vm.filterItem.value.split('¦')[1];
                        }
    
                    })();
    
                    function updateFilterValue() {
                        vm.filterItem.value = vm.from + "¦" + vm.to;
                    }
                }
            }
        };
    }

})();



(function () {
  'use strict';

  angular.module('app').directive('filterChannelInterval', FilterChannelInterval);

  FilterChannelInterval.$inject = ['$filter'];

  function FilterChannelInterval($filter) {
      return {
          require: '^^filter',
          templateUrl: 'assets/templates/ec_filters/values/filterChannelInterval.html',
          transclude: false,
          replace: true,
          scope: {
            isEsa: '='
          },
          controllerAs: 'ctrl',
          bindToController: true,
          controller: function ($scope) {            
              this.$onInit = function() {
                  var vm = this;
                  vm.filterItem = $scope.$parent.item;
                  
                  (function constructor() {
                      var validChannelIntervals = [
                        { value: 900, minutes: 15 },
                        { value: 1800, minutes: 30 },
                        { value: 3600, minutes: 60 },
                        { value: 86400, minutes: 1440 },
                        { value: 604800, minutes: 10080 },
                        { value: 2592000, minutes: 43200 },
                      ];

                      if (vm.isEsa) {
                        validChannelIntervals = [
                          { value: '5-minutes', minutes: 5 },
                          { value: '10-minutes', minutes: 10 },
                          { value: '15-minutes', minutes: 15 },
                          { value: '30-minutes', minutes: 30 },
                          { value: 'Hourly', minutes: 60 }, 
                          { value: 'Daily', minutes: 1440 },
                          { value: 'Weekly', minutes: 10080 },
                          { value: 'Monthly', minutes: 43200 },
                        ];
                      }
  
                      angular.forEach(validChannelIntervals, function(validChannelInterval) {
                        validChannelInterval.text = $filter('channelInterval')(validChannelInterval.minutes);
                      });
                      
                      vm.options = {
                          dataTextField: "text",
                          dataValueField: "value",
                          dataSource: validChannelIntervals
                      };
                  })();
              }
          }
      };
  }

})();


﻿(function () {
    'use strict';

    angular.module('app').directive('filterChargebackWorkflowStep', FilterChargebackWorkflowStep);

    FilterChargebackWorkflowStep.$inject = [];

    function FilterChargebackWorkflowStep() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/filterChargebackWorkflowStep.html',
            transclude: false,
            replace: true,
            scope: {
                valueProperty: '='
            },
            controllerAs: 'ctrl',
            bindToController: true,
            controller: function (apiResource, $scope) {            
                this.$onInit = function() {
                    var vm = this;
                    vm.filterItem = $scope.$parent.item;
    
                    vm.chargebackWorkflowComboChanged = chargebackWorkflowComboChanged;
                    vm.chargebackWorkflows = [];
    
                    (function constructor() {
                      apiResource.chargebackWorkflow().chargebackWorkflow().query({}, function (result) {
                        var chargebackWorkflowsOrdered = _.orderBy(result, function (workflow) { workflow.chargebackWorkflowInfo.toLowerCase() });
                        angular.forEach(chargebackWorkflowsOrdered, function (chargebackWorkflow) {
                          var chargebackWorkflowStepsOrdered = _.orderBy(chargebackWorkflow.chargebackWorkflowSteps, 'chargebackWorkflowStepOrder');
                          angular.forEach (chargebackWorkflowStepsOrdered, function (chargebackWorkflowStep) {
                            vm.chargebackWorkflows.push({
                              chargebackWorkflowStepId: chargebackWorkflowStep.chargebackWorkflowStepId,
                              chargebackWorkflowText: chargebackWorkflow.chargebackWorkflowInfo + ': ' + chargebackWorkflowStep.chargebackWorkflowStepInfo
                            });
                          });
                        });
                      });
                    })();                
    
                    function chargebackWorkflowComboChanged() {
                        if (vm.selectedChargebackWorkflow) {
                            vm.filterItem.value = vm.selectedChargebackWorkflow;
                        }
                    }
                }
            }
        };
    }
})();



(function () {
  'use strict';

  angular.module('app').directive('filterDataDisplayed', FilterDataDisplayed);

  FilterDataDisplayed.$inject = [];

  function FilterDataDisplayed() {
      return {
          require: '^^filter',
          templateUrl: 'assets/templates/ec_filters/values/filterDataDisplayed.html',
          transclude: false,
          replace: true,
          scope: {
          },
          controllerAs: 'ctrl',
          bindToController: true,
          controller: function (apiResource, $scope, $translate, customValidator) {
              this.$onInit = function() {
                  var vm = this;
                  vm.filterItem = $scope.$parent.item;
                  vm.isLoading = true;
                  vm.dataDisplayedOptions = [];
  
                  (function constructor() {
                      vm.filterItem.validationOptions = {
                          validateOnBlur: false,
                          messages: {
                              required: function (input) {
                                  return customValidator.validationMessages.requiredMessage(input);
                              }
                          }
                      };

                      loadValidDataDisplays();
                  })();

                  function loadValidDataDisplays() {
                      apiResource.filterData().filterdata().query({ datafieldId: vm.filterItem.dataFieldId }, function (result) {
                          var validDataDisplays = _.map(result, function (item) {
                              return mapDataDisplayValue(item.value);
                          });

                          vm.dataDisplayedOptions = validDataDisplays;
                          clearInvalidSelectedValue(validDataDisplays);

                          vm.isLoading = false;
                      }, function () {
                          vm.dataDisplayedOptions = getFallbackDataDisplays();
                          clearInvalidSelectedValue(vm.dataDisplayedOptions);
                          vm.isLoading = false;
                      });
                  }

                  function clearInvalidSelectedValue(dataDisplayedOptions) {
                      if (vm.filterItem.value !== null && !_.some(dataDisplayedOptions, function (item) {
                          return item.value === vm.filterItem.value;
                      })) {
                          vm.filterItem.value = null;
                      }
                  }

                  function getFallbackDataDisplays() {
                      return _.map(['Actual', 'Calendarized', 'Normalized'], function (value) {
                          return mapDataDisplayValue(value);
                      });
                  }

                  function mapDataDisplayValue(value) {
                      switch (value) {
                          case 'Actual':
                              return { text: $translate.instant('BillingPeriodData_TC'), value: value };
                          case 'Calendarized':
                              return { text: $translate.instant('calendarized'), value: value };
                          case 'Normalized':
                              return { text: $translate.instant('normalized'), value: value };
                          default:
                              return { text: value, value: value };
                      }
                  }
              }
          }
      };
  }

})();


(function () {
    'use strict';

    angular.module('app').directive('filterText', FilterText);

    FilterText.$inject = [];

    function FilterText() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/filterText.html',
            transclude: false,
            replace: true,
            scope: {
            },
            controllerAs: 'ctrl',
            bindToController: true,
            controller: function ($scope) {            
                this.$onInit = function() {
                    var vm = this;
                    vm.filterItem = $scope.$parent.item;
                    
                    (function constructor() {
    
                    })();
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular.module('app').directive('filterYear', FilterYear);

    FilterYear.$inject = [];

    function FilterYear() {
        return {
            require: '^^filter',
            templateUrl: 'assets/templates/ec_filters/values/filterYear.html',
            transclude: false,
            replace: true,
            scope: {
            },
            controllerAs: 'ctrl',
            bindToController: true,
            controller: function ($scope) {            
                this.$onInit = function() {
                    var vm = this;
                    vm.filterItem = $scope.$parent.item;
    
                    (function constructor() {
                        var validYears = [];
    
                        for (var i = 1980; i <= new Date().getFullYear() + 1; i++) {
                            validYears.push({value: i});
                        }
    
                        vm.options = {
                            dataTextField: "value",
                            dataValueField: "value",
                            dataSource: validYears
                        };
                    })();
                }
            }
        };
    }

})();



﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('filterHelper', FilterHelper);

    FilterHelper.$inject = ['$translate', 'userService'];

    /**
     * Provides utility functions related to list filtering
     * @constructor
     */
    function FilterHelper($translate, userService) {

        var helpers = {

            valueCaption: valueCaption,
            toApiFiltersRequestForm: toApiFiltersRequestForm,
            toUrlFilters: toUrlFilters,
            getSavedFilters: getSavedFilters,
            escapeValue: escapeValue
        };

        function escapeValue(filterValue) {
            if(filterValue && typeof filterValue === "string"){
                filterValue = filterValue.replace(/\\/g, "\\\\");
                filterValue = filterValue.replace(/'/g, "\\'");
            }
            return filterValue;
        }


        /**
         * returns the english caption for filter values
         * @returns {string}
         */
        function valueCaption(filterObject) {

            switch (filterObject.dataType.dataTypeCode) {

                case "boolean":

                    if (filterObject.value && filterObject.value.toString() === "1") {
                        return "yes";
                    }
                    else {
                        return "no";
                    }
                    break;

                case "string":
                case "double":
                case "accountperiod":

                    if (filterObject.value && filterObject.value.indexOf("¦") > -1) {
                        var values = filterObject.value.split("¦").join(" and ");
                        return values;
                    }
                    break;

                case "dateperiod":

                    if (filterObject.value && filterObject.value.indexOf("¦") > -1) {
                        var values = filterObject.value.split("¦");
                        return values[0] + " and " + values[1];
                    }
                    break;

                case "datetime":

                    var dateFormat = userService.getUser().preference.dateFormat;
                    if (filterObject.value && filterObject.value.indexOf("¦") > -1) {
                        var values = filterObject.value.split("¦");
                        return moment(values[0]).format(dateFormat) + " and " + moment(values[1]).format(dateFormat);
                    }
                    else if (filterObject.value) {
                        return moment(filterObject.value).format(dateFormat);
                    }
                    break;
            }

            return filterObject.value;
        }

        //takes a list of available filters, for each one if it is set, add it to savedfilterlist and makes a filterDisplay to show on the ribbon and returns the savedfilterlist
        function getSavedFilters(filterList) {           
            return _.filter(filterList, function (filter) {                
                if (filter.value != null) {
                    filter.valueCaption = valueCaption(filter);                    
                    filter.filterDisplay = $translate.instant(filter.caption) + " " + $translate.instant(filter.operator) + " " + filter.valueCaption;                    
                }
                return filter.value !== null;
            });            
        }


        function toApiFiltersRequestForm(filterList) {
            var transformedFilterList = [];
            _.forEach(filterList, function (filterItem) {

                if (filterItem.value != null) {
                    var tempFilterItem = {};

                    tempFilterItem.fieldId = filterItem.fieldId;
                    tempFilterItem.operator = filterItem.operator;
                    if (filterItem.dataType.dataTypeCode === "datetime") {
                        if (filterItem.value && filterItem.value.indexOf("¦") > -1) {
                            var values = filterItem.value.split("¦");
                            tempFilterItem.value = moment(values[0]).format('YYYY-MM-DD') + "¦" + moment(values[1]).format('YYYY-MM-DD');
                        }
                        else if (filterItem.value) {
                            tempFilterItem.value = moment(filterItem.value).format('YYYY-MM-DD');
                        }
                        else {
                            tempFilterItem.value = filterItem.value;
                        }
                    }
                    else {
                        tempFilterItem.value = filterItem.value;
                    }

                    transformedFilterList.push(tempFilterItem);
                }
            });

            return transformedFilterList;
        }

        // Takes an array of filters and creates the string representation needed to pass to an api which consumes filters
        function toUrlFilters(filterList) {
            var transformedFilterList = "";

            _.forEach(filterList, function (filterItem) {
                if (filterItem.value != null) {
					var filterValue = "";
                    if (transformedFilterList !== "") {
                        transformedFilterList = transformedFilterList + " and ";
                    }

					var filterValue = escapeValue(filterItem.value).toString().split("¦").join("'|'");

                    var captionValue = filterItem.queryParameterName ? filterItem.queryParameterName : filterItem.caption.split(" ").join("");

                    transformedFilterList = transformedFilterList + captionValue + " " + filterItem.operator + " '" + filterValue + "'";
                }
            });

            return transformedFilterList;
        }

        return helpers;
    }
})();
﻿(function () {
    'use strict';

    angular
		.module('app')
		.filter('absoluteValue', AbsoluteValue);

    AbsoluteValue.$inject = [];

    function AbsoluteValue() {
        return function (number) {            
            return Math.abs(number);
        };
    }
})();
﻿(function () {
    'use strict';

    angular
		.module('app')
		.filter('accountingPeriod', AccountingPeriod);

    AccountingPeriod.$inject = ['$filter'];

    function AccountingPeriod($filter) {

        return function (input, name) {
            // you need to escape your brackets with MORE BRACKETS
            return input ? name + moment(input, 'YYYYMM').format('[[]MM[]] YYYY') : null;
        };
    }

})();
﻿(function () {
    'use strict';
    
    angular
        .module('app')
        .filter('addressSettingForStateProvince', AddressSettingForStateProvince);

    AddressSettingForStateProvince.$inject = ['$translate'];


    function AddressSettingForStateProvince($translate) {

        return function (input, resourceName, field) {

            if (input && input.country) {
                if (input.country === 'CA') {
                    return $translate.instant('Province');
                }
            }

            return $translate.instant('State');
        };
    }

})();
﻿(function () {
    'use strict';
    
    angular
        .module('app')
        .filter('addressSettingForZipPostalCode', AddressSettingForZipPostalCode);

    AddressSettingForZipPostalCode.$inject = ['$translate'];


    function AddressSettingForZipPostalCode($translate) {

        return function (input, resourceName, field) {

            if (input && input.country) {
                if (input.country === 'CA') {
                    return $translate.instant('Postal code');
                }
            }

            return $translate.instant('Zip code');
        };
    }

})();
﻿(function () {
    'use strict';

    angular
		.module('app')
		.filter('affix', Affix);

    Affix.$inject = ['$filter'];

    function Affix($filter) {

        var functionObj = {
            prepend: function (input, text) {
                return input ? text + " " + input : input;
            },
            append: function (input, text) {
                return input ? input + " " + text : input;
            }
        };

        return function (input, operation, text) {

            // need commas (number formatting) for the numeric values for our new ec-numeric-box
            input = input ? $filter('number')(input) : input;

            return operation ? functionObj[operation](input, text) : input;
        };
    }

})();
﻿(function () {
    'use strict';

    angular
		.module('app')
		.filter('breadCrumb', BreadCrumb);

    BreadCrumb.$inject = [];

    function BreadCrumb() {

        return function (input, displaySetting) {
            // Modify property names to be only the last 4 characters
            // (placeCode => Code, placeInfo => Info, PlaceId => ceId, etc.)
            // This allows the filter to be used for all Modules
            var crumb = _.mapKeys(input, function (value, key) {
                return key.substr(key.length - 4);
            });
                
            // Match the db setting values
            // We default to Code [Info]
            if (displaySetting === "name" && crumb.Info) {
                return crumb.Info;
            }

            if (displaySetting === "code" && crumb.Code) {
                return crumb.Code;
            }

            if (displaySetting === "namefirst" && crumb.Info && crumb.Code) {
                return crumb.Info + " [" + crumb.Code + "]";
            }

            if (crumb.Info && crumb.Code) {
                return crumb.Code + " [" + crumb.Info + "]";
            }

            return null;
        };
    }

})();
(function () {
    'use strict';

    angular
		.module('app')
		.filter('channelInterval', ChannelInterval);

    ChannelInterval.$inject = ['$translate', 'translationHelper'];    

    //
    // Available Channel Intervals (in minutes)
    //
    // This display filter is to transform a numeric interval in minutes into a nicely-displayed text field
    // Logic should be identical to that contained in channel-intervals.ts on the Angular 5 side, but with different programming constructs
    //
    function ChannelInterval($translate, translationHelper) {     
       
        // "value" is channel interval in minutes
        return function (intervalInMinutes) {

            // Empty input handling
            if (intervalInMinutes == null || intervalInMinutes == "") {
                throw "intervalInMinutes is null or whitespace";
            }

            switch (intervalInMinutes)
            {
                case 5:
                    return $translate.instant('Interval_5Minute_TC');    
                case 10:
                    return $translate.instant('Interval_10Minute_TC');    
                case 15:
                    return $translate.instant('Interval_15Minute_TC');                    
                case 30:
                    return $translate.instant('Interval_30Minute_TC');                    
                case 60:
                    return $translate.instant('Interval_Hourly_TC');                    
                case 1440:
                    return $translate.instant('Interval_Daily_TC');                    
                case 10080:
                    return $translate.instant('Interval_Weekly_TC');                    
                case 43200:
                    return $translate.instant('Interval_Monthly_TC');                    
                default:
                    return translationHelper.translateAndInterpolate('Interval_Other_TC', { 'customMinutes' : intervalInMinutes });
            }            
        };
    }
})();
﻿(function () {
    'use strict';

    angular
		.module('app')
		.filter('monthYear', MonthYear);

    MonthYear.$inject = ['$filter'];

    function MonthYear($filter) {

        return function (input) {
            return moment(input, 'YYYYMM').format('MMMM YYYY');
        };
    }

})();
﻿(function () {
    'use strict';

    angular
		.module('app')
		.filter('fillEmptyPlaceholder', FillEmptyPlaceholder);

    FillEmptyPlaceholder.$inject = [];

    function FillEmptyPlaceholder() {
        return function (value) {
            return !value && value !== 0 ? '---' : value;
        };
    }
})();
﻿(function () {
    'use strict';

    angular
		.module('app')
		.filter('negativeSignCurrency', NegativeSignCurrency);

    NegativeSignCurrency.$inject = ['$filter'];

    function NegativeSignCurrency($filter) {

        // Angular's stock currency filter returns a negative value in parenthesis.
        // Replace the leading parenthesis with a negative sign and remove the trailing parenthesis
        return function (amount, currencySymbol, precision) {
            var currency = $filter('currency');

            // If our amount is less than zero do the stripping and replacement to format it correctly
            if (amount < 0) {
                return currency(amount, currencySymbol, precision).replace("(", "-").replace(")", "");
            }

            // If our amount is zero or positive just let angular do its thing
            return currency(amount, currencySymbol, precision);
        };
    }

})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .filter('temperature', Temperature);

    Temperature.$inject = ['$filter'];

    function Temperature($filter) {

        var functionObj = {
            degf: function (input, options) {
                return input < options.min ? convertCentigradeToFahrenheit(input) : input;
            },
            degc: function (input, options) {
                return input > options.max ? convertFahrenheitToCentigrade(input) : input;
            }
        };

        return function (input, options) {

            return !_.isUndefined(options) && !_.isUndefined(options.unit) ? functionObj[options.unit](input, options) : input;
        };

        function convertFahrenheitToCentigrade(value) {
            return Math.round((value - 32) * 5 / 9);
        }

        function convertCentigradeToFahrenheit(value) {
            return Math.round((value * 9 / 5) + 32);
        }
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('focusMe', focusMe);

    focusMe.$inject = ['$timeout'];

    function focusMe($timeout) {

        var service = {
            focus: focus
        };

        return service;

        function focus(element) {
            $timeout(function () {
                element.focus();
            });

            // TODO: Find a better way to select the focused element. 
            // At the moment this is nothing more than a hack via the timeout.
            // What needs to happen is that the IF the model has a value, wait
            // for it to be set once --- then defer the selection.
            // This would be better solved via a directive that takes in the model, 
            // but should only trigger if there is a value to be bound, before user input.
            // ng-dirty/ng-touch classes can be used for input.
            // Not sure for combo boxes. 
            $timeout(function () {
                element.select();
            }, 200);
        }

    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('accountProfileController', AccountProfileController);

    AccountProfileController.$inject = ['runtimeService', 'glazeService', '$window', 'apiResource', '$translate', '$injector'];

    function AccountProfileController(runtimeService, glazeService, $window, apiResource, $translate, $injector) {
        var vm = this;

        var userService2 = getUserService();

        (function constructor() {
            glazeService.primaryAction = glazeService.hideGlaze;

            initialFormLoad();
        })();

        function initialFormLoad() {
            var awaiter = new PromiseAwaiter();

            var hasCarbonHubApp = false;
            var hasEumOrUcpApp = false;
            var hasEchAppPromise = userService2.hasPermissionsNg1(["HasEchApp"]);
            var hasEumOrUcpAppPromise = userService2.hasPermissionsNg1(["HasEumOrUcpApp"]);

            Promise.all([hasEchAppPromise, hasEumOrUcpAppPromise]).then(function(values) {
                hasCarbonHubApp = values[0];
                hasEumOrUcpApp = values[1];
            });
        
            awaiter.add(apiResource.me().get(function (data) {

                //system information
                vm.systemUrl = $window.location.origin;
                vm.datasource = _.find(data.claim, { claimType: "https://energycap.com/datasource" }).value;
                vm.ownerId = "";
                vm.ownerName = _.find(data.claim, { claimType: "https://energycap.com/organization" }).value;
                vm.ownerDisplay = vm.ownerName;
                vm.upgradeVersion_V7 = data.upgradeVersion_V7;
                vm.version = window.ECP.version;

                //user information
                vm.fullName = data.fullName;
                vm.email = data.email;
                vm.systemUserCode = data.systemUserCode;
                vm.systemUserId = data.systemUserId;
                vm.userNumber = window.ECP.userNumber;
                vm.userRoleName = data.userRoleName;
                vm.placeDisplay = data.place.isMultiTopmostPlace ? $translate.instant('MultipleTopmost_TC') : data.place.placeInfo + ' [' + data.place.placeCode + ']';
                vm.costCenterDisplay = data.costCenter.isMultiTopmostCostCenter ? $translate.instant('MultipleTopmost_TC') : data.costCenter.costCenterInfo + ' [' + data.costCenter.costCenterCode + ']';
                vm.topMostCollectionDisplay = data.collection.isMultiTopmostCollection ? $translate.instant('MultipleTopmost_TC') : data.collection.collectionInfo + ' [' + data.collection.collectionCode + ']';
                vm.hasCarbonHubApp = hasCarbonHubApp;
                vm.hasEumOrUcpApp = hasEumOrUcpApp;
            }));

            glazeService.showLoading(awaiter);
        }

        function getUserService() {
            var service = null;

            try {
                service = $injector.get('userService2');
            } catch(e) {
                // Console error
                console.log('Could not get userService from injector', e);
            };

            return service;
        }

    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('closeFormTitleController', CloseFormTitleController);

    CloseFormTitleController.$inject = ['$rootScope', 'glazeService'];

    function CloseFormTitleController($rootScope, glazeService) {
        var vm = this;

        (function constructor() {

            // Initialize our error message in case there is a form error returned from the API
            vm.errorMessage = "";

            // Link our function to set our error message field to the service so when we have an error we can 
            // display it here
            glazeService.setFormTitleErrorMessage = setFormTitleErrorMessage;

            // Setup our actions for the form title, these will call the glaze services
            // primary and secondary actions which will be dictated by the forms controller
            vm.primaryAction = primaryAction;
        })();

        function primaryAction() {
            glazeService.primaryAction();
        }

        function setFormTitleErrorMessage(message) {
            vm.errorMessage = message;
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('downloadSpreadsheetTitleController', DownloadSpreadsheetTitleController);

    DownloadSpreadsheetTitleController.$inject = ['glazeService'];

    function DownloadSpreadsheetTitleController(glazeService) {
        var vm = this;

        vm.glazeService = glazeService;

        (function constructor() {
            vm.secondaryAction = glazeService.secondaryAction;
            vm.primaryAction = glazeService.primaryAction;
        })();

        function setFormTitleErrorMessage(message) {
            vm.errorMessage = message;
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('editMeterExplanationOfSavingsTitleController', EditMeterExplanationOfSavingsTitleController);

    EditMeterExplanationOfSavingsTitleController.$inject = ['$rootScope', 'glazeService'];

    function EditMeterExplanationOfSavingsTitleController($rootScope, glazeService) {
        var vm = this;
        
        (function constructor() {

            // Initialize our error message in case there is a form error returned from the API
            vm.errorMessage = "";

            // Link our function to set our error message field to the service so when we have an error we can 
            // display it here
            glazeService.setFormTitleErrorMessage = setFormTitleErrorMessage;

            // Setup our actions for the edit explanation of savings, these will call the glaze services
            // actions which will be dictated by the edit of explanation of savings controller
            vm.cancel = cancel;
            vm.reprocess = reprocess;
            vm.save = save;

            var unwatchIsLocked = $rootScope.$watch(function () {
                // Check to make sure the isLocked function exists, if not, just return false
                return { isLocked: glazeService.actions && glazeService.actions.hasOwnProperty("isLocked") ? glazeService.actions.isLocked() : false };
            }, function (newValue, oldValue) {

                // The loading flag changed, set our spinners visiblity based on the new value
                vm.isLocked = newValue.isLocked;
            }, true);

            $rootScope.$on('$destroy', function () {
                unwatchIsLocked();
            });

        })();

        function cancel() {
           glazeService.actions.cancel();
        }

        function reprocess() {
            glazeService.actions.reprocess();
        }

        function save() {
            glazeService.actions.save();
        }

        function setFormTitleErrorMessage(message) {
            vm.errorMessage = message;
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('formErrorController', FormErrorController);

    FormErrorController.$inject = ['glazeService', '$sce'];

    function FormErrorController(glazeService, $sce) {
        var vm = this;
 
        (function constructor() {

            vm.errorMessage = "";

            glazeService.setFormTitleErrorMessage = function (message) {
                vm.errorMessage = $sce.trustAsHtml(message);
            };

            glazeService.hideFormTitleErrorMessage = function (message) {
                vm.errorMessage = "";
            };

        })();
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('formTitleController', FormTitleController);

    FormTitleController.$inject = ['$rootScope', 'glazeService'];

    function FormTitleController($rootScope, glazeService) {
        var vm = this;
        vm.disablePrimaryAction = false;
        vm.confirmPrimaryAction = false;
        vm.glazeService = glazeService;
        (function constructor() {

            // Setup our actions for the form title, these will call the glaze services
            // primary and secondary actions which will be dictated by the forms controller
            vm.secondaryAction = secondaryAction;
            vm.primaryAction = primaryAction;
            vm.glazeService = glazeService;
        })();

        function secondaryAction() {
            glazeService.secondaryAction();
        }

        function primaryAction() {            

            var action = {
                action: vm.confirmPrimaryAction ? "confirmed" : "unconfirmed"
            };            

            glazeService.primaryAction(action);

            // *** Implementation Tip *** 
            // If needed, in the controller for your form you can add property "glazeService.isConfirm" so you can control
            // the state of formTitle.html. You will need to set it back to false on your secondary/primary actions to avoid
            // having Save & Continue buttons flicker in your other forms.
            if(glazeService.isConfirm){
                vm.confirmPrimaryAction = glazeService.isConfirm;
            }            
        }

        function setFormTitleErrorMessage(message) {
            vm.errorMessage = message;
        }

        
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('formWaitingOverlayController', FormWaitingOverlayController);

    FormWaitingOverlayController.$inject = ['glazeService'];

    function FormWaitingOverlayController(glazeService) {
        var vm = this;
        vm.glazeService = glazeService;
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('glazeCatalog', GlazeCatalog);

    GlazeCatalog.$inject = [];

    function GlazeCatalog() {

        var glazeCatalog = {
            catalog: [
            {
                'type': 'magnify-chart',
                'url': 'assets/templates/chart/details.html',
                'title': null,
                'titleUrl': 'assets/templates/glaze/closeFormTitle.html',
                'width': 'large',
                'showBreadcrumb': true
            },
            // account profile
            {
                'type': 'account-profile',
                'url': 'assets/templates/glaze/accountProfile.html',
                'title': 'GlobalHeaderHelp_About',
                'titleUrl': 'assets/templates/glaze/closeFormTitle.html'
            },
            // Building
            {
                'type': 'edit-building-groups',
                'url': 'assets/templates/buildings/building/editBuildingGroups.html',
                'title': 'Edit Manual Group Associations',
                'titleUrl': 'assets/templates/glaze/formTitle.html',
                'showBreadcrumb': false,
                'width': 'large',
                'permissionType': "BuildingAndMeterGroupsEdit"
            },
            // Meter
            {
                'type': 'edit-meter-groups',
                'url': 'assets/templates/buildings/meter/editMeterGroups.html',
                'title': 'Edit Manual Group Associations',
                'titleUrl': 'assets/templates/glaze/formTitle.html',
                'showBreadcrumb': false,
                'width': 'large',
                'permissionType': "BuildingAndMeterGroupsEdit"
            },
            {
                'type': 'meter-explanation-of-savings',
                'url': 'assets/templates/buildings/meter/meterExplanationOfSavings.html',
                'title': 'Explanation of Savings',
                'titleUrl': 'assets/templates/glaze/navigationTitle.html',
                'showBreadcrumb': true,
                'width': 'full',
                'fullHeight': true,
                'permissionType': ["MetersView", "LicenseFeatureCostAvoidanceView"]
            },
            {
                'type': 'edit-meter-explanation-of-savings',
                'url': 'assets/templates/buildings/meter/editMeterExplanationOfSavings.html',
                'title': 'Adjust Savings',
                'titleUrl': 'assets/templates/glaze/editMeterExplanationOfSavingsTitle.html',
                'showBreadcrumb': true,
                'width': 'full',
                'fullHeight': true,
                'permissionType': ["ManuallyAdjustSavingsManage", "LicenseFeatureCostAvoidanceView"]
            },
            {
                'type': 'create-other-adjustment',
                'url': 'assets/templates/buildings/meter/createOtherSavings.html',
                'title': 'Add Other Savings',
                'titleUrl': 'assets/templates/glaze/formTitle.html',
                'showBreadcrumb': false,
                'permissionType': ["SavingsAdjustmentsManage", "LicenseFeatureCostAvoidanceView"],
                'width': 'small'
            },
            {
                'type': 'edit-other-adjustment',
                'url': 'assets/templates/buildings/meter/editOtherSavings.html',
                'title': 'Edit Other Savings',
                'titleUrl': 'assets/templates/glaze/formTitle.html',
                'showBreadcrumb': false,
                'permissionType': "SavingsAdjustmentsManage",
                'width': 'small'
            },
            {
                'type': 'create-special-adjustment',
                'url': 'assets/templates/buildings/meter/createSpecialAdjustment.html',
                'title': 'Add Special Adjustment',
                'titleUrl': 'assets/templates/glaze/formTitle.html',
                'showBreadcrumb': false,
                'permissionType': ["SavingsAdjustmentsManage", "LicenseFeatureCostAvoidanceView"],
                'width': 'small'
            },
            {
                'type': 'edit-special-adjustment',
                'url': 'assets/templates/buildings/meter/editSpecialAdjustment.html',
                'title': 'Edit Special Adjustment',
                'titleUrl': 'assets/templates/glaze/formTitle.html',
                'showBreadcrumb': false,
                'permissionType': ["SavingsAdjustmentsManage", "LicenseFeatureCostAvoidanceView"],
                'width': 'small'
            },
            // Administration
            {
                'type': 'edit-report-group',
                'url': 'assets/templates/administration/reportGroups/editReportGroup.html',
                'title': 'Edit Report Group',
                'titleUrl': 'assets/templates/glaze/formTitle.html',
                'width': 'large',
                'permissionType': "ReportGroupsManage"
            },
            {
                'type': 'add-report-group',
                'url': 'assets/templates/administration/reportGroups/editReportGroup.html',
                'title': 'Add Report Group',
                'titleUrl': 'assets/templates/glaze/formTitle.html',
                'width': 'large',
                'permissionType': "ReportGroupsManage"
            },
            {
                'type': 'copy-report-group',
                'title': 'Copy Report Group',
                'titleUrl': 'assets/templates/glaze/formTitle.html',
                'permissionType': "ReportGroupsManage"
            },
            {
                'type': 'edit-target-comparison',
                'url': 'assets/templates/administration/targetComparison/editTargetComparison.html',
                'title': 'Edit Target Comparison Settings',
                'titleUrl': 'assets/templates/glaze/formTitle.html',
                'permissionType': "ApplicationSettingsManage"
            },
            {
                'type': 'edit-normalization',
                'url': 'assets/templates/administration/normalization/editNormalization.html',
                'title': 'Edit Normalization',
                'titleUrl': 'assets/templates/glaze/formTitle.html',
                'permissionType': "NormalizationSettingsManage"
            },
            {
                'type': 'edit-cost-avoidance',
                'url': 'assets/templates/administration/costAvoidance/editCostAvoidance.html',
                'title': 'Edit Default Cost Avoidance Settings for New Meters',
                'titleUrl': 'assets/templates/glaze/formTitle.html',
                'width': 'medium',
                'permissionType': ["GlobalCostAvoidanceSettingsManage", "LicenseFeatureCostAvoidanceView"]
            },
            // Import Interval Data
            {
                'type': 'import-interval-data',
                'url': 'assets/templates/bills/importIntervalData.html',
                'title': 'Upload_TC',
                'titleUrl': 'assets/templates/glaze/importFormTitle.html',
                'width': 'small',
                'permissionType': "IntervalDataManage"
            }
            ],
            find: function (glazeType) {
                return _.find(this.catalog, function (item) {
                    return glazeType === item.type;
                });
            }
        };

        return glazeCatalog;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('glazeService', GlazeService);

    GlazeService.$inject = ['$q', '$http', '$compile', '$rootScope', 'userService', 'urlService', 'glazeCatalog', 'runtimeService', '$window', 'customValidator', '$translate', '$templateCache', '$state'];

    function GlazeService($q, $http, $compile, $rootScope, userService, urlService, glazeCatalog, runtimeService, $window, customValidator, $translate, $templateCache, $state) {
        // glazeId passed in
        var currentId = 0;

        // Object that'll hold the glaze item once we find it in the catalog
        var glazeItem = {};

        var service = {           
            openGlaze: openGlaze,
            getGlazeElement: null,
            actions: null, // New proposed way of handling actions within glazes.  would replace primary and secondary action below
            primaryAction: null,
            secondaryAction: null,
            setFormTitleErrorMessage: null,
            isGlazeShowing: isGlazeShowing,
            getCurrentId: getCurrentId,
            hideGlaze: hideGlaze,
            hideGlazeForStateChange: hideGlazeForStateChange,
            onCloseEvent: onCloseEvent,
            showErrorMessage: showErrorMessage,
            hideErrorMessage: hideErrorMessage,
            showLoading: showLoading,
            setLoadingVisibility: setLoadingVisibility,
            setSavingVisibility: setSavingVisibility,
            setWaitingOverlayVisibility: setWaitingOverlayVisibility,
            setConfirmingPrimaryActionVisibility: setConfirmingPrimaryActionVisibility,
            initialFormLoad: null,
            getGlazeOptions: getGlazeOptions,
            getGlazeTitle: getGlazeTitle,
            showPrimaryActionConfirmationMessage: showPrimaryActionConfirmationMessage,
            setFormIsConfirmingPrimaryAction: [],
            setIsImporting: null,
            translateFormTitle: translateFormTitle,
            state: {
                showSpinner: false,
                spinnerText: ''
            }
        };

        // Variable that will hold the glaze scope that we will use to compile the glaze
        // and destroy when hiding the glaze.
        var glazeScope;

        //if the user changes states, force the glaze to close. This way if they navigate
        //backwards while it is open the page doesn't swap out behind the glaze.
        //subscribe only once at initialization
        $state.subscribeToEvent('$stateChangeSuccess', function () {
            hideGlaze();
        });

        function showLoading(awaiter) {
            setLoadingVisibility(true);

            awaiter.notifyWhenDone().then(function (data) {
                setLoadingVisibility(false);
            },
            function (data) {
                setLoadingVisibility(false);
            });
        }

        function setWaitingOverlayVisibility(waiting, text) {
            service.state.showSpinner = waiting;
            service.state.spinnerText = text;
        }

        function setLoadingVisibility(loading) {
            service.state.showSpinner = loading;
            service.state.spinnerText = "Loading";
        }

        function setSavingVisibility(saving) {
            service.state.showSpinner = saving;
            service.state.spinnerText = "Saving";
        }

        function setConfirmingPrimaryActionVisibility(confirming) {
            if (service.setFormIsConfirmingPrimaryAction.length > 0) {
                angular.forEach(service.setFormIsConfirmingPrimaryAction, function (func) {
                    func(confirming);
                });
            }
        }

        function getGlazeOptions() {
            return glazeItem.options;
        }

        function getGlazeTitle() {
            return glazeItem.customTitle || glazeItem.title;
        }

        // Our beginning function to display the glaze.  Accepts the objects id and the type of the glaze
        // First it checks permissions (if any) and then sends the glaze information along to render
        function glaze(id, type, customTitle, options) {
            service.setFormIsConfirmingPrimaryAction = [];
            service.state = { showSpinner: false, spinnerText: '' };

            // Set our current id that all controllers will use now instead of urlService
            currentId = id;

            // Go out to the catalog of glazes and find the one we're looking for
            glazeItem = glazeCatalog.find(type);

            glazeItem.customTitle = customTitle;

            if (options) {
                glazeItem.options = options;
            }

            // We'll only continue if we have a valid glaze item in the catalog, if not do nothing
            runtimeService.getConfigData().then(function (e) {
                if (glazeItem) {
                    // If this glaze requires a certain level of permission we must check first
                    if (glazeItem.permissionType) {
                        if (userService.userHasPermission(glazeItem.permissionType)) {
                            // What if they don't?  Just don't show anything?
                            getGlazeHtml(glazeItem.url, glazeItem.titleUrl);
                        }
                    } else {
                        // No permission needed for this page, just show it
                        getGlazeHtml(glazeItem.url, glazeItem.titleUrl);
                    }
                }
            });
        }

        // Go get the markup for a given template name from the template cache if possible,
        // but if it isn't there yet, load it from the server and stow it in the cache.
        // This way loading multiple glazes doesn't require us to download the template each time
        function loadTemplate(templateUrl) {
            var deferred = $q.defer();
            var fromCache = $templateCache.get(templateUrl);

            if (fromCache) {
                deferred.resolve(fromCache);
            } else {
                $http.get(templateUrl).then(function (templateResponse) {
                    $templateCache.put(templateUrl, templateResponse.data);
                    deferred.resolve(templateResponse.data);
                });
            }
            return deferred.promise;
        }

        // Given a template url and a title template url, this gets the html bits and then compiles them for the angular to work
        // If there is no title template url the standard kendo title (label and close button) will render
        // The html then gets passed on to the function that displays the glaze
        function getGlazeHtml(url, titleUrl) {
            // Grab the html template for the requested glaze
            loadTemplate(url).then(function (templateMarkup) {
                // Compile the html to let the angular work its magic
                glazeScope = $rootScope.$new(true);
                var templateHtml = $compile(templateMarkup)(glazeScope);

                glazeScope.disableBreadcrumbs = true;

                if (titleUrl) {
                    // There is a custom title template, get the html template
                    loadTemplate(titleUrl).then(function (titleMarkup) {
                        // Compile the html to let the angular work its magic
                        var titleHtml = $compile(titleMarkup)(glazeScope);
                        showGlaze(templateHtml, titleHtml);
                    });

                    // Add a class to the glaze if we are using the navigationTitle template for special styling
                    if (titleUrl.indexOf('navigationTitle.html') > -1) {
                        service.getGlazeElement().wrapper.addClass('ec-glaze-nav-header');
                    }

                }
                else {
                    showGlaze(templateHtml, null);
                }
            });
        }

        // Takes the compiled html and appends it to the window and title to display our glaze
        function showGlaze(templateHtml, titleHtml) {
            // These are simple displays so are just inline html for now
            var breadcrumbMarkup = '<div ng-controller="headerController as header" class="ec-breadcrumb-bar" disabled><ng-include src="\'assets/templates/core/breadcrumbs.html\'"></ng-include></div>';
            var waitingHtml = $compile("<div ng-controller='formWaitingOverlayController as waiting' ng-show='waiting.glazeService.state.showSpinner' class='ec-glaze-overlay'>" +
                                    "<card-body-overlay data-loading='waiting.glazeService.state.showSpinner' data-overlay-message='waiting.glazeService.state.spinnerText'></card-body-overlay></div>")(glazeScope);
            var errorHtml = $compile('<div ng-controller="formErrorController as formError" class="ec-util-flex-shrink"><div ng-show="formError.errorMessage" class="ec-glaze-error alert alert-warning mb-0" ng-bind-html="formError.errorMessage"></div></div>')(glazeScope);
            var glazeElement = service.getGlazeElement();

            if (glazeElement) {

                glazeElement.wrapper.removeClass('ec-catalyst-notitle');
                // Check if there is custom title text defined that overrides the glaze catalog entry. 
                if (glazeItem.customTitle) {
                    glazeElement.title($translate.instant(glazeItem.customTitle));
                }
                // if no custom title text, try using the glazeCatalog entry default title text
                else if (glazeItem.title) {
                    glazeElement.title($translate.instant(glazeItem.title));
                } else if(glazeItem.title === '') {
                    glazeElement.title('');
                    glazeElement.wrapper.addClass('ec-catalyst-notitle');
                }

                if (titleHtml) {
                    // There is a custom title template (for custom buttons or the like) defined for this glaze, render that in the header
                    // Remove all action buttons and add in our own html
                    glazeElement.setOptions({ actions: [] });
                    glazeElement.wrapper.find(".k-window-actions").append(titleHtml);
                }
                else {
                    // Set default action of Close to have the standard close button
                    glazeElement.setOptions({ actions: ["Close"] });
                }

                //insert the breadcrumb at the top if we need one, removing the old one in case we opened a second dialog on the same page
                //Do the $compile call here so we don't do it at all if there is no breadcrumb. It is expensive
                glazeElement.wrapper.find('.ec-breadcrumb-bar').remove();
                if (glazeItem.showBreadcrumb) {
                    var breadcrumbHtml = $compile(breadcrumbMarkup)(glazeScope);
                    glazeElement.wrapper.find('.k-window-titlebar').addClass('border-bottom-0').after(breadcrumbHtml)
                } else {
                    glazeElement.wrapper.find('.k-window-titlebar').removeClass('border-bottom-0');
                }

                var windowElement = angular.element("#glazeWindow");

                // Clear any potentially lingering html from the window and then append our new html
                windowElement.empty();
                windowElement.append(errorHtml);
                windowElement.append(templateHtml);
                windowElement.append(waitingHtml);

                // Set height 
                if (glazeItem.fullHeight) {
                    glazeElement.wrapper.addClass('ec-glaze-full-height');
                } else {
                    glazeElement.wrapper.removeClass('ec-glaze-full-height');
                }

                // The class will persist on the glaze element so we need to reset width classes before settting.
                glazeElement.wrapper.removeClass('ec-glaze-full ec-glaze-small ec-glaze-medium ec-glaze-large');

                // Set width class (medium is the default is no width is set in the catalog)
                if (glazeItem.width) {
                    glazeElement.wrapper.addClass('ec-glaze-' + glazeItem.width);
                } else {
                    glazeElement.wrapper.addClass('ec-glaze-medium');
                }

                // Kendo puts a &nbsp; in the title before the title text, we'd like to remove it for style purposes
                // It seems to hold no use
                angular.element('.k-window-titlebar').contents().filter(function () {
                    // Node Type 3 is Text
                    return this.nodeType === 3;
                }).remove();

                // Add an open class to initiate CSS animations
                glazeElement.wrapper.parent().addClass('open');

                // Now finally we show the user the glaze!
                glazeElement.open();

                // glaze is now open. so broadcast the listeners about this good news so that autofocus can work and
                // the forms can start loading their api request data
                $rootScope.$broadcast('glazeIsOpen');
            }
        }

        // Function to open a glaze window from javascript.
        function openGlaze(glazeId, glazeType, glazeCustomTitle, glazeOptions) {
            glaze(glazeId, glazeType, glazeCustomTitle, glazeOptions);
        }

        // Returns the hidden value of the window (true or false) to determine if the window is currently open
        function isGlazeShowing() {
            return service.getGlazeElement().element.is(":hidden");
        }

        // Returns the ID of the object being used in the glaze, can be a place, meter, account, etc
        function getCurrentId() {
            return $window.currentId || currentId;
        }

        function hideGlazeForStateChange(event) {
            //run the code only on left-click with no control key.
            //otherwise assume they are trying to open in new tab/window and we don't want to close
            if (!event.ctrlKey && event.button == 0) {
                hideGlaze();
            }
        }

        // Clears the glaze html and hides the window
        function hideGlaze() {
            if (!service || !service.getGlazeElement) {
                return;
            }

            setSavingVisibility(false);
            //setLoadingVisibility(false);

            var glazeElement = service.getGlazeElement();

            if (glazeElement) {
                // Destroy the scope that we created for the glaze so any
                // dangling Kendo DOM objects get cleaned up and unwatchers
                // fired.
                glazeElement.wrapper.removeClass('ec-glaze-nav-header ec-glaze-full-height');
                angular.element("#glazeWindow").empty();
                
                glazeElement.close();

                if (glazeScope) {
                    glazeScope.$destroy();
                }
            }
        }

        // Windows on close event.  Clears out our action functions and sets the url back to what is was before the glaze opened
        function onCloseEvent(event) {
            var glazeElement = service.getGlazeElement();
            glazeElement.wrapper.parent().removeClass('open');
            service.primaryAction = null;
            service.secondaryAction = null;
            service.actions = null;
            if ($window.ECP && $window.ECP.onGlazeClose && typeof($window.ECP.onGlazeClose == 'function')) {
                $window.ECP.onGlazeClose();
            }
        }

        // Accepts a string error message from the driving controller to indicate something failed while calling an API
        // Set's waiting to false since the form was disabled and showing the waiting spinner while it was being called
        function showErrorMessage(message) {
            service.setConfirmingPrimaryActionVisibility(false);
            service.translateFormTitle(message);

        }

        function translateFormTitle(message) {
            if (message) {

                // if there are multiple messages. wrap each message around <p> tag and stack them.
                // example: used in editCostAvoidanceController
                if (Array.isArray(message)) {
                    message = message.map(function (e) { return "<p>" + $translate.instant(_.escape(e)) + "</p>"; }).join("");
                    service.setFormTitleErrorMessage(message);
                }
                else {
                    service.setFormTitleErrorMessage("<p>" + $translate.instant(_.escape(message)) + "</p>");
                }

            }
            else {
                service.setFormTitleErrorMessage("<p>" + $translate.instant(customValidator.validationMessages.genericHeaderMessage()) + "</p>");
            }
        }


        function hideErrorMessage() {
            service.hideFormTitleErrorMessage();
        }

        // Accepts a string confirmation message from the driving controller to confirm a primary action
        // Enter blank string to cancel confirmation
        function showPrimaryActionConfirmationMessage(message) {
            if (Array.isArray(message) || message !== "") {
                service.setConfirmingPrimaryActionVisibility(true);
            }
            else {
                service.setConfirmingPrimaryActionVisibility(false);
            }

            service.translateFormTitle(message);
        }

        return service;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('importFormTitleController', ImportFormTitleController);

    ImportFormTitleController.$inject = ['$rootScope', 'glazeService'];

    function ImportFormTitleController($rootScope, glazeService) {
        var vm = this;        
        vm.isImporting = false;
        vm.isImportComplete = false;        
        vm.glazeService = glazeService;

        (function constructor() {

            vm.secondaryAction = secondaryAction;
            vm.primaryAction = primaryAction;

            glazeService.setIsImporting = setIsImporting;

        })();

        function setIsImporting(importing, isImportComplete) {
            vm.isImportComplete = isImportComplete;
            vm.isImporting = importing;
        }

        function secondaryAction() {
            glazeService.secondaryAction();
        }

        function primaryAction() {
            glazeService.primaryAction();
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('navigationTitleController', NavigationTitleController);

    NavigationTitleController.$inject = ['$rootScope', 'glazeService'];

    function NavigationTitleController($rootScope, glazeService) {
        var vm = this;

        (function constructor() {

            // Initialize our error message in case there is a form error returned from the API
            vm.errorMessage = "";

            // Link our function to set our error message field to the service so when we have an error we can 
            // display it here
            glazeService.setFormTitleErrorMessage = setFormTitleErrorMessage;

            // Setup our actions for the form title, these will call the glaze services
            // primary and secondary actions which will be dictated by the forms controller
            vm.secondaryAction = secondaryAction;

        })();

        function secondaryAction() {
            if (glazeService.actions != null) {
                glazeService.actions.secondaryAction();
            }
        }

        function setFormTitleErrorMessage(message) {
            vm.errorMessage = message;
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('glazeController', GlazeController);

    GlazeController.$inject = ['glazeService', '$window'];
    function GlazeController(glazeService, $window) {
        var vm = this;

        vm.glazeOnClose = glazeService.onCloseEvent;

        $window.ECP.openGlaze = glazeService.openGlaze;
        $window.ECP.hideGlaze = glazeService.hideGlaze;

        (function constructor() {
            glazeService.getGlazeElement = getGlazeElement;
        })();

        function getGlazeElement() {
            if (!vm.glazeWindow.wrapper.parent().hasClass('ec-glaze-container')) {
                vm.glazeWindow.wrapper.wrap('<div class="ec-glaze-container"></div>')
            }
            return vm.glazeWindow;
        }
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('gridHelper', GridHelper);

    GridHelper.$inject = [];

    /**
     * Provides utility functions related to grids
     * @constructor
     */
    function GridHelper() {

        var xxxSmallColumn = 40;
        var xxSmallColumn = 60;
        var xSmallColumn = 90;
        var smallColumn = 120;
        var mediumColumn = 160;
        var largeColumn = 200;
        var xLargeColumn = 250;
        var xxLargeColumn = 300;
        var xxxLargeColumn = 400;

        var service = {

            // column sizes
            XXXSMALL_COLUMN: xxxSmallColumn,
            XXSMALL_COLUMN: xxSmallColumn,
            XSMALL_COLUMN: xSmallColumn,
            SMALL_COLUMN: smallColumn,
            MEDIUM_COLUMN: mediumColumn,
            LARGE_COLUMN: largeColumn,
            XLARGE_COLUMN: xLargeColumn,
            XXLARGE_COLUMN: xxLargeColumn,
            XXXLARGE_COLUMN: xxxLargeColumn,

            // column sizes by type
            CURRENCY_COLUMN: xSmallColumn,
            DATE_COLUMN: xSmallColumn,
            LONG_OBJECT_NAMES: xxLargeColumn,
            PERSON_COLUMN: mediumColumn,
            UNIT_COLUMN: xSmallColumn,
            USE_COLUMN: xSmallColumn,

            // action icon size
            ACTION_ICON_WIDTH: 30,

            // row height
            HEADER_ROW_HEIGHT: 31,
            STANDARD_ROW_HEIGHT: 32,

            // These functions may in the future be moved to powerviewHelper to help decouple this helper from
            // powerview related logic.  This would require further work upstream at the powerview controller to call
            // helper functions for content from powerviewHelper instead of 'summaryChartHelper', for instance.  This would allow
            // powerviewHelper to call summaryChartHelper to get chart related details, then invoke these functions from itself for details view
            getAmChartDetailsDataGridConfig: getAmChartDetailsDataGridConfig,
            getArrowChartDetailsDataGridConfig: getArrowChartDetailsDataGridConfig
        };

        /**
         * Function that takes in a chart and a partial data grid config and returns a completed data grid config
         * @param {Object} chartConfig AmChart config
         * @param {Object} dataGridConfig Data grid config
         * @returns {Object} Data grid definition for details view
         */
        function getAmChartDetailsDataGridConfig(chartConfig, dataGridConfig) {
            var gridDefinitionOverrides = null;

            // If the controller specified column data explicitly, use that and let the ecGrid do the translation
            // otherwise check the chart type, we'll grab the column headers a little different for each type
            if (dataGridConfig && dataGridConfig.columns) {
                gridDefinitionOverrides = dataGridConfig;
            } else if (chartConfig.type === "pie") {
                gridDefinitionOverrides = { columns: pieChartColumns(chartConfig) };
            } else if (chartConfig.type === "serial") {
                gridDefinitionOverrides = { columns: serialChartColumns(chartConfig) };
            }

            // Add copy action button as last column
            gridDefinitionOverrides.columns.push(getDetailsGridCopyToClipboardColumn());

            // AmChart details grids are not resizable
            gridDefinitionOverrides.resizable = false;

            //add on any rows that should be only in the grid, like the target data points when targets are on
            var gridRows = (chartConfig.dataProvider || []).concat(gridDefinitionOverrides.additionalRows || []);

            return angular.extend(
                getDefaultGridDefinition(),
                gridDefinitionOverrides,
                { dataSource: { data: gridRows } }
            );
        }

        /**
         * Function that takes in a chart and a partial data grid config and returns a completed data grid config
         * @param {Object} chartConfig Arrow chart config
         * @param {Object} dataGridConfig Data grid config
         * @returns {Object} Data grid definition for details view
         */
        function getArrowChartDetailsDataGridConfig(chartConfig, dataGridConfig) {
            // Arrow type charts dataProvider is an object so we'll push that to our array, thus giving us one record with columns for every
            // property
            var config = angular.extend(
                getDefaultGridDefinition(),
                { columns: getDataProviderColumns(chartConfig) },
                dataGridConfig,
                { dataSource: { data: chartConfig.dataProvider.gridRows || [chartConfig.dataProvider] } } //TODO: remove the fallback for the generated row data once all arrow charts are converted
            );

            // Add copy action button as last column
            config.columns.push(getDetailsGridCopyToClipboardColumn());

            // AmChart details grids are not resizable
            config.resizable = false;

            return config;
        }

        /**
         * Function that returns the column definition for copy to clipboard
         * @returns {Object} Copy to clipboard column
         * @private
         */
        function getDetailsGridCopyToClipboardColumn() {
            return {
                headerAttributes: {
                    class: 'ec-grid-actions'
                },
                width: service.ACTION_ICON_WIDTH,
                headerTemplate: '<button class="btn btn-secondary ec-btn-icon"' +
                'ngclipboard ngclipboard-success="vm.copySuccess(e)"' + 'data-clipboard-target="#{{vm.id}}"' +
                'title="{{\'Copy data to clipboard\' | translate}}"' +
                'data-toggle="tooltip" tooltip>' +
                '<i class="ec-icon icon-copy"></i>' +
                '</button>'
            };
        }

        /**
         * Function that takes in any chart config and creates columns based on the keys
         * @param {Object} chartConfig Generic chart config
         * @returns {Object} Data grid columns based on a data provider
         * @private
         */
        function getDataProviderColumns(chartConfig) {
            var columns = [];
            Object.keys(chartConfig.dataProvider).forEach(function (key, index) {
                columns.push({
                    field: key,
                    title: key
                });
            });

            return columns;
        }

        /**
         * Function that takes in a serial chart config and generates data grid columns from it
         * @param {Object} chartConfig Serial chart config
         * @returns {Object} Serial chart columns for the data grid
         * @private
         */
        function serialChartColumns(chartConfig) {

            // Start out with the category field for the chart
            var columns = [
                {
                    field: chartConfig.categoryField,
                    title: chartConfig.categoryField
                }
            ];

            // Loop through all of the graphs pulling their value fields
            angular.forEach(chartConfig.graphs, function (graph) {
                var column = {
                    field: graph.valueField,
                    title: graph.valueField
                };

                columns.push(column);
            });

            return columns;
        }

        /**
         * Function that takes in a pie chart config and generates data grid columns from it
         * @param {Object} chartConfig Pie chart config
         * @returns {Object} Pie chart columns for the data grid
         * @private
         */
        function pieChartColumns(chartConfig) {
            // Grab the title and value field for the display
            var columns = [
                {
                    field: chartModel.titleField,
                    title: chartModel.titleField
                },
                {
                    field: chartModel.valueField,
                    title: chartModel.valueField
                }
            ];

            if (chartModel.percentField) {
                display.push({
                    field: chartModel.percentField,
                    title: chartModel.percentField,
                    template: '#=' + chartModel.percentField + '.toFixed(1) + "%"#'
                });
            }

            return columns;
        }

        /**
         * Function that returns a default data grid definition
         * @returns {Object} Default data grid definition
         * @private
         */
        function getDefaultGridDefinition() {
            // Basic definition of our grid for the chart data, the rest will be
            // filled in based on the chart type
            return {
                fontFamily: 'Roboto-Regular',
                scrollable: false,
                pageable: false,
                resizeable: false,
                columns: []
            };
        }

        return service;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('headerController', HeaderController);

    HeaderController.$inject = ['glazeService', '$state', '$rootScope', '$scope', 'userService', 'runtimeService', 'headerService', 'commodityIconPipe', 'confirmationService', '$translate', '$window'];

    function HeaderController(glazeService, $state, $rootScope, $scope, userService, runtimeService, headerService, commodityIconPipe, confirmationService, $translate, $window) {
        var vm = this;

        vm.state = $state;
        vm.showBreadcrumbBar = true;
        vm.headerData = {};

        if ($state.current.data) {
            vm.primaryTabs = userService.validateTabs($state.current.data.nav);

            angular.forEach(vm.primaryTabs, function (tab) {
                var subTabs = [];
                if (tab.sub && tab.sub.length > 0) {
                    subTabs = userService.validateTabs(tab.sub);
                }

                if (subTabs.length > 0) {
                    tab.defaultState = subTabs[0].stateIs;
                }
                else {
                    tab.defaultState = tab.stateIs;
                }
            });

            vm.secondaryTabs = getSecondaryTabs($state.current.name);

            if ($state.current.data.header) {
                vm.id = $state.params[$state.current.data.header.stateId];
                vm.baseUrl = $state.current.data.header.baseUrl;
                vm.editTooltip = $state.current.data.header.editTooltip;
                vm.deleteTooltip = $state.current.data.header.deleteTooltip;
                vm.showSavebutton = $state.current.data.header.showSavebutton; 
            }

            if ($state.params.commodityCode) {
                vm.commodityIcon = commodityIconPipe.transform($state.params);
                vm.commodityInfo = $state.params.commodityInfo;
            }
        }

        vm.showBreadcrumbMenu = false;

        vm.editSelf = function () {
            var headerState =  $state.current.data.header;

            if (headerState && headerState.editDirectLink) {
                $window.location.href = headerState.editDirectLink + vm.id;
            } else if(headerState && headerState.setupDirectLink) {
                $window.location.href = headerState.setupDirectLink + vm.id + "/setup";
            } else {
                glazeService.openGlaze(vm.id, $state.current.data.header.editGlaze);
            }
        };

        vm.deleteSelf = function () {

            confirmationService.confirmation($translate.instant("Delete"), $translate.instant("Are you sure?")).then(function (result) {

                if (!result) {
                    return;
                }

                headerService.deleteSelectedItem(vm.headerData);
            });

        };

        vm.onSave = function() {
            $window.history.back();
        };

        (function constructor() {
            getHeaderData();

            var stateChangeWatcher = $rootScope.$on('$stateChangeStart', stateChanged);

            $scope.$on('$destroy', function () {
                stateChangeWatcher();
            });

        })();

        function stateChanged(event, toState, toParams, fromState, fromParams) {
            if (toState.name.indexOf($state.current.name.split(".")[0] + ".") > -1) {
                getHeaderData(toState, toParams);
            }
        }

        function getSecondaryTabs(stateIs) {
            // During an Unauthorized page the state change start event will still fire, but the primary tabs will be empty
            // Since we validated the tabs above, so make sure there are tabs to return
            var secondaryTabs = _.filter(vm.primaryTabs, function (n) {
                return _.startsWith(stateIs, n.stateIs);
            });
            return secondaryTabs.length > 0 ? userService.validateTabs(secondaryTabs[0].sub) : [];
        }

        function seperateBreadcrumbs(result) {
            if (result.breadcrumbs.length > 2) {
                result.secondaryBreadcrumbs = _.take(result.breadcrumbs, result.breadcrumbs.length - 2);
                result.breadcrumbs = _.drop(result.breadcrumbs, result.breadcrumbs.length - 2);
            }

            return result;
        }

        function getHeaderData(toState, toParams) {            
            runtimeService.getConfigData().then(function (config) {
                if ($state.current && $state.current.data && $state.current.data.header) {
                    vm.breadcrumbDisplay = config.preference[$state.current.data.header.breadCrumbDisplay];
                }

                if (headerService.previousBreadcrumbs.length > 0) {
                    vm.headerData.breadcrumbs = headerService.previousBreadcrumbs;
                    seperateBreadcrumbs(vm.headerData);
                }

                // Load the secondary tabs as soon as possible.
                // headerService.getHeaderData will shuffle the toState data
                // to the current state data; but since the state change
                // has been successful, load the secondary tabs immediately.  
                if (vm.primaryTabs && toState) {
                    vm.secondaryTabs = getSecondaryTabs(toState.name);
                }

                headerService.getHeaderData(toState, toParams).then(function (result) {
                    if (result) {
                        vm.headerData = result;

                        // Sometimes we need to manage whether an object can be edited or not in the header service, but in cases where it's not set
                        // we should just set it to true since it's edit state is being managed from the modules stateprovider
                        if (!vm.headerData.hasOwnProperty("editable")) {
                            vm.headerData.editable = true;
                        }

                        if (vm.headerData.hasOwnProperty("baseUrl")) {
                            vm.baseUrl = vm.headerData.baseUrl;
                        }
                        
                        if (vm.headerData.code) {
                            vm.headerData.codeDisplay = "[" + vm.headerData.code + "]";
                        }
    
                        if (result.breadcrumbs && result.breadcrumbs.length > 0) {
                            seperateBreadcrumbs(vm.headerData);
                        }

                        if (vm.deleteTooltip) {
                            // Make sure the user has permission to delete and the item isn't their topmost
                            vm.userHasDeletePermission = headerService.userHasDeletePermission(config, vm.headerData, $state.current.data.header.deletePermission);
                        }

                        // If this is editable and has the editTooltip check that the user has permission
                        if (vm.headerData.editable && vm.editTooltip) {
                            vm.userHasEditPermission = headerService.userHasEditPermission(config, vm.headerData, $state.current.data.header.editPermission)
                        }
                    } else {
                        vm.showBreadcrumbBar = false;
                    }
                });
            });
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('headerService', HeaderService);

    HeaderService.$inject = ['apiResource', '$state', '$q', '$window', 'userService', '$translate', 'translationHelper', 'commodityIconPipe', 'meterIconPipe', 'placeTypeIconPipe', 'placeRoutePipe'];

    function HeaderService(apiResource, $state, $q, $window, userService, $translate, translationHelper, commodityIconPipe, meterIconPipe, placeTypeIconPipe, placeRoutePipe) {

        var service = {
            getHeaderData: getHeaderData,
            userHasDeletePermission: userHasDeletePermission,
            userHasEditPermission: userHasEditPermission,
            deleteSelectedItem: deleteSelectedItem,
            toggleDashboardLock: null,
            previousBreadcrumbs: []
        };

        return service;

        function getHeaderData(toState, toParams) {
            var deferred = $q.defer();

            //hold onto the breadcrumbs we last returned so that we can reuse them when we open a glaze without figuring it out again.
            //we generate a key so that we're sure the state we're looking at matches the breadcrumb state to prevent the breadcrumb from getting "stuck"
            var stateKey = ((toState !== undefined) ? toState.name : $state.current.name) + '-' + ((toParams !== undefined) ? JSON.stringify(toParams) : JSON.stringify($state.params));

            if ($state.current && $state.current.data && $state.current.data.breadcrumbs && $state.current.data.breadcrumbKey === stateKey) {
                deferred.resolve($state.current.data.breadcrumbs);
            } else {
                // Calling the state header data function which then gets header data for the given state
                // Once that is returned we can do some post processing before handing it back to the front end
                getStateHeaderData(toState, toParams).then(function (result) {
                    if (result) {
                        if (result.breadcrumbs) {
                            // Store the current items breadcrumbs so when we change states we can revive them until the new are returned
                            service.previousBreadcrumbs = result.breadcrumbs;
                        }
                        $state.current.data.breadcrumbs = result;
                    }
                    // The breadcrumbKey will sometimes not stick unless it is set here
                    $state.current.data.breadcrumbKey = stateKey;

                    deferred.resolve(result);
                });
            }

            return deferred.promise;
        }

        function getStateHeaderData(toState, toParams) {
            var deferred = $q.defer();

            if ($state.current.name.startsWith("building") || $state.current.name.startsWith("organization")) {
                getBuildingHeaderData().then(function (result) {
                    deferred.resolve(result);
                });
            } else if ($state.current.name.startsWith("placecategories") || $state.current.name.startsWith("placecategory")) {
                getPlaceCategoryHeaderData().then(function (result) {
                    deferred.resolve(result);
                });
            } else if ($state.current.name.startsWith("metercategories") || $state.current.name.startsWith("metercategory")) {
                getMeterCategoryHeaderData().then(function (result) {
                    deferred.resolve(result);
                });
            } else if ($state.current.name.startsWith("metergroup")) {
                getMeterGroupHeaderData().then(function (result) {
                    deferred.resolve(result);
                });
            } else if ($state.current.name.startsWith("placegroup")) {
                getPlaceGroupHeaderData().then(function (result) {
                    deferred.resolve(result);
                });
            } else if ($state.current.name.startsWith("meter")) {
                getMeterHeaderData().then(function (result) {
                    deferred.resolve(result);
                });
            } else if ($state.current.name.startsWith("account")) {
            } else if ($state.current.name.startsWith("costCenter")) {
            } else if ($state.current.name.startsWith("billLists")) {
                getBillListHeaderData(toState, toParams).then(function (result) {
                    deferred.resolve(result);
                });
            } else if ($state.current.name.startsWith("batches")) {
                getBatchBillListHeaderData(toState, toParams).then(function (result) {
                    deferred.resolve(result);
                });
            } else if ($state.current.name.startsWith("billImport")) {
                getImportBillListHeaderData(toState, toParams).then(function (result) {
                    deferred.resolve(result);
                });
            } else if ($state.current.name.startsWith("chargebacks")) {
                getChargebacksHeaderData(toState).then(function (result) {
                    deferred.resolve(result);
                });
            } else if ($state.current.name.startsWith("intervaldata")) {
                getIntervalDataHeaderData(toState).then(function (result) {
                    deferred.resolve(result);
                });
            } else if ($state.current.name.startsWith("reports")) {
                getReportsHeaderData(toState).then(function (result) {
                    deferred.resolve(result);
                });
            } else if ($state.current.name.startsWith("administration")) {
                getAdministrationHeaderData(toState).then(function (result) {
                    deferred.resolve(result);
                });
            } else if ($state.current.name.startsWith("vendor")) {
                getVendorHeaderData().then(function (result) {
                    deferred.resolve(result);
                });
            } else if ($state.current.name.startsWith("commodity")) {
                if ($state.current.name.startsWith("commodityViewCommodity")) {
                    getCommodityViewCommodityHeaderData().then(function (result) {
                        deferred.resolve(result);
                    });
                } else if ($state.current.name.startsWith("commodityViewVendor")) {
                    getCommodityViewVendorHeaderData().then(function (result) {
                        deferred.resolve(result);
                    });
                } else if ($state.current.name.startsWith("commodityViewRate")) {
                    getCommodityViewRateHeaderData().then(function (result) {
                        deferred.resolve(result);
                    });
                } else {
                    getVendorCommodityHeaderData().then(function (result) {
                        deferred.resolve(result);
                    });
                }
            } else if ($state.current.name.startsWith("rate")) {
                getVendorRateHeaderData().then(function (result) {
                    deferred.resolve(result);
                });
            } else {
                deferred.resolve(null);
            }

            return deferred.promise;
        }

        function userHasDeletePermission(config, entity, permission) {
            var userHasPermission = userService.userHasPermission(permission);

            // Additional checks can be done here
            if ($state.current.name.startsWith("costCenter")) {
                return userHasPermission && entity.costCenterId != config.costCenter.costCenterId;
            }

            return userHasPermission;
        }

        function userHasEditPermission(config, entity, permission) {
            var userHasPermission = userService.userHasPermission(permission);

            // Additional checks can be done here
            if ($state.current.name.startsWith("costCenter")) {
                return userHasPermission && entity.costCenterId != config.costCenter.costCenterId;
            } else if ($state.current.name.startsWith("organization")) {
                return userHasPermission && entity.placeId != config.place.placeId;
            }

            return userHasPermission;
        }

        function deleteSelectedItem(entity) {
            if ($state.current.name.startsWith("costCenter")) {
                // User is sure, let's attempt to delete the cost center
                apiResource.costCenter().costCenter().remove({ costCenterId: entity.costCenterId }, function (result) {
                    // Cost Center is now gone, locate to the parent of the Cost Center and refresh the tree
                    $window.location = "/accounts/costcenter/" + entity.parentId + "/actual/summary?refreshTree=true";
                }, function (error) {
                    /*eslint-disable */
                    // Something bad happened, alert the user of the message
                    alert(error.data.status.message);
                    /*eslint-enable */
                });
            } else if ($state.current.name.startsWith("rate")) {
                apiResource.rate().rate().remove({ rateId: entity.rateId }, function (result) {
                    // Rate is now gone, locate back to the vendor
                    $window.location = "/vendors#/vendor/" + entity.parentId + "/overview";
                }, function (error) {
                    /*eslint-disable */
                    // Something bad happened, alert the user of the message
                    alert(error.data.status.message);
                    /*eslint-enable */
                });
            } else if ($state.current.name.startsWith("vendor")) {
                apiResource.vendor().vendor().remove({ vendorId: entity.vendorId }, function (result) {
                    // Vendor is now gone, locate back to the root, don't know what tree view is showing
                    $window.location = "/vendors";
                }, function (error) {
                    /*eslint-disable */
                    // Something bad happened, alert the user of the message
                    alert(error.data.status.message);
                    /*eslint-enable */
                });
            }
        }

        function getBillListHeaderData(toState, toParams) {

            var deferred = $q.defer();

            if ((toState && toState.name.startsWith('billLists.export')) || (toState === undefined && $state.current.name.startsWith('billLists.export'))) {
                getBillExportHeaderData(toState, toParams).then(function (result) {
                    deferred.resolve(result);
                });
            } else {
                deferred.resolve({
                    info: 'Bill Lists'
                });
            }

            return deferred.promise;
        }

        function getIntervalDataHeaderData(toState) {
            var deferred = $q.defer();

            var headerData = {
                info: $translate.instant('Interval Data')
            }

            // Depending on how you are entering the page (ie. from a hyperlink in a different module or a soft entry from the same module),
            // toState and $state.current might not work as expected, which can mess up the breadcrumbs if the wrong state is used.
            // This code block handles the cases and figures out which state to use.
            if ((toState && toState.name === 'intervaldata.imports.formats') || (toState === undefined && $state.current.name === 'intervaldata.imports.formats')) {
                headerData.info = $translate.instant('IntervalDataImportFormats_TC');
            } else if ((toState && toState.name === 'intervaldata.imports') || (toState === undefined && $state.current.name === 'intervaldata.imports')) {
                headerData.info = $translate.instant('IntervalDataImport_TC');
            }

            deferred.resolve(headerData);

            return deferred.promise;
        }

        function getChargebacksHeaderData(toState) {
            var deferred = $q.defer();

            var headerData = {
                info: $translate.instant('Chargebacks_TC')
            };

            // Depending on how you are entering the page (ie. from a hyperlink in a different module or a soft entry from the same module),
            // toState and $state.current might not work as expected, which can mess up the breadcrumbs if the wrong state is used.
            // This code block handles the cases and figures out which state to use.
            if ((toState && toState.name === 'chargebacks.workflow') || (toState === undefined && $state.current.name === 'chargebacks.workflow')) {
                headerData.info = $translate.instant('ChargebackWorkflow_TC');
            } else if ((toState && toState.name.startsWith('chargebacks.billsplitlist')) || (toState === undefined && $state.current.name.startsWith('chargebacks.billsplitlist'))) {
                headerData.info = $translate.instant('BillsReadyToSplit_TC');
            }
            else if ((toState && toState.name.startsWith('chargebacks.chargebacklog')) || (toState === undefined && $state.current.name.startsWith('chargebacks.chargebacklog'))) {
                headerData.info = $translate.instant('ChargebackLog_TC');
            }

            deferred.resolve(headerData);

            return deferred.promise;
        }

        function getBatchBillListHeaderData(toState, toParams) {
            var deferred = $q.defer();

            var headerData = {
                info: $translate.instant('Batches')
            };

            // Depending on how you are entering the page (ie. from a hyperlink in a different module or a soft entry from the same module),
            // toState and $state.current might not work as expected, which can mess up the breadcrumbs if the wrong state is used.
            // This code block handles the cases and figures out which state to use.
            if ((toState && toState.name !== 'batches.list') || (toState === undefined)) {
                if (toParams && toParams.batchCode) {
                    headerData.info = toParams.batchCode;
                    headerData.breadcrumbs = [
                        {
                            Info: $translate.instant('Batches'),
                            locateLink: '/bills#/batches/list'
                        }
                    ];
                } else if ($state.params.batchCode) {
                    headerData.info = $state.params.batchCode;
                    headerData.breadcrumbs = [
                        {
                            Info: $translate.instant('Batches'),
                            locateLink: '/bills#/batches/list'
                        }
                    ];
                }
            }

            deferred.resolve(headerData);

            return deferred.promise;
        }

        function getImportBillListHeaderData(toState, toParams) {
            var deferred = $q.defer();

            var headerData = {
                info: $translate.instant('BillImport_TC')
            };

            // Depending on how you are entering the page (ie. from a hyperlink in a different module or a soft entry from the same module),
            // toState and $state.current might not work as expected, which can mess up the breadcrumbs if the wrong state is used.
            // This code block handles the cases and figures out which state to use.
            if ((toState && toState.name !== 'billImport.list') || (toState === undefined)) {
                if (toParams && toParams.importDate && toParams.importedBy) {
                    headerData.info = translationHelper.translateAndInterpolate('BillsImportedBreadcrumb_TC', {
                        'importDate': toParams.importDate,
                        'importedBy': toParams.importedBy
                    });
                    headerData.breadcrumbs = [
                        {
                            Info: $translate.instant('BillImport_TC'),
                            locateLink: '/bills#/billImport/list'
                        }
                    ];
                } else if ($state.params.importDate && $state.params.importedBy) {
                    headerData.info = translationHelper.translateAndInterpolate('BillsImportedBreadcrumb_TC', {
                        'importDate': $state.params.importDate,
                        'importedBy': $state.params.importedBy
                    });
                    headerData.breadcrumbs = [
                        {
                            Info: $translate.instant('BillImport_TC'),
                            locateLink: '/bills#/billImport/list'
                        }
                    ];
                }
            }

            deferred.resolve(headerData);

            return deferred.promise;
        }

        function getBillExportHeaderData(toState, toParams) {
            var deferred = $q.defer();

            var headerData = {
                info: $translate.instant('BillExport_TC')
            }


            // Depending on how you are entering the page (ie. hard entry from a hyperlink or soft entry from the same module),
            // toState and $state.current might not work as expected, which can mess up the breadcrumbs if the wrong state is used.
            // This code block handles the cases and figures out which state to use.
            if ((toState && toState.name === 'billLists.export.bills') || (toState === undefined && $state.current.name === 'billLists.export.bills')) {
                if (toParams && toParams.exportDest && toParams.exportDate && toParams.exportedBy) {
                    headerData.info = translationHelper.translateAndInterpolate('BillsExportedBreadcrumb_TC', {
                        'exportDest': toParams.exportDest,
                        'exportDate': toParams.exportDate,
                        'exportedBy': toParams.exportedBy
                    });
                    headerData.breadcrumbs = [
                        {
                            Info: $translate.instant('BillExport_TC'),
                            locateLink: '/bills#/billLists/export'
                        }
                    ];
                } else if ($state.params.exportDest && $state.params.exportDate && $state.params.exportedBy) {
                    headerData.info = translationHelper.translateAndInterpolate('BillsExportedBreadcrumb_TC', {
                        'exportDest': $state.params.exportDest,
                        'exportDate': $state.params.exportDate,
                        'exportedBy': $state.params.exportedBy
                    });
                    headerData.breadcrumbs = [
                        {
                            Info: $translate.instant('BillExport_TC'),
                            locateLink: '/bills#/billLists/export'
                        }
                    ];
                }
            }

            deferred.resolve(headerData);

            return deferred.promise;
        }

        function getBuildingHeaderData() {
            var deferred = $q.defer();

            var promises = {
                placeApi: apiResource.place().place({ cancelable: false }).get({ placeId: $state.params.placeId }).$promise,
                searchApi: apiResource.search().search({ cancelable: false }).get({ query: "placeId:" + $state.params.placeId, limit: 1 }).$promise
            };

            $q.all(promises).then(function (result) {
                var headerData = {};

                headerData.info = result.placeApi.placeInfo;
                headerData.code = result.placeApi.placeCode;
                headerData.placeId = result.placeApi.placeId;
                headerData.iconClass = placeTypeIconPipe.transform(result.placeApi.placeType);
                if (result.placeApi.placeId === 1) {
                    headerData.editable = false;
                }

                if (result.searchApi.places.length > 0) {
                    headerData.breadcrumbs = result.searchApi.places[0].result.parentPath;

                    angular.forEach(headerData.breadcrumbs, function (crumb) {
                        crumb.locateLink = placeRoutePipe.transformSync(crumb, 'ECAP', ['actual', 'summary'], true);
                    });
                }

                deferred.resolve(headerData);
            });

            return deferred.promise;
        }

        function getMeterHeaderData() {
            var deferred = $q.defer();

            var promises = {
                meterApi: apiResource.meter().meter({ cancelable: false }).get({ meterId: $state.params.meterId }).$promise,
                searchApi: apiResource.search().search({ cancelable: false }).get({ query: "meterId:" + $state.params.meterId, limit: 1 }).$promise
            };

            $q.all(promises).then(function (result) {
                var headerData = {};

                headerData.info = result.meterApi.meterInfo;
                headerData.code = result.meterApi.meterCode;
                headerData.commodity = result.meterApi.commodity;

                headerData.iconClass = meterIconPipe.transform(result.meterApi);
                headerData.channels = result.meterApi.channels;

                headerData.meterType = result.meterApi.meterType;

                if (result.searchApi.meters.length > 0) {
                    headerData.breadcrumbs = result.searchApi.meters[0].result.parentPath;

                    angular.forEach(headerData.breadcrumbs, function (crumb) {
                        crumb.locateLink = placeRoutePipe.transformSync(crumb, 'ECAP', ['actual', 'summary'], true);
                    });
                }

                deferred.resolve(headerData);
            });

            return deferred.promise;
        }


        function getReportsHeaderData(toState) {
            var deferred = $q.defer();
            var headerData = {};
            var stateName = toState ? toState.url.toLowerCase() : $state.current.url.toLowerCase();

            switch (stateName) {
                case 'recent':
                    headerData.info = 'RecentReports_TC';
                    break;
                case 'recommended':
                    headerData.info = 'Recommended reports'; //LOCO
                    break;
                case 'user':
                    headerData.info = 'MyReports_TC';
                    break;
                case 'shared':
                    headerData.info = 'ReportsSharedWithMe_TC';
                    break;
                default:
                    headerData.info = 'AllInstalledReports_TC';
            }

            headerData.info = $translate.instant(headerData.info);

            deferred.resolve(headerData);

            return deferred.promise;
        }

        function getAdministrationHeaderData(toState) {
            var deferred = $q.defer();
            var headerData = {};
            var stateName = toState ? toState.url.toLowerCase() : $state.current.url.toLowerCase();

            switch (stateName) {
                case 'reportgroups':
                    headerData.info = 'Report Groups';
                    break;
                case 'targetcomparison':
                    headerData.info = 'Target Comparison';
                    break;
                case 'normalization':
                    headerData.info = 'Normalization';
                    break;
                case 'costavoidance':
                    headerData.info = 'Cost Avoidance';
                    break;
                case 'setup':
                    headerData.info = 'Setup Spreadsheets';
                    break;
                default:
                    headerData.info = 'Administration';
            }

            headerData.info = $translate.instant(headerData.info);

            deferred.resolve(headerData);

            return deferred.promise;
        }

        function getVendorHeaderData() {
            var deferred = $q.defer();

            var promises = {
                vendorApi: apiResource.vendor().vendor({ cancelable: false }).get({ vendorId: $state.params.vendorId }).$promise
            };

            $q.all(promises).then(function (result) {
                var headerData = {};

                headerData.vendorId = result.vendorApi.vendorId;
                headerData.info = result.vendorApi.vendorInfo;
                headerData.code = result.vendorApi.vendorCode;

                deferred.resolve(headerData);
            });

            return deferred.promise;
        }

        function getVendorCommodityHeaderData() {
            var deferred = $q.defer();

            var promises = {
                vendorApi: apiResource.vendor().vendor({ cancelable: false }).get({ vendorId: $state.params.vendorId }).$promise
            };

            $q.all(promises).then(function (result) {
                var headerData = {};

                for (var i = 0; i < result.vendorApi.rates.length; i++) {
                    if (result.vendorApi.rates[i].commodity.commodityId.toString() === $state.params.commodityId) {
                        headerData.info = $translate.instant(result.vendorApi.rates[i].commodity.commodityInfo);
                        headerData.code = result.vendorApi.rates[i].commodity.commodityCode;
                        headerData.iconClass = commodityIconPipe.transform(result.vendorApi.rates[i].commodity);
                        break;
                    }
                }

                headerData.breadcrumbs = [{
                    vendorInfo: result.vendorApi.vendorInfo,
                    vendorCode: result.vendorApi.vendorCode,
                    locateLink: "vendors#/vendor/" + result.vendorApi.vendorId
                }];

                headerData.baseUrl = "/vendors#/vendor/" + $state.params.vendorId + "/commodity/";

                deferred.resolve(headerData);
            });

            return deferred.promise;
        }

        function getVendorRateHeaderData() {
            var deferred = $q.defer();

            var promises = {
                rateApi: apiResource.rate().rate({ cancelable: false }).get({ rateId: $state.params.rateId }).$promise
            };

            $q.all(promises).then(function (result) {
                var headerData = {};

                headerData.info = result.rateApi.name;
                headerData.code = null;

                headerData.breadcrumbs = [{
                    vendorInfo: result.rateApi.vendor.vendorInfo,
                    vendorCode: result.rateApi.vendor.vendorCode,
                    locateLink: "vendors#/vendor/" + result.rateApi.vendor.vendorId
                }, {
                    commodityInfo: $translate.instant(result.rateApi.commodity.commodityInfo),
                    commodityCode: result.rateApi.commodity.commodityCode,
                    locateLink: "vendors#/vendor/" + result.rateApi.vendor.vendorId + "/commodity/" + result.rateApi.commodity.commodityId
                }];

                headerData.parentId = $state.params.vendorId;
                headerData.rateId = $state.params.rateId;

                headerData.baseUrl = "/vendors#/vendor/" + $state.params.vendorId + "/commodity/" + $state.params.commodityId + "/rate/";

                deferred.resolve(headerData);
            });

            return deferred.promise;
        }

        function getCommodityViewCommodityHeaderData() {
            var deferred = $q.defer();

            var promises = {
                commodityApi: apiResource.commodity().commodity().get({ commodityId: $state.params.commodityId }).$promise
            };

            $q.all(promises).then(function (result) {
                var headerData = {};

                headerData.info = $translate.instant(result.commodityApi.commodityInfo);
                headerData.code = result.commodityApi.commodityCode;
                headerData.iconClass = commodityIconPipe.transform(result.commodityApi);

                headerData.breadcrumbs = [];

                deferred.resolve(headerData);
            });

            return deferred.promise;
        }

        function getCommodityViewVendorHeaderData() {
            var deferred = $q.defer();

            var promises = {
                commodityApi: apiResource.commodity().commodity().get({ commodityId: $state.params.commodityId }).$promise,
                vendorApi: apiResource.vendor().vendor().get({ vendorId: $state.params.vendorId }).$promise
            };

            $q.all(promises).then(function (result) {
                var headerData = {};

                headerData.info = result.vendorApi.vendorInfo;
                headerData.code = result.vendorApi.vendorCode;

                headerData.breadcrumbs = [{
                    commodityInfo: $translate.instant(result.commodityApi.commodityInfo),
                    commodityCode: result.commodityApi.commodityCode,
                    locateLink: "vendors#/commodity/" + $state.params.commodityId
                }];

                headerData.baseUrl = "/vendors#/commodity/" + $state.params.commodityId + "/vendor/";

                deferred.resolve(headerData);
            });

            return deferred.promise;
        }

        function getCommodityViewRateHeaderData() {
            var deferred = $q.defer();

            var promises = {
                rateApi: apiResource.rate().rate({ cancelable: false }).get({ rateId: $state.params.rateId }).$promise
            };

            $q.all(promises).then(function (result) {
                var headerData = {};

                headerData.info = result.rateApi.name;
                headerData.code = null;

                headerData.breadcrumbs = [{
                    commodityInfo: $translate.instant(result.rateApi.commodity.commodityInfo),
                    commodityCode: result.rateApi.commodity.commodityCode,
                    locateLink: "vendors#/commodity/" + result.rateApi.commodity.commodityId
                },
                {
                    vendorInfo: result.rateApi.vendor.vendorInfo,
                    vendorCode: result.rateApi.vendor.vendorCode,
                    locateLink: "vendors#/commodity/" + result.rateApi.commodity.commodityId + "/vendor/" + result.rateApi.vendor.vendorId
                }];

                headerData.baseUrl = "/vendors#/commodity/" + $state.params.commodityId + "/vendor/" + $state.params.vendorId + "/rate/";

                deferred.resolve(headerData);
            });

            return deferred.promise;
        }

        function getPlaceCategoryHeaderData() {
            var deferred = $q.defer();
            var headerData = {};

            headerData.info = $translate.instant("Building Groups");
            headerData.code = null;
            headerData.iconClass = "icon-group-buildings";
            headerData.breadcrumbs = [];

            if ($state.params.categoryId) {
                var promises = {
                    groupApi: apiResource.group().placeGroupCategory().get({ placeGroupCategoryId: $state.params.categoryId }).$promise
                };

                $q.all(promises).then(function (result) {

                    if (result.groupApi.autoGroup) {
                        headerData.editable = false;
                        result.groupApi.placeGroupCategoryInfo = $translate.instant(result.groupApi.placeGroupCategoryInfo);
                    } else {
                        headerData.editable = true;
                    }

                    headerData.info = result.groupApi.placeGroupCategoryInfo;
                    headerData.code = result.groupApi.placeGroupCategoryCode;
                    headerData.iconClass = null;

                    headerData.breadcrumbs = [{
                        placeCategoryCode: $translate.instant("Building Groups"),
                        placeCategoryInfo: $translate.instant("Building Groups"),
                        locateLink: "groups/placecategory"
                    }];


                    deferred.resolve(headerData);
                });
            }
            else {
                headerData.breadcrumbs = [];
                deferred.resolve(headerData);
            }

            return deferred.promise;
        }

        function getMeterCategoryHeaderData() {
            var deferred = $q.defer();
            var headerData = {};

            headerData.info = $translate.instant("Meter Groups");
            headerData.code = null;
            headerData.iconClass = "icon-group-meters";
            headerData.breadcrumbs = [];

            if ($state.params.categoryId) {
                var promises = {
                    groupApi: apiResource.group().meterGroupCategory().get({ meterGroupCategoryId: $state.params.categoryId }).$promise
                };

                $q.all(promises).then(function (result) {

                    if (result.groupApi.autoGroup) {
                        headerData.editable = false;
                        result.groupApi.meterGroupCategoryInfo = $translate.instant(result.groupApi.meterGroupCategoryInfo);
                    } else {
                        headerData.editable = true;
                    }

                    headerData.info = result.groupApi.meterGroupCategoryInfo;
                    headerData.code = result.groupApi.meterGroupCategoryCode;
                    headerData.iconClass = null;

                    headerData.breadcrumbs = [{
                        placeCategoryCode: $translate.instant("Meter Groups"),
                        placeCategoryInfo: $translate.instant("Meter Groups"),
                        locateLink: "groups/metercategory"
                    }];


                    deferred.resolve(headerData);
                });
            }
            else {
                headerData.breadcrumbs = [];
                deferred.resolve(headerData);
            }

            return deferred.promise;
        }

        function getPlaceGroupHeaderData() {
            var deferred = $q.defer();
            var headerData = {};

            var promises = {
                groupApi: apiResource.group().placeGroup().get({ placeGroupId: $state.params.groupId }).$promise
            };

            $q.all(promises).then(function (result) {
                headerData.info = $translate.instant(result.groupApi.placeGroupInfo);
                headerData.code = $translate.instant(result.groupApi.placeGroupInfo);

                if (result.groupApi.autoGroup) {
                    headerData.iconClass = 'icon-group-default';
                } else if (result.groupApi.userDefinedAutoGroup) {
                    headerData.iconClass = 'icon-group-custom-filter';
                } else {
                    headerData.iconClass = 'icon-group-manual';
                }

                if (result.groupApi.autoGroup) {
                    headerData.editable = false;
                }

                headerData.breadcrumbs = [{
                    placeCategoryCode: $translate.instant("Building Groups"),
                    placeCategoryInfo: $translate.instant("Building Groups"),
                    locateLink: "groups/placecategory"
                },
                {
                    placeCategoryCode: result.groupApi.placeGroupCategory.placeGroupCategoryCode,
                    placeCategoryInfo: result.groupApi.placeGroupCategory.placeGroupCategoryInfo,
                    locateLink: "groups/placecategory/" + result.groupApi.placeGroupCategory.placeGroupCategoryId
                }];

                deferred.resolve(headerData);
            });

            return deferred.promise;
        }

        function getMeterGroupHeaderData() {
            var deferred = $q.defer();
            var headerData = {};

            var promises = {
                groupApi: apiResource.group().meterGroup().get({ meterGroupId: $state.params.groupId }).$promise
            };

            $q.all(promises).then(function (result) {
                headerData.info = $translate.instant(result.groupApi.meterGroupInfo);
                headerData.code = null;

                if (result.groupApi.autoGroup) {
                    headerData.iconClass = 'icon-group-default';
                } else if (result.groupApi.userDefinedAutoGroup) {
                    headerData.iconClass = 'icon-group-custom-filter';
                } else {
                    headerData.iconClass = 'icon-group-manual';
                }

                if (result.groupApi.autoGroup) {
                    headerData.editable = false;
                }

                headerData.hideDemandTab = result.groupApi.memberCommodityCode !== "ELECTRIC";
                headerData.breadcrumbs = [{
                    placeCategoryCode: $translate.instant("Meter Groups"),
                    placeCategoryInfo: $translate.instant("Meter Groups"),
                    locateLink: "groups/metercategory"
                },
                {
                    placeCategoryCode: result.groupApi.meterGroupCategory.meterGroupCategoryCode,
                    placeCategoryInfo: result.groupApi.meterGroupCategory.meterGroupCategoryInfo,
                    locateLink: "groups/metercategory/" + result.groupApi.meterGroupCategory.meterGroupCategoryId
                }];

                deferred.resolve(headerData);
            });

            return deferred.promise;
        }
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .provider('l10n', L10nProvider);

    L10nProvider.$inject = [];

    function L10nProvider() {

        this.$get = function () {
            return new L10N();
        };

        function L10N() {
            this.parseFormats = function () {
                return ["yyyy-MM-ddTHH:mm:ss", "MM.dd.yyyy", "MM/dd/yyyy", "MM-dd-yyyy"];
            };
        }
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('mapResponseContentHelper', mapResponseContentHelper);

    mapResponseContentHelper.$inject = ['$resource'];

    function mapResponseContentHelper($resource) {

        // services
        var service = {
            mapExcelResponse: mapExcelResponse,
            mapTextResponse: mapTextResponse,
        };

        return service;

        function mapExcelResponse(result, headersGet) {
            //If the request is canceled the result will be null. Don't try to remap the response to an excel file because it won't work
            if (result && result.byteLength != 0) {
                var filename = parseFileName(headersGet);
                var format = new Blob([result], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                saveAs(format, filename);
            }
        }

        function mapTextResponse(result, headersGet) {
            //If the request is canceled the result will be null. Don't try to remap the response to an excel file because it won't work
            if (result && result.byteLength != 0) {
                var filename = parseFileName(headersGet);
                var format = new Blob([result], {
                    type: 'text/plain'
                });

                saveAs(format, filename);
            }
        }

        function parseFileName(headersGet) {
            var headers = headersGet();
            var cdHeader = headers['content-disposition'];
            var filenameRe = /[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var filename = filenameRe.exec(cdHeader);
            return filename[0].replace(' filename=', '');
        }
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('powerviewHelper', PowerviewHelper);

    // TODO: remove chartContext dependency after ECAP-3969 is done
    PowerviewHelper.$inject = ['apiResource', 'chartCatalog', 'glazeService', '$translate', 'chartContext', '$q', '$state', '$window', 'gridHelper'];

    function PowerviewHelper(apiResource, chartCatalog, glazeService, $translate, chartContext, $q, $state, $window, gridHelper) {

        var NO_COMMODITIES_MESSAGE = $translate.instant('NoDataToDisplay_SC');
        var NO_RESULTS_MESSAGE = $translate.instant('NoDataToDisplay_SC');
        var API_ERROR_MESSAGE = "SorryAnErrorOccurred_TC";

        var service = {};

        service.NO_RESULTS_MESSAGE = NO_RESULTS_MESSAGE;
        service.API_ERROR_MESSAGE = API_ERROR_MESSAGE;

        ////////////////////////////////////////////////////////////////////////
        // NEW METHODS
        service.getPowerviewProperties = getPowerviewProperties;
        service.getCommoditiesFromResults = getCommoditiesFromResults;
        service.filterDataByCommodity = filterDataByCommodity;
        service.checkWidgetsForDetailsView = checkWidgetsForDetailsView;
        ////////////////////////////////////////////////////////////////////////

        service.getWidgetDefinition = getWidgetDefinition;

        return service;

        // CONVERTED METHODS above
        ////////////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////////////
        // OLD METHODS below


        /**
         * Returns powerview properties depending on the api response
         * @param {Object|undefined} results Api resource response. If the Api returned
         * a rejection do not pass a result.
         * @param {boolean} displayCommodities If the powerview display commodities return them if available,
         * otherwise return the no commodities message
         * @returns {powerviewProperties}
         */
        function getPowerviewProperties(results, displayCommodities) {

            /**
             * @name powerviewProperties
             * @prop {array} [data] Data response from the api
             * @prop {string} [message] Message to display over the powerview
             * @prop {string} [status] The powerview status (hasData|noData|pending|error)
             */
            var powerviewProperties = {
                data: null,
                status: 'hasData',
                message: ''
            };

            if (results) {
                powerviewProperties.message = displayCommodities ? NO_COMMODITIES_MESSAGE : NO_RESULTS_MESSAGE;
                powerviewProperties.status = 'noData';

                if (angular.isArray(results)) {
                    if (displayCommodities) {
                        angular.forEach(results, function(result, index){
                            if (result && result.commodities && result.commodities.length > 0) {
                                powerviewProperties.data = powerviewProperties.data || [];
                                powerviewProperties.data[index] = result;
                                powerviewProperties.status = 'hasData';
                                powerviewProperties.message = '';
                            }
                        })
                    } else {
                        angular.forEach(results, function(result, index){
                            if (result && result.results && result.results.length > 0) {
                                powerviewProperties.data = powerviewProperties.data || [];
                                powerviewProperties.data[index] = result;
                                powerviewProperties.status = 'hasData';
                                powerviewProperties.message = '';
                            }
                        })
                    }
                } else {
                    var hasCommodities = displayCommodities && results.commodities && results.commodities.length > 0;
                    var hasResults = results.results && results.results.length > 0

                    if (hasCommodities || hasResults) {
                        powerviewProperties.data = results;
                        powerviewProperties.status = 'hasData';
                        powerviewProperties.message = '';
                    }
                }
            } else {
                powerviewProperties.message = API_ERROR_MESSAGE;
                powerviewProperties.status = 'error';
            }

            return powerviewProperties;
        }

        /**
         * @name widgetDefinition
         * @prop {String} title Header title
         * @prop {String} [footer] Footer text
         * @prop {string} [status=hasData] Widget's current status (hasData|noData|error|pending)
         * @prop {string} [message] Overlay message
         * @prop {Object[]} [actions] Collection of action definitions
         * @prop {String} [actions.title] Tootlip title for the action
         * @prop {String} [actions.tooltipPlacement=top] Tooltip placement (top|bottom|right|left)
         * @prop {String} actions.icon Classname of the action button icon
         * @prop {Function} actions.onClick Click handler
         * @prop {*} actions.params Parameters to pass to actions.onClick
         * @prop {Object} content The widget's content configuration object
         */

        /**
         * Get the widget definition
         * @param {object} params Parameters object
         * @param {string} params.id The entity id
         * @param {string} params.type The type of widget (chart|dataGrid|dataDisplay)
         * @param {string} [params.templateUrl] url for an optional template
         * @param {string} [params.title] The widget title
         * @param {string} [params.baseUrl] The base url for the chart source
         * @param {Object[]} [params.queryParams] Parameter to append to the baseUrl
         * @param {string} params.queryParams[].key The key of the query parameter
         * @param {string} params.queryParams[].value The value of the query parameter
         * @return {object} widgetAttrs
         */
        function getWidgetDefinition(params) {

            var showActions = (typeof params.showActions !== 'undefined') ? params.showActions : true;

            var widgetAttrs = {
                ////////////////////////////////////////////////////////////////
                // TODO: remove after ECAP-3957 is done
                source: getWidgetSourceUrl(params),
                converted: params.converted || false,
                ////////////////////////////////////////////////////////////////
                title: params.title || '',
                id: params.id,
                class: params.class,
                type: params.type,
                templateUrl: params.templateUrl || null,
                status: 'hasData',
                message: '',
                actions: (showActions) ? getWidgetActions(params) : [],
                showActions: showActions,
                content: params.content,
                updateStatus: updateWidgetStatus,
                autoHeight: params.autoHeight
            }

            // Get type and title from the chartCatalog if the widget type is a chart
            ////////////////////////////////////////////////////////////////////
            // TODO: remove after ECAP-4016 is done
            if (params.type == 'chart') {
                var chart = chartCatalog.find(params.baseUrl);
                widgetAttrs.title = chart.title;
                widgetAttrs.type = chart.type;

                getChartConfiguration(params.baseUrl, widgetAttrs.source).then(function (res) {
                    widgetAttrs.content = res;
                });

                return widgetAttrs;
            } else {
            ////////////////////////////////////////////////////////////////////
                return widgetAttrs;
            }
        }

        /**
         * Gets an array of actions to bind to the widget
         * @param {Object} type The widget type(chart|dataGrid)
         * @returns {Object[]} Array of actions
         * @private
         */
        function getWidgetActions(params) {
            var actions = [];

            // TODO: Change to look for params.noDetails to be more flexible
            if (params.type == 'chart') {
                actions.push({
                    title: $translate.instant('View details'),
                    onClick: openWidgetDetails,
                    icon: 'icon-expand',
                    params: getWidgetSourceUrl(params)
                });
            } else if (params.type == 'amchart' || params.type == 'arrowchart' || params.type == 'savingsarrowchart') {
                // TODO: Bring me back when the print styles are fixed
                // actions.push({
                //     title: 'Print',
                //     onClick: printWidgetDetails,
                //     icon: 'icon-print',
                //     classes: 'ec-powerview-action-hide',
                //     params: params.id
                // });

                actions.push({
                    title: 'View details',
                    icon: 'icon-expand',
                    params: params.id,
                    onClick: toggleWidgetDetails,
                    classes: 'ec-powerview-action-show'
                });

                actions.push({
                    title: 'Hide details',
                    icon: 'icon-compress',
                    onClick: toggleWidgetDetails,
                    classes: 'ec-powerview-action-hide'
                });
            }

            return actions;
        }

        /**
         * Get the source url for a widget
         * @param {object} params parameters object for getWidgetDefinition
         * @returns {string} The source url
         *
         * /////////////////////////////////////////////////////////////////////
         * @todo delete after ECAP-3958 is done
         * /////////////////////////////////////////////////////////////////////
         *
         * @private
         */
        function getWidgetSourceUrl(params) {
            var url = params.baseUrl + params.id;

            if (params.queryParams && params.queryParams.length > 0) {
                angular.forEach(params.queryParams, function (param, i) {
                    url = url + (i == 0 ? '?' : '&') + param.key + '=' + param.value;
                });
            }

            return url;
        }

        /**
         * Get the amchart config object
         * @param {string} source chart catalog source url
         * @returns {object} amchart config object
         * @todo delete after ECAP-3969 is done
         */
        function getChartConfiguration(baseUrl, source) {
            var catalog = chartContext.catalog(baseUrl);

            if (catalog) {
                return chartContext.provider(catalog, source).then(function (res) {
                    var chartConfig = {};

                    if (res.result) {
                        chartConfig = res.result;
                    } else {
                        chartConfig = res;
                    }

                    return chartConfig;
                }, function (err) {
                    console.error(err);
                    return {};
                })
            }
        }

        /**
         * Exception callback in something fails with the widget content
         * @param {string} status The new status (hasData|noData|error|pending)
         */
        function updateWidgetStatus(status, message) {
            this.status = status;
            this.message = message || this.message;
        }

        /**
         * Opens powerview details in a glaze
         * @param {string} sourceUrl The widgets sourceUrl to lookup in the chartCatalog
         * @todo delete after ECAP-4116 is done
         */
        function openWidgetDetails(sourceUrl) {
            glazeService.openGlaze(0, 'magnify-chart', null, sourceUrl);
        }

        /**
         * Toggles a widget to show their chart details in the powerview, all remaining widgets will be hidden
         * and the widget to view details will go full screen with the data grid below
         * @param {string} widgetId The widgets id, should correspond with the chart being shown.  Ex. Total Cost Summary id would be totalCostSummary
         */
        function toggleWidgetDetails(widgetId) {
            $state.queryParams.detailsId = widgetId ? widgetId : undefined;
            $state.go($state.current.name, $state.params, { reload: false, notify: false, location: 'replace' }, $state.queryParams);
        }

         /**
         * Takes in the array of data responses and returns the first set of commodities found, if none are found then we return null
         * @param {array} data - Array of the result data responses from the apis
         * @returns {array} - Commodities representing meters that exist under the place, if there are no meters we return null
         */
        function getCommoditiesFromResults(data) {
            // Loop through the chart data array and set the commodities array to the first
            // index that has data
            if (angular.isDefined(data) && data !== null) {
                for (var index = 0; index < data.length; i++) {
                    if (angular.isDefined(data[index]) && data[index] !== null && angular.isDefined(data[index].commodities)) {
                        return data[index].commodities;
                    }
                }
            }

            return null;
        }

        /**
         * Takes in the array of data responses and returns the first set of commodities found, if none are found then we return null
         * @param {Object} data - Data from Api response
         * @param {integer} commodityId - CommodityId to filter the data on
         * @returns {Object} - Data from Api response filtered by commodity if option exists, otherwise the same object is returned
         */
        function filterDataByCommodity(data, commodityId) {
            if (data && data.commodities) {
                // Since we have a commodityId, we want to filter the chart down to that commodity
                var commodity = data.commodities.filter(function (com) {
                            return com.commodityId == commodityId;
                })[0];

                if (commodity) {
                    commodity.updated = data.updated;
                }

                return commodity;
            }

            return data;
        }

        /**
         * Check the array of widgets to see if any have an id the same as the detailsId and if not, reset the view
         * to not show widget details
         * @param {array} widgets - Array of widgets
         */
        function checkWidgetsForDetailsView(widgets) {
            if (!_.find(widgets, function (widget) { return widget.id === $state.queryParams.detailsId; })) {
                toggleWidgetDetails();
            }
        }

        /**
         * Clone the html content of the widget we want to print and append it to
         * the body so we can hide everything else we don't want to print.
         * @param {string} widgetId The id of the widget we want to print
         * @private
         */
        function printWidgetDetails(widgetId) {
            var body = angular.element(document).find('body');
            var widgets = body.find('ec-widget');
            var widgetHtml;

            body.addClass('ec-powerview-print');

            angular.forEach(widgets, function(widget) {
                if (angular.element(widget).attr('id') == widgetId) {
                    widgetHtml = angular.element(widget).clone();
                }
            });

            body.append(widgetHtml);

            $window.print();

            // Remove the cloned widget and print class after printing.
            widgetHtml.remove();
            body.removeClass('ec-powerview-print');
        }
    }
})();
﻿var PromiseAwaiter = function () {
    "use strict";

    this.promises = [];

    // Adds a promise to the objects array
    PromiseAwaiter.prototype.add = function (promise) {
        this.promises.push(promise.$promise);
    };

    // When called returns the status of the promise array so the listener can react if success or failure
    PromiseAwaiter.prototype.notifyWhenDone = function () {
        return Promise.all(this.promises);
    };
};
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('regexService', regexService);

    regexService.$inject = [];

    function regexService() {

    	// regexes which restricts the input on every key-press starts with 'restrict' followed by the specific data-type
    	// regexes which validates the input as a whole starts with 'validate' followed by the specific data-type
    	// all other regexes are named corresponding to their respective purposes - eg: 'whiteSpaces' contains regex which matches the white spaces in provided string
        var service = {
        	restrictHyperLink: restrictHyperLink,
        	restrictInteger: restrictInteger,
        	restrictPositiveInteger: restrictPositiveInteger,
        	restrictDouble: restrictDouble,
        	restrictPositiveDouble: restrictPositiveDouble,
        	restrictZipPostalCode: restrictZipPostalCode,

        	whiteSpaces: whiteSpaces,
        	onlyAlphabets: onlyAlphabets,

        	validateZipPostalCode: validateZipPostalCode,
        	validateHyperLink: validateHyperLink,
        	validateDouble: validateDouble
        };

        return service;

        function restrictHyperLink() {
        	return '([A-Za-z])+:?\/?\/?[^\\s]*';
        }

        function restrictInteger() {
            return '(-)([0-9]+)?|([0-9]+)';
        }

        function restrictPositiveInteger() {
            return '[0-9]+';
        }

        function restrictPositiveDouble() {
            return '[0-9.]+';
        }

        function restrictDouble() {
            return '(-)([0-9.]+)?|([0-9.]+)';
        }

        function restrictZipPostalCode(country) {

            if (country === 'US') {
        		return '[0-9-]+';
            } else if (country === 'CA') {
        		return '[A-Za-z0-9 ]+';
            } else {
        	    return '.*';
        	}
        }

        function whiteSpaces() {
        	return '\\s';
        }

        function onlyAlphabets() {
        	return '[A-Za-z]+';
        }

        function validateZipPostalCode(country) {

        	if(country === 'US'){
        		return '[0-9]{5}((-| ?)[0-9]{4})?';
        	} else if (country === 'CA') {
        		return '[A-Z]\\d[A-Z] *\\d[A-Z]\\d';
        	}

        }

        function validateHyperLink() {
        	return '([A-Za-z])+(:\/\/)+[^\\s]*';
        }

        function validateDouble() {
        	return '-?\\d+.?\\d*';
        }
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .service('runtimeService', RuntimeService);

    RuntimeService.$inject = ['apiResource', 'userService', '$window', '$injector', '$location', '$http'];

    function RuntimeService(apiResource, userService1, $window, $injector, $location, $http) {
        var runtimeService = this;
        var windowJwtResourcePromise = null;
        var userService2 = getUserService();

        (function constructor() {

            // Meter Normalized Monthly Chart Option, defaulted to Monthly
            runtimeService.normalizedMonthlyMeterChartOption = "monthly";

            // Organization/Building Normalized Monthly Chart Option, defaulted to Monthly
            // We don't differentiate between Organizations and Buildings for charts, so we use a generic term of Place
            runtimeService.normalizedMonthlyPlaceChartOption = "monthly";
            runtimeService.getConfigData = getConfigData;
            runtimeService.refreshCachedUser = refreshCachedUser;
        })();

        /**
         * Apply the user currency preferences to Kendo to update the various controls
         * Use a fallback if the user data does not have settings
         */
        function updateKendoWithUserPrefs(user){
            // Override the default Kendo currency formatters
            var currencySymbol = user.currencyUnit ? user.currencyUnit.unitInfo : "$";
            kendo.cultures.current.numberFormat.currency.pattern[0] = '-' + currencySymbol + 'n';
            kendo.cultures.current.numberFormat.currency.symbol = currencySymbol;
        }

        /**Load the user information from the Me API.
         * If we are provided with a JWT, use that to get the user (from the ng1 api resource) so it has the correct permissions even if the viewer is logged in. 
         *      This happens on embedded dashboards.
         *      Because the ng5 user service doesn't provide a mechanism to override the token, use the apiResource for this and cached the promise result here like we did before
         *      The cached result lives for the life of the application
         *      The promise that is returned is the angular $promise object which is a little different than a real promise, but both have .then() which is all we ever use
         * 
         * Otherwise, use the standard cookie authentication with the ng5 userService as the backing store / caching provider
         *      If it gets called again, we depend on the underlying user service to provide the cached value or a fresh value if some process cleared that cache
         *      In this case it returns a standard browser Promise object, which also has a .then() subscription callback
         * 
         * In both cases we Store the result in the current ng1 userService for later use in pages that treat it as synchronously available.
         *      They can pretend it is synchronous because this call is made by the app initialization / state change so it always exists before they check it
         * 
         * @returns a promise-like object that has .catch((ME)=>) and .then((ME)=>) callback functions. The ME object definition
         * matches the response of the ME API: https://developer.energycap.com/api-docs/me/get_apiv3me/
         */
        
        function getConfigData() {
            var resultPromise = null;

            if (angular.isDefined($window.jwt)) {
                windowJwtResourcePromise = windowJwtResourcePromise || apiResource.me().withJwtAuthentication({}).$promise;
                resultPromise = windowJwtResourcePromise;
            } if (angular.isDefined($window.ECP.publicDashboardKey)) {
                $http.defaults.headers.common['ECI-PUBLIC-DASHBOARD-KEY'] = $window.ECP.publicDashboardKey;
                windowJwtResourcePromise = windowJwtResourcePromise || apiResource.me().withPublicDashboardAuthentication({}).$promise;
                resultPromise = windowJwtResourcePromise;
            } else {
                if ($http.defaults.headers.common['ECI-PUBLIC-DASHBOARD-KEY']) {
                    $http.defaults.headers.common['ECI-PUBLIC-DASHBOARD-KEY'] = undefined;
                }
                resultPromise = userService2.getUserNg1();
            }

            return resultPromise.then(function(data){
                userService1.setUser(data);
                updateKendoWithUserPrefs(data);

                return data;
            }).catch(function(error){
                console.error('failed to load user from Me api: ', error);
            });
        }

        /**Clear out the NG5 and NG1 user caches and reload the user with the latest settings
         * This is required when we modify the settings so that the ng1 userService.getUser call returns the right value
         * and works even if runtimeService.getConfigData isn't called first
         * 
         * @returns a user object that matches the response of the ME API: https://developer.energycap.com/api-docs/me/get_apiv3me/
        */
        function refreshCachedUser(){
            userService2.clearCachedUser();
            return getConfigData();
        }

        /**Returns either the angular 5 userService if available, or a shim that is backed by the angular 1 ApiResource ME API 
         * When running on pages outside the app (like the login screen, upgrade screen, etc) where angular 5 scripts are not loaded
         * we fall back to the angular 1 non-caching implementation so that the runtimeService can be instantiated without failing
         * because a dependency is unavailable
        */
        function getUserService(){
            var service = null;

            try {
                service = $injector.get('userService2');
            } catch(e){
                service = {
                    getUserNg1: function(){
                        return apiResource.me().get({}).$promise;
                    }
                }
            }

            return service;
        }
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('temperatureService', temperatureService);

    temperatureService.$inject = [];

    function temperatureService() {

        // temperature services
        var service = {
            balancePointOptions: balancePointOptions
        };

        return service;

        function balancePointOptions(option) {
            var options = {};

            if (option.toLowerCase() === 'degf') {
                options = {
                    unit: option.toLowerCase(),
                    format: "°F",
                    min: 0,
                    max: 100
                };
            }
            else if (option.toLowerCase() === 'degc') {
                options = {
                    unit: option.toLowerCase(),
                    format: "°C",
                    min: 0,
                    max: 100
                };
            }

            return options;
        }
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('ecTranslate')
        .factory('translationHelper', TranslationHelper);

    TranslationHelper.$inject = ['$translate', '$cookies', '$window'];

    /**
     * Provides utility functions related to translation
     * @constructor
     */
    function TranslationHelper($translate, $cookies, $window) {

        var helpers = {
            formatEndDate: formatEndDate,
            placeholder: placeholder,
            translateAndInterpolate: translateAndInterpolate,
            changeLanguage: changeLanguage
        };


        /**
         * Get endDate formatted for output MM/DD/YYYY
         * If endDate is 1/1/3000, return "present" translated into current language.
         **/
        function formatEndDate(endDate) {
            var formattedEndDate = moment(endDate).format('MM/DD/YYYY');
            return (formattedEndDate === '01/01/3000') ? $translate.instant('present') : formattedEndDate;
        }

        function placeholder() {
            return {
                Month: $translate.instant("Month"),
                MonthYYYY: $translate.instant("Month YYYY"),
                Day: $translate.instant("Day"),
                Choose: $translate.instant("Choose"),
                ChooseOrAdd: $translate.instant("Choose or add")
            };
        }

        /**
         * Translate locokey and interpolate placeholders
         *
         * var compiled = _.template('They used {a} {b} per {c}.');
         * compiled({ 'a': 11, 'b': 'kWh', 'c': day });
         * // ➜ 'They used 11 kWh per day'
         *
         * See http://devdocs.io/lodash~4/index#template
         **/
        function translateAndInterpolate(locoKey, replacementValues) {
            // use {} as delimeter
            _.templateSettings.interpolate = /{([\s\S]+?)}/g;
            var translated = $translate.instant(locoKey);
            var template = _.template(translated);
            return template(replacementValues);
        }
        /**
         * Update the tracking state to reflect the user's new preferred language
         * @param {string} newLanguage the key name (like en_US) for the new language
         * @param {boolean} reload (optional) reload the page after the settings change to ensure anything captured by translate.Instant() is updated. Defaults to true
         */
        function changeLanguage(newLanguage, reload) {
            var currentLanguage = $translate.use();

            if (newLanguage) {
                //store the value in a cookie so the server can know which language file to send down by default
                //keep it there for a while so we know what to default to when they come back later
                $cookies.put('language', newLanguage, { expires: moment().add(1, 'year').toDate(), path: "/" });
            }

            if (newLanguage && currentLanguage !== newLanguage) {
                $translate.use(newLanguage);

                //update the date format
                if (newLanguage === "en_US") {
                    moment.locale("en");
                } else {
                    moment.locale(newLanguage);
                }

                //Reload the page to reset anything captured by translate.Instant()
                if (_.isUndefined(reload) || reload === true) {
                    $window.location.reload();
                }
            }
        }

        return helpers;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('ecTranslate')
        .factory('translationLoader', TranslationLoader);

    TranslationLoader.$inject = ['$q', '$http'];

    function TranslationLoader($q, $http) {

        return function (options) {

            var deferred = $q.defer();
            // Load the localizations from the json file corresponding to the locale key
            $http.get('assets/locales/' + options.key + '.json').then(function (response) {
                // We found the related json file, load up the translations
                deferred.resolve(response.data);
            }, function (response) {
                // We failed to find the related json file, we'll fall back to the english and can notify the user in some way
                deferred.resolve({});
            });

            return deferred.promise;
        };
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('urlService', UrlService);

    UrlService.$inject = ['$location', '$filter', '$window'];

    function UrlService($location, $filter, $window) {

        var service = {
            runWatcherFuncs: runWatcherFuncs,
            addWatcherFunc: addWatcherFunc,
            removeWatcherFunc: removeWatcherFunc,
            setPreviousUrl: setPreviousUrl,
            getPreviousUrl: getPreviousUrl,
            host: host,
            module: getModule,
            id: getId,
            ids: getIds,
            type: getType,
            uiView: getUiView,
            search: search,
            path: path,
            replacePath: replacePath,
            replaceQuery: replaceQuery,
            baseUrl: baseUrl,
            all: function () {
                return $location;
            },
            chartDetails: function (source) {
                return path() + "?glazeId=0&glazeType=magnify-chart&glazeOptions=" + encodeURIComponent(source);
            }
        };

        var watcherFunctions = [];
        var previousUrl;

        function runWatcherFuncs(newValue, oldValue) {
            // loop through and call all watch functions in array
            angular.forEach(watcherFunctions, function (func) {
                func(newValue, oldValue);
            });
        }

        function addWatcherFunc(func) {
            watcherFunctions.push(func);
        }

        function removeWatcherFunc(func) {
            _.remove(watcherFunctions, function (watcherFunc) {
                return watcherFunc === func;
            });
        }

        function setPreviousUrl(url) {
            previousUrl = url;
        }

        function getPreviousUrl() {
            // If we open the create dialog immediatly after launching the app there is no previous url to go to
            // The previous url gets set on page change, so if there is none set it to the current url
            if (!previousUrl) {
                setPreviousUrl({ path: path(), search: search() });
            }

            if (previousUrl.search !== null) {
                if (previousUrl.search.hasOwnProperty('glazeId')) {
                    delete previousUrl.search.glazeId;
                }
                if (previousUrl.search.hasOwnProperty('glazeType')) {
                    delete previousUrl.search.glazeType;
                }
            }

            return previousUrl;
        }

        function replacePath(newPath) {
            $window.location.pathname = newPath;
        }

        function replaceQuery(newQuery) {
            $window.location.search = newQuery;
        }

        function search() {
            var searchParams = {};

            var findParams = $window.location.hash.split("?");
            if (findParams.length > 1) {
                var urlParams = findParams[1].split("&");
                angular.forEach(urlParams, function (param) {
                    var paramParts = param.split("=");
                    searchParams[paramParts[0]] = paramParts[1];
                });
            } else {
                return null;
            }

            return searchParams;
        }

        function host() {
            return $window.location.host;
        }

        function path() {
            var path = $location.path();
   
            if (path.startsWith('/app/')) {
                path = path.substr(5);
            } else if (path.startsWith('app/')) {
                path = path.substr(4);
            } else if (path.startsWith('/')) {
                path = path.substr(1);
            }

            return $filter('lowercase')(path);
        }

        function getModule() {
            return path().split('/')[0];
        }

        function isNumeric(string) { return !isNaN(string); }

        function getId() {
            var pathParts = (service.path()).split("/");

            if (pathParts.length === 1) {
                return null;
            }
            if (isNumeric(pathParts[2])) {
                return pathParts[2];
            }
            return null;
        }

        function getIds() {
            // Split the location path on the forward slash to seperate each section into an array
            var pathParts = service.path().split("/");

            // If there is only one item in the parts array then we don't have any items selected in a tree
            if (pathParts.length === 1) {
                return null;
            }

            // Array of id/type objects
            var pathIds = [];

            // Loop through all the path parts in the array and create id/type objects and push to our array
            for (var i = 0; i < pathParts.length; i++) {

                // We're looking for id's, so we'll check for numerics
                if (pathParts[i] && isNumeric(pathParts[i])) {

                    // If the item in the path is numeric then it's an id, and the item before it is the entity it
                    // represents, so we'll go back one in the array to get that type
                    var pathObject = {
                        id: pathParts[i],
                        type: pathParts[i - 1]
                    };

                    pathIds.push(pathObject);
                }
            }

            return pathIds;
        }

        function getType() {
            return $filter('lowercase')(service.path().split("/")[1]);
        }

        function getUiView() {
            var id = getId();
            var pathParts = service.path().split("/");

            // Going to replace the commas in the url path to dots to match our states
            if (id) {
                // Loop through all the path parts in the array looking for the last id in the url
                for (var i = pathParts.length; i > -1; i--) {
                    // We're looking for the last id
                    if (pathParts[i]) {
                        if (isNumeric(pathParts[i])) {
                            // found it!
                            return pathParts.slice(i + 1).toString().replace(",", ".");
                        } else {
                            // Strip any query string params off
                            pathParts[i] = pathParts[i].split("?")[0];
                        }
                    }
                }
            }

            return pathParts.slice(3).toString().replace(",", ".");
        }

        function baseUrl() {
            return $location.protocol() + "://" + $location.host() + ":" + $location.port();
        }

        return service;
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .factory('userService', UserService);

    UserService.$inject = ['$state'];

    function UserService($state) {
        var service = {
            getUser: getUser,
            setUser: setUser,
            userHasPermission: userHasPermission,
            validateTabs: validateTabs,
            userHasFeatureFlag: userHasFeatureFlag,
            userIsProfessionalOrSaaS: userIsProfessionalOrSaaS,
            userIsOfflineMode: userIsOfflineMode
        };

        var user;

        function getUser() {
            return user;
        }

        function setUser(data) {
            user = data;
        }

        function userHasPermission(permissionType) {
            // If there is no permissionType return true
            if (!permissionType) {
                return true;
            }

            // If the user doesn't have any permission return false
            if (!user.permissions) {
                return false;
            }

            
            if (permissionType.constructor === Array) {
                var hasPermission = true;
                for (var i = 0; i < permissionType.length && hasPermission; i++) {
                    // Loop through array of permissions types
                    // Check each one and as soon as one is false we will break out of the loop
                    // and return
                    if (!userHasPermission(permissionType[i])) {
                        hasPermission = false;
                    }
                }
                return hasPermission;
            } else {

                // Lookup the permissionPath from the permissionType
                // the list of valid permissionTypes is in permissions.ts
                // this is put in window.ECP so it can be shared between ng1 and ng4
                // If one is not found return false 
                var permissionPath = window.ECP.permissions.constructor[permissionType];
                if (!permissionPath) {
                    return false;
                }
                
                // if we have a valid permission path we can use the shared function to validate
                return window.ECP.permissions.constructor.checkPermission(permissionPath, user)
            }
        }

        /**Returns true if the current user has access to a specific feature. We use these feature flags to disable
         * parts of the application for a specific database or deployment environment, especially when the feature is still experimental
         * @param flag - a value to search for in the collection of feature flags available. Search is case insensitive
         */
        function userHasFeatureFlag(flag) {
            var searchFlag = flag.toLowerCase();
            var hasFlag = user.featureFlags && user.featureFlags.find(function (f) { return f == searchFlag }) != undefined || false;
            return hasFlag;
        }

        function validateTabs(tabs) {
            var validatedTabs = [];

            angular.forEach(tabs, function (tab) {
                // We will use the permissions from the state instead of the nav array
                // This way we only have to defined the permissions once and this is what is actually attached to the state
                var state = $state.get(tab.stateIs);
                if (state && userHasPermission(state.permissionType)) {
                    validatedTabs.push(tab);
                }
            });

            return validatedTabs;
        }

        function userIsProfessionalOrSaaS() {
            if (user.sku) {
                return user.sku.toUpperCase() == "PROFESSIONAL" || user.sku.toUpperCase() == "SAAS"
            }

            return false;
        }

        function userIsOfflineMode() {
            return user.applicationMode === 'Offline' || userHasFeatureFlag('offlinetesting');
        }

        return service;
    }
})();
﻿(function () {
    'use strict';

    angular.module('app')
        .controller('embeddedGridsterDashboardController', EmbeddedGridsterDashboardController)
        .component('ng1EmbeddedGridsterDashboardController', {
            template: '<embedded-gridster-dashboard-controller dashboard-id="vm.dashboardId" class="d-block"></embedded-gridster-dashboard-controller>',
            controllerAs: 'vm',
            bindings: {
                dashboardId: '<'
            }
        })
        .component('embeddedGridsterDashboardController', {
            templateUrl: 'assets/templates/dashboard/embeddedGridsterDashboardController.html',
            controllerAs: 'gridsterDashboard',
            controller: EmbeddedGridsterDashboardController,
            bindings: {
                dashboardId: '<',
            }
        });

    EmbeddedGridsterDashboardController.$inject = ['$scope', '$state', 'widgetContext'];

    function EmbeddedGridsterDashboardController($scope, $state, widgetContext) {
        var vm = this;

        vm.$onInit = init;

        function init() {
            vm.gridsterWidgets = [];
            vm.expanded = false

            vm.gridster = {
                columns: 8,
                pushing: true,
                swapping: false,
                floating: true,
                margins: [18, 18],
                outerMargin: true,
                mobileModeEnabled: false,
                rowHeight: 140,
                minSizeY: 2,
                resizable: {
                    enabled: false
                },
                draggable: {
                    enabled: false
                }
            };



            //listen for updates to the widgets from an external widget refresh (like when global dashboard filter is changed or even initial load)
            //be sure to unbind the listener on destroy so that we don't leak them
            $state.subscribeToEvent('refreshDashboard', refreshGridster);
            $state.subscribeToEvent('widgetExpanded', expandWidget);

            $scope.$on('$destroy', function () {
                $state.unsubscribeFromEvent('refreshDashboard', refreshGridster);
                $state.unsubscribeFromEvent('widgetExpanded', expandWidget);
            });

            $state.params.dashboardId = vm.dashboardId;

            widgetContext.refreshWidgets();
        }

        function refreshGridster() {
            // We want everything sorted by row, col and widgetId desc so widgets with the same row/col get ordered correctly in the grid
            vm.gridsterWidgets = _.orderBy(widgetContext.widgets, ['row', 'col', 'specificWidgetId'], ['asc', 'asc', 'desc']);
        }

        function expandWidget(event) {
            vm.expandedWidget = event.detail;
            vm.expanded = event.detail ? true : false;
        }
    }
})();

﻿(function () {
    'use strict';

    angular.module('dashboardModule').controller('gridsterDashboardController', GridsterDashboardController);

    GridsterDashboardController.$inject = ['$scope', 'widgetContext', 'glazeService', '$state', 'scrollService'];

    function GridsterDashboardController($scope, widgetContext, glazeService, $state, scrollService) {
        var vm = this;
        vm.gridsterWidgets = [];
        vm.dashboardEmpty = false;
        vm.expandedWidget = undefined;
        vm.expanded = false

        vm.openGlaze = glazeService.openGlaze;

        var lastScrollPosition = 0;

        //need to bind and unbind these events evenly to avoid leaking them when switching dashboards
        $state.subscribeToEvent('lockDashboard', lockDashboard);
        $state.subscribeToEvent('unlockDashboard', unlockDashboard);
        $state.subscribeToEvent('refreshDashboard', refreshGridster);
        $state.subscribeToEvent('widgetExpanded', expandWidget);

        $scope.$on('$destroy', function(){
            $state.unsubscribeFromEvent('lockDashboard', lockDashboard);
            $state.unsubscribeFromEvent('unlockDashboard', unlockDashboard);
            $state.unsubscribeFromEvent('refreshDashboard', refreshGridster);
            $state.unsubscribeFromEvent('widgetExpanded', expandWidget);
        });

        var ignoredGridsterEventTags = ["svg","use","button","i"];
        vm.padding = 18;

        vm.gridster = {
            columns: 8,
            pushing: true,
            swapping: false,
            floating: true,
            margins: [vm.padding,  vm.padding],
            outerMargin: true,
            mobileModeEnabled: false,
            rowHeight: 140,
            minSizeY: 2,
            resizable: {
                enabled: false,
                stop: function (event, $element, widget) {
                    // These events get fired even when we click on the delete/edit widget buttons, and the only way we
                    // can tell that those buttons were clicked is by examining a list of possible tag names since the event
                    // might come from the svg, use, or button elements.
                    if (event.target && ignoredGridsterEventTags.indexOf(event.target.tagName.toLowerCase()) === -1) {
                        widgetContext.reordered(true);
                    }
                }
            },
            draggable: {
                enabled: false,
                stop: function (event, $element, widget) {
                    // These events get fired even when we click on the delete/edit widget buttons, and the only way we
                    // can tell that those buttons were clicked is by examining a list of possible tag names since the event
                    // might come from the svg, use, or button elements.
                    if (event.target && ignoredGridsterEventTags.indexOf(event.target.tagName.toLowerCase()) === -1) {
                        widgetContext.reordered();
                    }
                }
            }
        };

        function lockDashboard() {
            toggleDashboardLock(true);
        };

        function unlockDashboard(){
            toggleDashboardLock(false);
        };

        function scrollToHighlightedWidget(widgets) {
            const highlightedWidget = widgets.find(function(widget) {
                if(widget.isHighlighted) return widget;
            })

            if(highlightedWidget) {
                const selector = '#specificWidget_'+ highlightedWidget.specificWidgetId;
                if(selector != null) {
                    setTimeout(function() {
                        scrollService.scrollToItem('#dashboardWrapper', selector);
                    });
                }

            }
        }

        //fires on initial load and then again when an external widget refresh is triggerd (like adding a widget)
        function refreshGridster() {
            // We want everything sorted by row, col and widgetId desc so widgets with the same row/col get ordered correctly in the grid
            vm.gridsterWidgets = _.orderBy(widgetContext.widgets, ['row', 'col', 'specificWidgetId'], ['asc', 'asc', 'desc']);

            // If a widget is currently expanded, update the expanded widget with the updated widget data
            if (vm.expandedWidget) {
                vm.expandedWidget = widgetContext.widgets.find(function (widget) {
                    return widget.specificWidgetId === vm.expandedWidget.specificWidgetId;
                });
            }

            /**
             * Set dashboard empty after we've loaded the dashboards so we
             * don't flash the 'getting started' screen
             */
            vm.dashboardEmpty = vm.gridsterWidgets.length === 0;

            $state.publishEvent('dashboardEmpty', vm.dashboardEmpty);
            //this is dependent to dashboard view state service
            toggleDashboardLock(widgetContext.dashboardLocked);

            if(widgetContext.widgets.length > 0 ) {
                scrollToHighlightedWidget(widgetContext.widgets);
            }
        }

        /**
         * This function enables or disables edit, resize, delete, rearrange functionality across
         * the widgets according to the state passed in. If the state passed in differs from the current state
         * an event is broadcast for grister-draggable-changed so that any listeners can react.
         * @param {boolean} locked set to true if the dashboard is in read-only mode
         */
        function toggleDashboardLock(locked) {
            if(locked == vm.gridster.draggable.enabled){
                vm.gridster.draggable.enabled = !locked;
                vm.gridster.resizable.enabled = !locked;
                widgetContext.dashboardLocked = locked;
                $scope.$broadcast('gridster-draggable-changed', vm.gridster);
            }
        }

        function expandWidget(event) {
            vm.expandedWidget = event.detail;
            vm.expanded = event.detail ? true : false;

            const scrollContainer = angular.element("#PageViewScrollContainer").length ? '#PageViewScrollContainer' : '#dashboardWrapper';

            // If the action is to expand the widget, we save the scroll position
            if(vm.expanded) {
                lastScrollPosition = scrollService.getCurrentScrollPosition(scrollContainer);
            } else if (lastScrollPosition > 0) {
                // If the lastScroll position is greater than 0, it means the user performed a scroll before expanding the widget
                // Scrolling inside a timeout to give some time for the widgets to render
                setTimeout(function() {
                    scrollService.scrollToPosition(scrollContainer, lastScrollPosition);
                }, 200);
            }
        }
    }
})();

﻿(function () {
    'use strict';

    angular.module('app').directive('billsOverdueFromVendorWidget', widget);

    widget.$inject = ['$q', '$filter', 'apiResource', 'widgetContext', '$translate', 'gridHelper', 'chartHelper'];

    function widget($q, $filter, apiResource, widgetContext, $translate, gridHelper, chartHelper) {
        return {
            replace: false,
            transclude: false,
            templateUrl: "assets/templates/dashboard/billsOverdueFromVendorWidget.html",
            controllerAs: "overdueBills",
            bindToController: true,
            scope: {
                specificWidgetId: "@",
                specificWidgetTitle: "@"
            },
            controller: function ($scope, $element) {
                this.$onInit = function () {
                    var vm = this;
                    vm.isLoading = true;
                    vm.hasData = true;
                    vm.appliedFilter = appliedFilter;

                    vm.grid = {
                        header: "Bills Overdue From Vendor",
                        height: "100%",
                        scrollable: true,
                        dataSource: {
                        },
                        columns: [
                            {
                                title: "Account",
                                template: "<a href='accounts/account/#=account.accountId#/bills'>[#:account.accountCode#] #:account.accountInfo#</a>"
                            },
                            {
                                field: "costCenter.costCenterInfo",
                                title: "Cost Center"
                            },
                            {
                                title: "Vendor",
                                template: "#:account.vendor.vendorInfo#"
                            },
                            {
                                field: "endDate",
                                title: "Last Bill End Date",
                                template: "#=moment(endDate).format('MM/DD/YYYY')#",
                                attributes: { class: 'text-center' },
                                headerAttributes: { class: 'text-center' },
                            },
                            {
                                field: "directCost",
                                title: "Last Bill(s) Cost",
                                template: function (item) { return chartHelper.currencyFormat(item.directCost, item.costUnit.unitInfo, 0); },
                                attributes: {
                                    class: "text-right"
                                },
                                headerAttributes: {
                                    class: "text-right"
                                }
                            },
                            {
                                field: "days",
                                title: "Avg Bill Length",
                                attributes: {
                                    class: "text-right"
                                },
                                headerAttributes: {
                                    class: "text-right"
                                }
                            },
                            {
                                field: "gapDays",
                                title: "Days Overdue",
                                attributes: {
                                    class: "text-right"
                                },
                                headerAttributes: {
                                    class: "text-right"
                                }
                            }
                        ]
                    };

                    (function constructor() {
                        execute({ specificWidgetId: vm.specificWidgetId });

                        // get the details of current widget
                        vm.currentWidget = _.find(widgetContext.widgets, function (item) {
                            return item.specificWidgetId == vm.specificWidgetId;
                        });

                        angular.forEach(vm.grid.columns, function (column) {
                            column.title = $translate.instant(column.title);
                        });

                    })();

                    // show only the applied filters
                    function appliedFilter(filter) {
                        return filter.value != null;
                    }

                    function execute(options) {
                        apiResource.dashboard().billsOverdueFromVendorWidget().get({ specificWidgetId: options.specificWidgetId, filter: widgetContext.globalFilters }, function (data, headers) {
                            vm.grid.dataSource = data;
                            vm.isLoading = false;
                            if (!data || data.length == 0) {
                                vm.hasData = false;
                            }
                        });
                    }
                }
            }
        };
    }
})();



﻿(function () {
    'use strict';

    angular.module('app').directive('intervalDataWidget', IntervalDataWidget);

    IntervalDataWidget.$inject = ['$q', '$filter', 'apiResource', 'chartHelper', 'widgetContext', '$translate', 'colorHelper', 'amChartsService'];

    function IntervalDataWidget($q, $filter, apiResource, chartHelper, widgetContext, $translate, colorHelper, amChartsService) {
        return {
            replace: false,
            transclude: false,
            templateUrl: "assets/templates/dashboard/intervalDataWidget.html",
            controllerAs: 'intervalDataWidget',
            bindToController: true,
            scope: {
                specificWidgetId: "@",
                specificWidgetTitle: "@"
            },
            controller: function ($scope, $element) {
                this.$onInit = function () {
                    var vm = this;
                    vm.isLoading = true;
                    vm.hasData = true;
                    vm.appliedFilter = appliedFilter;
                    vm.feedbackMessage = "";

                    vm.readingDays = [];
                    vm.weekendGuides = [];
                    vm.nightGuides = [];
                    vm.maxMeasuredValue = 0;

                    (function constructor() {
                        execute({ specificWidgetId: vm.specificWidgetId });

                        // get the details of current widget
                        vm.currentWidget = _.find(widgetContext.widgets, function (item) {
                            return item.specificWidgetId == vm.specificWidgetId;
                        });
                    })();

                    // show only the applied filters
                    function appliedFilter(filter) {
                        return filter.value != null;
                    }



                    function execute(options) {
                        var dateFormats = [
                            { period: 'fff', format: 'LL:NN:SS A' },
                            { period: 'ss', format: 'LL:NN:SS A' },
                            { period: 'mm', format: 'LL:NN A' },
                            { period: 'hh', format: 'LL:NN A' },
                            { period: 'DD', format: 'EEE MMM DD' },
                            { period: 'WW', format: 'EEE MMM DD' },
                            { period: 'MM', format: 'EEE MMM DD' },
                            { period: 'YYYY', format: 'EEE MMM DD' }];

                        var model = {
                            "type": "stock",
                            "theme": "light",
                            "marginLeft": 24,
                            "dataDateFormat": "YYYY-MM-DDTJJ:NN:SS",
                            "pathToImages": "/assets/images/amcharts/images/",
                            "dataSets": [],
                            "categoryAxesSettings": {
                                "parseDates": true,
                                "minPeriod": "mm",
                                "gridThickness": 1,
                                "gridAlpha": 1,
                                "gridColor": "#CCCCCC",
                                "fillAlpha": .1,
                                "boldPeriodBeginning": false,
                                "groupToPeriods": ['mm'],
                                "dateFormats": dateFormats,
                                "axisThickness": 1,
                                "axisColor": "#1a1a23",
                                "axisAlpha": 1,
                                "labelOffset": -4,
                                "axisHeight": 24
                            },
                            "balloon": {
                                "animationDuration": 0,
                                "fillAlpha": 1,
                                "fillColor": "#ffffff"
                            },
                            "valueAxesSettings": {
                                "labelOffset": -2,
                                "axisThickness": 1,
                                "axisAlpha": 1,
                                "axisColor": "#1a1a23",
                                "offset": 0,
                                "inside": false
                            },
                            "panels": [{
                                "color": "#1a1a23",
                                "title": "",
                                "percentHeight": 70,
                                "recalculateToPercents": "never", // important to not show values as percentages
                                "stockGraphs": [{
                                    "id": "g1",
                                    "valueField": "value",
                                    "lineColor": colorHelper.getPrimaryChartColors(0),
                                    "lineThickness": 2,
                                    "fillAlphas": 0,
                                    "comparable": true,
                                    "compareField": "value",
                                    "compareGraphLineColor": colorHelper.getPrimaryChartColors(1),
                                    "compareGraphLineThickness": 2,
                                    "balloonText": "[[dateLabel]] \n [[timeLabel]] \n [[value]] [[unitLabel]] \n [[readingType]]",
                                    "compareGraphBalloonText": "[[dateLabel]] \n [[timeLabel]] \n [[value]] [[unitLabel]] \n [[readingType]]",
                                    "compareGraph": {
                                        "fillAlphas": 0,
                                    }
                                }],
                                "stockLegend": null,
                                "valueAxes": [{
                                    "title": "",
                                    "gridThickness": 0,
                                    "guides": [{
                                        'lineAlpha': 1,
                                        'lineThickness': 2,
                                        'lineColor': colorHelper.getGuideLineColor("target")
                                    }]
                                }],
                                "categoryAxis": {
                                    "guides": []
                                }
                            }],
                            "chartScrollbarSettings": {
                                "enabled": false
                            },
                            "chartCursorSettings": {
                                "zoomable": false,
                                "valueBalloonsEnabled": true,
                                "graphBulletSize": 1,
                                "cursorAlpha": 0.1,
                                "categoryBalloonDateFormats": dateFormats
                            },
                            "panelsSettings": {
                                "marginLeft": 80,
                                "marginBottom": 0,
                                "marginRight": 8,
                                "marginTop": 8
                            }
                        };

                        apiResource.dashboard().intervalDataWidget().get({ specificWidgetId: options.specificWidgetId, filter: widgetContext.globalFilters }, function (data) {
                            if (data && data.length > 0) {

                                vm.readingDays = [];
                                vm.weekendGuides = [];
                                vm.nightGuides = [];
                                vm.maxMeasuredValue = 0;

                                /**
                                 * Process base interval data
                                 */
                                var baseData = data[0];

                                var unit = baseData.unit.unitInfo;
                                model.panels[0].title = unit;
                                // Set our value axis title to be the first items unit code, they'll all be the same
                                if (model.panels[0].valueAxes[0].title === "") {
                                    model.panels[0].valueAxes[0].title = unit;
                                }

                                var channelData1 = baseData.readings;
                                var notes = [];

                                model.dataSets.push({
                                    "title": "Channel Data",
                                    "fieldMappings": [{
                                        "fromField": "value",
                                        "toField": "value"
                                    }],
                                    "color": colorHelper.getPrimaryChartColors(0),
                                    "dataProvider": channelData1,
                                    "categoryField": "time",
                                    "stockEvents": notes
                                });

                                angular.forEach(baseData.readings, function (reading) {

                                    if (reading.value > vm.maxMeasuredValue) {
                                        vm.maxMeasuredValue = reading.value;
                                    }

                                    setLabelsForBalloon(reading, unit);

                                    createNightAndWeekendGuides(reading, model);

                                    if (reading.note != null && reading.note != "") {
                                        notes.push({
                                            "date": reading.time,
                                            "type": "sign",
                                            "backgroundColor": colorHelper.getPrimaryChartColors(0),
                                            "graph": "g1",
                                            "text": "!",
                                            "description": reading.note
                                        });
                                    }
                                });


                                /**
                                 * Process comparison interval data
                                 */
                                var compareData = data.length > 1 ? data[1] : null;
                                if (compareData != null) {
                                    var channelData2 = [];

                                    angular.forEach(compareData.readings, function (reading) {
                                        if (reading.value > vm.maxMeasuredValue) {
                                            vm.maxMeasuredValue = reading.value;
                                        }

                                        var dayOffset = _.find(vm.currentWidget.filters, function (filter) {
                                            return filter.caption == "Compare to readings n weeks ago";
                                        }).value * 7;

                                        reading.categoryTime = moment(reading.time).add(dayOffset, 'days').format('YYYY-MM-DD[T]HH:mm:ss');

                                        setLabelsForBalloon(reading, unit);

                                        channelData2.push(reading);
                                    });

                                    model.dataSets.push({
                                        "title": "Previous Week",
                                        "compared": true,
                                        "fieldMappings": [{
                                            "fromField": "value",
                                            "toField": "value"
                                        }],
                                        "color": colorHelper.getPrimaryChartColors(1),
                                        "dataProvider": channelData2,
                                        "categoryField": "categoryTime"
                                    });
                                }

                                var showHighest = _.find(vm.currentWidget.filters, function (filter) {
                                    return filter.caption == "Show highest (Y/N)";
                                }).value == "1";
                                if (showHighest) {

                                    model.panels[0].valueAxes[0].guides[0].value = vm.maxMeasuredValue;
                                    model.panels[0].valueAxes[0].guides[0].balloonText = vm.maxMeasuredValue + ' ' + unit;
                                }

                            }

                            var placeHolder = $element[0].querySelector('.ec-chart');
                            amChartsService.makeChart(placeHolder, model);

                            vm.isLoading = false;

                            if (model.dataSets.length === 0) {
                                vm.feedbackMessage = $translate.instant('No data is available');
                                vm.hasData = false;
                                vm.isLoading = false;
                            }
                        }, function (error) {
                            vm.feedbackMessage = error.data.status.message;
                            vm.hasData = false;
                            vm.isLoading = false;

                        });
                    }

                    function setLabelsForBalloon(reading, unit) {
                        // Formatted items for our bubble display
                        reading.timeLabel = moment(reading.time).format("h:mm:ss A");
                        reading.dateLabel = moment(reading.time).format("MM/DD/YYYY");
                        reading.unitLabel = unit;

                        if (reading.estimated) {
                            reading.readingType = $translate.instant('Estimated');
                        }
                        else {
                            reading.readingType = $translate.instant('Actual Data');
                        }
                    }

                    /**
                     * Given a reading, create highlight guides for nights and weekends
                     * if we have not already done so for the day of the reading.
                     * We only want to do this for the "base" readings, not comparison readings.
                     * @param {Object} reading The reading from the API.
                     */
                    function createNightAndWeekendGuides(reading, model) {

                        var shadeWeekends = _.find(vm.currentWidget.filters, function (filter) {
                            return filter.caption == "Shade weekends (Y/N)";
                        }).value == "1";
                        var shadeNights = _.find(vm.currentWidget.filters, function (filter) {
                            return filter.caption == "Shade day/night (Y/N)";
                        }).value == "1";

                        if (!shadeWeekends && !shadeNights) {
                            return;
                        }

                        // if we haven't already processed the current reading's day
                        var day = moment(reading.time).format("MM/DD/YYYY");
                        if (vm.readingDays.indexOf(day) === -1) {

                            // Check to see if the time fell on a weekend and we haven't already found that date.
                            if (shadeWeekends && (moment(reading.time).day() === 0 || moment(reading.time).day() === 6)) {

                                // Push the guide for each of our weekend days found
                                model.panels[0].categoryAxis.guides.push({
                                    "date": moment(day).format('YYYY-MM-DDTHH:mm:ss'),
                                    "toDate": moment(day).add(1, 'days').format('YYYY-MM-DDTHH:mm:ss'),
                                    "fillAlpha": .7,
                                    "fillColor": "#E4E4E4",
                                    "tickLength": 0,
                                    "lineThickness": 0
                                });
                            }

                            if (shadeNights) {
                                // Guides from midnight to 6AM
                                model.panels[0].categoryAxis.guides.push({
                                    "date": moment(day).format('YYYY-MM-DDTHH:mm:ss'),
                                    "toDate": moment(day).add(6, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
                                    "fillAlpha": .7,
                                    "fillColor": "#E0E0F3",
                                    "tickLength": 0,
                                    "lineThickness": 0
                                });
                                // Guides for 6PM to midnight
                                model.panels[0].categoryAxis.guides.push({
                                    "date": moment(day).add(18, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
                                    "toDate": moment(day).add(1, 'days').format('YYYY-MM-DDTHH:mm:ss'),
                                    "fillAlpha": .7,
                                    "fillColor": "#E0E0F3",
                                    "tickLength": 0,
                                    "lineThickness": 0
                                });
                            }


                            // add day to array so we don't add guides again
                            vm.readingDays.push(moment(reading.time).format("MM/DD/YYYY"));
                        }
                    }
                }

            }
        };
    }
})();



﻿(function () {
    'use strict';

    angular.module('app').directive('missingBillsWidget', MissingBillsWidget);

    MissingBillsWidget.$inject = ['$q', '$filter', 'apiResource', 'chartHelper', 'widgetContext', '$translate', 'gridHelper', '$log'];

    function MissingBillsWidget($q, $filter, apiResource, chartHelper, widgetContext, $translate, gridHelper, $log) {
        return {
            replace: false,
            transclude: false,
            templateUrl: "assets/templates/dashboard/missingBillsWidget.html",
            controllerAs: 'missingBills',
            bindToController: true,
            scope: {
                specificWidgetId: "@",
                specificWidgetTitle: "@"
            },
            controller: function ($scope, $element) {
                this.$onInit = function () {
                    var vm = this;
                    vm.isLoading = true;
                    vm.hasData = true;
                    vm.appliedFilter = appliedFilter;

                    vm.grid = {
                        header: "Missing Bills",
                        height: "100%",
                        scrollable: true,
                        dataSource: {
                        },
                        columns: [
                            {
                                title: "Account",
                                template: "<a href='accounts/account/#=accountId#/bills'>#:accountInfo#</a>"
                            },
                            {
                                title: "Meter",
                                template: "#:meterInfo#"
                            },
                            {
                                title: "Gap Range",
                                template: "#=moment(gapBeginDate).format('MM/DD/YYYY')# - #=moment(gapEndDate).format('MM/DD/YYYY')#"
                            },
                            {
                                field: "gapDays",
                                title: "No. of Days",
                                width: 84,
                                attributes: { class: 'text-right' },
                                headerAttributes: { class: 'text-right' }
                            }
                        ]
                    };

                    (function constructor() {
                        execute({ specificWidgetId: vm.specificWidgetId });

                        // get the details of current widget
                        vm.currentWidget = _.find(widgetContext.widgets, function (item) {
                            return item.specificWidgetId == vm.specificWidgetId;
                        });

                        angular.forEach(vm.grid.columns, function (column) {
                            column.title = $translate.instant(column.title);
                        });

                    })();

                    // show only the applied filters
                    function appliedFilter(filter) {
                        return filter.value != null;
                    }

                    function execute(options) {
                        apiResource.dashboard().missingBills().get({ filter: widgetContext.globalFilters, specificWidgetId: options.specificWidgetId, field: "account,accountId,accountInfo,meter,meterInfo,gapBeginDate,gapEndDate,gapDays" }, function (data) {
                            vm.grid.dataSource = data;
                            vm.isLoading = false;
                            if (!data || data.length == 0) {
                                vm.hasData = false;
                            }
                        }, function (err) {
                            vm.hasData = false;
                            vm.isLoading = false;
                            $log.error(err);
                        });

                    }
                }
            }
        };
    }
})();



﻿(function () {
    'use strict';

    angular.module('app').directive('mostExpensiveBuildingsWidget', MostExpensiveBuildingsWidget);

    MostExpensiveBuildingsWidget.$inject = ['apiResource', 'widgetContext', '$translate', 'chartHelper', 'gridHelper', 'placeTypeIconPipe', 'placeRoutePipe'];

    function MostExpensiveBuildingsWidget(apiResource, widgetContext, $translate, chartHelper, gridHelper, placeTypeIconPipe, placeRoutePipe) {
        return {
            replace: false,
            transclude: false,
            templateUrl: "assets/templates/dashboard/mostExpensiveBuildingsWidget.html",
            controllerAs: 'mostExpensiveBuildings',
            bindToController: true,
            scope: {
                specificWidgetId: "@",
                specificWidgetTitle: "@"
            },
            controller: function ($scope, $element) {
                this.$onInit = function () {
                    var vm = this;
                    vm.isLoading = true;
                    vm.hasData = true;
                    vm.appliedFilter = appliedFilter;

                    vm.grid = {
                        header: "Most Expensive Buildings",
                        height: "100%",
                        scrollable: true,
                        lockedColumnsRight: true,
                        dataSource: {
                        },
                        sortable: true,
                        columns: [
                            {
                                title: "Building",
                                template: "<div class='d-inline-flex align-items-center'><i class='ec-icon #:cssClass#'></i><a href='#:locateLink#'>#:place.placeInfo#</a></div>"
                            },
                            {
                                title: "Total cost",
                                field: "totalCostDisplay",
                                width: gridHelper.CURRENCY_COLUMN,
                                attributes: { class: 'text-right' },
                                headerAttributes: { class: 'text-right' }
                            },
                            {
                                title: "CurrentSize_TC",
                                field: "areaDisplay",
                                width: gridHelper.XSMALL_COLUMN,
                                attributes: { class: 'text-right' },
                                headerAttributes: { class: 'text-right' }
                            },
                            {
                                title: "Cost/area",
                                field: "costPerAreaDisplay",
                                width: gridHelper.XSMALL_COLUMN,
                                attributes: { class: 'text-right' },
                                headerAttributes: { class: 'text-right' }
                            }
                        ]
                    };

                    (function constructor() {
                        execute({ specificWidgetId: vm.specificWidgetId });

                        // get the details of current widget
                        vm.currentWidget = _.find(widgetContext.widgets, function (item) {
                            return item.specificWidgetId == vm.specificWidgetId;
                        });

                        angular.forEach(vm.grid.columns, function (column) {
                            column.title = $translate.instant(column.title);
                        });

                    })();

                    // show only the applied filters
                    function appliedFilter(filter) {
                        return filter.value != null;
                    }

                    function execute(options) {
                        apiResource.dashboard().mostExpensiveBuildingsWidget().get({ specificWidgetId: options.specificWidgetId, filter: widgetContext.globalFilters }, function (result) {

                            angular.forEach(result, function (record) {
                                record.cssClass = placeTypeIconPipe.transform(record.place.placeType);
                                record.locateLink = placeRoutePipe.transformSync(record.place, 'ECAP', ['actual', 'summary'], true);

                                record.totalCostDisplay = chartHelper.currencyFormat(record.totalCost, record.costUnit.unitInfo, 0);

                                if (record.currentArea != null && record.currentAreaUnit != null) {
                                    // format area and unit information
                                    record.areaDisplay = chartHelper.numberFormat(record.currentArea, 0) + " " + record.currentAreaUnit;
                                }
                                else {
                                    // use a blank value if area is not available
                                    record.areaDisplay = "";
                                }

                                if (record.currentArea != null && record.areaUnit != null && record.costPerArea != null) {
                                    // format cost/area
                                    record.costPerAreaDisplay = chartHelper.currencyFormat(record.costPerArea, record.costUnit.unitInfo, 2) + "/" + record.areaUnit;
                                }
                                else {
                                    // use a blank value if cost/area is not available
                                    record.costPerAreaDisplay = "";
                                }
                            });

                            vm.grid.dataSource = result;
                            vm.isLoading = false;
                            if (!result || result.length == 0) {
                                vm.hasData = false;
                            }
                        });

                    }
                }
            }
        };
    }
})();



﻿(function () {
    'use strict';

    angular.module('app').directive('mostExpensiveMetersWidget', MostExpensiveMetersWidget);

    MostExpensiveMetersWidget.$inject = ['apiResource', 'widgetContext', '$translate', 'gridHelper', 'chartHelper', 'meterIconPipe'];

    function MostExpensiveMetersWidget(apiResource, widgetContext, $translate, gridHelper, chartHelper, meterIconPipe) {
        return {
            replace: false,
            transclude: false,
            templateUrl: "assets/templates/dashboard/mostExpensiveMetersWidget.html",
            controllerAs: 'mostExpensiveMeters',
            bindToController: true,
            scope: {
                specificWidgetId: "@",
                specificWidgetTitle: "@"
            },
            controller: function ($scope, $element) {
                this.$onInit = function () {
                    var vm = this;
                    vm.isLoading = true;
                    vm.hasData = true;
                    vm.appliedFilter = appliedFilter;

                    vm.grid = {
                        header: "Most Expensive Meters",
                        height: "100%",
                        scrollable: true,
                        dataSource: {
                        },
                        sortable: true,
                        columns: [
                            {
                                title: "Meter",
                                field: "meter.meterInfo",
                                template: "<div class='d-inline-flex align-items-center'><i class='ec-icon flex-shrink mr-2 #=cssClass#'></i><a href='#=locateLink#'>#:meter.meterInfo#</a></div>",
                                width: gridHelper.LARGE_COLUMN
                            },
                            {
                                title: "Commodity",
                                field: "meter.commodity.commodityInfo",
                                width: gridHelper.SMALL_COLUMN,
                            },
                            {
                                title: "Place",
                                field: "place.placeInfo"
                            },
                            {
                                title: "Total cost",
                                field: "totalCostDisplay",
                                width: gridHelper.CURRENCY_COLUMN,
                                attributes: { class: 'text-right' },
                                headerAttributes: { class: 'text-right' }
                            }
                        ]
                    };

                    (function constructor() {
                        execute({ specificWidgetId: vm.specificWidgetId });

                        // get the details of current widget
                        vm.currentWidget = _.find(widgetContext.widgets, function (item) {
                            return item.specificWidgetId == vm.specificWidgetId;
                        });

                        angular.forEach(vm.grid.columns, function (column) {
                            column.title = $translate.instant(column.title);
                        });

                    })();

                    // show only the applied filters
                    function appliedFilter(filter) {
                        return filter.value != null;
                    }

                    function execute(options) {
                        apiResource.dashboard().mostExpensiveMetersWidget().get({ specificWidgetId: options.specificWidgetId, filter: widgetContext.globalFilters }, function (result) {

                            angular.forEach(result, function (record) {
                                record.cssClass = meterIconPipe.transform(record.meter);
                                record.locateLink = "buildings/meter/" + record.meter.meterId + "/actual/summary";
                                record.totalCostDisplay = chartHelper.currencyFormat(record.totalCost, record.costUnit.unitInfo, 0);
                            });

                            vm.grid.dataSource = result;
                            vm.isLoading = false;
                            if (!result || result.length == 0) {
                                vm.hasData = false;
                            }
                        });

                    }
                }
            }
        };
    }
})();



(function () {
    'use strict';

    angular.module('app').directive('performanceComparisonWidget', PerformanceComparisonWidget);

    PerformanceComparisonWidget.$inject = ['apiResource', 'widgetContext', 'chartHelper', 'colorHelper', '$timeout', 'amChartsService', '$log', 'userService'];

    function PerformanceComparisonWidget(apiResource, widgetContext, chartHelper, colorHelper, $timeout, amChartsService, $log, userService) {
        return {
            replace: false,
            transclude: false,
            templateUrl: "assets/templates/dashboard/performanceComparisonWidget.html",
            controllerAs: 'performanceComparisonWidget',
            bindToController: true,
            scope: {
                specificWidgetId: "@",
                specificWidgetTitle: "@"
            },
            controller: function ($scope, $element) {
                this.$onInit = function () {
                    var vm = this;
                    vm.isLoading = true;
                    vm.hasData = true;
                    vm.appliedFilter = appliedFilter;
                    vm.widgetType = "";
                    vm.entities = [];
                    vm.priorYearLegendDisplay = "";
                    vm.currentYearLegendDisplay = "";
                    vm.dataPoints = [];
                    vm.pyColor = colorHelper.getCurrentVsPriorYearColor("prior");
                    vm.cyColor = colorHelper.getCurrentVsPriorYearColor("current");
                    vm.floorAreaUnit = "SqFt";
                    vm.chartCostMaximum = 0; // Will be set by the sum of current year costs
                    vm.summary = {
                        pyCostTotal: null,
                        cyCostTotal: null,
                        cyCostTotalDisplay: null,
                        globalUse: null,
                        costUnit: null,
                        costPercentDiff: null,
                        pyGlobalUseTotal: null,
                        cyGlobalUseTotal: null,
                        globalUsePercentDiff: null
                    };

                    (function constructor() {

                        vm.currentWidget = _.find(widgetContext.widgets, function (item) {
                            return item.specificWidgetId == vm.specificWidgetId;
                        });

                        // Store the type of widget; used later on to customize some things, since this
                        // directive is serving two discrete widget types: Place Performance Comparison and
                        // Commodity Performance Comparison.                    
                        vm.widgetType = vm.currentWidget.widgetInfo.toLowerCase();

                        execute({ specificWidgetId: vm.specificWidgetId });
                    })();

                    // show only the applied filters
                    function appliedFilter(filter) {
                        return filter.value != null;
                    }

                    // Roll up global use by period so we can display a summary sparkline
                    function rollUpDataPoints(dataPoints) {
                        var groupByPeriod = _.groupBy(dataPoints, 'periodNumber');
                        var rollUps = [];
                        var max = _.maxBy(dataPoints, 'periodNumber').periodNumber;

                        for (var i = 1; i < max; i++) {
                            var rolledUpDataPoint = {
                                period: groupByPeriod["1"].period,
                                pyGlobalUse: _.sumBy(groupByPeriod[i.toString()], function (g) { return g.pyGlobalUse; }),
                                cyGlobalUse: _.sumBy(groupByPeriod[i.toString()], function (g) { return g.cyGlobalUse; })
                            };
                            rollUps.push(rolledUpDataPoint);
                        }

                        return rollUps;
                    }

                    function execute(options) {

                        // get API data
                        apiResource.dashboard().executeWidget().get({
                            specificWidgetId: vm.specificWidgetId,
                            filter: widgetContext.globalFilters
                        }, function (data) {

                            if (data) {

                                // FYI - data is sorted from highest prior year cost to lowest

                                vm.comparisons = data.performanceComparisons;
                                vm.dataPoints = data.dataPoints;

                                var firstComparison = data.performanceComparisons[0];
                                vm.priorYearLegendDisplay = firstComparison.pyDisplay;
                                vm.currentYearLegendDisplay = firstComparison.cyDisplay;

                                if (firstComparison.thirdValueDisplay) {
                                    var thirdValueDisplayParts = firstComparison.thirdValueDisplay.split('/');
                                    if (thirdValueDisplayParts.length == 2) {
                                        if (thirdValueDisplayParts[1]) {
                                            vm.floorAreaUnit = thirdValueDisplayParts[1].replace("SqFt", "ft²").replace("SqM", "m²");
                                        }
                                    }
                                }

                                // populate the summary information
                                vm.currencyUnit = userService.getUser().currencyUnit.unitInfo;
                                vm.summary.costUnit = vm.currencyUnit;

                                vm.summary.cyCostTotal = _.sumBy(data.performanceComparisons, function (pc) { return pc.cyCost; });

                               
                                vm.summary.pyCostTotal = _.sumBy(data.performanceComparisons, function (pc) { return pc.pyCost; });
                                vm.summary.pyGlobalUseTotal = _.sumBy(data.performanceComparisons, function (pc) { return pc.pyGlobalUse; });
                                vm.summary.cyGlobalUseTotal = _.sumBy(data.performanceComparisons, function (pc) { return pc.cyGlobalUse; });
                                vm.summary.globalUsePercentDiff = chartHelper.getPercentDifference(vm.summary.pyGlobalUseTotal, vm.summary.cyGlobalUseTotal);
                                vm.summary.costPercentDiff = chartHelper.getPercentDifference(vm.summary.pyCostTotal, vm.summary.cyCostTotal);
                                vm.summary.cyCostTotalDisplay = chartHelper.numberFormat(vm.summary.cyCostTotal, 0)
                                vm.summary.usePercentChangeClass = vm.summary.globalUsePercentDiff > 0 ? "ec-data-bad ec-data-increase" : (vm.summary.globalUsePercentDiff < 0) ? "ec-data-good ec-data-decrease" : "";

                                // summary thermometer
                                var summaryTherm = chartHelper.getThermometerChartDefaults("summary", vm.summary.pyCostTotal, vm.summary.cyCostTotal);
                                summaryTherm.valueAxes[0].maximum = vm.summary.pyCostTotal + (0.2 * vm.summary.pyCostTotal); // Thermometer scale is prior year cost + 20%
                                summaryTherm.valueAxes[0].minimum = 0;
                                amChartsService.makeChart("barCompChart_" + vm.specificWidgetId + "_summary", summaryTherm);

                                // summary spark chart                                
                                var summarySparkData = rollUpDataPoints(vm.dataPoints);
                                summarySparkData[summarySparkData.length - 1].bullet = "round";
                                var summarySpark = chartHelper.getSparklineChartDefaults(summarySparkData, "periodNumber", "pyGlobalUse", "cyGlobalUse");

                                summarySpark.categoryAxis.startOnAxis = true;
                                summarySpark.valueAxes[0].minimum = -1;    //don't clip the line when it reaches zero
                                summarySpark.marginTop = 8;
                                summarySpark.marginBottom = 8;

                                amChartsService.makeChart("lineCompChart_" + vm.specificWidgetId + "_summary", summarySpark);

                                // prepare the legend information
                                var pyDisplay = vm.comparisons[0].pyDisplay; // December 2017-January 2018                                
                                var pyDisplayParts = pyDisplay.split('-'); // December 2017,January 2018  
                                var cyDisplay = vm.comparisons[0].cyDisplay;
                                var cyDisplayParts = cyDisplay.split('-');

                                vm.translatedPyDisplay = chartHelper.translateMonthYear(pyDisplayParts[0]) + "-" + chartHelper.translateMonthYear(pyDisplayParts[1]);
                                vm.translatedCyDisplay = chartHelper.translateMonthYear(cyDisplayParts[0]) + "-" + chartHelper.translateMonthYear(cyDisplayParts[1]);

                                // NOTE: when listing by commodity or place, results should be ordered descending by cost. This is done in the stored procedure powering the widget.

                                // The "thermometer" charts are parts which describe the whole of the comparisons being displayed.
                                // So, set the maximum of the value axis to be the sum of all the current year values                                
                                vm.chartCostMaximum = vm.comparisons[0].pyCost + (0.2 * vm.comparisons[0].pyCost); // Thermometer scale is highest prior year cost + 20%                                

                                // Now, resort the comparisons from highest-lowest based on current year cost
                                vm.comparisons = _.orderBy(vm.comparisons, ['cyCost'], ['desc']);

                                // loop through the comparisons and begin to render the charts
                                $timeout(function () {
                                    angular.forEach(vm.comparisons, function (value, key) {

                                        var entity = value;

                                        // use proper unit display
                                        if (entity.thirdValueDisplay) {
                                            entity.thirdValueDisplay = entity.thirdValueDisplay.replace("SqFt", "ft²").replace("SqM", "m²");
                                        }

                                        // get subset of data points that pertain only to the current entity
                                        var entityData = _.filter(vm.dataPoints, function (value) {
                                            return value.id === entity.id;
                                        });
                                        entityData[entityData.length - 1].bullet = "round";

                                        // cost up/down 
                                        entity.costPercentChangeClass = entity.costPercentDiff > 0 ? "ec-data-bad ec-data-increase" : (entity.costPercentDiff < 0) ? "ec-data-good ec-data-decrease" : "";

                                        // use up/down 
                                        entity.usePercentChangeClass = entity.usePercentDiff > 0 ? "ec-data-bad ec-data-increase" : (entity.usePercentDiff < 0) ? "ec-data-good ec-data-decrease" : "";

                                        // third value up/down 
                                        entity.thirdValuePercentChangeClass = entity.thirdValuePercentDiff > 0 ? "ec-data-bad ec-data-increase" : (entity.thirdValuePercentDiff < 0) ? "ec-data-good ec-data-decrease" : "";

                                        // Separate values from their units
                                        entity.cyCostUnit = vm.currencyUnit;
                                        entity.cyCostDisplay = chartHelper.numberFormat(entity.cyCost, 0);
                            
                                        if (entity.thirdValueDisplay) {

                                        /* Next lines are all about splitting and replacing entity.thirdValueDisplay to fit the 3 columns (currency, raw value, units) 
                                        existing in the markup, we could have changed the markup to use as it is but in order to prevent double costUnit we do 
                                        the first replace: to remove the currency unit from the value and substitute the currency unit that is coming from the Me object in the separate column.
                                        These changes are affecting two widgets : CommodityPerformanceComparison and PlacePerformanceComparison and all this code is soon to be replace it, with the latest of angular as the other widgets.*/

                                            entity.thirdValueCostUnit = vm.currencyUnit;
                                            entity.thirdValueDisplayValue = entity.thirdValueDisplay.replace(vm.currencyUnit, '');
                                            entity.thirdValueDisplayValue = entity.thirdValueDisplayValue.replace(entity.thirdValueDisplayValue.substr(entity.thirdValueDisplayValue.indexOf('/'), entity.thirdValueDisplayValue.length - 1), '');
                                            entity.thirdValueUnit = entity.thirdValueDisplay.substr(entity.thirdValueDisplay.indexOf('/'), entity.thirdValueDisplay.length - 1);
                                        }

                                        // Cost comparison spark chart                                    
                                        var thermometer = chartHelper.getThermometerChartDefaults(entity.label, entity.pyCost, entity.cyCost);
                                        thermometer.valueAxes[0].maximum = vm.chartCostMaximum;
                                        thermometer.valueAxes[0].minimum = 0;

                                        amChartsService.makeChart("barCompChart_" + vm.specificWidgetId + "_" + entity.id, thermometer);

                                        // Use comparison spark chart
                                        var defaultSparklineChart = chartHelper.getSparklineChartDefaults(entityData, "periodNumber", "pyUse", "cyUse");

                                        defaultSparklineChart.categoryAxis.startOnAxis = true;
                                        defaultSparklineChart.valueAxes[0].minimum = -1;    //don't clip the line when it reaches zero
                                        defaultSparklineChart.marginTop = 8;
                                        defaultSparklineChart.marginBottom = 8;

                                        amChartsService.makeChart("lineCompChart_" + vm.specificWidgetId + "_" + entity.id, defaultSparklineChart);
                                    });

                                    vm.isLoading = false;
                                });
                            }
                        }, function (err) {
                            if (err && err.data && err.data.status && err.data.status.message && err.data.status.message.toLowerCase() != "no data returned") {
                                vm.message = err.data.status.message;
                            }
                            vm.hasData = false;
                            vm.isLoading = false;
                            $log.error(err);
                        });
                    }
                }
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('app').directive('textWidget', TextWidget);

    TextWidget.$inject = ['apiResource', 'widgetContext', 'chartHelper', 'userService', '$sanitize', '$sce'];

    function TextWidget(apiResource, widgetContext, chartHelper, userService, $sanitize, $sce) {
        return {
            templateUrl: "assets/templates/dashboard/textWidget.html",
            controllerAs: 'textWidget',
            bindToController: true,
            scope: {
                specificWidgetId: "@",
                specificWidgetTitle: "@"
            },
            controller: function ($scope, $element) {
                this.$onInit = function(){
                    var vm = this;
                    vm.isLoading = true;
                    vm.hasData = true;
                    vm.appliedFilter = appliedFilter;

                    (function constructor() {
                        vm.currentWidget = _.find(widgetContext.widgets, function (item) {
                            return item.specificWidgetId == vm.specificWidgetId;
                        });                   

                        execute();
                    })();

                    // show only the applied filters
                    function appliedFilter(filter) {
                        return filter.value != null;
                    }


                    function execute() {
                        var textFilter = _.find(vm.currentWidget.filters, function(e){
                            return e.caption == "Text";
                        });

                        vm.santizedText = $sce.trustAsHtml($sanitize(textFilter.value));
                        vm.hasData = true;
                        vm.isLoading = false;
                    }
                };
            }
        };
    }
})();
(function () {
	'use strict';

	angular
		.module('groupsModule')
		.controller('benchmarkingComparisonController', BenchmarkingComparisonController);

	BenchmarkingComparisonController.$inject = ['$state', 'apiResource', '$translate', '$filter', '$timeout',
		'translationHelper', 'colorHelper', 'runtimeService', 'userService', 'meterIconPipe', 'benchmarkFiltersService', '$scope', 'amChartsService', 'userService2'];

	function BenchmarkingComparisonController($state, apiResource, $translate, $filter, $timeout,
		translationHelper, colorHelper, runtimeService, userService, meterIconPipe, benchmarkFiltersService, $scope, amChartsService, userService2) {
		var vm = this;

		vm.groupId = $state.params.groupId;
		vm.hideProgressBar = false;
		vm.state = $state;
		vm.changeView = changeView;

		// Clear AmChart resources and event listeners
		// when the object is destroyed.
		$scope.$on("$destroy", function () {
			$state.unsubscribeFromEvent('groupsUpdated', refresh);
			if (vm.scatterPlot) {
				vm.scatterPlot.clear();
			}
		});

		vm.availablePeriods = [{ text: $translate.instant('last 12 months'), value: 1 },
		{ text: $translate.instant('last calendar year'), value: 2 },
		{ text: $translate.instant('last fiscal year'), value: 3 },
		{ text: '', value: 4 }];

		vm.updateFiltersAndRefresh = updateFiltersAndRefresh;

		vm.setGridView = setGridView;
		vm.setSortDirection = setSortDirection;
		vm.showCost = true;
		vm.showIncompleteDataLegend = false;

		// TODO: use chartHelper's/formatHelper functions to get the formatting once Zac finishes
		vm.numberFormats = {
			costPerDecimals: 2,
			totalCostDecimals: 0,
			valueDecimals: 0,
			valuePerDecimals: 3,
			unitCostDecimals: 3,
			totalValueDecimals: 0,
			savingsOpportunityDecimals: 0,
			areaDecimals: 0
		};

		function isNullOrUndefined(e) { return angular.isUndefined(e) || e === null; };
		vm.NA = $translate.instant("N/A");
		vm.valueFormats = {
			cost: function (e) { if (isNullOrUndefined(e)) { return vm.NA; } return vm.moneyUnit + $filter('number')(e, vm.numberFormats.totalCostDecimals); },
			costSavings: function (e) { if (isNullOrUndefined(e)) { return vm.NA; } return vm.moneyUnit + $filter('number')(e, vm.numberFormats.savingsOpportunityDecimals); },
			costPerArea: function (e) { if (isNullOrUndefined(e) || vm.benchmarkFactorUnit === null) { return vm.NA; } return vm.moneyUnit + $filter('number')(e, vm.numberFormats.costPerDecimals) + "/" + vm.benchmarkFactorUnit; },
			costPerDay: function (e) { if (isNullOrUndefined(e) || vm.benchmarkFactorUnit === null) { return vm.NA; } return vm.moneyUnit + $filter('number')(e, vm.numberFormats.costPerDecimals) + "/" + $translate.instant(vm.benchmarkFactorUnit); },
			costPerValue: function (e) { if (isNullOrUndefined(e) || vm.benchmarkFactorUnit === null) { return vm.NA; } return vm.moneyUnit + $filter('number')(e, vm.numberFormats.unitCostDecimals) + "/" + vm.benchmarkFactorUnit; },
			costPerAreaMoneyUnitOnly: function (e) { if (isNullOrUndefined(e)) { return vm.NA; } return vm.moneyUnit + $filter('number')(e, vm.numberFormats.costPerDecimals); },
			costPerDayMoneyUnitOnly: function (e) { if (isNullOrUndefined(e)) { return vm.NA; } return vm.moneyUnit + $filter('number')(e, vm.numberFormats.costPerDecimals); },
			costPerValueMoneyUnitOnly: function (e) { if (isNullOrUndefined(e)) { return vm.NA; } return vm.moneyUnit + $filter('number')(e, vm.numberFormats.unitCostDecimals); },
			costPerValueTertiary: function (e) { if (isNullOrUndefined(e) || vm.tertiaryUnit === null) { return vm.NA; } return vm.moneyUnit + $filter('number')(e, vm.numberFormats.unitCostDecimals) + "/" + vm.tertiaryUnit; },
			costPerValueQuaternary: function (e) { if (isNullOrUndefined(e) || vm.quaternaryUnit === null) { return vm.NA; } return vm.moneyUnit + $filter('number')(e, vm.numberFormats.unitCostDecimals) + "/" + vm.quaternaryUnit; },
			costPerCustomBenchmark: function (e) { if (isNullOrUndefined(e) || vm.benchmarkFactorUnit === null) { return vm.NA; } return vm.moneyUnit + $filter('number')(e, vm.numberFormats.costPerDecimals) + "/" + vm.benchmarkFactorUnit; },
			// the "value" from "value per x"
			value: function (e) { if (isNullOrUndefined(e) || vm.benchmarkValueUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.totalValueDecimals) + " " + vm.benchmarkValueUnit; },
			valueSavings: function (e) { if (isNullOrUndefined(e) || vm.benchmarkValueUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.savingsOpportunityDecimals) + " " + vm.benchmarkValueUnit; },
			valueTertiary: function (e) { if (isNullOrUndefined(e) || vm.tertiaryUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.totalValueDecimals) + " " + vm.tertiaryUnit; },
			valueQuaternary: function (e) { if (isNullOrUndefined(e) || vm.quaternaryUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.totalValueDecimals) + " " + vm.quaternaryUnit; },
			valuePerArea: function (e) { if (isNullOrUndefined(e) || vm.benchmarkUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.valuePerDecimals) + " " + vm.benchmarkUnit; },
			valuePerDay: function (e) { if (isNullOrUndefined(e) || vm.benchmarkValueUnit === null || vm.benchmarkFactorUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.valuePerDecimals) + " " + vm.benchmarkValueUnit + "/" + $translate.instant(vm.benchmarkFactorUnit); },
			valuePerCustomBenchmark: function (e) { if (isNullOrUndefined(e) || vm.benchmarkValueUnit === null || vm.benchmarkFactorUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.valuePerDecimals) + " " + vm.benchmarkValueUnit + "/" + $translate.instant(vm.benchmarkFactorUnit); },
			// the "value" from "x per value"
			perValue: function (e) { if (isNullOrUndefined(e) || vm.benchmarkFactorUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.totalValueDecimals) + " " + vm.benchmarkFactorUnit; },
			area: function (e) { if (isNullOrUndefined(e) || vm.benchmarkFactorUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.areaDecimals) + " " + vm.benchmarkFactorUnit; },
			demand: function (e) { if (isNullOrUndefined(e) || vm.benchmarkUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.valueDecimals) + " " + vm.benchmarkUnit; },
			weatherPerArea: function (e) { if (isNullOrUndefined(e) || vm.benchmarkUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.valuePerDecimals) + " " + vm.benchmarkUnit; },
			rawCost: function (e) { if (isNullOrUndefined(e)) { return vm.NA; } return $filter('number')(e, vm.numberFormats.totalCostDecimals); },
			rawCostSavings: function (e) { if (isNullOrUndefined(e)) { return vm.NA; } return $filter('number')(e, vm.numberFormats.savingsOpportunityDecimals); },
			rawCostPerArea: function (e) { if (isNullOrUndefined(e) || vm.benchmarkFactorUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.costPerDecimals) },
			rawCostPerDay: function (e) { if (isNullOrUndefined(e) || vm.benchmarkFactorUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.costPerDecimals) },
			rawCostPerValue: function (e) { if (isNullOrUndefined(e) || vm.benchmarkFactorUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.unitCostDecimals) },
			rawCostPerValueTertiary: function (e) { if (isNullOrUndefined(e) || vm.tertiaryUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.unitCostDecimals) },
			rawCostPerValueQuaternary: function (e) { if (isNullOrUndefined(e) || vm.quaternaryUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.unitCostDecimals) },
			// the "value" from "value per x"
			rawValue: function (e) { if (isNullOrUndefined(e) || vm.benchmarkValueUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.totalValueDecimals) },
			rawValueSavings: function (e) { if (isNullOrUndefined(e) || vm.benchmarkValueUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.savingsOpportunityDecimals) },
			rawValueTertiary: function (e) { if (isNullOrUndefined(e) || vm.tertiaryUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.totalValueDecimals) },
			rawValueQuaternary: function (e) { if (isNullOrUndefined(e) || vm.quaternaryUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.totalValueDecimals) },
			rawValuePerArea: function (e) { if (isNullOrUndefined(e) || vm.benchmarkUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.valuePerDecimals) },
			rawValuePerDay: function (e) { if (isNullOrUndefined(e) || vm.benchmarkValueUnit === null || vm.benchmarkFactorUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.valuePerDecimals) },
			// the "value" from "x per value"
			rawPerValue: function (e) { if (isNullOrUndefined(e) || vm.benchmarkFactorUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.totalValueDecimals) },
			rawArea: function (e) { if (isNullOrUndefined(e) || vm.benchmarkFactorUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.areaDecimals) },
			rawDemand: function (e) { if (isNullOrUndefined(e) || vm.benchmarkUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.valueDecimals) },
			rawWeatherPerArea: function (e) { if (isNullOrUndefined(e) || vm.benchmarkUnit === null) { return vm.NA; } return $filter('number')(e, vm.numberFormats.valuePerDecimals) },
		}

		vm.excludeMember = excludeMember;
		vm.includeMember = includeMember;

		vm.buildingAndMeterGroupsEdit = false;

		(function constructor() {
			// Set Permissions to hide/show buttons
			// Everything on this screen as some dependency on permissions so calling once
			// and not doing anything until these values are set
			runtimeService.getConfigData().then(function (meSettings) {
				benchmarkFiltersService.subscribeToFilterChanges(vm.updateFiltersAndRefresh);
				$state.subscribeToEvent('groupsUpdated', refresh);

				vm.buildingAndMeterGroupsEdit = userService.userHasPermission("BuildingAndMeterGroupsEdit");

				apiResource.commodity().commodityWithCategoryInfo().query({}, function (result) {
					vm.availableCommodityCategories = new Map();

					var commodities = _.filter(result, function (commodity) {
						return commodity.inUse;
					});

					commodities.unshift({ commodityInfo: 'all', commodityId: 0 });

					angular.forEach(commodities, function (commodity) {
						commodity.commodityInfo = $translate.instant(commodity.commodityInfo);

						if (commodity.commodityCategory) {
							if (!vm.availableCommodityCategories.has(commodity.commodityCategory.commodityCategoryId)) {
								vm.availableCommodityCategories.set(commodity.commodityCategory.commodityCategoryId, $translate.instant(commodity.commodityCategory.commodityCategoryInfo));
							}
						}
					});

					vm.availableCommodities = commodities;

					var groupDisplaySetting = meSettings.preference.groupDisplaySetting;
					var savedDataView = groupDisplaySetting.dataView;
					vm.selectedDataView = benchmarkFiltersService.getValidDataView(savedDataView, vm.type, vm.benchmark, (vm.groupType === 'placeGroup'));

					setSelectedPeriod(groupDisplaySetting.periodType, groupDisplaySetting.userDefinedRangeStartPeriod, groupDisplaySetting.userDefinedRangeEndPeriod);

					vm.selectedCommodityId = groupDisplaySetting.commodityId;
					vm.selectedCommodityCategoryId = groupDisplaySetting.commodityCategoryId;

					vm.showExcluded = groupDisplaySetting.showExcludedMembers;
					vm.showZeroAverages = groupDisplaySetting.showZeroAverages;
					vm.showExcludedText = vm.groupType == "placeGroup" ? $translate.instant("show excluded buildings") : $translate.instant("show excluded meters");

					checkForOutdatedSettingsAndContinue();
				});


				vm.hrefFunction = function (item) {
					if (vm.groupType == "placeGroup") {
						return "buildings/building/" + item.placeId + "/actual/summary";
					}
					else {
						return "buildings/meter/" + item.meterId + "/actual/summary";
					}
				};

				vm.displayFunction = function (item) {
					if (vm.groupType == "placeGroup") {
						return item.placeDisplay;
					}
					else {
						return item.meterDisplay;
					}

				};

				vm.getIcon = function (item) {
					if (vm.groupType === 'placeGroup') {
						return '';
					} else {
						return meterIconPipe.transform(item);
					}
				}

				vm.toolTipFunction = function (item) {
					if (vm.groupType == "placeGroup") {
						return item.placeInfo + " [" + item.placeCode + "]";
					}
					else {
						return item.meterInfo + " [" + item.meterCode + "]";
					}

				};

				vm.balloonFunction = function (e) {
					var item = e.dataContext;
					var balloonHtml = "<span style='display: inline-block'>" + vm.displayFunction(item) + "</span><br/>";
					balloonHtml += "<span style='display: inline-block'>" + vm.primaryBalloonLabel + ": " + vm.primaryFormat(item[vm.primaryAxisValueSelector]) + "</span><br/>";
					balloonHtml += "<span style='display: inline-block'>" + vm.secondaryAxisLabel + ": " + vm.secondaryFormat(item[vm.secondaryAxisValueSelector]) + "</span>";
					return balloonHtml;
				};

				if ($state.current.name.startsWith("placegroup")) {
					vm.groupType = "placeGroup";
				}
				else {
					vm.groupType = "meterGroup";
				}

				// set vm.type, chart selector properties
				initializeCharts($state.current.name);

				vm.color = colorHelper.getBenchmarkColors(vm.type);
			});

		})();

		function initializeCharts(state) {
			var dataView;
			if (vm.selectedDataView) {
				dataView = vm.selectedDataView;
			}

			toggleIncompleteDataLegend(state, dataView);

			getChartTitle();
			vm.medianCardTitle = '';
			vm.totalCardTitle = '';
			// format function to use in the median card
			vm.medianCardFormat = undefined;
			vm.benchmark = '';

			// PRIMARY VALUE
			// Column header for the primary value in the details view
			vm.detailsViewPrimaryColumnHeader = '';
			vm.primaryValueSelector = 'value';
			vm.primaryHighValueLabel = "high";
			vm.primaryLowValueLabel = "low";
			vm.primaryAxisLabel = '';
			vm.primaryBalloonLabel = '';
			vm.primaryMedianValueSelector = "medianValue";
			vm.primaryHighValueSelector = "highValue";
			vm.primaryLowValueSelector = "lowValue";
			vm.primaryAxisValueSelector = null;
			vm.primaryAxisLowValueSelector = null;
			vm.primaryFormat = null;
			// format function for primary data displayed on high-low/low-high bar charts
			vm.primaryHiLowFormat = null;
			// format function for x-axis labels on scatter chart
			vm.primaryAxisFormat = null;

			// SECONDARY VALUE
			vm.detailsViewSecondaryColumnHeader = 'TotalCost_TC';
			vm.secondaryValueSelector = 'cost';
			vm.secondaryHighValueLabel = "high";
			vm.secondaryLowValueLabel = "low";
			vm.secondaryAxisLabel = '';
			vm.secondaryMedianValueSelector = "medianCost";
			vm.secondaryHighValueSelector = "highCost";
			vm.secondaryLowValueSelector = "lowCost";
			vm.secondaryAxisValueSelector = null;
			vm.secondaryAxisLowValueSelector = null;
			// format function  y-axis labels on scatter chart
			vm.secondaryAxisFormat = null;

			// TERTIARY VALUE
			vm.detailsViewTertiaryColumnHeader = "TotalUse_TC";
			vm.tertiaryValueSelector = "";
			vm.tertiaryUnitSelector = "";

			// QUATERNARY VALUE
			vm.detailsViewQuaternaryColumnHeader = "TotalUse_TC";
			vm.quaternaryValueSelector = "";
			vm.quaternaryUnitSelector = "";

			vm.needSavingsOpportunity = true;
			vm.savingsOpportunityValueSelector = "savingsOpportunity";
			vm.savingsOpportunityHighValueSelector = "highSavingsOpportunity";


			switch (state) {
				case "placegroup.cost.area":
					vm.type = "areacost";
					vm.benchmark = 'area';
					vm.primaryBalloonLabel = $translate.instant("CostPerArea");
					vm.secondaryAxisLabel = $translate.instant("TotalCost_TC");
					vm.valueTypePerBenchmark = $translate.instant("CostPerArea");
					//cost/area is primary
					vm.primaryFormat = function (e) { return vm.valueFormats.costPerAreaMoneyUnitOnly(e); };
					vm.primaryHiLowFormat = function (e) { return vm.valueFormats.costPerArea(e); };
					vm.primaryAxisFormat = function (e) { return vm.valueFormats.costPerAreaMoneyUnitOnly(e); };
					vm.medianCardFormat = function (e) { return vm.valueFormats.rawCostPerArea(e); };
					//total cost is secondary
					vm.secondaryFormat = function (e) { return vm.valueFormats.cost(e); };
					//Savings Opportunity is money
					vm.savingsOpportunityFormat = function (e) { return vm.valueFormats.costSavings(e); };
					vm.memberId = function (member) { return member.placeId; };
					break;
				case "placegroup.cost.day":
					vm.type = "cost";
					vm.benchmark = 'day';
					vm.primaryBalloonLabel = $translate.instant("Cost/day");
					vm.secondaryAxisLabel = $translate.instant("TotalCost_TC");
					vm.valueTypePerBenchmark = $translate.instant("Cost/day");
					//cost/day is primary
					vm.primaryFormat = function (e) { return vm.valueFormats.costPerDayMoneyUnitOnly(e); };
					vm.primaryHiLowFormat = function (e) { return vm.valueFormats.costPerDay(e); };
					vm.primaryAxisFormat = function (e) { return vm.valueFormats.costPerDayMoneyUnitOnly(e); };
					vm.medianCardFormat = function (e) { return vm.valueFormats.rawCostPerDay(e); };
					//total cost is secondary
					vm.secondaryFormat = function (e) { return vm.valueFormats.cost(e); };
					//Savings Opportunity is money
					vm.savingsOpportunityFormat = function (e) { return vm.valueFormats.costSavings(e); };
					vm.memberId = function (member) { return member.placeId; };
					break;
				case "placegroup.use.day":
					vm.type = "use";
					vm.benchmark = 'day';
					vm.primaryBalloonLabel = $translate.instant("Use / Day");
					vm.secondaryAxisLabel = $translate.instant("TotalCost_TC");
					vm.valueTypePerBenchmark = $translate.instant("Use / Day");
					//use/day is primary
					vm.primaryFormat = function (e) { return vm.valueFormats.rawValuePerDay(e); };
					vm.primaryHiLowFormat = function (e) { return vm.valueFormats.valuePerDay(e); };
					vm.primaryAxisFormat = function (e) { return vm.valueFormats.rawValuePerDay(e); };
					vm.medianCardFormat = function (e) { return vm.valueFormats.rawValuePerDay(e); };
					//total cost is secondary
					vm.secondaryFormat = function (e) { return vm.valueFormats.cost(e); };
					//total use is tertiary
					vm.tertiaryFormat = function (e) { return vm.valueFormats.value(e); };
					//Savings Opportunity is Usage
					vm.savingsOpportunityFormat = function (e) { return vm.valueFormats.valueSavings(e); };
					vm.memberId = function (member) { return member.placeId; };
					vm.detailsViewTertiaryColumnHeader = "TotalUse_TC";
					vm.tertiaryValueSelector = "use";
					vm.tertiaryUnitSelector = "useUnitDisplay";
					vm.tertiaryHighValueSelector = "highUse";

					if (dataView === "normalized") {
						//secondary axis is Usage
						vm.secondaryAxisLabel = $translate.instant("TotalUse_TC");
						vm.secondaryAxisValueSelector = "use";
						vm.secondaryAxisLowValueSelector = "lowUse";
						vm.secondaryAxisFormat = function (e) { return vm.valueFormats.value(e); };
					}
					break;
				case "placegroup.use.area":
					vm.type = "areause";
					vm.benchmark = 'area';
					vm.primaryBalloonLabel = $translate.instant("UsePerArea");
					vm.secondaryAxisLabel = $translate.instant("TotalCost_TC");
					vm.valueTypePerBenchmark = $translate.instant("UsePerArea");
					//use/area is primary
					vm.primaryFormat = function (e) { return vm.valueFormats.rawValuePerArea(e); };
					vm.primaryHiLowFormat = function (e) { return vm.valueFormats.valuePerArea(e); };
					vm.primaryAxisFormat = function (e) { return vm.valueFormats.rawValuePerArea(e); };
					vm.medianCardFormat = function (e) { return vm.valueFormats.rawValuePerArea(e); };
					//total cost is secondary
					vm.secondaryFormat = function (e) { return vm.valueFormats.cost(e); };
					//total use is tertiary
					vm.tertiaryFormat = function (e) { return vm.valueFormats.value(e); };
					//Savings Opportunity is Usage
					vm.savingsOpportunityFormat = function (e) { return vm.valueFormats.valueSavings(e); };
					vm.memberId = function (member) { return member.placeId; };
					vm.detailsViewTertiaryColumnHeader = "TotalUse_TC";
					vm.tertiaryValueSelector = "use";
					vm.tertiaryUnitSelector = "useUnitDisplay";
					vm.tertiaryHighValueSelector = "highUse";

					if (dataView === "normalized") {
						//secondary axis is area
						vm.secondaryAxisLabel = $translate.instant("Total area");
						vm.secondaryAxisValueSelector = "area";
						vm.secondaryAxisLowValueSelector = "lowArea";
						vm.secondaryAxisFormat = function (e) { return vm.valueFormats.area(e); };
					}
					break;
				case "placegroup.demand.area":
					vm.type = "areaDemand";
					vm.benchmark = 'area';
					turnOffSavingsOpportunityView();
					vm.primaryBalloonLabel = $translate.instant("Peak Demand/Area");
					vm.secondaryAxisLabel = $translate.instant("TotalCost_TC");
					vm.valueTypePerBenchmark = $translate.instant("Peak Demand/Area");
					//demand/area is primary
					vm.primaryFormat = function (e) { return vm.valueFormats.rawValuePerArea(e); };
					vm.primaryHiLowFormat = function (e) { return vm.valueFormats.valuePerArea(e); };
					vm.primaryAxisFormat = function (e) { return vm.valueFormats.rawValuePerArea(e); };
					vm.medianCardFormat = function (e) { return vm.valueFormats.rawValuePerArea(e); };
					//total cost is secondary
					vm.secondaryFormat = function (e) { return vm.valueFormats.cost(e); };
					vm.memberId = function (member) { return member.placeId; };
					break;
				case "placegroup.weather.hdd":
					// This is not a current valid option
					vm.type = "heatingSensitivity";
					vm.benchmark = 'hdd';
					turnOffSavingsOpportunityView();
					vm.detailsViewSecondaryColumnHeader = "Non-Weather Load (Use per HDD per area)";
					vm.primaryAxisLabel = $translate.instant("Weather Load (Use per HDD per area)");
					vm.secondaryAxisLabel = $translate.instant("Non-Weather Load (Use per HDD per area)");
					vm.valueTypePerBenchmark = '';
					//weather load is primary
					vm.primaryFormat = function (e) { return vm.valueFormats.weatherPerArea(e); };
					vm.primaryHiLowFormat = function (e) { return vm.valueFormats.weatherPerArea(e); };
					vm.medianCardFormat = function (e) { return vm.valueFormats.rawWeatherPerArea(e); };
					//non-weather load is secondary
					vm.secondaryFormat = function (e) { return vm.valueFormats.weatherPerArea(e); };
					vm.primaryValueSelector = 'slopeValue';
					vm.secondaryValueSelector = 'baseValue';

					vm.primaryMedianValueSelector = "averageWeatherLoad";
					vm.primaryHighValueSelector = "highWeatherLoad";
					vm.primaryLowValueSelector = "lowWeatherLoad";

					vm.secondaryMedianValueSelector = "averageNonWeatherLoad";
					vm.secondaryHighValueSelector = "highNonWeatherLoad";
					vm.secondaryLowValueSelector = "lowNonWeatherLoad";
					vm.memberId = function (member) { return member.placeId; };
					break;
				case "placegroup.weather.cdd":
					// This is not a current valid option
					vm.type = "coolingSensitivity";
					vm.benchmark = 'cdd';
					turnOffSavingsOpportunityView();
					vm.detailsViewSecondaryColumnHeader = "Non-Weather Load (Use per CDD per area)";
					vm.primaryAxisLabel = $translate.instant("Weather Load (Use per CDD per area)");
					vm.secondaryAxisLabel = $translate.instant("Non-Weather Load (Use per CDD per area)");
					vm.valueTypePerBenchmark = '';
					//weather load is primary
					vm.primaryFormat = function (e) { return vm.valueFormats.weatherPerArea(e); };
					vm.primaryHiLowFormat = function (e) { return vm.valueFormats.weatherPerArea(e); };
					vm.medianCardFormat = function (e) { return vm.valueFormats.rawWeatherPerArea(e); };
					//non-weather load is secondary
					vm.secondaryFormat = function (e) { return vm.valueFormats.weatherPerArea(e); };
					vm.primaryValueSelector = 'slopeValue';
					vm.secondaryValueSelector = 'baseValue';

					vm.primaryMedianValueSelector = "averageWeatherLoad";
					vm.primaryHighValueSelector = "highWeatherLoad";
					vm.primaryLowValueSelector = "lowWeatherLoad";

					vm.secondaryMedianValueSelector = "averageNonWeatherLoad";
					vm.secondaryHighValueSelector = "highNonWeatherLoad";
					vm.secondaryLowValueSelector = "lowNonWeatherLoad";
					vm.memberId = function (member) { return member.placeId; };
					break;
				case "metergroup.cost.day":
					vm.type = "cost";
					vm.benchmark = 'day';
					vm.primaryBalloonLabel = $translate.instant("Cost/day");
					vm.secondaryAxisLabel = $translate.instant("TotalCost_TC");
					vm.valueTypePerBenchmark = $translate.instant("Cost/day");
					//cost/day is primary
					vm.primaryFormat = function (e) { return vm.valueFormats.costPerDayMoneyUnitOnly(e); };
					vm.primaryHiLowFormat = function (e) { return vm.valueFormats.costPerDay(e); };
					vm.primaryAxisFormat = function (e) { return vm.valueFormats.costPerDayMoneyUnitOnly(e); };
					vm.medianCardFormat = function (e) { return vm.valueFormats.rawCostPerDay(e); };
					//total cost is secondary
					vm.secondaryFormat = function (e) { return vm.valueFormats.cost(e); };
					//total use is tertiary
					vm.tertiaryFormat = function (e) { return vm.valueFormats.valueTertiary(e); };
					//Savings Opportunity is Cost
					vm.savingsOpportunityFormat = function (e) { return vm.valueFormats.costSavings(e); };
					vm.memberId = function (member) { return member.meterId; };
					vm.detailsViewTertiaryColumnHeader = "TotalUse_TC";
					vm.tertiaryValueSelector = "use";
					vm.tertiaryUnitSelector = "useUnitDisplay";
					vm.tertiaryHighValueSelector = "highUse";
					break;
				case "metergroup.cost.unit":
					vm.type = "unitcost";
					vm.benchmark = 'unit';
					vm.primaryMedianValueSelector = "medianUnitCost";
					vm.primaryHighValueSelector = "highUnitCost";
					vm.primaryLowValueSelector = "lowUnitCost";
					vm.primaryBalloonLabel = $translate.instant("CostPerUnit");
					vm.secondaryAxisLabel = $translate.instant("TotalCost_TC");
					vm.valueTypePerBenchmark = $translate.instant("CostPerUnit");
					//unit cost is primary
					vm.primaryFormat = function (e) { return vm.valueFormats.costPerDayMoneyUnitOnly(e); };
					vm.primaryHiLowFormat = function (e) { return vm.valueFormats.costPerValue(e); };
					vm.primaryAxisFormat = function (e) { return vm.valueFormats.costPerValueMoneyUnitOnly(e); };
					vm.medianCardFormat = function (e) { return vm.valueFormats.rawCostPerValue(e); };
					//total cost is secondary
					vm.secondaryFormat = function (e) { return vm.valueFormats.cost(e); };
					//total use is tertiary
					vm.tertiaryFormat = function (e) { return vm.valueFormats.perValue(e); };
					//Savings Opportunity is Cost
					vm.savingsOpportunityFormat = function (e) { return vm.valueFormats.costSavings(e); };
					vm.memberId = function (member) { return member.meterId; };
					vm.secondaryValueSelector = "cost";
					vm.detailsViewTertiaryColumnHeader = "TotalUse_TC";
					vm.tertiaryValueSelector = "use";
					vm.tertiaryUnitSelector = "useUnitDisplay";
					vm.tertiaryHighValueSelector = "highUse";

					break;
				case "metergroup.use.day":
					vm.type = "use";
					vm.benchmark = 'day';
					vm.primaryBalloonLabel = $translate.instant("Use / Day");
					vm.secondaryAxisLabel = $translate.instant("TotalCost_TC");
					vm.valueTypePerBenchmark = $translate.instant("Use / Day");
					//use/day is primary
					vm.primaryFormat = function (e) { return vm.valueFormats.rawValuePerDay(e); };
					vm.primaryHiLowFormat = function (e) { return vm.valueFormats.valuePerDay(e); };
					vm.primaryAxisFormat = function (e) { return vm.valueFormats.rawValuePerDay(e); };
					vm.medianCardFormat = function (e) { return vm.valueFormats.rawValuePerDay(e); };
					//total cost is secondary
					vm.secondaryFormat = function (e) { return vm.valueFormats.cost(e); };
					//unitcost is tertiary
					vm.tertiaryFormat = function (e) { return vm.valueFormats.costPerValueTertiary(e); };
					//total use is quaternary
					vm.quaternaryFormat = function (e) { return vm.valueFormats.value(e); };
					//Savings Opportunity is Usage
					vm.savingsOpportunityFormat = function (e) { return vm.valueFormats.valueSavings(e); };
					vm.memberId = function (member) { return member.meterId; };
					vm.secondaryValueSelector = "cost";
					vm.detailsViewTertiaryColumnHeader = "UnitCost_TC";
					vm.tertiaryValueSelector = "unitCost";
					vm.tertiaryUnitSelector = "useUnitDisplay";
					vm.tertiaryHighValueSelector = "highUnitCost";
					vm.detailsViewQuaternaryColumnHeader = "TotalUse_TC";
					vm.quaternaryValueSelector = "use";
					vm.quaternaryUnitSelector = "useUnitDisplay";
					vm.quaternaryHighValueSelector = "highUse";

					if (dataView === "normalized") {
						//secondary axis is Usage
						vm.secondaryAxisLabel = $translate.instant("TotalUse_TC");
						vm.secondaryAxisValueSelector = "use";
						vm.secondaryAxisLowValueSelector = "lowUse";
						vm.secondaryAxisFormat = function (e) { return vm.valueFormats.value(e); };
					}
					break;
				case "metergroup.demand.peak":
					vm.type = "demand";
					vm.benchmark = 'peak';
					turnOffSavingsOpportunityView();
					vm.primaryBalloonLabel = $translate.instant("Peak demand");
					vm.secondaryAxisLabel = $translate.instant("TotalCost_TC");
					vm.valueTypePerBenchmark = $translate.instant("Peak demand");
					//demand is primary
					vm.primaryFormat = function (e) { return vm.valueFormats.rawDemand(e); };
					vm.primaryHiLowFormat = function (e) { return vm.valueFormats.demand(e); };
					vm.primaryAxisFormat = function (e) { return vm.valueFormats.rawDemand(e); };
					vm.medianCardFormat = function (e) { return vm.valueFormats.rawDemand(e); };
					//total cost is secondary
					vm.secondaryFormat = function (e) { return vm.valueFormats.cost(e); };
					vm.memberId = function (member) { return member.meterId; };
					break;
				case 'placegroup.cost.benchmark1':
				case 'placegroup.cost.benchmark2':
				case 'placegroup.cost.benchmark3':
				case 'placegroup.use.benchmark1':
				case 'placegroup.use.benchmark2':
				case 'placegroup.use.benchmark3':
					initializeCustomBenchmarkCharts(state);
					break;
			}

			if (!vm.primaryAxisValueSelector) {
				vm.primaryAxisValueSelector = vm.primaryValueSelector;
			}
			if (!vm.primaryAxisLowValueSelector) {
				vm.primaryAxisLowValueSelector = vm.primaryLowValueSelector;
			}
			if (!vm.primaryAxisFormat) {
				vm.primaryAxisFormat = vm.primaryFormat;
			}
			if (!vm.secondaryAxisValueSelector) {
				vm.secondaryAxisValueSelector = vm.secondaryValueSelector;
			}
			if (!vm.secondaryAxisLowValueSelector) {
				vm.secondaryAxisLowValueSelector = vm.secondaryLowValueSelector;
			}
			if (!vm.secondaryAxisFormat) {
				vm.secondaryAxisFormat = vm.secondaryFormat;
			}
		}


		/**We only want to show the incomplete data legend when the results we show
		 * are actually being evaluated for completeness. At this time only Calendarized and Normalized data
		 * for benchmarks and area are actually checked. Everything else indicates that it is complete because
		 * we don't even try to figure it out.
		 */
		function toggleIncompleteDataLegend(state, dataView) {
			var visibleStates = [
				'placegroup.cost.benchmark1',
				'placegroup.cost.benchmark2',
				'placegroup.cost.benchmark3',
				'placegroup.use.benchmark1',
				'placegroup.use.benchmark2',
				'placegroup.use.benchmark3',
				'placegroup.cost.area',
				'placegroup.use.area'
			];

			if (visibleStates.indexOf(state) !== -1 && dataView && (dataView === 'calendarized' || dataView === 'normalized')) {
				vm.showIncompleteDataLegend = true;
			} else {
				vm.showIncompleteDataLegend = false;
			}
		}


		function initializeCustomBenchmarkCharts(state) {
			var splitState = state.split('.');
			var valueType = splitState[1];
			vm.benchmark = splitState[2];
			vm.type = vm.benchmark + valueType;

			turnOffSavingsOpportunityView();

			if (valueType === 'cost') {
				// benchmark factor will be added later when we have it
				vm.valueTypePerBenchmark = $translate.instant("cost");
				vm.primaryBalloonLabel = vm.valueTypePerBenchmark;
				vm.secondaryAxisLabel = $translate.instant("TotalCost_TC");
				//cost/benchmark is primary
				vm.primaryFormat = function (e) { return vm.valueFormats.costPerValueMoneyUnitOnly(e); };
				vm.primaryHiLowFormat = function (e) { return vm.valueFormats.costPerCustomBenchmark(e); };
				vm.primaryAxisFormat = function (e) { return vm.valueFormats.costPerValueMoneyUnitOnly(e); };
				vm.medianCardFormat = function (e) { return vm.valueFormats.rawCostPerArea(e); };
				//total cost is secondary
				vm.secondaryFormat = function (e) { return vm.valueFormats.cost(e); };
				vm.memberId = function (member) {
					return member.placeId;
				};
			} else {
				// benchmark factor will be added later when we have it
				vm.valueTypePerBenchmark = $translate.instant("use");
				vm.primaryBalloonLabel = vm.valueTypePerBenchmark;
				vm.secondaryAxisLabel = $translate.instant("TotalCost_TC");
				//use/benchmark is primary
				vm.primaryFormat = function (e) { return vm.valueFormats.rawValuePerArea(e); };
				vm.primaryHiLowFormat = function (e) { return vm.valueFormats.valuePerCustomBenchmark(e); };
				vm.primaryAxisFormat = function (e) { return vm.valueFormats.rawValuePerArea(e); };
				vm.medianCardFormat = function (e) { return vm.valueFormats.rawValuePerArea(e); };
				//total cost is secondary
				vm.secondaryFormat = function (e) { return vm.valueFormats.cost(e); };
				//total use is tertiary
				vm.tertiaryFormat = function (e) { return vm.valueFormats.value(e); };
				vm.memberId = function (member) {
					return member.placeId;
				};
				vm.detailsViewTertiaryColumnHeader = "TotalUse_TC";
				vm.tertiaryValueSelector = "use";
				vm.tertiaryUnitSelector = "useUnitDisplay";
				vm.tertiaryHighValueSelector = "highUse";
			}
		}


		function turnOffSavingsOpportunityView() {
			vm.needSavingsOpportunity = false; //no savings opportunity for this view
			if ($state.queryParams.view == "savingsopp") {
				$state.go($state.current.name, { groupId: vm.groupId }, {}, { view: 'desc' });
			}
		}


		/**
		 * Set `selectedPeriod` from given `periodType`.
		 * PeriodType will come from the Me API or from the `benchmarkFiltersService`.
		 * Using previously defined `vm.availablePeriods` because the text in those
		 * objects are being used in the graphs.
		 * @param periodType BenchmarksBillingPeriod
		 * @param customPeriodStart number (YYYYMM)
		 * @param customPeriodEnd number (YYYYMM)
		 */
		function setSelectedPeriod(periodType, customPeriodStart, customPeriodEnd) {
			// Check to see if our period type is supported, it could have been saved from ECO 3.x and is not supported here
			// If it's not found set it to Last 12 months
			var periodIndex = _.findIndex(vm.availablePeriods, function (period) {
				return period.value === periodType;
			});

			if (periodIndex === -1) {
				vm.selectedPeriod = _.find(vm.availablePeriods, function (period) {
					return period.value === 1;
				});
			} else {
				vm.selectedPeriod = vm.availablePeriods[periodIndex];
			}

			vm.customPeriodStart = customPeriodStart;
			vm.customPeriodEnd = customPeriodEnd;
		}

		function changeView(view) {
			$state.go($state.current.name, { groupId: vm.groupId }, { location: 'replace' }, { view: view });

			setupInternalState(view);
		}

		function setupInternalState(view) {
			if (angular.isUndefined(view)) {
				view = "desc";
			}

			switch (view) {
				case "desc":
					setSortDirection("-percent");
					break;
				case "asc":
					setSortDirection("+percent");
					break;
				case "savingsopp":
					setSortDirection("-" + vm.savingsOpportunityValueSelector);
					break;
				case "grid":
					setGridView();
					break;
			}
		}

		function setGridView() {
			vm.viewTitle = vm.title;
		}

		function setSortDirection(sortDirection) {
			// Set's the sort direction for our horizontal bar chart
			vm.viewTitle = vm.title;
			if (sortDirection == "-" + vm.savingsOpportunityValueSelector) {
				vm.viewTitle = "Savings opportunity if reduced to average";
			}
			vm.sortDirection = sortDirection;
		}

		function refresh() {
			vm.hideProgressBar = false;
			vm.noDataAvailable = false;
			vm.noSavingsDataAvailable = true; //always assume we have no savings opportunity - if we need to show that view and we have any savings opportunities, we will flip this flag
			vm.showCost = vm.selectedDataView !== "normalized";

			// gotta reset vm properties based on selected data view
			initializeCharts($state.current.name);

			/*****************************************************************
			 *
			 *                DETAILS VIEW GRID SETUP
			 *
			 *****************************************************************/
			var columns = [{
				title: (vm.groupType == "placeGroup") ? $translate.instant("Building") : $translate.instant("Meter"),
				field: "display",
				attributes: {
					class: 'v-align-middle'
				},
				template: '<div class="d-flex text-clip">' +
					(vm.groupType === 'meterGroup' ? '<i class="ec-icon mr-2 flex-shrink #=icon#"></i>' : '') +
					'<a title="#=toolTip#" href="#=href#">#=display#</a>' +
					'</div>'
			},
			{
				title: vm.detailsViewPrimaryColumnHeader,
				rawTitle: vm.detailsViewPrimaryColumnHeader,
				field: "primaryChartValue",
				headerAttributes: {
					class: 'text-right'
				},
				template: '<div class="ec-chart-bar-row-inner d-flex no-hover">' +
					'<div class="ec-chart-bar-primary flex-shrink" style="width: #=percent#%"></div>' +
					'<div class="ec-chart-bar-units ml-auto" translate>#=formattedPrimary#</div>' +
					'</div>'
			},
			{
				title: $translate.instant(vm.detailsViewSecondaryColumnHeader),
				headerAttributes: {
					class: 'text-right'
				},
				rawTitle: vm.detailsViewSecondaryColumnHeader,
				field: "secondaryChartValue",
				template: '<div class="ec-chart-bar-row-inner d-flex no-hover">' +
					'<div class="ec-chart-bar-primary flex-shrink" style="width: #=percentCost#%"></div>' +
					'<div class="ec-chart-bar-units ml-auto" translate>#=formattedSecondary#</div>' +
					'</div>'
			}];
			if (vm.tertiaryValueSelector != "") {
				columns.push({
					title: $translate.instant(vm.detailsViewTertiaryColumnHeader),
					rawTitle: vm.detailsViewTertiaryColumnHeader,
					field: "tertiaryChartValue",
					headerAttributes: {
						class: 'text-right'
					},
					template: '<div class="ec-chart-bar-row-inner d-flex no-hover">' +
						'<div class="ec-chart-bar-primary flex-shrink" style="width: #=percentTertiary#%"></div>' +
						'<div class="ec-chart-bar-units ml-auto" translate>#=formattedTertiary#</div>' +
						'</div>'
				});
			}
			if (vm.quaternaryValueSelector != "") {
				columns.push({
					title: $translate.instant(vm.detailsViewQuaternaryColumnHeader),
					headerAttributes: {
						class: 'text-right'
					},
					rawTitle: vm.detailsViewQuaternaryColumnHeader,
					field: "quaternaryChartValue",
					template: '<div class="ec-chart-bar-row-inner d-flex no-hover">' +
						'<div class="ec-chart-bar-primary flex-shrink" style="width: #=percentQuaternary#%"></div>' +
						'<div class="ec-chart-bar-units ml-auto" translate>#=formattedQuaternary#</div>' +
						'</div>'
				});
			}

			if (vm.buildingAndMeterGroupsEdit) {
				columns.push(
					{
						width: 28,
						template: "<button ng-if='#=includeInCharts#' class='ec-btn-icon btn' title='{{ \"Exclude member\" | translate}}' ng-click='grid.controller.excludeMember(#=memberId#)'><i class='ec-icon icon-hide'></i></button><button ng-if='!#=includeInCharts#' class='ec-btn-icon btn' title='{{ \"Include member\" | translate}}' ng-click='grid.controller.includeMember(#=memberId#)'><i class='ec-icon icon-show'></i></button>"
					}
				);
			}

			if (!vm.showCost) {
				_.forEach(columns, function (column) {
					if (column.rawTitle && column.rawTitle.toLowerCase().includes("cost")) {
						column.hidden = true;
					}
				});
			}
			vm.membersGrid = {
				header: "",
				height: '100%',
				scrollable: true,
				pageable: false,
				sortable: true,
				columns: columns,
				dataSource: {

				}
			};

			/*****************************************************************
			 *
			 *                GET DATA
			 *
			 *****************************************************************/
			if (vm.groupType == "placeGroup") {
				var digestParams = {
					placeGroupId: vm.groupId,
					view: vm.selectedDataView,
					type: vm.type,
					periodType: vm.selectedPeriod.value,
					showExcluded: vm.showExcluded,
					showZeroAverages: vm.showZeroAverages
				};

				if (isCommoditySelected()) {
					digestParams.commodityId = vm.selectedCommodityId;
				} else {
					digestParams.commodityCategoryId = vm.selectedCommodityCategoryId;
				}

				apiResource.group().placeGroupDigest().get(digestParams, function (data) {
					populateView(data);
				}, function (error) {
					vm.noDataAvailable = true;
					vm.hideProgressBar = true;
				});
			}
			else {
				var digestParams = {
					meterGroupId: vm.groupId,
					view: vm.selectedDataView,
					type: vm.type,
					periodType: vm.selectedPeriod.value,
					showExcluded: vm.showExcluded,
					showZeroAverages: vm.showZeroAverages
				};

				if (isCommoditySelected()) {
					digestParams.commodityId = vm.selectedCommodityId;
				} else {
					digestParams.commodityCategoryId = vm.selectedCommodityCategoryId;
				}

				apiResource.group().meterGroupDigest().get(digestParams, function (data) {
					populateView(data);
				}, function (error) {
					vm.noDataAvailable = true;
					vm.hideProgressBar = true;
				});
			}
		}


		function populateView(data) {
			vm.model = data;

			// our model may not have any content and thus why are checking for the results property
			// the api can return a 204 no content under certain scenarios
			if (vm.model.hasOwnProperty("results") && vm.model.results.length > 0) {

				// setting units first for the "no data" check below
				vm.benchmarkValueUnit = vm.model.benchmarkValueUnit;
				vm.benchmarkUnit = vm.model.benchmarkUnit;
				vm.benchmarkFactorUnit = vm.model.benchmarkFactorUnit;
				// adding these to the model so the tertiary and quaternary unit selectors can work
				if (!angular.isUndefined(vm.model.useUnit) && vm.model.useUnit != null && !angular.isUndefined(vm.model.useUnit.unitInfo)) {
					vm.model.useUnitDisplay = vm.model.useUnit.unitInfo;
				}
				if (!angular.isUndefined(vm.model.costUnit) && vm.model.costUnit != null && !angular.isUndefined(vm.model.costUnit.unitInfo)) {
					vm.model.costUnitDisplay = vm.model.costUnit.unitInfo;
					vm.moneyUnit = vm.model.costUnit.unitInfo;
				}

				vm.primaryHighValue = vm.medianCardFormat(vm.model[vm.primaryHighValueSelector]);
				vm.primaryLowValue = vm.medianCardFormat(vm.model[vm.primaryLowValueSelector]);
				if (vm.primaryHighValue === "N/A" && vm.primaryLowValue === "N/A") {
					vm.noDataAvailable = true;
				}
				else {
					vm.primaryMedianValue = vm.medianCardFormat(vm.model[vm.primaryMedianValueSelector]);
					if (vm.tertiaryValueSelector != "") {
						vm.tertiaryUnit = vm.model[vm.tertiaryUnitSelector];
					}
					if (vm.quaternaryValueSelector != "") {
						vm.quaternaryUnit = vm.model[vm.quaternaryUnitSelector];
					}

					vm.secondaryMedianValue = vm.secondaryFormat(vm.model[vm.secondaryMedianValueSelector]);
					vm.secondaryHighValue = vm.secondaryFormat(vm.model[vm.secondaryHighValueSelector]);
					vm.secondaryLowValue = vm.secondaryFormat(vm.model[vm.secondaryLowValueSelector]);

					_.forEach(vm.model.results, function (item) {
						item.memberId = vm.memberId(item);

						item.display = vm.displayFunction(item);
						item.icon = vm.getIcon(item);
						item.color = vm.color.foreground1;
						item.forecolor1 = vm.color.foreground1;
						item.forecolor2 = vm.color.foreground2;
						item.backcolor = vm.color.background;
						item.percent = (item[vm.primaryValueSelector] / vm.model[vm.primaryHighValueSelector]) * 100;
						item.percentCost = (item[vm.secondaryValueSelector] / vm.model[vm.secondaryHighValueSelector]) * 100;
						item.percentUse = 0;
						if (vm.needSavingsOpportunity) {
							if (item[vm.savingsOpportunityValueSelector] !== null && item[vm.savingsOpportunityValueSelector] > 0 && vm.model[vm.savingsOpportunityHighValueSelector] !== null && vm.model[vm.savingsOpportunityHighValueSelector] > 0) {
								item.percentSavingsOpportunity = (item[vm.savingsOpportunityValueSelector] / vm.model[vm.savingsOpportunityHighValueSelector]) * 100;
								item.saver = true;
								item.formattedSavingsOpportunity = vm.savingsOpportunityFormat(item[vm.savingsOpportunityValueSelector]);
								//even if we have one saver, we have something to show on the Savings Opportunity tab
								vm.noSavingsDataAvailable = false;
							}
							else {
								item.percentSavingsOpportunity = 0;
								item.saver = false;
								item.formattedSavingsOpportunity = vm.savingsOpportunityFormat(item[vm.savingsOpportunityValueSelector]);
							}

						}

						item.href = vm.hrefFunction(item);
						item.toolTip = vm.toolTipFunction(item);
						item.hiLowFormattedPrimary = vm.primaryHiLowFormat(item[vm.primaryValueSelector]);
						item.formattedPrimary = vm.primaryFormat(item[vm.primaryValueSelector]);
						item.formattedSecondary = vm.secondaryFormat(item[vm.secondaryValueSelector]);

						item.primaryChartValue = item[vm.primaryAxisValueSelector];
						item.secondaryChartValue = item[vm.secondaryAxisValueSelector];
						if (vm.tertiaryValueSelector != "") {
							item.tertiaryChartValue = item[vm.tertiaryValueSelector];
							item.percentTertiary = (item[vm.tertiaryValueSelector] / vm.model[vm.tertiaryHighValueSelector]) * 100;
							item.formattedTertiary = vm.tertiaryFormat(item[vm.tertiaryValueSelector]);
						}
						if (vm.quaternaryValueSelector != "") {
							item.quaternaryChartValue = item[vm.quaternaryValueSelector];
							item.percentQuaternary = (item[vm.quaternaryValueSelector] / vm.model[vm.quaternaryHighValueSelector]) * 100;
							item.formattedQuaternary = vm.quaternaryFormat(item[vm.quaternaryValueSelector]);
						}
					});

					vm.membersGrid.dataSource.data = vm.model.results;

					if (vm.state.queryParams.view === "scatter") {

						vm.primaryAxisLabel = vm.benchmarkUnit;
						vm.scatterPlot = amChartsService.makeChart("scatterPlot", {
							"type": "xy",
							"dataProvider": vm.model.results,
							"marginBottom": 0,
							"balloon": {
								"disableMouseEvents": false,
								"fixedPosition": true,
								"fillAlpha": 1
							},
							"valueAxes": [{
								"id": "X",
								"position": "bottom",
								"axisAlpha": 0,
								"labelFrequency": 2,
								"labelFunction": function (value) { return vm.primaryAxisFormat(value); },
								"minimum": vm.model[vm.primaryAxisLowValueSelector],
								"title": vm.primaryAxisLabel,
								"precision": 4,
								"dashLength": 1
							}, {
								"id": "Y",
								"axisAlpha": 0,
								"labelFunction": function (value) { return vm.secondaryAxisFormat(value); },
								"minimum": vm.model[vm.secondaryAxisLowValueSelector],
								"title": vm.secondaryAxisLabel,
								"dashLength": 1,
								"position": "left"
							}],
							"chartCursor": {
								"categoryBalloonEnabled": false,
								"balloonPointerOrientation": "vertical",
								"cursorAlpha": 0,
								"zoomable": false
							},
							"hideBalloonTime": 5000,
							"graphs": [{
								"balloonText": "x:[[x]] y:[[y]]",
								"bullet": "round",
								"minBulletSize": 10,
								"maxBulletSize": 10,
								"lineAlpha": 0,
								"balloonFunction": vm.balloonFunction,
								"xField": "primaryChartValue",
								"yField": "secondaryChartValue",
								"lineColor": vm.color.foreground1,
								"fillAlphas": 0
							}]
						});
					}
				}
			}
			else {
				vm.noDataAvailable = true;
			}
			vm.hideProgressBar = true;

			////////////////////////////////////////////////////////////////////////////////////
			// The following needs to be done at this point because custom benchmark information
			// is not available prior to this point.

			// update primary column header in details view (will always be benchmarkUnit)
			vm.detailsViewPrimaryColumnHeader = vm.benchmarkUnit;
			vm.membersGrid.columns[1].title = vm.detailsViewPrimaryColumnHeader;

			if (vm.type.substr(0, 9) === 'benchmark') {
				setCustomBenchmarkTitles();
			}

			setCardTitles();
		}


		/**
		 * Set titles and labels specific to custom benchmarks
		 */
		function setCustomBenchmarkTitles() {
			if (vm.benchmarkFactorUnit) {
				vm.valueTypePerBenchmark += '/' + vm.benchmarkFactorUnit;
			}

			vm.primaryAxisLabel = vm.benchmarkUnit;
			if (vm.scatterPlot) {
				vm.primaryBalloonLabel = vm.valueTypePerBenchmark;
				vm.scatterPlot.xAxes[0].title = vm.primaryAxisLabel;
				// refresh x-axis title
				vm.scatterPlot.validateNow();
			}
		}


		/**
		 * Set card titles for median card and total card
		 */
		function setCardTitles() {
			var medianTitle = vm.valueTypePerBenchmark;
			if (vm.benchmarkUnit) {
				medianTitle += ' (' + $translate.instant(vm.benchmarkUnit) + ')';
			}
			vm.medianCardTitle = medianTitle;
			vm.totalCardTitle = $translate.instant("Total cost");
		}


		/**
		 * Callback function called when user updates filters.
		 *
		 * @param {BenchmarkFilters} benchmarkFilters
		 */
		function updateFiltersAndRefresh(benchmarkFilters) {
			vm.selectedDataView = benchmarkFilters.dataView;

			vm.selectedCommodityId = benchmarkFilters.commodityId;
			vm.selectedCommodityCategoryId = benchmarkFilters.commodityCategoryId;

			setSelectedPeriod(benchmarkFilters.periodType, benchmarkFilters.userDefinedRangeStartPeriod, benchmarkFilters.userDefinedRangeEndPeriod);
			vm.showExcluded = benchmarkFilters.showExcludedMembers;
			vm.showZeroAverages = benchmarkFilters.showZeroAverages;

			refresh();
		}


		function excludeMember(memberId) {
			if (vm.groupType == "placeGroup") {
				apiResource.group().placeGroupMembers().update({ placeGroupId: vm.groupId, memberId: memberId }, { includeInCharts: false }, function (result) {
					// Since we're not showing excluded members when you remove one you have to refresh
					// If we are showing excluded and you remove one nothing will change after a refresh
					if (!vm.showExcluded) {
						refresh();
					} else {
						// Find the member and update it's includeInCharts setting to update the icon
						// since we are not refreshing the whole set
						setMemberIncludeInChartsStatus(memberId, false);
					}
				});
			} else {
				apiResource.group().meterGroupMembers().update({ meterGroupId: vm.groupId, memberId: memberId }, { includeInCharts: false }, function (result) {
					// Since we're not showing excluded members when you remove one you have to refresh
					// If we are showing excluded and you remove one nothing will change after a refresh
					if (!vm.showExcluded) {
						refresh();
					} else {
						// Find the member and update it's includeInCharts setting to update the icon
						// since we are not refreshing the whole set
						setMemberIncludeInChartsStatus(memberId, false);
					}
				});
			}

		}

		function includeMember(memberId) {
			if (vm.groupType == "placeGroup") {
				apiResource.group().placeGroupMembers().update({ placeGroupId: vm.groupId, memberId: memberId }, { includeInCharts: true }, function (result) {
					// Find the member and update it's includeInCharts setting to update the icon
					// No need to call refresh since in order to do this action excluded members must already be shown and included
					setMemberIncludeInChartsStatus(memberId, true);
				});
			} else {
				apiResource.group().meterGroupMembers().update({ meterGroupId: vm.groupId, memberId: memberId }, { includeInCharts: true }, function (result) {
					// Find the member and update it's includeInCharts setting to update the icon
					// No need to call refresh since in order to do this action excluded members must already be shown and included
					setMemberIncludeInChartsStatus(memberId, true);
				});
			}

		}

		function setMemberIncludeInChartsStatus(memberId, includeInCharts) {
			_.find(vm.model.results, function (item) {
				return item.memberId === memberId;
			}).includeInCharts = includeInCharts;
		}

		/**
		 * Construct title for main chart.
		 * Shows billing period range, commodity (if not "all"), and dataView (Actual/Cal/Norm)
		 */
		function getChartTitle() {
			vm.title = '';
			if (vm.selectedPeriod && (vm.selectedCommodityId != null || vm.selectedCommodityCategoryId != null) && vm.selectedDataView) {
				var customRangeOption = 4;
				var billingPeriodRange = vm.selectedPeriod.value !== customRangeOption
					? vm.selectedPeriod.text
					: $filter("monthYear")(vm.customPeriodStart) + '\u2013' + $filter("monthYear")(vm.customPeriodEnd);
				var commodityDisplay = '';

				if (isCommoditySelected()) {
					if (vm.availableCommodities) {
						var commodityIndex = _.findIndex(vm.availableCommodities, function (commodity) {
							return commodity.commodityId === vm.selectedCommodityId;
						});
						if (commodityIndex === -1) {
							commodityIndex = 0;
						}
						var currentCommodity = vm.availableCommodities[commodityIndex];
						commodityDisplay = vm.selectedCommodityId !== 0
							? '/ ' + currentCommodity.commodityInfo + ' ' + $translate.instant('only')
							: '';
					}
				} else {
					if (vm.availableCommodityCategories) {
						var commodityCategoryInfo = vm.availableCommodityCategories.get(vm.selectedCommodityCategoryId);
						if (commodityCategoryInfo) {
							commodityDisplay = '/ ' + commodityCategoryInfo + ' ' + $translate.instant('only');
						}
					}
				}

				vm.title = billingPeriodRange + ' ' + commodityDisplay + ' (' + $translate.instant('BenchmarkDataView_' + vm.selectedDataView) + ')';
			}
		}

		/**
		 * Used to determine if a commodity or commodity category is selected in the commodity filter
		   * The display preferences returns from the me api as zero for both commodity and commodity category
		   * when not set rather than null, but zero is valid for a commodity id since we use that for the "All" option
		   * Zero for commodity category is not valid so we can use that to determine if a commodity category is selected
		   */
		function isCommoditySelected() {
			return vm.selectedCommodityCategoryId === 0 || vm.selectedCommodityCategoryId === null;
		}

		function isCommodityAvailable(commodityId) {
			return _.find(vm.availableCommodities, function (commodity) {
				return commodity.commodityId === commodityId;
			});
		}

		function isCommodityCategoryAvailable(commodityCategoryId) {
			return vm.availableCommodityCategories.has(commodityCategoryId);
		}

		function checkForOutdatedSettingsAndContinue() {
			var settings = {
				preference: {
					groupDisplaySetting: {}
				}
			};
			var updateMeSettings = false;
			if (isCommoditySelected()) {
				if (!isCommodityAvailable(vm.selectedCommodityId)) {
					vm.selectedCommodityId = 0;
					settings.preference.groupDisplaySetting.commodityId = 0;
					updateMeSettings = true;
				}
			} else {
				if (!isCommodityCategoryAvailable(vm.selectedCommodityCategoryId)) {
					vm.selectedCommodityCategoryId = 0;
					settings.preference.groupDisplaySetting.commodityCategoryId = 0;
					updateMeSettings = true;
				}
			}

			if (updateMeSettings) {
				userService2.updateUserNg1(settings).then(function () {
					refreshAndSetupView();
				}, function () {
					console.error("Error updating user settings", error);
				});
			} else {
				refreshAndSetupView();
			}
		}

		function refreshAndSetupView() {
			refresh();

			if (angular.isUndefined($state.queryParams.view)) {
				changeView("desc");
			} else {
				setupInternalState($state.queryParams.view);
			}
		}

	}
})();

﻿(function () {
    'use strict';

    angular
        .module('groupsModule')
        .controller('meterCategoriesController', MeterCategoriesController);

    MeterCategoriesController.$inject = ['apiResource', '$translate', '$state', '$q', 'confirmationService', 'userService', '$dialog'];

    function MeterCategoriesController(apiResource, $translate, $state, $q, confirmationService, userService, $dialog) {
        var vm = this;
        vm.categoryId = $state.params.categoryId;

        vm.automaticTag = [{ label: 'automatic', type: 'accent' }];
        vm.manualTag = [{ label: 'manual', type: 'warning' }];

        vm.hasGroupEditPermission = userService.userHasPermission("BuildingAndMeterGroupsEdit");
        vm.hasGroupDeletePermission = userService.userHasPermission("BuildingAndMeterGroupsDelete");
        vm.hasGroupCreatePermission = userService.userHasPermission("BuildingAndMeterGroupsCreate");

        vm.autoGroup = false;
        vm.groupsGrid = {
            dataSource: {
                sort: [
                    { field: "meterGroupInfo", dir: "asc" }
                ],
                pageable: false
            },
            scrollable: false,
            pageable: false,
            groupable: false,
            navigatable: false,
            functions: {
            },
            columns: [
                {
                    field: "meterGroupCategory.meterGroupCategoryCode",
                    hidden: true
                },
                {
                    field: "meterGroupInfo",
                    title: "MeterGroup_SC",
                    template: "<a href='groups/metergroup/#=meterGroupId#'>#:meterGroupInfo#</a>",
                    headerAttributes: {
                        class: 'border-left-0'
                    }
                },
                {
                    field: "visibleMemberCount",
                    title: "Members",
                    attributes: {
                        "class": "text-right"
                    },
                    headerAttributes: {
                        "class": "text-right"
                    }
                },
                {
                    field: "userDefinedAutoGroup",
                    title: "Type",
                    template: function (e) {
                        if (e.userDefinedAutoGroup) {
                            return "<ec-tags [tags]='grid.controller.automaticTag' class='mb-n2 mt-n2'></ec-tags>";
                        }
                        return "<ec-tags [tags]='grid.controller.manualTag' class='mb-n2 mt-n2'></ec-tags>";
                    }
                },
                {
                    field: "lastUpdated",
                    title: "Updated",
                    template: "#= lastUpdated ? moment(lastUpdated).format('MM/DD/YYYY') : '' #"
                },
                {
                    headerAttributes: { "class": "ec-grid-actions" },
                    attributes: { "class": "ec-grid-actions" },
                    template: function (e) {
                        if (!e.autoGroup) {
                            return "<button id='deleteMeterGroupBtn_" + e.meterGroupId + "'" +
                                   "        ng-if='grid.controller.hasGroupDeletePermission'" +
                                   "        class='ec-btn-icon btn btn-secondary'" +
                                   "        tooltip data-toggle='tooltip' data-placement='left'" +
                                   "        title='{{ \"DeleteMeterGroup_SC\" | translate}}'" +
                                   "        ng-click='grid.controller.deleteGroup(" + e.meterGroupId + ")'>" +
                                   "            <i class='ec-icon icon-delete'></i>" +
                                   "</button>" +
                                   "<button id='editMeterGroupBtn_" + e.meterGroupId + "'" +
                                   "        ng-if='grid.controller.hasGroupEditPermission'" +
                                   "        name='edit_" + kendo.htmlEncode(e.meterGroupInfo) + "'" +
                                   "        class='ec-btn-icon btn btn-secondary'" +
                                   "        tooltip data-toggle='tooltip' data-placement='left'" +
                                   "        title='{{ \"EditMeterGroup_SC\" | translate}}'" +
                                   "        ng-click='grid.controller.manageMeterGroup(" + e.meterGroupId + ")'>" +
                                   "            <i class='ec-icon icon-edit'></i>" +
                                   "</button>";
                        } else {
                            return "";
                        }
                    },
                    headerTemplate: function () {
                        if (!vm.autoGroup) {
                            return "<button class='ec-btn-icon btn btn-secondary'" +
                                   "        ng-if='grid.controller.hasGroupEditPermission'" +
                                   "        ng-click='grid.controller.refreshGroups()'" +
                                   "        tooltip data-toggle='tooltip' data-placement='left'" +
                                   "        title='{{ \"Refresh group members\" | translate}}'>" +
                                   "            <i class='ec-icon icon-refresh'></i>" +
                                   "</button>" +
                                   "<button id='addMeterGroupBtn'" +
                                   "        ng-if='grid.controller.hasGroupCreatePermission'" +
                                   "        class='ec-btn-icon btn btn-secondary'" +
                                   "        tooltip data-toggle='tooltip' data-placement='left'" +
                                   "        title='{{ \"AddNewMeterGroup_SC\" | translate}}'" +
                                   "        ng-click='grid.controller.manageMeterGroup()'>" +
                                   "            <i class='ec-icon icon-add'></i>" +
                                   "</button>";
                        }
                        else {
                            return "";
                        }
                    }
                }
            ]
        };

        function returnPromises() {
            var category = apiResource.group().meterGroupCategory().get({ meterGroupCategoryId: vm.categoryId }, function (data) {
                vm.category = data;
            });

            var groups = apiResource.group().meterGroup().query({ filter: "meterGroupCategoryId equals '" + vm.categoryId + "'" }, function (data) {
                vm.groups = data;
            }, function () {
                vm.groupsGrid.dataSource.data = [];
            });

            return [category.$promise, groups.$promise];
        }

        vm.getGroupsData = function() {
            $q.all(returnPromises()).then(function () {
                vm.groupsGrid.dataSource.data = _.forEach(vm.groups, function (n) {
                    if (n.autoGroup) {
                        n.meterGroupInfo = $translate.instant(n.meterGroupInfo);
                    }

                    // We want to show the count of members that are visible to the user
                    if (n.limitMembersByTopmost) {
                        n.visibleMemberCount = n.memberCountWithTopmost;
                    } else {
                        n.visibleMemberCount = n.memberCount;
                    }

                    return n;
                });
                vm.memberCount = vm.groups.length;
                vm.groupsGrid.headerCount = vm.memberCount;
                vm.autoGroup = vm.category.autoGroup;
                // can't add groups to autogroup categories, remove the button
                if (vm.autoGroup) {
                    vm.groupsGrid.columns[5].headerAttributes = { "class": "ec-grid-actions" };
                }

                vm.isOutsideLoading = false;
            });
        };

        (function constructor() {

            vm.getGroupsData();

            vm.refreshGroups = function () {
                vm.isOutsideLoading = true;
                vm.groupsGrid.dataSource.data = [];

                apiResource.group().meterGroupUpdateAllUserAutoGroups().save(function (data) {
                    vm.getGroupsData();
                });
            };

            vm.manageMeterGroup = function (groupId) {
                var context = {
                    groupType: 'Meter',
                    groupId: groupId
                };

                $dialog.openDialog('manage-group', 'xlarge', context)
                    .then(reloadGridIfSaved)
                    .catch(alertApiFailure);
            }

            // Click handler when user deletes a meter group
            vm.deleteGroup = function(meterGroupId) {

                confirmationService.confirmation($translate.instant("DeleteMeterGroup_SC"), $translate.instant("Are you sure?")).then(function (result) {

                    // User doesn't want to continue
                    if (!result) {
                        return;
                    }

                    // User wants to continue - call the DELETE group API
                    apiResource.group().meterGroup().delete({ meterGroupId: meterGroupId }, reloadGrid, alertApiFailure);
                });
            };

        })();

        function reloadGridIfSaved(result) {
            if (result.save) {
               reloadGrid();
            }
        }

        function reloadGrid() {
            vm.isOutsideLoading = true;
            vm.groupsGrid.dataSource.data = [];
            vm.getGroupsData();
        }

        function alertApiFailure(error) {
            if (error && error.data && error.data.status && error.data.status.message) {
                // TODO: finish user assistance layer for API failures on edit/delete
                alert(error.data.status.message);
            }
        }

    }
})();

﻿(function () {
    'use strict';

    angular
        .module('groupsModule')
        .controller('meterGroupMembersController', MeterGroupMembersController);

    MeterGroupMembersController.$inject = ['$state', 'apiResource', 'filterHelper', '$translate', '$q', 'runtimeService', 'userService', 'meterIconPipe', '$scope', 'placeRoutePipe', 'placeTypeIconPipe'];

    function MeterGroupMembersController($state, apiResource, filterHelper, $translate, $q, runtimeService, userService, meterIconPipe, $scope, placeRoutePipe, placeTypeIconPipe) {
        var vm = this;

		// Clear event listeners when the object is destroyed.
		$scope.$on("$destroy", function () {
			$state.unsubscribeFromEvent('groupsUpdated', reloadData);
        });

        vm.group = { userDefinedAutoGroup: false, autoGroup: false };
        vm.groupId = $state.params.groupId;
        vm.grid = {
            dataSource: {
                sort: [
                    { field: "meterDisplay", dir: "asc" }
                ],
                pageable: false,
                group: { field: "excludeInCharts" }
            },
            sortable: true,
            scrollable: false,
            columns: [
                {
                    headerAttributes: {
                        class: 'border-left-0'
                    },
                    title: "Meter",
                    template: "<div class='d-flex'><i class='ec-icon flex-shrink mr-2 #:commodityCode#'></i><a href='#:link#'>#:meterDisplay#</a></div>"
                },
                {
                    title: "ParentLocation_SC",
                    template: "<div class='d-flex'><i class='ec-icon flex-shrink mr-1 #:parentPlaceIcon#'></i><a href='#:parentPlaceLink#'>#:parentPlaceDisplay#</a></div>"
                },
                {
                    field: "active",
                    title: "Active",
                    template: "<i class='ec-icon ec-icon-xs mx-1 #=active == true  ? 'icon-check' : ''#'></i>"
                },
                {
                    field: "excludeInCharts",
                    title: "IncludedInBenchmarks_SC",
                    template: "<i class='ec-icon ec-icon-xs mx-1 #=includeInCharts == true  ? 'icon-check' : ''#'></i>",
                    groupHeaderTemplate: function (e) {
                        return e.value == true ? "<span class='ec-grid-grouping-primary' translate>HiddenFromBenchmarks_SC</span><span class='ml-auto ec-grid-actions' ng-if='grid.controller.buildingAndMeterGroupsEdit'><button tooltip data-toggle='tooltip' data-placement='left' title='{{ \"ShowAll_TC\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='grid.controller.includeAllMembers()'><i class='ec-icon icon-show'></i></button></span>" : '<span class="ec-grid-grouping-primary" translate>IncludedInBenchmarks_SC</span>';
                    }
                },
				{
				    attributes: {
				        "class": "ec-grid-actions"
				    },
				    template: function (e) {
				        if (!e.includeInCharts) {
				            return "<button ng-if='grid.controller.buildingAndMeterGroupsEdit' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Include member\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='grid.controller.includeMember(" + e.meterId + ")'><i class='ec-icon icon-show'></i></button>";
				        }
				        else {
				            return '';
				        }
				    },
				    headerAttributes: {
				        "class": "ec-grid-actions"
				    },
				    headerTemplate: function () {
				        if (vm.group.userDefinedAutoGroup) {
				            return "<button tooltip data-toggle='tooltip' ng-click='grid.controller.refreshGroups()' data-placement='left' title='{{ \"Refresh members\" | translate}}' class='ec-btn-icon btn btn-secondary'><i class='ec-icon icon-refresh'></i></button>";
                        }
                        else {
                            return "";
                        }
				    }
				}
            ]
        };

        vm.filters = {};

        vm.includeMember = includeMember;
        vm.excludeMember = excludeMember;
        vm.includeAllMembers = includeAllMembers;

        vm.buildingAndMeterGroupsEdit = false;

        (function constructor() {
            // Set Permissions to hide/show buttons
			runtimeService.getConfigData().then(function () {
                vm.buildingAndMeterGroupsEdit = userService.userHasPermission("BuildingAndMeterGroupsEdit");

                loadData();
            });

            vm.refreshGroups = function () {
                vm.hideProgressBar = false;
                vm.grid.dataSource.data = [];

                apiResource.group().meterGroupUpdateUserAutoGroup().save({ meterGroupId: vm.groupId }, function (data) {
                    loadData();
                });
            };

            $state.subscribeToEvent('groupsUpdated', reloadData);
        })();

        function reloadData() {
            vm.hideProgressBar = false;
            loadData();
        }

        function loadData() {
            $q.all(returnPromises()).then(function () {
                vm.hideProgressBar = true;
                vm.grid.dataSource.data = _.forEach(vm.groupMembers, function (n) {
                    n.commodityCode = meterIconPipe.transform(n),
                    n.excludeInCharts = !n.includeInCharts;
                    n.meterDisplay = n.meterInfo + " [" + n.meterCode + "]";
                    n.parentPlaceDisplay = n.place.placeInfo + " [" + n.place.placeCode + "]";
                    n.parentPlaceLink = placeRoutePipe.transformSync(n.place, 'ECAP', ['actual', 'summary'], true);
                    n.parentPlaceIcon = placeTypeIconPipe.transform(n.place.placeType);
                    n.link = "buildings/meter/" + n.meterId + "/actual/summary";
                    return n;
                });
                vm.memberCount = vm.groupMembers.length;
                vm.lastUpdated = moment(vm.group.lastUpdated).isValid() ? moment(vm.group.lastUpdated).fromNow() : '';
            });
        }

        function returnPromises() {
            var group = refreshGroupDetails();

            var groupMembers = apiResource.group().meterGroupMembers().query({ meterGroupId: vm.groupId }, function (meterGroupMembers) {
                vm.groupMembers = meterGroupMembers;
            }, function (error) {
                vm.grid.dataSource.data = [];
                vm.hideProgressBar = true;
            });

            return [group.$promise, groupMembers.$promise];
        }

        function includeMember(memberId) {
            apiResource.group().meterGroupMembers().update({ meterGroupId: vm.groupId, memberId: memberId }, { includeInCharts: true }, function (result) {
                // Find the member and update it's includeInCharts setting to update the icon
                setMemberIncludeInChartsStatus(memberId, true);
            });
        }

        function excludeMember(memberId) {
            apiResource.group().meterGroupMembers().update({ meterGroupId: vm.groupId, memberId: memberId }, { includeInCharts: false }, function (result) {
                // Find the member and update it's includeInCharts setting to update the icon
                setMemberIncludeInChartsStatus(memberId, false);
            });
        }

        function includeAllMembers() {
            apiResource.group().meterGroupIncludeAllMembersInCharts().save({ meterGroupId: vm.groupId }, function (result) {
                // reload the entire datasource so the member "include" indicators update and the last updated time refreshes
                loadData();
            });
        }

        function setMemberIncludeInChartsStatus(memberId, includeInCharts) {
            var member = _.find(vm.grid.dataSource.data, function (item) {
                return item.meterId === memberId;
            });

            member.includeInCharts = includeInCharts;
            member.excludeInCharts = !includeInCharts;

            // refresh "last updated" date
            refreshGroupDetails();
        }

        /** Refresh the details about the group, which we call on initial load and after re-including an item in the group
         * @returns the api resource for the api call, which has a .$promise property
        */
        function refreshGroupDetails() {
            return apiResource.group().meterGroup().get({ meterGroupId: vm.groupId }, function (meterGroup) {
                meterGroup.userDefinedAutoGroupFilters = filterHelper.getSavedFilters(meterGroup.userDefinedAutoGroupFilters);
                vm.lastUpdated = moment(vm.group.lastUpdated).isValid() ? moment(vm.group.lastUpdated).fromNow() : '';
                vm.group = meterGroup;
            });
        }
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('groupsModule')
        .controller('meterGroupsController', MeterGroupsController);

    MeterGroupsController.$inject = ['apiResource', '$translate', 'confirmationService', 'userService', '$dialog', '$state'];

    function MeterGroupsController(apiResource, $translate, confirmationService, userService, $dialog, $state) {
        var vm = this;

        vm.automaticTag = [{ label: 'automatic', type: 'accent' }];
        vm.manualTag = [{ label: 'manual', type: 'warning' }];

        vm.hasGroupEditPermission = userService.userHasPermission("BuildingAndMeterGroupsEdit");
        vm.hasGroupDeletePermission = userService.userHasPermission("BuildingAndMeterGroupsDelete");
        vm.hasGroupCreatePermission = userService.userHasPermission("BuildingAndMeterGroupsCreate");

        vm.groupsGrid = {
            dataSource: {
                sort: {
                    field: "meterGroupInfo", dir: "asc"
                },
                pageable: false,
                group: {
                    field: "categorySortOrder", dir: "asc"
                }
            },
            scrollable: false,
            pageable: false,
            groupable: false,
            navigatable: false,
            functions: {
            },
            columns: [
                {
                    field: "categorySortOrder",
                    hidden: true,
                    groupHeaderTemplate: function (item) {
                        var actions = "";
                        var meterGroup = _.find(vm.groupsGrid.dataSource.data, function (meterGroup) {
                            return meterGroup.categorySortOrder == item.value;
                        });

                        if (!meterGroup.autoGroup) {
                            actions = '<span class="ml-auto ec-grid-action">' +
                                '<ec-button id="editGroupCategory_' + meterGroup.meterGroupCategory.meterGroupCategoryId + '"' +
                                'ng-if="grid.controller.hasGroupEditPermission" class="is-action-icon" type="icon" icon="icon-edit"' +
                                '(clicked)="grid.controller.editGroupCategory(' + meterGroup.meterGroupCategory.meterGroupCategoryId + ')">' +
                                '</ec-button></span>';
                        }

                        return "<a class='ec-grid-grouping-primary' href='groups/metercategory/" + meterGroup.meterGroupCategory.meterGroupCategoryId + "'>" +
                                kendo.htmlEncode(meterGroup.meterGroupCategory.meterGroupCategoryInfo) + "</a>" + actions;
                    }
                },
                {
                    headerAttributes: {
                        class: 'border-left-0'
                    },
                    field: "meterGroupInfo",
                    title: "MeterGroup_SC",
                    template: "<a href='groups/metergroup/#:meterGroupId#'>#:meterGroupInfo#</a>"
                },
                {
                    field: "visibleMemberCount",
                    title: "Members",
                    attributes: {
                        "class": "text-right"
                    },
                    headerAttributes: {
                        "class": "text-right"
                    }

                },
                {
                    field: "userDefinedAutoGroup",
                    title: "Membership",
                    template: function (e) {
                        if (e.userDefinedAutoGroup) {
                            return "<ec-tags [tags]='grid.controller.automaticTag' class='mb-n2 mt-n2'></ec-tags>";
                        }
                        return "<ec-tags [tags]='grid.controller.manualTag' class='mb-n2 mt-n2'></ec-tags>";
                    }
                },
                {
                    field: "lastUpdated",
                    title: "Updated",
                    template: "#= lastUpdated ? moment(lastUpdated).format('MM/DD/YYYY') : '' #"
                },
                {
                    headerAttributes: { "class": "ec-grid-actions" },
                    attributes: { "class": "ec-grid-actions" },
                    template: function (e) {
                        if (!e.autoGroup) {
                            return "<button id='deleteMeterGroupBtn_" + e.meterGroupId + "'" +
                                   "        ng-if='grid.controller.hasGroupDeletePermission'" +
                                   "        class='ec-btn-icon btn btn-secondary'" +
                                   "        tooltip data-toggle='tooltip' data-placement='left'" +
                                   "        title='{{ \"DeleteMeterGroup_SC\" | translate}}'" +
                                   "        ng-click='grid.controller.deleteGroup(" + e.meterGroupId + ")'>" +
                                   "            <i class='ec-icon icon-delete'></i>" +
                                   "</button>" +
                                   "<button id='editMeterGroupBtn_" + e.meterGroupId + "'" +
                                   "        ng-if='grid.controller.hasGroupEditPermission'" +
                                   "        name='edit_" + kendo.htmlEncode(e.meterGroupInfo) + "'" +
                                   "        class='ec-btn-icon btn btn-secondary'" +
                                   "        tooltip data-toggle='tooltip' data-placement='left'" +
                                   "        title='{{ \"EditMeterGroup_SC\" | translate}}'" +
                                   "        ng-click='grid.controller.manageMeterGroup(" + e.meterGroupId + ")'>" +
                                   "            <i class='ec-icon icon-edit'></i>" +
                                   "</button>";
                        } else {
                            return "";
                        }
                    },
                    headerTemplate: "<button class='ec-btn-icon btn btn-secondary'" +
                                    "        ng-if='grid.controller.hasGroupEditPermission'" +
                                    "        ng-click='grid.controller.refreshGroups()'" +
                                    "        tooltip data-toggle='tooltip' data-placement='left'" +
                                    "        title='{{ \"Refresh group members\" | translate}}'>" +
                                    "           <i class='ec-icon icon-refresh'></i>" +
                                    "</button>" +
                                    "<button id='addMeterGroupBtn'" +
                                    "        ng-if='grid.controller.hasGroupCreatePermission'" +
                                    "        class='ec-btn-icon btn btn-secondary'" +
                                    "        tooltip data-toggle='tooltip' data-placement='left'" +
                                    "        title='{{ \"AddNewMeterGroup_SC\" | translate}}'" +
                                    "        ng-click='grid.controller.manageMeterGroup()'>" +
                                    "           <i class='ec-icon icon-add'></i>" +
                                    "</button>"
                }
            ]
        };

        vm.getGroupsData = function () {
            apiResource.group().meterGroup().query({ filter: "" }, function (data) {
                vm.groupsGrid.dataSource.data = _.forEach(data, function (n) {
                    n.categorySortOrder = (n.autoGroup ? "1" : "0") + n.meterGroupCategory.meterGroupCategoryInfo;

                    if (n.autoGroup) {
                        n.meterGroupCategory.meterGroupCategoryInfo = $translate.instant(n.meterGroupCategory.meterGroupCategoryInfo);
                    }

                    // We want to show the count of members that are visible to the user
                    if (n.limitMembersByTopmost) {
                        n.visibleMemberCount = n.memberCountWithTopmost;
                    } else {
                        n.visibleMemberCount = n.memberCount;
                    }

                    vm.isOutsideLoading = false;
                    return n;
                });
            });
        };

        (function constructor() {

            // Get all meter groups filtering out auto group types
            vm.getGroupsData();

            vm.refreshGroups = function () {
                vm.isOutsideLoading = true;
                vm.groupsGrid.dataSource.data = [];

                apiResource.group().meterGroupUpdateAllUserAutoGroups().save(function (data) {
                    vm.getGroupsData();
                });
            };

            vm.manageMeterGroup = function (groupId) {
                var context = {
                    groupType: 'Meter',
                    groupId: groupId
                };

                $dialog.openDialog('manage-group', 'xlarge', context)
                    .then(reloadGridIfSaved)
                    .catch(alertApiFailure);
            }

            vm.deleteGroup = function (meterGroupId) {
                confirmationService.confirmation($translate.instant("DeleteMeterGroup_SC"), $translate.instant("Are you sure?")).then(function (result) {

                    // User doesn't want to continue
                    if (!result) {
                        return;
                    }

                    $state.publishEvent('groupsUpdated'); //refresh the tree in groups-module.component

                    // User wants to continue - call the DELETE group API
                    apiResource.group().meterGroup().delete({ meterGroupId: meterGroupId }, reloadGrid, alertApiFailure);
                });
            };

            vm.editGroupCategory = function(meterGroupCategoryId) {
                var meterGroupCategory = _.find(vm.groupsGrid.dataSource.data, function (meterGroup) {
                    return meterGroup.meterGroupCategory.meterGroupCategoryId === meterGroupCategoryId;
                }).meterGroupCategory;

                $dialog.openDialog('manage-group-category', 400, meterGroupCategory)
                    .then(reloadGridIfSaved)
                    .catch(alertApiFailure);
            };
        })();

        function reloadGridIfSaved(result) {
            if (result.save) {
               $state.publishEvent('groupsUpdated'); //refresh the tree in groups-module.component
               reloadGrid();
            }
        }

        function reloadGrid() {
            vm.isOutsideLoading = true;
            vm.groupsGrid.dataSource.data = [];
            vm.getGroupsData();
        }

        function alertApiFailure(error) {
            if (error && error.data && error.data.status && error.data.status.message) {
                // TODO: finish user assistance layer for API failures on edit/delete
                alert(error.data.status.message);
            }
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('groupsModule')
        .controller('placeCategoriesController', PlaceCategoriesController);

    PlaceCategoriesController.$inject = ['apiResource', '$translate', '$state', '$q', 'confirmationService', 'userService', '$dialog'];

    function PlaceCategoriesController(apiResource, $translate, $state, $q, confirmationService, userService, $dialog) {
        var vm = this;
        vm.categoryId = $state.params.categoryId;

        vm.automaticTag = [{ label: 'automatic', type: 'accent' }];
        vm.manualTag = [{ label: 'manual', type: 'warning' }];

        vm.hasGroupEditPermission = userService.userHasPermission("BuildingAndMeterGroupsEdit");
        vm.hasGroupDeletePermission = userService.userHasPermission("BuildingAndMeterGroupsDelete");
        vm.hasGroupCreatePermission = userService.userHasPermission("BuildingAndMeterGroupsCreate");

        vm.autoGroup = false;
        vm.groupsGrid = {
            dataSource: {
                sort: [
                    { field: "placeGroupInfo", dir: "asc" }
                ],
                pageable: false
            },
            scrollable: false,
            pageable: false,
            groupable: false,
            navigatable: false,
            functions: {
            },
            columns: [
                {
                    field: "placeGroupCategory.placeGroupCategoryCode",
                    hidden: true
                },
                {
                    field: "placeGroupInfo",
                    title: "BuildingGroup_SC",
                    template: "<a href='groups/placegroup/#=placeGroupId#'>#:placeGroupInfo#</a>",
                    headerAttributes: {
                        class: 'border-left-0'
                    }
                },
                {
                    field: "visibleMemberCount",
                    title: "Members",
                    attributes: {
                        "class": "text-right"
                    },
                    headerAttributes: {
                        "class": "text-right"
                    }
                },
                {
                    field: "userDefinedAutoGroup",
                    title: "Type",
                    template: function (e) {
                        if (e.userDefinedAutoGroup) {
                            return "<ec-tags [tags]='grid.controller.automaticTag' class='mb-n2 mt-n2'></ec-tags>";
                        }
                        return "<ec-tags [tags]='grid.controller.manualTag' class='mb-n2 mt-n2'></ec-tags>";
                    }
                },
                {
                    field: "lastUpdated",
                    title: "Updated",
                    template: "#= lastUpdated ? moment(lastUpdated).format('MM/DD/YYYY') : '' #"
                },
                {
                    headerAttributes: { "class": "ec-grid-actions" },
                    attributes: { "class": "ec-grid-actions" },
                    template: function (e) {
                        if (!e.autoGroup) {
                            return "<button id='deleteBuildingGroupBtn_" + e.placeGroupId + "'" +
                                   "        ng-if='grid.controller.hasGroupDeletePermission'" +
                                   "        class='ec-btn-icon btn btn-secondary'" +
                                   "        tooltip data-toggle='tooltip' data-placement='left'" +
                                   "        title='{{ \"DeleteBuildingGroup_SC\" | translate}}'" +
                                   "        ng-click='grid.controller.deleteGroup(" + e.placeGroupId + ")'>" +
                                   "          <i class='ec-icon icon-delete'></i>" +
                                   "</button>" +
                                   "<button id='editBuildingGroupBtn_" + e.placeGroupId + "'" +
                                   "        ng-if='grid.controller.hasGroupEditPermission'" +
                                   "        name='edit_" + kendo.htmlEncode(e.placeGroupInfo) + "'" +
                                   "        class='ec-btn-icon btn btn-secondary'" +
                                   "        tooltip data-toggle='tooltip' data-placement='left'" +
                                   "        title='{{ \"EditBuildingGroup_SC\" | translate}}'" +
                                   "        ng-click='grid.controller.manageBuildingGroup(" + e.placeGroupId + ")'>" +
                                   "          <i class='ec-icon icon-edit'></i>" +
                                   "</button>";
                        }
                        else {
                            return "";
                        }
                    },
                    headerTemplate: function () {
                        if (!vm.autoGroup) {
                            return "<button class='ec-btn-icon btn btn-secondary'" +
                                   "        ng-if='grid.controller.hasGroupEditPermission'" +
                                   "        ng-click='grid.controller.refreshGroups()'" +
                                   "        tooltip data-toggle='tooltip' data-placement='left'" +
                                   "        title='{{ \"Refresh group members\" | translate}}'>" +
                                   "          <i class='ec-icon icon-refresh'></i>" +
                                   "</button>" +
                                   "<button id='addBuildingGroupBtn'" +
                                   "        ng-if='grid.controller.hasGroupCreatePermission'" +
                                   "        ng-click='grid.controller.manageBuildingGroup()'" +
                                   "        class='ec-btn-icon btn btn-secondary'" +
                                   "        tooltip data-toggle='tooltip' data-placement='left'" +
                                   "        title='{{ \"AddNewBuildingGroup_SC\" | translate}}'>" +
                                   "          <i class='ec-icon icon-add'></i>" +
                                   "</button>";
                        }
                        else {
                            return "";
                        }
                    }
                }
            ]
        };

        function returnPromises() {
            var category = apiResource.group().placeGroupCategory().get({ placeGroupCategoryId: vm.categoryId }, function (data) {
                vm.category = data;
            });

            var groups = apiResource.group().placeGroup().query({ filter: "placeGroupCategoryId equals '" + vm.categoryId + "'" }, function (data) {
                vm.groups = data;
            }, function () {
                vm.groupsGrid.dataSource.data = [];
            });

            return [category.$promise, groups.$promise];
        }

        vm.getGroupsData = function() {
            $q.all(returnPromises()).then(function () {
                vm.groupsGrid.dataSource.data = _.forEach(vm.groups, function (n) {
                    if (n.autoGroup) {
                        n.placeGroupInfo = $translate.instant(n.placeGroupInfo);
                    }

                    // We want to show the count of members that are visible to the user
                    if (n.limitMembersByTopmost) {
                        n.visibleMemberCount = n.memberCountWithTopmost;
                    } else {
                        n.visibleMemberCount = n.memberCount;
                    }

                    return n;
                });
                vm.memberCount = vm.groups.length;
                vm.groupsGrid.headerCount = vm.memberCount;
                vm.autoGroup = vm.category.autoGroup;
                // can't add groups to autogroup categories, remove the button
                if (vm.autoGroup) {
                    vm.groupsGrid.columns[5].headerAttributes = { "class": "ec-grid-actions" };
                }

                vm.isOutsideLoading = false;
            });
        };

        (function constructor() {

            vm.getGroupsData();

            vm.refreshGroups = function () {
                vm.isOutsideLoading = true;
                vm.groupsGrid.dataSource.data = [];

                apiResource.group().placeGroupUpdateAllUserAutoGroups().save(function (data) {
                    vm.getGroupsData();
                });
            };

            vm.manageBuildingGroup = function (groupId) {
                var context = {
                    groupType: 'Building',
                    groupId: groupId
                };

                $dialog.openDialog('manage-group', 'xlarge', context)
                    .then(reloadGridIfSaved)
                    .catch(alertApiFailure);
            }


            // Click handler when user deletes a place group
            vm.deleteGroup = function(placeGroupId) {

                confirmationService.confirmation($translate.instant("DeleteBuildingGroup_SC"), $translate.instant("Are you sure?")).then(function (result) {

                    // User doesn't want to continue
                    if (!result) {
                        return;
                    }

                    $state.publishEvent('groupsUpdated'); //refresh the tree in groups-module.component

                    // User wants to continue - call the DELETE group API
                    apiResource.group().placeGroup().delete({ placeGroupId: placeGroupId }, reloadGrid, alertApiFailure);
                });
            };

        })();

        function reloadGridIfSaved(result) {
            if (result.save) {
               reloadGrid();
            }
        }

        function reloadGrid() {
            vm.isOutsideLoading = true;
            vm.groupsGrid.dataSource.data = [];
            vm.getGroupsData();
        }

        function alertApiFailure(error) {
            if (error && error.data && error.data.status && error.data.status.message) {
                // TODO: finish user assistance layer for API failures on edit/delete
                alert(error.data.status.message);
            }
        }

    }
})();

﻿(function () {
    'use strict';

    angular
        .module('groupsModule')
        .controller('placeGroupMembersController', PlaceGroupMembersController);

    PlaceGroupMembersController.$inject = ['$state', 'apiResource', 'filterHelper', '$translate', '$q', 'runtimeService', 'userService', '$scope', 'placeRoutePipe'];

    function PlaceGroupMembersController($state, apiResource, filterHelper, $translate, $q, runtimeService, userService, $scope, placeRoutePipe) {
        var vm = this;

		// Clear event listeners when the object is destroyed.
		$scope.$on("$destroy", function () {
			$state.unsubscribeFromEvent('groupsUpdated', reloadData);
        });

        vm.group = { userDefinedAutoGroup: false, autoGroup: false };
        vm.groupId = $state.params.groupId;
        vm.grid = {
            dataSource: {
                sort: [
                    { field: "placeDisplay", dir: "asc" }
                ],
                pageable: false,
                group: { field: "excludeInCharts" }
            },
            sortable: true,
            scrollable: false,
            columns: [
                {
                    headerAttributes: {
                        class: 'border-left-0'
                    },
                    title: "Building",
                    template: "<div class='d-flex'><i class='ec-icon flex-shrink mr-1 icon-building'></i><a href='#:link#'>#:placeDisplay#</a></div>"
                },
                {
                    title: "ParentLocation_SC",
                    template: "<div class='d-flex'><i class='ec-icon flex-shrink mr-1 icon-organization'></i><a href='#:parentPlaceLink#'>#:parentPlaceDisplay#</a></div>"
                },
                {
                    field: "excludeInCharts",
                    title: "IncludedInBenchmarks_SC",
                    template: "<i class='ec-icon ec-icon-xs mx-1 #=includeInCharts == true  ? 'icon-check' : ''#'></i>",
                    groupHeaderTemplate: function (e) {
                        return e.value == true ? "<span class='ec-grid-grouping-primary' translate>HiddenFromBenchmarks_SC</span><span ng-if='grid.controller.buildingAndMeterGroupsEdit' class='ml-auto ec-grid-actions'><button tooltip data-toggle='tooltip' data-placement='left' title='{{ \"ShowAll_TC\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='grid.controller.includeAllMembers()'><i class='ec-icon icon-show'></i></button></span>" : '<span class="ec-grid-grouping-primary" translate>IncludedInBenchmarks_SC</span>';
                    }
                },
				{
				    attributes: {
				        "class": "ec-grid-actions"
				    },
				    template: function (e) {
				        if (!e.includeInCharts) {
				            return "<button ng-if='grid.controller.buildingAndMeterGroupsEdit' tooltip data-toggle='tooltip' data-placement='left' title='{{ \"Include member\" | translate}}' class='ec-btn-icon btn btn-secondary' ng-click='grid.controller.includeMember(" + e.placeId + ")'><i class='ec-icon icon-show'></i></button>";
				        }
				        else {
				            return '';
				        }
				    },
				    headerAttributes: {
				        "class": "ec-grid-actions"
				    },
				    headerTemplate: function () {
				        if (vm.group.userDefinedAutoGroup) {
				            return "<button tooltip data-toggle='tooltip' ng-click='grid.controller.refreshGroups()' data-placement='left' title='{{ \"Refresh members\" | translate}}' class='ec-btn-icon btn btn-secondary'><i class='ec-icon icon-refresh'></i></button>";
                        }
                        else {
                            return "";
                        }
				    }
				}
            ]
        };
        vm.filters = {};

        vm.includeMember = includeMember;
        vm.excludeMember = excludeMember;
        vm.includeAllMembers = includeAllMembers;

        vm.buildingAndMeterGroupsEdit = false;

        (function constructor() {

            // Set Permissions to hide/show buttons
			runtimeService.getConfigData().then(function () {
                vm.buildingAndMeterGroupsEdit = userService.userHasPermission("BuildingAndMeterGroupsEdit");

                loadData();
            });

            vm.refreshGroups = function () {
                vm.hideProgressBar = false;
                vm.grid.dataSource.data = [];

                apiResource.group().placeGroupUpdateUserAutoGroup().save({ placeGroupId: vm.groupId }, function (data) {
                    loadData();
                });
            };

            $state.subscribeToEvent('groupsUpdated', reloadData);
        })();


        function reloadData() {
            vm.hideProgressBar = false;
            loadData();
        }

        function loadData() {
            $q.all(returnPromises()).then(function () {
                vm.hideProgressBar = true;
                vm.grid.dataSource.data = _.forEach(vm.groupMembers, function (n) {
                    n.excludeInCharts = !n.includeInCharts;
                    n.placeDisplay = n.placeInfo + " [" + n.placeCode + "]";
                    n.parentPlaceDisplay = n.parent.placeInfo + " [" + n.parent.placeCode + "]";
                    n.parentPlaceLink = placeRoutePipe.transformSync(n.parent, 'ECAP', ['actual', 'summary'], true);
                    n.link = placeRoutePipe.transformSync(n, 'ECAP', ['actual', 'summary'], true);
                    return n;
                });
                vm.memberCount = vm.groupMembers.length;
                vm.lastUpdated = moment(vm.group.lastUpdated).isValid() ? moment(vm.group.lastUpdated).fromNow() : '';
            });
        }

        function returnPromises() {
            var group = refreshGroupDetails();

            var groupMembers = apiResource.group().placeGroupMembers().query({ placeGroupId: vm.groupId }, function (placeGroupMembers) {
                vm.groupMembers = placeGroupMembers;
            }, function (error) {
                vm.grid.dataSource.data = [];
                vm.hideProgressBar = true;
            });

            return [group.$promise, groupMembers.$promise];
        }

        function includeMember(memberId) {
            apiResource.group().placeGroupMembers().update({ placeGroupId: vm.groupId, memberId: memberId }, { includeInCharts: true }, function (result) {
                // Find the member and update it's includeInCharts setting to update the icon
                setMemberIncludeInChartsStatus(memberId, true);
            });
        }

        function excludeMember(memberId) {
            apiResource.group().placeGroupMembers().update({ placeGroupId: vm.groupId, memberId: memberId }, { includeInCharts: false }, function (result) {
                // Find the member and update it's includeInCharts setting to update the icon
                setMemberIncludeInChartsStatus(memberId, false);
            });
        }

        function includeAllMembers() {
            apiResource.group().placeGroupIncludeAllMembersInCharts().save({ placeGroupId: vm.groupId }, function (result) {
                // reload the entire datasource so the member "include" indicators update and the last updated time refreshes
                loadData();
            });
        }

        function setMemberIncludeInChartsStatus(memberId, includeInCharts) {
            var member = _.find(vm.grid.dataSource.data, function (item) {
                return item.placeId === memberId;
            });

            member.includeInCharts = includeInCharts;
            member.excludeInCharts = !includeInCharts;

            // refresh "last updated" date
            refreshGroupDetails();
        }

        /** Refresh the details about the group, which we call on initial load and after re-including an item in the group
         * @returns the api resource for the api call, which has a .$promise property
        */
        function refreshGroupDetails(){
            return apiResource.group().placeGroup().get({ placeGroupId: vm.groupId }, function (placeGroup) {
                placeGroup.userDefinedAutoGroupFilters = filterHelper.getSavedFilters(placeGroup.userDefinedAutoGroupFilters);
                vm.group = placeGroup;
                vm.lastUpdated = moment(vm.group.lastUpdated).isValid() ? moment(vm.group.lastUpdated).fromNow() : '';
            });
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('groupsModule')
        .controller('placeGroupsController', PlaceGroupsController);

    PlaceGroupsController.$inject = ['apiResource', '$translate', 'confirmationService', 'userService', '$dialog', '$state'];

    function PlaceGroupsController(apiResource, $translate, confirmationService, userService, $dialog, $state) {
        var vm = this;

        vm.automaticTag = [{ label: 'automatic', type: 'accent' }];
        vm.manualTag = [{ label: 'manual', type: 'warning' }];

        vm.hasGroupEditPermission = userService.userHasPermission("BuildingAndMeterGroupsEdit");
        vm.hasGroupDeletePermission = userService.userHasPermission("BuildingAndMeterGroupsDelete");
        vm.hasGroupCreatePermission = userService.userHasPermission("BuildingAndMeterGroupsCreate");

        vm.groupsGrid = {
            dataSource: {
                sort: {
                    field: "placeGroupInfo", dir: "asc"
                },
                pageable: false,
                group: {
                    field: "categorySortOrder", dir: "asc"
                }
            },
            scrollable: false,
            pageable: false,
            groupable: false,
            navigatable: false,
            functions: {
            },
            columns: [
                {

                    field: "categorySortOrder",
                    hidden: true,
                    groupHeaderTemplate: function (item) {
                        var actions = "";
                        var placeGroup = _.find(vm.groupsGrid.dataSource.data, function (placeGroup) {
                            return placeGroup.categorySortOrder == item.value;
                        });

                        if (!placeGroup.autoGroup) {
                            actions = '<span class="ml-auto ec-grid-action">' +
                                '<ec-button id="editGroupCategory_' + placeGroup.placeGroupCategory.placeGroupCategoryId + '"' +
                                'ng-if="grid.controller.hasGroupEditPermission" class="is-action-icon" type="icon" icon="icon-edit"' +
                                '(clicked)="grid.controller.editGroupCategory(' + placeGroup.placeGroupCategory.placeGroupCategoryId + ')">' +
                                '</ec-button></span>';
                        }

                        return "<a class='ec-grid-grouping-primary' href='groups/placecategory/" + placeGroup.placeGroupCategory.placeGroupCategoryId + "'>" +
                                kendo.htmlEncode(placeGroup.placeGroupCategory.placeGroupCategoryInfo) + "</a>" + actions;
                    }
                },
                {
                    headerAttributes: {
                        class: 'border-left-0'
                    },
                    field: "placeGroupInfo",
                    title: "BuildingGroup_SC",
                    template: "<a href='groups/placegroup/#=placeGroupId#'>#:placeGroupInfo#</a>"
                },
                {
                    field: "visibleMemberCount",
                    title: "Members",
                    attributes: {
                        "class": "text-right"
                    },
                    headerAttributes: {
                        "class": "text-right"
                    }

                },
                {
                    field: "userDefinedAutoGroup",
                    title: "Type",
                    template: function (e) {
                        if (e.userDefinedAutoGroup) {
                            return "<ec-tags [tags]='grid.controller.automaticTag' class='mb-n2 mt-n2'></ec-tags>";
                        }
                        return "<ec-tags [tags]='grid.controller.manualTag' class='mb-n2 mt-n2'></ec-tags>";
                    }
                },
                {
                    field: "lastUpdated",
                    title: "Updated",
                    template: "#= lastUpdated ? moment(lastUpdated).format('MM/DD/YYYY') : '' #"
                },
                {
                    headerAttributes: { "class": "ec-grid-actions" },
                    attributes: { "class": "ec-grid-actions" },
                    template: function (e) {
                        if (!e.autoGroup) {
                            return "<button id='deleteBuildingGroupBtn_" + e.placeGroupId + "'" +
                                   "        ng-if='grid.controller.hasGroupDeletePermission'" +
                                   "        class='ec-btn-icon btn btn-secondary'" +
                                   "        tooltip data-toggle='tooltip' data-placement='left'" +
                                   "        title='{{ \"DeleteBuildingGroup_SC\" | translate}}'" +
                                   "        ng-click='grid.controller.deleteGroup(" + e.placeGroupId + ")'>" +
                                   "            <i class='ec-icon icon-delete'></i>" +
                                   "</button>" +
                                   "<button id='editBuildingGroupBtn_" + e.placeGroupId + "'" +
                                   "        ng-if='grid.controller.hasGroupEditPermission'" +
                                   "        name='edit_" + kendo.htmlEncode(e.placeGroupInfo) + "'" +
                                   "        class='ec-btn-icon btn btn-secondary'" +
                                   "        tooltip data-toggle='tooltip' data-placement='left'" +
                                   "        title='{{ \"EditBuildingGroup_SC\" | translate}}'" +
                                   "        ng-click='grid.controller.manageBuildingGroup(" + e.placeGroupId + ")'>" +
                                   "            <i class='ec-icon icon-edit'></i>" +
                                   "</button>";
                        }
                        else {
                            return "";
                        }
                    },
                    headerTemplate: "<button class='ec-btn-icon btn btn-secondary'" +
                                    "        ng-if='grid.controller.hasGroupEditPermission'" +
                                    "        ng-click='grid.controller.refreshGroups()'" +
                                    "        tooltip data-toggle='tooltip' data-placement='left'" +
                                    "        title='{{ \"Refresh group members\" | translate}}'>" +
                                    "           <i class='ec-icon icon-refresh'></i>" +
                                    "</button>" +
                                    "<button id='addBuildingGroupBtn'" +
                                    "        ng-if='grid.controller.hasGroupCreatePermission'" +
                                    "        class='ec-btn-icon btn btn-secondary'" +
                                    "        tooltip data-toggle='tooltip' data-placement='left'" +
                                    "        title='{{ \"AddNewBuildingGroup_SC\" | translate}}'" +
                                    "        ng-click='grid.controller.manageBuildingGroup()'>" +
                                    "           <i class='ec-icon icon-add'></i>" +
                                    "</button>"
                }
            ]
        };

        vm.getGroupsData = function() {
            apiResource.group().placeGroup().query({ filter: "" }, function (data) {
                vm.groupsGrid.dataSource.data = _.forEach(data, function (n) {
                    n.categorySortOrder = (n.autoGroup ? "1" : "0") + n.placeGroupCategory.placeGroupCategoryInfo;

                    if (n.autoGroup) {
                        n.placeGroupCategory.placeGroupCategoryInfo = $translate.instant(n.placeGroupCategory.placeGroupCategoryInfo);
                    }

                    // We want to show the count of members that are visible to the user
                    if (n.limitMembersByTopmost) {
                        n.visibleMemberCount = n.memberCountWithTopmost;
                    } else {
                        n.visibleMemberCount = n.memberCount;
                    }

                    vm.isOutsideLoading = false;
                    return n;
                });
            });
        };

        (function constructor() {
            // Get all place groups filtering out auto group types
            vm.getGroupsData();

            vm.refreshGroups = function () {
                vm.isOutsideLoading = true;
                vm.groupsGrid.dataSource.data = [];

                apiResource.group().placeGroupUpdateAllUserAutoGroups().save(function (data) {
                    vm.getGroupsData();
                });
            };

            vm.manageBuildingGroup = function (groupId) {
                var context = {
                    groupType: 'Building',
                    groupId: groupId
                };

                $dialog.openDialog('manage-group', 'xlarge', context)
                    .then(reloadGridIfSaved)
                    .catch(alertApiFailure);
            }

            // Click handler when user deletes a place group
            vm.deleteGroup = function(placeGroupId) {
                confirmationService.confirmation($translate.instant("DeleteBuildingGroup_SC"), $translate.instant("Are you sure?")).then(function (result) {

                    // User doesn't want to continue
                    if (!result) {
                        return;
                    }

                    $state.publishEvent('groupsUpdated'); //refresh the tree in groups-module.component

                    // User wants to continue - call the DELETE group API
                    apiResource.group().placeGroup().delete({ placeGroupId: placeGroupId }, reloadGrid, alertApiFailure);
                });
            };

            vm.editGroupCategory = function(placeGroupCategoryId) {
                var placeGroupCategory = _.find(vm.groupsGrid.dataSource.data, function (placeGroup) {
                    return placeGroup.placeGroupCategory.placeGroupCategoryId === placeGroupCategoryId;
                }).placeGroupCategory;

                $dialog.openDialog('manage-group-category', 400, placeGroupCategory)
                    .then(reloadGridIfSaved)
                    .catch(alertApiFailure);
            };
        })();

        function reloadGridIfSaved(result) {
            if (result.save) {
               $state.publishEvent('groupsUpdated'); //refresh the tree in groups-module.component
               reloadGrid();
            }
        }

        function reloadGrid() {
            vm.isOutsideLoading = true;
            vm.groupsGrid.dataSource.data = [];
            vm.getGroupsData();
        }

        function alertApiFailure(error) {
            if (error && error.data && error.data.status && error.data.status.message) {
                // TODO: finish user assistance layer for API failures on edit/delete
                alert(error.data.status.message);
            }
        }


    }
})();

﻿(function () {
    'use strict';

    angular
        .module('loginModule')
        .controller('loginController', LoginController);

    LoginController.$inject = ['$translate', '$window', 'translationHelper'];

    function LoginController($translate, $window, translationHelper) {
        var vm = this;

        vm.language = $translate.use() || "en_US"; // default language to English if it isn't set (happens when cookie is blank)

        vm.languageChange = function () {
            translationHelper.changeLanguage(vm.language, false);
        };

        (function constructor() {

            // If we have a partialUrl (URL that is return due an invalid cookie),
            // generate the hash part for NG1 redirects
            if (angular.element('#partialUrl').val() != "") {
                var redirectUrl = angular.element('#partialUrl').val() + $window.location.hash;
                angular.element('#redirectUrl').val(redirectUrl);
            }

        })();
    }
})();
(function() {
  'use strict';

  angular.module('app').component('ng1Compile', {
    template:'',
    controller: ng1CompileController,
    controllerAs: '$ctrl',
    bindings: {
      html: '<'
    }
  });
  
  function ng1CompileController($scope, $element, $compile) {
    var ctrl = this;
  
    ctrl.$onInit = function(){
      $element.html(ctrl.html);
      $compile($element.contents())($scope);
    }
  }
})();

(function() {
  'use strict';

  angular.module('app').component('ng1View', {
    template:'',
    controller: ng1ViewController,
    controllerAs: '$ctrl',
    bindings: {
      view: '<',
    }
  });
  
  /**
   * This directive functions as an ng1 router outlet for ng5 routes that render
   * an ng1 view. Takes in a view property with the templateUrl and controller name
   * and then compiles the view and appends it to the DOM.
   */
  function ng1ViewController($rootScope, $controller, $element, $templateRequest, $compile) {
    var ctrl = this;
  
    ctrl.$onInit = function(){
      var templateUrl = ctrl.view.template;
      var controllerName = ctrl.view.controller;
  
      $templateRequest(templateUrl).then(function(template) {
        var controllerParts = controllerName.split('as');
        var controllerAs = controllerParts[1].trim();
        
        ctrl.locals = {$template: template};
        $element.html(ctrl.locals.$template);
    
        var link = $compile($element.contents());
    
        if (controllerName) {
          ctrl.locals.$scope = $rootScope.$new();
  
          var controller = $controller(controllerName, ctrl.locals);
          if (controllerAs) {
            ctrl.locals.$scope[controllerAs] = controller;
          }
          $element.data('$ngControllerController', controller);
          $element.children().data('$ngControllerController', controller);
        }
  
        link(ctrl.locals.$scope);
      }).catch(function(err) {
        console.error('Failed to compile AngularJS view', err);
      });
    }

    ctrl.$onDestroy = function(){
      if(ctrl.locals && ctrl.locals.$scope){
        ctrl.locals.$scope.$destroy();
      }
    };
  }
})();

(function () {
  'use strict';
  angular.module('ngWrapperModule', [
    'app',
    'kendo.directives',
    'dashboardModule',
    'buildingsModule',
    'accountsModule',
    'billsModule',
    'vendorsModule',
    'groupsModule',
    'administrationModule'
  ])
    .config(Config)

  Config.$inject = ['$locationProvider'];

  function Config($locationProvider) {
    $locationProvider.html5Mode(true);
  }
})();
﻿(function () {
    'use strict';

    angular
        .module('app')
        .controller('formAndControlsController', FormAndControlsController);

    FormAndControlsController.$inject = ['$timeout', '$templateCache', '$q', 'glazeService', 'apiResource', 'customValidator', '$state'];

    function FormAndControlsController($timeout, $templateCache, $q, glazeService, apiResource, customValidator, $state) {
        var vm = this;
        vm.refreshCommodity = refreshCommodity;
        vm.toggleAddVendorForm = toggleAddVendorForm;
        vm.reload = reload;

        vm.controls = {
            disabledOptionalWithValueEcTextBox: "Value set",
            requiredWithValueEcNumericBox: 12345,
            selected: true,
            notSelected: false,
            enabledToggle: "1",
            disabledToggle: "0",
            disabledOptionalWithPlaceholderEcDatePicker: "01/01/2001",
            disabledOptionalWithValueAutoComplete: "Item 1",
            disabledOptionalWithValuesMultiSelect: [{ text: "Item 1", value: 1 }, { text: "Item 2", value: 2 }],
            disabledOptionalFooterAddItemComboBox: { text: "Item 1", value: 1 }
        };

        vm.toggles = [
            { label: "yes", value: "1" },
            { label: "no", value: "0" }
        ];

        vm.validationOptions = {
            validateOnBlur: false,
            messages: {
                required: function (input) {
                    var optionalParam = {};
                    return customValidator.validationMessages.requiredMessage(input, optionalParam);
                },
                customValidation: function (input) {
                    var optionalParam = {};
                    return customValidator.validationMessages.customValidationMessage(input, optionalParam);
                }
            },
            rules: {
                customValidation: function (input) {
                    var optionalParam = {};
                    return customValidator.validations.customValidation(input, optionalParam);
                }
            }
        };

        vm.showAddHeader = showAddHeader;
        vm.validateItem = validateItem;
        vm.loadVendorList = true;
        vm.headerTemplate = $templateCache.get('headerTemplate.html');
        vm.footerTemplate = $templateCache.get('footerTemplate.html');
        vm.noDataTemplate = $templateCache.get('noDataTemplate.html');

        vm.currentState = $state.current;

        (function constructor() {
            glazeService.primaryAction = validate;
            glazeService.secondaryAction = glazeService.hideGlaze;
            initialFormLoad();
        })();

        function initialFormLoad() {
            var awaiter = new PromiseAwaiter();

            awaiter.add(apiResource.commodity().commodity().query(function (results) {
                vm.commodityList = results;
            }));

            vm.vendorList = new kendo.data.DataSource({
                serverFiltering: true,
                transport: {
                    read: function (options) {
                        if (options) {
                            if (vm.loadVendorList) {
                                options.success([]);
                            } else {
                                var params = {};
                                if (vm.newComboBox && vm.newComboBox.text() !== "") {
                                    params.filter = "vendorInfo like '" + vm.newComboBox.text() + "'";
                                }
                                apiResource.vendor().vendor().query(params, function (results, headers) {
                                    vm.vendorHeaders = headers();
                                    if (parseInt(vm.vendorHeaders.totalpages) <= 1) {
                                        vm.vendorHeaders.pagesize = vm.vendorHeaders.totalnumberofrecords;
                                    }
                                    options.success(results);
                                }, function(err) {
                                    console.error(err);
                                });
                            }
                        }
                    }
                }
            });

            makePagedDataSource();

            glazeService.showLoading(awaiter);
        }

        function makePagedDataSource() {
            vm.multiPageDataSourceLoading = true;

            var items = [];
            for (var count = 1; count <= 250; count++) {
                items.push({
                    text: "Item " + count,
                    value: count
                });
            }

            vm.selectOptions = {
                dataSource: items
            };

            vm.multiPageDataSource = new kendo.data.DataSource({
                data: items
            });

            $timeout(function () {
                // vm.requiredFooterAddItemComboBox.setFooter({
                //     totalnumberofrecords: 300,
                //     pagesize: 250
                // });

                vm.multiPageDataSourceLoading = false;
            }, 100);
        };

        function validate() {
            if (vm.validator.validate()) {
                save();
            }
            else {
                glazeService.showErrorMessage();
            }
        }

        function save() {
            glazeService.setSavingVisibility(true);

            $timeout(function () {
                glazeService.hideGlaze();
            }, 500);
        }

        function showAddHeader() {
            vm.requiredFooterAddItemComboBox.enable(false);
            vm.addItemShown = true;
            vm.requiredFooterAddItemComboBox.hideList();
        }

        function validateItem() {
            // event.preventDefault();

            vm.addItemErrorMessage = "";

            if (vm.addItemValidator.validate()) {
                vm.newItemSaving = true;

                $timeout(function () {
                    vm.newItemSaving = false;

                    toggleAddVendorForm();

                }, 500);
            }
            else {
                vm.addItemErrorMessage = customValidator.validationMessages.genericHeaderMessage();
            }
        }

        function refreshCommodity(id) {
            vm.selectedCommodity = _.find(vm.commodityList, function (c) { return c.commodityId == id; });
        }

        /**
         * Toggle the add item form in the vendor combobox
         */
        function toggleAddVendorForm() {
            vm.loadVendorList = !vm.loadVendorList;
            vm.vendorList.fetch();

            // Toggle combobox headers and form
            vm.showAddVendorForm = !vm.showAddVendorForm
        }

        function reload() {
            $state.reload();
        }
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('vendorsModule')
        .controller('commodityMetersController', CommodityMetersController);

    CommodityMetersController.$inject = ['apiResource', '$state', '$translate', 'powerviewHelper', 'placeRoutePipe'];

    /**
    * Controller for the Commodity Meters Powerview
    */
    function CommodityMetersController(apiResource, $state, $translate, powerviewHelper, placeRoutePipe) {
        var vm = this;
        
        ////////////////////////////////////////////////////////////////////////
        // TODO: remove after ECAP-3957 is done
        vm.converted = true;
        ////////////////////////////////////////////////////////////////////////

        // Initialize the controller when added to the DOM
        init();

        /**
        * Constructor function to be called when the controller is ready to load
        */
        function init() {
            vm.id = $state.params.commodityId;
            vm.status = 'pending';
            vm.message = 'Loading';

            // Default our filter to commodity since that's always a given for this page.  We'll have to decide if we should also tie in
            // vendor based on the state params
            var filter = "commodityId equals '" + vm.id + "'";

            var vendorId = $state.params.vendorId;
            if (vendorId) {
                filter += " and vendorId equals '" + vendorId + "'";
            }

            apiResource.meter().allMeters().query({ filter: filter }, function (result) {
                setPowerviewProperties(powerviewHelper.getPowerviewProperties({results: result}, true));
                createWidgets();
            }, function (error) {
                setPowerviewProperties(powerviewHelper.getPowerviewProperties());
            });
        }

        /**
         * Sets view properties for the powerview
         * @param {Object} properties - The powerview properties
         */
        function setPowerviewProperties(properties) {
            vm.data = properties.data;
            vm.message = properties.message;
            vm.status = properties.status;
        }

        function createWidgets() {
            vm.widgets = [];

            vm.widgets.push(powerviewHelper.getWidgetDefinition({
                id: "meters",
                type: 'dataGrid',
                class: 'col-12',
                title: $translate.instant('Meters') + ' - ' + vm.data.results.length,
                content: getMetersGrid()
            }));
        }

        /**
        * Generates the defintion for the meters grid
        * @returns {object} - Object that will define the meters grid
        */
        function getMetersGrid() {
            return {
                dataGrid: {
                    dataSource: {
                        sort: [
                            {
                                field: "active", dir: "desc"
                            },
                            {
                                field: "meterInfo", dir: "asc"
                            }
                        ],
                        data: vm.data.results
                    },
                    sortable: {
                        mode: "multiple",
                    },
                    columns: [
                        {
                            field: "meterInfo",
                            title: "Meter name",
                            template: "<a href='buildings/meter/#=meterId#/actual/summary'>#:meterInfo#</a>"
                        },
                        {
                            field: "meterCode",
                            title: "Meter code"
                        },
                        {
                            field: "place.placeInfo",
                            title: "Place name",
                            template: function (dataItem) {
                                var place = dataItem.place;
                                return "<a href='" + placeRoutePipe.transformSync(place, 'ECAP', ['actual', 'summary'], true) + "'>" + kendo.htmlEncode(place.placeInfo) + "</a>";
                            }
                        },
                        {
                            field: "place.placeCode",
                            title: "Place code"
                        },

                        // TODO: Revisit when we do simple rates
                        //{
                        //    field: "rate",
                        //    title: "Rate"
                        //},
                        //{
                        //    field: "rateEffective",
                        //    title: "Rate effective"
                        //},
                        {
                            field: "meterType.meterTypeId",
                            title: "Chargeback",
                            template: "<i class='ec-icon #=meterType.meterTypeId == 6 ? \'icon-check\' : \'\'#'></i>",
                            headerAttributes: {
                                class: 'ec-grid-not-resizable'
                            }
                        },
                        {
                            field: "active",
                            title: "Active",
                            headerAttributes: {
                                class: 'ec-grid-not-resizable'
                            },
                            template: "<i class='ec-icon #=active == true ? 'icon-check' : ''#'></i>"
                        }

                    ]
                }
            };
        }

    }
})();

﻿(function () {
    'use strict';

    angular
        .module('vendorsModule')
        .controller('commodityRateSchedulesController', CommodityRateSchedulesController);

    CommodityRateSchedulesController.$inject = ['apiResource', '$state', '$translate', 'runtimeService', 'confirmationService', 'powerviewHelper', 'gridHelper', 'userService', '$dialog'];

    /**
    * Controller for the Commodity Rate Schedules Powerview
    */
    function CommodityRateSchedulesController(apiResource, $state, $translate, runtimeService, confirmationService, powerviewHelper, gridHelper, userService, $dialog) {
        var vm = this;

        var ADD_NEW_LABEL = 'Add Rate Schedule';

        ////////////////////////////////////////////////////////////////////////
        // TODO: remove after ECAP-3957 is done
        vm.converted = true;
        ////////////////////////////////////////////////////////////////////////

        vm.id = $state.params.commodityId;
        vm.vendorId = $state.params.vendorId;

        vm.addRate = addRate;
        vm.editRate = editRate;
        vm.deleteRate = deleteRate;

        vm.addNew = {
            label: $translate.instant(ADD_NEW_LABEL),
            callback: addRate
        }

        vm.rateSchedulesCreate = false;
        vm.rateSchedulesEdit = false;
        vm.rateSchedulesDelete = false;

        init();

        /**
        * Constructor function to be called when the controller is ready to load
        */
        function init() {

            // need to track if the tree view is by commodity
            // if yes, then we need to change it to vendor view
            runtimeService.getConfigData().then(function (config) {
                vm.rateSchedulesCreate = userService.userHasPermission("RateSchedulesCreate");
                vm.rateSchedulesEdit = userService.userHasPermission("RateSchedulesEdit");
                vm.rateSchedulesDelete = userService.userHasPermission("RateSchedulesDelete");

                vm.viewVendorsTreeByCommodity = config.preference.viewVendorsTreeByCommodity;

                vm.status = 'pending';
                vm.message = 'Loading';

                var vendorId = $state.params.vendorId;

                // Default our filter to commodity since that's always a given for this page.  We'll have to decide if we should also tie in
                // vendor based on the state params
                var filter = "commodityId equals '" + vm.id + "'";

                if (vendorId) {
                    filter += " and vendorId equals '" + vendorId + "'";
                }

                apiResource.rate().rate().query({ filter: filter }, function (result) {
                    setPowerviewProperties(powerviewHelper.getPowerviewProperties({ results: result }, true));
                    createWidgets();
                }, function (error) {
                    setPowerviewProperties(powerviewHelper.getPowerviewProperties());
                });

            });
        }

        /**
         * Sets view properties for the powerview
         * @param {Object} properties - The powerview properties
         */
        function setPowerviewProperties(properties) {
            vm.data = properties.data;
            vm.message = properties.message;
            vm.status = properties.status;

            // Show the widget even if there is no data
            if (properties.status === 'noData') {
                vm.status = 'hasData';
            } else {
                vm.status = properties.status;
            }

        }

        function createWidgets() {
            vm.widgets = [];

            vm.widgets.push(powerviewHelper.getWidgetDefinition({
                id: "rateSchedules",
                type: 'dataGrid',
                class: 'col-12',
                autoHeight: true,
                title: $translate.instant('Rate Schedules') + ' - ' + vm.data.results.length,
                content: getRateSchedulesGrid()
            }));
        }

        /**
        * Click handler for the rate schedules grid to add a rate item
        */
        function addRate() {
            $dialog.openDialog('manage-rate', 'medium', {
                commodityId: vm.id,
                vendorId: vm.vendorId
            })
                .then(reloadGridIfSaved)
                .catch(alertApiFailure);
        }

        /**
        * Click handler for the rate schedules grid to edit a rate item
        * @param {integer} rateId - Rate identifier
        *
        * TODO: ECAP-32977
        */
        function editRate(rateId) {
            $dialog.openDialog('manage-rate', 'medium', { rateId: rateId })
                .then(reloadGridIfSaved)
                .catch(alertApiFailure);
        }

        function reloadGridIfSaved(result) {
            if (result.save) {
                $state.publishEvent('reloadVendors');
                $state.reload();
            }
        }

        function alertApiFailure(error) {
            if (error && error.data && error.data.status && error.data.status.message) {
                // TODO: finish user assistance layer for API failures on edit/delete
                alert(error.data.status.message);
            }
        }

        /**
        * Click handler for the rate schedules grid to delete a rate item
        * @param {integer} rateId - Rate identifier
        */
        function deleteRate(rateId) {
            confirmationService.confirmation($translate.instant("Delete rate schedule"), $translate.instant("Are you sure?")).then(function (result) {

                if (!result) {
                    return;
                }

                var refreshTreeAndLocateNode = null;
                var ids = null;

                //What do we do if the service returns a 406 unacceptable?
                apiResource.rate().rate().remove({ rateId: rateId }, function (result) {
                    $state.publishEvent('reloadVendors');
                    $state.reload();
                });
            });
        }

        /**
        * Generates the defintion for the rate schedules grid
        * @returns {object} - Object that will define the rate schedules grid
        */
        function getRateSchedulesGrid() {
            var content = {
                dataGrid: {
                    columns: [
                        {
                            field: "name",
                            title: "Rate schedule",
                            template: function (e) {
                                if (vm.viewVendorsTreeByCommodity) {
                                    return '<a href="vendors/commodity/' + e.commodity.commodityId + '/vendor/' + e.vendor.vendorId + '/rate/' + e.rateId + '/properties">' + kendo.htmlEncode(e.name) + '</a>';
                                } else {
                                    return '<a href="vendors/vendor/' + e.vendor.vendorId + '/commodity/' + e.commodity.commodityId + '/rate/' + e.rateId + '/properties">' + kendo.htmlEncode(e.name) + '</a>';
                                }
                            }
                        },
                        {
                            attributes: {
                                "class": "ec-grid-actions"
                            },
                            headerAttributes: { "class": "ec-grid-actions" },
                            headerTemplate: "<button ng-if='vm.controller.rateSchedulesCreate' ng-click='vm.controller.addRate()' tooltip data-toggle='tooltip' data-placement='left' title='" + $translate.instant('Add rate schedule') + "' class='ec-btn-icon btn btn-secondary'><i class='ec-icon icon-add'></i></button>",
                            template: "<button ng-if='vm.controller.rateSchedulesDelete' ng-click='vm.controller.deleteRate(#=rateId#)' tooltip data-toggle='tooltip' data-placement='left' title='" + $translate.instant("Delete rate schedule") + "' class='ec-btn-icon btn btn-secondary'><i class='ec-icon icon-delete'></i></button><button ng-if='vm.controller.rateSchedulesEdit' ng-click='vm.controller.editRate(#=rateId#)' tooltip data-toggle='tooltip' data-placement='left' title='" + $translate.instant("Edit rate schedule") + "' class='ec-btn-icon btn btn-secondary'><i class='ec-icon icon-edit'></i></button>",
                            width: gridHelper.ACTION_ICON_WIDTH * 2
                        }
                    ]
                }
            };

            if (vm.data) {
                content.dataGrid.dataSource = {
                    data: vm.data.results
                };
            }

            return content;
        }

    }
})();

﻿(function () {
    'use strict';

    angular
        .module('vendorsModule')
        .controller('rateMetersController', RateMetersController);

    RateMetersController.$inject = ['$state', 'apiResource', 'powerviewHelper', '$translate', 'placeRoutePipe'];

    /**
    * Controller for the Rate Meters Powerview
    */
    function RateMetersController($state, apiResource, powerviewHelper, $translate, placeRoutePipe) {
        var vm = this;

        ////////////////////////////////////////////////////////////////////////
        // TODO: remove after ECAP-3957 is done
        vm.converted = true;
        ////////////////////////////////////////////////////////////////////////

        vm.id = $state.params.rateId;
        vm.vendorId = $state.params.vendorId;
        vm.commodityId = $state.params.commodityId;

        init();

        /**
        * Constructor function to be called when the controller is ready to load
        */
        function init() {
            vm.status = 'pending';
            vm.message = 'Loading';

            // Calling the rate api to get the rate code for the meter filter
            apiResource.rate().rate().get({ rateId: vm.id }, function (result) {

                // Get all meters for a given rate code
                apiResource.meter().allMeters().query({ filter: "rateCode equals '" + result.name + "' and vendorId equals '" + vm.vendorId + "' and commodityId equals '" + vm.commodityId + "'" }, function (meters) {

                    angular.forEach(meters, function (meter) {
                        meter.placeLocateLink = placeRoutePipe.transformSync(meter.place, 'ECAP', ['actual', 'summary'], true);
                        meter.meterLocateLink = "buildings/meter/" + meter.meterId + "/actual/summary";
                    });

                    setPowerviewProperties(powerviewHelper.getPowerviewProperties({ results: meters }, true));
                    createWidgets();
                }, function (error) {
                    setPowerviewProperties(powerviewHelper.getPowerviewProperties());
                });
            });
        }

        /**
         * Sets view properties for the powerview
         * @param {Object} properties - The powerview properties
         */
        function setPowerviewProperties(properties) {
            vm.data = properties.data;
            vm.message = properties.message;
            vm.status = properties.status;
        }

        function createWidgets() {
            vm.widgets = [];

            vm.widgets.push(powerviewHelper.getWidgetDefinition({
                id: "meters",
                type: 'dataGrid',
                class: 'col-12',
                title: $translate.instant('Meters') + ' - ' + vm.data.results.length,
                content: getMetersGrid()
            }));
        }

        /**
        * Generates the defintion for the meters grid
        * @returns {object} - Object that will define the meters grid
        */
        function getMetersGrid() {
            return {
                dataGrid: {
                    dataSource: {
                        sort: [
                            {
                                field: "active", dir: "desc"
                            },
                            {
                                field: "meterInfo", dir: "asc"
                            }
                        ],
                        data: vm.data.results
                    },
                    sortable: {
                        mode: "multiple",
                        allowUnsort: true
                    },
                    columns: [
                        {
                            field: "meterInfo",
                            title: "Meter name",
                            template: "<a href='#=meterLocateLink#'>#:meterInfo#</a>"
                        },
                        {
                            field: "meterCode",
                            title: "Meter code"
                        },
                        {
                            field: "place.placeInfo",
                            title: "Place name",
                            template: "<a href='#=placeLocateLink#'>#:place.placeInfo#</a>"
                        },
                        {
                            field: "place.placeCode",
                            title: "Place code"
                        },
                        // TODO: Revisit when we do simple rates
                        //{
                        //    field: "rateEffective",
                        //    title: "Rate effective"
                        //    //template: "#=rateEffective ? moment(rateEffective).format('MM/DD/YYYY') : ''#"
                        //},
                        {
                            field: "meterType.meterTypeId",
                            title: "Chargeback",
                            template: "<i class='#=meterType.meterTypeId == 6  ? 'ec-icon icon-check' : ''#'></i>"
                        },
                        {
                            field: "active",
                            title: "Active",
                            template: "<i class='#=active == true   ? 'ec-icon icon-check' : ''#'></i>"
                        }
                    ]
                }
            };
        }
    }
})();
﻿(function () {
    'use strict';

    angular
        .module('vendorsModule')
        .controller('rateVersionsController', RateVersionsController);

    RateVersionsController.$inject = ['urlService', 'apiResource'];

    function RateVersionsController(urlService, apiResource) {
        var vm = this;
       
    }
})();

﻿(function () {
    'use strict';

    angular
        .module('vendorsModule')
        .controller('vendorReassignController', VendorReassignController);

    VendorReassignController.$inject = ['apiResource', '$state', '$translate'];

    /**
    * Controller for the Vendor Accounts Reassign Tab
    */
    function VendorReassignController(apiResource, $state, $translate) {
        var vm = this;

        vm.id = $state.params.vendorId;
        vm.accountGrid = accountsGrid();
        vm.newVendorId = 0;
        vm.moveAccounts = moveAccounts;
        vm.singleAccountCheckboxClick = singleAccountCheckboxClick;
        vm.errorMessage = $translate.instant('ChooseNewVendor_SC');

        init();

        /**
        * Constructor function to be called when the controller is ready to load
        */
        function init() {
            vm.selectedAccountIds = [];
            vm.isLoading = true;
            vm.allAccountsSelected = false;

            //filter out the vendor we are on
            apiResource.vendor().allVendors({ cancelable: false }).query({ filter: "vendorId not equals '" + vm.id + "'",field:'vendorId,vendorCode,vendorInfo'}, function (result) {
                vm.vendors = new kendo.data.DataSource({
                    data: result
                });
                vm.newVendorId = result[0].vendorId;
            });

            apiResource.account().allAccounts().query({ filter: "vendorId equals '" + vm.id + "'" }, function (result) {
                angular.forEach(result, function (account) {
                    account.selected = false;

                    account.locateLink = "accounts/account/" + account.accountId + "/actual/summary";
                    if (account.address) {

                        var queryParts = [account.address.line1, account.address.line2, account.address.line3, account.address.city, account.address.state, account.address.postalCode];
                        queryParts = queryParts.filter(function(line){ return line; }).map(function(part) { return encodeURIComponent(part); });
                        if (queryParts.length) {
                            account.address.addressLink = 'https://www.google.com/maps/search/?api=1&query=' + queryParts.join(' ');
                        }

                        account.address.cityStateZip = "";

                        // Build up our city, state and zip field based on the components available
                        if (account.address.city) {
                            account.address.cityStateZip += account.address.city;
                        }

                        if (account.address.state) {
                            if (account.address.cityStateZip !== "") {
                                account.address.cityStateZip += ", ";
                            }

                            account.address.cityStateZip += account.address.state;
                        }

                        if (account.address.postalCode) {
                            if (account.address.cityStateZip !== "") {
                                account.address.cityStateZip += " ";
                            }

                            account.address.cityStateZip += account.address.postalCode;
                        }
                    } else {
                        // Create an empty address.  This account has none and the template works best with empty values
                        account.address = {
                            line1: "",
                            line2: null,
                            citStateZip: null,
                            addressLink: null
                        };
                    }

                });
                vm.accountGrid.dataSource.data = result;
                vm.accountGrid.headerCount = result.length;

                vm.isLoading = false;

            }, function (error) {
                vm.accountGrid.dataSource.data = [];
                vm.isLoading = false;
            });
        }


        function moveAccounts() {
            if (vm.selectedAccountIds.length > 0) {
                vm.isLoading = true;
                apiResource.vendor().assignAccounts().update({ vendorId: vm.newVendorId }, vm.selectedAccountIds, function (result) {
                    init();
                }, function (error) {
                    vm.errorMessage = error.data.status.message;
                    init();
                });
            }

        }

        function singleAccountCheckboxClick(account) {
            if (account.selected) {
                vm.selectedAccountIds.push(account.accountId);
            } else {
                _.remove(vm.selectedAccountIds, function (accountId) {
                    return accountId == account.accountId;
                })
            }
        }

        /**
        * Generates the defintion for the accounts grid
        * @returns {object} - Object that will define the accounts grid
        */
        function accountsGrid() {
            return  {
                header: "Accounts",
                dataSource: {
                    sort: [
                       {
                           field: "active", dir: "desc"
                       },
                       {
                           field: "accountCode", dir: "asc"
                       }
                    ]
                },
                height: '100%',
                width: '100%',
                scrollable: false,
                sortable: {
                    mode: "multiple",
                    allowUnsort: true
                },
                columns: [
                    {
                        sortable: false,

                        headerTemplate: "<ec-check-box ng-model='grid.controller.allAccountsSelected' ng-change='grid.controller.allAccountsCheckboxClick()'></ec-check-box>",
                        template: "<ec-check-box class='checkbox' ng-model='dataItem.selected' ng-change='grid.controller.singleAccountCheckboxClick(dataItem)'></ec-check-box>",

                        width: 30
                    },
					{
					    field: "accountCode",
					    title: "Account number",
					    template: "<a href='#=locateLink#'>#:accountCode#</a>"
					},
					{
					    field: "accountInfo",
					    title: "Account name"
					},
                    {
                        field: "address",
                        title: "Service address",
                        template: function (e) {

                            var showLine1 = (typeof e.address.line1 != 'undefined') && e.address.line1 !== '' && e.address.line1 != null;
                            var showLine2 = (typeof e.address.line2 != 'undefined') && e.address.line2 !== '' && e.address.line2 != null;
                            var showLine3 = (typeof e.address.line3 != 'undefined') && e.address.line3 !== '' && e.address.line3 != null;
                            var showCityStateZip = (typeof e.address.cityStateZip != 'undefined') && e.address.cityStateZip !== '' && e.address.cityStateZip != null;

                            return '<a class="is-map-link" ng-show="' + !!e.address.addressLink + '" ng-href="' + e.address.addressLink + '" target="_blank">' +
                                    '<span class="ec-address" ng-show="' + showLine1 + '">' + kendo.htmlEncode(e.address.line1) + '</span> ' +
                                    '<span class="ec-address" ng-show="' + showLine2 + '">' + kendo.htmlEncode(e.address.line2) + '</span> ' +
                                    '<span class="ec-address" ng-show="' + showLine3 + '">' + kendo.htmlEncode(e.address.line3) + '</span> ' +
                                    '<span class="ec-address" ng-show="' + showCityStateZip + '">' + kendo.htmlEncode(e.address.cityStateZip) + '</span>' +
                                    '</a>';
                        },
                        sortable: false
                    },
					{
					    field: "serviceStart",
					    title: "Service start",
					    template: "#=serviceStart ? moment(serviceStart).format('MM/DD/YYYY') : ''#"
					},
                    {
                        field: "serviceEnd",
                        title: "Service end",
                        template: "#=serviceEnd && moment(serviceEnd).format('MM/DD/YYYY') !== '01/01/3000' ? moment(serviceEnd).format('MM/DD/YYYY') : ''#"
                    },
					{
					    field: "active",
					    title: "Active",
					    template: "<i class='ec-icon #=active == true   ? 'icon-check' : ''#'></i>"
					}
                ]
            };
        }

        vm.allAccountsCheckboxClick = function () {
            vm.selectedAccountIds = [];

            angular.forEach(vm.accountGrid.dataSource.data, function (account) {
                if (vm.allAccountsSelected) {
                    vm.selectedAccountIds.push(account.accountId);
                }

                account.selected = vm.allAccountsSelected;
            });
        }

    }
})();

(function() {
  'use strict';

  /**
   * App custom components module
   */
  angular.module('ecComponents', []);
})();
﻿(function () {
    'use strict';

    /**
     * Component for an amchart that receives a configuration object and calls
     * makeChart on the amChartsService passing in the component's element and configuration
     * object
     * 
     * @param {object} config AmChart makeChart config object
     * @param {Function} [onStatusUpdate] callback to call when there is a status change
     * 
     * @requires $element
     * @requires $log
     */
    angular
		.module('ecComponents')
		.component('ecAmchart', {
            controller: AmchartController,
            bindings: {
                id: '@',
                config: '<',
                onStatusUpdate: '&?'
            }
        });

    AmchartController.$inject = ['$element', '$log', 'amChartsService'];
    function AmchartController($element, $log, amChartsService){
        var ctrl = this;
        var ERROR_MESSAGE = 'Failed to draw chart';
        var NO_DATA_MESSAGE = 'No data is available';

        ctrl.$onInit = onInit;
        ctrl.$onChanges = onChanges;

        /**
         * Initialize the component and add a few styles to make sure we have
         * space to draw the chart
         */
        function onInit() {
            $element.addClass('w-100 h-100 d-block');
        }

        /**
         * Redraw the chart when the configuration changes
         * @param {Object} changeObj Angular $onChanges changeObj hash
         */
        function onChanges(changeObj) {
            if (changeObj.config) {
                if (changeObj.config.isFirstChange()) {
                    updateStatus('pending');
                }

                if (changeObj.config.currentValue) {
                    makeChart(changeObj.config.currentValue);
                }
            }
        }

        /**
         * Draw the AmChart. If there is no config object or no dataProvider, show
         * an error message. If there is a config and dataProvider but no data, show
         * a no data message.
         * @param {object} chartConfig The amChart configuration object
         */
        function makeChart(chartConfig) {
            try {
                if(chartConfig.dataProvider && chartConfig.dataProvider.length > 0) {
                    amChartsService.makeChart($element[0], chartConfig);
                    updateStatus('hasData');
                } else {
                    updateStatus('noData', NO_DATA_MESSAGE);
                }
            } catch (error) {
                $log.error('Could not create amchart', error);
                updateStatus('error', ERROR_MESSAGE);
            }
        }

        /**
         * Call the update status callback if there is one and it is a function
         * @param {string} status The updated status (hasData|noData|pending|error)
         * @param {string} [message] An optional message to update
         */
        function updateStatus(status, message) {
            if (ctrl.onStatusUpdate && angular.isFunction(ctrl.onStatusUpdate)) {
                ctrl.onStatusUpdate({status: status, message: message || ''});
            }
        }
    }

})();
﻿(function () {
    'use strict';

    /**
     * Displays an up/down arrow chart
     * 
     * @param {String} type Arrow chart type (arrowchart|savingsarrowchart)
     * @param {Object} config Configuration object
     * @param {Object} config.dataProvider Formatted API response data
     * @param {Number} [config.dataProvider.previousYearValue] Previous year value (arrowchart)
     * @param {String} [config.dataProvider.previousYearValueDisplay] Formatted value for previous year (arrowchart)
     * @param {Number} [config.dataProvider.currentYearValue] Current year value (arrowchart)
     * @param {String} [config.dataProvider.currentYearValueDisplay] Formatted value for current year (arrowchart)
     * @param {Number} [config.dataProvider.batccValue] BATCC value (savingsarrowchart)
     * @param {String} [config.dataProvider.batccValueDisplay] Formatted value for BATCC (savingsarrowchart)
     * @param {Number} [config.dataProvider.avoidanceValue] Cost avoidance value (savingsarrowchart)
     * @param {String} [config.dataProvider.avoidanceValueDisplay] Formatted value for cost avoidance (savingsarrowchart)
     * @param {String} [config.dataProvider.actualValueDisplay] Formatted actual value (savingsarrowchart)
     * @param {Function} [onStatusUpdate] callback to call when there is a status change
     * 
     * @requires $filter
     * @requires $translate
     * @requires $log
     */
    angular
		.module('ecComponents')
		.component('ecArrowchart', {
            templateUrl: 'assets/components/arrowchart/arrowchart.html',
            controller: ArrowChartController,
            bindings: {
                id: '@',
                type: '<',
                config: '<',
                onStatusUpdate: '&?'
            }
        });

    ArrowChartController.$inject = ['$filter', '$translate', '$log'];
    function ArrowChartController($filter, $translate, $log) {
        var ctrl = this;
        ////////////////////////////////////////////////////////////////////////
        // TODO: check that these labels are correct
        var PREVIOUS_LABEL = 'Previous Year';
        var CURRENT_LABEL = 'Current Year';
        ////////////////////////////////////////////////////////////////////////
        var BATCC_LABEL = 'BATCC';
        var BATCC_TITLE = 'Baseline Adjusted to Current Conditions';
        var ACTUAL_LABEL = 'Actual';
        var AVOIDANCE_LABEL = 'Savings';
        var NO_DATA_LABEL = 'No data is available';
        var ERROR_MESSAGE = 'Failed to draw chart';
        var NO_DATA_MESSAGE = 'No data is available';

        ctrl.$onInit = init;
        ctrl.$onChanges = onChanges;

        /**
         * Initialize the component when added to the DOM
         */
        function init() { }

        /**
         * Update the chart properteis when bindings change
         * @param {Object} changeObj Angular $onChange changeObj hash 
         */
        function onChanges(changeObj) {        
            // Update labels if chart type changes
            if (changeObj.type && changeObj.type.currentValue) {
                setLabels();
            }

            if (changeObj.config) {
                if (changeObj.config.isFirstChange()) {
                    updateStatus('pending');
                }

                if (changeObj.config.currentValue) {
                    var data = changeObj.config.currentValue.dataProvider;

                    if (data) {
                        setValues(data);
                        setArrowChartProps(data);
                    } else {
                        updateStatus('noData', NO_DATA_MESSAGE);
                    }
                }
            }
        }

        /**
         * Set the translated chart data labels by chart type.
         */
        function setLabels() {
            switch (ctrl.type) {
                case 'arrowchart':
                    ctrl.previousLabel = $translate.instant(PREVIOUS_LABEL);
                    ctrl.currentLabel = $translate.instant(CURRENT_LABEL);
                    break;
                case 'savingsarrowchart':
                    ////////////////////////////////////////////////////////////
                    // TODO: use a label after we update ecDataDisplay to support abreviations
                    ctrl.batccTitle = $translate.instant(BATCC_TITLE);
                    ctrl.batccLabel = $translate.instant(BATCC_LABEL);
                    ////////////////////////////////////////////////////////////
                    ctrl.actualLabel = $translate.instant(ACTUAL_LABEL);
                    ctrl.avoidanceLabel = $translate.instant(AVOIDANCE_LABEL);
                    break;
            }
        }

        /**
         * Set the chart data values by chart type. If a value has no data, show
         * 'No data is available'
         * @param {Object} data DataProvider object returned from the API
         */
        function setValues(data) {
            var noDataValue = $translate.instant(NO_DATA_LABEL);

            switch (ctrl.type) {
                case 'arrowchart':
                    ctrl.previousValue = data.previousYearValueDisplay || noDataValue;
                    ctrl.previousYearSpan = data.previousYearSpan || '';
                    ctrl.currentValue = data.currentYearValueDisplay || noDataValue;
                    ctrl.currentYearSpan = data.currentYearSpan || '';
                    break;
                case 'savingsarrowchart':
                    ctrl.batccValue = data.batccValueDisplay || noDataValue;
                    ctrl.actualValue = data.actualValueDisplay || noDataValue;
                    ctrl.avoidanceValue = data.avoidanceValueDisplay || noDataValue;
                    break;
            }
        }
        
        /**
         * Set the view model arrow properties based on chart type. If both the 
         * 'before' and 'after' values are undefined, show the NO_DATA_MESSAGE. 
         * If either the 'before' value or the 'after' value are undefined, set 
         * the arrow properties to null. If an error occurs, show the ERROR_MESSAGE.
         * @param {Object} data DataProvider object returned from the API
         */
        function setArrowChartProps(data) {
            var goodDirection, badDirection, percentage;

            try {
                switch(ctrl.type) {
                    case 'arrowchart':
                        percentage = getArrowPercentage(data.previousYearValue, data.currentYearValue);
                        goodDirection = 'down';
                        badDirection = 'up';
                        break;
                    case 'savingsarrowchart':
                        percentage = getSavingsArrowPercentage(data.batccValue, data.actualValue, data.avoidanceValue);
                        goodDirection = 'up';
                        badDirection = 'down';
                        break;
                }

                if (percentage === null) {
                    updateStatus('noData', NO_DATA_MESSAGE);
                } else {
                    if (percentage !== false) {
                        var arrow = {};
                        arrow.good = true;
                        arrow.direction = goodDirection;

                        percentage = _.round(percentage, 1);

                        if (percentage < 0) {
                            percentage *= -1;
                            arrow.good = false;
                            arrow.direction = badDirection;
                        } else if (percentage === 0) {
                            arrow.good = null;
                            arrow.direction = null;
                        }

                        arrow.value = $filter('number')(percentage, 1);
                        arrow.value = arrow.value + '%';

                        ctrl.arrow = arrow;
                    } else {
                        ctrl.arrow = null;
                    }

                    updateStatus('hasData');
                } 
            } catch (error) {
                $log.error('Could not create arrowchart.', error);
                updateStatus('error', ERROR_MESSAGE);
            }
        }

        /**
         * Get percentage value for arrowchart
         * @param {Number} previous The previous year value from the DataProvider
         * @param {Number} current The current year value from the DataProvider
         * @returns {Number|Null|False} The percentage or null if both parameters are null or false if one parameter is null or previous is 0
         */
        function getArrowPercentage(previous, current) {
            if (previous === 0 && current === 0) {
                return 0;
            } else if (previous === null && current === null) {
                return null;
            } else if (previous === null || current === null || previous === 0){
                return false;
            } else {
                if (angular.isNumber(previous) && angular.isNumber(current)) {
                    return ((previous - current) / previous) * 100;
                } else {
                    var error = '';
                    if (!angular.isNumber(previous)) {
                        error = 'previousYearValue is not a number. ';
                    }

                    if (!angular.isNumber(current)) {
                        error = error + 'currentYearValue is not a number.';
                    }

                    throw new Error(error);
                }
            }
        }

        /**
         * Get the percentage value for a savingsarrowchart
         * @param {Number} batcc The batcc value from the DataProvider
         * @param {Number} actual The actual value from the DataProvider
         * @param {Number} avoidance The avoidance value from the DataProvider
         * @returns {Number|Null|False} The percentage or null if all parameters are null or false if one of the parameters is null or batcc is 0
         */
        function getSavingsArrowPercentage(batcc, actual, avoidance) {
            if (avoidance === 0 && batcc === 0) {
                return 0;
            } else if (batcc === null && actual === null && avoidance === null) {
                return null;
            } else if (batcc === null || avoidance === null || batcc === 0) {
                return false;
            } else {
                if (angular.isNumber(avoidance) && angular.isNumber(batcc)) {
                    return avoidance / batcc * 100;
                } else {
                    var error = '';
                    if (!angular.isNumber(avoidance)) {
                        error = 'avoidanceValue is not a number. ';
                    } 
                    
                    if (!angular.isNumber(batcc)) {
                        error = error + 'batccValue is not a number.';
                    }

                    throw new Error(error);
                }
            }
        }

        /**
         * Call the update status callback if there is one and it is a function
         * @param {string} status The updated status (hasData|noData|pending|error)
         * @param {string} [message] An optional message to update
         */
        function updateStatus(status, message) {
            if (ctrl.onStatusUpdate && angular.isFunction(ctrl.onStatusUpdate)) {
                ctrl.onStatusUpdate({status: status, message: message || ''});
            }
        }
    }
})();
(function() {
'use strict';

  /**
   * Data table component that wraps a kendo grid
   * @param {object} definition Kendo grid definition object
   * @param {function} [onStatusUpdate] Callback to update the component's parent status
   * 
   * @requires $translate
   * @requires $log
   */
  angular
    .module('ecComponents')
    .component('ecDataGrid', {
      templateUrl: 'assets/components/dataGrid/dataGrid.html',
      controller: DataGridController,
      controllerAs: 'vm',
      bindings: {
        id: '@',
        definition: '<',
        onStatusUpdate: '&?',
        controller: '<?'
      },
    });

  DataGridController.inject = ['$log', '$translate'];
  function DataGridController($log, $translate) {
    var ctrl = this;
    
    // Constants
    var NO_DATA_MESSAGE = 'No data is available';
    var ERROR_MESSAGE = 'Failed to create data table';
    var DISABLE_RESIZE_CLASSES = ['ec-grid-actions', 'ec-grid-not-resizable'];
    var userSortedColumns = [];
    var originalGridColumns = [];
    
    ctrl.active = false;

    ctrl.$onInit = init;
    ctrl.$onChanges = onChanges;
    ctrl.copySuccess = copySuccess;

    /**
     * Componont onInit lifecycle event
     * @private
     */
    function init() {}
    
    /**
     * Update the component when bindings change
     * @private
     */
    function onChanges(changesObj) { 
      if (changesObj.definition) {
        if (changesObj.definition.isFirstChange()) {
          updateStatus('pending');
        }

        if (changesObj.definition.currentValue) {
          if (changesObj.definition.currentValue.dataSource) {
            setDefinition();
          } else {
            updateStatus('noData', changesObj.definition.currentValue.noDataMessage || NO_DATA_MESSAGE);
          }
        }
      }
    };

    /**
     * Set defaults before passing definition to Kendo Grid
     * @private
     */
    function setDefinition() {
      setDefaults();
      setResizableOptions();      
      setLockedColumnOptions();
      translateColumnTitles();
      setSortableOptions();
      setDataSource();
    }

    /**
     * Set up some defaults for out datagrid such as the template for noRecords
     * and attach a handler to the kendo grid databound event
     * @private
     */
    function setDefaults() {
      // Set up the noRecords template
      var noRecordsDefault = {
        template: NO_DATA_MESSAGE
      };
      ctrl.definition.noRecords = ctrl.definition.noRecords || noRecordsDefault;

      ctrl.definition.dataBound = onDataBound;
    }

    /**
     * Make all grids resizable and attach an event handler to columnResize. If 
     * the grid definition is explicity set to false, we won't do anything.
     * @private
     */
    function setResizableOptions() {
      if (ctrl.definition.resizable !== false) {
        ctrl.definition.resizable = true;
      }

      ctrl.resizable = ctrl.definition.resizable;
    }

    /**
     * Check if any columns are locked and what side of the grid the locked 
     * columns should be on. Add a css class to correctly position the locked columns
     * @private
     */
    function setLockedColumnOptions() {
      if (ctrl.definition.columns) {
        ctrl.locked = ctrl.definition.columns.some(function(column){
          return column.locked;
        })

        if (ctrl.locked && ctrl.definition.lockedColumnsRight) {
          ctrl.lockedRight = true;
        }
      }
    }

    /**
     * Translate the column titles
     * @private
     */
    function translateColumnTitles() {
      if (ctrl.definition.columns && ctrl.definition.columns.length > 0) {
        var columns = ctrl.definition.columns;

        angular.forEach(columns, function(column) {
          if(column.title) {
            // Use double quotes to wrap html to work with kendo's templating
            column.title = "<span class='ec-grid-col-title'>" + $translate.instant(column.title) + "</span>";
          } else {
            column.title = "<span class='ec-grid-col-title'></span>";
          }
        });

        // Save original dataGrid columns
        originalGridColumns = angular.copy(columns);
      }
    }

    /**
     * If the data grid is sortable, make sure we are setting the sortable mode
     * to 'single' and attach an event handler for user sorting.
     * @private
     */ 
    function setSortableOptions() {
      var sortable = ctrl.definition.sortable;

      if (sortable) {
        ctrl.sortable = true;
        
        if (angular.isObject(sortable)) {
          sortable.mode = sortable.mode || 'single';
        } else {
          sortable = {
            mode: 'single'
          };
        }
      }
    }

    /**
     * Update the grid's dataSource and refresh the kendoGrid directive. If there
     * is no data or an error update the parent status and display a message to 
     * the user
     * @private
     */
    function setDataSource() {
      try {
        if (angular.isArray(ctrl.definition.dataSource)) {
          var dataSource = angular.copy(ctrl.definition.dataSource);
          ctrl.definition.dataSource = new kendo.data.DataSource({
            data: dataSource
          });
          $log.warn('Definition.dataSource was an array, expected an object. We assigned dataSource to dataSource.data instead, but there is no default sorting set on dataSource. See http://docs.telerik.com/kendo-ui/api/javascript/data/datasource#configuration-sort.');
        }

        if (angular.isArray(ctrl.definition.dataSource.data)) {
          if (ctrl.definition.dataSource.data.length === 0) {
            ctrl.noRecords = true;
            ctrl.definition.scrollable = false;
          }

          if (ctrl.kendoGrid) {
            ctrl.kendoGrid.setDataSource(new kendo.data.DataSource(ctrl.definition.dataSource));
          }
          updateStatus('hasData');
        } else {
          updateStatus('noData', ctrl.definition.noDataMessage || NO_DATA_MESSAGE);
        }
  
      } catch (error) {
        $log.error(error);
        updateStatus('error', ERROR_MESSAGE);
      }
    }

    /**
     * When the kendoGrid is initialized, save the returned object to our controller
     * to use later and bind a handler to the start of a resize event.
     * @param {object} e Kendo Grid created event object
     * @private
     */
    function onDataBound(e) {
      ctrl.kendoGrid = e.sender;

      if (ctrl.resizable) {
        ctrl.kendoGrid.resizable.bind('start', onResize);
      }
    }

    /**
     * Handle a column resize event and prevent resizing on columns that have a
     * class that is in the DISABLE_RESIZE_CLASSES array
     * @param {object} e resize start event
     * @private
     */
    function onResize(e) {
      var disableResize = false;

      // Loop through all our excluded classes and see if they exist in the column attempting to be resized
      angular.forEach(DISABLE_RESIZE_CLASSES, function (className) {
          if (_.findIndex(angular.element(e.currentTarget).data("th")[0].classList, function (headerClass) {
              return headerClass === className;
          }) > -1) {
              disableResize = true;
          }
      });

      if (disableResize) {
          // Column shouldn't resize so prevent default
          e.preventDefault();

          // Remove classes and styles that kendo added when resize started
          ctrl.kendoGrid.wrapper.removeClass("k-grid-column-resizing");
          angular.element(document).find('body').css('cursor', '');
          ctrl.kendoGrid.wrapper.find('th').css('cursor', '').find('a').css('cursor', '');
      }
    }

    /**
     * Call the update status callback if there is one and it is a function
     * @param {string} status The updated status (hasData|noData|pending|error)
     * @param {string} [message] An optional message to update
     */
    function updateStatus(status, message) {
      if (ctrl.onStatusUpdate && angular.isFunction(ctrl.onStatusUpdate)) {
        ctrl.onStatusUpdate({status: status, message: message || ''});
      }
    }

    /**
     * Clear the current clipboard selection
     * @param {object} e ngClipboard copy event object 
     */
    function copySuccess(e) {
        e.clearSelection();
    }
  }
})();
(function() {
'use strict';

  /**
   * @desc Wraps (transcludes) any type of content in a card, shows a title and 
   * actions as icon buttons in a header, has an optional footer, and provides 
   * an interface for displaying a loading animation and a info or error message.
   * 
   * @param {string} [title] Widget header title 
   * @param {string} [footer] Widget footer text
   * @param {string} [status=hasData] Value of the widget's current status (hasData|noData|error|pending)
   * @param {string} [message] Status message
   * @param {Boolean} [autoHeight=false] Set the height of the widget to 'auto' with
   * no min-height allowing the widget to take on the height of it's content.
   * @param {Object[]} [actions] Collection of action definitions
   * @param {String} [actions.title] Tootlip title for the action
   * @param {String} [actions.tooltipPlacement=top] Tooltip placement (top|bottom|right|left)
   * @param {String} actions.icon Classname of the action button icon
   * @param {Function} actions.onClick Click handler
   * @param {*} actions.params Parameters to pass to actions.onClick
   * @param {Object} [addNew] Properties for a call to action button to display when
   * the status is 'noData'
   * @param {String} [addNew.label] Add new button label
   * @param {Function} [addNew.callback] Bound controller function to call on click
   */
  angular
    .module('app')
    .component('ecWidget1', {
      templateUrl: 'assets/components/widget/widget.html',
      controller: WidgetController,
      controllerAs: 'vm',
      bindings: {
        title: '<?',
        footer: '<?',
        actions: '<?',
        status: '<?',
        message: '<?',
        autoHeight: '<?',
        addNew: '<?'
      },
      transclude: true
    });

  WidgetController.inject = [];
  function WidgetController() {
    var vm = this;
    
    vm.$onInit = init;
    vm.$onChanges = onChanges;
    
    /**
     * Initialize the controller and set default values for optional attributes
     */
    function init() { 
      vm.status = vm.status || 'hasData';
      vm.actions = vm.actions || [];

      // Add default values to actions
      angular.forEach(vm.actions, function(action) {
        action.tooltipPlacement = action.tooltipPlacement || 'top'
      });
    };

    /**
     * Update properties when there are changes
     * @param {Object} changeObj Angular's onChanges changeObj
     */
    function onChanges(changeObj) {
      if (changeObj.message) {
        vm.message = changeObj.message.currentValue;
      }

      if (changeObj.status) {
        vm.status = changeObj.status.currentValue;
      }
    }
  }
})();
'use strict'

window.ECP = window.ECP || {};
window.ECP.ghostHelpers = window.ECP.ghostHelpers || {};
window.ECP.ghostHelpers = Object.assign(window.ECP.ghostHelpers, {
    scrollToElement: scrollToElement,
    dispatchKeyboardEvent: dispatchKeyboardEvent,
    getInputValue: getInputValue,
    updateInputAndBlur: updateInputAndBlur,
    updateDateInputAndBlur: updateDateInputAndBlur,
    updateNg1InputAndBlur: updateNg1InputAndBlur,
    pickFromComboByName: pickFromComboByName,
    pickFromCombo: pickFromCombo,
    addOrRemoveMultiselectCustomValue: addOrRemoveMultiselectCustomValue,
    pickOrRemoveFromMultiselectByName: pickOrRemoveFromMultiselectByName,
    findItemFromMultiselectListByText: findItemFromMultiselectListByText,
    clearMultiselectValues: clearMultiselectValues,
    clearMultiselectCustomValues: clearMultiselectCustomValues,
    shiftClick: shiftClick,
    controlClick: controlClick,
    resizeColumn: resizeColumn,
    setTinyMCEContent: setTinyMCEContent
});

/**
 * Scroll to a target element to bring it into the view
 * @param {string} scrollPane selector for the scrolling element, must be a valid selector for Document#querySelector(https://developer.mozilla.org/en-US/docs/Web/API/Document/querySelector)
 * @param {string} target selector for the target element, must be a valid selector for Document#querySelector(https://developer.mozilla.org/en-US/docs/Web/API/Document/querySelector)
 */
function scrollToElement(scrollPane, target) {
    var targetEl = document.querySelector(target);
    var scrollPaneEl = document.querySelector(scrollPane);
    if(!scrollPaneEl){
        throw Error('scroll pane "' + scrollPane + '" not found');
    } else if(!targetEl) {
        throw Error('scroll target element "' + target + '" not found');
    } else {
        //reset scroll position to zero, find the new position of target, then shift to that position. 
        //This makes figuring out which direction to go simpler
        scrollPaneEl.scrollTop = 0;
        scrollPaneEl.scrollTop = targetEl.getBoundingClientRect().y - scrollPaneEl.getBoundingClientRect().y;
    }
}

/**
 * Dispatch a KeyboardEvent on a target element
 * @param {string} target - selector for the target element, must be a valid selector for document.querySelector
 * @param {string} keyEventType - keydown | keyup | keypress
 * @param {string} key - the key pressed (https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key)
 * @example window.ECP.ghostHelpers.dispatchKeyboardEvent('#type_input', 'keydown', 'Enter')
 */
function dispatchKeyboardEvent(target, keyEventType, key) {
    var targetEl = document.querySelector(target);
    var keyEvent = new KeyboardEvent(keyEventType, {key: key, bubbles: true});
    targetEl.dispatchEvent(keyEvent);
}

/**
 * After making a change to an input that is wrapped in a date input or numeric box
 * we need to trigger the logic that synchronizes the internal state with the value we changed.
 * This requires us to tell angular to sync, then to trigger a blur event that bubbles so
 * the box itself will apply the reformatting logic.
 * 
 * @example window.ECP.ghostHelpers.updateInputAndBlur('#days_input', 15);
 */
function updateInputAndBlur(target, newValue) {
    var targetEl = document.querySelector(target);

    // Trigger a focusin event to mimick a user clicking or tabbing into the input.
    // We need this in order to trigger logic that happens when focusing a control.
    targetEl.dispatchEvent(new Event('focusin', {bubbles: true}));

    targetEl.value = newValue;

    //first sync the angular form model to the value of the input
    targetEl.dispatchEvent(new Event('input', {bubbles: true}));

    //then trigger a blur event 
    targetEl.dispatchEvent(new Event('focusout', {bubbles: true}));
}

function updateDateInputAndBlur(target, newValue) {
    var targetEl = document.querySelector(target);

    // Trigger a focusin event to mimick a user clicking or tabbing into the input.
    // We need this in order to trigger logic that happens when focusing a control.
    targetEl.dispatchEvent(new Event('focusin', {bubbles: true}));

    targetEl.value = newValue;

    //first sync the angular form model to the value of the input
    targetEl.dispatchEvent(new Event('input', {bubbles: true}));

    //then trigger a blur event 
    targetEl.dispatchEvent(new Event('blur', {bubbles: true}));
}

/**
 * Assign a value to an Ng1 form control and emit events to trigger any Ng1 watchers.
 * @example window.ECP.ghostHelpers.updateNg1InputAndBlur('#changeLog_input', 15);
 */
function updateNg1InputAndBlur(target, newValue) {
    var targetEl = document.querySelector(target);

    targetEl.value = newValue;

    //first sync the angular form model to the value of the input
    targetEl.dispatchEvent(new Event('input'));

    //then trigger a blur event 
    targetEl.dispatchEvent(new Event('blur'));
}

/**
 * Gets the input value for a given input
 * @param {string} selector 
 */
function getInputValue(selector) {
   return document.querySelector(selector).value;
}

/**Select a value in a combobox given the ID of the combobox and the name of the item within it
 * @param {string} comboSelector - the css selector for the combobox, something like "#commodity" which will be used to find the button #workflowStep_0_button_button
 * @param {string} itemText - the text of the menu item, something like "Natural Gas" which will be searched for in the menu contents and then selected. 
 *                            First looks for an exact match and falls back to a match that included the search text. Searches are case insensitive.
 * @example window.ECP.ghostHelpers.pickFromComboByName('#commodity', 'Electric');
 */
function pickFromComboByName(comboSelector, itemText){
    openCombo(comboSelector);

    var items = document.querySelectorAll(comboSelector + '_menu li');
    var menuItem = null;
    itemText = (itemText || '').toLowerCase();    

    var itemsArray = Array.from(items);

    // First look for an exact match
    menuItem = itemsArray.find(function(item) {
        return item.innerText.toLowerCase() === itemText;
    });

     //will try to find items when ec-combobox is more complex example rollupUnitCombo when there 
    //are more than one element value-name and description, only matching with value-name not description
    if(!menuItem) {
        items = document.querySelectorAll(comboSelector + '_menu li .text-body-1');
        itemsArray = Array.from(items);
        menuItem = itemsArray.find(function(item) {
            return item.innerText.toLowerCase() === itemText;
        });

        if(!menuItem) {
            // If an exact match isn't found, fallback to an item that contains the search text
            items = document.querySelectorAll(comboSelector + '_menu li');
            itemsArray = Array.from(items);
            menuItem = itemsArray.find(function(item) {
                return item.innerText.toLowerCase().includes(itemText);    
            });
        }
    } 

    if(menuItem) {
        clickElement(menuItem);
    } else {
        throw Error('menu item for combo "' + comboSelector + '" with text "' + itemText + '" not found, make sure it is in the top 250 if pagination enabled');
    }
}

/**Select a value in a combobox given the ID of the combobox and the selector of an item within it
 * @param {string} comboSelector - the css selector for the combobox, something like "#workflowStep_0" which will be used to find the button #workflowStep_0_button_button
 * @param {string} itemSelector - the css selector for the menu item, something like "#step_1043" which will be selected from the menu if found.
 * @example window.ECP.ghostHelpers.pickFromComboByName('#workflowStep_0', '#step_1043');
 */
function pickFromCombo(comboSelector, itemSelector){
    openCombo(comboSelector);

    var menuItem = document.querySelector(itemSelector);

    if(menuItem) {
        clickElement(menuItem);
    } else {
        throw Error('menu item for combo "' + comboSelector + '" matching selector "' + itemSelector + '" not found, make sure it is in the top 250 if pagination enabled');
    }
}

/**Open the provided combobox.  */
function openCombo(comboSelector){
    var comboButton = document.querySelector(comboSelector + '_button_button');
    if(comboButton){
        clickElement(comboButton);
    } else {
        throw Error('combo button for combo "' + comboSelector + '" not found');
    }
}

/**Clicks the provided element with bubbling true */
function clickElement(element){
    element.dispatchEvent(new Event('click', {bubbles: true}));
}

/**fires a mousedown event on the provided element, which is required for interacting with kendo multiselect
 * delete buttons.
*/
function mouseDownElement(element){
    var clickEvent = document.createEvent('MouseEvents');
    clickEvent.initEvent('mousedown', true, true);
    element.dispatchEvent(clickEvent);
}

/**
 * Add a new custom value to a multiselect control (with allowCustom enabled). If the value is already selected, the value is removed.
 * The comparison to see if it is already there is case insensitive but must be an exact match otherwise
 * @param {string} target - The css selector for the multiselect wrapper component
 * @param {string} newValue - The string value to add or remove from the multiselect
 * @example - window.ECP.ghostHelpers.addOrRemoveMultiselectCustomValue("#billLineDescriptions", "Some custom value");
 */
function addOrRemoveMultiselectCustomValue(target, newValue) {
    //first check to see if it is already there, and if so, click the delete icon
    var listItems = Array.from(document.querySelectorAll(target + '-multiselect .k-chip'));
    var matchingItems = listItems.filter(function(li) {
        return li.innerText.toLowerCase() == newValue.toLowerCase();
    });

    matchingItems.forEach(function(listItem) {
        var deleteIcon = listItem.querySelector('.k-chip-remove-action .k-icon');
        if(deleteIcon){
            mouseDownElement(deleteIcon);
        }
    });

    //if it wasn't already selected, add it instead
    if(matchingItems.length == 0){
        var targetEl = document.querySelector(target + '-multiselect input');

        // In order to make the dropdown open, we have to set a value and dispatch an input event
        targetEl.value = newValue;
        targetEl.dispatchEvent(new Event('input'));
    
        // Click on the custom item to add it
        document.querySelector(".k-multiselect-popup .k-list-custom-value").click();
    }
}

/**
 * Takes a list of elements and returns the item that matches the itemText provided. If an exact match is not found it searches for an item that contains the text.
 * If the value is already selected, the value is deselected.
 * @param {string} items - list of html elements to search from
 * @param {string} itemText - Text of the item to select or deselect
 * @example - window.ECP.ghostHelpers.findItemFromMultiselectListByText(items, "Ash");
 */
function findItemFromMultiselectListByText(items, itemText) {
    var menuItem = null;
    itemText = (itemText || '').toLowerCase();

    var itemsArray = Array.from(items);

    // First look for an exact match
    menuItem = itemsArray.find(function(item) {
        return item.innerText.toLowerCase() === itemText;
    });
    
    // If an exact match isn't found, fallback to an item that contains the search text
    menuItem = itemsArray.find(function(item) {
        return item.innerText.toLowerCase().includes(itemText);
    });

    return menuItem;
}

/**
 * Finds the matching item from the available values in the multiselect and adds it to the selected items.
 * If the value is already selected, the value is deselected.
 * @param {string} target - CSS selector for the multiselect wrapper component which will be used to find the multiselect's input
 * @param {string} itemText - Text of the item to select or deselect
 * @example - window.ECP.ghostHelpers.pickOrRemoveFromMultiselectByName("#billLineTypes", "Transportation Use");
 */
function pickOrRemoveFromMultiselectByName(target, itemText) {
    var targetEl = document.querySelector(target + '-multiselect input');

    // In order to make the dropdown open, we have to set a value and dispatch an input event
    targetEl.value = itemText.charAt(0);
    targetEl.dispatchEvent(new Event('input'));

    var items = document.querySelectorAll('.k-list-item');
    var menuItem = null;
    
    menuItem = findItemFromMultiselectListByText(items, itemText);

    if (menuItem) {
        clickElement(menuItem);
    } else {
        throw Error('item for multiselect "' + target + '" with text "' + itemText + '" not found');
    }

    // Reset the input value
    targetEl.value = '';
    targetEl.dispatchEvent(new Event('input'));
}

/**
 * Clears out all currently selected values from a kendo multiselect.
 * @param {string} target - CSS selector of the multiselect wrapper component.
 * @example - window.ECP.ghostHelpers.clearMultiselectValues("#billLineItems"); 
 */
function clearMultiselectValues(target) {
    var tags = document.querySelectorAll(target + '-multiselect .k-chip-remove-action .k-icon');

    tags.forEach(function (tag) {
        mouseDownElement(tag);
    });
}

/**
 * Clears out all currently selected custom values from a kendo multiselect.
 * This function should be used if any item in the list was provided as a custom string and can't be picked from the dropdown
 * @param {string} target - CSS selector of the multiselect wrapper component
 * @example - window.ECP.ghostHelpers.clearMultiselectCustomValues("#billLineDescriptions"); 
 */
function clearMultiselectCustomValues(target) {
    var tags = document.querySelectorAll(target + '-multiselect .k-chip');

    tags.forEach(function (tag) {
        addOrRemoveMultiselectCustomValue(target, tag.innerText);
    });
}

function shiftClick(target) {
    var element = document.querySelector(target);
    var event = new MouseEvent('click', {shiftKey: true, bubbles: true});
    element.dispatchEvent(event);
}

function controlClick(target) {
    var element = document.querySelector(target);
    var event = new MouseEvent('click', {ctrlKey: true, bubbles: true});
    element.dispatchEvent(event);   
}

function resizeColumn(handleSelector, widthDiff) {
    var handle = document.querySelector(handleSelector);
    handle.dispatchEvent(new MouseEvent('mousedown', { screenX: 500 }));
    document.dispatchEvent(new MouseEvent('mousemove', { screenX: 500 + widthDiff }));
    document.dispatchEvent(new MouseEvent('mouseup'));
}

/**
 * Function to set the value to a Tiny MCE control on the screen. Just give the function the textarea element ID 
 * and the expected value and it will be set to the control.
 * @param {string} textareaElementId - the format should be the ec-wysiwyg id + '_editor'
 * @param {string} value 
 * @example - window.ECP.ghostHelpers.setTinyMCEContent("customFieldValue_1043_editor", "<h1>EnergyCAP</h1>"); 
 */
function setTinyMCEContent(textareaElementId, value) {
    window.tinyMCE.get(textareaElementId).setContent(value);
    window.tinyMCE.get(textareaElementId).save();
}
